// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes v-shake {
  59% {
    margin-left: 0;
  }
  60%, 80% {
    margin-left: 2px;
  }
  70%, 90% {
    margin-left: -2px;
  }
}
:where(.vuetify-styles) .bg-black {
  background-color: #000000 !important;
}
:where(.vuetify-styles) .bg-black {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-white {
  background-color: #FFFFFF !important;
}
:where(.vuetify-styles) .bg-white {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-transparent {
  background-color: transparent !important;
}
:where(.vuetify-styles) .bg-transparent {
  color: currentColor !important;
}

:where(.vuetify-styles) .bg-red {
  background-color: #F44336 !important;
}
:where(.vuetify-styles) .bg-red {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-red-lighten-5 {
  background-color: #FFEBEE !important;
}
:where(.vuetify-styles) .bg-red-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-red-lighten-4 {
  background-color: #FFCDD2 !important;
}
:where(.vuetify-styles) .bg-red-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-red-lighten-3 {
  background-color: #EF9A9A !important;
}
:where(.vuetify-styles) .bg-red-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-red-lighten-2 {
  background-color: #E57373 !important;
}
:where(.vuetify-styles) .bg-red-lighten-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-red-lighten-1 {
  background-color: #EF5350 !important;
}
:where(.vuetify-styles) .bg-red-lighten-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-red-darken-1 {
  background-color: #E53935 !important;
}
:where(.vuetify-styles) .bg-red-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-red-darken-2 {
  background-color: #D32F2F !important;
}
:where(.vuetify-styles) .bg-red-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-red-darken-3 {
  background-color: #C62828 !important;
}
:where(.vuetify-styles) .bg-red-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-red-darken-4 {
  background-color: #B71C1C !important;
}
:where(.vuetify-styles) .bg-red-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-red-accent-1 {
  background-color: #FF8A80 !important;
}
:where(.vuetify-styles) .bg-red-accent-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-red-accent-2 {
  background-color: #FF5252 !important;
}
:where(.vuetify-styles) .bg-red-accent-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-red-accent-3 {
  background-color: #FF1744 !important;
}
:where(.vuetify-styles) .bg-red-accent-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-red-accent-4 {
  background-color: #D50000 !important;
}
:where(.vuetify-styles) .bg-red-accent-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-pink {
  background-color: #e91e63 !important;
}
:where(.vuetify-styles) .bg-pink {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-pink-lighten-5 {
  background-color: #fce4ec !important;
}
:where(.vuetify-styles) .bg-pink-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-pink-lighten-4 {
  background-color: #f8bbd0 !important;
}
:where(.vuetify-styles) .bg-pink-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-pink-lighten-3 {
  background-color: #f48fb1 !important;
}
:where(.vuetify-styles) .bg-pink-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-pink-lighten-2 {
  background-color: #f06292 !important;
}
:where(.vuetify-styles) .bg-pink-lighten-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-pink-lighten-1 {
  background-color: #ec407a !important;
}
:where(.vuetify-styles) .bg-pink-lighten-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-pink-darken-1 {
  background-color: #d81b60 !important;
}
:where(.vuetify-styles) .bg-pink-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-pink-darken-2 {
  background-color: #c2185b !important;
}
:where(.vuetify-styles) .bg-pink-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-pink-darken-3 {
  background-color: #ad1457 !important;
}
:where(.vuetify-styles) .bg-pink-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-pink-darken-4 {
  background-color: #880e4f !important;
}
:where(.vuetify-styles) .bg-pink-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-pink-accent-1 {
  background-color: #ff80ab !important;
}
:where(.vuetify-styles) .bg-pink-accent-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-pink-accent-2 {
  background-color: #ff4081 !important;
}
:where(.vuetify-styles) .bg-pink-accent-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-pink-accent-3 {
  background-color: #f50057 !important;
}
:where(.vuetify-styles) .bg-pink-accent-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-pink-accent-4 {
  background-color: #c51162 !important;
}
:where(.vuetify-styles) .bg-pink-accent-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-purple {
  background-color: #9c27b0 !important;
}
:where(.vuetify-styles) .bg-purple {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-purple-lighten-5 {
  background-color: #f3e5f5 !important;
}
:where(.vuetify-styles) .bg-purple-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-purple-lighten-4 {
  background-color: #e1bee7 !important;
}
:where(.vuetify-styles) .bg-purple-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-purple-lighten-3 {
  background-color: #ce93d8 !important;
}
:where(.vuetify-styles) .bg-purple-lighten-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-purple-lighten-2 {
  background-color: #ba68c8 !important;
}
:where(.vuetify-styles) .bg-purple-lighten-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-purple-lighten-1 {
  background-color: #ab47bc !important;
}
:where(.vuetify-styles) .bg-purple-lighten-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-purple-darken-1 {
  background-color: #8e24aa !important;
}
:where(.vuetify-styles) .bg-purple-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-purple-darken-2 {
  background-color: #7b1fa2 !important;
}
:where(.vuetify-styles) .bg-purple-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-purple-darken-3 {
  background-color: #6a1b9a !important;
}
:where(.vuetify-styles) .bg-purple-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-purple-darken-4 {
  background-color: #4a148c !important;
}
:where(.vuetify-styles) .bg-purple-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-purple-accent-1 {
  background-color: #ea80fc !important;
}
:where(.vuetify-styles) .bg-purple-accent-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-purple-accent-2 {
  background-color: #e040fb !important;
}
:where(.vuetify-styles) .bg-purple-accent-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-purple-accent-3 {
  background-color: #d500f9 !important;
}
:where(.vuetify-styles) .bg-purple-accent-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-purple-accent-4 {
  background-color: #aa00ff !important;
}
:where(.vuetify-styles) .bg-purple-accent-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-purple {
  background-color: #673ab7 !important;
}
:where(.vuetify-styles) .bg-deep-purple {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-purple-lighten-5 {
  background-color: #ede7f6 !important;
}
:where(.vuetify-styles) .bg-deep-purple-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-deep-purple-lighten-4 {
  background-color: #d1c4e9 !important;
}
:where(.vuetify-styles) .bg-deep-purple-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-deep-purple-lighten-3 {
  background-color: #b39ddb !important;
}
:where(.vuetify-styles) .bg-deep-purple-lighten-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-purple-lighten-2 {
  background-color: #9575cd !important;
}
:where(.vuetify-styles) .bg-deep-purple-lighten-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-purple-lighten-1 {
  background-color: #7e57c2 !important;
}
:where(.vuetify-styles) .bg-deep-purple-lighten-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-purple-darken-1 {
  background-color: #5e35b1 !important;
}
:where(.vuetify-styles) .bg-deep-purple-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-purple-darken-2 {
  background-color: #512da8 !important;
}
:where(.vuetify-styles) .bg-deep-purple-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-purple-darken-3 {
  background-color: #4527a0 !important;
}
:where(.vuetify-styles) .bg-deep-purple-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-purple-darken-4 {
  background-color: #311b92 !important;
}
:where(.vuetify-styles) .bg-deep-purple-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-purple-accent-1 {
  background-color: #b388ff !important;
}
:where(.vuetify-styles) .bg-deep-purple-accent-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-purple-accent-2 {
  background-color: #7c4dff !important;
}
:where(.vuetify-styles) .bg-deep-purple-accent-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-purple-accent-3 {
  background-color: #651fff !important;
}
:where(.vuetify-styles) .bg-deep-purple-accent-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-purple-accent-4 {
  background-color: #6200ea !important;
}
:where(.vuetify-styles) .bg-deep-purple-accent-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-indigo {
  background-color: #3f51b5 !important;
}
:where(.vuetify-styles) .bg-indigo {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-indigo-lighten-5 {
  background-color: #e8eaf6 !important;
}
:where(.vuetify-styles) .bg-indigo-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-indigo-lighten-4 {
  background-color: #c5cae9 !important;
}
:where(.vuetify-styles) .bg-indigo-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-indigo-lighten-3 {
  background-color: #9fa8da !important;
}
:where(.vuetify-styles) .bg-indigo-lighten-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-indigo-lighten-2 {
  background-color: #7986cb !important;
}
:where(.vuetify-styles) .bg-indigo-lighten-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-indigo-lighten-1 {
  background-color: #5c6bc0 !important;
}
:where(.vuetify-styles) .bg-indigo-lighten-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-indigo-darken-1 {
  background-color: #3949ab !important;
}
:where(.vuetify-styles) .bg-indigo-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-indigo-darken-2 {
  background-color: #303f9f !important;
}
:where(.vuetify-styles) .bg-indigo-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-indigo-darken-3 {
  background-color: #283593 !important;
}
:where(.vuetify-styles) .bg-indigo-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-indigo-darken-4 {
  background-color: #1a237e !important;
}
:where(.vuetify-styles) .bg-indigo-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-indigo-accent-1 {
  background-color: #8c9eff !important;
}
:where(.vuetify-styles) .bg-indigo-accent-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-indigo-accent-2 {
  background-color: #536dfe !important;
}
:where(.vuetify-styles) .bg-indigo-accent-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-indigo-accent-3 {
  background-color: #3d5afe !important;
}
:where(.vuetify-styles) .bg-indigo-accent-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-indigo-accent-4 {
  background-color: #304ffe !important;
}
:where(.vuetify-styles) .bg-indigo-accent-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue {
  background-color: #2196F3 !important;
}
:where(.vuetify-styles) .bg-blue {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-lighten-5 {
  background-color: #E3F2FD !important;
}
:where(.vuetify-styles) .bg-blue-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-blue-lighten-4 {
  background-color: #BBDEFB !important;
}
:where(.vuetify-styles) .bg-blue-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-blue-lighten-3 {
  background-color: #90CAF9 !important;
}
:where(.vuetify-styles) .bg-blue-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-blue-lighten-2 {
  background-color: #64B5F6 !important;
}
:where(.vuetify-styles) .bg-blue-lighten-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-blue-lighten-1 {
  background-color: #42A5F5 !important;
}
:where(.vuetify-styles) .bg-blue-lighten-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-darken-1 {
  background-color: #1E88E5 !important;
}
:where(.vuetify-styles) .bg-blue-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-darken-2 {
  background-color: #1976D2 !important;
}
:where(.vuetify-styles) .bg-blue-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-darken-3 {
  background-color: #1565C0 !important;
}
:where(.vuetify-styles) .bg-blue-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-darken-4 {
  background-color: #0D47A1 !important;
}
:where(.vuetify-styles) .bg-blue-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-accent-1 {
  background-color: #82B1FF !important;
}
:where(.vuetify-styles) .bg-blue-accent-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-blue-accent-2 {
  background-color: #448AFF !important;
}
:where(.vuetify-styles) .bg-blue-accent-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-accent-3 {
  background-color: #2979FF !important;
}
:where(.vuetify-styles) .bg-blue-accent-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-accent-4 {
  background-color: #2962FF !important;
}
:where(.vuetify-styles) .bg-blue-accent-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-light-blue {
  background-color: #03a9f4 !important;
}
:where(.vuetify-styles) .bg-light-blue {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-light-blue-lighten-5 {
  background-color: #e1f5fe !important;
}
:where(.vuetify-styles) .bg-light-blue-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-blue-lighten-4 {
  background-color: #b3e5fc !important;
}
:where(.vuetify-styles) .bg-light-blue-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-blue-lighten-3 {
  background-color: #81d4fa !important;
}
:where(.vuetify-styles) .bg-light-blue-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-blue-lighten-2 {
  background-color: #4fc3f7 !important;
}
:where(.vuetify-styles) .bg-light-blue-lighten-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-blue-lighten-1 {
  background-color: #29b6f6 !important;
}
:where(.vuetify-styles) .bg-light-blue-lighten-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-blue-darken-1 {
  background-color: #039be5 !important;
}
:where(.vuetify-styles) .bg-light-blue-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-light-blue-darken-2 {
  background-color: #0288d1 !important;
}
:where(.vuetify-styles) .bg-light-blue-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-light-blue-darken-3 {
  background-color: #0277bd !important;
}
:where(.vuetify-styles) .bg-light-blue-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-light-blue-darken-4 {
  background-color: #01579b !important;
}
:where(.vuetify-styles) .bg-light-blue-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-light-blue-accent-1 {
  background-color: #80d8ff !important;
}
:where(.vuetify-styles) .bg-light-blue-accent-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-blue-accent-2 {
  background-color: #40c4ff !important;
}
:where(.vuetify-styles) .bg-light-blue-accent-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-blue-accent-3 {
  background-color: #00b0ff !important;
}
:where(.vuetify-styles) .bg-light-blue-accent-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-light-blue-accent-4 {
  background-color: #0091ea !important;
}
:where(.vuetify-styles) .bg-light-blue-accent-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-cyan {
  background-color: #00bcd4 !important;
}
:where(.vuetify-styles) .bg-cyan {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-cyan-lighten-5 {
  background-color: #e0f7fa !important;
}
:where(.vuetify-styles) .bg-cyan-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-cyan-lighten-4 {
  background-color: #b2ebf2 !important;
}
:where(.vuetify-styles) .bg-cyan-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-cyan-lighten-3 {
  background-color: #80deea !important;
}
:where(.vuetify-styles) .bg-cyan-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-cyan-lighten-2 {
  background-color: #4dd0e1 !important;
}
:where(.vuetify-styles) .bg-cyan-lighten-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-cyan-lighten-1 {
  background-color: #26c6da !important;
}
:where(.vuetify-styles) .bg-cyan-lighten-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-cyan-darken-1 {
  background-color: #00acc1 !important;
}
:where(.vuetify-styles) .bg-cyan-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-cyan-darken-2 {
  background-color: #0097a7 !important;
}
:where(.vuetify-styles) .bg-cyan-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-cyan-darken-3 {
  background-color: #00838f !important;
}
:where(.vuetify-styles) .bg-cyan-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-cyan-darken-4 {
  background-color: #006064 !important;
}
:where(.vuetify-styles) .bg-cyan-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-cyan-accent-1 {
  background-color: #84ffff !important;
}
:where(.vuetify-styles) .bg-cyan-accent-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-cyan-accent-2 {
  background-color: #18ffff !important;
}
:where(.vuetify-styles) .bg-cyan-accent-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-cyan-accent-3 {
  background-color: #00e5ff !important;
}
:where(.vuetify-styles) .bg-cyan-accent-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-cyan-accent-4 {
  background-color: #00b8d4 !important;
}
:where(.vuetify-styles) .bg-cyan-accent-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-teal {
  background-color: #009688 !important;
}
:where(.vuetify-styles) .bg-teal {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-teal-lighten-5 {
  background-color: #e0f2f1 !important;
}
:where(.vuetify-styles) .bg-teal-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-teal-lighten-4 {
  background-color: #b2dfdb !important;
}
:where(.vuetify-styles) .bg-teal-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-teal-lighten-3 {
  background-color: #80cbc4 !important;
}
:where(.vuetify-styles) .bg-teal-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-teal-lighten-2 {
  background-color: #4db6ac !important;
}
:where(.vuetify-styles) .bg-teal-lighten-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-teal-lighten-1 {
  background-color: #26a69a !important;
}
:where(.vuetify-styles) .bg-teal-lighten-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-teal-darken-1 {
  background-color: #00897b !important;
}
:where(.vuetify-styles) .bg-teal-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-teal-darken-2 {
  background-color: #00796b !important;
}
:where(.vuetify-styles) .bg-teal-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-teal-darken-3 {
  background-color: #00695c !important;
}
:where(.vuetify-styles) .bg-teal-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-teal-darken-4 {
  background-color: #004d40 !important;
}
:where(.vuetify-styles) .bg-teal-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-teal-accent-1 {
  background-color: #a7ffeb !important;
}
:where(.vuetify-styles) .bg-teal-accent-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-teal-accent-2 {
  background-color: #64ffda !important;
}
:where(.vuetify-styles) .bg-teal-accent-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-teal-accent-3 {
  background-color: #1de9b6 !important;
}
:where(.vuetify-styles) .bg-teal-accent-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-teal-accent-4 {
  background-color: #00bfa5 !important;
}
:where(.vuetify-styles) .bg-teal-accent-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-green {
  background-color: #4CAF50 !important;
}
:where(.vuetify-styles) .bg-green {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-green-lighten-5 {
  background-color: #E8F5E9 !important;
}
:where(.vuetify-styles) .bg-green-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-green-lighten-4 {
  background-color: #C8E6C9 !important;
}
:where(.vuetify-styles) .bg-green-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-green-lighten-3 {
  background-color: #A5D6A7 !important;
}
:where(.vuetify-styles) .bg-green-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-green-lighten-2 {
  background-color: #81C784 !important;
}
:where(.vuetify-styles) .bg-green-lighten-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-green-lighten-1 {
  background-color: #66BB6A !important;
}
:where(.vuetify-styles) .bg-green-lighten-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-green-darken-1 {
  background-color: #43A047 !important;
}
:where(.vuetify-styles) .bg-green-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-green-darken-2 {
  background-color: #388E3C !important;
}
:where(.vuetify-styles) .bg-green-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-green-darken-3 {
  background-color: #2E7D32 !important;
}
:where(.vuetify-styles) .bg-green-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-green-darken-4 {
  background-color: #1B5E20 !important;
}
:where(.vuetify-styles) .bg-green-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-green-accent-1 {
  background-color: #B9F6CA !important;
}
:where(.vuetify-styles) .bg-green-accent-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-green-accent-2 {
  background-color: #69F0AE !important;
}
:where(.vuetify-styles) .bg-green-accent-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-green-accent-3 {
  background-color: #00E676 !important;
}
:where(.vuetify-styles) .bg-green-accent-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-green-accent-4 {
  background-color: #00C853 !important;
}
:where(.vuetify-styles) .bg-green-accent-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-green {
  background-color: #8bc34a !important;
}
:where(.vuetify-styles) .bg-light-green {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-green-lighten-5 {
  background-color: #f1f8e9 !important;
}
:where(.vuetify-styles) .bg-light-green-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-green-lighten-4 {
  background-color: #dcedc8 !important;
}
:where(.vuetify-styles) .bg-light-green-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-green-lighten-3 {
  background-color: #c5e1a5 !important;
}
:where(.vuetify-styles) .bg-light-green-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-green-lighten-2 {
  background-color: #aed581 !important;
}
:where(.vuetify-styles) .bg-light-green-lighten-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-green-lighten-1 {
  background-color: #9ccc65 !important;
}
:where(.vuetify-styles) .bg-light-green-lighten-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-green-darken-1 {
  background-color: #7cb342 !important;
}
:where(.vuetify-styles) .bg-light-green-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-light-green-darken-2 {
  background-color: #689f38 !important;
}
:where(.vuetify-styles) .bg-light-green-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-light-green-darken-3 {
  background-color: #558b2f !important;
}
:where(.vuetify-styles) .bg-light-green-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-light-green-darken-4 {
  background-color: #33691e !important;
}
:where(.vuetify-styles) .bg-light-green-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-light-green-accent-1 {
  background-color: #ccff90 !important;
}
:where(.vuetify-styles) .bg-light-green-accent-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-green-accent-2 {
  background-color: #b2ff59 !important;
}
:where(.vuetify-styles) .bg-light-green-accent-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-green-accent-3 {
  background-color: #76ff03 !important;
}
:where(.vuetify-styles) .bg-light-green-accent-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-light-green-accent-4 {
  background-color: #64dd17 !important;
}
:where(.vuetify-styles) .bg-light-green-accent-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-lime {
  background-color: #cddc39 !important;
}
:where(.vuetify-styles) .bg-lime {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-lime-lighten-5 {
  background-color: #f9fbe7 !important;
}
:where(.vuetify-styles) .bg-lime-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-lime-lighten-4 {
  background-color: #f0f4c3 !important;
}
:where(.vuetify-styles) .bg-lime-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-lime-lighten-3 {
  background-color: #e6ee9c !important;
}
:where(.vuetify-styles) .bg-lime-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-lime-lighten-2 {
  background-color: #dce775 !important;
}
:where(.vuetify-styles) .bg-lime-lighten-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-lime-lighten-1 {
  background-color: #d4e157 !important;
}
:where(.vuetify-styles) .bg-lime-lighten-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-lime-darken-1 {
  background-color: #c0ca33 !important;
}
:where(.vuetify-styles) .bg-lime-darken-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-lime-darken-2 {
  background-color: #afb42b !important;
}
:where(.vuetify-styles) .bg-lime-darken-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-lime-darken-3 {
  background-color: #9e9d24 !important;
}
:where(.vuetify-styles) .bg-lime-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-lime-darken-4 {
  background-color: #827717 !important;
}
:where(.vuetify-styles) .bg-lime-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-lime-accent-1 {
  background-color: #f4ff81 !important;
}
:where(.vuetify-styles) .bg-lime-accent-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-lime-accent-2 {
  background-color: #eeff41 !important;
}
:where(.vuetify-styles) .bg-lime-accent-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-lime-accent-3 {
  background-color: #c6ff00 !important;
}
:where(.vuetify-styles) .bg-lime-accent-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-lime-accent-4 {
  background-color: #aeea00 !important;
}
:where(.vuetify-styles) .bg-lime-accent-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-yellow {
  background-color: #ffeb3b !important;
}
:where(.vuetify-styles) .bg-yellow {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-yellow-lighten-5 {
  background-color: #fffde7 !important;
}
:where(.vuetify-styles) .bg-yellow-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-yellow-lighten-4 {
  background-color: #fff9c4 !important;
}
:where(.vuetify-styles) .bg-yellow-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-yellow-lighten-3 {
  background-color: #fff59d !important;
}
:where(.vuetify-styles) .bg-yellow-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-yellow-lighten-2 {
  background-color: #fff176 !important;
}
:where(.vuetify-styles) .bg-yellow-lighten-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-yellow-lighten-1 {
  background-color: #ffee58 !important;
}
:where(.vuetify-styles) .bg-yellow-lighten-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-yellow-darken-1 {
  background-color: #fdd835 !important;
}
:where(.vuetify-styles) .bg-yellow-darken-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-yellow-darken-2 {
  background-color: #fbc02d !important;
}
:where(.vuetify-styles) .bg-yellow-darken-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-yellow-darken-3 {
  background-color: #f9a825 !important;
}
:where(.vuetify-styles) .bg-yellow-darken-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-yellow-darken-4 {
  background-color: #f57f17 !important;
}
:where(.vuetify-styles) .bg-yellow-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-yellow-accent-1 {
  background-color: #ffff8d !important;
}
:where(.vuetify-styles) .bg-yellow-accent-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-yellow-accent-2 {
  background-color: #ffff00 !important;
}
:where(.vuetify-styles) .bg-yellow-accent-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-yellow-accent-3 {
  background-color: #ffea00 !important;
}
:where(.vuetify-styles) .bg-yellow-accent-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-yellow-accent-4 {
  background-color: #ffd600 !important;
}
:where(.vuetify-styles) .bg-yellow-accent-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-amber {
  background-color: #ffc107 !important;
}
:where(.vuetify-styles) .bg-amber {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-amber-lighten-5 {
  background-color: #fff8e1 !important;
}
:where(.vuetify-styles) .bg-amber-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-amber-lighten-4 {
  background-color: #ffecb3 !important;
}
:where(.vuetify-styles) .bg-amber-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-amber-lighten-3 {
  background-color: #ffe082 !important;
}
:where(.vuetify-styles) .bg-amber-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-amber-lighten-2 {
  background-color: #ffd54f !important;
}
:where(.vuetify-styles) .bg-amber-lighten-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-amber-lighten-1 {
  background-color: #ffca28 !important;
}
:where(.vuetify-styles) .bg-amber-lighten-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-amber-darken-1 {
  background-color: #ffb300 !important;
}
:where(.vuetify-styles) .bg-amber-darken-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-amber-darken-2 {
  background-color: #ffa000 !important;
}
:where(.vuetify-styles) .bg-amber-darken-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-amber-darken-3 {
  background-color: #ff8f00 !important;
}
:where(.vuetify-styles) .bg-amber-darken-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-amber-darken-4 {
  background-color: #ff6f00 !important;
}
:where(.vuetify-styles) .bg-amber-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-amber-accent-1 {
  background-color: #ffe57f !important;
}
:where(.vuetify-styles) .bg-amber-accent-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-amber-accent-2 {
  background-color: #ffd740 !important;
}
:where(.vuetify-styles) .bg-amber-accent-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-amber-accent-3 {
  background-color: #ffc400 !important;
}
:where(.vuetify-styles) .bg-amber-accent-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-amber-accent-4 {
  background-color: #ffab00 !important;
}
:where(.vuetify-styles) .bg-amber-accent-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-orange {
  background-color: #ff9800 !important;
}
:where(.vuetify-styles) .bg-orange {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-orange-lighten-5 {
  background-color: #fff3e0 !important;
}
:where(.vuetify-styles) .bg-orange-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-orange-lighten-4 {
  background-color: #ffe0b2 !important;
}
:where(.vuetify-styles) .bg-orange-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-orange-lighten-3 {
  background-color: #ffcc80 !important;
}
:where(.vuetify-styles) .bg-orange-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-orange-lighten-2 {
  background-color: #ffb74d !important;
}
:where(.vuetify-styles) .bg-orange-lighten-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-orange-lighten-1 {
  background-color: #ffa726 !important;
}
:where(.vuetify-styles) .bg-orange-lighten-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-orange-darken-1 {
  background-color: #fb8c00 !important;
}
:where(.vuetify-styles) .bg-orange-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-orange-darken-2 {
  background-color: #f57c00 !important;
}
:where(.vuetify-styles) .bg-orange-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-orange-darken-3 {
  background-color: #ef6c00 !important;
}
:where(.vuetify-styles) .bg-orange-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-orange-darken-4 {
  background-color: #e65100 !important;
}
:where(.vuetify-styles) .bg-orange-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-orange-accent-1 {
  background-color: #ffd180 !important;
}
:where(.vuetify-styles) .bg-orange-accent-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-orange-accent-2 {
  background-color: #ffab40 !important;
}
:where(.vuetify-styles) .bg-orange-accent-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-orange-accent-3 {
  background-color: #ff9100 !important;
}
:where(.vuetify-styles) .bg-orange-accent-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-orange-accent-4 {
  background-color: #ff6d00 !important;
}
:where(.vuetify-styles) .bg-orange-accent-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-orange {
  background-color: #ff5722 !important;
}
:where(.vuetify-styles) .bg-deep-orange {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-orange-lighten-5 {
  background-color: #fbe9e7 !important;
}
:where(.vuetify-styles) .bg-deep-orange-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-deep-orange-lighten-4 {
  background-color: #ffccbc !important;
}
:where(.vuetify-styles) .bg-deep-orange-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-deep-orange-lighten-3 {
  background-color: #ffab91 !important;
}
:where(.vuetify-styles) .bg-deep-orange-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-deep-orange-lighten-2 {
  background-color: #ff8a65 !important;
}
:where(.vuetify-styles) .bg-deep-orange-lighten-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-deep-orange-lighten-1 {
  background-color: #ff7043 !important;
}
:where(.vuetify-styles) .bg-deep-orange-lighten-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-orange-darken-1 {
  background-color: #f4511e !important;
}
:where(.vuetify-styles) .bg-deep-orange-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-orange-darken-2 {
  background-color: #e64a19 !important;
}
:where(.vuetify-styles) .bg-deep-orange-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-orange-darken-3 {
  background-color: #d84315 !important;
}
:where(.vuetify-styles) .bg-deep-orange-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-orange-darken-4 {
  background-color: #bf360c !important;
}
:where(.vuetify-styles) .bg-deep-orange-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-orange-accent-1 {
  background-color: #ff9e80 !important;
}
:where(.vuetify-styles) .bg-deep-orange-accent-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-deep-orange-accent-2 {
  background-color: #ff6e40 !important;
}
:where(.vuetify-styles) .bg-deep-orange-accent-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-orange-accent-3 {
  background-color: #ff3d00 !important;
}
:where(.vuetify-styles) .bg-deep-orange-accent-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-deep-orange-accent-4 {
  background-color: #dd2c00 !important;
}
:where(.vuetify-styles) .bg-deep-orange-accent-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-brown {
  background-color: #795548 !important;
}
:where(.vuetify-styles) .bg-brown {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-brown-lighten-5 {
  background-color: #efebe9 !important;
}
:where(.vuetify-styles) .bg-brown-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-brown-lighten-4 {
  background-color: #d7ccc8 !important;
}
:where(.vuetify-styles) .bg-brown-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-brown-lighten-3 {
  background-color: #bcaaa4 !important;
}
:where(.vuetify-styles) .bg-brown-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-brown-lighten-2 {
  background-color: #a1887f !important;
}
:where(.vuetify-styles) .bg-brown-lighten-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-brown-lighten-1 {
  background-color: #8d6e63 !important;
}
:where(.vuetify-styles) .bg-brown-lighten-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-brown-darken-1 {
  background-color: #6d4c41 !important;
}
:where(.vuetify-styles) .bg-brown-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-brown-darken-2 {
  background-color: #5d4037 !important;
}
:where(.vuetify-styles) .bg-brown-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-brown-darken-3 {
  background-color: #4e342e !important;
}
:where(.vuetify-styles) .bg-brown-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-brown-darken-4 {
  background-color: #3e2723 !important;
}
:where(.vuetify-styles) .bg-brown-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-grey {
  background-color: #607d8b !important;
}
:where(.vuetify-styles) .bg-blue-grey {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-grey-lighten-5 {
  background-color: #eceff1 !important;
}
:where(.vuetify-styles) .bg-blue-grey-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-blue-grey-lighten-4 {
  background-color: #cfd8dc !important;
}
:where(.vuetify-styles) .bg-blue-grey-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-blue-grey-lighten-3 {
  background-color: #b0bec5 !important;
}
:where(.vuetify-styles) .bg-blue-grey-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-blue-grey-lighten-2 {
  background-color: #90a4ae !important;
}
:where(.vuetify-styles) .bg-blue-grey-lighten-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-grey-lighten-1 {
  background-color: #78909c !important;
}
:where(.vuetify-styles) .bg-blue-grey-lighten-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-grey-darken-1 {
  background-color: #546e7a !important;
}
:where(.vuetify-styles) .bg-blue-grey-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-grey-darken-2 {
  background-color: #455a64 !important;
}
:where(.vuetify-styles) .bg-blue-grey-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-grey-darken-3 {
  background-color: #37474f !important;
}
:where(.vuetify-styles) .bg-blue-grey-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-blue-grey-darken-4 {
  background-color: #263238 !important;
}
:where(.vuetify-styles) .bg-blue-grey-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-grey {
  background-color: #9e9e9e !important;
}
:where(.vuetify-styles) .bg-grey {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-grey-lighten-5 {
  background-color: #fafafa !important;
}
:where(.vuetify-styles) .bg-grey-lighten-5 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-grey-lighten-4 {
  background-color: #f5f5f5 !important;
}
:where(.vuetify-styles) .bg-grey-lighten-4 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-grey-lighten-3 {
  background-color: #eeeeee !important;
}
:where(.vuetify-styles) .bg-grey-lighten-3 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-grey-lighten-2 {
  background-color: #e0e0e0 !important;
}
:where(.vuetify-styles) .bg-grey-lighten-2 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-grey-lighten-1 {
  background-color: #bdbdbd !important;
}
:where(.vuetify-styles) .bg-grey-lighten-1 {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-grey-darken-1 {
  background-color: #757575 !important;
}
:where(.vuetify-styles) .bg-grey-darken-1 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-grey-darken-2 {
  background-color: #616161 !important;
}
:where(.vuetify-styles) .bg-grey-darken-2 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-grey-darken-3 {
  background-color: #424242 !important;
}
:where(.vuetify-styles) .bg-grey-darken-3 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-grey-darken-4 {
  background-color: #212121 !important;
}
:where(.vuetify-styles) .bg-grey-darken-4 {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-shades-black {
  background-color: #000000 !important;
}
:where(.vuetify-styles) .bg-shades-black {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .bg-shades-white {
  background-color: #FFFFFF !important;
}
:where(.vuetify-styles) .bg-shades-white {
  color: #000000 !important;
}

:where(.vuetify-styles) .bg-shades-transparent {
  background-color: transparent !important;
}
:where(.vuetify-styles) .bg-shades-transparent {
  color: currentColor !important;
}

:where(.vuetify-styles) .text-black {
  color: #000000 !important;
}

:where(.vuetify-styles) .text-white {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .text-transparent {
  color: transparent !important;
}

:where(.vuetify-styles) .text-red {
  color: #F44336 !important;
}

:where(.vuetify-styles) .text-red-lighten-5 {
  color: #FFEBEE !important;
}

:where(.vuetify-styles) .text-red-lighten-4 {
  color: #FFCDD2 !important;
}

:where(.vuetify-styles) .text-red-lighten-3 {
  color: #EF9A9A !important;
}

:where(.vuetify-styles) .text-red-lighten-2 {
  color: #E57373 !important;
}

:where(.vuetify-styles) .text-red-lighten-1 {
  color: #EF5350 !important;
}

:where(.vuetify-styles) .text-red-darken-1 {
  color: #E53935 !important;
}

:where(.vuetify-styles) .text-red-darken-2 {
  color: #D32F2F !important;
}

:where(.vuetify-styles) .text-red-darken-3 {
  color: #C62828 !important;
}

:where(.vuetify-styles) .text-red-darken-4 {
  color: #B71C1C !important;
}

:where(.vuetify-styles) .text-red-accent-1 {
  color: #FF8A80 !important;
}

:where(.vuetify-styles) .text-red-accent-2 {
  color: #FF5252 !important;
}

:where(.vuetify-styles) .text-red-accent-3 {
  color: #FF1744 !important;
}

:where(.vuetify-styles) .text-red-accent-4 {
  color: #D50000 !important;
}

:where(.vuetify-styles) .text-pink {
  color: #e91e63 !important;
}

:where(.vuetify-styles) .text-pink-lighten-5 {
  color: #fce4ec !important;
}

:where(.vuetify-styles) .text-pink-lighten-4 {
  color: #f8bbd0 !important;
}

:where(.vuetify-styles) .text-pink-lighten-3 {
  color: #f48fb1 !important;
}

:where(.vuetify-styles) .text-pink-lighten-2 {
  color: #f06292 !important;
}

:where(.vuetify-styles) .text-pink-lighten-1 {
  color: #ec407a !important;
}

:where(.vuetify-styles) .text-pink-darken-1 {
  color: #d81b60 !important;
}

:where(.vuetify-styles) .text-pink-darken-2 {
  color: #c2185b !important;
}

:where(.vuetify-styles) .text-pink-darken-3 {
  color: #ad1457 !important;
}

:where(.vuetify-styles) .text-pink-darken-4 {
  color: #880e4f !important;
}

:where(.vuetify-styles) .text-pink-accent-1 {
  color: #ff80ab !important;
}

:where(.vuetify-styles) .text-pink-accent-2 {
  color: #ff4081 !important;
}

:where(.vuetify-styles) .text-pink-accent-3 {
  color: #f50057 !important;
}

:where(.vuetify-styles) .text-pink-accent-4 {
  color: #c51162 !important;
}

:where(.vuetify-styles) .text-purple {
  color: #9c27b0 !important;
}

:where(.vuetify-styles) .text-purple-lighten-5 {
  color: #f3e5f5 !important;
}

:where(.vuetify-styles) .text-purple-lighten-4 {
  color: #e1bee7 !important;
}

:where(.vuetify-styles) .text-purple-lighten-3 {
  color: #ce93d8 !important;
}

:where(.vuetify-styles) .text-purple-lighten-2 {
  color: #ba68c8 !important;
}

:where(.vuetify-styles) .text-purple-lighten-1 {
  color: #ab47bc !important;
}

:where(.vuetify-styles) .text-purple-darken-1 {
  color: #8e24aa !important;
}

:where(.vuetify-styles) .text-purple-darken-2 {
  color: #7b1fa2 !important;
}

:where(.vuetify-styles) .text-purple-darken-3 {
  color: #6a1b9a !important;
}

:where(.vuetify-styles) .text-purple-darken-4 {
  color: #4a148c !important;
}

:where(.vuetify-styles) .text-purple-accent-1 {
  color: #ea80fc !important;
}

:where(.vuetify-styles) .text-purple-accent-2 {
  color: #e040fb !important;
}

:where(.vuetify-styles) .text-purple-accent-3 {
  color: #d500f9 !important;
}

:where(.vuetify-styles) .text-purple-accent-4 {
  color: #aa00ff !important;
}

:where(.vuetify-styles) .text-deep-purple {
  color: #673ab7 !important;
}

:where(.vuetify-styles) .text-deep-purple-lighten-5 {
  color: #ede7f6 !important;
}

:where(.vuetify-styles) .text-deep-purple-lighten-4 {
  color: #d1c4e9 !important;
}

:where(.vuetify-styles) .text-deep-purple-lighten-3 {
  color: #b39ddb !important;
}

:where(.vuetify-styles) .text-deep-purple-lighten-2 {
  color: #9575cd !important;
}

:where(.vuetify-styles) .text-deep-purple-lighten-1 {
  color: #7e57c2 !important;
}

:where(.vuetify-styles) .text-deep-purple-darken-1 {
  color: #5e35b1 !important;
}

:where(.vuetify-styles) .text-deep-purple-darken-2 {
  color: #512da8 !important;
}

:where(.vuetify-styles) .text-deep-purple-darken-3 {
  color: #4527a0 !important;
}

:where(.vuetify-styles) .text-deep-purple-darken-4 {
  color: #311b92 !important;
}

:where(.vuetify-styles) .text-deep-purple-accent-1 {
  color: #b388ff !important;
}

:where(.vuetify-styles) .text-deep-purple-accent-2 {
  color: #7c4dff !important;
}

:where(.vuetify-styles) .text-deep-purple-accent-3 {
  color: #651fff !important;
}

:where(.vuetify-styles) .text-deep-purple-accent-4 {
  color: #6200ea !important;
}

:where(.vuetify-styles) .text-indigo {
  color: #3f51b5 !important;
}

:where(.vuetify-styles) .text-indigo-lighten-5 {
  color: #e8eaf6 !important;
}

:where(.vuetify-styles) .text-indigo-lighten-4 {
  color: #c5cae9 !important;
}

:where(.vuetify-styles) .text-indigo-lighten-3 {
  color: #9fa8da !important;
}

:where(.vuetify-styles) .text-indigo-lighten-2 {
  color: #7986cb !important;
}

:where(.vuetify-styles) .text-indigo-lighten-1 {
  color: #5c6bc0 !important;
}

:where(.vuetify-styles) .text-indigo-darken-1 {
  color: #3949ab !important;
}

:where(.vuetify-styles) .text-indigo-darken-2 {
  color: #303f9f !important;
}

:where(.vuetify-styles) .text-indigo-darken-3 {
  color: #283593 !important;
}

:where(.vuetify-styles) .text-indigo-darken-4 {
  color: #1a237e !important;
}

:where(.vuetify-styles) .text-indigo-accent-1 {
  color: #8c9eff !important;
}

:where(.vuetify-styles) .text-indigo-accent-2 {
  color: #536dfe !important;
}

:where(.vuetify-styles) .text-indigo-accent-3 {
  color: #3d5afe !important;
}

:where(.vuetify-styles) .text-indigo-accent-4 {
  color: #304ffe !important;
}

:where(.vuetify-styles) .text-blue {
  color: #2196F3 !important;
}

:where(.vuetify-styles) .text-blue-lighten-5 {
  color: #E3F2FD !important;
}

:where(.vuetify-styles) .text-blue-lighten-4 {
  color: #BBDEFB !important;
}

:where(.vuetify-styles) .text-blue-lighten-3 {
  color: #90CAF9 !important;
}

:where(.vuetify-styles) .text-blue-lighten-2 {
  color: #64B5F6 !important;
}

:where(.vuetify-styles) .text-blue-lighten-1 {
  color: #42A5F5 !important;
}

:where(.vuetify-styles) .text-blue-darken-1 {
  color: #1E88E5 !important;
}

:where(.vuetify-styles) .text-blue-darken-2 {
  color: #1976D2 !important;
}

:where(.vuetify-styles) .text-blue-darken-3 {
  color: #1565C0 !important;
}

:where(.vuetify-styles) .text-blue-darken-4 {
  color: #0D47A1 !important;
}

:where(.vuetify-styles) .text-blue-accent-1 {
  color: #82B1FF !important;
}

:where(.vuetify-styles) .text-blue-accent-2 {
  color: #448AFF !important;
}

:where(.vuetify-styles) .text-blue-accent-3 {
  color: #2979FF !important;
}

:where(.vuetify-styles) .text-blue-accent-4 {
  color: #2962FF !important;
}

:where(.vuetify-styles) .text-light-blue {
  color: #03a9f4 !important;
}

:where(.vuetify-styles) .text-light-blue-lighten-5 {
  color: #e1f5fe !important;
}

:where(.vuetify-styles) .text-light-blue-lighten-4 {
  color: #b3e5fc !important;
}

:where(.vuetify-styles) .text-light-blue-lighten-3 {
  color: #81d4fa !important;
}

:where(.vuetify-styles) .text-light-blue-lighten-2 {
  color: #4fc3f7 !important;
}

:where(.vuetify-styles) .text-light-blue-lighten-1 {
  color: #29b6f6 !important;
}

:where(.vuetify-styles) .text-light-blue-darken-1 {
  color: #039be5 !important;
}

:where(.vuetify-styles) .text-light-blue-darken-2 {
  color: #0288d1 !important;
}

:where(.vuetify-styles) .text-light-blue-darken-3 {
  color: #0277bd !important;
}

:where(.vuetify-styles) .text-light-blue-darken-4 {
  color: #01579b !important;
}

:where(.vuetify-styles) .text-light-blue-accent-1 {
  color: #80d8ff !important;
}

:where(.vuetify-styles) .text-light-blue-accent-2 {
  color: #40c4ff !important;
}

:where(.vuetify-styles) .text-light-blue-accent-3 {
  color: #00b0ff !important;
}

:where(.vuetify-styles) .text-light-blue-accent-4 {
  color: #0091ea !important;
}

:where(.vuetify-styles) .text-cyan {
  color: #00bcd4 !important;
}

:where(.vuetify-styles) .text-cyan-lighten-5 {
  color: #e0f7fa !important;
}

:where(.vuetify-styles) .text-cyan-lighten-4 {
  color: #b2ebf2 !important;
}

:where(.vuetify-styles) .text-cyan-lighten-3 {
  color: #80deea !important;
}

:where(.vuetify-styles) .text-cyan-lighten-2 {
  color: #4dd0e1 !important;
}

:where(.vuetify-styles) .text-cyan-lighten-1 {
  color: #26c6da !important;
}

:where(.vuetify-styles) .text-cyan-darken-1 {
  color: #00acc1 !important;
}

:where(.vuetify-styles) .text-cyan-darken-2 {
  color: #0097a7 !important;
}

:where(.vuetify-styles) .text-cyan-darken-3 {
  color: #00838f !important;
}

:where(.vuetify-styles) .text-cyan-darken-4 {
  color: #006064 !important;
}

:where(.vuetify-styles) .text-cyan-accent-1 {
  color: #84ffff !important;
}

:where(.vuetify-styles) .text-cyan-accent-2 {
  color: #18ffff !important;
}

:where(.vuetify-styles) .text-cyan-accent-3 {
  color: #00e5ff !important;
}

:where(.vuetify-styles) .text-cyan-accent-4 {
  color: #00b8d4 !important;
}

:where(.vuetify-styles) .text-teal {
  color: #009688 !important;
}

:where(.vuetify-styles) .text-teal-lighten-5 {
  color: #e0f2f1 !important;
}

:where(.vuetify-styles) .text-teal-lighten-4 {
  color: #b2dfdb !important;
}

:where(.vuetify-styles) .text-teal-lighten-3 {
  color: #80cbc4 !important;
}

:where(.vuetify-styles) .text-teal-lighten-2 {
  color: #4db6ac !important;
}

:where(.vuetify-styles) .text-teal-lighten-1 {
  color: #26a69a !important;
}

:where(.vuetify-styles) .text-teal-darken-1 {
  color: #00897b !important;
}

:where(.vuetify-styles) .text-teal-darken-2 {
  color: #00796b !important;
}

:where(.vuetify-styles) .text-teal-darken-3 {
  color: #00695c !important;
}

:where(.vuetify-styles) .text-teal-darken-4 {
  color: #004d40 !important;
}

:where(.vuetify-styles) .text-teal-accent-1 {
  color: #a7ffeb !important;
}

:where(.vuetify-styles) .text-teal-accent-2 {
  color: #64ffda !important;
}

:where(.vuetify-styles) .text-teal-accent-3 {
  color: #1de9b6 !important;
}

:where(.vuetify-styles) .text-teal-accent-4 {
  color: #00bfa5 !important;
}

:where(.vuetify-styles) .text-green {
  color: #4CAF50 !important;
}

:where(.vuetify-styles) .text-green-lighten-5 {
  color: #E8F5E9 !important;
}

:where(.vuetify-styles) .text-green-lighten-4 {
  color: #C8E6C9 !important;
}

:where(.vuetify-styles) .text-green-lighten-3 {
  color: #A5D6A7 !important;
}

:where(.vuetify-styles) .text-green-lighten-2 {
  color: #81C784 !important;
}

:where(.vuetify-styles) .text-green-lighten-1 {
  color: #66BB6A !important;
}

:where(.vuetify-styles) .text-green-darken-1 {
  color: #43A047 !important;
}

:where(.vuetify-styles) .text-green-darken-2 {
  color: #388E3C !important;
}

:where(.vuetify-styles) .text-green-darken-3 {
  color: #2E7D32 !important;
}

:where(.vuetify-styles) .text-green-darken-4 {
  color: #1B5E20 !important;
}

:where(.vuetify-styles) .text-green-accent-1 {
  color: #B9F6CA !important;
}

:where(.vuetify-styles) .text-green-accent-2 {
  color: #69F0AE !important;
}

:where(.vuetify-styles) .text-green-accent-3 {
  color: #00E676 !important;
}

:where(.vuetify-styles) .text-green-accent-4 {
  color: #00C853 !important;
}

:where(.vuetify-styles) .text-light-green {
  color: #8bc34a !important;
}

:where(.vuetify-styles) .text-light-green-lighten-5 {
  color: #f1f8e9 !important;
}

:where(.vuetify-styles) .text-light-green-lighten-4 {
  color: #dcedc8 !important;
}

:where(.vuetify-styles) .text-light-green-lighten-3 {
  color: #c5e1a5 !important;
}

:where(.vuetify-styles) .text-light-green-lighten-2 {
  color: #aed581 !important;
}

:where(.vuetify-styles) .text-light-green-lighten-1 {
  color: #9ccc65 !important;
}

:where(.vuetify-styles) .text-light-green-darken-1 {
  color: #7cb342 !important;
}

:where(.vuetify-styles) .text-light-green-darken-2 {
  color: #689f38 !important;
}

:where(.vuetify-styles) .text-light-green-darken-3 {
  color: #558b2f !important;
}

:where(.vuetify-styles) .text-light-green-darken-4 {
  color: #33691e !important;
}

:where(.vuetify-styles) .text-light-green-accent-1 {
  color: #ccff90 !important;
}

:where(.vuetify-styles) .text-light-green-accent-2 {
  color: #b2ff59 !important;
}

:where(.vuetify-styles) .text-light-green-accent-3 {
  color: #76ff03 !important;
}

:where(.vuetify-styles) .text-light-green-accent-4 {
  color: #64dd17 !important;
}

:where(.vuetify-styles) .text-lime {
  color: #cddc39 !important;
}

:where(.vuetify-styles) .text-lime-lighten-5 {
  color: #f9fbe7 !important;
}

:where(.vuetify-styles) .text-lime-lighten-4 {
  color: #f0f4c3 !important;
}

:where(.vuetify-styles) .text-lime-lighten-3 {
  color: #e6ee9c !important;
}

:where(.vuetify-styles) .text-lime-lighten-2 {
  color: #dce775 !important;
}

:where(.vuetify-styles) .text-lime-lighten-1 {
  color: #d4e157 !important;
}

:where(.vuetify-styles) .text-lime-darken-1 {
  color: #c0ca33 !important;
}

:where(.vuetify-styles) .text-lime-darken-2 {
  color: #afb42b !important;
}

:where(.vuetify-styles) .text-lime-darken-3 {
  color: #9e9d24 !important;
}

:where(.vuetify-styles) .text-lime-darken-4 {
  color: #827717 !important;
}

:where(.vuetify-styles) .text-lime-accent-1 {
  color: #f4ff81 !important;
}

:where(.vuetify-styles) .text-lime-accent-2 {
  color: #eeff41 !important;
}

:where(.vuetify-styles) .text-lime-accent-3 {
  color: #c6ff00 !important;
}

:where(.vuetify-styles) .text-lime-accent-4 {
  color: #aeea00 !important;
}

:where(.vuetify-styles) .text-yellow {
  color: #ffeb3b !important;
}

:where(.vuetify-styles) .text-yellow-lighten-5 {
  color: #fffde7 !important;
}

:where(.vuetify-styles) .text-yellow-lighten-4 {
  color: #fff9c4 !important;
}

:where(.vuetify-styles) .text-yellow-lighten-3 {
  color: #fff59d !important;
}

:where(.vuetify-styles) .text-yellow-lighten-2 {
  color: #fff176 !important;
}

:where(.vuetify-styles) .text-yellow-lighten-1 {
  color: #ffee58 !important;
}

:where(.vuetify-styles) .text-yellow-darken-1 {
  color: #fdd835 !important;
}

:where(.vuetify-styles) .text-yellow-darken-2 {
  color: #fbc02d !important;
}

:where(.vuetify-styles) .text-yellow-darken-3 {
  color: #f9a825 !important;
}

:where(.vuetify-styles) .text-yellow-darken-4 {
  color: #f57f17 !important;
}

:where(.vuetify-styles) .text-yellow-accent-1 {
  color: #ffff8d !important;
}

:where(.vuetify-styles) .text-yellow-accent-2 {
  color: #ffff00 !important;
}

:where(.vuetify-styles) .text-yellow-accent-3 {
  color: #ffea00 !important;
}

:where(.vuetify-styles) .text-yellow-accent-4 {
  color: #ffd600 !important;
}

:where(.vuetify-styles) .text-amber {
  color: #ffc107 !important;
}

:where(.vuetify-styles) .text-amber-lighten-5 {
  color: #fff8e1 !important;
}

:where(.vuetify-styles) .text-amber-lighten-4 {
  color: #ffecb3 !important;
}

:where(.vuetify-styles) .text-amber-lighten-3 {
  color: #ffe082 !important;
}

:where(.vuetify-styles) .text-amber-lighten-2 {
  color: #ffd54f !important;
}

:where(.vuetify-styles) .text-amber-lighten-1 {
  color: #ffca28 !important;
}

:where(.vuetify-styles) .text-amber-darken-1 {
  color: #ffb300 !important;
}

:where(.vuetify-styles) .text-amber-darken-2 {
  color: #ffa000 !important;
}

:where(.vuetify-styles) .text-amber-darken-3 {
  color: #ff8f00 !important;
}

:where(.vuetify-styles) .text-amber-darken-4 {
  color: #ff6f00 !important;
}

:where(.vuetify-styles) .text-amber-accent-1 {
  color: #ffe57f !important;
}

:where(.vuetify-styles) .text-amber-accent-2 {
  color: #ffd740 !important;
}

:where(.vuetify-styles) .text-amber-accent-3 {
  color: #ffc400 !important;
}

:where(.vuetify-styles) .text-amber-accent-4 {
  color: #ffab00 !important;
}

:where(.vuetify-styles) .text-orange {
  color: #ff9800 !important;
}

:where(.vuetify-styles) .text-orange-lighten-5 {
  color: #fff3e0 !important;
}

:where(.vuetify-styles) .text-orange-lighten-4 {
  color: #ffe0b2 !important;
}

:where(.vuetify-styles) .text-orange-lighten-3 {
  color: #ffcc80 !important;
}

:where(.vuetify-styles) .text-orange-lighten-2 {
  color: #ffb74d !important;
}

:where(.vuetify-styles) .text-orange-lighten-1 {
  color: #ffa726 !important;
}

:where(.vuetify-styles) .text-orange-darken-1 {
  color: #fb8c00 !important;
}

:where(.vuetify-styles) .text-orange-darken-2 {
  color: #f57c00 !important;
}

:where(.vuetify-styles) .text-orange-darken-3 {
  color: #ef6c00 !important;
}

:where(.vuetify-styles) .text-orange-darken-4 {
  color: #e65100 !important;
}

:where(.vuetify-styles) .text-orange-accent-1 {
  color: #ffd180 !important;
}

:where(.vuetify-styles) .text-orange-accent-2 {
  color: #ffab40 !important;
}

:where(.vuetify-styles) .text-orange-accent-3 {
  color: #ff9100 !important;
}

:where(.vuetify-styles) .text-orange-accent-4 {
  color: #ff6d00 !important;
}

:where(.vuetify-styles) .text-deep-orange {
  color: #ff5722 !important;
}

:where(.vuetify-styles) .text-deep-orange-lighten-5 {
  color: #fbe9e7 !important;
}

:where(.vuetify-styles) .text-deep-orange-lighten-4 {
  color: #ffccbc !important;
}

:where(.vuetify-styles) .text-deep-orange-lighten-3 {
  color: #ffab91 !important;
}

:where(.vuetify-styles) .text-deep-orange-lighten-2 {
  color: #ff8a65 !important;
}

:where(.vuetify-styles) .text-deep-orange-lighten-1 {
  color: #ff7043 !important;
}

:where(.vuetify-styles) .text-deep-orange-darken-1 {
  color: #f4511e !important;
}

:where(.vuetify-styles) .text-deep-orange-darken-2 {
  color: #e64a19 !important;
}

:where(.vuetify-styles) .text-deep-orange-darken-3 {
  color: #d84315 !important;
}

:where(.vuetify-styles) .text-deep-orange-darken-4 {
  color: #bf360c !important;
}

:where(.vuetify-styles) .text-deep-orange-accent-1 {
  color: #ff9e80 !important;
}

:where(.vuetify-styles) .text-deep-orange-accent-2 {
  color: #ff6e40 !important;
}

:where(.vuetify-styles) .text-deep-orange-accent-3 {
  color: #ff3d00 !important;
}

:where(.vuetify-styles) .text-deep-orange-accent-4 {
  color: #dd2c00 !important;
}

:where(.vuetify-styles) .text-brown {
  color: #795548 !important;
}

:where(.vuetify-styles) .text-brown-lighten-5 {
  color: #efebe9 !important;
}

:where(.vuetify-styles) .text-brown-lighten-4 {
  color: #d7ccc8 !important;
}

:where(.vuetify-styles) .text-brown-lighten-3 {
  color: #bcaaa4 !important;
}

:where(.vuetify-styles) .text-brown-lighten-2 {
  color: #a1887f !important;
}

:where(.vuetify-styles) .text-brown-lighten-1 {
  color: #8d6e63 !important;
}

:where(.vuetify-styles) .text-brown-darken-1 {
  color: #6d4c41 !important;
}

:where(.vuetify-styles) .text-brown-darken-2 {
  color: #5d4037 !important;
}

:where(.vuetify-styles) .text-brown-darken-3 {
  color: #4e342e !important;
}

:where(.vuetify-styles) .text-brown-darken-4 {
  color: #3e2723 !important;
}

:where(.vuetify-styles) .text-blue-grey {
  color: #607d8b !important;
}

:where(.vuetify-styles) .text-blue-grey-lighten-5 {
  color: #eceff1 !important;
}

:where(.vuetify-styles) .text-blue-grey-lighten-4 {
  color: #cfd8dc !important;
}

:where(.vuetify-styles) .text-blue-grey-lighten-3 {
  color: #b0bec5 !important;
}

:where(.vuetify-styles) .text-blue-grey-lighten-2 {
  color: #90a4ae !important;
}

:where(.vuetify-styles) .text-blue-grey-lighten-1 {
  color: #78909c !important;
}

:where(.vuetify-styles) .text-blue-grey-darken-1 {
  color: #546e7a !important;
}

:where(.vuetify-styles) .text-blue-grey-darken-2 {
  color: #455a64 !important;
}

:where(.vuetify-styles) .text-blue-grey-darken-3 {
  color: #37474f !important;
}

:where(.vuetify-styles) .text-blue-grey-darken-4 {
  color: #263238 !important;
}

:where(.vuetify-styles) .text-grey {
  color: #9e9e9e !important;
}

:where(.vuetify-styles) .text-grey-lighten-5 {
  color: #fafafa !important;
}

:where(.vuetify-styles) .text-grey-lighten-4 {
  color: #f5f5f5 !important;
}

:where(.vuetify-styles) .text-grey-lighten-3 {
  color: #eeeeee !important;
}

:where(.vuetify-styles) .text-grey-lighten-2 {
  color: #e0e0e0 !important;
}

:where(.vuetify-styles) .text-grey-lighten-1 {
  color: #bdbdbd !important;
}

:where(.vuetify-styles) .text-grey-darken-1 {
  color: #757575 !important;
}

:where(.vuetify-styles) .text-grey-darken-2 {
  color: #616161 !important;
}

:where(.vuetify-styles) .text-grey-darken-3 {
  color: #424242 !important;
}

:where(.vuetify-styles) .text-grey-darken-4 {
  color: #212121 !important;
}

:where(.vuetify-styles) .text-shades-black {
  color: #000000 !important;
}

:where(.vuetify-styles) .text-shades-white {
  color: #FFFFFF !important;
}

:where(.vuetify-styles) .text-shades-transparent {
  color: transparent !important;
}

/*!
 * ress.css • v2.0.4
 * MIT License
 * github.com/filipelinhares/ress
 */
/* # =================================================================
   # Global selectors
   # ================================================================= */
:where(.vuetify-styles) html {
  box-sizing: border-box;
  overflow-y: scroll; /* All browsers without overlaying scrollbars */
  -webkit-text-size-adjust: 100%; /* Prevent adjustments of font size after orientation changes in iOS */
  word-break: normal;
  -moz-tab-size: 4;
  tab-size: 4;
}

:where(.vuetify-styles) *,
:where(.vuetify-styles) ::before,
:where(.vuetify-styles) ::after {
  background-repeat: no-repeat; /* Set \`background-repeat: no-repeat\` to all elements and pseudo elements */
  box-sizing: inherit;
}

:where(.vuetify-styles) ::before,
:where(.vuetify-styles) ::after {
  text-decoration: inherit; /* Inherit text-decoration and vertical align to ::before and ::after pseudo elements */
  vertical-align: inherit;
}

:where(.vuetify-styles) * {
  padding: 0; /* Reset \`padding\` and \`margin\` of all elements */
  margin: 0;
}

/* # =================================================================
   # General elements
   # ================================================================= */
:where(.vuetify-styles) hr {
  overflow: visible; /* Show the overflow in Edge and IE */
  height: 0; /* Add the correct box sizing in Firefox */
}

:where(.vuetify-styles) details,
:where(.vuetify-styles) main {
  display: block; /* Render the \`main\` element consistently in IE. */
}

:where(.vuetify-styles) summary {
  display: list-item; /* Add the correct display in all browsers */
}

:where(.vuetify-styles) small {
  font-size: 80%; /* Set font-size to 80% in \`small\` elements */
}

:where(.vuetify-styles) [hidden] {
  display: none; /* Add the correct display in IE */
}

:where(.vuetify-styles) abbr[title] {
  border-bottom: none; /* Remove the bottom border in Chrome 57 */
  /* Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari */
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

:where(.vuetify-styles) a {
  background-color: transparent; /* Remove the gray background on active links in IE 10 */
}

:where(.vuetify-styles) a:active,
:where(.vuetify-styles) a:hover {
  outline-width: 0; /* Remove the outline when hovering in all browsers */
}

:where(.vuetify-styles) code,
:where(.vuetify-styles) kbd,
:where(.vuetify-styles) pre,
:where(.vuetify-styles) samp {
  font-family: monospace, monospace; /* Specify the font family of code elements */
}

:where(.vuetify-styles) pre {
  font-size: 1em; /* Correct the odd \`em\` font sizing in all browsers */
}

:where(.vuetify-styles) b,
:where(.vuetify-styles) strong {
  font-weight: bolder; /* Add the correct font weight in Chrome, Edge, and Safari */
}

/* https://gist.github.com/unruthless/413930 */
:where(.vuetify-styles) sub,
:where(.vuetify-styles) sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

:where(.vuetify-styles) sub {
  bottom: -0.25em;
}

:where(.vuetify-styles) sup {
  top: -0.5em;
}

/* # =================================================================
   # Forms
   # ================================================================= */
:where(.vuetify-styles) input {
  border-radius: 0;
}

/* Replace pointer cursor in disabled elements */
:where(.vuetify-styles) [disabled] {
  cursor: default;
}

:where(.vuetify-styles) [type=number]::-webkit-inner-spin-button,
:where(.vuetify-styles) [type=number]::-webkit-outer-spin-button {
  height: auto; /* Correct the cursor style of increment and decrement buttons in Chrome */
}

:where(.vuetify-styles) [type=search] {
  -webkit-appearance: textfield; /* Correct the odd appearance in Chrome and Safari */
  outline-offset: -2px; /* Correct the outline style in Safari */
}

:where(.vuetify-styles) [type=search]::-webkit-search-cancel-button,
:where(.vuetify-styles) [type=search]::-webkit-search-decoration {
  -webkit-appearance: none; /* Remove the inner padding in Chrome and Safari on macOS */
}

:where(.vuetify-styles) textarea {
  overflow: auto; /* Internet Explorer 11+ */
  resize: vertical; /* Specify textarea resizability */
}

:where(.vuetify-styles) button,
:where(.vuetify-styles) input,
:where(.vuetify-styles) optgroup,
:where(.vuetify-styles) select,
:where(.vuetify-styles) textarea {
  font: inherit; /* Specify font inheritance of form elements */
}

:where(.vuetify-styles) optgroup {
  font-weight: bold; /* Restore the font weight unset by the previous rule */
}

:where(.vuetify-styles) button {
  overflow: visible; /* Address \`overflow\` set to \`hidden\` in IE 8/9/10/11 */
}

:where(.vuetify-styles) button,
:where(.vuetify-styles) select {
  text-transform: none; /* Firefox 40+, Internet Explorer 11- */
}

/* Apply cursor pointer to button elements */
:where(.vuetify-styles) button,
:where(.vuetify-styles) [type=button],
:where(.vuetify-styles) [type=reset],
:where(.vuetify-styles) [type=submit],
:where(.vuetify-styles) [role=button] {
  cursor: pointer;
  color: inherit;
}

/* Remove inner padding and border in Firefox 4+ */
:where(.vuetify-styles) button::-moz-focus-inner,
:where(.vuetify-styles) [type=button]::-moz-focus-inner,
:where(.vuetify-styles) [type=reset]::-moz-focus-inner,
:where(.vuetify-styles) [type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/* Replace focus style removed in the border reset above */
:where(.vuetify-styles) button:-moz-focusring,
:where(.vuetify-styles) [type=button]::-moz-focus-inner,
:where(.vuetify-styles) [type=reset]::-moz-focus-inner,
:where(.vuetify-styles) [type=submit]::-moz-focus-inner {
  outline: 1px dotted ButtonText;
}

:where(.vuetify-styles) button,
:where(.vuetify-styles) html [type=button],
:where(.vuetify-styles) [type=reset],
:where(.vuetify-styles) [type=submit] {
  -webkit-appearance: button; /* Correct the inability to style clickable types in iOS */
}

/* Remove the default button styling in all browsers */
:where(.vuetify-styles) button,
:where(.vuetify-styles) input,
:where(.vuetify-styles) select,
:where(.vuetify-styles) textarea {
  background-color: transparent;
  border-style: none;
}

/* Style select like a standard input */
:where(.vuetify-styles) select {
  -moz-appearance: none; /* Firefox 36+ */
  -webkit-appearance: none; /* Chrome 41+ */
}

:where(.vuetify-styles) select::-ms-expand {
  display: none; /* Internet Explorer 11+ */
}

:where(.vuetify-styles) select::-ms-value {
  color: currentColor; /* Internet Explorer 11+ */
}

:where(.vuetify-styles) legend {
  border: 0; /* Correct \`color\` not being inherited in IE 8/9/10/11 */
  color: inherit; /* Correct the color inheritance from \`fieldset\` elements in IE */
  display: table; /* Correct the text wrapping in Edge and IE */
  max-width: 100%; /* Correct the text wrapping in Edge and IE */
  white-space: normal; /* Correct the text wrapping in Edge and IE */
  max-width: 100%; /* Correct the text wrapping in Edge 18- and IE */
}

:where(.vuetify-styles) ::-webkit-file-upload-button {
  /* Correct the inability to style clickable types in iOS and Safari */
  -webkit-appearance: button;
  color: inherit;
  font: inherit; /* Change font properties to \`inherit\` in Chrome and Safari */
}

:where(.vuetify-styles) ::-ms-clear,
:where(.vuetify-styles) ::-ms-reveal {
  display: none;
}

/* # =================================================================
   # Specify media element style
   # ================================================================= */
:where(.vuetify-styles) img {
  border-style: none; /* Remove border when inside \`a\` element in IE 8/9/10 */
}

/* Add the correct vertical alignment in Chrome, Firefox, and Opera */
:where(.vuetify-styles) progress {
  vertical-align: baseline;
}

/* # =================================================================
   # Accessibility
   # ================================================================= */
/* Hide content from screens but not screenreaders */
@media screen {
  :where(.vuetify-styles) [hidden~=screen] {
    display: inherit;
  }
  :where(.vuetify-styles) [hidden~=screen]:not(:active):not(:focus):not(:target) {
    position: absolute !important;
    clip: rect(0 0 0 0) !important;
  }
}
/* Specify the progress cursor of updating elements */
:where(.vuetify-styles) [aria-busy=true] {
  cursor: progress;
}

/* Specify the pointer cursor of trigger elements */
:where(.vuetify-styles) [aria-controls] {
  cursor: pointer;
}

/* Specify the unstyled cursor of disabled, not-editable, or otherwise inoperable elements */
:where(.vuetify-styles) [aria-disabled=true] {
  cursor: default;
}

@media (prefers-reduced-motion: no-preference) {
  :where(.vuetify-styles) .dialog-transition-enter-active,
  :where(.vuetify-styles) .dialog-bottom-transition-enter-active,
  :where(.vuetify-styles) .dialog-top-transition-enter-active {
    transition-duration: 225ms !important;
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .dialog-transition-leave-active,
  :where(.vuetify-styles) .dialog-bottom-transition-leave-active,
  :where(.vuetify-styles) .dialog-top-transition-leave-active {
    transition-duration: 125ms !important;
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1) !important;
  }
  :where(.vuetify-styles) .dialog-transition-enter-active, :where(.vuetify-styles) .dialog-transition-leave-active, :where(.vuetify-styles) .dialog-bottom-transition-enter-active, :where(.vuetify-styles) .dialog-bottom-transition-leave-active, :where(.vuetify-styles) .dialog-top-transition-enter-active, :where(.vuetify-styles) .dialog-top-transition-leave-active {
    transition-property: transform, opacity !important;
    pointer-events: none;
  }
  :where(.vuetify-styles) .dialog-transition-enter-from, :where(.vuetify-styles) .dialog-transition-leave-to {
    transform: scale(0.9);
    opacity: 0;
  }
  :where(.vuetify-styles) .dialog-transition-enter-to, :where(.vuetify-styles) .dialog-transition-leave-from {
    opacity: 1;
  }
  :where(.vuetify-styles) .dialog-bottom-transition-enter-from, :where(.vuetify-styles) .dialog-bottom-transition-leave-to {
    transform: translateY(calc(50vh + 50%));
  }
  :where(.vuetify-styles) .dialog-top-transition-enter-from, :where(.vuetify-styles) .dialog-top-transition-leave-to {
    transform: translateY(calc(-50vh - 50%));
  }
  :where(.vuetify-styles) .picker-transition-enter-active,
  :where(.vuetify-styles) .picker-reverse-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .picker-transition-leave-active,
  :where(.vuetify-styles) .picker-reverse-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .picker-transition-move,
  :where(.vuetify-styles) .picker-reverse-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .picker-transition-enter-from, :where(.vuetify-styles) .picker-transition-leave-to, :where(.vuetify-styles) .picker-reverse-transition-enter-from, :where(.vuetify-styles) .picker-reverse-transition-leave-to {
    opacity: 0;
  }
  :where(.vuetify-styles) .picker-transition-leave-from, :where(.vuetify-styles) .picker-transition-leave-active, :where(.vuetify-styles) .picker-transition-leave-to, :where(.vuetify-styles) .picker-reverse-transition-leave-from, :where(.vuetify-styles) .picker-reverse-transition-leave-active, :where(.vuetify-styles) .picker-reverse-transition-leave-to {
    position: absolute !important;
  }
  :where(.vuetify-styles) .picker-transition-enter-active, :where(.vuetify-styles) .picker-transition-leave-active, :where(.vuetify-styles) .picker-reverse-transition-enter-active, :where(.vuetify-styles) .picker-reverse-transition-leave-active {
    transition-property: transform, opacity !important;
  }
  :where(.vuetify-styles) .picker-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .picker-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .picker-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .picker-transition-enter-from {
    transform: translate(100%, 0);
  }
  :where(.vuetify-styles) .picker-transition-leave-to {
    transform: translate(-100%, 0);
  }
  :where(.vuetify-styles) .picker-reverse-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .picker-reverse-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .picker-reverse-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .picker-reverse-transition-enter-from {
    transform: translate(-100%, 0);
  }
  :where(.vuetify-styles) .picker-reverse-transition-leave-to {
    transform: translate(100%, 0);
  }
  :where(.vuetify-styles) .expand-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .expand-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .expand-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .expand-transition-enter-active, :where(.vuetify-styles) .expand-transition-leave-active {
    transition-property: height !important;
  }
  :where(.vuetify-styles) .expand-x-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .expand-x-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .expand-x-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .expand-x-transition-enter-active, :where(.vuetify-styles) .expand-x-transition-leave-active {
    transition-property: width !important;
  }
  :where(.vuetify-styles) .expand-both-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .expand-both-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .expand-both-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .expand-both-transition-enter-active, :where(.vuetify-styles) .expand-both-transition-leave-active {
    transition-property: height, width !important;
  }
  :where(.vuetify-styles) .scale-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scale-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scale-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scale-transition-leave-to {
    opacity: 0;
  }
  :where(.vuetify-styles) .scale-transition-leave-active {
    transition-duration: 100ms !important;
  }
  :where(.vuetify-styles) .scale-transition-enter-from {
    opacity: 0;
    transform: scale(0);
  }
  :where(.vuetify-styles) .scale-transition-enter-active, :where(.vuetify-styles) .scale-transition-leave-active {
    transition-property: transform, opacity !important;
  }
  :where(.vuetify-styles) .scale-rotate-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scale-rotate-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scale-rotate-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scale-rotate-transition-leave-to {
    opacity: 0;
  }
  :where(.vuetify-styles) .scale-rotate-transition-leave-active {
    transition-duration: 100ms !important;
  }
  :where(.vuetify-styles) .scale-rotate-transition-enter-from {
    opacity: 0;
    transform: scale(0) rotate(-45deg);
  }
  :where(.vuetify-styles) .scale-rotate-transition-enter-active, :where(.vuetify-styles) .scale-rotate-transition-leave-active {
    transition-property: transform, opacity !important;
  }
  :where(.vuetify-styles) .scale-rotate-reverse-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scale-rotate-reverse-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scale-rotate-reverse-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scale-rotate-reverse-transition-leave-to {
    opacity: 0;
  }
  :where(.vuetify-styles) .scale-rotate-reverse-transition-leave-active {
    transition-duration: 100ms !important;
  }
  :where(.vuetify-styles) .scale-rotate-reverse-transition-enter-from {
    opacity: 0;
    transform: scale(0) rotate(45deg);
  }
  :where(.vuetify-styles) .scale-rotate-reverse-transition-enter-active, :where(.vuetify-styles) .scale-rotate-reverse-transition-leave-active {
    transition-property: transform, opacity !important;
  }
  :where(.vuetify-styles) .message-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .message-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .message-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .message-transition-enter-from, :where(.vuetify-styles) .message-transition-leave-to {
    opacity: 0;
    transform: translateY(-15px);
  }
  :where(.vuetify-styles) .message-transition-leave-from, :where(.vuetify-styles) .message-transition-leave-active {
    position: absolute;
  }
  :where(.vuetify-styles) .message-transition-enter-active, :where(.vuetify-styles) .message-transition-leave-active {
    transition-property: transform, opacity !important;
  }
  :where(.vuetify-styles) .slide-y-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .slide-y-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .slide-y-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .slide-y-transition-enter-from, :where(.vuetify-styles) .slide-y-transition-leave-to {
    opacity: 0;
    transform: translateY(-15px);
  }
  :where(.vuetify-styles) .slide-y-transition-enter-active, :where(.vuetify-styles) .slide-y-transition-leave-active {
    transition-property: transform, opacity !important;
  }
  :where(.vuetify-styles) .slide-y-reverse-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .slide-y-reverse-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .slide-y-reverse-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .slide-y-reverse-transition-enter-from, :where(.vuetify-styles) .slide-y-reverse-transition-leave-to {
    opacity: 0;
    transform: translateY(15px);
  }
  :where(.vuetify-styles) .slide-y-reverse-transition-enter-active, :where(.vuetify-styles) .slide-y-reverse-transition-leave-active {
    transition-property: transform, opacity !important;
  }
  :where(.vuetify-styles) .scroll-y-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scroll-y-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scroll-y-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scroll-y-transition-enter-from, :where(.vuetify-styles) .scroll-y-transition-leave-to {
    opacity: 0;
  }
  :where(.vuetify-styles) .scroll-y-transition-enter-from {
    transform: translateY(-15px);
  }
  :where(.vuetify-styles) .scroll-y-transition-leave-to {
    transform: translateY(15px);
  }
  :where(.vuetify-styles) .scroll-y-transition-enter-active, :where(.vuetify-styles) .scroll-y-transition-leave-active {
    transition-property: transform, opacity !important;
  }
  :where(.vuetify-styles) .scroll-y-reverse-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scroll-y-reverse-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scroll-y-reverse-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scroll-y-reverse-transition-enter-from, :where(.vuetify-styles) .scroll-y-reverse-transition-leave-to {
    opacity: 0;
  }
  :where(.vuetify-styles) .scroll-y-reverse-transition-enter-from {
    transform: translateY(15px);
  }
  :where(.vuetify-styles) .scroll-y-reverse-transition-leave-to {
    transform: translateY(-15px);
  }
  :where(.vuetify-styles) .scroll-y-reverse-transition-enter-active, :where(.vuetify-styles) .scroll-y-reverse-transition-leave-active {
    transition-property: transform, opacity !important;
  }
  :where(.vuetify-styles) .scroll-x-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scroll-x-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scroll-x-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scroll-x-transition-enter-from, :where(.vuetify-styles) .scroll-x-transition-leave-to {
    opacity: 0;
  }
  :where(.vuetify-styles) .scroll-x-transition-enter-from {
    transform: translateX(-15px);
  }
  :where(.vuetify-styles) .scroll-x-transition-leave-to {
    transform: translateX(15px);
  }
  :where(.vuetify-styles) .scroll-x-transition-enter-active, :where(.vuetify-styles) .scroll-x-transition-leave-active {
    transition-property: transform, opacity !important;
  }
  :where(.vuetify-styles) .scroll-x-reverse-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scroll-x-reverse-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scroll-x-reverse-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .scroll-x-reverse-transition-enter-from, :where(.vuetify-styles) .scroll-x-reverse-transition-leave-to {
    opacity: 0;
  }
  :where(.vuetify-styles) .scroll-x-reverse-transition-enter-from {
    transform: translateX(15px);
  }
  :where(.vuetify-styles) .scroll-x-reverse-transition-leave-to {
    transform: translateX(-15px);
  }
  :where(.vuetify-styles) .scroll-x-reverse-transition-enter-active, :where(.vuetify-styles) .scroll-x-reverse-transition-leave-active {
    transition-property: transform, opacity !important;
  }
  :where(.vuetify-styles) .slide-x-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .slide-x-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .slide-x-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .slide-x-transition-enter-from, :where(.vuetify-styles) .slide-x-transition-leave-to {
    opacity: 0;
    transform: translateX(-15px);
  }
  :where(.vuetify-styles) .slide-x-transition-enter-active, :where(.vuetify-styles) .slide-x-transition-leave-active {
    transition-property: transform, opacity !important;
  }
  :where(.vuetify-styles) .slide-x-reverse-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .slide-x-reverse-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .slide-x-reverse-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .slide-x-reverse-transition-enter-from, :where(.vuetify-styles) .slide-x-reverse-transition-leave-to {
    opacity: 0;
    transform: translateX(15px);
  }
  :where(.vuetify-styles) .slide-x-reverse-transition-enter-active, :where(.vuetify-styles) .slide-x-reverse-transition-leave-active {
    transition-property: transform, opacity !important;
  }
  :where(.vuetify-styles) .fade-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .fade-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .fade-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .fade-transition-enter-from, :where(.vuetify-styles) .fade-transition-leave-to {
    opacity: 0 !important;
  }
  :where(.vuetify-styles) .fade-transition-enter-active, :where(.vuetify-styles) .fade-transition-leave-active {
    transition-property: opacity !important;
  }
  :where(.vuetify-styles) .fab-transition-enter-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .fab-transition-leave-active {
    transition-duration: 0.3s !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .fab-transition-move {
    transition-duration: 0.5s !important;
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  :where(.vuetify-styles) .fab-transition-enter-from, :where(.vuetify-styles) .fab-transition-leave-to {
    transform: scale(0) rotate(-45deg);
  }
  :where(.vuetify-styles) .fab-transition-enter-active, :where(.vuetify-styles) .fab-transition-leave-active {
    transition-property: transform !important;
  }
}
:where(.vuetify-styles) .v-locale--is-rtl {
  direction: rtl;
}
:where(.vuetify-styles) .v-locale--is-ltr {
  direction: ltr;
}

:where(.vuetify-styles) .blockquote {
  padding: 16px 0 16px 24px;
  font-size: 18px;
  font-weight: 300;
}

:where(.vuetify-styles) html {
  font-family: "Roboto", sans-serif;
  line-height: 1.5;
  font-size: 1rem;
  overflow-x: hidden;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

:where(.vuetify-styles) html.overflow-y-hidden {
  overflow-y: hidden !important;
}

:where(.vuetify-styles) :root {
  --v-theme-overlay-multiplier: 1;
  --v-scrollbar-offset: 0px;
}

@supports (-webkit-touch-callout: none) {
  :where(.vuetify-styles) body {
    cursor: pointer;
  }
}
@media only print {
  :where(.vuetify-styles) .hidden-print-only {
    display: none !important;
  }
}

@media only screen {
  :where(.vuetify-styles) .hidden-screen-only {
    display: none !important;
  }
}

@media (max-width: 599.98px) {
  :where(.vuetify-styles) .hidden-xs {
    display: none !important;
  }
}

@media (min-width: 600px) and (max-width: 959.98px) {
  :where(.vuetify-styles) .hidden-sm {
    display: none !important;
  }
}

@media (min-width: 960px) and (max-width: 1279.98px) {
  :where(.vuetify-styles) .hidden-md {
    display: none !important;
  }
}

@media (min-width: 1280px) and (max-width: 1919.98px) {
  :where(.vuetify-styles) .hidden-lg {
    display: none !important;
  }
}

@media (min-width: 1920px) and (max-width: 2559.98px) {
  :where(.vuetify-styles) .hidden-xl {
    display: none !important;
  }
}

@media (min-width: 2560px) {
  :where(.vuetify-styles) .hidden-xxl {
    display: none !important;
  }
}

@media (min-width: 600px) {
  :where(.vuetify-styles) .hidden-sm-and-up {
    display: none !important;
  }
}

@media (min-width: 960px) {
  :where(.vuetify-styles) .hidden-md-and-up {
    display: none !important;
  }
}

@media (min-width: 1280px) {
  :where(.vuetify-styles) .hidden-lg-and-up {
    display: none !important;
  }
}

@media (min-width: 1920px) {
  :where(.vuetify-styles) .hidden-xl-and-up {
    display: none !important;
  }
}

@media (max-width: 959.98px) {
  :where(.vuetify-styles) .hidden-sm-and-down {
    display: none !important;
  }
}

@media (max-width: 1279.98px) {
  :where(.vuetify-styles) .hidden-md-and-down {
    display: none !important;
  }
}

@media (max-width: 1919.98px) {
  :where(.vuetify-styles) .hidden-lg-and-down {
    display: none !important;
  }
}

@media (max-width: 2559.98px) {
  :where(.vuetify-styles) .hidden-xl-and-down {
    display: none !important;
  }
}

:where(.vuetify-styles) .elevation-24 {
  box-shadow: 0px 11px 15px -7px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 24px 38px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 9px 46px 8px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-23 {
  box-shadow: 0px 11px 14px -7px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 23px 36px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 9px 44px 8px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-22 {
  box-shadow: 0px 10px 14px -6px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 22px 35px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 8px 42px 7px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-21 {
  box-shadow: 0px 10px 13px -6px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 21px 33px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 8px 40px 7px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-20 {
  box-shadow: 0px 10px 13px -6px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 20px 31px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 8px 38px 7px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-19 {
  box-shadow: 0px 9px 12px -6px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 19px 29px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 7px 36px 6px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-18 {
  box-shadow: 0px 9px 11px -5px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 18px 28px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 7px 34px 6px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-17 {
  box-shadow: 0px 8px 11px -5px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 17px 26px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 6px 32px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-16 {
  box-shadow: 0px 8px 10px -5px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 16px 24px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 6px 30px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-15 {
  box-shadow: 0px 8px 9px -5px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 15px 22px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 6px 28px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-14 {
  box-shadow: 0px 7px 9px -4px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 14px 21px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 5px 26px 4px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-13 {
  box-shadow: 0px 7px 8px -4px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 13px 19px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 5px 24px 4px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-12 {
  box-shadow: 0px 7px 8px -4px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 12px 17px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 5px 22px 4px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-11 {
  box-shadow: 0px 6px 7px -4px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 11px 15px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 4px 20px 3px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-10 {
  box-shadow: 0px 6px 6px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 10px 14px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 4px 18px 3px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-9 {
  box-shadow: 0px 5px 6px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 9px 12px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 3px 16px 2px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-8 {
  box-shadow: 0px 5px 5px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 8px 10px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 3px 14px 2px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-7 {
  box-shadow: 0px 4px 5px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 7px 10px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 2px 16px 1px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-6 {
  box-shadow: 0px 3px 5px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 6px 10px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 18px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-5 {
  box-shadow: 0px 3px 5px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 5px 8px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 14px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-4 {
  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-3 {
  box-shadow: 0px 3px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 3px 4px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 8px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-2 {
  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-1 {
  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .elevation-0 {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
}

:where(.vuetify-styles) .pointer-events-none {
  pointer-events: none !important;
}

:where(.vuetify-styles) .pointer-events-auto {
  pointer-events: auto !important;
}

:where(.vuetify-styles) .pointer-pass-through {
  pointer-events: none !important;
}
:where(.vuetify-styles) .pointer-pass-through > * {
  pointer-events: auto !important;
}

:where(.vuetify-styles) .d-sr-only,
:where(.vuetify-styles) .d-sr-only-focusable:not(:focus) {
  border: 0 !important;
  clip: rect(0, 0, 0, 0) !important;
  height: 1px !important;
  margin: -1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  white-space: nowrap !important;
  width: 1px !important;
}

:where(.vuetify-styles) .overflow-auto {
  overflow: auto !important;
}

:where(.vuetify-styles) .overflow-hidden {
  overflow: hidden !important;
}

:where(.vuetify-styles) .overflow-visible {
  overflow: visible !important;
}

:where(.vuetify-styles) .overflow-scroll {
  overflow: scroll !important;
}

:where(.vuetify-styles) .overflow-x-auto {
  overflow-x: auto !important;
}

:where(.vuetify-styles) .overflow-x-hidden {
  overflow-x: hidden !important;
}

:where(.vuetify-styles) .overflow-x-scroll {
  overflow-x: scroll !important;
}

:where(.vuetify-styles) .overflow-y-auto {
  overflow-y: auto !important;
}

:where(.vuetify-styles) .overflow-y-hidden {
  overflow-y: hidden !important;
}

:where(.vuetify-styles) .overflow-y-scroll {
  overflow-y: scroll !important;
}

:where(.vuetify-styles) .d-none {
  display: none !important;
}

:where(.vuetify-styles) .d-inline {
  display: inline !important;
}

:where(.vuetify-styles) .d-inline-block {
  display: inline-block !important;
}

:where(.vuetify-styles) .d-block {
  display: block !important;
}

:where(.vuetify-styles) .d-table {
  display: table !important;
}

:where(.vuetify-styles) .d-table-row {
  display: table-row !important;
}

:where(.vuetify-styles) .d-table-cell {
  display: table-cell !important;
}

:where(.vuetify-styles) .d-flex {
  display: flex !important;
}

:where(.vuetify-styles) .d-inline-flex {
  display: inline-flex !important;
}

:where(.vuetify-styles) .float-none {
  float: none !important;
}

:where(.vuetify-styles) .float-left {
  float: left !important;
}

:where(.vuetify-styles) .float-right {
  float: right !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .float-end {
  float: left !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .float-start {
  float: right !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .float-end {
  float: right !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .float-start {
  float: left !important;
}

:where(.vuetify-styles) .flex-fill {
  flex: 1 1 auto !important;
}

:where(.vuetify-styles) .flex-1-1 {
  flex: 1 1 auto !important;
}

:where(.vuetify-styles) .flex-1-0 {
  flex: 1 0 auto !important;
}

:where(.vuetify-styles) .flex-0-1 {
  flex: 0 1 auto !important;
}

:where(.vuetify-styles) .flex-0-0 {
  flex: 0 0 auto !important;
}

:where(.vuetify-styles) .flex-1-1-100 {
  flex: 1 1 100% !important;
}

:where(.vuetify-styles) .flex-1-0-100 {
  flex: 1 0 100% !important;
}

:where(.vuetify-styles) .flex-0-1-100 {
  flex: 0 1 100% !important;
}

:where(.vuetify-styles) .flex-0-0-100 {
  flex: 0 0 100% !important;
}

:where(.vuetify-styles) .flex-1-1-0 {
  flex: 1 1 0 !important;
}

:where(.vuetify-styles) .flex-1-0-0 {
  flex: 1 0 0 !important;
}

:where(.vuetify-styles) .flex-0-1-0 {
  flex: 0 1 0 !important;
}

:where(.vuetify-styles) .flex-0-0-0 {
  flex: 0 0 0 !important;
}

:where(.vuetify-styles) .flex-row {
  flex-direction: row !important;
}

:where(.vuetify-styles) .flex-column {
  flex-direction: column !important;
}

:where(.vuetify-styles) .flex-row-reverse {
  flex-direction: row-reverse !important;
}

:where(.vuetify-styles) .flex-column-reverse {
  flex-direction: column-reverse !important;
}

:where(.vuetify-styles) .flex-grow-0 {
  flex-grow: 0 !important;
}

:where(.vuetify-styles) .flex-grow-1 {
  flex-grow: 1 !important;
}

:where(.vuetify-styles) .flex-shrink-0 {
  flex-shrink: 0 !important;
}

:where(.vuetify-styles) .flex-shrink-1 {
  flex-shrink: 1 !important;
}

:where(.vuetify-styles) .flex-wrap {
  flex-wrap: wrap !important;
}

:where(.vuetify-styles) .flex-nowrap {
  flex-wrap: nowrap !important;
}

:where(.vuetify-styles) .flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

:where(.vuetify-styles) .justify-start {
  justify-content: flex-start !important;
}

:where(.vuetify-styles) .justify-end {
  justify-content: flex-end !important;
}

:where(.vuetify-styles) .justify-center {
  justify-content: center !important;
}

:where(.vuetify-styles) .justify-space-between {
  justify-content: space-between !important;
}

:where(.vuetify-styles) .justify-space-around {
  justify-content: space-around !important;
}

:where(.vuetify-styles) .justify-space-evenly {
  justify-content: space-evenly !important;
}

:where(.vuetify-styles) .justify-items-start {
  justify-items: flex-start !important;
}

:where(.vuetify-styles) .justify-items-end {
  justify-items: flex-end !important;
}

:where(.vuetify-styles) .justify-items-center {
  justify-items: center !important;
}

:where(.vuetify-styles) .justify-items-stretch {
  justify-items: stretch !important;
}

:where(.vuetify-styles) .align-start {
  align-items: flex-start !important;
}

:where(.vuetify-styles) .align-end {
  align-items: flex-end !important;
}

:where(.vuetify-styles) .align-center {
  align-items: center !important;
}

:where(.vuetify-styles) .align-baseline {
  align-items: baseline !important;
}

:where(.vuetify-styles) .align-stretch {
  align-items: stretch !important;
}

:where(.vuetify-styles) .align-content-start {
  align-content: flex-start !important;
}

:where(.vuetify-styles) .align-content-end {
  align-content: flex-end !important;
}

:where(.vuetify-styles) .align-content-center {
  align-content: center !important;
}

:where(.vuetify-styles) .align-content-space-between {
  align-content: space-between !important;
}

:where(.vuetify-styles) .align-content-space-around {
  align-content: space-around !important;
}

:where(.vuetify-styles) .align-content-space-evenly {
  align-content: space-evenly !important;
}

:where(.vuetify-styles) .align-content-stretch {
  align-content: stretch !important;
}

:where(.vuetify-styles) .align-self-auto {
  align-self: auto !important;
}

:where(.vuetify-styles) .align-self-start {
  align-self: flex-start !important;
}

:where(.vuetify-styles) .align-self-end {
  align-self: flex-end !important;
}

:where(.vuetify-styles) .align-self-center {
  align-self: center !important;
}

:where(.vuetify-styles) .align-self-baseline {
  align-self: baseline !important;
}

:where(.vuetify-styles) .align-self-stretch {
  align-self: stretch !important;
}

:where(.vuetify-styles) .order-first {
  order: -1 !important;
}

:where(.vuetify-styles) .order-0 {
  order: 0 !important;
}

:where(.vuetify-styles) .order-1 {
  order: 1 !important;
}

:where(.vuetify-styles) .order-2 {
  order: 2 !important;
}

:where(.vuetify-styles) .order-3 {
  order: 3 !important;
}

:where(.vuetify-styles) .order-4 {
  order: 4 !important;
}

:where(.vuetify-styles) .order-5 {
  order: 5 !important;
}

:where(.vuetify-styles) .order-6 {
  order: 6 !important;
}

:where(.vuetify-styles) .order-7 {
  order: 7 !important;
}

:where(.vuetify-styles) .order-8 {
  order: 8 !important;
}

:where(.vuetify-styles) .order-9 {
  order: 9 !important;
}

:where(.vuetify-styles) .order-10 {
  order: 10 !important;
}

:where(.vuetify-styles) .order-11 {
  order: 11 !important;
}

:where(.vuetify-styles) .order-12 {
  order: 12 !important;
}

:where(.vuetify-styles) .order-last {
  order: 13 !important;
}

:where(.vuetify-styles) .ga-0 {
  gap: 0px !important;
}

:where(.vuetify-styles) .ga-1 {
  gap: 4px !important;
}

:where(.vuetify-styles) .ga-2 {
  gap: 8px !important;
}

:where(.vuetify-styles) .ga-3 {
  gap: 12px !important;
}

:where(.vuetify-styles) .ga-4 {
  gap: 16px !important;
}

:where(.vuetify-styles) .ga-5 {
  gap: 20px !important;
}

:where(.vuetify-styles) .ga-6 {
  gap: 24px !important;
}

:where(.vuetify-styles) .ga-7 {
  gap: 28px !important;
}

:where(.vuetify-styles) .ga-8 {
  gap: 32px !important;
}

:where(.vuetify-styles) .ga-9 {
  gap: 36px !important;
}

:where(.vuetify-styles) .ga-10 {
  gap: 40px !important;
}

:where(.vuetify-styles) .ga-11 {
  gap: 44px !important;
}

:where(.vuetify-styles) .ga-12 {
  gap: 48px !important;
}

:where(.vuetify-styles) .ga-13 {
  gap: 52px !important;
}

:where(.vuetify-styles) .ga-14 {
  gap: 56px !important;
}

:where(.vuetify-styles) .ga-15 {
  gap: 60px !important;
}

:where(.vuetify-styles) .ga-16 {
  gap: 64px !important;
}

:where(.vuetify-styles) .ga-auto {
  gap: auto !important;
}

:where(.vuetify-styles) .gr-0 {
  row-gap: 0px !important;
}

:where(.vuetify-styles) .gr-1 {
  row-gap: 4px !important;
}

:where(.vuetify-styles) .gr-2 {
  row-gap: 8px !important;
}

:where(.vuetify-styles) .gr-3 {
  row-gap: 12px !important;
}

:where(.vuetify-styles) .gr-4 {
  row-gap: 16px !important;
}

:where(.vuetify-styles) .gr-5 {
  row-gap: 20px !important;
}

:where(.vuetify-styles) .gr-6 {
  row-gap: 24px !important;
}

:where(.vuetify-styles) .gr-7 {
  row-gap: 28px !important;
}

:where(.vuetify-styles) .gr-8 {
  row-gap: 32px !important;
}

:where(.vuetify-styles) .gr-9 {
  row-gap: 36px !important;
}

:where(.vuetify-styles) .gr-10 {
  row-gap: 40px !important;
}

:where(.vuetify-styles) .gr-11 {
  row-gap: 44px !important;
}

:where(.vuetify-styles) .gr-12 {
  row-gap: 48px !important;
}

:where(.vuetify-styles) .gr-13 {
  row-gap: 52px !important;
}

:where(.vuetify-styles) .gr-14 {
  row-gap: 56px !important;
}

:where(.vuetify-styles) .gr-15 {
  row-gap: 60px !important;
}

:where(.vuetify-styles) .gr-16 {
  row-gap: 64px !important;
}

:where(.vuetify-styles) .gr-auto {
  row-gap: auto !important;
}

:where(.vuetify-styles) .gc-0 {
  column-gap: 0px !important;
}

:where(.vuetify-styles) .gc-1 {
  column-gap: 4px !important;
}

:where(.vuetify-styles) .gc-2 {
  column-gap: 8px !important;
}

:where(.vuetify-styles) .gc-3 {
  column-gap: 12px !important;
}

:where(.vuetify-styles) .gc-4 {
  column-gap: 16px !important;
}

:where(.vuetify-styles) .gc-5 {
  column-gap: 20px !important;
}

:where(.vuetify-styles) .gc-6 {
  column-gap: 24px !important;
}

:where(.vuetify-styles) .gc-7 {
  column-gap: 28px !important;
}

:where(.vuetify-styles) .gc-8 {
  column-gap: 32px !important;
}

:where(.vuetify-styles) .gc-9 {
  column-gap: 36px !important;
}

:where(.vuetify-styles) .gc-10 {
  column-gap: 40px !important;
}

:where(.vuetify-styles) .gc-11 {
  column-gap: 44px !important;
}

:where(.vuetify-styles) .gc-12 {
  column-gap: 48px !important;
}

:where(.vuetify-styles) .gc-13 {
  column-gap: 52px !important;
}

:where(.vuetify-styles) .gc-14 {
  column-gap: 56px !important;
}

:where(.vuetify-styles) .gc-15 {
  column-gap: 60px !important;
}

:where(.vuetify-styles) .gc-16 {
  column-gap: 64px !important;
}

:where(.vuetify-styles) .gc-auto {
  column-gap: auto !important;
}

:where(.vuetify-styles) .ma-0 {
  margin: 0px !important;
}

:where(.vuetify-styles) .ma-1 {
  margin: 4px !important;
}

:where(.vuetify-styles) .ma-2 {
  margin: 8px !important;
}

:where(.vuetify-styles) .ma-3 {
  margin: 12px !important;
}

:where(.vuetify-styles) .ma-4 {
  margin: 16px !important;
}

:where(.vuetify-styles) .ma-5 {
  margin: 20px !important;
}

:where(.vuetify-styles) .ma-6 {
  margin: 24px !important;
}

:where(.vuetify-styles) .ma-7 {
  margin: 28px !important;
}

:where(.vuetify-styles) .ma-8 {
  margin: 32px !important;
}

:where(.vuetify-styles) .ma-9 {
  margin: 36px !important;
}

:where(.vuetify-styles) .ma-10 {
  margin: 40px !important;
}

:where(.vuetify-styles) .ma-11 {
  margin: 44px !important;
}

:where(.vuetify-styles) .ma-12 {
  margin: 48px !important;
}

:where(.vuetify-styles) .ma-13 {
  margin: 52px !important;
}

:where(.vuetify-styles) .ma-14 {
  margin: 56px !important;
}

:where(.vuetify-styles) .ma-15 {
  margin: 60px !important;
}

:where(.vuetify-styles) .ma-16 {
  margin: 64px !important;
}

:where(.vuetify-styles) .ma-auto {
  margin: auto !important;
}

:where(.vuetify-styles) .mx-0 {
  margin-right: 0px !important;
  margin-left: 0px !important;
}

:where(.vuetify-styles) .mx-1 {
  margin-right: 4px !important;
  margin-left: 4px !important;
}

:where(.vuetify-styles) .mx-2 {
  margin-right: 8px !important;
  margin-left: 8px !important;
}

:where(.vuetify-styles) .mx-3 {
  margin-right: 12px !important;
  margin-left: 12px !important;
}

:where(.vuetify-styles) .mx-4 {
  margin-right: 16px !important;
  margin-left: 16px !important;
}

:where(.vuetify-styles) .mx-5 {
  margin-right: 20px !important;
  margin-left: 20px !important;
}

:where(.vuetify-styles) .mx-6 {
  margin-right: 24px !important;
  margin-left: 24px !important;
}

:where(.vuetify-styles) .mx-7 {
  margin-right: 28px !important;
  margin-left: 28px !important;
}

:where(.vuetify-styles) .mx-8 {
  margin-right: 32px !important;
  margin-left: 32px !important;
}

:where(.vuetify-styles) .mx-9 {
  margin-right: 36px !important;
  margin-left: 36px !important;
}

:where(.vuetify-styles) .mx-10 {
  margin-right: 40px !important;
  margin-left: 40px !important;
}

:where(.vuetify-styles) .mx-11 {
  margin-right: 44px !important;
  margin-left: 44px !important;
}

:where(.vuetify-styles) .mx-12 {
  margin-right: 48px !important;
  margin-left: 48px !important;
}

:where(.vuetify-styles) .mx-13 {
  margin-right: 52px !important;
  margin-left: 52px !important;
}

:where(.vuetify-styles) .mx-14 {
  margin-right: 56px !important;
  margin-left: 56px !important;
}

:where(.vuetify-styles) .mx-15 {
  margin-right: 60px !important;
  margin-left: 60px !important;
}

:where(.vuetify-styles) .mx-16 {
  margin-right: 64px !important;
  margin-left: 64px !important;
}

:where(.vuetify-styles) .mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

:where(.vuetify-styles) .my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

:where(.vuetify-styles) .my-1 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

:where(.vuetify-styles) .my-2 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

:where(.vuetify-styles) .my-3 {
  margin-top: 12px !important;
  margin-bottom: 12px !important;
}

:where(.vuetify-styles) .my-4 {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}

:where(.vuetify-styles) .my-5 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

:where(.vuetify-styles) .my-6 {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}

:where(.vuetify-styles) .my-7 {
  margin-top: 28px !important;
  margin-bottom: 28px !important;
}

:where(.vuetify-styles) .my-8 {
  margin-top: 32px !important;
  margin-bottom: 32px !important;
}

:where(.vuetify-styles) .my-9 {
  margin-top: 36px !important;
  margin-bottom: 36px !important;
}

:where(.vuetify-styles) .my-10 {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}

:where(.vuetify-styles) .my-11 {
  margin-top: 44px !important;
  margin-bottom: 44px !important;
}

:where(.vuetify-styles) .my-12 {
  margin-top: 48px !important;
  margin-bottom: 48px !important;
}

:where(.vuetify-styles) .my-13 {
  margin-top: 52px !important;
  margin-bottom: 52px !important;
}

:where(.vuetify-styles) .my-14 {
  margin-top: 56px !important;
  margin-bottom: 56px !important;
}

:where(.vuetify-styles) .my-15 {
  margin-top: 60px !important;
  margin-bottom: 60px !important;
}

:where(.vuetify-styles) .my-16 {
  margin-top: 64px !important;
  margin-bottom: 64px !important;
}

:where(.vuetify-styles) .my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

:where(.vuetify-styles) .mt-0 {
  margin-top: 0px !important;
}

:where(.vuetify-styles) .mt-1 {
  margin-top: 4px !important;
}

:where(.vuetify-styles) .mt-2 {
  margin-top: 8px !important;
}

:where(.vuetify-styles) .mt-3 {
  margin-top: 12px !important;
}

:where(.vuetify-styles) .mt-4 {
  margin-top: 16px !important;
}

:where(.vuetify-styles) .mt-5 {
  margin-top: 20px !important;
}

:where(.vuetify-styles) .mt-6 {
  margin-top: 24px !important;
}

:where(.vuetify-styles) .mt-7 {
  margin-top: 28px !important;
}

:where(.vuetify-styles) .mt-8 {
  margin-top: 32px !important;
}

:where(.vuetify-styles) .mt-9 {
  margin-top: 36px !important;
}

:where(.vuetify-styles) .mt-10 {
  margin-top: 40px !important;
}

:where(.vuetify-styles) .mt-11 {
  margin-top: 44px !important;
}

:where(.vuetify-styles) .mt-12 {
  margin-top: 48px !important;
}

:where(.vuetify-styles) .mt-13 {
  margin-top: 52px !important;
}

:where(.vuetify-styles) .mt-14 {
  margin-top: 56px !important;
}

:where(.vuetify-styles) .mt-15 {
  margin-top: 60px !important;
}

:where(.vuetify-styles) .mt-16 {
  margin-top: 64px !important;
}

:where(.vuetify-styles) .mt-auto {
  margin-top: auto !important;
}

:where(.vuetify-styles) .mr-0 {
  margin-right: 0px !important;
}

:where(.vuetify-styles) .mr-1 {
  margin-right: 4px !important;
}

:where(.vuetify-styles) .mr-2 {
  margin-right: 8px !important;
}

:where(.vuetify-styles) .mr-3 {
  margin-right: 12px !important;
}

:where(.vuetify-styles) .mr-4 {
  margin-right: 16px !important;
}

:where(.vuetify-styles) .mr-5 {
  margin-right: 20px !important;
}

:where(.vuetify-styles) .mr-6 {
  margin-right: 24px !important;
}

:where(.vuetify-styles) .mr-7 {
  margin-right: 28px !important;
}

:where(.vuetify-styles) .mr-8 {
  margin-right: 32px !important;
}

:where(.vuetify-styles) .mr-9 {
  margin-right: 36px !important;
}

:where(.vuetify-styles) .mr-10 {
  margin-right: 40px !important;
}

:where(.vuetify-styles) .mr-11 {
  margin-right: 44px !important;
}

:where(.vuetify-styles) .mr-12 {
  margin-right: 48px !important;
}

:where(.vuetify-styles) .mr-13 {
  margin-right: 52px !important;
}

:where(.vuetify-styles) .mr-14 {
  margin-right: 56px !important;
}

:where(.vuetify-styles) .mr-15 {
  margin-right: 60px !important;
}

:where(.vuetify-styles) .mr-16 {
  margin-right: 64px !important;
}

:where(.vuetify-styles) .mr-auto {
  margin-right: auto !important;
}

:where(.vuetify-styles) .mb-0 {
  margin-bottom: 0px !important;
}

:where(.vuetify-styles) .mb-1 {
  margin-bottom: 4px !important;
}

:where(.vuetify-styles) .mb-2 {
  margin-bottom: 8px !important;
}

:where(.vuetify-styles) .mb-3 {
  margin-bottom: 12px !important;
}

:where(.vuetify-styles) .mb-4 {
  margin-bottom: 16px !important;
}

:where(.vuetify-styles) .mb-5 {
  margin-bottom: 20px !important;
}

:where(.vuetify-styles) .mb-6 {
  margin-bottom: 24px !important;
}

:where(.vuetify-styles) .mb-7 {
  margin-bottom: 28px !important;
}

:where(.vuetify-styles) .mb-8 {
  margin-bottom: 32px !important;
}

:where(.vuetify-styles) .mb-9 {
  margin-bottom: 36px !important;
}

:where(.vuetify-styles) .mb-10 {
  margin-bottom: 40px !important;
}

:where(.vuetify-styles) .mb-11 {
  margin-bottom: 44px !important;
}

:where(.vuetify-styles) .mb-12 {
  margin-bottom: 48px !important;
}

:where(.vuetify-styles) .mb-13 {
  margin-bottom: 52px !important;
}

:where(.vuetify-styles) .mb-14 {
  margin-bottom: 56px !important;
}

:where(.vuetify-styles) .mb-15 {
  margin-bottom: 60px !important;
}

:where(.vuetify-styles) .mb-16 {
  margin-bottom: 64px !important;
}

:where(.vuetify-styles) .mb-auto {
  margin-bottom: auto !important;
}

:where(.vuetify-styles) .ml-0 {
  margin-left: 0px !important;
}

:where(.vuetify-styles) .ml-1 {
  margin-left: 4px !important;
}

:where(.vuetify-styles) .ml-2 {
  margin-left: 8px !important;
}

:where(.vuetify-styles) .ml-3 {
  margin-left: 12px !important;
}

:where(.vuetify-styles) .ml-4 {
  margin-left: 16px !important;
}

:where(.vuetify-styles) .ml-5 {
  margin-left: 20px !important;
}

:where(.vuetify-styles) .ml-6 {
  margin-left: 24px !important;
}

:where(.vuetify-styles) .ml-7 {
  margin-left: 28px !important;
}

:where(.vuetify-styles) .ml-8 {
  margin-left: 32px !important;
}

:where(.vuetify-styles) .ml-9 {
  margin-left: 36px !important;
}

:where(.vuetify-styles) .ml-10 {
  margin-left: 40px !important;
}

:where(.vuetify-styles) .ml-11 {
  margin-left: 44px !important;
}

:where(.vuetify-styles) .ml-12 {
  margin-left: 48px !important;
}

:where(.vuetify-styles) .ml-13 {
  margin-left: 52px !important;
}

:where(.vuetify-styles) .ml-14 {
  margin-left: 56px !important;
}

:where(.vuetify-styles) .ml-15 {
  margin-left: 60px !important;
}

:where(.vuetify-styles) .ml-16 {
  margin-left: 64px !important;
}

:where(.vuetify-styles) .ml-auto {
  margin-left: auto !important;
}

:where(.vuetify-styles) .ms-0 {
  margin-inline-start: 0px !important;
}

:where(.vuetify-styles) .ms-1 {
  margin-inline-start: 4px !important;
}

:where(.vuetify-styles) .ms-2 {
  margin-inline-start: 8px !important;
}

:where(.vuetify-styles) .ms-3 {
  margin-inline-start: 12px !important;
}

:where(.vuetify-styles) .ms-4 {
  margin-inline-start: 16px !important;
}

:where(.vuetify-styles) .ms-5 {
  margin-inline-start: 20px !important;
}

:where(.vuetify-styles) .ms-6 {
  margin-inline-start: 24px !important;
}

:where(.vuetify-styles) .ms-7 {
  margin-inline-start: 28px !important;
}

:where(.vuetify-styles) .ms-8 {
  margin-inline-start: 32px !important;
}

:where(.vuetify-styles) .ms-9 {
  margin-inline-start: 36px !important;
}

:where(.vuetify-styles) .ms-10 {
  margin-inline-start: 40px !important;
}

:where(.vuetify-styles) .ms-11 {
  margin-inline-start: 44px !important;
}

:where(.vuetify-styles) .ms-12 {
  margin-inline-start: 48px !important;
}

:where(.vuetify-styles) .ms-13 {
  margin-inline-start: 52px !important;
}

:where(.vuetify-styles) .ms-14 {
  margin-inline-start: 56px !important;
}

:where(.vuetify-styles) .ms-15 {
  margin-inline-start: 60px !important;
}

:where(.vuetify-styles) .ms-16 {
  margin-inline-start: 64px !important;
}

:where(.vuetify-styles) .ms-auto {
  margin-inline-start: auto !important;
}

:where(.vuetify-styles) .me-0 {
  margin-inline-end: 0px !important;
}

:where(.vuetify-styles) .me-1 {
  margin-inline-end: 4px !important;
}

:where(.vuetify-styles) .me-2 {
  margin-inline-end: 8px !important;
}

:where(.vuetify-styles) .me-3 {
  margin-inline-end: 12px !important;
}

:where(.vuetify-styles) .me-4 {
  margin-inline-end: 16px !important;
}

:where(.vuetify-styles) .me-5 {
  margin-inline-end: 20px !important;
}

:where(.vuetify-styles) .me-6 {
  margin-inline-end: 24px !important;
}

:where(.vuetify-styles) .me-7 {
  margin-inline-end: 28px !important;
}

:where(.vuetify-styles) .me-8 {
  margin-inline-end: 32px !important;
}

:where(.vuetify-styles) .me-9 {
  margin-inline-end: 36px !important;
}

:where(.vuetify-styles) .me-10 {
  margin-inline-end: 40px !important;
}

:where(.vuetify-styles) .me-11 {
  margin-inline-end: 44px !important;
}

:where(.vuetify-styles) .me-12 {
  margin-inline-end: 48px !important;
}

:where(.vuetify-styles) .me-13 {
  margin-inline-end: 52px !important;
}

:where(.vuetify-styles) .me-14 {
  margin-inline-end: 56px !important;
}

:where(.vuetify-styles) .me-15 {
  margin-inline-end: 60px !important;
}

:where(.vuetify-styles) .me-16 {
  margin-inline-end: 64px !important;
}

:where(.vuetify-styles) .me-auto {
  margin-inline-end: auto !important;
}

:where(.vuetify-styles) .ma-n1 {
  margin: -4px !important;
}

:where(.vuetify-styles) .ma-n2 {
  margin: -8px !important;
}

:where(.vuetify-styles) .ma-n3 {
  margin: -12px !important;
}

:where(.vuetify-styles) .ma-n4 {
  margin: -16px !important;
}

:where(.vuetify-styles) .ma-n5 {
  margin: -20px !important;
}

:where(.vuetify-styles) .ma-n6 {
  margin: -24px !important;
}

:where(.vuetify-styles) .ma-n7 {
  margin: -28px !important;
}

:where(.vuetify-styles) .ma-n8 {
  margin: -32px !important;
}

:where(.vuetify-styles) .ma-n9 {
  margin: -36px !important;
}

:where(.vuetify-styles) .ma-n10 {
  margin: -40px !important;
}

:where(.vuetify-styles) .ma-n11 {
  margin: -44px !important;
}

:where(.vuetify-styles) .ma-n12 {
  margin: -48px !important;
}

:where(.vuetify-styles) .ma-n13 {
  margin: -52px !important;
}

:where(.vuetify-styles) .ma-n14 {
  margin: -56px !important;
}

:where(.vuetify-styles) .ma-n15 {
  margin: -60px !important;
}

:where(.vuetify-styles) .ma-n16 {
  margin: -64px !important;
}

:where(.vuetify-styles) .mx-n1 {
  margin-right: -4px !important;
  margin-left: -4px !important;
}

:where(.vuetify-styles) .mx-n2 {
  margin-right: -8px !important;
  margin-left: -8px !important;
}

:where(.vuetify-styles) .mx-n3 {
  margin-right: -12px !important;
  margin-left: -12px !important;
}

:where(.vuetify-styles) .mx-n4 {
  margin-right: -16px !important;
  margin-left: -16px !important;
}

:where(.vuetify-styles) .mx-n5 {
  margin-right: -20px !important;
  margin-left: -20px !important;
}

:where(.vuetify-styles) .mx-n6 {
  margin-right: -24px !important;
  margin-left: -24px !important;
}

:where(.vuetify-styles) .mx-n7 {
  margin-right: -28px !important;
  margin-left: -28px !important;
}

:where(.vuetify-styles) .mx-n8 {
  margin-right: -32px !important;
  margin-left: -32px !important;
}

:where(.vuetify-styles) .mx-n9 {
  margin-right: -36px !important;
  margin-left: -36px !important;
}

:where(.vuetify-styles) .mx-n10 {
  margin-right: -40px !important;
  margin-left: -40px !important;
}

:where(.vuetify-styles) .mx-n11 {
  margin-right: -44px !important;
  margin-left: -44px !important;
}

:where(.vuetify-styles) .mx-n12 {
  margin-right: -48px !important;
  margin-left: -48px !important;
}

:where(.vuetify-styles) .mx-n13 {
  margin-right: -52px !important;
  margin-left: -52px !important;
}

:where(.vuetify-styles) .mx-n14 {
  margin-right: -56px !important;
  margin-left: -56px !important;
}

:where(.vuetify-styles) .mx-n15 {
  margin-right: -60px !important;
  margin-left: -60px !important;
}

:where(.vuetify-styles) .mx-n16 {
  margin-right: -64px !important;
  margin-left: -64px !important;
}

:where(.vuetify-styles) .my-n1 {
  margin-top: -4px !important;
  margin-bottom: -4px !important;
}

:where(.vuetify-styles) .my-n2 {
  margin-top: -8px !important;
  margin-bottom: -8px !important;
}

:where(.vuetify-styles) .my-n3 {
  margin-top: -12px !important;
  margin-bottom: -12px !important;
}

:where(.vuetify-styles) .my-n4 {
  margin-top: -16px !important;
  margin-bottom: -16px !important;
}

:where(.vuetify-styles) .my-n5 {
  margin-top: -20px !important;
  margin-bottom: -20px !important;
}

:where(.vuetify-styles) .my-n6 {
  margin-top: -24px !important;
  margin-bottom: -24px !important;
}

:where(.vuetify-styles) .my-n7 {
  margin-top: -28px !important;
  margin-bottom: -28px !important;
}

:where(.vuetify-styles) .my-n8 {
  margin-top: -32px !important;
  margin-bottom: -32px !important;
}

:where(.vuetify-styles) .my-n9 {
  margin-top: -36px !important;
  margin-bottom: -36px !important;
}

:where(.vuetify-styles) .my-n10 {
  margin-top: -40px !important;
  margin-bottom: -40px !important;
}

:where(.vuetify-styles) .my-n11 {
  margin-top: -44px !important;
  margin-bottom: -44px !important;
}

:where(.vuetify-styles) .my-n12 {
  margin-top: -48px !important;
  margin-bottom: -48px !important;
}

:where(.vuetify-styles) .my-n13 {
  margin-top: -52px !important;
  margin-bottom: -52px !important;
}

:where(.vuetify-styles) .my-n14 {
  margin-top: -56px !important;
  margin-bottom: -56px !important;
}

:where(.vuetify-styles) .my-n15 {
  margin-top: -60px !important;
  margin-bottom: -60px !important;
}

:where(.vuetify-styles) .my-n16 {
  margin-top: -64px !important;
  margin-bottom: -64px !important;
}

:where(.vuetify-styles) .mt-n1 {
  margin-top: -4px !important;
}

:where(.vuetify-styles) .mt-n2 {
  margin-top: -8px !important;
}

:where(.vuetify-styles) .mt-n3 {
  margin-top: -12px !important;
}

:where(.vuetify-styles) .mt-n4 {
  margin-top: -16px !important;
}

:where(.vuetify-styles) .mt-n5 {
  margin-top: -20px !important;
}

:where(.vuetify-styles) .mt-n6 {
  margin-top: -24px !important;
}

:where(.vuetify-styles) .mt-n7 {
  margin-top: -28px !important;
}

:where(.vuetify-styles) .mt-n8 {
  margin-top: -32px !important;
}

:where(.vuetify-styles) .mt-n9 {
  margin-top: -36px !important;
}

:where(.vuetify-styles) .mt-n10 {
  margin-top: -40px !important;
}

:where(.vuetify-styles) .mt-n11 {
  margin-top: -44px !important;
}

:where(.vuetify-styles) .mt-n12 {
  margin-top: -48px !important;
}

:where(.vuetify-styles) .mt-n13 {
  margin-top: -52px !important;
}

:where(.vuetify-styles) .mt-n14 {
  margin-top: -56px !important;
}

:where(.vuetify-styles) .mt-n15 {
  margin-top: -60px !important;
}

:where(.vuetify-styles) .mt-n16 {
  margin-top: -64px !important;
}

:where(.vuetify-styles) .mr-n1 {
  margin-right: -4px !important;
}

:where(.vuetify-styles) .mr-n2 {
  margin-right: -8px !important;
}

:where(.vuetify-styles) .mr-n3 {
  margin-right: -12px !important;
}

:where(.vuetify-styles) .mr-n4 {
  margin-right: -16px !important;
}

:where(.vuetify-styles) .mr-n5 {
  margin-right: -20px !important;
}

:where(.vuetify-styles) .mr-n6 {
  margin-right: -24px !important;
}

:where(.vuetify-styles) .mr-n7 {
  margin-right: -28px !important;
}

:where(.vuetify-styles) .mr-n8 {
  margin-right: -32px !important;
}

:where(.vuetify-styles) .mr-n9 {
  margin-right: -36px !important;
}

:where(.vuetify-styles) .mr-n10 {
  margin-right: -40px !important;
}

:where(.vuetify-styles) .mr-n11 {
  margin-right: -44px !important;
}

:where(.vuetify-styles) .mr-n12 {
  margin-right: -48px !important;
}

:where(.vuetify-styles) .mr-n13 {
  margin-right: -52px !important;
}

:where(.vuetify-styles) .mr-n14 {
  margin-right: -56px !important;
}

:where(.vuetify-styles) .mr-n15 {
  margin-right: -60px !important;
}

:where(.vuetify-styles) .mr-n16 {
  margin-right: -64px !important;
}

:where(.vuetify-styles) .mb-n1 {
  margin-bottom: -4px !important;
}

:where(.vuetify-styles) .mb-n2 {
  margin-bottom: -8px !important;
}

:where(.vuetify-styles) .mb-n3 {
  margin-bottom: -12px !important;
}

:where(.vuetify-styles) .mb-n4 {
  margin-bottom: -16px !important;
}

:where(.vuetify-styles) .mb-n5 {
  margin-bottom: -20px !important;
}

:where(.vuetify-styles) .mb-n6 {
  margin-bottom: -24px !important;
}

:where(.vuetify-styles) .mb-n7 {
  margin-bottom: -28px !important;
}

:where(.vuetify-styles) .mb-n8 {
  margin-bottom: -32px !important;
}

:where(.vuetify-styles) .mb-n9 {
  margin-bottom: -36px !important;
}

:where(.vuetify-styles) .mb-n10 {
  margin-bottom: -40px !important;
}

:where(.vuetify-styles) .mb-n11 {
  margin-bottom: -44px !important;
}

:where(.vuetify-styles) .mb-n12 {
  margin-bottom: -48px !important;
}

:where(.vuetify-styles) .mb-n13 {
  margin-bottom: -52px !important;
}

:where(.vuetify-styles) .mb-n14 {
  margin-bottom: -56px !important;
}

:where(.vuetify-styles) .mb-n15 {
  margin-bottom: -60px !important;
}

:where(.vuetify-styles) .mb-n16 {
  margin-bottom: -64px !important;
}

:where(.vuetify-styles) .ml-n1 {
  margin-left: -4px !important;
}

:where(.vuetify-styles) .ml-n2 {
  margin-left: -8px !important;
}

:where(.vuetify-styles) .ml-n3 {
  margin-left: -12px !important;
}

:where(.vuetify-styles) .ml-n4 {
  margin-left: -16px !important;
}

:where(.vuetify-styles) .ml-n5 {
  margin-left: -20px !important;
}

:where(.vuetify-styles) .ml-n6 {
  margin-left: -24px !important;
}

:where(.vuetify-styles) .ml-n7 {
  margin-left: -28px !important;
}

:where(.vuetify-styles) .ml-n8 {
  margin-left: -32px !important;
}

:where(.vuetify-styles) .ml-n9 {
  margin-left: -36px !important;
}

:where(.vuetify-styles) .ml-n10 {
  margin-left: -40px !important;
}

:where(.vuetify-styles) .ml-n11 {
  margin-left: -44px !important;
}

:where(.vuetify-styles) .ml-n12 {
  margin-left: -48px !important;
}

:where(.vuetify-styles) .ml-n13 {
  margin-left: -52px !important;
}

:where(.vuetify-styles) .ml-n14 {
  margin-left: -56px !important;
}

:where(.vuetify-styles) .ml-n15 {
  margin-left: -60px !important;
}

:where(.vuetify-styles) .ml-n16 {
  margin-left: -64px !important;
}

:where(.vuetify-styles) .ms-n1 {
  margin-inline-start: -4px !important;
}

:where(.vuetify-styles) .ms-n2 {
  margin-inline-start: -8px !important;
}

:where(.vuetify-styles) .ms-n3 {
  margin-inline-start: -12px !important;
}

:where(.vuetify-styles) .ms-n4 {
  margin-inline-start: -16px !important;
}

:where(.vuetify-styles) .ms-n5 {
  margin-inline-start: -20px !important;
}

:where(.vuetify-styles) .ms-n6 {
  margin-inline-start: -24px !important;
}

:where(.vuetify-styles) .ms-n7 {
  margin-inline-start: -28px !important;
}

:where(.vuetify-styles) .ms-n8 {
  margin-inline-start: -32px !important;
}

:where(.vuetify-styles) .ms-n9 {
  margin-inline-start: -36px !important;
}

:where(.vuetify-styles) .ms-n10 {
  margin-inline-start: -40px !important;
}

:where(.vuetify-styles) .ms-n11 {
  margin-inline-start: -44px !important;
}

:where(.vuetify-styles) .ms-n12 {
  margin-inline-start: -48px !important;
}

:where(.vuetify-styles) .ms-n13 {
  margin-inline-start: -52px !important;
}

:where(.vuetify-styles) .ms-n14 {
  margin-inline-start: -56px !important;
}

:where(.vuetify-styles) .ms-n15 {
  margin-inline-start: -60px !important;
}

:where(.vuetify-styles) .ms-n16 {
  margin-inline-start: -64px !important;
}

:where(.vuetify-styles) .me-n1 {
  margin-inline-end: -4px !important;
}

:where(.vuetify-styles) .me-n2 {
  margin-inline-end: -8px !important;
}

:where(.vuetify-styles) .me-n3 {
  margin-inline-end: -12px !important;
}

:where(.vuetify-styles) .me-n4 {
  margin-inline-end: -16px !important;
}

:where(.vuetify-styles) .me-n5 {
  margin-inline-end: -20px !important;
}

:where(.vuetify-styles) .me-n6 {
  margin-inline-end: -24px !important;
}

:where(.vuetify-styles) .me-n7 {
  margin-inline-end: -28px !important;
}

:where(.vuetify-styles) .me-n8 {
  margin-inline-end: -32px !important;
}

:where(.vuetify-styles) .me-n9 {
  margin-inline-end: -36px !important;
}

:where(.vuetify-styles) .me-n10 {
  margin-inline-end: -40px !important;
}

:where(.vuetify-styles) .me-n11 {
  margin-inline-end: -44px !important;
}

:where(.vuetify-styles) .me-n12 {
  margin-inline-end: -48px !important;
}

:where(.vuetify-styles) .me-n13 {
  margin-inline-end: -52px !important;
}

:where(.vuetify-styles) .me-n14 {
  margin-inline-end: -56px !important;
}

:where(.vuetify-styles) .me-n15 {
  margin-inline-end: -60px !important;
}

:where(.vuetify-styles) .me-n16 {
  margin-inline-end: -64px !important;
}

:where(.vuetify-styles) .pa-0 {
  padding: 0px !important;
}

:where(.vuetify-styles) .pa-1 {
  padding: 4px !important;
}

:where(.vuetify-styles) .pa-2 {
  padding: 8px !important;
}

:where(.vuetify-styles) .pa-3 {
  padding: 12px !important;
}

:where(.vuetify-styles) .pa-4 {
  padding: 16px !important;
}

:where(.vuetify-styles) .pa-5 {
  padding: 20px !important;
}

:where(.vuetify-styles) .pa-6 {
  padding: 24px !important;
}

:where(.vuetify-styles) .pa-7 {
  padding: 28px !important;
}

:where(.vuetify-styles) .pa-8 {
  padding: 32px !important;
}

:where(.vuetify-styles) .pa-9 {
  padding: 36px !important;
}

:where(.vuetify-styles) .pa-10 {
  padding: 40px !important;
}

:where(.vuetify-styles) .pa-11 {
  padding: 44px !important;
}

:where(.vuetify-styles) .pa-12 {
  padding: 48px !important;
}

:where(.vuetify-styles) .pa-13 {
  padding: 52px !important;
}

:where(.vuetify-styles) .pa-14 {
  padding: 56px !important;
}

:where(.vuetify-styles) .pa-15 {
  padding: 60px !important;
}

:where(.vuetify-styles) .pa-16 {
  padding: 64px !important;
}

:where(.vuetify-styles) .px-0 {
  padding-right: 0px !important;
  padding-left: 0px !important;
}

:where(.vuetify-styles) .px-1 {
  padding-right: 4px !important;
  padding-left: 4px !important;
}

:where(.vuetify-styles) .px-2 {
  padding-right: 8px !important;
  padding-left: 8px !important;
}

:where(.vuetify-styles) .px-3 {
  padding-right: 12px !important;
  padding-left: 12px !important;
}

:where(.vuetify-styles) .px-4 {
  padding-right: 16px !important;
  padding-left: 16px !important;
}

:where(.vuetify-styles) .px-5 {
  padding-right: 20px !important;
  padding-left: 20px !important;
}

:where(.vuetify-styles) .px-6 {
  padding-right: 24px !important;
  padding-left: 24px !important;
}

:where(.vuetify-styles) .px-7 {
  padding-right: 28px !important;
  padding-left: 28px !important;
}

:where(.vuetify-styles) .px-8 {
  padding-right: 32px !important;
  padding-left: 32px !important;
}

:where(.vuetify-styles) .px-9 {
  padding-right: 36px !important;
  padding-left: 36px !important;
}

:where(.vuetify-styles) .px-10 {
  padding-right: 40px !important;
  padding-left: 40px !important;
}

:where(.vuetify-styles) .px-11 {
  padding-right: 44px !important;
  padding-left: 44px !important;
}

:where(.vuetify-styles) .px-12 {
  padding-right: 48px !important;
  padding-left: 48px !important;
}

:where(.vuetify-styles) .px-13 {
  padding-right: 52px !important;
  padding-left: 52px !important;
}

:where(.vuetify-styles) .px-14 {
  padding-right: 56px !important;
  padding-left: 56px !important;
}

:where(.vuetify-styles) .px-15 {
  padding-right: 60px !important;
  padding-left: 60px !important;
}

:where(.vuetify-styles) .px-16 {
  padding-right: 64px !important;
  padding-left: 64px !important;
}

:where(.vuetify-styles) .py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

:where(.vuetify-styles) .py-1 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

:where(.vuetify-styles) .py-2 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

:where(.vuetify-styles) .py-3 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

:where(.vuetify-styles) .py-4 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

:where(.vuetify-styles) .py-5 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

:where(.vuetify-styles) .py-6 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}

:where(.vuetify-styles) .py-7 {
  padding-top: 28px !important;
  padding-bottom: 28px !important;
}

:where(.vuetify-styles) .py-8 {
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}

:where(.vuetify-styles) .py-9 {
  padding-top: 36px !important;
  padding-bottom: 36px !important;
}

:where(.vuetify-styles) .py-10 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}

:where(.vuetify-styles) .py-11 {
  padding-top: 44px !important;
  padding-bottom: 44px !important;
}

:where(.vuetify-styles) .py-12 {
  padding-top: 48px !important;
  padding-bottom: 48px !important;
}

:where(.vuetify-styles) .py-13 {
  padding-top: 52px !important;
  padding-bottom: 52px !important;
}

:where(.vuetify-styles) .py-14 {
  padding-top: 56px !important;
  padding-bottom: 56px !important;
}

:where(.vuetify-styles) .py-15 {
  padding-top: 60px !important;
  padding-bottom: 60px !important;
}

:where(.vuetify-styles) .py-16 {
  padding-top: 64px !important;
  padding-bottom: 64px !important;
}

:where(.vuetify-styles) .pt-0 {
  padding-top: 0px !important;
}

:where(.vuetify-styles) .pt-1 {
  padding-top: 4px !important;
}

:where(.vuetify-styles) .pt-2 {
  padding-top: 8px !important;
}

:where(.vuetify-styles) .pt-3 {
  padding-top: 12px !important;
}

:where(.vuetify-styles) .pt-4 {
  padding-top: 16px !important;
}

:where(.vuetify-styles) .pt-5 {
  padding-top: 20px !important;
}

:where(.vuetify-styles) .pt-6 {
  padding-top: 24px !important;
}

:where(.vuetify-styles) .pt-7 {
  padding-top: 28px !important;
}

:where(.vuetify-styles) .pt-8 {
  padding-top: 32px !important;
}

:where(.vuetify-styles) .pt-9 {
  padding-top: 36px !important;
}

:where(.vuetify-styles) .pt-10 {
  padding-top: 40px !important;
}

:where(.vuetify-styles) .pt-11 {
  padding-top: 44px !important;
}

:where(.vuetify-styles) .pt-12 {
  padding-top: 48px !important;
}

:where(.vuetify-styles) .pt-13 {
  padding-top: 52px !important;
}

:where(.vuetify-styles) .pt-14 {
  padding-top: 56px !important;
}

:where(.vuetify-styles) .pt-15 {
  padding-top: 60px !important;
}

:where(.vuetify-styles) .pt-16 {
  padding-top: 64px !important;
}

:where(.vuetify-styles) .pr-0 {
  padding-right: 0px !important;
}

:where(.vuetify-styles) .pr-1 {
  padding-right: 4px !important;
}

:where(.vuetify-styles) .pr-2 {
  padding-right: 8px !important;
}

:where(.vuetify-styles) .pr-3 {
  padding-right: 12px !important;
}

:where(.vuetify-styles) .pr-4 {
  padding-right: 16px !important;
}

:where(.vuetify-styles) .pr-5 {
  padding-right: 20px !important;
}

:where(.vuetify-styles) .pr-6 {
  padding-right: 24px !important;
}

:where(.vuetify-styles) .pr-7 {
  padding-right: 28px !important;
}

:where(.vuetify-styles) .pr-8 {
  padding-right: 32px !important;
}

:where(.vuetify-styles) .pr-9 {
  padding-right: 36px !important;
}

:where(.vuetify-styles) .pr-10 {
  padding-right: 40px !important;
}

:where(.vuetify-styles) .pr-11 {
  padding-right: 44px !important;
}

:where(.vuetify-styles) .pr-12 {
  padding-right: 48px !important;
}

:where(.vuetify-styles) .pr-13 {
  padding-right: 52px !important;
}

:where(.vuetify-styles) .pr-14 {
  padding-right: 56px !important;
}

:where(.vuetify-styles) .pr-15 {
  padding-right: 60px !important;
}

:where(.vuetify-styles) .pr-16 {
  padding-right: 64px !important;
}

:where(.vuetify-styles) .pb-0 {
  padding-bottom: 0px !important;
}

:where(.vuetify-styles) .pb-1 {
  padding-bottom: 4px !important;
}

:where(.vuetify-styles) .pb-2 {
  padding-bottom: 8px !important;
}

:where(.vuetify-styles) .pb-3 {
  padding-bottom: 12px !important;
}

:where(.vuetify-styles) .pb-4 {
  padding-bottom: 16px !important;
}

:where(.vuetify-styles) .pb-5 {
  padding-bottom: 20px !important;
}

:where(.vuetify-styles) .pb-6 {
  padding-bottom: 24px !important;
}

:where(.vuetify-styles) .pb-7 {
  padding-bottom: 28px !important;
}

:where(.vuetify-styles) .pb-8 {
  padding-bottom: 32px !important;
}

:where(.vuetify-styles) .pb-9 {
  padding-bottom: 36px !important;
}

:where(.vuetify-styles) .pb-10 {
  padding-bottom: 40px !important;
}

:where(.vuetify-styles) .pb-11 {
  padding-bottom: 44px !important;
}

:where(.vuetify-styles) .pb-12 {
  padding-bottom: 48px !important;
}

:where(.vuetify-styles) .pb-13 {
  padding-bottom: 52px !important;
}

:where(.vuetify-styles) .pb-14 {
  padding-bottom: 56px !important;
}

:where(.vuetify-styles) .pb-15 {
  padding-bottom: 60px !important;
}

:where(.vuetify-styles) .pb-16 {
  padding-bottom: 64px !important;
}

:where(.vuetify-styles) .pl-0 {
  padding-left: 0px !important;
}

:where(.vuetify-styles) .pl-1 {
  padding-left: 4px !important;
}

:where(.vuetify-styles) .pl-2 {
  padding-left: 8px !important;
}

:where(.vuetify-styles) .pl-3 {
  padding-left: 12px !important;
}

:where(.vuetify-styles) .pl-4 {
  padding-left: 16px !important;
}

:where(.vuetify-styles) .pl-5 {
  padding-left: 20px !important;
}

:where(.vuetify-styles) .pl-6 {
  padding-left: 24px !important;
}

:where(.vuetify-styles) .pl-7 {
  padding-left: 28px !important;
}

:where(.vuetify-styles) .pl-8 {
  padding-left: 32px !important;
}

:where(.vuetify-styles) .pl-9 {
  padding-left: 36px !important;
}

:where(.vuetify-styles) .pl-10 {
  padding-left: 40px !important;
}

:where(.vuetify-styles) .pl-11 {
  padding-left: 44px !important;
}

:where(.vuetify-styles) .pl-12 {
  padding-left: 48px !important;
}

:where(.vuetify-styles) .pl-13 {
  padding-left: 52px !important;
}

:where(.vuetify-styles) .pl-14 {
  padding-left: 56px !important;
}

:where(.vuetify-styles) .pl-15 {
  padding-left: 60px !important;
}

:where(.vuetify-styles) .pl-16 {
  padding-left: 64px !important;
}

:where(.vuetify-styles) .ps-0 {
  padding-inline-start: 0px !important;
}

:where(.vuetify-styles) .ps-1 {
  padding-inline-start: 4px !important;
}

:where(.vuetify-styles) .ps-2 {
  padding-inline-start: 8px !important;
}

:where(.vuetify-styles) .ps-3 {
  padding-inline-start: 12px !important;
}

:where(.vuetify-styles) .ps-4 {
  padding-inline-start: 16px !important;
}

:where(.vuetify-styles) .ps-5 {
  padding-inline-start: 20px !important;
}

:where(.vuetify-styles) .ps-6 {
  padding-inline-start: 24px !important;
}

:where(.vuetify-styles) .ps-7 {
  padding-inline-start: 28px !important;
}

:where(.vuetify-styles) .ps-8 {
  padding-inline-start: 32px !important;
}

:where(.vuetify-styles) .ps-9 {
  padding-inline-start: 36px !important;
}

:where(.vuetify-styles) .ps-10 {
  padding-inline-start: 40px !important;
}

:where(.vuetify-styles) .ps-11 {
  padding-inline-start: 44px !important;
}

:where(.vuetify-styles) .ps-12 {
  padding-inline-start: 48px !important;
}

:where(.vuetify-styles) .ps-13 {
  padding-inline-start: 52px !important;
}

:where(.vuetify-styles) .ps-14 {
  padding-inline-start: 56px !important;
}

:where(.vuetify-styles) .ps-15 {
  padding-inline-start: 60px !important;
}

:where(.vuetify-styles) .ps-16 {
  padding-inline-start: 64px !important;
}

:where(.vuetify-styles) .pe-0 {
  padding-inline-end: 0px !important;
}

:where(.vuetify-styles) .pe-1 {
  padding-inline-end: 4px !important;
}

:where(.vuetify-styles) .pe-2 {
  padding-inline-end: 8px !important;
}

:where(.vuetify-styles) .pe-3 {
  padding-inline-end: 12px !important;
}

:where(.vuetify-styles) .pe-4 {
  padding-inline-end: 16px !important;
}

:where(.vuetify-styles) .pe-5 {
  padding-inline-end: 20px !important;
}

:where(.vuetify-styles) .pe-6 {
  padding-inline-end: 24px !important;
}

:where(.vuetify-styles) .pe-7 {
  padding-inline-end: 28px !important;
}

:where(.vuetify-styles) .pe-8 {
  padding-inline-end: 32px !important;
}

:where(.vuetify-styles) .pe-9 {
  padding-inline-end: 36px !important;
}

:where(.vuetify-styles) .pe-10 {
  padding-inline-end: 40px !important;
}

:where(.vuetify-styles) .pe-11 {
  padding-inline-end: 44px !important;
}

:where(.vuetify-styles) .pe-12 {
  padding-inline-end: 48px !important;
}

:where(.vuetify-styles) .pe-13 {
  padding-inline-end: 52px !important;
}

:where(.vuetify-styles) .pe-14 {
  padding-inline-end: 56px !important;
}

:where(.vuetify-styles) .pe-15 {
  padding-inline-end: 60px !important;
}

:where(.vuetify-styles) .pe-16 {
  padding-inline-end: 64px !important;
}

:where(.vuetify-styles) .rounded-0 {
  border-radius: 0 !important;
}

:where(.vuetify-styles) .rounded-sm {
  border-radius: 2px !important;
}

:where(.vuetify-styles) .rounded {
  border-radius: 4px !important;
}

:where(.vuetify-styles) .rounded-lg {
  border-radius: 8px !important;
}

:where(.vuetify-styles) .rounded-xl {
  border-radius: 24px !important;
}

:where(.vuetify-styles) .rounded-pill {
  border-radius: 9999px !important;
}

:where(.vuetify-styles) .rounded-circle {
  border-radius: 50% !important;
}

:where(.vuetify-styles) .rounded-shaped {
  border-radius: 24px 0 !important;
}

:where(.vuetify-styles) .rounded-t-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

:where(.vuetify-styles) .rounded-t-sm {
  border-top-left-radius: 2px !important;
  border-top-right-radius: 2px !important;
}

:where(.vuetify-styles) .rounded-t {
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
}

:where(.vuetify-styles) .rounded-t-lg {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}

:where(.vuetify-styles) .rounded-t-xl {
  border-top-left-radius: 24px !important;
  border-top-right-radius: 24px !important;
}

:where(.vuetify-styles) .rounded-t-pill {
  border-top-left-radius: 9999px !important;
  border-top-right-radius: 9999px !important;
}

:where(.vuetify-styles) .rounded-t-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

:where(.vuetify-styles) .rounded-t-shaped {
  border-top-left-radius: 24px !important;
  border-top-right-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-e-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-e-0 {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-e-sm {
  border-top-right-radius: 2px !important;
  border-bottom-right-radius: 2px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-e-sm {
  border-top-left-radius: 2px !important;
  border-bottom-left-radius: 2px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-e {
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-e {
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-e-lg {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-e-lg {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-e-xl {
  border-top-right-radius: 24px !important;
  border-bottom-right-radius: 24px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-e-xl {
  border-top-left-radius: 24px !important;
  border-bottom-left-radius: 24px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-e-pill {
  border-top-right-radius: 9999px !important;
  border-bottom-right-radius: 9999px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-e-pill {
  border-top-left-radius: 9999px !important;
  border-bottom-left-radius: 9999px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-e-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-e-circle {
  border-top-left-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-e-shaped {
  border-top-right-radius: 24px !important;
  border-bottom-right-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-e-shaped {
  border-top-left-radius: 24px !important;
  border-bottom-left-radius: 0 !important;
}

:where(.vuetify-styles) .rounded-b-0 {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

:where(.vuetify-styles) .rounded-b-sm {
  border-bottom-left-radius: 2px !important;
  border-bottom-right-radius: 2px !important;
}

:where(.vuetify-styles) .rounded-b {
  border-bottom-left-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}

:where(.vuetify-styles) .rounded-b-lg {
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

:where(.vuetify-styles) .rounded-b-xl {
  border-bottom-left-radius: 24px !important;
  border-bottom-right-radius: 24px !important;
}

:where(.vuetify-styles) .rounded-b-pill {
  border-bottom-left-radius: 9999px !important;
  border-bottom-right-radius: 9999px !important;
}

:where(.vuetify-styles) .rounded-b-circle {
  border-bottom-left-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

:where(.vuetify-styles) .rounded-b-shaped {
  border-bottom-left-radius: 24px !important;
  border-bottom-right-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-s-0 {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-s-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-s-sm {
  border-top-left-radius: 2px !important;
  border-bottom-left-radius: 2px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-s-sm {
  border-top-right-radius: 2px !important;
  border-bottom-right-radius: 2px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-s {
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-s {
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-s-lg {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-s-lg {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-s-xl {
  border-top-left-radius: 24px !important;
  border-bottom-left-radius: 24px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-s-xl {
  border-top-right-radius: 24px !important;
  border-bottom-right-radius: 24px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-s-pill {
  border-top-left-radius: 9999px !important;
  border-bottom-left-radius: 9999px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-s-pill {
  border-top-right-radius: 9999px !important;
  border-bottom-right-radius: 9999px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-s-circle {
  border-top-left-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-s-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-s-shaped {
  border-top-left-radius: 24px !important;
  border-bottom-left-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-s-shaped {
  border-top-right-radius: 24px !important;
  border-bottom-right-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-ts-0 {
  border-top-left-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-ts-0 {
  border-top-right-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-ts-sm {
  border-top-left-radius: 2px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-ts-sm {
  border-top-right-radius: 2px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-ts {
  border-top-left-radius: 4px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-ts {
  border-top-right-radius: 4px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-ts-lg {
  border-top-left-radius: 8px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-ts-lg {
  border-top-right-radius: 8px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-ts-xl {
  border-top-left-radius: 24px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-ts-xl {
  border-top-right-radius: 24px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-ts-pill {
  border-top-left-radius: 9999px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-ts-pill {
  border-top-right-radius: 9999px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-ts-circle {
  border-top-left-radius: 50% !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-ts-circle {
  border-top-right-radius: 50% !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-ts-shaped {
  border-top-left-radius: 24px 0 !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-ts-shaped {
  border-top-right-radius: 24px 0 !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-te-0 {
  border-top-right-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-te-0 {
  border-top-left-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-te-sm {
  border-top-right-radius: 2px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-te-sm {
  border-top-left-radius: 2px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-te {
  border-top-right-radius: 4px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-te {
  border-top-left-radius: 4px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-te-lg {
  border-top-right-radius: 8px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-te-lg {
  border-top-left-radius: 8px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-te-xl {
  border-top-right-radius: 24px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-te-xl {
  border-top-left-radius: 24px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-te-pill {
  border-top-right-radius: 9999px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-te-pill {
  border-top-left-radius: 9999px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-te-circle {
  border-top-right-radius: 50% !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-te-circle {
  border-top-left-radius: 50% !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-te-shaped {
  border-top-right-radius: 24px 0 !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-te-shaped {
  border-top-left-radius: 24px 0 !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-be-0 {
  border-bottom-right-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-be-0 {
  border-bottom-left-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-be-sm {
  border-bottom-right-radius: 2px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-be-sm {
  border-bottom-left-radius: 2px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-be {
  border-bottom-right-radius: 4px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-be {
  border-bottom-left-radius: 4px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-be-lg {
  border-bottom-right-radius: 8px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-be-lg {
  border-bottom-left-radius: 8px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-be-xl {
  border-bottom-right-radius: 24px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-be-xl {
  border-bottom-left-radius: 24px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-be-pill {
  border-bottom-right-radius: 9999px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-be-pill {
  border-bottom-left-radius: 9999px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-be-circle {
  border-bottom-right-radius: 50% !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-be-circle {
  border-bottom-left-radius: 50% !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-be-shaped {
  border-bottom-right-radius: 24px 0 !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-be-shaped {
  border-bottom-left-radius: 24px 0 !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-bs-0 {
  border-bottom-left-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-bs-0 {
  border-bottom-right-radius: 0 !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-bs-sm {
  border-bottom-left-radius: 2px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-bs-sm {
  border-bottom-right-radius: 2px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-bs {
  border-bottom-left-radius: 4px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-bs {
  border-bottom-right-radius: 4px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-bs-lg {
  border-bottom-left-radius: 8px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-bs-lg {
  border-bottom-right-radius: 8px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-bs-xl {
  border-bottom-left-radius: 24px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-bs-xl {
  border-bottom-right-radius: 24px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-bs-pill {
  border-bottom-left-radius: 9999px !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-bs-pill {
  border-bottom-right-radius: 9999px !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-bs-circle {
  border-bottom-left-radius: 50% !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-bs-circle {
  border-bottom-right-radius: 50% !important;
}

:where(.vuetify-styles) .v-locale--is-ltr .rounded-bs-shaped {
  border-bottom-left-radius: 24px 0 !important;
}

:where(.vuetify-styles) .v-locale--is-rtl .rounded-bs-shaped {
  border-bottom-right-radius: 24px 0 !important;
}

:where(.vuetify-styles) .border-0 {
  border-width: 0 !important;
  border-style: solid !important;
  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border {
  border-width: thin !important;
  border-style: solid !important;
  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-thin {
  border-width: thin !important;
  border-style: solid !important;
  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-sm {
  border-width: 1px !important;
  border-style: solid !important;
  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-md {
  border-width: 2px !important;
  border-style: solid !important;
  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-lg {
  border-width: 4px !important;
  border-style: solid !important;
  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-xl {
  border-width: 8px !important;
  border-style: solid !important;
  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-current {
  border-color: currentColor !important;
}

:where(.vuetify-styles) .border-opacity-0 {
  --v-border-opacity: 0 !important;
}

:where(.vuetify-styles) .border-opacity {
  --v-border-opacity: 0.12 !important;
}

:where(.vuetify-styles) .border-opacity-25 {
  --v-border-opacity: 0.25 !important;
}

:where(.vuetify-styles) .border-opacity-50 {
  --v-border-opacity: 0.5 !important;
}

:where(.vuetify-styles) .border-opacity-75 {
  --v-border-opacity: 0.75 !important;
}

:where(.vuetify-styles) .border-opacity-100 {
  --v-border-opacity: 1 !important;
}

:where(.vuetify-styles) .border-t-0 {
  border-block-start-width: 0 !important;
  border-block-start-style: solid !important;
  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-t {
  border-block-start-width: thin !important;
  border-block-start-style: solid !important;
  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-t-thin {
  border-block-start-width: thin !important;
  border-block-start-style: solid !important;
  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-t-sm {
  border-block-start-width: 1px !important;
  border-block-start-style: solid !important;
  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-t-md {
  border-block-start-width: 2px !important;
  border-block-start-style: solid !important;
  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-t-lg {
  border-block-start-width: 4px !important;
  border-block-start-style: solid !important;
  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-t-xl {
  border-block-start-width: 8px !important;
  border-block-start-style: solid !important;
  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-e-0 {
  border-inline-end-width: 0 !important;
  border-inline-end-style: solid !important;
  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-e {
  border-inline-end-width: thin !important;
  border-inline-end-style: solid !important;
  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-e-thin {
  border-inline-end-width: thin !important;
  border-inline-end-style: solid !important;
  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-e-sm {
  border-inline-end-width: 1px !important;
  border-inline-end-style: solid !important;
  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-e-md {
  border-inline-end-width: 2px !important;
  border-inline-end-style: solid !important;
  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-e-lg {
  border-inline-end-width: 4px !important;
  border-inline-end-style: solid !important;
  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-e-xl {
  border-inline-end-width: 8px !important;
  border-inline-end-style: solid !important;
  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-b-0 {
  border-block-end-width: 0 !important;
  border-block-end-style: solid !important;
  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-b {
  border-block-end-width: thin !important;
  border-block-end-style: solid !important;
  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-b-thin {
  border-block-end-width: thin !important;
  border-block-end-style: solid !important;
  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-b-sm {
  border-block-end-width: 1px !important;
  border-block-end-style: solid !important;
  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-b-md {
  border-block-end-width: 2px !important;
  border-block-end-style: solid !important;
  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-b-lg {
  border-block-end-width: 4px !important;
  border-block-end-style: solid !important;
  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-b-xl {
  border-block-end-width: 8px !important;
  border-block-end-style: solid !important;
  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-s-0 {
  border-inline-start-width: 0 !important;
  border-inline-start-style: solid !important;
  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-s {
  border-inline-start-width: thin !important;
  border-inline-start-style: solid !important;
  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-s-thin {
  border-inline-start-width: thin !important;
  border-inline-start-style: solid !important;
  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-s-sm {
  border-inline-start-width: 1px !important;
  border-inline-start-style: solid !important;
  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-s-md {
  border-inline-start-width: 2px !important;
  border-inline-start-style: solid !important;
  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-s-lg {
  border-inline-start-width: 4px !important;
  border-inline-start-style: solid !important;
  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-s-xl {
  border-inline-start-width: 8px !important;
  border-inline-start-style: solid !important;
  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

:where(.vuetify-styles) .border-solid {
  border-style: solid !important;
}

:where(.vuetify-styles) .border-dashed {
  border-style: dashed !important;
}

:where(.vuetify-styles) .border-dotted {
  border-style: dotted !important;
}

:where(.vuetify-styles) .border-double {
  border-style: double !important;
}

:where(.vuetify-styles) .border-none {
  border-style: none !important;
}

:where(.vuetify-styles) .text-left {
  text-align: left !important;
}

:where(.vuetify-styles) .text-right {
  text-align: right !important;
}

:where(.vuetify-styles) .text-center {
  text-align: center !important;
}

:where(.vuetify-styles) .text-justify {
  text-align: justify !important;
}

:where(.vuetify-styles) .text-start {
  text-align: start !important;
}

:where(.vuetify-styles) .text-end {
  text-align: end !important;
}

:where(.vuetify-styles) .text-decoration-line-through {
  text-decoration: line-through !important;
}

:where(.vuetify-styles) .text-decoration-none {
  text-decoration: none !important;
}

:where(.vuetify-styles) .text-decoration-overline {
  text-decoration: overline !important;
}

:where(.vuetify-styles) .text-decoration-underline {
  text-decoration: underline !important;
}

:where(.vuetify-styles) .text-wrap {
  white-space: normal !important;
}

:where(.vuetify-styles) .text-no-wrap {
  white-space: nowrap !important;
}

:where(.vuetify-styles) .text-pre {
  white-space: pre !important;
}

:where(.vuetify-styles) .text-pre-line {
  white-space: pre-line !important;
}

:where(.vuetify-styles) .text-pre-wrap {
  white-space: pre-wrap !important;
}

:where(.vuetify-styles) .text-break {
  overflow-wrap: break-word !important;
  word-break: break-word !important;
}

:where(.vuetify-styles) .opacity-hover {
  opacity: var(--v-hover-opacity) !important;
}

:where(.vuetify-styles) .opacity-focus {
  opacity: var(--v-focus-opacity) !important;
}

:where(.vuetify-styles) .opacity-selected {
  opacity: var(--v-selected-opacity) !important;
}

:where(.vuetify-styles) .opacity-activated {
  opacity: var(--v-activated-opacity) !important;
}

:where(.vuetify-styles) .opacity-pressed {
  opacity: var(--v-pressed-opacity) !important;
}

:where(.vuetify-styles) .opacity-dragged {
  opacity: var(--v-dragged-opacity) !important;
}

:where(.vuetify-styles) .opacity-0 {
  opacity: 0 !important;
}

:where(.vuetify-styles) .opacity-10 {
  opacity: 0.1 !important;
}

:where(.vuetify-styles) .opacity-20 {
  opacity: 0.2 !important;
}

:where(.vuetify-styles) .opacity-30 {
  opacity: 0.3 !important;
}

:where(.vuetify-styles) .opacity-40 {
  opacity: 0.4 !important;
}

:where(.vuetify-styles) .opacity-50 {
  opacity: 0.5 !important;
}

:where(.vuetify-styles) .opacity-60 {
  opacity: 0.6 !important;
}

:where(.vuetify-styles) .opacity-70 {
  opacity: 0.7 !important;
}

:where(.vuetify-styles) .opacity-80 {
  opacity: 0.8 !important;
}

:where(.vuetify-styles) .opacity-90 {
  opacity: 0.9 !important;
}

:where(.vuetify-styles) .opacity-100 {
  opacity: 1 !important;
}

:where(.vuetify-styles) .text-high-emphasis {
  color: rgba(var(--v-theme-on-background), var(--v-high-emphasis-opacity)) !important;
}

:where(.vuetify-styles) .text-medium-emphasis {
  color: rgba(var(--v-theme-on-background), var(--v-medium-emphasis-opacity)) !important;
}

:where(.vuetify-styles) .text-disabled {
  color: rgba(var(--v-theme-on-background), var(--v-disabled-opacity)) !important;
}

:where(.vuetify-styles) .text-truncate {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

:where(.vuetify-styles) .text-h1 {
  font-size: 6rem !important;
  font-weight: 300;
  line-height: 1;
  letter-spacing: -0.015625em !important;
  font-family: "Roboto", sans-serif;
  text-transform: none !important;
}

:where(.vuetify-styles) .text-h2 {
  font-size: 3.75rem !important;
  font-weight: 300;
  line-height: 1;
  letter-spacing: -0.0083333333em !important;
  font-family: "Roboto", sans-serif;
  text-transform: none !important;
}

:where(.vuetify-styles) .text-h3 {
  font-size: 3rem !important;
  font-weight: 400;
  line-height: 1.05;
  letter-spacing: normal !important;
  font-family: "Roboto", sans-serif;
  text-transform: none !important;
}

:where(.vuetify-styles) .text-h4 {
  font-size: 2.125rem !important;
  font-weight: 400;
  line-height: 1.175;
  letter-spacing: 0.0073529412em !important;
  font-family: "Roboto", sans-serif;
  text-transform: none !important;
}

:where(.vuetify-styles) .text-h5 {
  font-size: 1.5rem !important;
  font-weight: 400;
  line-height: 1.333;
  letter-spacing: normal !important;
  font-family: "Roboto", sans-serif;
  text-transform: none !important;
}

:where(.vuetify-styles) .text-h6 {
  font-size: 1.25rem !important;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: 0.0125em !important;
  font-family: "Roboto", sans-serif;
  text-transform: none !important;
}

:where(.vuetify-styles) .text-subtitle-1 {
  font-size: 1rem !important;
  font-weight: normal;
  line-height: 1.75;
  letter-spacing: 0.009375em !important;
  font-family: "Roboto", sans-serif;
  text-transform: none !important;
}

:where(.vuetify-styles) .text-subtitle-2 {
  font-size: 0.875rem !important;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: 0.0071428571em !important;
  font-family: "Roboto", sans-serif;
  text-transform: none !important;
}

:where(.vuetify-styles) .text-body-1 {
  font-size: 1rem !important;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.03125em !important;
  font-family: "Roboto", sans-serif;
  text-transform: none !important;
}

:where(.vuetify-styles) .text-body-2 {
  font-size: 0.875rem !important;
  font-weight: 400;
  line-height: 1.425;
  letter-spacing: 0.0178571429em !important;
  font-family: "Roboto", sans-serif;
  text-transform: none !important;
}

:where(.vuetify-styles) .text-button {
  font-size: 0.875rem !important;
  font-weight: 500;
  line-height: 2.6;
  letter-spacing: 0.0892857143em !important;
  font-family: "Roboto", sans-serif;
  text-transform: uppercase !important;
}

:where(.vuetify-styles) .text-caption {
  font-size: 0.75rem !important;
  font-weight: 400;
  line-height: 1.667;
  letter-spacing: 0.0333333333em !important;
  font-family: "Roboto", sans-serif;
  text-transform: none !important;
}

:where(.vuetify-styles) .text-overline {
  font-size: 0.75rem !important;
  font-weight: 500;
  line-height: 2.667;
  letter-spacing: 0.1666666667em !important;
  font-family: "Roboto", sans-serif;
  text-transform: uppercase !important;
}

:where(.vuetify-styles) .text-none {
  text-transform: none !important;
}

:where(.vuetify-styles) .text-capitalize {
  text-transform: capitalize !important;
}

:where(.vuetify-styles) .text-lowercase {
  text-transform: lowercase !important;
}

:where(.vuetify-styles) .text-uppercase {
  text-transform: uppercase !important;
}

:where(.vuetify-styles) .font-weight-thin {
  font-weight: 100 !important;
}

:where(.vuetify-styles) .font-weight-light {
  font-weight: 300 !important;
}

:where(.vuetify-styles) .font-weight-regular {
  font-weight: 400 !important;
}

:where(.vuetify-styles) .font-weight-medium {
  font-weight: 500 !important;
}

:where(.vuetify-styles) .font-weight-semibold {
  font-weight: 600 !important;
}

:where(.vuetify-styles) .font-weight-bold {
  font-weight: 700 !important;
}

:where(.vuetify-styles) .font-weight-black {
  font-weight: 900 !important;
}

:where(.vuetify-styles) .font-italic {
  font-style: italic !important;
}

:where(.vuetify-styles) .text-mono {
  font-family: monospace !important;
}

:where(.vuetify-styles) .position-static {
  position: static !important;
}

:where(.vuetify-styles) .position-relative {
  position: relative !important;
}

:where(.vuetify-styles) .position-fixed {
  position: fixed !important;
}

:where(.vuetify-styles) .position-absolute {
  position: absolute !important;
}

:where(.vuetify-styles) .position-sticky {
  position: sticky !important;
}

:where(.vuetify-styles) .top-0 {
  top: 0 !important;
}

:where(.vuetify-styles) .right-0 {
  right: 0 !important;
}

:where(.vuetify-styles) .bottom-0 {
  bottom: 0 !important;
}

:where(.vuetify-styles) .left-0 {
  left: 0 !important;
}

:where(.vuetify-styles) .cursor-auto {
  cursor: auto !important;
}

:where(.vuetify-styles) .cursor-default {
  cursor: default !important;
}

:where(.vuetify-styles) .cursor-pointer {
  cursor: pointer !important;
}

:where(.vuetify-styles) .cursor-wait {
  cursor: wait !important;
}

:where(.vuetify-styles) .cursor-text {
  cursor: text !important;
}

:where(.vuetify-styles) .cursor-move {
  cursor: move !important;
}

:where(.vuetify-styles) .cursor-help {
  cursor: help !important;
}

:where(.vuetify-styles) .cursor-not-allowed {
  cursor: not-allowed !important;
}

:where(.vuetify-styles) .cursor-progress {
  cursor: progress !important;
}

:where(.vuetify-styles) .cursor-grab {
  cursor: grab !important;
}

:where(.vuetify-styles) .cursor-grabbing {
  cursor: grabbing !important;
}

:where(.vuetify-styles) .cursor-none {
  cursor: none !important;
}

:where(.vuetify-styles) .fill-height {
  height: 100% !important;
}

:where(.vuetify-styles) .h-auto {
  height: auto !important;
}

:where(.vuetify-styles) .h-screen {
  height: 100vh !important;
}

:where(.vuetify-styles) .h-0 {
  height: 0 !important;
}

:where(.vuetify-styles) .h-25 {
  height: 25% !important;
}

:where(.vuetify-styles) .h-50 {
  height: 50% !important;
}

:where(.vuetify-styles) .h-75 {
  height: 75% !important;
}

:where(.vuetify-styles) .h-100 {
  height: 100% !important;
}

:where(.vuetify-styles) .h-screen {
  height: 100dvh !important;
}

:where(.vuetify-styles) .w-auto {
  width: auto !important;
}

:where(.vuetify-styles) .w-0 {
  width: 0 !important;
}

:where(.vuetify-styles) .w-25 {
  width: 25% !important;
}

:where(.vuetify-styles) .w-33 {
  width: 33% !important;
}

:where(.vuetify-styles) .w-50 {
  width: 50% !important;
}

:where(.vuetify-styles) .w-66 {
  width: 66% !important;
}

:where(.vuetify-styles) .w-75 {
  width: 75% !important;
}

:where(.vuetify-styles) .w-100 {
  width: 100% !important;
}

@media (min-width: 600px) {
  :where(.vuetify-styles) .d-sm-none {
    display: none !important;
  }
  :where(.vuetify-styles) .d-sm-inline {
    display: inline !important;
  }
  :where(.vuetify-styles) .d-sm-inline-block {
    display: inline-block !important;
  }
  :where(.vuetify-styles) .d-sm-block {
    display: block !important;
  }
  :where(.vuetify-styles) .d-sm-table {
    display: table !important;
  }
  :where(.vuetify-styles) .d-sm-table-row {
    display: table-row !important;
  }
  :where(.vuetify-styles) .d-sm-table-cell {
    display: table-cell !important;
  }
  :where(.vuetify-styles) .d-sm-flex {
    display: flex !important;
  }
  :where(.vuetify-styles) .d-sm-inline-flex {
    display: inline-flex !important;
  }
  :where(.vuetify-styles) .float-sm-none {
    float: none !important;
  }
  :where(.vuetify-styles) .float-sm-left {
    float: left !important;
  }
  :where(.vuetify-styles) .float-sm-right {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-rtl .float-sm-end {
    float: left !important;
  }
  :where(.vuetify-styles) .v-locale--is-rtl .float-sm-start {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-ltr .float-sm-end {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-ltr .float-sm-start {
    float: left !important;
  }
  :where(.vuetify-styles) .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  :where(.vuetify-styles) .flex-sm-1-1 {
    flex: 1 1 auto !important;
  }
  :where(.vuetify-styles) .flex-sm-1-0 {
    flex: 1 0 auto !important;
  }
  :where(.vuetify-styles) .flex-sm-0-1 {
    flex: 0 1 auto !important;
  }
  :where(.vuetify-styles) .flex-sm-0-0 {
    flex: 0 0 auto !important;
  }
  :where(.vuetify-styles) .flex-sm-1-1-100 {
    flex: 1 1 100% !important;
  }
  :where(.vuetify-styles) .flex-sm-1-0-100 {
    flex: 1 0 100% !important;
  }
  :where(.vuetify-styles) .flex-sm-0-1-100 {
    flex: 0 1 100% !important;
  }
  :where(.vuetify-styles) .flex-sm-0-0-100 {
    flex: 0 0 100% !important;
  }
  :where(.vuetify-styles) .flex-sm-1-1-0 {
    flex: 1 1 0 !important;
  }
  :where(.vuetify-styles) .flex-sm-1-0-0 {
    flex: 1 0 0 !important;
  }
  :where(.vuetify-styles) .flex-sm-0-1-0 {
    flex: 0 1 0 !important;
  }
  :where(.vuetify-styles) .flex-sm-0-0-0 {
    flex: 0 0 0 !important;
  }
  :where(.vuetify-styles) .flex-sm-row {
    flex-direction: row !important;
  }
  :where(.vuetify-styles) .flex-sm-column {
    flex-direction: column !important;
  }
  :where(.vuetify-styles) .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  :where(.vuetify-styles) .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  :where(.vuetify-styles) .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  :where(.vuetify-styles) .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  :where(.vuetify-styles) .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  :where(.vuetify-styles) .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  :where(.vuetify-styles) .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  :where(.vuetify-styles) .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  :where(.vuetify-styles) .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :where(.vuetify-styles) .justify-sm-start {
    justify-content: flex-start !important;
  }
  :where(.vuetify-styles) .justify-sm-end {
    justify-content: flex-end !important;
  }
  :where(.vuetify-styles) .justify-sm-center {
    justify-content: center !important;
  }
  :where(.vuetify-styles) .justify-sm-space-between {
    justify-content: space-between !important;
  }
  :where(.vuetify-styles) .justify-sm-space-around {
    justify-content: space-around !important;
  }
  :where(.vuetify-styles) .justify-sm-space-evenly {
    justify-content: space-evenly !important;
  }
  :where(.vuetify-styles) .justify-items-sm-start {
    justify-items: flex-start !important;
  }
  :where(.vuetify-styles) .justify-items-sm-end {
    justify-items: flex-end !important;
  }
  :where(.vuetify-styles) .justify-items-sm-center {
    justify-items: center !important;
  }
  :where(.vuetify-styles) .justify-items-sm-stretch {
    justify-items: stretch !important;
  }
  :where(.vuetify-styles) .align-sm-start {
    align-items: flex-start !important;
  }
  :where(.vuetify-styles) .align-sm-end {
    align-items: flex-end !important;
  }
  :where(.vuetify-styles) .align-sm-center {
    align-items: center !important;
  }
  :where(.vuetify-styles) .align-sm-baseline {
    align-items: baseline !important;
  }
  :where(.vuetify-styles) .align-sm-stretch {
    align-items: stretch !important;
  }
  :where(.vuetify-styles) .align-content-sm-start {
    align-content: flex-start !important;
  }
  :where(.vuetify-styles) .align-content-sm-end {
    align-content: flex-end !important;
  }
  :where(.vuetify-styles) .align-content-sm-center {
    align-content: center !important;
  }
  :where(.vuetify-styles) .align-content-sm-space-between {
    align-content: space-between !important;
  }
  :where(.vuetify-styles) .align-content-sm-space-around {
    align-content: space-around !important;
  }
  :where(.vuetify-styles) .align-content-sm-space-evenly {
    align-content: space-evenly !important;
  }
  :where(.vuetify-styles) .align-content-sm-stretch {
    align-content: stretch !important;
  }
  :where(.vuetify-styles) .align-self-sm-auto {
    align-self: auto !important;
  }
  :where(.vuetify-styles) .align-self-sm-start {
    align-self: flex-start !important;
  }
  :where(.vuetify-styles) .align-self-sm-end {
    align-self: flex-end !important;
  }
  :where(.vuetify-styles) .align-self-sm-center {
    align-self: center !important;
  }
  :where(.vuetify-styles) .align-self-sm-baseline {
    align-self: baseline !important;
  }
  :where(.vuetify-styles) .align-self-sm-stretch {
    align-self: stretch !important;
  }
  :where(.vuetify-styles) .order-sm-first {
    order: -1 !important;
  }
  :where(.vuetify-styles) .order-sm-0 {
    order: 0 !important;
  }
  :where(.vuetify-styles) .order-sm-1 {
    order: 1 !important;
  }
  :where(.vuetify-styles) .order-sm-2 {
    order: 2 !important;
  }
  :where(.vuetify-styles) .order-sm-3 {
    order: 3 !important;
  }
  :where(.vuetify-styles) .order-sm-4 {
    order: 4 !important;
  }
  :where(.vuetify-styles) .order-sm-5 {
    order: 5 !important;
  }
  :where(.vuetify-styles) .order-sm-6 {
    order: 6 !important;
  }
  :where(.vuetify-styles) .order-sm-7 {
    order: 7 !important;
  }
  :where(.vuetify-styles) .order-sm-8 {
    order: 8 !important;
  }
  :where(.vuetify-styles) .order-sm-9 {
    order: 9 !important;
  }
  :where(.vuetify-styles) .order-sm-10 {
    order: 10 !important;
  }
  :where(.vuetify-styles) .order-sm-11 {
    order: 11 !important;
  }
  :where(.vuetify-styles) .order-sm-12 {
    order: 12 !important;
  }
  :where(.vuetify-styles) .order-sm-last {
    order: 13 !important;
  }
  :where(.vuetify-styles) .ga-sm-0 {
    gap: 0px !important;
  }
  :where(.vuetify-styles) .ga-sm-1 {
    gap: 4px !important;
  }
  :where(.vuetify-styles) .ga-sm-2 {
    gap: 8px !important;
  }
  :where(.vuetify-styles) .ga-sm-3 {
    gap: 12px !important;
  }
  :where(.vuetify-styles) .ga-sm-4 {
    gap: 16px !important;
  }
  :where(.vuetify-styles) .ga-sm-5 {
    gap: 20px !important;
  }
  :where(.vuetify-styles) .ga-sm-6 {
    gap: 24px !important;
  }
  :where(.vuetify-styles) .ga-sm-7 {
    gap: 28px !important;
  }
  :where(.vuetify-styles) .ga-sm-8 {
    gap: 32px !important;
  }
  :where(.vuetify-styles) .ga-sm-9 {
    gap: 36px !important;
  }
  :where(.vuetify-styles) .ga-sm-10 {
    gap: 40px !important;
  }
  :where(.vuetify-styles) .ga-sm-11 {
    gap: 44px !important;
  }
  :where(.vuetify-styles) .ga-sm-12 {
    gap: 48px !important;
  }
  :where(.vuetify-styles) .ga-sm-13 {
    gap: 52px !important;
  }
  :where(.vuetify-styles) .ga-sm-14 {
    gap: 56px !important;
  }
  :where(.vuetify-styles) .ga-sm-15 {
    gap: 60px !important;
  }
  :where(.vuetify-styles) .ga-sm-16 {
    gap: 64px !important;
  }
  :where(.vuetify-styles) .ga-sm-auto {
    gap: auto !important;
  }
  :where(.vuetify-styles) .gr-sm-0 {
    row-gap: 0px !important;
  }
  :where(.vuetify-styles) .gr-sm-1 {
    row-gap: 4px !important;
  }
  :where(.vuetify-styles) .gr-sm-2 {
    row-gap: 8px !important;
  }
  :where(.vuetify-styles) .gr-sm-3 {
    row-gap: 12px !important;
  }
  :where(.vuetify-styles) .gr-sm-4 {
    row-gap: 16px !important;
  }
  :where(.vuetify-styles) .gr-sm-5 {
    row-gap: 20px !important;
  }
  :where(.vuetify-styles) .gr-sm-6 {
    row-gap: 24px !important;
  }
  :where(.vuetify-styles) .gr-sm-7 {
    row-gap: 28px !important;
  }
  :where(.vuetify-styles) .gr-sm-8 {
    row-gap: 32px !important;
  }
  :where(.vuetify-styles) .gr-sm-9 {
    row-gap: 36px !important;
  }
  :where(.vuetify-styles) .gr-sm-10 {
    row-gap: 40px !important;
  }
  :where(.vuetify-styles) .gr-sm-11 {
    row-gap: 44px !important;
  }
  :where(.vuetify-styles) .gr-sm-12 {
    row-gap: 48px !important;
  }
  :where(.vuetify-styles) .gr-sm-13 {
    row-gap: 52px !important;
  }
  :where(.vuetify-styles) .gr-sm-14 {
    row-gap: 56px !important;
  }
  :where(.vuetify-styles) .gr-sm-15 {
    row-gap: 60px !important;
  }
  :where(.vuetify-styles) .gr-sm-16 {
    row-gap: 64px !important;
  }
  :where(.vuetify-styles) .gr-sm-auto {
    row-gap: auto !important;
  }
  :where(.vuetify-styles) .gc-sm-0 {
    column-gap: 0px !important;
  }
  :where(.vuetify-styles) .gc-sm-1 {
    column-gap: 4px !important;
  }
  :where(.vuetify-styles) .gc-sm-2 {
    column-gap: 8px !important;
  }
  :where(.vuetify-styles) .gc-sm-3 {
    column-gap: 12px !important;
  }
  :where(.vuetify-styles) .gc-sm-4 {
    column-gap: 16px !important;
  }
  :where(.vuetify-styles) .gc-sm-5 {
    column-gap: 20px !important;
  }
  :where(.vuetify-styles) .gc-sm-6 {
    column-gap: 24px !important;
  }
  :where(.vuetify-styles) .gc-sm-7 {
    column-gap: 28px !important;
  }
  :where(.vuetify-styles) .gc-sm-8 {
    column-gap: 32px !important;
  }
  :where(.vuetify-styles) .gc-sm-9 {
    column-gap: 36px !important;
  }
  :where(.vuetify-styles) .gc-sm-10 {
    column-gap: 40px !important;
  }
  :where(.vuetify-styles) .gc-sm-11 {
    column-gap: 44px !important;
  }
  :where(.vuetify-styles) .gc-sm-12 {
    column-gap: 48px !important;
  }
  :where(.vuetify-styles) .gc-sm-13 {
    column-gap: 52px !important;
  }
  :where(.vuetify-styles) .gc-sm-14 {
    column-gap: 56px !important;
  }
  :where(.vuetify-styles) .gc-sm-15 {
    column-gap: 60px !important;
  }
  :where(.vuetify-styles) .gc-sm-16 {
    column-gap: 64px !important;
  }
  :where(.vuetify-styles) .gc-sm-auto {
    column-gap: auto !important;
  }
  :where(.vuetify-styles) .ma-sm-0 {
    margin: 0px !important;
  }
  :where(.vuetify-styles) .ma-sm-1 {
    margin: 4px !important;
  }
  :where(.vuetify-styles) .ma-sm-2 {
    margin: 8px !important;
  }
  :where(.vuetify-styles) .ma-sm-3 {
    margin: 12px !important;
  }
  :where(.vuetify-styles) .ma-sm-4 {
    margin: 16px !important;
  }
  :where(.vuetify-styles) .ma-sm-5 {
    margin: 20px !important;
  }
  :where(.vuetify-styles) .ma-sm-6 {
    margin: 24px !important;
  }
  :where(.vuetify-styles) .ma-sm-7 {
    margin: 28px !important;
  }
  :where(.vuetify-styles) .ma-sm-8 {
    margin: 32px !important;
  }
  :where(.vuetify-styles) .ma-sm-9 {
    margin: 36px !important;
  }
  :where(.vuetify-styles) .ma-sm-10 {
    margin: 40px !important;
  }
  :where(.vuetify-styles) .ma-sm-11 {
    margin: 44px !important;
  }
  :where(.vuetify-styles) .ma-sm-12 {
    margin: 48px !important;
  }
  :where(.vuetify-styles) .ma-sm-13 {
    margin: 52px !important;
  }
  :where(.vuetify-styles) .ma-sm-14 {
    margin: 56px !important;
  }
  :where(.vuetify-styles) .ma-sm-15 {
    margin: 60px !important;
  }
  :where(.vuetify-styles) .ma-sm-16 {
    margin: 64px !important;
  }
  :where(.vuetify-styles) .ma-sm-auto {
    margin: auto !important;
  }
  :where(.vuetify-styles) .mx-sm-0 {
    margin-right: 0px !important;
    margin-left: 0px !important;
  }
  :where(.vuetify-styles) .mx-sm-1 {
    margin-right: 4px !important;
    margin-left: 4px !important;
  }
  :where(.vuetify-styles) .mx-sm-2 {
    margin-right: 8px !important;
    margin-left: 8px !important;
  }
  :where(.vuetify-styles) .mx-sm-3 {
    margin-right: 12px !important;
    margin-left: 12px !important;
  }
  :where(.vuetify-styles) .mx-sm-4 {
    margin-right: 16px !important;
    margin-left: 16px !important;
  }
  :where(.vuetify-styles) .mx-sm-5 {
    margin-right: 20px !important;
    margin-left: 20px !important;
  }
  :where(.vuetify-styles) .mx-sm-6 {
    margin-right: 24px !important;
    margin-left: 24px !important;
  }
  :where(.vuetify-styles) .mx-sm-7 {
    margin-right: 28px !important;
    margin-left: 28px !important;
  }
  :where(.vuetify-styles) .mx-sm-8 {
    margin-right: 32px !important;
    margin-left: 32px !important;
  }
  :where(.vuetify-styles) .mx-sm-9 {
    margin-right: 36px !important;
    margin-left: 36px !important;
  }
  :where(.vuetify-styles) .mx-sm-10 {
    margin-right: 40px !important;
    margin-left: 40px !important;
  }
  :where(.vuetify-styles) .mx-sm-11 {
    margin-right: 44px !important;
    margin-left: 44px !important;
  }
  :where(.vuetify-styles) .mx-sm-12 {
    margin-right: 48px !important;
    margin-left: 48px !important;
  }
  :where(.vuetify-styles) .mx-sm-13 {
    margin-right: 52px !important;
    margin-left: 52px !important;
  }
  :where(.vuetify-styles) .mx-sm-14 {
    margin-right: 56px !important;
    margin-left: 56px !important;
  }
  :where(.vuetify-styles) .mx-sm-15 {
    margin-right: 60px !important;
    margin-left: 60px !important;
  }
  :where(.vuetify-styles) .mx-sm-16 {
    margin-right: 64px !important;
    margin-left: 64px !important;
  }
  :where(.vuetify-styles) .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  :where(.vuetify-styles) .my-sm-0 {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  :where(.vuetify-styles) .my-sm-1 {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }
  :where(.vuetify-styles) .my-sm-2 {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }
  :where(.vuetify-styles) .my-sm-3 {
    margin-top: 12px !important;
    margin-bottom: 12px !important;
  }
  :where(.vuetify-styles) .my-sm-4 {
    margin-top: 16px !important;
    margin-bottom: 16px !important;
  }
  :where(.vuetify-styles) .my-sm-5 {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  :where(.vuetify-styles) .my-sm-6 {
    margin-top: 24px !important;
    margin-bottom: 24px !important;
  }
  :where(.vuetify-styles) .my-sm-7 {
    margin-top: 28px !important;
    margin-bottom: 28px !important;
  }
  :where(.vuetify-styles) .my-sm-8 {
    margin-top: 32px !important;
    margin-bottom: 32px !important;
  }
  :where(.vuetify-styles) .my-sm-9 {
    margin-top: 36px !important;
    margin-bottom: 36px !important;
  }
  :where(.vuetify-styles) .my-sm-10 {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  :where(.vuetify-styles) .my-sm-11 {
    margin-top: 44px !important;
    margin-bottom: 44px !important;
  }
  :where(.vuetify-styles) .my-sm-12 {
    margin-top: 48px !important;
    margin-bottom: 48px !important;
  }
  :where(.vuetify-styles) .my-sm-13 {
    margin-top: 52px !important;
    margin-bottom: 52px !important;
  }
  :where(.vuetify-styles) .my-sm-14 {
    margin-top: 56px !important;
    margin-bottom: 56px !important;
  }
  :where(.vuetify-styles) .my-sm-15 {
    margin-top: 60px !important;
    margin-bottom: 60px !important;
  }
  :where(.vuetify-styles) .my-sm-16 {
    margin-top: 64px !important;
    margin-bottom: 64px !important;
  }
  :where(.vuetify-styles) .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  :where(.vuetify-styles) .mt-sm-0 {
    margin-top: 0px !important;
  }
  :where(.vuetify-styles) .mt-sm-1 {
    margin-top: 4px !important;
  }
  :where(.vuetify-styles) .mt-sm-2 {
    margin-top: 8px !important;
  }
  :where(.vuetify-styles) .mt-sm-3 {
    margin-top: 12px !important;
  }
  :where(.vuetify-styles) .mt-sm-4 {
    margin-top: 16px !important;
  }
  :where(.vuetify-styles) .mt-sm-5 {
    margin-top: 20px !important;
  }
  :where(.vuetify-styles) .mt-sm-6 {
    margin-top: 24px !important;
  }
  :where(.vuetify-styles) .mt-sm-7 {
    margin-top: 28px !important;
  }
  :where(.vuetify-styles) .mt-sm-8 {
    margin-top: 32px !important;
  }
  :where(.vuetify-styles) .mt-sm-9 {
    margin-top: 36px !important;
  }
  :where(.vuetify-styles) .mt-sm-10 {
    margin-top: 40px !important;
  }
  :where(.vuetify-styles) .mt-sm-11 {
    margin-top: 44px !important;
  }
  :where(.vuetify-styles) .mt-sm-12 {
    margin-top: 48px !important;
  }
  :where(.vuetify-styles) .mt-sm-13 {
    margin-top: 52px !important;
  }
  :where(.vuetify-styles) .mt-sm-14 {
    margin-top: 56px !important;
  }
  :where(.vuetify-styles) .mt-sm-15 {
    margin-top: 60px !important;
  }
  :where(.vuetify-styles) .mt-sm-16 {
    margin-top: 64px !important;
  }
  :where(.vuetify-styles) .mt-sm-auto {
    margin-top: auto !important;
  }
  :where(.vuetify-styles) .mr-sm-0 {
    margin-right: 0px !important;
  }
  :where(.vuetify-styles) .mr-sm-1 {
    margin-right: 4px !important;
  }
  :where(.vuetify-styles) .mr-sm-2 {
    margin-right: 8px !important;
  }
  :where(.vuetify-styles) .mr-sm-3 {
    margin-right: 12px !important;
  }
  :where(.vuetify-styles) .mr-sm-4 {
    margin-right: 16px !important;
  }
  :where(.vuetify-styles) .mr-sm-5 {
    margin-right: 20px !important;
  }
  :where(.vuetify-styles) .mr-sm-6 {
    margin-right: 24px !important;
  }
  :where(.vuetify-styles) .mr-sm-7 {
    margin-right: 28px !important;
  }
  :where(.vuetify-styles) .mr-sm-8 {
    margin-right: 32px !important;
  }
  :where(.vuetify-styles) .mr-sm-9 {
    margin-right: 36px !important;
  }
  :where(.vuetify-styles) .mr-sm-10 {
    margin-right: 40px !important;
  }
  :where(.vuetify-styles) .mr-sm-11 {
    margin-right: 44px !important;
  }
  :where(.vuetify-styles) .mr-sm-12 {
    margin-right: 48px !important;
  }
  :where(.vuetify-styles) .mr-sm-13 {
    margin-right: 52px !important;
  }
  :where(.vuetify-styles) .mr-sm-14 {
    margin-right: 56px !important;
  }
  :where(.vuetify-styles) .mr-sm-15 {
    margin-right: 60px !important;
  }
  :where(.vuetify-styles) .mr-sm-16 {
    margin-right: 64px !important;
  }
  :where(.vuetify-styles) .mr-sm-auto {
    margin-right: auto !important;
  }
  :where(.vuetify-styles) .mb-sm-0 {
    margin-bottom: 0px !important;
  }
  :where(.vuetify-styles) .mb-sm-1 {
    margin-bottom: 4px !important;
  }
  :where(.vuetify-styles) .mb-sm-2 {
    margin-bottom: 8px !important;
  }
  :where(.vuetify-styles) .mb-sm-3 {
    margin-bottom: 12px !important;
  }
  :where(.vuetify-styles) .mb-sm-4 {
    margin-bottom: 16px !important;
  }
  :where(.vuetify-styles) .mb-sm-5 {
    margin-bottom: 20px !important;
  }
  :where(.vuetify-styles) .mb-sm-6 {
    margin-bottom: 24px !important;
  }
  :where(.vuetify-styles) .mb-sm-7 {
    margin-bottom: 28px !important;
  }
  :where(.vuetify-styles) .mb-sm-8 {
    margin-bottom: 32px !important;
  }
  :where(.vuetify-styles) .mb-sm-9 {
    margin-bottom: 36px !important;
  }
  :where(.vuetify-styles) .mb-sm-10 {
    margin-bottom: 40px !important;
  }
  :where(.vuetify-styles) .mb-sm-11 {
    margin-bottom: 44px !important;
  }
  :where(.vuetify-styles) .mb-sm-12 {
    margin-bottom: 48px !important;
  }
  :where(.vuetify-styles) .mb-sm-13 {
    margin-bottom: 52px !important;
  }
  :where(.vuetify-styles) .mb-sm-14 {
    margin-bottom: 56px !important;
  }
  :where(.vuetify-styles) .mb-sm-15 {
    margin-bottom: 60px !important;
  }
  :where(.vuetify-styles) .mb-sm-16 {
    margin-bottom: 64px !important;
  }
  :where(.vuetify-styles) .mb-sm-auto {
    margin-bottom: auto !important;
  }
  :where(.vuetify-styles) .ml-sm-0 {
    margin-left: 0px !important;
  }
  :where(.vuetify-styles) .ml-sm-1 {
    margin-left: 4px !important;
  }
  :where(.vuetify-styles) .ml-sm-2 {
    margin-left: 8px !important;
  }
  :where(.vuetify-styles) .ml-sm-3 {
    margin-left: 12px !important;
  }
  :where(.vuetify-styles) .ml-sm-4 {
    margin-left: 16px !important;
  }
  :where(.vuetify-styles) .ml-sm-5 {
    margin-left: 20px !important;
  }
  :where(.vuetify-styles) .ml-sm-6 {
    margin-left: 24px !important;
  }
  :where(.vuetify-styles) .ml-sm-7 {
    margin-left: 28px !important;
  }
  :where(.vuetify-styles) .ml-sm-8 {
    margin-left: 32px !important;
  }
  :where(.vuetify-styles) .ml-sm-9 {
    margin-left: 36px !important;
  }
  :where(.vuetify-styles) .ml-sm-10 {
    margin-left: 40px !important;
  }
  :where(.vuetify-styles) .ml-sm-11 {
    margin-left: 44px !important;
  }
  :where(.vuetify-styles) .ml-sm-12 {
    margin-left: 48px !important;
  }
  :where(.vuetify-styles) .ml-sm-13 {
    margin-left: 52px !important;
  }
  :where(.vuetify-styles) .ml-sm-14 {
    margin-left: 56px !important;
  }
  :where(.vuetify-styles) .ml-sm-15 {
    margin-left: 60px !important;
  }
  :where(.vuetify-styles) .ml-sm-16 {
    margin-left: 64px !important;
  }
  :where(.vuetify-styles) .ml-sm-auto {
    margin-left: auto !important;
  }
  :where(.vuetify-styles) .ms-sm-0 {
    margin-inline-start: 0px !important;
  }
  :where(.vuetify-styles) .ms-sm-1 {
    margin-inline-start: 4px !important;
  }
  :where(.vuetify-styles) .ms-sm-2 {
    margin-inline-start: 8px !important;
  }
  :where(.vuetify-styles) .ms-sm-3 {
    margin-inline-start: 12px !important;
  }
  :where(.vuetify-styles) .ms-sm-4 {
    margin-inline-start: 16px !important;
  }
  :where(.vuetify-styles) .ms-sm-5 {
    margin-inline-start: 20px !important;
  }
  :where(.vuetify-styles) .ms-sm-6 {
    margin-inline-start: 24px !important;
  }
  :where(.vuetify-styles) .ms-sm-7 {
    margin-inline-start: 28px !important;
  }
  :where(.vuetify-styles) .ms-sm-8 {
    margin-inline-start: 32px !important;
  }
  :where(.vuetify-styles) .ms-sm-9 {
    margin-inline-start: 36px !important;
  }
  :where(.vuetify-styles) .ms-sm-10 {
    margin-inline-start: 40px !important;
  }
  :where(.vuetify-styles) .ms-sm-11 {
    margin-inline-start: 44px !important;
  }
  :where(.vuetify-styles) .ms-sm-12 {
    margin-inline-start: 48px !important;
  }
  :where(.vuetify-styles) .ms-sm-13 {
    margin-inline-start: 52px !important;
  }
  :where(.vuetify-styles) .ms-sm-14 {
    margin-inline-start: 56px !important;
  }
  :where(.vuetify-styles) .ms-sm-15 {
    margin-inline-start: 60px !important;
  }
  :where(.vuetify-styles) .ms-sm-16 {
    margin-inline-start: 64px !important;
  }
  :where(.vuetify-styles) .ms-sm-auto {
    margin-inline-start: auto !important;
  }
  :where(.vuetify-styles) .me-sm-0 {
    margin-inline-end: 0px !important;
  }
  :where(.vuetify-styles) .me-sm-1 {
    margin-inline-end: 4px !important;
  }
  :where(.vuetify-styles) .me-sm-2 {
    margin-inline-end: 8px !important;
  }
  :where(.vuetify-styles) .me-sm-3 {
    margin-inline-end: 12px !important;
  }
  :where(.vuetify-styles) .me-sm-4 {
    margin-inline-end: 16px !important;
  }
  :where(.vuetify-styles) .me-sm-5 {
    margin-inline-end: 20px !important;
  }
  :where(.vuetify-styles) .me-sm-6 {
    margin-inline-end: 24px !important;
  }
  :where(.vuetify-styles) .me-sm-7 {
    margin-inline-end: 28px !important;
  }
  :where(.vuetify-styles) .me-sm-8 {
    margin-inline-end: 32px !important;
  }
  :where(.vuetify-styles) .me-sm-9 {
    margin-inline-end: 36px !important;
  }
  :where(.vuetify-styles) .me-sm-10 {
    margin-inline-end: 40px !important;
  }
  :where(.vuetify-styles) .me-sm-11 {
    margin-inline-end: 44px !important;
  }
  :where(.vuetify-styles) .me-sm-12 {
    margin-inline-end: 48px !important;
  }
  :where(.vuetify-styles) .me-sm-13 {
    margin-inline-end: 52px !important;
  }
  :where(.vuetify-styles) .me-sm-14 {
    margin-inline-end: 56px !important;
  }
  :where(.vuetify-styles) .me-sm-15 {
    margin-inline-end: 60px !important;
  }
  :where(.vuetify-styles) .me-sm-16 {
    margin-inline-end: 64px !important;
  }
  :where(.vuetify-styles) .me-sm-auto {
    margin-inline-end: auto !important;
  }
  :where(.vuetify-styles) .ma-sm-n1 {
    margin: -4px !important;
  }
  :where(.vuetify-styles) .ma-sm-n2 {
    margin: -8px !important;
  }
  :where(.vuetify-styles) .ma-sm-n3 {
    margin: -12px !important;
  }
  :where(.vuetify-styles) .ma-sm-n4 {
    margin: -16px !important;
  }
  :where(.vuetify-styles) .ma-sm-n5 {
    margin: -20px !important;
  }
  :where(.vuetify-styles) .ma-sm-n6 {
    margin: -24px !important;
  }
  :where(.vuetify-styles) .ma-sm-n7 {
    margin: -28px !important;
  }
  :where(.vuetify-styles) .ma-sm-n8 {
    margin: -32px !important;
  }
  :where(.vuetify-styles) .ma-sm-n9 {
    margin: -36px !important;
  }
  :where(.vuetify-styles) .ma-sm-n10 {
    margin: -40px !important;
  }
  :where(.vuetify-styles) .ma-sm-n11 {
    margin: -44px !important;
  }
  :where(.vuetify-styles) .ma-sm-n12 {
    margin: -48px !important;
  }
  :where(.vuetify-styles) .ma-sm-n13 {
    margin: -52px !important;
  }
  :where(.vuetify-styles) .ma-sm-n14 {
    margin: -56px !important;
  }
  :where(.vuetify-styles) .ma-sm-n15 {
    margin: -60px !important;
  }
  :where(.vuetify-styles) .ma-sm-n16 {
    margin: -64px !important;
  }
  :where(.vuetify-styles) .mx-sm-n1 {
    margin-right: -4px !important;
    margin-left: -4px !important;
  }
  :where(.vuetify-styles) .mx-sm-n2 {
    margin-right: -8px !important;
    margin-left: -8px !important;
  }
  :where(.vuetify-styles) .mx-sm-n3 {
    margin-right: -12px !important;
    margin-left: -12px !important;
  }
  :where(.vuetify-styles) .mx-sm-n4 {
    margin-right: -16px !important;
    margin-left: -16px !important;
  }
  :where(.vuetify-styles) .mx-sm-n5 {
    margin-right: -20px !important;
    margin-left: -20px !important;
  }
  :where(.vuetify-styles) .mx-sm-n6 {
    margin-right: -24px !important;
    margin-left: -24px !important;
  }
  :where(.vuetify-styles) .mx-sm-n7 {
    margin-right: -28px !important;
    margin-left: -28px !important;
  }
  :where(.vuetify-styles) .mx-sm-n8 {
    margin-right: -32px !important;
    margin-left: -32px !important;
  }
  :where(.vuetify-styles) .mx-sm-n9 {
    margin-right: -36px !important;
    margin-left: -36px !important;
  }
  :where(.vuetify-styles) .mx-sm-n10 {
    margin-right: -40px !important;
    margin-left: -40px !important;
  }
  :where(.vuetify-styles) .mx-sm-n11 {
    margin-right: -44px !important;
    margin-left: -44px !important;
  }
  :where(.vuetify-styles) .mx-sm-n12 {
    margin-right: -48px !important;
    margin-left: -48px !important;
  }
  :where(.vuetify-styles) .mx-sm-n13 {
    margin-right: -52px !important;
    margin-left: -52px !important;
  }
  :where(.vuetify-styles) .mx-sm-n14 {
    margin-right: -56px !important;
    margin-left: -56px !important;
  }
  :where(.vuetify-styles) .mx-sm-n15 {
    margin-right: -60px !important;
    margin-left: -60px !important;
  }
  :where(.vuetify-styles) .mx-sm-n16 {
    margin-right: -64px !important;
    margin-left: -64px !important;
  }
  :where(.vuetify-styles) .my-sm-n1 {
    margin-top: -4px !important;
    margin-bottom: -4px !important;
  }
  :where(.vuetify-styles) .my-sm-n2 {
    margin-top: -8px !important;
    margin-bottom: -8px !important;
  }
  :where(.vuetify-styles) .my-sm-n3 {
    margin-top: -12px !important;
    margin-bottom: -12px !important;
  }
  :where(.vuetify-styles) .my-sm-n4 {
    margin-top: -16px !important;
    margin-bottom: -16px !important;
  }
  :where(.vuetify-styles) .my-sm-n5 {
    margin-top: -20px !important;
    margin-bottom: -20px !important;
  }
  :where(.vuetify-styles) .my-sm-n6 {
    margin-top: -24px !important;
    margin-bottom: -24px !important;
  }
  :where(.vuetify-styles) .my-sm-n7 {
    margin-top: -28px !important;
    margin-bottom: -28px !important;
  }
  :where(.vuetify-styles) .my-sm-n8 {
    margin-top: -32px !important;
    margin-bottom: -32px !important;
  }
  :where(.vuetify-styles) .my-sm-n9 {
    margin-top: -36px !important;
    margin-bottom: -36px !important;
  }
  :where(.vuetify-styles) .my-sm-n10 {
    margin-top: -40px !important;
    margin-bottom: -40px !important;
  }
  :where(.vuetify-styles) .my-sm-n11 {
    margin-top: -44px !important;
    margin-bottom: -44px !important;
  }
  :where(.vuetify-styles) .my-sm-n12 {
    margin-top: -48px !important;
    margin-bottom: -48px !important;
  }
  :where(.vuetify-styles) .my-sm-n13 {
    margin-top: -52px !important;
    margin-bottom: -52px !important;
  }
  :where(.vuetify-styles) .my-sm-n14 {
    margin-top: -56px !important;
    margin-bottom: -56px !important;
  }
  :where(.vuetify-styles) .my-sm-n15 {
    margin-top: -60px !important;
    margin-bottom: -60px !important;
  }
  :where(.vuetify-styles) .my-sm-n16 {
    margin-top: -64px !important;
    margin-bottom: -64px !important;
  }
  :where(.vuetify-styles) .mt-sm-n1 {
    margin-top: -4px !important;
  }
  :where(.vuetify-styles) .mt-sm-n2 {
    margin-top: -8px !important;
  }
  :where(.vuetify-styles) .mt-sm-n3 {
    margin-top: -12px !important;
  }
  :where(.vuetify-styles) .mt-sm-n4 {
    margin-top: -16px !important;
  }
  :where(.vuetify-styles) .mt-sm-n5 {
    margin-top: -20px !important;
  }
  :where(.vuetify-styles) .mt-sm-n6 {
    margin-top: -24px !important;
  }
  :where(.vuetify-styles) .mt-sm-n7 {
    margin-top: -28px !important;
  }
  :where(.vuetify-styles) .mt-sm-n8 {
    margin-top: -32px !important;
  }
  :where(.vuetify-styles) .mt-sm-n9 {
    margin-top: -36px !important;
  }
  :where(.vuetify-styles) .mt-sm-n10 {
    margin-top: -40px !important;
  }
  :where(.vuetify-styles) .mt-sm-n11 {
    margin-top: -44px !important;
  }
  :where(.vuetify-styles) .mt-sm-n12 {
    margin-top: -48px !important;
  }
  :where(.vuetify-styles) .mt-sm-n13 {
    margin-top: -52px !important;
  }
  :where(.vuetify-styles) .mt-sm-n14 {
    margin-top: -56px !important;
  }
  :where(.vuetify-styles) .mt-sm-n15 {
    margin-top: -60px !important;
  }
  :where(.vuetify-styles) .mt-sm-n16 {
    margin-top: -64px !important;
  }
  :where(.vuetify-styles) .mr-sm-n1 {
    margin-right: -4px !important;
  }
  :where(.vuetify-styles) .mr-sm-n2 {
    margin-right: -8px !important;
  }
  :where(.vuetify-styles) .mr-sm-n3 {
    margin-right: -12px !important;
  }
  :where(.vuetify-styles) .mr-sm-n4 {
    margin-right: -16px !important;
  }
  :where(.vuetify-styles) .mr-sm-n5 {
    margin-right: -20px !important;
  }
  :where(.vuetify-styles) .mr-sm-n6 {
    margin-right: -24px !important;
  }
  :where(.vuetify-styles) .mr-sm-n7 {
    margin-right: -28px !important;
  }
  :where(.vuetify-styles) .mr-sm-n8 {
    margin-right: -32px !important;
  }
  :where(.vuetify-styles) .mr-sm-n9 {
    margin-right: -36px !important;
  }
  :where(.vuetify-styles) .mr-sm-n10 {
    margin-right: -40px !important;
  }
  :where(.vuetify-styles) .mr-sm-n11 {
    margin-right: -44px !important;
  }
  :where(.vuetify-styles) .mr-sm-n12 {
    margin-right: -48px !important;
  }
  :where(.vuetify-styles) .mr-sm-n13 {
    margin-right: -52px !important;
  }
  :where(.vuetify-styles) .mr-sm-n14 {
    margin-right: -56px !important;
  }
  :where(.vuetify-styles) .mr-sm-n15 {
    margin-right: -60px !important;
  }
  :where(.vuetify-styles) .mr-sm-n16 {
    margin-right: -64px !important;
  }
  :where(.vuetify-styles) .mb-sm-n1 {
    margin-bottom: -4px !important;
  }
  :where(.vuetify-styles) .mb-sm-n2 {
    margin-bottom: -8px !important;
  }
  :where(.vuetify-styles) .mb-sm-n3 {
    margin-bottom: -12px !important;
  }
  :where(.vuetify-styles) .mb-sm-n4 {
    margin-bottom: -16px !important;
  }
  :where(.vuetify-styles) .mb-sm-n5 {
    margin-bottom: -20px !important;
  }
  :where(.vuetify-styles) .mb-sm-n6 {
    margin-bottom: -24px !important;
  }
  :where(.vuetify-styles) .mb-sm-n7 {
    margin-bottom: -28px !important;
  }
  :where(.vuetify-styles) .mb-sm-n8 {
    margin-bottom: -32px !important;
  }
  :where(.vuetify-styles) .mb-sm-n9 {
    margin-bottom: -36px !important;
  }
  :where(.vuetify-styles) .mb-sm-n10 {
    margin-bottom: -40px !important;
  }
  :where(.vuetify-styles) .mb-sm-n11 {
    margin-bottom: -44px !important;
  }
  :where(.vuetify-styles) .mb-sm-n12 {
    margin-bottom: -48px !important;
  }
  :where(.vuetify-styles) .mb-sm-n13 {
    margin-bottom: -52px !important;
  }
  :where(.vuetify-styles) .mb-sm-n14 {
    margin-bottom: -56px !important;
  }
  :where(.vuetify-styles) .mb-sm-n15 {
    margin-bottom: -60px !important;
  }
  :where(.vuetify-styles) .mb-sm-n16 {
    margin-bottom: -64px !important;
  }
  :where(.vuetify-styles) .ml-sm-n1 {
    margin-left: -4px !important;
  }
  :where(.vuetify-styles) .ml-sm-n2 {
    margin-left: -8px !important;
  }
  :where(.vuetify-styles) .ml-sm-n3 {
    margin-left: -12px !important;
  }
  :where(.vuetify-styles) .ml-sm-n4 {
    margin-left: -16px !important;
  }
  :where(.vuetify-styles) .ml-sm-n5 {
    margin-left: -20px !important;
  }
  :where(.vuetify-styles) .ml-sm-n6 {
    margin-left: -24px !important;
  }
  :where(.vuetify-styles) .ml-sm-n7 {
    margin-left: -28px !important;
  }
  :where(.vuetify-styles) .ml-sm-n8 {
    margin-left: -32px !important;
  }
  :where(.vuetify-styles) .ml-sm-n9 {
    margin-left: -36px !important;
  }
  :where(.vuetify-styles) .ml-sm-n10 {
    margin-left: -40px !important;
  }
  :where(.vuetify-styles) .ml-sm-n11 {
    margin-left: -44px !important;
  }
  :where(.vuetify-styles) .ml-sm-n12 {
    margin-left: -48px !important;
  }
  :where(.vuetify-styles) .ml-sm-n13 {
    margin-left: -52px !important;
  }
  :where(.vuetify-styles) .ml-sm-n14 {
    margin-left: -56px !important;
  }
  :where(.vuetify-styles) .ml-sm-n15 {
    margin-left: -60px !important;
  }
  :where(.vuetify-styles) .ml-sm-n16 {
    margin-left: -64px !important;
  }
  :where(.vuetify-styles) .ms-sm-n1 {
    margin-inline-start: -4px !important;
  }
  :where(.vuetify-styles) .ms-sm-n2 {
    margin-inline-start: -8px !important;
  }
  :where(.vuetify-styles) .ms-sm-n3 {
    margin-inline-start: -12px !important;
  }
  :where(.vuetify-styles) .ms-sm-n4 {
    margin-inline-start: -16px !important;
  }
  :where(.vuetify-styles) .ms-sm-n5 {
    margin-inline-start: -20px !important;
  }
  :where(.vuetify-styles) .ms-sm-n6 {
    margin-inline-start: -24px !important;
  }
  :where(.vuetify-styles) .ms-sm-n7 {
    margin-inline-start: -28px !important;
  }
  :where(.vuetify-styles) .ms-sm-n8 {
    margin-inline-start: -32px !important;
  }
  :where(.vuetify-styles) .ms-sm-n9 {
    margin-inline-start: -36px !important;
  }
  :where(.vuetify-styles) .ms-sm-n10 {
    margin-inline-start: -40px !important;
  }
  :where(.vuetify-styles) .ms-sm-n11 {
    margin-inline-start: -44px !important;
  }
  :where(.vuetify-styles) .ms-sm-n12 {
    margin-inline-start: -48px !important;
  }
  :where(.vuetify-styles) .ms-sm-n13 {
    margin-inline-start: -52px !important;
  }
  :where(.vuetify-styles) .ms-sm-n14 {
    margin-inline-start: -56px !important;
  }
  :where(.vuetify-styles) .ms-sm-n15 {
    margin-inline-start: -60px !important;
  }
  :where(.vuetify-styles) .ms-sm-n16 {
    margin-inline-start: -64px !important;
  }
  :where(.vuetify-styles) .me-sm-n1 {
    margin-inline-end: -4px !important;
  }
  :where(.vuetify-styles) .me-sm-n2 {
    margin-inline-end: -8px !important;
  }
  :where(.vuetify-styles) .me-sm-n3 {
    margin-inline-end: -12px !important;
  }
  :where(.vuetify-styles) .me-sm-n4 {
    margin-inline-end: -16px !important;
  }
  :where(.vuetify-styles) .me-sm-n5 {
    margin-inline-end: -20px !important;
  }
  :where(.vuetify-styles) .me-sm-n6 {
    margin-inline-end: -24px !important;
  }
  :where(.vuetify-styles) .me-sm-n7 {
    margin-inline-end: -28px !important;
  }
  :where(.vuetify-styles) .me-sm-n8 {
    margin-inline-end: -32px !important;
  }
  :where(.vuetify-styles) .me-sm-n9 {
    margin-inline-end: -36px !important;
  }
  :where(.vuetify-styles) .me-sm-n10 {
    margin-inline-end: -40px !important;
  }
  :where(.vuetify-styles) .me-sm-n11 {
    margin-inline-end: -44px !important;
  }
  :where(.vuetify-styles) .me-sm-n12 {
    margin-inline-end: -48px !important;
  }
  :where(.vuetify-styles) .me-sm-n13 {
    margin-inline-end: -52px !important;
  }
  :where(.vuetify-styles) .me-sm-n14 {
    margin-inline-end: -56px !important;
  }
  :where(.vuetify-styles) .me-sm-n15 {
    margin-inline-end: -60px !important;
  }
  :where(.vuetify-styles) .me-sm-n16 {
    margin-inline-end: -64px !important;
  }
  :where(.vuetify-styles) .pa-sm-0 {
    padding: 0px !important;
  }
  :where(.vuetify-styles) .pa-sm-1 {
    padding: 4px !important;
  }
  :where(.vuetify-styles) .pa-sm-2 {
    padding: 8px !important;
  }
  :where(.vuetify-styles) .pa-sm-3 {
    padding: 12px !important;
  }
  :where(.vuetify-styles) .pa-sm-4 {
    padding: 16px !important;
  }
  :where(.vuetify-styles) .pa-sm-5 {
    padding: 20px !important;
  }
  :where(.vuetify-styles) .pa-sm-6 {
    padding: 24px !important;
  }
  :where(.vuetify-styles) .pa-sm-7 {
    padding: 28px !important;
  }
  :where(.vuetify-styles) .pa-sm-8 {
    padding: 32px !important;
  }
  :where(.vuetify-styles) .pa-sm-9 {
    padding: 36px !important;
  }
  :where(.vuetify-styles) .pa-sm-10 {
    padding: 40px !important;
  }
  :where(.vuetify-styles) .pa-sm-11 {
    padding: 44px !important;
  }
  :where(.vuetify-styles) .pa-sm-12 {
    padding: 48px !important;
  }
  :where(.vuetify-styles) .pa-sm-13 {
    padding: 52px !important;
  }
  :where(.vuetify-styles) .pa-sm-14 {
    padding: 56px !important;
  }
  :where(.vuetify-styles) .pa-sm-15 {
    padding: 60px !important;
  }
  :where(.vuetify-styles) .pa-sm-16 {
    padding: 64px !important;
  }
  :where(.vuetify-styles) .px-sm-0 {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  :where(.vuetify-styles) .px-sm-1 {
    padding-right: 4px !important;
    padding-left: 4px !important;
  }
  :where(.vuetify-styles) .px-sm-2 {
    padding-right: 8px !important;
    padding-left: 8px !important;
  }
  :where(.vuetify-styles) .px-sm-3 {
    padding-right: 12px !important;
    padding-left: 12px !important;
  }
  :where(.vuetify-styles) .px-sm-4 {
    padding-right: 16px !important;
    padding-left: 16px !important;
  }
  :where(.vuetify-styles) .px-sm-5 {
    padding-right: 20px !important;
    padding-left: 20px !important;
  }
  :where(.vuetify-styles) .px-sm-6 {
    padding-right: 24px !important;
    padding-left: 24px !important;
  }
  :where(.vuetify-styles) .px-sm-7 {
    padding-right: 28px !important;
    padding-left: 28px !important;
  }
  :where(.vuetify-styles) .px-sm-8 {
    padding-right: 32px !important;
    padding-left: 32px !important;
  }
  :where(.vuetify-styles) .px-sm-9 {
    padding-right: 36px !important;
    padding-left: 36px !important;
  }
  :where(.vuetify-styles) .px-sm-10 {
    padding-right: 40px !important;
    padding-left: 40px !important;
  }
  :where(.vuetify-styles) .px-sm-11 {
    padding-right: 44px !important;
    padding-left: 44px !important;
  }
  :where(.vuetify-styles) .px-sm-12 {
    padding-right: 48px !important;
    padding-left: 48px !important;
  }
  :where(.vuetify-styles) .px-sm-13 {
    padding-right: 52px !important;
    padding-left: 52px !important;
  }
  :where(.vuetify-styles) .px-sm-14 {
    padding-right: 56px !important;
    padding-left: 56px !important;
  }
  :where(.vuetify-styles) .px-sm-15 {
    padding-right: 60px !important;
    padding-left: 60px !important;
  }
  :where(.vuetify-styles) .px-sm-16 {
    padding-right: 64px !important;
    padding-left: 64px !important;
  }
  :where(.vuetify-styles) .py-sm-0 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  :where(.vuetify-styles) .py-sm-1 {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
  :where(.vuetify-styles) .py-sm-2 {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  :where(.vuetify-styles) .py-sm-3 {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  :where(.vuetify-styles) .py-sm-4 {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
  :where(.vuetify-styles) .py-sm-5 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  :where(.vuetify-styles) .py-sm-6 {
    padding-top: 24px !important;
    padding-bottom: 24px !important;
  }
  :where(.vuetify-styles) .py-sm-7 {
    padding-top: 28px !important;
    padding-bottom: 28px !important;
  }
  :where(.vuetify-styles) .py-sm-8 {
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }
  :where(.vuetify-styles) .py-sm-9 {
    padding-top: 36px !important;
    padding-bottom: 36px !important;
  }
  :where(.vuetify-styles) .py-sm-10 {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  :where(.vuetify-styles) .py-sm-11 {
    padding-top: 44px !important;
    padding-bottom: 44px !important;
  }
  :where(.vuetify-styles) .py-sm-12 {
    padding-top: 48px !important;
    padding-bottom: 48px !important;
  }
  :where(.vuetify-styles) .py-sm-13 {
    padding-top: 52px !important;
    padding-bottom: 52px !important;
  }
  :where(.vuetify-styles) .py-sm-14 {
    padding-top: 56px !important;
    padding-bottom: 56px !important;
  }
  :where(.vuetify-styles) .py-sm-15 {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }
  :where(.vuetify-styles) .py-sm-16 {
    padding-top: 64px !important;
    padding-bottom: 64px !important;
  }
  :where(.vuetify-styles) .pt-sm-0 {
    padding-top: 0px !important;
  }
  :where(.vuetify-styles) .pt-sm-1 {
    padding-top: 4px !important;
  }
  :where(.vuetify-styles) .pt-sm-2 {
    padding-top: 8px !important;
  }
  :where(.vuetify-styles) .pt-sm-3 {
    padding-top: 12px !important;
  }
  :where(.vuetify-styles) .pt-sm-4 {
    padding-top: 16px !important;
  }
  :where(.vuetify-styles) .pt-sm-5 {
    padding-top: 20px !important;
  }
  :where(.vuetify-styles) .pt-sm-6 {
    padding-top: 24px !important;
  }
  :where(.vuetify-styles) .pt-sm-7 {
    padding-top: 28px !important;
  }
  :where(.vuetify-styles) .pt-sm-8 {
    padding-top: 32px !important;
  }
  :where(.vuetify-styles) .pt-sm-9 {
    padding-top: 36px !important;
  }
  :where(.vuetify-styles) .pt-sm-10 {
    padding-top: 40px !important;
  }
  :where(.vuetify-styles) .pt-sm-11 {
    padding-top: 44px !important;
  }
  :where(.vuetify-styles) .pt-sm-12 {
    padding-top: 48px !important;
  }
  :where(.vuetify-styles) .pt-sm-13 {
    padding-top: 52px !important;
  }
  :where(.vuetify-styles) .pt-sm-14 {
    padding-top: 56px !important;
  }
  :where(.vuetify-styles) .pt-sm-15 {
    padding-top: 60px !important;
  }
  :where(.vuetify-styles) .pt-sm-16 {
    padding-top: 64px !important;
  }
  :where(.vuetify-styles) .pr-sm-0 {
    padding-right: 0px !important;
  }
  :where(.vuetify-styles) .pr-sm-1 {
    padding-right: 4px !important;
  }
  :where(.vuetify-styles) .pr-sm-2 {
    padding-right: 8px !important;
  }
  :where(.vuetify-styles) .pr-sm-3 {
    padding-right: 12px !important;
  }
  :where(.vuetify-styles) .pr-sm-4 {
    padding-right: 16px !important;
  }
  :where(.vuetify-styles) .pr-sm-5 {
    padding-right: 20px !important;
  }
  :where(.vuetify-styles) .pr-sm-6 {
    padding-right: 24px !important;
  }
  :where(.vuetify-styles) .pr-sm-7 {
    padding-right: 28px !important;
  }
  :where(.vuetify-styles) .pr-sm-8 {
    padding-right: 32px !important;
  }
  :where(.vuetify-styles) .pr-sm-9 {
    padding-right: 36px !important;
  }
  :where(.vuetify-styles) .pr-sm-10 {
    padding-right: 40px !important;
  }
  :where(.vuetify-styles) .pr-sm-11 {
    padding-right: 44px !important;
  }
  :where(.vuetify-styles) .pr-sm-12 {
    padding-right: 48px !important;
  }
  :where(.vuetify-styles) .pr-sm-13 {
    padding-right: 52px !important;
  }
  :where(.vuetify-styles) .pr-sm-14 {
    padding-right: 56px !important;
  }
  :where(.vuetify-styles) .pr-sm-15 {
    padding-right: 60px !important;
  }
  :where(.vuetify-styles) .pr-sm-16 {
    padding-right: 64px !important;
  }
  :where(.vuetify-styles) .pb-sm-0 {
    padding-bottom: 0px !important;
  }
  :where(.vuetify-styles) .pb-sm-1 {
    padding-bottom: 4px !important;
  }
  :where(.vuetify-styles) .pb-sm-2 {
    padding-bottom: 8px !important;
  }
  :where(.vuetify-styles) .pb-sm-3 {
    padding-bottom: 12px !important;
  }
  :where(.vuetify-styles) .pb-sm-4 {
    padding-bottom: 16px !important;
  }
  :where(.vuetify-styles) .pb-sm-5 {
    padding-bottom: 20px !important;
  }
  :where(.vuetify-styles) .pb-sm-6 {
    padding-bottom: 24px !important;
  }
  :where(.vuetify-styles) .pb-sm-7 {
    padding-bottom: 28px !important;
  }
  :where(.vuetify-styles) .pb-sm-8 {
    padding-bottom: 32px !important;
  }
  :where(.vuetify-styles) .pb-sm-9 {
    padding-bottom: 36px !important;
  }
  :where(.vuetify-styles) .pb-sm-10 {
    padding-bottom: 40px !important;
  }
  :where(.vuetify-styles) .pb-sm-11 {
    padding-bottom: 44px !important;
  }
  :where(.vuetify-styles) .pb-sm-12 {
    padding-bottom: 48px !important;
  }
  :where(.vuetify-styles) .pb-sm-13 {
    padding-bottom: 52px !important;
  }
  :where(.vuetify-styles) .pb-sm-14 {
    padding-bottom: 56px !important;
  }
  :where(.vuetify-styles) .pb-sm-15 {
    padding-bottom: 60px !important;
  }
  :where(.vuetify-styles) .pb-sm-16 {
    padding-bottom: 64px !important;
  }
  :where(.vuetify-styles) .pl-sm-0 {
    padding-left: 0px !important;
  }
  :where(.vuetify-styles) .pl-sm-1 {
    padding-left: 4px !important;
  }
  :where(.vuetify-styles) .pl-sm-2 {
    padding-left: 8px !important;
  }
  :where(.vuetify-styles) .pl-sm-3 {
    padding-left: 12px !important;
  }
  :where(.vuetify-styles) .pl-sm-4 {
    padding-left: 16px !important;
  }
  :where(.vuetify-styles) .pl-sm-5 {
    padding-left: 20px !important;
  }
  :where(.vuetify-styles) .pl-sm-6 {
    padding-left: 24px !important;
  }
  :where(.vuetify-styles) .pl-sm-7 {
    padding-left: 28px !important;
  }
  :where(.vuetify-styles) .pl-sm-8 {
    padding-left: 32px !important;
  }
  :where(.vuetify-styles) .pl-sm-9 {
    padding-left: 36px !important;
  }
  :where(.vuetify-styles) .pl-sm-10 {
    padding-left: 40px !important;
  }
  :where(.vuetify-styles) .pl-sm-11 {
    padding-left: 44px !important;
  }
  :where(.vuetify-styles) .pl-sm-12 {
    padding-left: 48px !important;
  }
  :where(.vuetify-styles) .pl-sm-13 {
    padding-left: 52px !important;
  }
  :where(.vuetify-styles) .pl-sm-14 {
    padding-left: 56px !important;
  }
  :where(.vuetify-styles) .pl-sm-15 {
    padding-left: 60px !important;
  }
  :where(.vuetify-styles) .pl-sm-16 {
    padding-left: 64px !important;
  }
  :where(.vuetify-styles) .ps-sm-0 {
    padding-inline-start: 0px !important;
  }
  :where(.vuetify-styles) .ps-sm-1 {
    padding-inline-start: 4px !important;
  }
  :where(.vuetify-styles) .ps-sm-2 {
    padding-inline-start: 8px !important;
  }
  :where(.vuetify-styles) .ps-sm-3 {
    padding-inline-start: 12px !important;
  }
  :where(.vuetify-styles) .ps-sm-4 {
    padding-inline-start: 16px !important;
  }
  :where(.vuetify-styles) .ps-sm-5 {
    padding-inline-start: 20px !important;
  }
  :where(.vuetify-styles) .ps-sm-6 {
    padding-inline-start: 24px !important;
  }
  :where(.vuetify-styles) .ps-sm-7 {
    padding-inline-start: 28px !important;
  }
  :where(.vuetify-styles) .ps-sm-8 {
    padding-inline-start: 32px !important;
  }
  :where(.vuetify-styles) .ps-sm-9 {
    padding-inline-start: 36px !important;
  }
  :where(.vuetify-styles) .ps-sm-10 {
    padding-inline-start: 40px !important;
  }
  :where(.vuetify-styles) .ps-sm-11 {
    padding-inline-start: 44px !important;
  }
  :where(.vuetify-styles) .ps-sm-12 {
    padding-inline-start: 48px !important;
  }
  :where(.vuetify-styles) .ps-sm-13 {
    padding-inline-start: 52px !important;
  }
  :where(.vuetify-styles) .ps-sm-14 {
    padding-inline-start: 56px !important;
  }
  :where(.vuetify-styles) .ps-sm-15 {
    padding-inline-start: 60px !important;
  }
  :where(.vuetify-styles) .ps-sm-16 {
    padding-inline-start: 64px !important;
  }
  :where(.vuetify-styles) .pe-sm-0 {
    padding-inline-end: 0px !important;
  }
  :where(.vuetify-styles) .pe-sm-1 {
    padding-inline-end: 4px !important;
  }
  :where(.vuetify-styles) .pe-sm-2 {
    padding-inline-end: 8px !important;
  }
  :where(.vuetify-styles) .pe-sm-3 {
    padding-inline-end: 12px !important;
  }
  :where(.vuetify-styles) .pe-sm-4 {
    padding-inline-end: 16px !important;
  }
  :where(.vuetify-styles) .pe-sm-5 {
    padding-inline-end: 20px !important;
  }
  :where(.vuetify-styles) .pe-sm-6 {
    padding-inline-end: 24px !important;
  }
  :where(.vuetify-styles) .pe-sm-7 {
    padding-inline-end: 28px !important;
  }
  :where(.vuetify-styles) .pe-sm-8 {
    padding-inline-end: 32px !important;
  }
  :where(.vuetify-styles) .pe-sm-9 {
    padding-inline-end: 36px !important;
  }
  :where(.vuetify-styles) .pe-sm-10 {
    padding-inline-end: 40px !important;
  }
  :where(.vuetify-styles) .pe-sm-11 {
    padding-inline-end: 44px !important;
  }
  :where(.vuetify-styles) .pe-sm-12 {
    padding-inline-end: 48px !important;
  }
  :where(.vuetify-styles) .pe-sm-13 {
    padding-inline-end: 52px !important;
  }
  :where(.vuetify-styles) .pe-sm-14 {
    padding-inline-end: 56px !important;
  }
  :where(.vuetify-styles) .pe-sm-15 {
    padding-inline-end: 60px !important;
  }
  :where(.vuetify-styles) .pe-sm-16 {
    padding-inline-end: 64px !important;
  }
  :where(.vuetify-styles) .text-sm-left {
    text-align: left !important;
  }
  :where(.vuetify-styles) .text-sm-right {
    text-align: right !important;
  }
  :where(.vuetify-styles) .text-sm-center {
    text-align: center !important;
  }
  :where(.vuetify-styles) .text-sm-justify {
    text-align: justify !important;
  }
  :where(.vuetify-styles) .text-sm-start {
    text-align: start !important;
  }
  :where(.vuetify-styles) .text-sm-end {
    text-align: end !important;
  }
  :where(.vuetify-styles) .text-sm-h1 {
    font-size: 6rem !important;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.015625em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-sm-h2 {
    font-size: 3.75rem !important;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.0083333333em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-sm-h3 {
    font-size: 3rem !important;
    font-weight: 400;
    line-height: 1.05;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-sm-h4 {
    font-size: 2.125rem !important;
    font-weight: 400;
    line-height: 1.175;
    letter-spacing: 0.0073529412em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-sm-h5 {
    font-size: 1.5rem !important;
    font-weight: 400;
    line-height: 1.333;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-sm-h6 {
    font-size: 1.25rem !important;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: 0.0125em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-sm-subtitle-1 {
    font-size: 1rem !important;
    font-weight: normal;
    line-height: 1.75;
    letter-spacing: 0.009375em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-sm-subtitle-2 {
    font-size: 0.875rem !important;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: 0.0071428571em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-sm-body-1 {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.03125em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-sm-body-2 {
    font-size: 0.875rem !important;
    font-weight: 400;
    line-height: 1.425;
    letter-spacing: 0.0178571429em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-sm-button {
    font-size: 0.875rem !important;
    font-weight: 500;
    line-height: 2.6;
    letter-spacing: 0.0892857143em !important;
    font-family: "Roboto", sans-serif;
    text-transform: uppercase !important;
  }
  :where(.vuetify-styles) .text-sm-caption {
    font-size: 0.75rem !important;
    font-weight: 400;
    line-height: 1.667;
    letter-spacing: 0.0333333333em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-sm-overline {
    font-size: 0.75rem !important;
    font-weight: 500;
    line-height: 2.667;
    letter-spacing: 0.1666666667em !important;
    font-family: "Roboto", sans-serif;
    text-transform: uppercase !important;
  }
  :where(.vuetify-styles) .h-sm-auto {
    height: auto !important;
  }
  :where(.vuetify-styles) .h-sm-screen {
    height: 100vh !important;
  }
  :where(.vuetify-styles) .h-sm-0 {
    height: 0 !important;
  }
  :where(.vuetify-styles) .h-sm-25 {
    height: 25% !important;
  }
  :where(.vuetify-styles) .h-sm-50 {
    height: 50% !important;
  }
  :where(.vuetify-styles) .h-sm-75 {
    height: 75% !important;
  }
  :where(.vuetify-styles) .h-sm-100 {
    height: 100% !important;
  }
  :where(.vuetify-styles) .w-sm-auto {
    width: auto !important;
  }
  :where(.vuetify-styles) .w-sm-0 {
    width: 0 !important;
  }
  :where(.vuetify-styles) .w-sm-25 {
    width: 25% !important;
  }
  :where(.vuetify-styles) .w-sm-33 {
    width: 33% !important;
  }
  :where(.vuetify-styles) .w-sm-50 {
    width: 50% !important;
  }
  :where(.vuetify-styles) .w-sm-66 {
    width: 66% !important;
  }
  :where(.vuetify-styles) .w-sm-75 {
    width: 75% !important;
  }
  :where(.vuetify-styles) .w-sm-100 {
    width: 100% !important;
  }
}
@media (min-width: 960px) {
  :where(.vuetify-styles) .d-md-none {
    display: none !important;
  }
  :where(.vuetify-styles) .d-md-inline {
    display: inline !important;
  }
  :where(.vuetify-styles) .d-md-inline-block {
    display: inline-block !important;
  }
  :where(.vuetify-styles) .d-md-block {
    display: block !important;
  }
  :where(.vuetify-styles) .d-md-table {
    display: table !important;
  }
  :where(.vuetify-styles) .d-md-table-row {
    display: table-row !important;
  }
  :where(.vuetify-styles) .d-md-table-cell {
    display: table-cell !important;
  }
  :where(.vuetify-styles) .d-md-flex {
    display: flex !important;
  }
  :where(.vuetify-styles) .d-md-inline-flex {
    display: inline-flex !important;
  }
  :where(.vuetify-styles) .float-md-none {
    float: none !important;
  }
  :where(.vuetify-styles) .float-md-left {
    float: left !important;
  }
  :where(.vuetify-styles) .float-md-right {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-rtl .float-md-end {
    float: left !important;
  }
  :where(.vuetify-styles) .v-locale--is-rtl .float-md-start {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-ltr .float-md-end {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-ltr .float-md-start {
    float: left !important;
  }
  :where(.vuetify-styles) .flex-md-fill {
    flex: 1 1 auto !important;
  }
  :where(.vuetify-styles) .flex-md-1-1 {
    flex: 1 1 auto !important;
  }
  :where(.vuetify-styles) .flex-md-1-0 {
    flex: 1 0 auto !important;
  }
  :where(.vuetify-styles) .flex-md-0-1 {
    flex: 0 1 auto !important;
  }
  :where(.vuetify-styles) .flex-md-0-0 {
    flex: 0 0 auto !important;
  }
  :where(.vuetify-styles) .flex-md-1-1-100 {
    flex: 1 1 100% !important;
  }
  :where(.vuetify-styles) .flex-md-1-0-100 {
    flex: 1 0 100% !important;
  }
  :where(.vuetify-styles) .flex-md-0-1-100 {
    flex: 0 1 100% !important;
  }
  :where(.vuetify-styles) .flex-md-0-0-100 {
    flex: 0 0 100% !important;
  }
  :where(.vuetify-styles) .flex-md-1-1-0 {
    flex: 1 1 0 !important;
  }
  :where(.vuetify-styles) .flex-md-1-0-0 {
    flex: 1 0 0 !important;
  }
  :where(.vuetify-styles) .flex-md-0-1-0 {
    flex: 0 1 0 !important;
  }
  :where(.vuetify-styles) .flex-md-0-0-0 {
    flex: 0 0 0 !important;
  }
  :where(.vuetify-styles) .flex-md-row {
    flex-direction: row !important;
  }
  :where(.vuetify-styles) .flex-md-column {
    flex-direction: column !important;
  }
  :where(.vuetify-styles) .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  :where(.vuetify-styles) .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  :where(.vuetify-styles) .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  :where(.vuetify-styles) .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  :where(.vuetify-styles) .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  :where(.vuetify-styles) .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  :where(.vuetify-styles) .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  :where(.vuetify-styles) .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  :where(.vuetify-styles) .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :where(.vuetify-styles) .justify-md-start {
    justify-content: flex-start !important;
  }
  :where(.vuetify-styles) .justify-md-end {
    justify-content: flex-end !important;
  }
  :where(.vuetify-styles) .justify-md-center {
    justify-content: center !important;
  }
  :where(.vuetify-styles) .justify-md-space-between {
    justify-content: space-between !important;
  }
  :where(.vuetify-styles) .justify-md-space-around {
    justify-content: space-around !important;
  }
  :where(.vuetify-styles) .justify-md-space-evenly {
    justify-content: space-evenly !important;
  }
  :where(.vuetify-styles) .justify-items-md-start {
    justify-items: flex-start !important;
  }
  :where(.vuetify-styles) .justify-items-md-end {
    justify-items: flex-end !important;
  }
  :where(.vuetify-styles) .justify-items-md-center {
    justify-items: center !important;
  }
  :where(.vuetify-styles) .justify-items-md-stretch {
    justify-items: stretch !important;
  }
  :where(.vuetify-styles) .align-md-start {
    align-items: flex-start !important;
  }
  :where(.vuetify-styles) .align-md-end {
    align-items: flex-end !important;
  }
  :where(.vuetify-styles) .align-md-center {
    align-items: center !important;
  }
  :where(.vuetify-styles) .align-md-baseline {
    align-items: baseline !important;
  }
  :where(.vuetify-styles) .align-md-stretch {
    align-items: stretch !important;
  }
  :where(.vuetify-styles) .align-content-md-start {
    align-content: flex-start !important;
  }
  :where(.vuetify-styles) .align-content-md-end {
    align-content: flex-end !important;
  }
  :where(.vuetify-styles) .align-content-md-center {
    align-content: center !important;
  }
  :where(.vuetify-styles) .align-content-md-space-between {
    align-content: space-between !important;
  }
  :where(.vuetify-styles) .align-content-md-space-around {
    align-content: space-around !important;
  }
  :where(.vuetify-styles) .align-content-md-space-evenly {
    align-content: space-evenly !important;
  }
  :where(.vuetify-styles) .align-content-md-stretch {
    align-content: stretch !important;
  }
  :where(.vuetify-styles) .align-self-md-auto {
    align-self: auto !important;
  }
  :where(.vuetify-styles) .align-self-md-start {
    align-self: flex-start !important;
  }
  :where(.vuetify-styles) .align-self-md-end {
    align-self: flex-end !important;
  }
  :where(.vuetify-styles) .align-self-md-center {
    align-self: center !important;
  }
  :where(.vuetify-styles) .align-self-md-baseline {
    align-self: baseline !important;
  }
  :where(.vuetify-styles) .align-self-md-stretch {
    align-self: stretch !important;
  }
  :where(.vuetify-styles) .order-md-first {
    order: -1 !important;
  }
  :where(.vuetify-styles) .order-md-0 {
    order: 0 !important;
  }
  :where(.vuetify-styles) .order-md-1 {
    order: 1 !important;
  }
  :where(.vuetify-styles) .order-md-2 {
    order: 2 !important;
  }
  :where(.vuetify-styles) .order-md-3 {
    order: 3 !important;
  }
  :where(.vuetify-styles) .order-md-4 {
    order: 4 !important;
  }
  :where(.vuetify-styles) .order-md-5 {
    order: 5 !important;
  }
  :where(.vuetify-styles) .order-md-6 {
    order: 6 !important;
  }
  :where(.vuetify-styles) .order-md-7 {
    order: 7 !important;
  }
  :where(.vuetify-styles) .order-md-8 {
    order: 8 !important;
  }
  :where(.vuetify-styles) .order-md-9 {
    order: 9 !important;
  }
  :where(.vuetify-styles) .order-md-10 {
    order: 10 !important;
  }
  :where(.vuetify-styles) .order-md-11 {
    order: 11 !important;
  }
  :where(.vuetify-styles) .order-md-12 {
    order: 12 !important;
  }
  :where(.vuetify-styles) .order-md-last {
    order: 13 !important;
  }
  :where(.vuetify-styles) .ga-md-0 {
    gap: 0px !important;
  }
  :where(.vuetify-styles) .ga-md-1 {
    gap: 4px !important;
  }
  :where(.vuetify-styles) .ga-md-2 {
    gap: 8px !important;
  }
  :where(.vuetify-styles) .ga-md-3 {
    gap: 12px !important;
  }
  :where(.vuetify-styles) .ga-md-4 {
    gap: 16px !important;
  }
  :where(.vuetify-styles) .ga-md-5 {
    gap: 20px !important;
  }
  :where(.vuetify-styles) .ga-md-6 {
    gap: 24px !important;
  }
  :where(.vuetify-styles) .ga-md-7 {
    gap: 28px !important;
  }
  :where(.vuetify-styles) .ga-md-8 {
    gap: 32px !important;
  }
  :where(.vuetify-styles) .ga-md-9 {
    gap: 36px !important;
  }
  :where(.vuetify-styles) .ga-md-10 {
    gap: 40px !important;
  }
  :where(.vuetify-styles) .ga-md-11 {
    gap: 44px !important;
  }
  :where(.vuetify-styles) .ga-md-12 {
    gap: 48px !important;
  }
  :where(.vuetify-styles) .ga-md-13 {
    gap: 52px !important;
  }
  :where(.vuetify-styles) .ga-md-14 {
    gap: 56px !important;
  }
  :where(.vuetify-styles) .ga-md-15 {
    gap: 60px !important;
  }
  :where(.vuetify-styles) .ga-md-16 {
    gap: 64px !important;
  }
  :where(.vuetify-styles) .ga-md-auto {
    gap: auto !important;
  }
  :where(.vuetify-styles) .gr-md-0 {
    row-gap: 0px !important;
  }
  :where(.vuetify-styles) .gr-md-1 {
    row-gap: 4px !important;
  }
  :where(.vuetify-styles) .gr-md-2 {
    row-gap: 8px !important;
  }
  :where(.vuetify-styles) .gr-md-3 {
    row-gap: 12px !important;
  }
  :where(.vuetify-styles) .gr-md-4 {
    row-gap: 16px !important;
  }
  :where(.vuetify-styles) .gr-md-5 {
    row-gap: 20px !important;
  }
  :where(.vuetify-styles) .gr-md-6 {
    row-gap: 24px !important;
  }
  :where(.vuetify-styles) .gr-md-7 {
    row-gap: 28px !important;
  }
  :where(.vuetify-styles) .gr-md-8 {
    row-gap: 32px !important;
  }
  :where(.vuetify-styles) .gr-md-9 {
    row-gap: 36px !important;
  }
  :where(.vuetify-styles) .gr-md-10 {
    row-gap: 40px !important;
  }
  :where(.vuetify-styles) .gr-md-11 {
    row-gap: 44px !important;
  }
  :where(.vuetify-styles) .gr-md-12 {
    row-gap: 48px !important;
  }
  :where(.vuetify-styles) .gr-md-13 {
    row-gap: 52px !important;
  }
  :where(.vuetify-styles) .gr-md-14 {
    row-gap: 56px !important;
  }
  :where(.vuetify-styles) .gr-md-15 {
    row-gap: 60px !important;
  }
  :where(.vuetify-styles) .gr-md-16 {
    row-gap: 64px !important;
  }
  :where(.vuetify-styles) .gr-md-auto {
    row-gap: auto !important;
  }
  :where(.vuetify-styles) .gc-md-0 {
    column-gap: 0px !important;
  }
  :where(.vuetify-styles) .gc-md-1 {
    column-gap: 4px !important;
  }
  :where(.vuetify-styles) .gc-md-2 {
    column-gap: 8px !important;
  }
  :where(.vuetify-styles) .gc-md-3 {
    column-gap: 12px !important;
  }
  :where(.vuetify-styles) .gc-md-4 {
    column-gap: 16px !important;
  }
  :where(.vuetify-styles) .gc-md-5 {
    column-gap: 20px !important;
  }
  :where(.vuetify-styles) .gc-md-6 {
    column-gap: 24px !important;
  }
  :where(.vuetify-styles) .gc-md-7 {
    column-gap: 28px !important;
  }
  :where(.vuetify-styles) .gc-md-8 {
    column-gap: 32px !important;
  }
  :where(.vuetify-styles) .gc-md-9 {
    column-gap: 36px !important;
  }
  :where(.vuetify-styles) .gc-md-10 {
    column-gap: 40px !important;
  }
  :where(.vuetify-styles) .gc-md-11 {
    column-gap: 44px !important;
  }
  :where(.vuetify-styles) .gc-md-12 {
    column-gap: 48px !important;
  }
  :where(.vuetify-styles) .gc-md-13 {
    column-gap: 52px !important;
  }
  :where(.vuetify-styles) .gc-md-14 {
    column-gap: 56px !important;
  }
  :where(.vuetify-styles) .gc-md-15 {
    column-gap: 60px !important;
  }
  :where(.vuetify-styles) .gc-md-16 {
    column-gap: 64px !important;
  }
  :where(.vuetify-styles) .gc-md-auto {
    column-gap: auto !important;
  }
  :where(.vuetify-styles) .ma-md-0 {
    margin: 0px !important;
  }
  :where(.vuetify-styles) .ma-md-1 {
    margin: 4px !important;
  }
  :where(.vuetify-styles) .ma-md-2 {
    margin: 8px !important;
  }
  :where(.vuetify-styles) .ma-md-3 {
    margin: 12px !important;
  }
  :where(.vuetify-styles) .ma-md-4 {
    margin: 16px !important;
  }
  :where(.vuetify-styles) .ma-md-5 {
    margin: 20px !important;
  }
  :where(.vuetify-styles) .ma-md-6 {
    margin: 24px !important;
  }
  :where(.vuetify-styles) .ma-md-7 {
    margin: 28px !important;
  }
  :where(.vuetify-styles) .ma-md-8 {
    margin: 32px !important;
  }
  :where(.vuetify-styles) .ma-md-9 {
    margin: 36px !important;
  }
  :where(.vuetify-styles) .ma-md-10 {
    margin: 40px !important;
  }
  :where(.vuetify-styles) .ma-md-11 {
    margin: 44px !important;
  }
  :where(.vuetify-styles) .ma-md-12 {
    margin: 48px !important;
  }
  :where(.vuetify-styles) .ma-md-13 {
    margin: 52px !important;
  }
  :where(.vuetify-styles) .ma-md-14 {
    margin: 56px !important;
  }
  :where(.vuetify-styles) .ma-md-15 {
    margin: 60px !important;
  }
  :where(.vuetify-styles) .ma-md-16 {
    margin: 64px !important;
  }
  :where(.vuetify-styles) .ma-md-auto {
    margin: auto !important;
  }
  :where(.vuetify-styles) .mx-md-0 {
    margin-right: 0px !important;
    margin-left: 0px !important;
  }
  :where(.vuetify-styles) .mx-md-1 {
    margin-right: 4px !important;
    margin-left: 4px !important;
  }
  :where(.vuetify-styles) .mx-md-2 {
    margin-right: 8px !important;
    margin-left: 8px !important;
  }
  :where(.vuetify-styles) .mx-md-3 {
    margin-right: 12px !important;
    margin-left: 12px !important;
  }
  :where(.vuetify-styles) .mx-md-4 {
    margin-right: 16px !important;
    margin-left: 16px !important;
  }
  :where(.vuetify-styles) .mx-md-5 {
    margin-right: 20px !important;
    margin-left: 20px !important;
  }
  :where(.vuetify-styles) .mx-md-6 {
    margin-right: 24px !important;
    margin-left: 24px !important;
  }
  :where(.vuetify-styles) .mx-md-7 {
    margin-right: 28px !important;
    margin-left: 28px !important;
  }
  :where(.vuetify-styles) .mx-md-8 {
    margin-right: 32px !important;
    margin-left: 32px !important;
  }
  :where(.vuetify-styles) .mx-md-9 {
    margin-right: 36px !important;
    margin-left: 36px !important;
  }
  :where(.vuetify-styles) .mx-md-10 {
    margin-right: 40px !important;
    margin-left: 40px !important;
  }
  :where(.vuetify-styles) .mx-md-11 {
    margin-right: 44px !important;
    margin-left: 44px !important;
  }
  :where(.vuetify-styles) .mx-md-12 {
    margin-right: 48px !important;
    margin-left: 48px !important;
  }
  :where(.vuetify-styles) .mx-md-13 {
    margin-right: 52px !important;
    margin-left: 52px !important;
  }
  :where(.vuetify-styles) .mx-md-14 {
    margin-right: 56px !important;
    margin-left: 56px !important;
  }
  :where(.vuetify-styles) .mx-md-15 {
    margin-right: 60px !important;
    margin-left: 60px !important;
  }
  :where(.vuetify-styles) .mx-md-16 {
    margin-right: 64px !important;
    margin-left: 64px !important;
  }
  :where(.vuetify-styles) .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  :where(.vuetify-styles) .my-md-0 {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  :where(.vuetify-styles) .my-md-1 {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }
  :where(.vuetify-styles) .my-md-2 {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }
  :where(.vuetify-styles) .my-md-3 {
    margin-top: 12px !important;
    margin-bottom: 12px !important;
  }
  :where(.vuetify-styles) .my-md-4 {
    margin-top: 16px !important;
    margin-bottom: 16px !important;
  }
  :where(.vuetify-styles) .my-md-5 {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  :where(.vuetify-styles) .my-md-6 {
    margin-top: 24px !important;
    margin-bottom: 24px !important;
  }
  :where(.vuetify-styles) .my-md-7 {
    margin-top: 28px !important;
    margin-bottom: 28px !important;
  }
  :where(.vuetify-styles) .my-md-8 {
    margin-top: 32px !important;
    margin-bottom: 32px !important;
  }
  :where(.vuetify-styles) .my-md-9 {
    margin-top: 36px !important;
    margin-bottom: 36px !important;
  }
  :where(.vuetify-styles) .my-md-10 {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  :where(.vuetify-styles) .my-md-11 {
    margin-top: 44px !important;
    margin-bottom: 44px !important;
  }
  :where(.vuetify-styles) .my-md-12 {
    margin-top: 48px !important;
    margin-bottom: 48px !important;
  }
  :where(.vuetify-styles) .my-md-13 {
    margin-top: 52px !important;
    margin-bottom: 52px !important;
  }
  :where(.vuetify-styles) .my-md-14 {
    margin-top: 56px !important;
    margin-bottom: 56px !important;
  }
  :where(.vuetify-styles) .my-md-15 {
    margin-top: 60px !important;
    margin-bottom: 60px !important;
  }
  :where(.vuetify-styles) .my-md-16 {
    margin-top: 64px !important;
    margin-bottom: 64px !important;
  }
  :where(.vuetify-styles) .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  :where(.vuetify-styles) .mt-md-0 {
    margin-top: 0px !important;
  }
  :where(.vuetify-styles) .mt-md-1 {
    margin-top: 4px !important;
  }
  :where(.vuetify-styles) .mt-md-2 {
    margin-top: 8px !important;
  }
  :where(.vuetify-styles) .mt-md-3 {
    margin-top: 12px !important;
  }
  :where(.vuetify-styles) .mt-md-4 {
    margin-top: 16px !important;
  }
  :where(.vuetify-styles) .mt-md-5 {
    margin-top: 20px !important;
  }
  :where(.vuetify-styles) .mt-md-6 {
    margin-top: 24px !important;
  }
  :where(.vuetify-styles) .mt-md-7 {
    margin-top: 28px !important;
  }
  :where(.vuetify-styles) .mt-md-8 {
    margin-top: 32px !important;
  }
  :where(.vuetify-styles) .mt-md-9 {
    margin-top: 36px !important;
  }
  :where(.vuetify-styles) .mt-md-10 {
    margin-top: 40px !important;
  }
  :where(.vuetify-styles) .mt-md-11 {
    margin-top: 44px !important;
  }
  :where(.vuetify-styles) .mt-md-12 {
    margin-top: 48px !important;
  }
  :where(.vuetify-styles) .mt-md-13 {
    margin-top: 52px !important;
  }
  :where(.vuetify-styles) .mt-md-14 {
    margin-top: 56px !important;
  }
  :where(.vuetify-styles) .mt-md-15 {
    margin-top: 60px !important;
  }
  :where(.vuetify-styles) .mt-md-16 {
    margin-top: 64px !important;
  }
  :where(.vuetify-styles) .mt-md-auto {
    margin-top: auto !important;
  }
  :where(.vuetify-styles) .mr-md-0 {
    margin-right: 0px !important;
  }
  :where(.vuetify-styles) .mr-md-1 {
    margin-right: 4px !important;
  }
  :where(.vuetify-styles) .mr-md-2 {
    margin-right: 8px !important;
  }
  :where(.vuetify-styles) .mr-md-3 {
    margin-right: 12px !important;
  }
  :where(.vuetify-styles) .mr-md-4 {
    margin-right: 16px !important;
  }
  :where(.vuetify-styles) .mr-md-5 {
    margin-right: 20px !important;
  }
  :where(.vuetify-styles) .mr-md-6 {
    margin-right: 24px !important;
  }
  :where(.vuetify-styles) .mr-md-7 {
    margin-right: 28px !important;
  }
  :where(.vuetify-styles) .mr-md-8 {
    margin-right: 32px !important;
  }
  :where(.vuetify-styles) .mr-md-9 {
    margin-right: 36px !important;
  }
  :where(.vuetify-styles) .mr-md-10 {
    margin-right: 40px !important;
  }
  :where(.vuetify-styles) .mr-md-11 {
    margin-right: 44px !important;
  }
  :where(.vuetify-styles) .mr-md-12 {
    margin-right: 48px !important;
  }
  :where(.vuetify-styles) .mr-md-13 {
    margin-right: 52px !important;
  }
  :where(.vuetify-styles) .mr-md-14 {
    margin-right: 56px !important;
  }
  :where(.vuetify-styles) .mr-md-15 {
    margin-right: 60px !important;
  }
  :where(.vuetify-styles) .mr-md-16 {
    margin-right: 64px !important;
  }
  :where(.vuetify-styles) .mr-md-auto {
    margin-right: auto !important;
  }
  :where(.vuetify-styles) .mb-md-0 {
    margin-bottom: 0px !important;
  }
  :where(.vuetify-styles) .mb-md-1 {
    margin-bottom: 4px !important;
  }
  :where(.vuetify-styles) .mb-md-2 {
    margin-bottom: 8px !important;
  }
  :where(.vuetify-styles) .mb-md-3 {
    margin-bottom: 12px !important;
  }
  :where(.vuetify-styles) .mb-md-4 {
    margin-bottom: 16px !important;
  }
  :where(.vuetify-styles) .mb-md-5 {
    margin-bottom: 20px !important;
  }
  :where(.vuetify-styles) .mb-md-6 {
    margin-bottom: 24px !important;
  }
  :where(.vuetify-styles) .mb-md-7 {
    margin-bottom: 28px !important;
  }
  :where(.vuetify-styles) .mb-md-8 {
    margin-bottom: 32px !important;
  }
  :where(.vuetify-styles) .mb-md-9 {
    margin-bottom: 36px !important;
  }
  :where(.vuetify-styles) .mb-md-10 {
    margin-bottom: 40px !important;
  }
  :where(.vuetify-styles) .mb-md-11 {
    margin-bottom: 44px !important;
  }
  :where(.vuetify-styles) .mb-md-12 {
    margin-bottom: 48px !important;
  }
  :where(.vuetify-styles) .mb-md-13 {
    margin-bottom: 52px !important;
  }
  :where(.vuetify-styles) .mb-md-14 {
    margin-bottom: 56px !important;
  }
  :where(.vuetify-styles) .mb-md-15 {
    margin-bottom: 60px !important;
  }
  :where(.vuetify-styles) .mb-md-16 {
    margin-bottom: 64px !important;
  }
  :where(.vuetify-styles) .mb-md-auto {
    margin-bottom: auto !important;
  }
  :where(.vuetify-styles) .ml-md-0 {
    margin-left: 0px !important;
  }
  :where(.vuetify-styles) .ml-md-1 {
    margin-left: 4px !important;
  }
  :where(.vuetify-styles) .ml-md-2 {
    margin-left: 8px !important;
  }
  :where(.vuetify-styles) .ml-md-3 {
    margin-left: 12px !important;
  }
  :where(.vuetify-styles) .ml-md-4 {
    margin-left: 16px !important;
  }
  :where(.vuetify-styles) .ml-md-5 {
    margin-left: 20px !important;
  }
  :where(.vuetify-styles) .ml-md-6 {
    margin-left: 24px !important;
  }
  :where(.vuetify-styles) .ml-md-7 {
    margin-left: 28px !important;
  }
  :where(.vuetify-styles) .ml-md-8 {
    margin-left: 32px !important;
  }
  :where(.vuetify-styles) .ml-md-9 {
    margin-left: 36px !important;
  }
  :where(.vuetify-styles) .ml-md-10 {
    margin-left: 40px !important;
  }
  :where(.vuetify-styles) .ml-md-11 {
    margin-left: 44px !important;
  }
  :where(.vuetify-styles) .ml-md-12 {
    margin-left: 48px !important;
  }
  :where(.vuetify-styles) .ml-md-13 {
    margin-left: 52px !important;
  }
  :where(.vuetify-styles) .ml-md-14 {
    margin-left: 56px !important;
  }
  :where(.vuetify-styles) .ml-md-15 {
    margin-left: 60px !important;
  }
  :where(.vuetify-styles) .ml-md-16 {
    margin-left: 64px !important;
  }
  :where(.vuetify-styles) .ml-md-auto {
    margin-left: auto !important;
  }
  :where(.vuetify-styles) .ms-md-0 {
    margin-inline-start: 0px !important;
  }
  :where(.vuetify-styles) .ms-md-1 {
    margin-inline-start: 4px !important;
  }
  :where(.vuetify-styles) .ms-md-2 {
    margin-inline-start: 8px !important;
  }
  :where(.vuetify-styles) .ms-md-3 {
    margin-inline-start: 12px !important;
  }
  :where(.vuetify-styles) .ms-md-4 {
    margin-inline-start: 16px !important;
  }
  :where(.vuetify-styles) .ms-md-5 {
    margin-inline-start: 20px !important;
  }
  :where(.vuetify-styles) .ms-md-6 {
    margin-inline-start: 24px !important;
  }
  :where(.vuetify-styles) .ms-md-7 {
    margin-inline-start: 28px !important;
  }
  :where(.vuetify-styles) .ms-md-8 {
    margin-inline-start: 32px !important;
  }
  :where(.vuetify-styles) .ms-md-9 {
    margin-inline-start: 36px !important;
  }
  :where(.vuetify-styles) .ms-md-10 {
    margin-inline-start: 40px !important;
  }
  :where(.vuetify-styles) .ms-md-11 {
    margin-inline-start: 44px !important;
  }
  :where(.vuetify-styles) .ms-md-12 {
    margin-inline-start: 48px !important;
  }
  :where(.vuetify-styles) .ms-md-13 {
    margin-inline-start: 52px !important;
  }
  :where(.vuetify-styles) .ms-md-14 {
    margin-inline-start: 56px !important;
  }
  :where(.vuetify-styles) .ms-md-15 {
    margin-inline-start: 60px !important;
  }
  :where(.vuetify-styles) .ms-md-16 {
    margin-inline-start: 64px !important;
  }
  :where(.vuetify-styles) .ms-md-auto {
    margin-inline-start: auto !important;
  }
  :where(.vuetify-styles) .me-md-0 {
    margin-inline-end: 0px !important;
  }
  :where(.vuetify-styles) .me-md-1 {
    margin-inline-end: 4px !important;
  }
  :where(.vuetify-styles) .me-md-2 {
    margin-inline-end: 8px !important;
  }
  :where(.vuetify-styles) .me-md-3 {
    margin-inline-end: 12px !important;
  }
  :where(.vuetify-styles) .me-md-4 {
    margin-inline-end: 16px !important;
  }
  :where(.vuetify-styles) .me-md-5 {
    margin-inline-end: 20px !important;
  }
  :where(.vuetify-styles) .me-md-6 {
    margin-inline-end: 24px !important;
  }
  :where(.vuetify-styles) .me-md-7 {
    margin-inline-end: 28px !important;
  }
  :where(.vuetify-styles) .me-md-8 {
    margin-inline-end: 32px !important;
  }
  :where(.vuetify-styles) .me-md-9 {
    margin-inline-end: 36px !important;
  }
  :where(.vuetify-styles) .me-md-10 {
    margin-inline-end: 40px !important;
  }
  :where(.vuetify-styles) .me-md-11 {
    margin-inline-end: 44px !important;
  }
  :where(.vuetify-styles) .me-md-12 {
    margin-inline-end: 48px !important;
  }
  :where(.vuetify-styles) .me-md-13 {
    margin-inline-end: 52px !important;
  }
  :where(.vuetify-styles) .me-md-14 {
    margin-inline-end: 56px !important;
  }
  :where(.vuetify-styles) .me-md-15 {
    margin-inline-end: 60px !important;
  }
  :where(.vuetify-styles) .me-md-16 {
    margin-inline-end: 64px !important;
  }
  :where(.vuetify-styles) .me-md-auto {
    margin-inline-end: auto !important;
  }
  :where(.vuetify-styles) .ma-md-n1 {
    margin: -4px !important;
  }
  :where(.vuetify-styles) .ma-md-n2 {
    margin: -8px !important;
  }
  :where(.vuetify-styles) .ma-md-n3 {
    margin: -12px !important;
  }
  :where(.vuetify-styles) .ma-md-n4 {
    margin: -16px !important;
  }
  :where(.vuetify-styles) .ma-md-n5 {
    margin: -20px !important;
  }
  :where(.vuetify-styles) .ma-md-n6 {
    margin: -24px !important;
  }
  :where(.vuetify-styles) .ma-md-n7 {
    margin: -28px !important;
  }
  :where(.vuetify-styles) .ma-md-n8 {
    margin: -32px !important;
  }
  :where(.vuetify-styles) .ma-md-n9 {
    margin: -36px !important;
  }
  :where(.vuetify-styles) .ma-md-n10 {
    margin: -40px !important;
  }
  :where(.vuetify-styles) .ma-md-n11 {
    margin: -44px !important;
  }
  :where(.vuetify-styles) .ma-md-n12 {
    margin: -48px !important;
  }
  :where(.vuetify-styles) .ma-md-n13 {
    margin: -52px !important;
  }
  :where(.vuetify-styles) .ma-md-n14 {
    margin: -56px !important;
  }
  :where(.vuetify-styles) .ma-md-n15 {
    margin: -60px !important;
  }
  :where(.vuetify-styles) .ma-md-n16 {
    margin: -64px !important;
  }
  :where(.vuetify-styles) .mx-md-n1 {
    margin-right: -4px !important;
    margin-left: -4px !important;
  }
  :where(.vuetify-styles) .mx-md-n2 {
    margin-right: -8px !important;
    margin-left: -8px !important;
  }
  :where(.vuetify-styles) .mx-md-n3 {
    margin-right: -12px !important;
    margin-left: -12px !important;
  }
  :where(.vuetify-styles) .mx-md-n4 {
    margin-right: -16px !important;
    margin-left: -16px !important;
  }
  :where(.vuetify-styles) .mx-md-n5 {
    margin-right: -20px !important;
    margin-left: -20px !important;
  }
  :where(.vuetify-styles) .mx-md-n6 {
    margin-right: -24px !important;
    margin-left: -24px !important;
  }
  :where(.vuetify-styles) .mx-md-n7 {
    margin-right: -28px !important;
    margin-left: -28px !important;
  }
  :where(.vuetify-styles) .mx-md-n8 {
    margin-right: -32px !important;
    margin-left: -32px !important;
  }
  :where(.vuetify-styles) .mx-md-n9 {
    margin-right: -36px !important;
    margin-left: -36px !important;
  }
  :where(.vuetify-styles) .mx-md-n10 {
    margin-right: -40px !important;
    margin-left: -40px !important;
  }
  :where(.vuetify-styles) .mx-md-n11 {
    margin-right: -44px !important;
    margin-left: -44px !important;
  }
  :where(.vuetify-styles) .mx-md-n12 {
    margin-right: -48px !important;
    margin-left: -48px !important;
  }
  :where(.vuetify-styles) .mx-md-n13 {
    margin-right: -52px !important;
    margin-left: -52px !important;
  }
  :where(.vuetify-styles) .mx-md-n14 {
    margin-right: -56px !important;
    margin-left: -56px !important;
  }
  :where(.vuetify-styles) .mx-md-n15 {
    margin-right: -60px !important;
    margin-left: -60px !important;
  }
  :where(.vuetify-styles) .mx-md-n16 {
    margin-right: -64px !important;
    margin-left: -64px !important;
  }
  :where(.vuetify-styles) .my-md-n1 {
    margin-top: -4px !important;
    margin-bottom: -4px !important;
  }
  :where(.vuetify-styles) .my-md-n2 {
    margin-top: -8px !important;
    margin-bottom: -8px !important;
  }
  :where(.vuetify-styles) .my-md-n3 {
    margin-top: -12px !important;
    margin-bottom: -12px !important;
  }
  :where(.vuetify-styles) .my-md-n4 {
    margin-top: -16px !important;
    margin-bottom: -16px !important;
  }
  :where(.vuetify-styles) .my-md-n5 {
    margin-top: -20px !important;
    margin-bottom: -20px !important;
  }
  :where(.vuetify-styles) .my-md-n6 {
    margin-top: -24px !important;
    margin-bottom: -24px !important;
  }
  :where(.vuetify-styles) .my-md-n7 {
    margin-top: -28px !important;
    margin-bottom: -28px !important;
  }
  :where(.vuetify-styles) .my-md-n8 {
    margin-top: -32px !important;
    margin-bottom: -32px !important;
  }
  :where(.vuetify-styles) .my-md-n9 {
    margin-top: -36px !important;
    margin-bottom: -36px !important;
  }
  :where(.vuetify-styles) .my-md-n10 {
    margin-top: -40px !important;
    margin-bottom: -40px !important;
  }
  :where(.vuetify-styles) .my-md-n11 {
    margin-top: -44px !important;
    margin-bottom: -44px !important;
  }
  :where(.vuetify-styles) .my-md-n12 {
    margin-top: -48px !important;
    margin-bottom: -48px !important;
  }
  :where(.vuetify-styles) .my-md-n13 {
    margin-top: -52px !important;
    margin-bottom: -52px !important;
  }
  :where(.vuetify-styles) .my-md-n14 {
    margin-top: -56px !important;
    margin-bottom: -56px !important;
  }
  :where(.vuetify-styles) .my-md-n15 {
    margin-top: -60px !important;
    margin-bottom: -60px !important;
  }
  :where(.vuetify-styles) .my-md-n16 {
    margin-top: -64px !important;
    margin-bottom: -64px !important;
  }
  :where(.vuetify-styles) .mt-md-n1 {
    margin-top: -4px !important;
  }
  :where(.vuetify-styles) .mt-md-n2 {
    margin-top: -8px !important;
  }
  :where(.vuetify-styles) .mt-md-n3 {
    margin-top: -12px !important;
  }
  :where(.vuetify-styles) .mt-md-n4 {
    margin-top: -16px !important;
  }
  :where(.vuetify-styles) .mt-md-n5 {
    margin-top: -20px !important;
  }
  :where(.vuetify-styles) .mt-md-n6 {
    margin-top: -24px !important;
  }
  :where(.vuetify-styles) .mt-md-n7 {
    margin-top: -28px !important;
  }
  :where(.vuetify-styles) .mt-md-n8 {
    margin-top: -32px !important;
  }
  :where(.vuetify-styles) .mt-md-n9 {
    margin-top: -36px !important;
  }
  :where(.vuetify-styles) .mt-md-n10 {
    margin-top: -40px !important;
  }
  :where(.vuetify-styles) .mt-md-n11 {
    margin-top: -44px !important;
  }
  :where(.vuetify-styles) .mt-md-n12 {
    margin-top: -48px !important;
  }
  :where(.vuetify-styles) .mt-md-n13 {
    margin-top: -52px !important;
  }
  :where(.vuetify-styles) .mt-md-n14 {
    margin-top: -56px !important;
  }
  :where(.vuetify-styles) .mt-md-n15 {
    margin-top: -60px !important;
  }
  :where(.vuetify-styles) .mt-md-n16 {
    margin-top: -64px !important;
  }
  :where(.vuetify-styles) .mr-md-n1 {
    margin-right: -4px !important;
  }
  :where(.vuetify-styles) .mr-md-n2 {
    margin-right: -8px !important;
  }
  :where(.vuetify-styles) .mr-md-n3 {
    margin-right: -12px !important;
  }
  :where(.vuetify-styles) .mr-md-n4 {
    margin-right: -16px !important;
  }
  :where(.vuetify-styles) .mr-md-n5 {
    margin-right: -20px !important;
  }
  :where(.vuetify-styles) .mr-md-n6 {
    margin-right: -24px !important;
  }
  :where(.vuetify-styles) .mr-md-n7 {
    margin-right: -28px !important;
  }
  :where(.vuetify-styles) .mr-md-n8 {
    margin-right: -32px !important;
  }
  :where(.vuetify-styles) .mr-md-n9 {
    margin-right: -36px !important;
  }
  :where(.vuetify-styles) .mr-md-n10 {
    margin-right: -40px !important;
  }
  :where(.vuetify-styles) .mr-md-n11 {
    margin-right: -44px !important;
  }
  :where(.vuetify-styles) .mr-md-n12 {
    margin-right: -48px !important;
  }
  :where(.vuetify-styles) .mr-md-n13 {
    margin-right: -52px !important;
  }
  :where(.vuetify-styles) .mr-md-n14 {
    margin-right: -56px !important;
  }
  :where(.vuetify-styles) .mr-md-n15 {
    margin-right: -60px !important;
  }
  :where(.vuetify-styles) .mr-md-n16 {
    margin-right: -64px !important;
  }
  :where(.vuetify-styles) .mb-md-n1 {
    margin-bottom: -4px !important;
  }
  :where(.vuetify-styles) .mb-md-n2 {
    margin-bottom: -8px !important;
  }
  :where(.vuetify-styles) .mb-md-n3 {
    margin-bottom: -12px !important;
  }
  :where(.vuetify-styles) .mb-md-n4 {
    margin-bottom: -16px !important;
  }
  :where(.vuetify-styles) .mb-md-n5 {
    margin-bottom: -20px !important;
  }
  :where(.vuetify-styles) .mb-md-n6 {
    margin-bottom: -24px !important;
  }
  :where(.vuetify-styles) .mb-md-n7 {
    margin-bottom: -28px !important;
  }
  :where(.vuetify-styles) .mb-md-n8 {
    margin-bottom: -32px !important;
  }
  :where(.vuetify-styles) .mb-md-n9 {
    margin-bottom: -36px !important;
  }
  :where(.vuetify-styles) .mb-md-n10 {
    margin-bottom: -40px !important;
  }
  :where(.vuetify-styles) .mb-md-n11 {
    margin-bottom: -44px !important;
  }
  :where(.vuetify-styles) .mb-md-n12 {
    margin-bottom: -48px !important;
  }
  :where(.vuetify-styles) .mb-md-n13 {
    margin-bottom: -52px !important;
  }
  :where(.vuetify-styles) .mb-md-n14 {
    margin-bottom: -56px !important;
  }
  :where(.vuetify-styles) .mb-md-n15 {
    margin-bottom: -60px !important;
  }
  :where(.vuetify-styles) .mb-md-n16 {
    margin-bottom: -64px !important;
  }
  :where(.vuetify-styles) .ml-md-n1 {
    margin-left: -4px !important;
  }
  :where(.vuetify-styles) .ml-md-n2 {
    margin-left: -8px !important;
  }
  :where(.vuetify-styles) .ml-md-n3 {
    margin-left: -12px !important;
  }
  :where(.vuetify-styles) .ml-md-n4 {
    margin-left: -16px !important;
  }
  :where(.vuetify-styles) .ml-md-n5 {
    margin-left: -20px !important;
  }
  :where(.vuetify-styles) .ml-md-n6 {
    margin-left: -24px !important;
  }
  :where(.vuetify-styles) .ml-md-n7 {
    margin-left: -28px !important;
  }
  :where(.vuetify-styles) .ml-md-n8 {
    margin-left: -32px !important;
  }
  :where(.vuetify-styles) .ml-md-n9 {
    margin-left: -36px !important;
  }
  :where(.vuetify-styles) .ml-md-n10 {
    margin-left: -40px !important;
  }
  :where(.vuetify-styles) .ml-md-n11 {
    margin-left: -44px !important;
  }
  :where(.vuetify-styles) .ml-md-n12 {
    margin-left: -48px !important;
  }
  :where(.vuetify-styles) .ml-md-n13 {
    margin-left: -52px !important;
  }
  :where(.vuetify-styles) .ml-md-n14 {
    margin-left: -56px !important;
  }
  :where(.vuetify-styles) .ml-md-n15 {
    margin-left: -60px !important;
  }
  :where(.vuetify-styles) .ml-md-n16 {
    margin-left: -64px !important;
  }
  :where(.vuetify-styles) .ms-md-n1 {
    margin-inline-start: -4px !important;
  }
  :where(.vuetify-styles) .ms-md-n2 {
    margin-inline-start: -8px !important;
  }
  :where(.vuetify-styles) .ms-md-n3 {
    margin-inline-start: -12px !important;
  }
  :where(.vuetify-styles) .ms-md-n4 {
    margin-inline-start: -16px !important;
  }
  :where(.vuetify-styles) .ms-md-n5 {
    margin-inline-start: -20px !important;
  }
  :where(.vuetify-styles) .ms-md-n6 {
    margin-inline-start: -24px !important;
  }
  :where(.vuetify-styles) .ms-md-n7 {
    margin-inline-start: -28px !important;
  }
  :where(.vuetify-styles) .ms-md-n8 {
    margin-inline-start: -32px !important;
  }
  :where(.vuetify-styles) .ms-md-n9 {
    margin-inline-start: -36px !important;
  }
  :where(.vuetify-styles) .ms-md-n10 {
    margin-inline-start: -40px !important;
  }
  :where(.vuetify-styles) .ms-md-n11 {
    margin-inline-start: -44px !important;
  }
  :where(.vuetify-styles) .ms-md-n12 {
    margin-inline-start: -48px !important;
  }
  :where(.vuetify-styles) .ms-md-n13 {
    margin-inline-start: -52px !important;
  }
  :where(.vuetify-styles) .ms-md-n14 {
    margin-inline-start: -56px !important;
  }
  :where(.vuetify-styles) .ms-md-n15 {
    margin-inline-start: -60px !important;
  }
  :where(.vuetify-styles) .ms-md-n16 {
    margin-inline-start: -64px !important;
  }
  :where(.vuetify-styles) .me-md-n1 {
    margin-inline-end: -4px !important;
  }
  :where(.vuetify-styles) .me-md-n2 {
    margin-inline-end: -8px !important;
  }
  :where(.vuetify-styles) .me-md-n3 {
    margin-inline-end: -12px !important;
  }
  :where(.vuetify-styles) .me-md-n4 {
    margin-inline-end: -16px !important;
  }
  :where(.vuetify-styles) .me-md-n5 {
    margin-inline-end: -20px !important;
  }
  :where(.vuetify-styles) .me-md-n6 {
    margin-inline-end: -24px !important;
  }
  :where(.vuetify-styles) .me-md-n7 {
    margin-inline-end: -28px !important;
  }
  :where(.vuetify-styles) .me-md-n8 {
    margin-inline-end: -32px !important;
  }
  :where(.vuetify-styles) .me-md-n9 {
    margin-inline-end: -36px !important;
  }
  :where(.vuetify-styles) .me-md-n10 {
    margin-inline-end: -40px !important;
  }
  :where(.vuetify-styles) .me-md-n11 {
    margin-inline-end: -44px !important;
  }
  :where(.vuetify-styles) .me-md-n12 {
    margin-inline-end: -48px !important;
  }
  :where(.vuetify-styles) .me-md-n13 {
    margin-inline-end: -52px !important;
  }
  :where(.vuetify-styles) .me-md-n14 {
    margin-inline-end: -56px !important;
  }
  :where(.vuetify-styles) .me-md-n15 {
    margin-inline-end: -60px !important;
  }
  :where(.vuetify-styles) .me-md-n16 {
    margin-inline-end: -64px !important;
  }
  :where(.vuetify-styles) .pa-md-0 {
    padding: 0px !important;
  }
  :where(.vuetify-styles) .pa-md-1 {
    padding: 4px !important;
  }
  :where(.vuetify-styles) .pa-md-2 {
    padding: 8px !important;
  }
  :where(.vuetify-styles) .pa-md-3 {
    padding: 12px !important;
  }
  :where(.vuetify-styles) .pa-md-4 {
    padding: 16px !important;
  }
  :where(.vuetify-styles) .pa-md-5 {
    padding: 20px !important;
  }
  :where(.vuetify-styles) .pa-md-6 {
    padding: 24px !important;
  }
  :where(.vuetify-styles) .pa-md-7 {
    padding: 28px !important;
  }
  :where(.vuetify-styles) .pa-md-8 {
    padding: 32px !important;
  }
  :where(.vuetify-styles) .pa-md-9 {
    padding: 36px !important;
  }
  :where(.vuetify-styles) .pa-md-10 {
    padding: 40px !important;
  }
  :where(.vuetify-styles) .pa-md-11 {
    padding: 44px !important;
  }
  :where(.vuetify-styles) .pa-md-12 {
    padding: 48px !important;
  }
  :where(.vuetify-styles) .pa-md-13 {
    padding: 52px !important;
  }
  :where(.vuetify-styles) .pa-md-14 {
    padding: 56px !important;
  }
  :where(.vuetify-styles) .pa-md-15 {
    padding: 60px !important;
  }
  :where(.vuetify-styles) .pa-md-16 {
    padding: 64px !important;
  }
  :where(.vuetify-styles) .px-md-0 {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  :where(.vuetify-styles) .px-md-1 {
    padding-right: 4px !important;
    padding-left: 4px !important;
  }
  :where(.vuetify-styles) .px-md-2 {
    padding-right: 8px !important;
    padding-left: 8px !important;
  }
  :where(.vuetify-styles) .px-md-3 {
    padding-right: 12px !important;
    padding-left: 12px !important;
  }
  :where(.vuetify-styles) .px-md-4 {
    padding-right: 16px !important;
    padding-left: 16px !important;
  }
  :where(.vuetify-styles) .px-md-5 {
    padding-right: 20px !important;
    padding-left: 20px !important;
  }
  :where(.vuetify-styles) .px-md-6 {
    padding-right: 24px !important;
    padding-left: 24px !important;
  }
  :where(.vuetify-styles) .px-md-7 {
    padding-right: 28px !important;
    padding-left: 28px !important;
  }
  :where(.vuetify-styles) .px-md-8 {
    padding-right: 32px !important;
    padding-left: 32px !important;
  }
  :where(.vuetify-styles) .px-md-9 {
    padding-right: 36px !important;
    padding-left: 36px !important;
  }
  :where(.vuetify-styles) .px-md-10 {
    padding-right: 40px !important;
    padding-left: 40px !important;
  }
  :where(.vuetify-styles) .px-md-11 {
    padding-right: 44px !important;
    padding-left: 44px !important;
  }
  :where(.vuetify-styles) .px-md-12 {
    padding-right: 48px !important;
    padding-left: 48px !important;
  }
  :where(.vuetify-styles) .px-md-13 {
    padding-right: 52px !important;
    padding-left: 52px !important;
  }
  :where(.vuetify-styles) .px-md-14 {
    padding-right: 56px !important;
    padding-left: 56px !important;
  }
  :where(.vuetify-styles) .px-md-15 {
    padding-right: 60px !important;
    padding-left: 60px !important;
  }
  :where(.vuetify-styles) .px-md-16 {
    padding-right: 64px !important;
    padding-left: 64px !important;
  }
  :where(.vuetify-styles) .py-md-0 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  :where(.vuetify-styles) .py-md-1 {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
  :where(.vuetify-styles) .py-md-2 {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  :where(.vuetify-styles) .py-md-3 {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  :where(.vuetify-styles) .py-md-4 {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
  :where(.vuetify-styles) .py-md-5 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  :where(.vuetify-styles) .py-md-6 {
    padding-top: 24px !important;
    padding-bottom: 24px !important;
  }
  :where(.vuetify-styles) .py-md-7 {
    padding-top: 28px !important;
    padding-bottom: 28px !important;
  }
  :where(.vuetify-styles) .py-md-8 {
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }
  :where(.vuetify-styles) .py-md-9 {
    padding-top: 36px !important;
    padding-bottom: 36px !important;
  }
  :where(.vuetify-styles) .py-md-10 {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  :where(.vuetify-styles) .py-md-11 {
    padding-top: 44px !important;
    padding-bottom: 44px !important;
  }
  :where(.vuetify-styles) .py-md-12 {
    padding-top: 48px !important;
    padding-bottom: 48px !important;
  }
  :where(.vuetify-styles) .py-md-13 {
    padding-top: 52px !important;
    padding-bottom: 52px !important;
  }
  :where(.vuetify-styles) .py-md-14 {
    padding-top: 56px !important;
    padding-bottom: 56px !important;
  }
  :where(.vuetify-styles) .py-md-15 {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }
  :where(.vuetify-styles) .py-md-16 {
    padding-top: 64px !important;
    padding-bottom: 64px !important;
  }
  :where(.vuetify-styles) .pt-md-0 {
    padding-top: 0px !important;
  }
  :where(.vuetify-styles) .pt-md-1 {
    padding-top: 4px !important;
  }
  :where(.vuetify-styles) .pt-md-2 {
    padding-top: 8px !important;
  }
  :where(.vuetify-styles) .pt-md-3 {
    padding-top: 12px !important;
  }
  :where(.vuetify-styles) .pt-md-4 {
    padding-top: 16px !important;
  }
  :where(.vuetify-styles) .pt-md-5 {
    padding-top: 20px !important;
  }
  :where(.vuetify-styles) .pt-md-6 {
    padding-top: 24px !important;
  }
  :where(.vuetify-styles) .pt-md-7 {
    padding-top: 28px !important;
  }
  :where(.vuetify-styles) .pt-md-8 {
    padding-top: 32px !important;
  }
  :where(.vuetify-styles) .pt-md-9 {
    padding-top: 36px !important;
  }
  :where(.vuetify-styles) .pt-md-10 {
    padding-top: 40px !important;
  }
  :where(.vuetify-styles) .pt-md-11 {
    padding-top: 44px !important;
  }
  :where(.vuetify-styles) .pt-md-12 {
    padding-top: 48px !important;
  }
  :where(.vuetify-styles) .pt-md-13 {
    padding-top: 52px !important;
  }
  :where(.vuetify-styles) .pt-md-14 {
    padding-top: 56px !important;
  }
  :where(.vuetify-styles) .pt-md-15 {
    padding-top: 60px !important;
  }
  :where(.vuetify-styles) .pt-md-16 {
    padding-top: 64px !important;
  }
  :where(.vuetify-styles) .pr-md-0 {
    padding-right: 0px !important;
  }
  :where(.vuetify-styles) .pr-md-1 {
    padding-right: 4px !important;
  }
  :where(.vuetify-styles) .pr-md-2 {
    padding-right: 8px !important;
  }
  :where(.vuetify-styles) .pr-md-3 {
    padding-right: 12px !important;
  }
  :where(.vuetify-styles) .pr-md-4 {
    padding-right: 16px !important;
  }
  :where(.vuetify-styles) .pr-md-5 {
    padding-right: 20px !important;
  }
  :where(.vuetify-styles) .pr-md-6 {
    padding-right: 24px !important;
  }
  :where(.vuetify-styles) .pr-md-7 {
    padding-right: 28px !important;
  }
  :where(.vuetify-styles) .pr-md-8 {
    padding-right: 32px !important;
  }
  :where(.vuetify-styles) .pr-md-9 {
    padding-right: 36px !important;
  }
  :where(.vuetify-styles) .pr-md-10 {
    padding-right: 40px !important;
  }
  :where(.vuetify-styles) .pr-md-11 {
    padding-right: 44px !important;
  }
  :where(.vuetify-styles) .pr-md-12 {
    padding-right: 48px !important;
  }
  :where(.vuetify-styles) .pr-md-13 {
    padding-right: 52px !important;
  }
  :where(.vuetify-styles) .pr-md-14 {
    padding-right: 56px !important;
  }
  :where(.vuetify-styles) .pr-md-15 {
    padding-right: 60px !important;
  }
  :where(.vuetify-styles) .pr-md-16 {
    padding-right: 64px !important;
  }
  :where(.vuetify-styles) .pb-md-0 {
    padding-bottom: 0px !important;
  }
  :where(.vuetify-styles) .pb-md-1 {
    padding-bottom: 4px !important;
  }
  :where(.vuetify-styles) .pb-md-2 {
    padding-bottom: 8px !important;
  }
  :where(.vuetify-styles) .pb-md-3 {
    padding-bottom: 12px !important;
  }
  :where(.vuetify-styles) .pb-md-4 {
    padding-bottom: 16px !important;
  }
  :where(.vuetify-styles) .pb-md-5 {
    padding-bottom: 20px !important;
  }
  :where(.vuetify-styles) .pb-md-6 {
    padding-bottom: 24px !important;
  }
  :where(.vuetify-styles) .pb-md-7 {
    padding-bottom: 28px !important;
  }
  :where(.vuetify-styles) .pb-md-8 {
    padding-bottom: 32px !important;
  }
  :where(.vuetify-styles) .pb-md-9 {
    padding-bottom: 36px !important;
  }
  :where(.vuetify-styles) .pb-md-10 {
    padding-bottom: 40px !important;
  }
  :where(.vuetify-styles) .pb-md-11 {
    padding-bottom: 44px !important;
  }
  :where(.vuetify-styles) .pb-md-12 {
    padding-bottom: 48px !important;
  }
  :where(.vuetify-styles) .pb-md-13 {
    padding-bottom: 52px !important;
  }
  :where(.vuetify-styles) .pb-md-14 {
    padding-bottom: 56px !important;
  }
  :where(.vuetify-styles) .pb-md-15 {
    padding-bottom: 60px !important;
  }
  :where(.vuetify-styles) .pb-md-16 {
    padding-bottom: 64px !important;
  }
  :where(.vuetify-styles) .pl-md-0 {
    padding-left: 0px !important;
  }
  :where(.vuetify-styles) .pl-md-1 {
    padding-left: 4px !important;
  }
  :where(.vuetify-styles) .pl-md-2 {
    padding-left: 8px !important;
  }
  :where(.vuetify-styles) .pl-md-3 {
    padding-left: 12px !important;
  }
  :where(.vuetify-styles) .pl-md-4 {
    padding-left: 16px !important;
  }
  :where(.vuetify-styles) .pl-md-5 {
    padding-left: 20px !important;
  }
  :where(.vuetify-styles) .pl-md-6 {
    padding-left: 24px !important;
  }
  :where(.vuetify-styles) .pl-md-7 {
    padding-left: 28px !important;
  }
  :where(.vuetify-styles) .pl-md-8 {
    padding-left: 32px !important;
  }
  :where(.vuetify-styles) .pl-md-9 {
    padding-left: 36px !important;
  }
  :where(.vuetify-styles) .pl-md-10 {
    padding-left: 40px !important;
  }
  :where(.vuetify-styles) .pl-md-11 {
    padding-left: 44px !important;
  }
  :where(.vuetify-styles) .pl-md-12 {
    padding-left: 48px !important;
  }
  :where(.vuetify-styles) .pl-md-13 {
    padding-left: 52px !important;
  }
  :where(.vuetify-styles) .pl-md-14 {
    padding-left: 56px !important;
  }
  :where(.vuetify-styles) .pl-md-15 {
    padding-left: 60px !important;
  }
  :where(.vuetify-styles) .pl-md-16 {
    padding-left: 64px !important;
  }
  :where(.vuetify-styles) .ps-md-0 {
    padding-inline-start: 0px !important;
  }
  :where(.vuetify-styles) .ps-md-1 {
    padding-inline-start: 4px !important;
  }
  :where(.vuetify-styles) .ps-md-2 {
    padding-inline-start: 8px !important;
  }
  :where(.vuetify-styles) .ps-md-3 {
    padding-inline-start: 12px !important;
  }
  :where(.vuetify-styles) .ps-md-4 {
    padding-inline-start: 16px !important;
  }
  :where(.vuetify-styles) .ps-md-5 {
    padding-inline-start: 20px !important;
  }
  :where(.vuetify-styles) .ps-md-6 {
    padding-inline-start: 24px !important;
  }
  :where(.vuetify-styles) .ps-md-7 {
    padding-inline-start: 28px !important;
  }
  :where(.vuetify-styles) .ps-md-8 {
    padding-inline-start: 32px !important;
  }
  :where(.vuetify-styles) .ps-md-9 {
    padding-inline-start: 36px !important;
  }
  :where(.vuetify-styles) .ps-md-10 {
    padding-inline-start: 40px !important;
  }
  :where(.vuetify-styles) .ps-md-11 {
    padding-inline-start: 44px !important;
  }
  :where(.vuetify-styles) .ps-md-12 {
    padding-inline-start: 48px !important;
  }
  :where(.vuetify-styles) .ps-md-13 {
    padding-inline-start: 52px !important;
  }
  :where(.vuetify-styles) .ps-md-14 {
    padding-inline-start: 56px !important;
  }
  :where(.vuetify-styles) .ps-md-15 {
    padding-inline-start: 60px !important;
  }
  :where(.vuetify-styles) .ps-md-16 {
    padding-inline-start: 64px !important;
  }
  :where(.vuetify-styles) .pe-md-0 {
    padding-inline-end: 0px !important;
  }
  :where(.vuetify-styles) .pe-md-1 {
    padding-inline-end: 4px !important;
  }
  :where(.vuetify-styles) .pe-md-2 {
    padding-inline-end: 8px !important;
  }
  :where(.vuetify-styles) .pe-md-3 {
    padding-inline-end: 12px !important;
  }
  :where(.vuetify-styles) .pe-md-4 {
    padding-inline-end: 16px !important;
  }
  :where(.vuetify-styles) .pe-md-5 {
    padding-inline-end: 20px !important;
  }
  :where(.vuetify-styles) .pe-md-6 {
    padding-inline-end: 24px !important;
  }
  :where(.vuetify-styles) .pe-md-7 {
    padding-inline-end: 28px !important;
  }
  :where(.vuetify-styles) .pe-md-8 {
    padding-inline-end: 32px !important;
  }
  :where(.vuetify-styles) .pe-md-9 {
    padding-inline-end: 36px !important;
  }
  :where(.vuetify-styles) .pe-md-10 {
    padding-inline-end: 40px !important;
  }
  :where(.vuetify-styles) .pe-md-11 {
    padding-inline-end: 44px !important;
  }
  :where(.vuetify-styles) .pe-md-12 {
    padding-inline-end: 48px !important;
  }
  :where(.vuetify-styles) .pe-md-13 {
    padding-inline-end: 52px !important;
  }
  :where(.vuetify-styles) .pe-md-14 {
    padding-inline-end: 56px !important;
  }
  :where(.vuetify-styles) .pe-md-15 {
    padding-inline-end: 60px !important;
  }
  :where(.vuetify-styles) .pe-md-16 {
    padding-inline-end: 64px !important;
  }
  :where(.vuetify-styles) .text-md-left {
    text-align: left !important;
  }
  :where(.vuetify-styles) .text-md-right {
    text-align: right !important;
  }
  :where(.vuetify-styles) .text-md-center {
    text-align: center !important;
  }
  :where(.vuetify-styles) .text-md-justify {
    text-align: justify !important;
  }
  :where(.vuetify-styles) .text-md-start {
    text-align: start !important;
  }
  :where(.vuetify-styles) .text-md-end {
    text-align: end !important;
  }
  :where(.vuetify-styles) .text-md-h1 {
    font-size: 6rem !important;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.015625em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-md-h2 {
    font-size: 3.75rem !important;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.0083333333em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-md-h3 {
    font-size: 3rem !important;
    font-weight: 400;
    line-height: 1.05;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-md-h4 {
    font-size: 2.125rem !important;
    font-weight: 400;
    line-height: 1.175;
    letter-spacing: 0.0073529412em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-md-h5 {
    font-size: 1.5rem !important;
    font-weight: 400;
    line-height: 1.333;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-md-h6 {
    font-size: 1.25rem !important;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: 0.0125em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-md-subtitle-1 {
    font-size: 1rem !important;
    font-weight: normal;
    line-height: 1.75;
    letter-spacing: 0.009375em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-md-subtitle-2 {
    font-size: 0.875rem !important;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: 0.0071428571em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-md-body-1 {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.03125em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-md-body-2 {
    font-size: 0.875rem !important;
    font-weight: 400;
    line-height: 1.425;
    letter-spacing: 0.0178571429em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-md-button {
    font-size: 0.875rem !important;
    font-weight: 500;
    line-height: 2.6;
    letter-spacing: 0.0892857143em !important;
    font-family: "Roboto", sans-serif;
    text-transform: uppercase !important;
  }
  :where(.vuetify-styles) .text-md-caption {
    font-size: 0.75rem !important;
    font-weight: 400;
    line-height: 1.667;
    letter-spacing: 0.0333333333em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-md-overline {
    font-size: 0.75rem !important;
    font-weight: 500;
    line-height: 2.667;
    letter-spacing: 0.1666666667em !important;
    font-family: "Roboto", sans-serif;
    text-transform: uppercase !important;
  }
  :where(.vuetify-styles) .h-md-auto {
    height: auto !important;
  }
  :where(.vuetify-styles) .h-md-screen {
    height: 100vh !important;
  }
  :where(.vuetify-styles) .h-md-0 {
    height: 0 !important;
  }
  :where(.vuetify-styles) .h-md-25 {
    height: 25% !important;
  }
  :where(.vuetify-styles) .h-md-50 {
    height: 50% !important;
  }
  :where(.vuetify-styles) .h-md-75 {
    height: 75% !important;
  }
  :where(.vuetify-styles) .h-md-100 {
    height: 100% !important;
  }
  :where(.vuetify-styles) .w-md-auto {
    width: auto !important;
  }
  :where(.vuetify-styles) .w-md-0 {
    width: 0 !important;
  }
  :where(.vuetify-styles) .w-md-25 {
    width: 25% !important;
  }
  :where(.vuetify-styles) .w-md-33 {
    width: 33% !important;
  }
  :where(.vuetify-styles) .w-md-50 {
    width: 50% !important;
  }
  :where(.vuetify-styles) .w-md-66 {
    width: 66% !important;
  }
  :where(.vuetify-styles) .w-md-75 {
    width: 75% !important;
  }
  :where(.vuetify-styles) .w-md-100 {
    width: 100% !important;
  }
}
@media (min-width: 1280px) {
  :where(.vuetify-styles) .d-lg-none {
    display: none !important;
  }
  :where(.vuetify-styles) .d-lg-inline {
    display: inline !important;
  }
  :where(.vuetify-styles) .d-lg-inline-block {
    display: inline-block !important;
  }
  :where(.vuetify-styles) .d-lg-block {
    display: block !important;
  }
  :where(.vuetify-styles) .d-lg-table {
    display: table !important;
  }
  :where(.vuetify-styles) .d-lg-table-row {
    display: table-row !important;
  }
  :where(.vuetify-styles) .d-lg-table-cell {
    display: table-cell !important;
  }
  :where(.vuetify-styles) .d-lg-flex {
    display: flex !important;
  }
  :where(.vuetify-styles) .d-lg-inline-flex {
    display: inline-flex !important;
  }
  :where(.vuetify-styles) .float-lg-none {
    float: none !important;
  }
  :where(.vuetify-styles) .float-lg-left {
    float: left !important;
  }
  :where(.vuetify-styles) .float-lg-right {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-rtl .float-lg-end {
    float: left !important;
  }
  :where(.vuetify-styles) .v-locale--is-rtl .float-lg-start {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-ltr .float-lg-end {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-ltr .float-lg-start {
    float: left !important;
  }
  :where(.vuetify-styles) .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  :where(.vuetify-styles) .flex-lg-1-1 {
    flex: 1 1 auto !important;
  }
  :where(.vuetify-styles) .flex-lg-1-0 {
    flex: 1 0 auto !important;
  }
  :where(.vuetify-styles) .flex-lg-0-1 {
    flex: 0 1 auto !important;
  }
  :where(.vuetify-styles) .flex-lg-0-0 {
    flex: 0 0 auto !important;
  }
  :where(.vuetify-styles) .flex-lg-1-1-100 {
    flex: 1 1 100% !important;
  }
  :where(.vuetify-styles) .flex-lg-1-0-100 {
    flex: 1 0 100% !important;
  }
  :where(.vuetify-styles) .flex-lg-0-1-100 {
    flex: 0 1 100% !important;
  }
  :where(.vuetify-styles) .flex-lg-0-0-100 {
    flex: 0 0 100% !important;
  }
  :where(.vuetify-styles) .flex-lg-1-1-0 {
    flex: 1 1 0 !important;
  }
  :where(.vuetify-styles) .flex-lg-1-0-0 {
    flex: 1 0 0 !important;
  }
  :where(.vuetify-styles) .flex-lg-0-1-0 {
    flex: 0 1 0 !important;
  }
  :where(.vuetify-styles) .flex-lg-0-0-0 {
    flex: 0 0 0 !important;
  }
  :where(.vuetify-styles) .flex-lg-row {
    flex-direction: row !important;
  }
  :where(.vuetify-styles) .flex-lg-column {
    flex-direction: column !important;
  }
  :where(.vuetify-styles) .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  :where(.vuetify-styles) .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  :where(.vuetify-styles) .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  :where(.vuetify-styles) .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  :where(.vuetify-styles) .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  :where(.vuetify-styles) .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  :where(.vuetify-styles) .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  :where(.vuetify-styles) .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  :where(.vuetify-styles) .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :where(.vuetify-styles) .justify-lg-start {
    justify-content: flex-start !important;
  }
  :where(.vuetify-styles) .justify-lg-end {
    justify-content: flex-end !important;
  }
  :where(.vuetify-styles) .justify-lg-center {
    justify-content: center !important;
  }
  :where(.vuetify-styles) .justify-lg-space-between {
    justify-content: space-between !important;
  }
  :where(.vuetify-styles) .justify-lg-space-around {
    justify-content: space-around !important;
  }
  :where(.vuetify-styles) .justify-lg-space-evenly {
    justify-content: space-evenly !important;
  }
  :where(.vuetify-styles) .justify-items-lg-start {
    justify-items: flex-start !important;
  }
  :where(.vuetify-styles) .justify-items-lg-end {
    justify-items: flex-end !important;
  }
  :where(.vuetify-styles) .justify-items-lg-center {
    justify-items: center !important;
  }
  :where(.vuetify-styles) .justify-items-lg-stretch {
    justify-items: stretch !important;
  }
  :where(.vuetify-styles) .align-lg-start {
    align-items: flex-start !important;
  }
  :where(.vuetify-styles) .align-lg-end {
    align-items: flex-end !important;
  }
  :where(.vuetify-styles) .align-lg-center {
    align-items: center !important;
  }
  :where(.vuetify-styles) .align-lg-baseline {
    align-items: baseline !important;
  }
  :where(.vuetify-styles) .align-lg-stretch {
    align-items: stretch !important;
  }
  :where(.vuetify-styles) .align-content-lg-start {
    align-content: flex-start !important;
  }
  :where(.vuetify-styles) .align-content-lg-end {
    align-content: flex-end !important;
  }
  :where(.vuetify-styles) .align-content-lg-center {
    align-content: center !important;
  }
  :where(.vuetify-styles) .align-content-lg-space-between {
    align-content: space-between !important;
  }
  :where(.vuetify-styles) .align-content-lg-space-around {
    align-content: space-around !important;
  }
  :where(.vuetify-styles) .align-content-lg-space-evenly {
    align-content: space-evenly !important;
  }
  :where(.vuetify-styles) .align-content-lg-stretch {
    align-content: stretch !important;
  }
  :where(.vuetify-styles) .align-self-lg-auto {
    align-self: auto !important;
  }
  :where(.vuetify-styles) .align-self-lg-start {
    align-self: flex-start !important;
  }
  :where(.vuetify-styles) .align-self-lg-end {
    align-self: flex-end !important;
  }
  :where(.vuetify-styles) .align-self-lg-center {
    align-self: center !important;
  }
  :where(.vuetify-styles) .align-self-lg-baseline {
    align-self: baseline !important;
  }
  :where(.vuetify-styles) .align-self-lg-stretch {
    align-self: stretch !important;
  }
  :where(.vuetify-styles) .order-lg-first {
    order: -1 !important;
  }
  :where(.vuetify-styles) .order-lg-0 {
    order: 0 !important;
  }
  :where(.vuetify-styles) .order-lg-1 {
    order: 1 !important;
  }
  :where(.vuetify-styles) .order-lg-2 {
    order: 2 !important;
  }
  :where(.vuetify-styles) .order-lg-3 {
    order: 3 !important;
  }
  :where(.vuetify-styles) .order-lg-4 {
    order: 4 !important;
  }
  :where(.vuetify-styles) .order-lg-5 {
    order: 5 !important;
  }
  :where(.vuetify-styles) .order-lg-6 {
    order: 6 !important;
  }
  :where(.vuetify-styles) .order-lg-7 {
    order: 7 !important;
  }
  :where(.vuetify-styles) .order-lg-8 {
    order: 8 !important;
  }
  :where(.vuetify-styles) .order-lg-9 {
    order: 9 !important;
  }
  :where(.vuetify-styles) .order-lg-10 {
    order: 10 !important;
  }
  :where(.vuetify-styles) .order-lg-11 {
    order: 11 !important;
  }
  :where(.vuetify-styles) .order-lg-12 {
    order: 12 !important;
  }
  :where(.vuetify-styles) .order-lg-last {
    order: 13 !important;
  }
  :where(.vuetify-styles) .ga-lg-0 {
    gap: 0px !important;
  }
  :where(.vuetify-styles) .ga-lg-1 {
    gap: 4px !important;
  }
  :where(.vuetify-styles) .ga-lg-2 {
    gap: 8px !important;
  }
  :where(.vuetify-styles) .ga-lg-3 {
    gap: 12px !important;
  }
  :where(.vuetify-styles) .ga-lg-4 {
    gap: 16px !important;
  }
  :where(.vuetify-styles) .ga-lg-5 {
    gap: 20px !important;
  }
  :where(.vuetify-styles) .ga-lg-6 {
    gap: 24px !important;
  }
  :where(.vuetify-styles) .ga-lg-7 {
    gap: 28px !important;
  }
  :where(.vuetify-styles) .ga-lg-8 {
    gap: 32px !important;
  }
  :where(.vuetify-styles) .ga-lg-9 {
    gap: 36px !important;
  }
  :where(.vuetify-styles) .ga-lg-10 {
    gap: 40px !important;
  }
  :where(.vuetify-styles) .ga-lg-11 {
    gap: 44px !important;
  }
  :where(.vuetify-styles) .ga-lg-12 {
    gap: 48px !important;
  }
  :where(.vuetify-styles) .ga-lg-13 {
    gap: 52px !important;
  }
  :where(.vuetify-styles) .ga-lg-14 {
    gap: 56px !important;
  }
  :where(.vuetify-styles) .ga-lg-15 {
    gap: 60px !important;
  }
  :where(.vuetify-styles) .ga-lg-16 {
    gap: 64px !important;
  }
  :where(.vuetify-styles) .ga-lg-auto {
    gap: auto !important;
  }
  :where(.vuetify-styles) .gr-lg-0 {
    row-gap: 0px !important;
  }
  :where(.vuetify-styles) .gr-lg-1 {
    row-gap: 4px !important;
  }
  :where(.vuetify-styles) .gr-lg-2 {
    row-gap: 8px !important;
  }
  :where(.vuetify-styles) .gr-lg-3 {
    row-gap: 12px !important;
  }
  :where(.vuetify-styles) .gr-lg-4 {
    row-gap: 16px !important;
  }
  :where(.vuetify-styles) .gr-lg-5 {
    row-gap: 20px !important;
  }
  :where(.vuetify-styles) .gr-lg-6 {
    row-gap: 24px !important;
  }
  :where(.vuetify-styles) .gr-lg-7 {
    row-gap: 28px !important;
  }
  :where(.vuetify-styles) .gr-lg-8 {
    row-gap: 32px !important;
  }
  :where(.vuetify-styles) .gr-lg-9 {
    row-gap: 36px !important;
  }
  :where(.vuetify-styles) .gr-lg-10 {
    row-gap: 40px !important;
  }
  :where(.vuetify-styles) .gr-lg-11 {
    row-gap: 44px !important;
  }
  :where(.vuetify-styles) .gr-lg-12 {
    row-gap: 48px !important;
  }
  :where(.vuetify-styles) .gr-lg-13 {
    row-gap: 52px !important;
  }
  :where(.vuetify-styles) .gr-lg-14 {
    row-gap: 56px !important;
  }
  :where(.vuetify-styles) .gr-lg-15 {
    row-gap: 60px !important;
  }
  :where(.vuetify-styles) .gr-lg-16 {
    row-gap: 64px !important;
  }
  :where(.vuetify-styles) .gr-lg-auto {
    row-gap: auto !important;
  }
  :where(.vuetify-styles) .gc-lg-0 {
    column-gap: 0px !important;
  }
  :where(.vuetify-styles) .gc-lg-1 {
    column-gap: 4px !important;
  }
  :where(.vuetify-styles) .gc-lg-2 {
    column-gap: 8px !important;
  }
  :where(.vuetify-styles) .gc-lg-3 {
    column-gap: 12px !important;
  }
  :where(.vuetify-styles) .gc-lg-4 {
    column-gap: 16px !important;
  }
  :where(.vuetify-styles) .gc-lg-5 {
    column-gap: 20px !important;
  }
  :where(.vuetify-styles) .gc-lg-6 {
    column-gap: 24px !important;
  }
  :where(.vuetify-styles) .gc-lg-7 {
    column-gap: 28px !important;
  }
  :where(.vuetify-styles) .gc-lg-8 {
    column-gap: 32px !important;
  }
  :where(.vuetify-styles) .gc-lg-9 {
    column-gap: 36px !important;
  }
  :where(.vuetify-styles) .gc-lg-10 {
    column-gap: 40px !important;
  }
  :where(.vuetify-styles) .gc-lg-11 {
    column-gap: 44px !important;
  }
  :where(.vuetify-styles) .gc-lg-12 {
    column-gap: 48px !important;
  }
  :where(.vuetify-styles) .gc-lg-13 {
    column-gap: 52px !important;
  }
  :where(.vuetify-styles) .gc-lg-14 {
    column-gap: 56px !important;
  }
  :where(.vuetify-styles) .gc-lg-15 {
    column-gap: 60px !important;
  }
  :where(.vuetify-styles) .gc-lg-16 {
    column-gap: 64px !important;
  }
  :where(.vuetify-styles) .gc-lg-auto {
    column-gap: auto !important;
  }
  :where(.vuetify-styles) .ma-lg-0 {
    margin: 0px !important;
  }
  :where(.vuetify-styles) .ma-lg-1 {
    margin: 4px !important;
  }
  :where(.vuetify-styles) .ma-lg-2 {
    margin: 8px !important;
  }
  :where(.vuetify-styles) .ma-lg-3 {
    margin: 12px !important;
  }
  :where(.vuetify-styles) .ma-lg-4 {
    margin: 16px !important;
  }
  :where(.vuetify-styles) .ma-lg-5 {
    margin: 20px !important;
  }
  :where(.vuetify-styles) .ma-lg-6 {
    margin: 24px !important;
  }
  :where(.vuetify-styles) .ma-lg-7 {
    margin: 28px !important;
  }
  :where(.vuetify-styles) .ma-lg-8 {
    margin: 32px !important;
  }
  :where(.vuetify-styles) .ma-lg-9 {
    margin: 36px !important;
  }
  :where(.vuetify-styles) .ma-lg-10 {
    margin: 40px !important;
  }
  :where(.vuetify-styles) .ma-lg-11 {
    margin: 44px !important;
  }
  :where(.vuetify-styles) .ma-lg-12 {
    margin: 48px !important;
  }
  :where(.vuetify-styles) .ma-lg-13 {
    margin: 52px !important;
  }
  :where(.vuetify-styles) .ma-lg-14 {
    margin: 56px !important;
  }
  :where(.vuetify-styles) .ma-lg-15 {
    margin: 60px !important;
  }
  :where(.vuetify-styles) .ma-lg-16 {
    margin: 64px !important;
  }
  :where(.vuetify-styles) .ma-lg-auto {
    margin: auto !important;
  }
  :where(.vuetify-styles) .mx-lg-0 {
    margin-right: 0px !important;
    margin-left: 0px !important;
  }
  :where(.vuetify-styles) .mx-lg-1 {
    margin-right: 4px !important;
    margin-left: 4px !important;
  }
  :where(.vuetify-styles) .mx-lg-2 {
    margin-right: 8px !important;
    margin-left: 8px !important;
  }
  :where(.vuetify-styles) .mx-lg-3 {
    margin-right: 12px !important;
    margin-left: 12px !important;
  }
  :where(.vuetify-styles) .mx-lg-4 {
    margin-right: 16px !important;
    margin-left: 16px !important;
  }
  :where(.vuetify-styles) .mx-lg-5 {
    margin-right: 20px !important;
    margin-left: 20px !important;
  }
  :where(.vuetify-styles) .mx-lg-6 {
    margin-right: 24px !important;
    margin-left: 24px !important;
  }
  :where(.vuetify-styles) .mx-lg-7 {
    margin-right: 28px !important;
    margin-left: 28px !important;
  }
  :where(.vuetify-styles) .mx-lg-8 {
    margin-right: 32px !important;
    margin-left: 32px !important;
  }
  :where(.vuetify-styles) .mx-lg-9 {
    margin-right: 36px !important;
    margin-left: 36px !important;
  }
  :where(.vuetify-styles) .mx-lg-10 {
    margin-right: 40px !important;
    margin-left: 40px !important;
  }
  :where(.vuetify-styles) .mx-lg-11 {
    margin-right: 44px !important;
    margin-left: 44px !important;
  }
  :where(.vuetify-styles) .mx-lg-12 {
    margin-right: 48px !important;
    margin-left: 48px !important;
  }
  :where(.vuetify-styles) .mx-lg-13 {
    margin-right: 52px !important;
    margin-left: 52px !important;
  }
  :where(.vuetify-styles) .mx-lg-14 {
    margin-right: 56px !important;
    margin-left: 56px !important;
  }
  :where(.vuetify-styles) .mx-lg-15 {
    margin-right: 60px !important;
    margin-left: 60px !important;
  }
  :where(.vuetify-styles) .mx-lg-16 {
    margin-right: 64px !important;
    margin-left: 64px !important;
  }
  :where(.vuetify-styles) .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  :where(.vuetify-styles) .my-lg-0 {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  :where(.vuetify-styles) .my-lg-1 {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }
  :where(.vuetify-styles) .my-lg-2 {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }
  :where(.vuetify-styles) .my-lg-3 {
    margin-top: 12px !important;
    margin-bottom: 12px !important;
  }
  :where(.vuetify-styles) .my-lg-4 {
    margin-top: 16px !important;
    margin-bottom: 16px !important;
  }
  :where(.vuetify-styles) .my-lg-5 {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  :where(.vuetify-styles) .my-lg-6 {
    margin-top: 24px !important;
    margin-bottom: 24px !important;
  }
  :where(.vuetify-styles) .my-lg-7 {
    margin-top: 28px !important;
    margin-bottom: 28px !important;
  }
  :where(.vuetify-styles) .my-lg-8 {
    margin-top: 32px !important;
    margin-bottom: 32px !important;
  }
  :where(.vuetify-styles) .my-lg-9 {
    margin-top: 36px !important;
    margin-bottom: 36px !important;
  }
  :where(.vuetify-styles) .my-lg-10 {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  :where(.vuetify-styles) .my-lg-11 {
    margin-top: 44px !important;
    margin-bottom: 44px !important;
  }
  :where(.vuetify-styles) .my-lg-12 {
    margin-top: 48px !important;
    margin-bottom: 48px !important;
  }
  :where(.vuetify-styles) .my-lg-13 {
    margin-top: 52px !important;
    margin-bottom: 52px !important;
  }
  :where(.vuetify-styles) .my-lg-14 {
    margin-top: 56px !important;
    margin-bottom: 56px !important;
  }
  :where(.vuetify-styles) .my-lg-15 {
    margin-top: 60px !important;
    margin-bottom: 60px !important;
  }
  :where(.vuetify-styles) .my-lg-16 {
    margin-top: 64px !important;
    margin-bottom: 64px !important;
  }
  :where(.vuetify-styles) .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  :where(.vuetify-styles) .mt-lg-0 {
    margin-top: 0px !important;
  }
  :where(.vuetify-styles) .mt-lg-1 {
    margin-top: 4px !important;
  }
  :where(.vuetify-styles) .mt-lg-2 {
    margin-top: 8px !important;
  }
  :where(.vuetify-styles) .mt-lg-3 {
    margin-top: 12px !important;
  }
  :where(.vuetify-styles) .mt-lg-4 {
    margin-top: 16px !important;
  }
  :where(.vuetify-styles) .mt-lg-5 {
    margin-top: 20px !important;
  }
  :where(.vuetify-styles) .mt-lg-6 {
    margin-top: 24px !important;
  }
  :where(.vuetify-styles) .mt-lg-7 {
    margin-top: 28px !important;
  }
  :where(.vuetify-styles) .mt-lg-8 {
    margin-top: 32px !important;
  }
  :where(.vuetify-styles) .mt-lg-9 {
    margin-top: 36px !important;
  }
  :where(.vuetify-styles) .mt-lg-10 {
    margin-top: 40px !important;
  }
  :where(.vuetify-styles) .mt-lg-11 {
    margin-top: 44px !important;
  }
  :where(.vuetify-styles) .mt-lg-12 {
    margin-top: 48px !important;
  }
  :where(.vuetify-styles) .mt-lg-13 {
    margin-top: 52px !important;
  }
  :where(.vuetify-styles) .mt-lg-14 {
    margin-top: 56px !important;
  }
  :where(.vuetify-styles) .mt-lg-15 {
    margin-top: 60px !important;
  }
  :where(.vuetify-styles) .mt-lg-16 {
    margin-top: 64px !important;
  }
  :where(.vuetify-styles) .mt-lg-auto {
    margin-top: auto !important;
  }
  :where(.vuetify-styles) .mr-lg-0 {
    margin-right: 0px !important;
  }
  :where(.vuetify-styles) .mr-lg-1 {
    margin-right: 4px !important;
  }
  :where(.vuetify-styles) .mr-lg-2 {
    margin-right: 8px !important;
  }
  :where(.vuetify-styles) .mr-lg-3 {
    margin-right: 12px !important;
  }
  :where(.vuetify-styles) .mr-lg-4 {
    margin-right: 16px !important;
  }
  :where(.vuetify-styles) .mr-lg-5 {
    margin-right: 20px !important;
  }
  :where(.vuetify-styles) .mr-lg-6 {
    margin-right: 24px !important;
  }
  :where(.vuetify-styles) .mr-lg-7 {
    margin-right: 28px !important;
  }
  :where(.vuetify-styles) .mr-lg-8 {
    margin-right: 32px !important;
  }
  :where(.vuetify-styles) .mr-lg-9 {
    margin-right: 36px !important;
  }
  :where(.vuetify-styles) .mr-lg-10 {
    margin-right: 40px !important;
  }
  :where(.vuetify-styles) .mr-lg-11 {
    margin-right: 44px !important;
  }
  :where(.vuetify-styles) .mr-lg-12 {
    margin-right: 48px !important;
  }
  :where(.vuetify-styles) .mr-lg-13 {
    margin-right: 52px !important;
  }
  :where(.vuetify-styles) .mr-lg-14 {
    margin-right: 56px !important;
  }
  :where(.vuetify-styles) .mr-lg-15 {
    margin-right: 60px !important;
  }
  :where(.vuetify-styles) .mr-lg-16 {
    margin-right: 64px !important;
  }
  :where(.vuetify-styles) .mr-lg-auto {
    margin-right: auto !important;
  }
  :where(.vuetify-styles) .mb-lg-0 {
    margin-bottom: 0px !important;
  }
  :where(.vuetify-styles) .mb-lg-1 {
    margin-bottom: 4px !important;
  }
  :where(.vuetify-styles) .mb-lg-2 {
    margin-bottom: 8px !important;
  }
  :where(.vuetify-styles) .mb-lg-3 {
    margin-bottom: 12px !important;
  }
  :where(.vuetify-styles) .mb-lg-4 {
    margin-bottom: 16px !important;
  }
  :where(.vuetify-styles) .mb-lg-5 {
    margin-bottom: 20px !important;
  }
  :where(.vuetify-styles) .mb-lg-6 {
    margin-bottom: 24px !important;
  }
  :where(.vuetify-styles) .mb-lg-7 {
    margin-bottom: 28px !important;
  }
  :where(.vuetify-styles) .mb-lg-8 {
    margin-bottom: 32px !important;
  }
  :where(.vuetify-styles) .mb-lg-9 {
    margin-bottom: 36px !important;
  }
  :where(.vuetify-styles) .mb-lg-10 {
    margin-bottom: 40px !important;
  }
  :where(.vuetify-styles) .mb-lg-11 {
    margin-bottom: 44px !important;
  }
  :where(.vuetify-styles) .mb-lg-12 {
    margin-bottom: 48px !important;
  }
  :where(.vuetify-styles) .mb-lg-13 {
    margin-bottom: 52px !important;
  }
  :where(.vuetify-styles) .mb-lg-14 {
    margin-bottom: 56px !important;
  }
  :where(.vuetify-styles) .mb-lg-15 {
    margin-bottom: 60px !important;
  }
  :where(.vuetify-styles) .mb-lg-16 {
    margin-bottom: 64px !important;
  }
  :where(.vuetify-styles) .mb-lg-auto {
    margin-bottom: auto !important;
  }
  :where(.vuetify-styles) .ml-lg-0 {
    margin-left: 0px !important;
  }
  :where(.vuetify-styles) .ml-lg-1 {
    margin-left: 4px !important;
  }
  :where(.vuetify-styles) .ml-lg-2 {
    margin-left: 8px !important;
  }
  :where(.vuetify-styles) .ml-lg-3 {
    margin-left: 12px !important;
  }
  :where(.vuetify-styles) .ml-lg-4 {
    margin-left: 16px !important;
  }
  :where(.vuetify-styles) .ml-lg-5 {
    margin-left: 20px !important;
  }
  :where(.vuetify-styles) .ml-lg-6 {
    margin-left: 24px !important;
  }
  :where(.vuetify-styles) .ml-lg-7 {
    margin-left: 28px !important;
  }
  :where(.vuetify-styles) .ml-lg-8 {
    margin-left: 32px !important;
  }
  :where(.vuetify-styles) .ml-lg-9 {
    margin-left: 36px !important;
  }
  :where(.vuetify-styles) .ml-lg-10 {
    margin-left: 40px !important;
  }
  :where(.vuetify-styles) .ml-lg-11 {
    margin-left: 44px !important;
  }
  :where(.vuetify-styles) .ml-lg-12 {
    margin-left: 48px !important;
  }
  :where(.vuetify-styles) .ml-lg-13 {
    margin-left: 52px !important;
  }
  :where(.vuetify-styles) .ml-lg-14 {
    margin-left: 56px !important;
  }
  :where(.vuetify-styles) .ml-lg-15 {
    margin-left: 60px !important;
  }
  :where(.vuetify-styles) .ml-lg-16 {
    margin-left: 64px !important;
  }
  :where(.vuetify-styles) .ml-lg-auto {
    margin-left: auto !important;
  }
  :where(.vuetify-styles) .ms-lg-0 {
    margin-inline-start: 0px !important;
  }
  :where(.vuetify-styles) .ms-lg-1 {
    margin-inline-start: 4px !important;
  }
  :where(.vuetify-styles) .ms-lg-2 {
    margin-inline-start: 8px !important;
  }
  :where(.vuetify-styles) .ms-lg-3 {
    margin-inline-start: 12px !important;
  }
  :where(.vuetify-styles) .ms-lg-4 {
    margin-inline-start: 16px !important;
  }
  :where(.vuetify-styles) .ms-lg-5 {
    margin-inline-start: 20px !important;
  }
  :where(.vuetify-styles) .ms-lg-6 {
    margin-inline-start: 24px !important;
  }
  :where(.vuetify-styles) .ms-lg-7 {
    margin-inline-start: 28px !important;
  }
  :where(.vuetify-styles) .ms-lg-8 {
    margin-inline-start: 32px !important;
  }
  :where(.vuetify-styles) .ms-lg-9 {
    margin-inline-start: 36px !important;
  }
  :where(.vuetify-styles) .ms-lg-10 {
    margin-inline-start: 40px !important;
  }
  :where(.vuetify-styles) .ms-lg-11 {
    margin-inline-start: 44px !important;
  }
  :where(.vuetify-styles) .ms-lg-12 {
    margin-inline-start: 48px !important;
  }
  :where(.vuetify-styles) .ms-lg-13 {
    margin-inline-start: 52px !important;
  }
  :where(.vuetify-styles) .ms-lg-14 {
    margin-inline-start: 56px !important;
  }
  :where(.vuetify-styles) .ms-lg-15 {
    margin-inline-start: 60px !important;
  }
  :where(.vuetify-styles) .ms-lg-16 {
    margin-inline-start: 64px !important;
  }
  :where(.vuetify-styles) .ms-lg-auto {
    margin-inline-start: auto !important;
  }
  :where(.vuetify-styles) .me-lg-0 {
    margin-inline-end: 0px !important;
  }
  :where(.vuetify-styles) .me-lg-1 {
    margin-inline-end: 4px !important;
  }
  :where(.vuetify-styles) .me-lg-2 {
    margin-inline-end: 8px !important;
  }
  :where(.vuetify-styles) .me-lg-3 {
    margin-inline-end: 12px !important;
  }
  :where(.vuetify-styles) .me-lg-4 {
    margin-inline-end: 16px !important;
  }
  :where(.vuetify-styles) .me-lg-5 {
    margin-inline-end: 20px !important;
  }
  :where(.vuetify-styles) .me-lg-6 {
    margin-inline-end: 24px !important;
  }
  :where(.vuetify-styles) .me-lg-7 {
    margin-inline-end: 28px !important;
  }
  :where(.vuetify-styles) .me-lg-8 {
    margin-inline-end: 32px !important;
  }
  :where(.vuetify-styles) .me-lg-9 {
    margin-inline-end: 36px !important;
  }
  :where(.vuetify-styles) .me-lg-10 {
    margin-inline-end: 40px !important;
  }
  :where(.vuetify-styles) .me-lg-11 {
    margin-inline-end: 44px !important;
  }
  :where(.vuetify-styles) .me-lg-12 {
    margin-inline-end: 48px !important;
  }
  :where(.vuetify-styles) .me-lg-13 {
    margin-inline-end: 52px !important;
  }
  :where(.vuetify-styles) .me-lg-14 {
    margin-inline-end: 56px !important;
  }
  :where(.vuetify-styles) .me-lg-15 {
    margin-inline-end: 60px !important;
  }
  :where(.vuetify-styles) .me-lg-16 {
    margin-inline-end: 64px !important;
  }
  :where(.vuetify-styles) .me-lg-auto {
    margin-inline-end: auto !important;
  }
  :where(.vuetify-styles) .ma-lg-n1 {
    margin: -4px !important;
  }
  :where(.vuetify-styles) .ma-lg-n2 {
    margin: -8px !important;
  }
  :where(.vuetify-styles) .ma-lg-n3 {
    margin: -12px !important;
  }
  :where(.vuetify-styles) .ma-lg-n4 {
    margin: -16px !important;
  }
  :where(.vuetify-styles) .ma-lg-n5 {
    margin: -20px !important;
  }
  :where(.vuetify-styles) .ma-lg-n6 {
    margin: -24px !important;
  }
  :where(.vuetify-styles) .ma-lg-n7 {
    margin: -28px !important;
  }
  :where(.vuetify-styles) .ma-lg-n8 {
    margin: -32px !important;
  }
  :where(.vuetify-styles) .ma-lg-n9 {
    margin: -36px !important;
  }
  :where(.vuetify-styles) .ma-lg-n10 {
    margin: -40px !important;
  }
  :where(.vuetify-styles) .ma-lg-n11 {
    margin: -44px !important;
  }
  :where(.vuetify-styles) .ma-lg-n12 {
    margin: -48px !important;
  }
  :where(.vuetify-styles) .ma-lg-n13 {
    margin: -52px !important;
  }
  :where(.vuetify-styles) .ma-lg-n14 {
    margin: -56px !important;
  }
  :where(.vuetify-styles) .ma-lg-n15 {
    margin: -60px !important;
  }
  :where(.vuetify-styles) .ma-lg-n16 {
    margin: -64px !important;
  }
  :where(.vuetify-styles) .mx-lg-n1 {
    margin-right: -4px !important;
    margin-left: -4px !important;
  }
  :where(.vuetify-styles) .mx-lg-n2 {
    margin-right: -8px !important;
    margin-left: -8px !important;
  }
  :where(.vuetify-styles) .mx-lg-n3 {
    margin-right: -12px !important;
    margin-left: -12px !important;
  }
  :where(.vuetify-styles) .mx-lg-n4 {
    margin-right: -16px !important;
    margin-left: -16px !important;
  }
  :where(.vuetify-styles) .mx-lg-n5 {
    margin-right: -20px !important;
    margin-left: -20px !important;
  }
  :where(.vuetify-styles) .mx-lg-n6 {
    margin-right: -24px !important;
    margin-left: -24px !important;
  }
  :where(.vuetify-styles) .mx-lg-n7 {
    margin-right: -28px !important;
    margin-left: -28px !important;
  }
  :where(.vuetify-styles) .mx-lg-n8 {
    margin-right: -32px !important;
    margin-left: -32px !important;
  }
  :where(.vuetify-styles) .mx-lg-n9 {
    margin-right: -36px !important;
    margin-left: -36px !important;
  }
  :where(.vuetify-styles) .mx-lg-n10 {
    margin-right: -40px !important;
    margin-left: -40px !important;
  }
  :where(.vuetify-styles) .mx-lg-n11 {
    margin-right: -44px !important;
    margin-left: -44px !important;
  }
  :where(.vuetify-styles) .mx-lg-n12 {
    margin-right: -48px !important;
    margin-left: -48px !important;
  }
  :where(.vuetify-styles) .mx-lg-n13 {
    margin-right: -52px !important;
    margin-left: -52px !important;
  }
  :where(.vuetify-styles) .mx-lg-n14 {
    margin-right: -56px !important;
    margin-left: -56px !important;
  }
  :where(.vuetify-styles) .mx-lg-n15 {
    margin-right: -60px !important;
    margin-left: -60px !important;
  }
  :where(.vuetify-styles) .mx-lg-n16 {
    margin-right: -64px !important;
    margin-left: -64px !important;
  }
  :where(.vuetify-styles) .my-lg-n1 {
    margin-top: -4px !important;
    margin-bottom: -4px !important;
  }
  :where(.vuetify-styles) .my-lg-n2 {
    margin-top: -8px !important;
    margin-bottom: -8px !important;
  }
  :where(.vuetify-styles) .my-lg-n3 {
    margin-top: -12px !important;
    margin-bottom: -12px !important;
  }
  :where(.vuetify-styles) .my-lg-n4 {
    margin-top: -16px !important;
    margin-bottom: -16px !important;
  }
  :where(.vuetify-styles) .my-lg-n5 {
    margin-top: -20px !important;
    margin-bottom: -20px !important;
  }
  :where(.vuetify-styles) .my-lg-n6 {
    margin-top: -24px !important;
    margin-bottom: -24px !important;
  }
  :where(.vuetify-styles) .my-lg-n7 {
    margin-top: -28px !important;
    margin-bottom: -28px !important;
  }
  :where(.vuetify-styles) .my-lg-n8 {
    margin-top: -32px !important;
    margin-bottom: -32px !important;
  }
  :where(.vuetify-styles) .my-lg-n9 {
    margin-top: -36px !important;
    margin-bottom: -36px !important;
  }
  :where(.vuetify-styles) .my-lg-n10 {
    margin-top: -40px !important;
    margin-bottom: -40px !important;
  }
  :where(.vuetify-styles) .my-lg-n11 {
    margin-top: -44px !important;
    margin-bottom: -44px !important;
  }
  :where(.vuetify-styles) .my-lg-n12 {
    margin-top: -48px !important;
    margin-bottom: -48px !important;
  }
  :where(.vuetify-styles) .my-lg-n13 {
    margin-top: -52px !important;
    margin-bottom: -52px !important;
  }
  :where(.vuetify-styles) .my-lg-n14 {
    margin-top: -56px !important;
    margin-bottom: -56px !important;
  }
  :where(.vuetify-styles) .my-lg-n15 {
    margin-top: -60px !important;
    margin-bottom: -60px !important;
  }
  :where(.vuetify-styles) .my-lg-n16 {
    margin-top: -64px !important;
    margin-bottom: -64px !important;
  }
  :where(.vuetify-styles) .mt-lg-n1 {
    margin-top: -4px !important;
  }
  :where(.vuetify-styles) .mt-lg-n2 {
    margin-top: -8px !important;
  }
  :where(.vuetify-styles) .mt-lg-n3 {
    margin-top: -12px !important;
  }
  :where(.vuetify-styles) .mt-lg-n4 {
    margin-top: -16px !important;
  }
  :where(.vuetify-styles) .mt-lg-n5 {
    margin-top: -20px !important;
  }
  :where(.vuetify-styles) .mt-lg-n6 {
    margin-top: -24px !important;
  }
  :where(.vuetify-styles) .mt-lg-n7 {
    margin-top: -28px !important;
  }
  :where(.vuetify-styles) .mt-lg-n8 {
    margin-top: -32px !important;
  }
  :where(.vuetify-styles) .mt-lg-n9 {
    margin-top: -36px !important;
  }
  :where(.vuetify-styles) .mt-lg-n10 {
    margin-top: -40px !important;
  }
  :where(.vuetify-styles) .mt-lg-n11 {
    margin-top: -44px !important;
  }
  :where(.vuetify-styles) .mt-lg-n12 {
    margin-top: -48px !important;
  }
  :where(.vuetify-styles) .mt-lg-n13 {
    margin-top: -52px !important;
  }
  :where(.vuetify-styles) .mt-lg-n14 {
    margin-top: -56px !important;
  }
  :where(.vuetify-styles) .mt-lg-n15 {
    margin-top: -60px !important;
  }
  :where(.vuetify-styles) .mt-lg-n16 {
    margin-top: -64px !important;
  }
  :where(.vuetify-styles) .mr-lg-n1 {
    margin-right: -4px !important;
  }
  :where(.vuetify-styles) .mr-lg-n2 {
    margin-right: -8px !important;
  }
  :where(.vuetify-styles) .mr-lg-n3 {
    margin-right: -12px !important;
  }
  :where(.vuetify-styles) .mr-lg-n4 {
    margin-right: -16px !important;
  }
  :where(.vuetify-styles) .mr-lg-n5 {
    margin-right: -20px !important;
  }
  :where(.vuetify-styles) .mr-lg-n6 {
    margin-right: -24px !important;
  }
  :where(.vuetify-styles) .mr-lg-n7 {
    margin-right: -28px !important;
  }
  :where(.vuetify-styles) .mr-lg-n8 {
    margin-right: -32px !important;
  }
  :where(.vuetify-styles) .mr-lg-n9 {
    margin-right: -36px !important;
  }
  :where(.vuetify-styles) .mr-lg-n10 {
    margin-right: -40px !important;
  }
  :where(.vuetify-styles) .mr-lg-n11 {
    margin-right: -44px !important;
  }
  :where(.vuetify-styles) .mr-lg-n12 {
    margin-right: -48px !important;
  }
  :where(.vuetify-styles) .mr-lg-n13 {
    margin-right: -52px !important;
  }
  :where(.vuetify-styles) .mr-lg-n14 {
    margin-right: -56px !important;
  }
  :where(.vuetify-styles) .mr-lg-n15 {
    margin-right: -60px !important;
  }
  :where(.vuetify-styles) .mr-lg-n16 {
    margin-right: -64px !important;
  }
  :where(.vuetify-styles) .mb-lg-n1 {
    margin-bottom: -4px !important;
  }
  :where(.vuetify-styles) .mb-lg-n2 {
    margin-bottom: -8px !important;
  }
  :where(.vuetify-styles) .mb-lg-n3 {
    margin-bottom: -12px !important;
  }
  :where(.vuetify-styles) .mb-lg-n4 {
    margin-bottom: -16px !important;
  }
  :where(.vuetify-styles) .mb-lg-n5 {
    margin-bottom: -20px !important;
  }
  :where(.vuetify-styles) .mb-lg-n6 {
    margin-bottom: -24px !important;
  }
  :where(.vuetify-styles) .mb-lg-n7 {
    margin-bottom: -28px !important;
  }
  :where(.vuetify-styles) .mb-lg-n8 {
    margin-bottom: -32px !important;
  }
  :where(.vuetify-styles) .mb-lg-n9 {
    margin-bottom: -36px !important;
  }
  :where(.vuetify-styles) .mb-lg-n10 {
    margin-bottom: -40px !important;
  }
  :where(.vuetify-styles) .mb-lg-n11 {
    margin-bottom: -44px !important;
  }
  :where(.vuetify-styles) .mb-lg-n12 {
    margin-bottom: -48px !important;
  }
  :where(.vuetify-styles) .mb-lg-n13 {
    margin-bottom: -52px !important;
  }
  :where(.vuetify-styles) .mb-lg-n14 {
    margin-bottom: -56px !important;
  }
  :where(.vuetify-styles) .mb-lg-n15 {
    margin-bottom: -60px !important;
  }
  :where(.vuetify-styles) .mb-lg-n16 {
    margin-bottom: -64px !important;
  }
  :where(.vuetify-styles) .ml-lg-n1 {
    margin-left: -4px !important;
  }
  :where(.vuetify-styles) .ml-lg-n2 {
    margin-left: -8px !important;
  }
  :where(.vuetify-styles) .ml-lg-n3 {
    margin-left: -12px !important;
  }
  :where(.vuetify-styles) .ml-lg-n4 {
    margin-left: -16px !important;
  }
  :where(.vuetify-styles) .ml-lg-n5 {
    margin-left: -20px !important;
  }
  :where(.vuetify-styles) .ml-lg-n6 {
    margin-left: -24px !important;
  }
  :where(.vuetify-styles) .ml-lg-n7 {
    margin-left: -28px !important;
  }
  :where(.vuetify-styles) .ml-lg-n8 {
    margin-left: -32px !important;
  }
  :where(.vuetify-styles) .ml-lg-n9 {
    margin-left: -36px !important;
  }
  :where(.vuetify-styles) .ml-lg-n10 {
    margin-left: -40px !important;
  }
  :where(.vuetify-styles) .ml-lg-n11 {
    margin-left: -44px !important;
  }
  :where(.vuetify-styles) .ml-lg-n12 {
    margin-left: -48px !important;
  }
  :where(.vuetify-styles) .ml-lg-n13 {
    margin-left: -52px !important;
  }
  :where(.vuetify-styles) .ml-lg-n14 {
    margin-left: -56px !important;
  }
  :where(.vuetify-styles) .ml-lg-n15 {
    margin-left: -60px !important;
  }
  :where(.vuetify-styles) .ml-lg-n16 {
    margin-left: -64px !important;
  }
  :where(.vuetify-styles) .ms-lg-n1 {
    margin-inline-start: -4px !important;
  }
  :where(.vuetify-styles) .ms-lg-n2 {
    margin-inline-start: -8px !important;
  }
  :where(.vuetify-styles) .ms-lg-n3 {
    margin-inline-start: -12px !important;
  }
  :where(.vuetify-styles) .ms-lg-n4 {
    margin-inline-start: -16px !important;
  }
  :where(.vuetify-styles) .ms-lg-n5 {
    margin-inline-start: -20px !important;
  }
  :where(.vuetify-styles) .ms-lg-n6 {
    margin-inline-start: -24px !important;
  }
  :where(.vuetify-styles) .ms-lg-n7 {
    margin-inline-start: -28px !important;
  }
  :where(.vuetify-styles) .ms-lg-n8 {
    margin-inline-start: -32px !important;
  }
  :where(.vuetify-styles) .ms-lg-n9 {
    margin-inline-start: -36px !important;
  }
  :where(.vuetify-styles) .ms-lg-n10 {
    margin-inline-start: -40px !important;
  }
  :where(.vuetify-styles) .ms-lg-n11 {
    margin-inline-start: -44px !important;
  }
  :where(.vuetify-styles) .ms-lg-n12 {
    margin-inline-start: -48px !important;
  }
  :where(.vuetify-styles) .ms-lg-n13 {
    margin-inline-start: -52px !important;
  }
  :where(.vuetify-styles) .ms-lg-n14 {
    margin-inline-start: -56px !important;
  }
  :where(.vuetify-styles) .ms-lg-n15 {
    margin-inline-start: -60px !important;
  }
  :where(.vuetify-styles) .ms-lg-n16 {
    margin-inline-start: -64px !important;
  }
  :where(.vuetify-styles) .me-lg-n1 {
    margin-inline-end: -4px !important;
  }
  :where(.vuetify-styles) .me-lg-n2 {
    margin-inline-end: -8px !important;
  }
  :where(.vuetify-styles) .me-lg-n3 {
    margin-inline-end: -12px !important;
  }
  :where(.vuetify-styles) .me-lg-n4 {
    margin-inline-end: -16px !important;
  }
  :where(.vuetify-styles) .me-lg-n5 {
    margin-inline-end: -20px !important;
  }
  :where(.vuetify-styles) .me-lg-n6 {
    margin-inline-end: -24px !important;
  }
  :where(.vuetify-styles) .me-lg-n7 {
    margin-inline-end: -28px !important;
  }
  :where(.vuetify-styles) .me-lg-n8 {
    margin-inline-end: -32px !important;
  }
  :where(.vuetify-styles) .me-lg-n9 {
    margin-inline-end: -36px !important;
  }
  :where(.vuetify-styles) .me-lg-n10 {
    margin-inline-end: -40px !important;
  }
  :where(.vuetify-styles) .me-lg-n11 {
    margin-inline-end: -44px !important;
  }
  :where(.vuetify-styles) .me-lg-n12 {
    margin-inline-end: -48px !important;
  }
  :where(.vuetify-styles) .me-lg-n13 {
    margin-inline-end: -52px !important;
  }
  :where(.vuetify-styles) .me-lg-n14 {
    margin-inline-end: -56px !important;
  }
  :where(.vuetify-styles) .me-lg-n15 {
    margin-inline-end: -60px !important;
  }
  :where(.vuetify-styles) .me-lg-n16 {
    margin-inline-end: -64px !important;
  }
  :where(.vuetify-styles) .pa-lg-0 {
    padding: 0px !important;
  }
  :where(.vuetify-styles) .pa-lg-1 {
    padding: 4px !important;
  }
  :where(.vuetify-styles) .pa-lg-2 {
    padding: 8px !important;
  }
  :where(.vuetify-styles) .pa-lg-3 {
    padding: 12px !important;
  }
  :where(.vuetify-styles) .pa-lg-4 {
    padding: 16px !important;
  }
  :where(.vuetify-styles) .pa-lg-5 {
    padding: 20px !important;
  }
  :where(.vuetify-styles) .pa-lg-6 {
    padding: 24px !important;
  }
  :where(.vuetify-styles) .pa-lg-7 {
    padding: 28px !important;
  }
  :where(.vuetify-styles) .pa-lg-8 {
    padding: 32px !important;
  }
  :where(.vuetify-styles) .pa-lg-9 {
    padding: 36px !important;
  }
  :where(.vuetify-styles) .pa-lg-10 {
    padding: 40px !important;
  }
  :where(.vuetify-styles) .pa-lg-11 {
    padding: 44px !important;
  }
  :where(.vuetify-styles) .pa-lg-12 {
    padding: 48px !important;
  }
  :where(.vuetify-styles) .pa-lg-13 {
    padding: 52px !important;
  }
  :where(.vuetify-styles) .pa-lg-14 {
    padding: 56px !important;
  }
  :where(.vuetify-styles) .pa-lg-15 {
    padding: 60px !important;
  }
  :where(.vuetify-styles) .pa-lg-16 {
    padding: 64px !important;
  }
  :where(.vuetify-styles) .px-lg-0 {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  :where(.vuetify-styles) .px-lg-1 {
    padding-right: 4px !important;
    padding-left: 4px !important;
  }
  :where(.vuetify-styles) .px-lg-2 {
    padding-right: 8px !important;
    padding-left: 8px !important;
  }
  :where(.vuetify-styles) .px-lg-3 {
    padding-right: 12px !important;
    padding-left: 12px !important;
  }
  :where(.vuetify-styles) .px-lg-4 {
    padding-right: 16px !important;
    padding-left: 16px !important;
  }
  :where(.vuetify-styles) .px-lg-5 {
    padding-right: 20px !important;
    padding-left: 20px !important;
  }
  :where(.vuetify-styles) .px-lg-6 {
    padding-right: 24px !important;
    padding-left: 24px !important;
  }
  :where(.vuetify-styles) .px-lg-7 {
    padding-right: 28px !important;
    padding-left: 28px !important;
  }
  :where(.vuetify-styles) .px-lg-8 {
    padding-right: 32px !important;
    padding-left: 32px !important;
  }
  :where(.vuetify-styles) .px-lg-9 {
    padding-right: 36px !important;
    padding-left: 36px !important;
  }
  :where(.vuetify-styles) .px-lg-10 {
    padding-right: 40px !important;
    padding-left: 40px !important;
  }
  :where(.vuetify-styles) .px-lg-11 {
    padding-right: 44px !important;
    padding-left: 44px !important;
  }
  :where(.vuetify-styles) .px-lg-12 {
    padding-right: 48px !important;
    padding-left: 48px !important;
  }
  :where(.vuetify-styles) .px-lg-13 {
    padding-right: 52px !important;
    padding-left: 52px !important;
  }
  :where(.vuetify-styles) .px-lg-14 {
    padding-right: 56px !important;
    padding-left: 56px !important;
  }
  :where(.vuetify-styles) .px-lg-15 {
    padding-right: 60px !important;
    padding-left: 60px !important;
  }
  :where(.vuetify-styles) .px-lg-16 {
    padding-right: 64px !important;
    padding-left: 64px !important;
  }
  :where(.vuetify-styles) .py-lg-0 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  :where(.vuetify-styles) .py-lg-1 {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
  :where(.vuetify-styles) .py-lg-2 {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  :where(.vuetify-styles) .py-lg-3 {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  :where(.vuetify-styles) .py-lg-4 {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
  :where(.vuetify-styles) .py-lg-5 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  :where(.vuetify-styles) .py-lg-6 {
    padding-top: 24px !important;
    padding-bottom: 24px !important;
  }
  :where(.vuetify-styles) .py-lg-7 {
    padding-top: 28px !important;
    padding-bottom: 28px !important;
  }
  :where(.vuetify-styles) .py-lg-8 {
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }
  :where(.vuetify-styles) .py-lg-9 {
    padding-top: 36px !important;
    padding-bottom: 36px !important;
  }
  :where(.vuetify-styles) .py-lg-10 {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  :where(.vuetify-styles) .py-lg-11 {
    padding-top: 44px !important;
    padding-bottom: 44px !important;
  }
  :where(.vuetify-styles) .py-lg-12 {
    padding-top: 48px !important;
    padding-bottom: 48px !important;
  }
  :where(.vuetify-styles) .py-lg-13 {
    padding-top: 52px !important;
    padding-bottom: 52px !important;
  }
  :where(.vuetify-styles) .py-lg-14 {
    padding-top: 56px !important;
    padding-bottom: 56px !important;
  }
  :where(.vuetify-styles) .py-lg-15 {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }
  :where(.vuetify-styles) .py-lg-16 {
    padding-top: 64px !important;
    padding-bottom: 64px !important;
  }
  :where(.vuetify-styles) .pt-lg-0 {
    padding-top: 0px !important;
  }
  :where(.vuetify-styles) .pt-lg-1 {
    padding-top: 4px !important;
  }
  :where(.vuetify-styles) .pt-lg-2 {
    padding-top: 8px !important;
  }
  :where(.vuetify-styles) .pt-lg-3 {
    padding-top: 12px !important;
  }
  :where(.vuetify-styles) .pt-lg-4 {
    padding-top: 16px !important;
  }
  :where(.vuetify-styles) .pt-lg-5 {
    padding-top: 20px !important;
  }
  :where(.vuetify-styles) .pt-lg-6 {
    padding-top: 24px !important;
  }
  :where(.vuetify-styles) .pt-lg-7 {
    padding-top: 28px !important;
  }
  :where(.vuetify-styles) .pt-lg-8 {
    padding-top: 32px !important;
  }
  :where(.vuetify-styles) .pt-lg-9 {
    padding-top: 36px !important;
  }
  :where(.vuetify-styles) .pt-lg-10 {
    padding-top: 40px !important;
  }
  :where(.vuetify-styles) .pt-lg-11 {
    padding-top: 44px !important;
  }
  :where(.vuetify-styles) .pt-lg-12 {
    padding-top: 48px !important;
  }
  :where(.vuetify-styles) .pt-lg-13 {
    padding-top: 52px !important;
  }
  :where(.vuetify-styles) .pt-lg-14 {
    padding-top: 56px !important;
  }
  :where(.vuetify-styles) .pt-lg-15 {
    padding-top: 60px !important;
  }
  :where(.vuetify-styles) .pt-lg-16 {
    padding-top: 64px !important;
  }
  :where(.vuetify-styles) .pr-lg-0 {
    padding-right: 0px !important;
  }
  :where(.vuetify-styles) .pr-lg-1 {
    padding-right: 4px !important;
  }
  :where(.vuetify-styles) .pr-lg-2 {
    padding-right: 8px !important;
  }
  :where(.vuetify-styles) .pr-lg-3 {
    padding-right: 12px !important;
  }
  :where(.vuetify-styles) .pr-lg-4 {
    padding-right: 16px !important;
  }
  :where(.vuetify-styles) .pr-lg-5 {
    padding-right: 20px !important;
  }
  :where(.vuetify-styles) .pr-lg-6 {
    padding-right: 24px !important;
  }
  :where(.vuetify-styles) .pr-lg-7 {
    padding-right: 28px !important;
  }
  :where(.vuetify-styles) .pr-lg-8 {
    padding-right: 32px !important;
  }
  :where(.vuetify-styles) .pr-lg-9 {
    padding-right: 36px !important;
  }
  :where(.vuetify-styles) .pr-lg-10 {
    padding-right: 40px !important;
  }
  :where(.vuetify-styles) .pr-lg-11 {
    padding-right: 44px !important;
  }
  :where(.vuetify-styles) .pr-lg-12 {
    padding-right: 48px !important;
  }
  :where(.vuetify-styles) .pr-lg-13 {
    padding-right: 52px !important;
  }
  :where(.vuetify-styles) .pr-lg-14 {
    padding-right: 56px !important;
  }
  :where(.vuetify-styles) .pr-lg-15 {
    padding-right: 60px !important;
  }
  :where(.vuetify-styles) .pr-lg-16 {
    padding-right: 64px !important;
  }
  :where(.vuetify-styles) .pb-lg-0 {
    padding-bottom: 0px !important;
  }
  :where(.vuetify-styles) .pb-lg-1 {
    padding-bottom: 4px !important;
  }
  :where(.vuetify-styles) .pb-lg-2 {
    padding-bottom: 8px !important;
  }
  :where(.vuetify-styles) .pb-lg-3 {
    padding-bottom: 12px !important;
  }
  :where(.vuetify-styles) .pb-lg-4 {
    padding-bottom: 16px !important;
  }
  :where(.vuetify-styles) .pb-lg-5 {
    padding-bottom: 20px !important;
  }
  :where(.vuetify-styles) .pb-lg-6 {
    padding-bottom: 24px !important;
  }
  :where(.vuetify-styles) .pb-lg-7 {
    padding-bottom: 28px !important;
  }
  :where(.vuetify-styles) .pb-lg-8 {
    padding-bottom: 32px !important;
  }
  :where(.vuetify-styles) .pb-lg-9 {
    padding-bottom: 36px !important;
  }
  :where(.vuetify-styles) .pb-lg-10 {
    padding-bottom: 40px !important;
  }
  :where(.vuetify-styles) .pb-lg-11 {
    padding-bottom: 44px !important;
  }
  :where(.vuetify-styles) .pb-lg-12 {
    padding-bottom: 48px !important;
  }
  :where(.vuetify-styles) .pb-lg-13 {
    padding-bottom: 52px !important;
  }
  :where(.vuetify-styles) .pb-lg-14 {
    padding-bottom: 56px !important;
  }
  :where(.vuetify-styles) .pb-lg-15 {
    padding-bottom: 60px !important;
  }
  :where(.vuetify-styles) .pb-lg-16 {
    padding-bottom: 64px !important;
  }
  :where(.vuetify-styles) .pl-lg-0 {
    padding-left: 0px !important;
  }
  :where(.vuetify-styles) .pl-lg-1 {
    padding-left: 4px !important;
  }
  :where(.vuetify-styles) .pl-lg-2 {
    padding-left: 8px !important;
  }
  :where(.vuetify-styles) .pl-lg-3 {
    padding-left: 12px !important;
  }
  :where(.vuetify-styles) .pl-lg-4 {
    padding-left: 16px !important;
  }
  :where(.vuetify-styles) .pl-lg-5 {
    padding-left: 20px !important;
  }
  :where(.vuetify-styles) .pl-lg-6 {
    padding-left: 24px !important;
  }
  :where(.vuetify-styles) .pl-lg-7 {
    padding-left: 28px !important;
  }
  :where(.vuetify-styles) .pl-lg-8 {
    padding-left: 32px !important;
  }
  :where(.vuetify-styles) .pl-lg-9 {
    padding-left: 36px !important;
  }
  :where(.vuetify-styles) .pl-lg-10 {
    padding-left: 40px !important;
  }
  :where(.vuetify-styles) .pl-lg-11 {
    padding-left: 44px !important;
  }
  :where(.vuetify-styles) .pl-lg-12 {
    padding-left: 48px !important;
  }
  :where(.vuetify-styles) .pl-lg-13 {
    padding-left: 52px !important;
  }
  :where(.vuetify-styles) .pl-lg-14 {
    padding-left: 56px !important;
  }
  :where(.vuetify-styles) .pl-lg-15 {
    padding-left: 60px !important;
  }
  :where(.vuetify-styles) .pl-lg-16 {
    padding-left: 64px !important;
  }
  :where(.vuetify-styles) .ps-lg-0 {
    padding-inline-start: 0px !important;
  }
  :where(.vuetify-styles) .ps-lg-1 {
    padding-inline-start: 4px !important;
  }
  :where(.vuetify-styles) .ps-lg-2 {
    padding-inline-start: 8px !important;
  }
  :where(.vuetify-styles) .ps-lg-3 {
    padding-inline-start: 12px !important;
  }
  :where(.vuetify-styles) .ps-lg-4 {
    padding-inline-start: 16px !important;
  }
  :where(.vuetify-styles) .ps-lg-5 {
    padding-inline-start: 20px !important;
  }
  :where(.vuetify-styles) .ps-lg-6 {
    padding-inline-start: 24px !important;
  }
  :where(.vuetify-styles) .ps-lg-7 {
    padding-inline-start: 28px !important;
  }
  :where(.vuetify-styles) .ps-lg-8 {
    padding-inline-start: 32px !important;
  }
  :where(.vuetify-styles) .ps-lg-9 {
    padding-inline-start: 36px !important;
  }
  :where(.vuetify-styles) .ps-lg-10 {
    padding-inline-start: 40px !important;
  }
  :where(.vuetify-styles) .ps-lg-11 {
    padding-inline-start: 44px !important;
  }
  :where(.vuetify-styles) .ps-lg-12 {
    padding-inline-start: 48px !important;
  }
  :where(.vuetify-styles) .ps-lg-13 {
    padding-inline-start: 52px !important;
  }
  :where(.vuetify-styles) .ps-lg-14 {
    padding-inline-start: 56px !important;
  }
  :where(.vuetify-styles) .ps-lg-15 {
    padding-inline-start: 60px !important;
  }
  :where(.vuetify-styles) .ps-lg-16 {
    padding-inline-start: 64px !important;
  }
  :where(.vuetify-styles) .pe-lg-0 {
    padding-inline-end: 0px !important;
  }
  :where(.vuetify-styles) .pe-lg-1 {
    padding-inline-end: 4px !important;
  }
  :where(.vuetify-styles) .pe-lg-2 {
    padding-inline-end: 8px !important;
  }
  :where(.vuetify-styles) .pe-lg-3 {
    padding-inline-end: 12px !important;
  }
  :where(.vuetify-styles) .pe-lg-4 {
    padding-inline-end: 16px !important;
  }
  :where(.vuetify-styles) .pe-lg-5 {
    padding-inline-end: 20px !important;
  }
  :where(.vuetify-styles) .pe-lg-6 {
    padding-inline-end: 24px !important;
  }
  :where(.vuetify-styles) .pe-lg-7 {
    padding-inline-end: 28px !important;
  }
  :where(.vuetify-styles) .pe-lg-8 {
    padding-inline-end: 32px !important;
  }
  :where(.vuetify-styles) .pe-lg-9 {
    padding-inline-end: 36px !important;
  }
  :where(.vuetify-styles) .pe-lg-10 {
    padding-inline-end: 40px !important;
  }
  :where(.vuetify-styles) .pe-lg-11 {
    padding-inline-end: 44px !important;
  }
  :where(.vuetify-styles) .pe-lg-12 {
    padding-inline-end: 48px !important;
  }
  :where(.vuetify-styles) .pe-lg-13 {
    padding-inline-end: 52px !important;
  }
  :where(.vuetify-styles) .pe-lg-14 {
    padding-inline-end: 56px !important;
  }
  :where(.vuetify-styles) .pe-lg-15 {
    padding-inline-end: 60px !important;
  }
  :where(.vuetify-styles) .pe-lg-16 {
    padding-inline-end: 64px !important;
  }
  :where(.vuetify-styles) .text-lg-left {
    text-align: left !important;
  }
  :where(.vuetify-styles) .text-lg-right {
    text-align: right !important;
  }
  :where(.vuetify-styles) .text-lg-center {
    text-align: center !important;
  }
  :where(.vuetify-styles) .text-lg-justify {
    text-align: justify !important;
  }
  :where(.vuetify-styles) .text-lg-start {
    text-align: start !important;
  }
  :where(.vuetify-styles) .text-lg-end {
    text-align: end !important;
  }
  :where(.vuetify-styles) .text-lg-h1 {
    font-size: 6rem !important;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.015625em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-lg-h2 {
    font-size: 3.75rem !important;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.0083333333em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-lg-h3 {
    font-size: 3rem !important;
    font-weight: 400;
    line-height: 1.05;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-lg-h4 {
    font-size: 2.125rem !important;
    font-weight: 400;
    line-height: 1.175;
    letter-spacing: 0.0073529412em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-lg-h5 {
    font-size: 1.5rem !important;
    font-weight: 400;
    line-height: 1.333;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-lg-h6 {
    font-size: 1.25rem !important;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: 0.0125em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-lg-subtitle-1 {
    font-size: 1rem !important;
    font-weight: normal;
    line-height: 1.75;
    letter-spacing: 0.009375em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-lg-subtitle-2 {
    font-size: 0.875rem !important;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: 0.0071428571em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-lg-body-1 {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.03125em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-lg-body-2 {
    font-size: 0.875rem !important;
    font-weight: 400;
    line-height: 1.425;
    letter-spacing: 0.0178571429em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-lg-button {
    font-size: 0.875rem !important;
    font-weight: 500;
    line-height: 2.6;
    letter-spacing: 0.0892857143em !important;
    font-family: "Roboto", sans-serif;
    text-transform: uppercase !important;
  }
  :where(.vuetify-styles) .text-lg-caption {
    font-size: 0.75rem !important;
    font-weight: 400;
    line-height: 1.667;
    letter-spacing: 0.0333333333em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-lg-overline {
    font-size: 0.75rem !important;
    font-weight: 500;
    line-height: 2.667;
    letter-spacing: 0.1666666667em !important;
    font-family: "Roboto", sans-serif;
    text-transform: uppercase !important;
  }
  :where(.vuetify-styles) .h-lg-auto {
    height: auto !important;
  }
  :where(.vuetify-styles) .h-lg-screen {
    height: 100vh !important;
  }
  :where(.vuetify-styles) .h-lg-0 {
    height: 0 !important;
  }
  :where(.vuetify-styles) .h-lg-25 {
    height: 25% !important;
  }
  :where(.vuetify-styles) .h-lg-50 {
    height: 50% !important;
  }
  :where(.vuetify-styles) .h-lg-75 {
    height: 75% !important;
  }
  :where(.vuetify-styles) .h-lg-100 {
    height: 100% !important;
  }
  :where(.vuetify-styles) .w-lg-auto {
    width: auto !important;
  }
  :where(.vuetify-styles) .w-lg-0 {
    width: 0 !important;
  }
  :where(.vuetify-styles) .w-lg-25 {
    width: 25% !important;
  }
  :where(.vuetify-styles) .w-lg-33 {
    width: 33% !important;
  }
  :where(.vuetify-styles) .w-lg-50 {
    width: 50% !important;
  }
  :where(.vuetify-styles) .w-lg-66 {
    width: 66% !important;
  }
  :where(.vuetify-styles) .w-lg-75 {
    width: 75% !important;
  }
  :where(.vuetify-styles) .w-lg-100 {
    width: 100% !important;
  }
}
@media (min-width: 1920px) {
  :where(.vuetify-styles) .d-xl-none {
    display: none !important;
  }
  :where(.vuetify-styles) .d-xl-inline {
    display: inline !important;
  }
  :where(.vuetify-styles) .d-xl-inline-block {
    display: inline-block !important;
  }
  :where(.vuetify-styles) .d-xl-block {
    display: block !important;
  }
  :where(.vuetify-styles) .d-xl-table {
    display: table !important;
  }
  :where(.vuetify-styles) .d-xl-table-row {
    display: table-row !important;
  }
  :where(.vuetify-styles) .d-xl-table-cell {
    display: table-cell !important;
  }
  :where(.vuetify-styles) .d-xl-flex {
    display: flex !important;
  }
  :where(.vuetify-styles) .d-xl-inline-flex {
    display: inline-flex !important;
  }
  :where(.vuetify-styles) .float-xl-none {
    float: none !important;
  }
  :where(.vuetify-styles) .float-xl-left {
    float: left !important;
  }
  :where(.vuetify-styles) .float-xl-right {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-rtl .float-xl-end {
    float: left !important;
  }
  :where(.vuetify-styles) .v-locale--is-rtl .float-xl-start {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-ltr .float-xl-end {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-ltr .float-xl-start {
    float: left !important;
  }
  :where(.vuetify-styles) .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  :where(.vuetify-styles) .flex-xl-1-1 {
    flex: 1 1 auto !important;
  }
  :where(.vuetify-styles) .flex-xl-1-0 {
    flex: 1 0 auto !important;
  }
  :where(.vuetify-styles) .flex-xl-0-1 {
    flex: 0 1 auto !important;
  }
  :where(.vuetify-styles) .flex-xl-0-0 {
    flex: 0 0 auto !important;
  }
  :where(.vuetify-styles) .flex-xl-1-1-100 {
    flex: 1 1 100% !important;
  }
  :where(.vuetify-styles) .flex-xl-1-0-100 {
    flex: 1 0 100% !important;
  }
  :where(.vuetify-styles) .flex-xl-0-1-100 {
    flex: 0 1 100% !important;
  }
  :where(.vuetify-styles) .flex-xl-0-0-100 {
    flex: 0 0 100% !important;
  }
  :where(.vuetify-styles) .flex-xl-1-1-0 {
    flex: 1 1 0 !important;
  }
  :where(.vuetify-styles) .flex-xl-1-0-0 {
    flex: 1 0 0 !important;
  }
  :where(.vuetify-styles) .flex-xl-0-1-0 {
    flex: 0 1 0 !important;
  }
  :where(.vuetify-styles) .flex-xl-0-0-0 {
    flex: 0 0 0 !important;
  }
  :where(.vuetify-styles) .flex-xl-row {
    flex-direction: row !important;
  }
  :where(.vuetify-styles) .flex-xl-column {
    flex-direction: column !important;
  }
  :where(.vuetify-styles) .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  :where(.vuetify-styles) .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  :where(.vuetify-styles) .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  :where(.vuetify-styles) .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  :where(.vuetify-styles) .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  :where(.vuetify-styles) .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  :where(.vuetify-styles) .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  :where(.vuetify-styles) .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  :where(.vuetify-styles) .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :where(.vuetify-styles) .justify-xl-start {
    justify-content: flex-start !important;
  }
  :where(.vuetify-styles) .justify-xl-end {
    justify-content: flex-end !important;
  }
  :where(.vuetify-styles) .justify-xl-center {
    justify-content: center !important;
  }
  :where(.vuetify-styles) .justify-xl-space-between {
    justify-content: space-between !important;
  }
  :where(.vuetify-styles) .justify-xl-space-around {
    justify-content: space-around !important;
  }
  :where(.vuetify-styles) .justify-xl-space-evenly {
    justify-content: space-evenly !important;
  }
  :where(.vuetify-styles) .justify-items-xl-start {
    justify-items: flex-start !important;
  }
  :where(.vuetify-styles) .justify-items-xl-end {
    justify-items: flex-end !important;
  }
  :where(.vuetify-styles) .justify-items-xl-center {
    justify-items: center !important;
  }
  :where(.vuetify-styles) .justify-items-xl-stretch {
    justify-items: stretch !important;
  }
  :where(.vuetify-styles) .align-xl-start {
    align-items: flex-start !important;
  }
  :where(.vuetify-styles) .align-xl-end {
    align-items: flex-end !important;
  }
  :where(.vuetify-styles) .align-xl-center {
    align-items: center !important;
  }
  :where(.vuetify-styles) .align-xl-baseline {
    align-items: baseline !important;
  }
  :where(.vuetify-styles) .align-xl-stretch {
    align-items: stretch !important;
  }
  :where(.vuetify-styles) .align-content-xl-start {
    align-content: flex-start !important;
  }
  :where(.vuetify-styles) .align-content-xl-end {
    align-content: flex-end !important;
  }
  :where(.vuetify-styles) .align-content-xl-center {
    align-content: center !important;
  }
  :where(.vuetify-styles) .align-content-xl-space-between {
    align-content: space-between !important;
  }
  :where(.vuetify-styles) .align-content-xl-space-around {
    align-content: space-around !important;
  }
  :where(.vuetify-styles) .align-content-xl-space-evenly {
    align-content: space-evenly !important;
  }
  :where(.vuetify-styles) .align-content-xl-stretch {
    align-content: stretch !important;
  }
  :where(.vuetify-styles) .align-self-xl-auto {
    align-self: auto !important;
  }
  :where(.vuetify-styles) .align-self-xl-start {
    align-self: flex-start !important;
  }
  :where(.vuetify-styles) .align-self-xl-end {
    align-self: flex-end !important;
  }
  :where(.vuetify-styles) .align-self-xl-center {
    align-self: center !important;
  }
  :where(.vuetify-styles) .align-self-xl-baseline {
    align-self: baseline !important;
  }
  :where(.vuetify-styles) .align-self-xl-stretch {
    align-self: stretch !important;
  }
  :where(.vuetify-styles) .order-xl-first {
    order: -1 !important;
  }
  :where(.vuetify-styles) .order-xl-0 {
    order: 0 !important;
  }
  :where(.vuetify-styles) .order-xl-1 {
    order: 1 !important;
  }
  :where(.vuetify-styles) .order-xl-2 {
    order: 2 !important;
  }
  :where(.vuetify-styles) .order-xl-3 {
    order: 3 !important;
  }
  :where(.vuetify-styles) .order-xl-4 {
    order: 4 !important;
  }
  :where(.vuetify-styles) .order-xl-5 {
    order: 5 !important;
  }
  :where(.vuetify-styles) .order-xl-6 {
    order: 6 !important;
  }
  :where(.vuetify-styles) .order-xl-7 {
    order: 7 !important;
  }
  :where(.vuetify-styles) .order-xl-8 {
    order: 8 !important;
  }
  :where(.vuetify-styles) .order-xl-9 {
    order: 9 !important;
  }
  :where(.vuetify-styles) .order-xl-10 {
    order: 10 !important;
  }
  :where(.vuetify-styles) .order-xl-11 {
    order: 11 !important;
  }
  :where(.vuetify-styles) .order-xl-12 {
    order: 12 !important;
  }
  :where(.vuetify-styles) .order-xl-last {
    order: 13 !important;
  }
  :where(.vuetify-styles) .ga-xl-0 {
    gap: 0px !important;
  }
  :where(.vuetify-styles) .ga-xl-1 {
    gap: 4px !important;
  }
  :where(.vuetify-styles) .ga-xl-2 {
    gap: 8px !important;
  }
  :where(.vuetify-styles) .ga-xl-3 {
    gap: 12px !important;
  }
  :where(.vuetify-styles) .ga-xl-4 {
    gap: 16px !important;
  }
  :where(.vuetify-styles) .ga-xl-5 {
    gap: 20px !important;
  }
  :where(.vuetify-styles) .ga-xl-6 {
    gap: 24px !important;
  }
  :where(.vuetify-styles) .ga-xl-7 {
    gap: 28px !important;
  }
  :where(.vuetify-styles) .ga-xl-8 {
    gap: 32px !important;
  }
  :where(.vuetify-styles) .ga-xl-9 {
    gap: 36px !important;
  }
  :where(.vuetify-styles) .ga-xl-10 {
    gap: 40px !important;
  }
  :where(.vuetify-styles) .ga-xl-11 {
    gap: 44px !important;
  }
  :where(.vuetify-styles) .ga-xl-12 {
    gap: 48px !important;
  }
  :where(.vuetify-styles) .ga-xl-13 {
    gap: 52px !important;
  }
  :where(.vuetify-styles) .ga-xl-14 {
    gap: 56px !important;
  }
  :where(.vuetify-styles) .ga-xl-15 {
    gap: 60px !important;
  }
  :where(.vuetify-styles) .ga-xl-16 {
    gap: 64px !important;
  }
  :where(.vuetify-styles) .ga-xl-auto {
    gap: auto !important;
  }
  :where(.vuetify-styles) .gr-xl-0 {
    row-gap: 0px !important;
  }
  :where(.vuetify-styles) .gr-xl-1 {
    row-gap: 4px !important;
  }
  :where(.vuetify-styles) .gr-xl-2 {
    row-gap: 8px !important;
  }
  :where(.vuetify-styles) .gr-xl-3 {
    row-gap: 12px !important;
  }
  :where(.vuetify-styles) .gr-xl-4 {
    row-gap: 16px !important;
  }
  :where(.vuetify-styles) .gr-xl-5 {
    row-gap: 20px !important;
  }
  :where(.vuetify-styles) .gr-xl-6 {
    row-gap: 24px !important;
  }
  :where(.vuetify-styles) .gr-xl-7 {
    row-gap: 28px !important;
  }
  :where(.vuetify-styles) .gr-xl-8 {
    row-gap: 32px !important;
  }
  :where(.vuetify-styles) .gr-xl-9 {
    row-gap: 36px !important;
  }
  :where(.vuetify-styles) .gr-xl-10 {
    row-gap: 40px !important;
  }
  :where(.vuetify-styles) .gr-xl-11 {
    row-gap: 44px !important;
  }
  :where(.vuetify-styles) .gr-xl-12 {
    row-gap: 48px !important;
  }
  :where(.vuetify-styles) .gr-xl-13 {
    row-gap: 52px !important;
  }
  :where(.vuetify-styles) .gr-xl-14 {
    row-gap: 56px !important;
  }
  :where(.vuetify-styles) .gr-xl-15 {
    row-gap: 60px !important;
  }
  :where(.vuetify-styles) .gr-xl-16 {
    row-gap: 64px !important;
  }
  :where(.vuetify-styles) .gr-xl-auto {
    row-gap: auto !important;
  }
  :where(.vuetify-styles) .gc-xl-0 {
    column-gap: 0px !important;
  }
  :where(.vuetify-styles) .gc-xl-1 {
    column-gap: 4px !important;
  }
  :where(.vuetify-styles) .gc-xl-2 {
    column-gap: 8px !important;
  }
  :where(.vuetify-styles) .gc-xl-3 {
    column-gap: 12px !important;
  }
  :where(.vuetify-styles) .gc-xl-4 {
    column-gap: 16px !important;
  }
  :where(.vuetify-styles) .gc-xl-5 {
    column-gap: 20px !important;
  }
  :where(.vuetify-styles) .gc-xl-6 {
    column-gap: 24px !important;
  }
  :where(.vuetify-styles) .gc-xl-7 {
    column-gap: 28px !important;
  }
  :where(.vuetify-styles) .gc-xl-8 {
    column-gap: 32px !important;
  }
  :where(.vuetify-styles) .gc-xl-9 {
    column-gap: 36px !important;
  }
  :where(.vuetify-styles) .gc-xl-10 {
    column-gap: 40px !important;
  }
  :where(.vuetify-styles) .gc-xl-11 {
    column-gap: 44px !important;
  }
  :where(.vuetify-styles) .gc-xl-12 {
    column-gap: 48px !important;
  }
  :where(.vuetify-styles) .gc-xl-13 {
    column-gap: 52px !important;
  }
  :where(.vuetify-styles) .gc-xl-14 {
    column-gap: 56px !important;
  }
  :where(.vuetify-styles) .gc-xl-15 {
    column-gap: 60px !important;
  }
  :where(.vuetify-styles) .gc-xl-16 {
    column-gap: 64px !important;
  }
  :where(.vuetify-styles) .gc-xl-auto {
    column-gap: auto !important;
  }
  :where(.vuetify-styles) .ma-xl-0 {
    margin: 0px !important;
  }
  :where(.vuetify-styles) .ma-xl-1 {
    margin: 4px !important;
  }
  :where(.vuetify-styles) .ma-xl-2 {
    margin: 8px !important;
  }
  :where(.vuetify-styles) .ma-xl-3 {
    margin: 12px !important;
  }
  :where(.vuetify-styles) .ma-xl-4 {
    margin: 16px !important;
  }
  :where(.vuetify-styles) .ma-xl-5 {
    margin: 20px !important;
  }
  :where(.vuetify-styles) .ma-xl-6 {
    margin: 24px !important;
  }
  :where(.vuetify-styles) .ma-xl-7 {
    margin: 28px !important;
  }
  :where(.vuetify-styles) .ma-xl-8 {
    margin: 32px !important;
  }
  :where(.vuetify-styles) .ma-xl-9 {
    margin: 36px !important;
  }
  :where(.vuetify-styles) .ma-xl-10 {
    margin: 40px !important;
  }
  :where(.vuetify-styles) .ma-xl-11 {
    margin: 44px !important;
  }
  :where(.vuetify-styles) .ma-xl-12 {
    margin: 48px !important;
  }
  :where(.vuetify-styles) .ma-xl-13 {
    margin: 52px !important;
  }
  :where(.vuetify-styles) .ma-xl-14 {
    margin: 56px !important;
  }
  :where(.vuetify-styles) .ma-xl-15 {
    margin: 60px !important;
  }
  :where(.vuetify-styles) .ma-xl-16 {
    margin: 64px !important;
  }
  :where(.vuetify-styles) .ma-xl-auto {
    margin: auto !important;
  }
  :where(.vuetify-styles) .mx-xl-0 {
    margin-right: 0px !important;
    margin-left: 0px !important;
  }
  :where(.vuetify-styles) .mx-xl-1 {
    margin-right: 4px !important;
    margin-left: 4px !important;
  }
  :where(.vuetify-styles) .mx-xl-2 {
    margin-right: 8px !important;
    margin-left: 8px !important;
  }
  :where(.vuetify-styles) .mx-xl-3 {
    margin-right: 12px !important;
    margin-left: 12px !important;
  }
  :where(.vuetify-styles) .mx-xl-4 {
    margin-right: 16px !important;
    margin-left: 16px !important;
  }
  :where(.vuetify-styles) .mx-xl-5 {
    margin-right: 20px !important;
    margin-left: 20px !important;
  }
  :where(.vuetify-styles) .mx-xl-6 {
    margin-right: 24px !important;
    margin-left: 24px !important;
  }
  :where(.vuetify-styles) .mx-xl-7 {
    margin-right: 28px !important;
    margin-left: 28px !important;
  }
  :where(.vuetify-styles) .mx-xl-8 {
    margin-right: 32px !important;
    margin-left: 32px !important;
  }
  :where(.vuetify-styles) .mx-xl-9 {
    margin-right: 36px !important;
    margin-left: 36px !important;
  }
  :where(.vuetify-styles) .mx-xl-10 {
    margin-right: 40px !important;
    margin-left: 40px !important;
  }
  :where(.vuetify-styles) .mx-xl-11 {
    margin-right: 44px !important;
    margin-left: 44px !important;
  }
  :where(.vuetify-styles) .mx-xl-12 {
    margin-right: 48px !important;
    margin-left: 48px !important;
  }
  :where(.vuetify-styles) .mx-xl-13 {
    margin-right: 52px !important;
    margin-left: 52px !important;
  }
  :where(.vuetify-styles) .mx-xl-14 {
    margin-right: 56px !important;
    margin-left: 56px !important;
  }
  :where(.vuetify-styles) .mx-xl-15 {
    margin-right: 60px !important;
    margin-left: 60px !important;
  }
  :where(.vuetify-styles) .mx-xl-16 {
    margin-right: 64px !important;
    margin-left: 64px !important;
  }
  :where(.vuetify-styles) .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  :where(.vuetify-styles) .my-xl-0 {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  :where(.vuetify-styles) .my-xl-1 {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }
  :where(.vuetify-styles) .my-xl-2 {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }
  :where(.vuetify-styles) .my-xl-3 {
    margin-top: 12px !important;
    margin-bottom: 12px !important;
  }
  :where(.vuetify-styles) .my-xl-4 {
    margin-top: 16px !important;
    margin-bottom: 16px !important;
  }
  :where(.vuetify-styles) .my-xl-5 {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  :where(.vuetify-styles) .my-xl-6 {
    margin-top: 24px !important;
    margin-bottom: 24px !important;
  }
  :where(.vuetify-styles) .my-xl-7 {
    margin-top: 28px !important;
    margin-bottom: 28px !important;
  }
  :where(.vuetify-styles) .my-xl-8 {
    margin-top: 32px !important;
    margin-bottom: 32px !important;
  }
  :where(.vuetify-styles) .my-xl-9 {
    margin-top: 36px !important;
    margin-bottom: 36px !important;
  }
  :where(.vuetify-styles) .my-xl-10 {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  :where(.vuetify-styles) .my-xl-11 {
    margin-top: 44px !important;
    margin-bottom: 44px !important;
  }
  :where(.vuetify-styles) .my-xl-12 {
    margin-top: 48px !important;
    margin-bottom: 48px !important;
  }
  :where(.vuetify-styles) .my-xl-13 {
    margin-top: 52px !important;
    margin-bottom: 52px !important;
  }
  :where(.vuetify-styles) .my-xl-14 {
    margin-top: 56px !important;
    margin-bottom: 56px !important;
  }
  :where(.vuetify-styles) .my-xl-15 {
    margin-top: 60px !important;
    margin-bottom: 60px !important;
  }
  :where(.vuetify-styles) .my-xl-16 {
    margin-top: 64px !important;
    margin-bottom: 64px !important;
  }
  :where(.vuetify-styles) .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  :where(.vuetify-styles) .mt-xl-0 {
    margin-top: 0px !important;
  }
  :where(.vuetify-styles) .mt-xl-1 {
    margin-top: 4px !important;
  }
  :where(.vuetify-styles) .mt-xl-2 {
    margin-top: 8px !important;
  }
  :where(.vuetify-styles) .mt-xl-3 {
    margin-top: 12px !important;
  }
  :where(.vuetify-styles) .mt-xl-4 {
    margin-top: 16px !important;
  }
  :where(.vuetify-styles) .mt-xl-5 {
    margin-top: 20px !important;
  }
  :where(.vuetify-styles) .mt-xl-6 {
    margin-top: 24px !important;
  }
  :where(.vuetify-styles) .mt-xl-7 {
    margin-top: 28px !important;
  }
  :where(.vuetify-styles) .mt-xl-8 {
    margin-top: 32px !important;
  }
  :where(.vuetify-styles) .mt-xl-9 {
    margin-top: 36px !important;
  }
  :where(.vuetify-styles) .mt-xl-10 {
    margin-top: 40px !important;
  }
  :where(.vuetify-styles) .mt-xl-11 {
    margin-top: 44px !important;
  }
  :where(.vuetify-styles) .mt-xl-12 {
    margin-top: 48px !important;
  }
  :where(.vuetify-styles) .mt-xl-13 {
    margin-top: 52px !important;
  }
  :where(.vuetify-styles) .mt-xl-14 {
    margin-top: 56px !important;
  }
  :where(.vuetify-styles) .mt-xl-15 {
    margin-top: 60px !important;
  }
  :where(.vuetify-styles) .mt-xl-16 {
    margin-top: 64px !important;
  }
  :where(.vuetify-styles) .mt-xl-auto {
    margin-top: auto !important;
  }
  :where(.vuetify-styles) .mr-xl-0 {
    margin-right: 0px !important;
  }
  :where(.vuetify-styles) .mr-xl-1 {
    margin-right: 4px !important;
  }
  :where(.vuetify-styles) .mr-xl-2 {
    margin-right: 8px !important;
  }
  :where(.vuetify-styles) .mr-xl-3 {
    margin-right: 12px !important;
  }
  :where(.vuetify-styles) .mr-xl-4 {
    margin-right: 16px !important;
  }
  :where(.vuetify-styles) .mr-xl-5 {
    margin-right: 20px !important;
  }
  :where(.vuetify-styles) .mr-xl-6 {
    margin-right: 24px !important;
  }
  :where(.vuetify-styles) .mr-xl-7 {
    margin-right: 28px !important;
  }
  :where(.vuetify-styles) .mr-xl-8 {
    margin-right: 32px !important;
  }
  :where(.vuetify-styles) .mr-xl-9 {
    margin-right: 36px !important;
  }
  :where(.vuetify-styles) .mr-xl-10 {
    margin-right: 40px !important;
  }
  :where(.vuetify-styles) .mr-xl-11 {
    margin-right: 44px !important;
  }
  :where(.vuetify-styles) .mr-xl-12 {
    margin-right: 48px !important;
  }
  :where(.vuetify-styles) .mr-xl-13 {
    margin-right: 52px !important;
  }
  :where(.vuetify-styles) .mr-xl-14 {
    margin-right: 56px !important;
  }
  :where(.vuetify-styles) .mr-xl-15 {
    margin-right: 60px !important;
  }
  :where(.vuetify-styles) .mr-xl-16 {
    margin-right: 64px !important;
  }
  :where(.vuetify-styles) .mr-xl-auto {
    margin-right: auto !important;
  }
  :where(.vuetify-styles) .mb-xl-0 {
    margin-bottom: 0px !important;
  }
  :where(.vuetify-styles) .mb-xl-1 {
    margin-bottom: 4px !important;
  }
  :where(.vuetify-styles) .mb-xl-2 {
    margin-bottom: 8px !important;
  }
  :where(.vuetify-styles) .mb-xl-3 {
    margin-bottom: 12px !important;
  }
  :where(.vuetify-styles) .mb-xl-4 {
    margin-bottom: 16px !important;
  }
  :where(.vuetify-styles) .mb-xl-5 {
    margin-bottom: 20px !important;
  }
  :where(.vuetify-styles) .mb-xl-6 {
    margin-bottom: 24px !important;
  }
  :where(.vuetify-styles) .mb-xl-7 {
    margin-bottom: 28px !important;
  }
  :where(.vuetify-styles) .mb-xl-8 {
    margin-bottom: 32px !important;
  }
  :where(.vuetify-styles) .mb-xl-9 {
    margin-bottom: 36px !important;
  }
  :where(.vuetify-styles) .mb-xl-10 {
    margin-bottom: 40px !important;
  }
  :where(.vuetify-styles) .mb-xl-11 {
    margin-bottom: 44px !important;
  }
  :where(.vuetify-styles) .mb-xl-12 {
    margin-bottom: 48px !important;
  }
  :where(.vuetify-styles) .mb-xl-13 {
    margin-bottom: 52px !important;
  }
  :where(.vuetify-styles) .mb-xl-14 {
    margin-bottom: 56px !important;
  }
  :where(.vuetify-styles) .mb-xl-15 {
    margin-bottom: 60px !important;
  }
  :where(.vuetify-styles) .mb-xl-16 {
    margin-bottom: 64px !important;
  }
  :where(.vuetify-styles) .mb-xl-auto {
    margin-bottom: auto !important;
  }
  :where(.vuetify-styles) .ml-xl-0 {
    margin-left: 0px !important;
  }
  :where(.vuetify-styles) .ml-xl-1 {
    margin-left: 4px !important;
  }
  :where(.vuetify-styles) .ml-xl-2 {
    margin-left: 8px !important;
  }
  :where(.vuetify-styles) .ml-xl-3 {
    margin-left: 12px !important;
  }
  :where(.vuetify-styles) .ml-xl-4 {
    margin-left: 16px !important;
  }
  :where(.vuetify-styles) .ml-xl-5 {
    margin-left: 20px !important;
  }
  :where(.vuetify-styles) .ml-xl-6 {
    margin-left: 24px !important;
  }
  :where(.vuetify-styles) .ml-xl-7 {
    margin-left: 28px !important;
  }
  :where(.vuetify-styles) .ml-xl-8 {
    margin-left: 32px !important;
  }
  :where(.vuetify-styles) .ml-xl-9 {
    margin-left: 36px !important;
  }
  :where(.vuetify-styles) .ml-xl-10 {
    margin-left: 40px !important;
  }
  :where(.vuetify-styles) .ml-xl-11 {
    margin-left: 44px !important;
  }
  :where(.vuetify-styles) .ml-xl-12 {
    margin-left: 48px !important;
  }
  :where(.vuetify-styles) .ml-xl-13 {
    margin-left: 52px !important;
  }
  :where(.vuetify-styles) .ml-xl-14 {
    margin-left: 56px !important;
  }
  :where(.vuetify-styles) .ml-xl-15 {
    margin-left: 60px !important;
  }
  :where(.vuetify-styles) .ml-xl-16 {
    margin-left: 64px !important;
  }
  :where(.vuetify-styles) .ml-xl-auto {
    margin-left: auto !important;
  }
  :where(.vuetify-styles) .ms-xl-0 {
    margin-inline-start: 0px !important;
  }
  :where(.vuetify-styles) .ms-xl-1 {
    margin-inline-start: 4px !important;
  }
  :where(.vuetify-styles) .ms-xl-2 {
    margin-inline-start: 8px !important;
  }
  :where(.vuetify-styles) .ms-xl-3 {
    margin-inline-start: 12px !important;
  }
  :where(.vuetify-styles) .ms-xl-4 {
    margin-inline-start: 16px !important;
  }
  :where(.vuetify-styles) .ms-xl-5 {
    margin-inline-start: 20px !important;
  }
  :where(.vuetify-styles) .ms-xl-6 {
    margin-inline-start: 24px !important;
  }
  :where(.vuetify-styles) .ms-xl-7 {
    margin-inline-start: 28px !important;
  }
  :where(.vuetify-styles) .ms-xl-8 {
    margin-inline-start: 32px !important;
  }
  :where(.vuetify-styles) .ms-xl-9 {
    margin-inline-start: 36px !important;
  }
  :where(.vuetify-styles) .ms-xl-10 {
    margin-inline-start: 40px !important;
  }
  :where(.vuetify-styles) .ms-xl-11 {
    margin-inline-start: 44px !important;
  }
  :where(.vuetify-styles) .ms-xl-12 {
    margin-inline-start: 48px !important;
  }
  :where(.vuetify-styles) .ms-xl-13 {
    margin-inline-start: 52px !important;
  }
  :where(.vuetify-styles) .ms-xl-14 {
    margin-inline-start: 56px !important;
  }
  :where(.vuetify-styles) .ms-xl-15 {
    margin-inline-start: 60px !important;
  }
  :where(.vuetify-styles) .ms-xl-16 {
    margin-inline-start: 64px !important;
  }
  :where(.vuetify-styles) .ms-xl-auto {
    margin-inline-start: auto !important;
  }
  :where(.vuetify-styles) .me-xl-0 {
    margin-inline-end: 0px !important;
  }
  :where(.vuetify-styles) .me-xl-1 {
    margin-inline-end: 4px !important;
  }
  :where(.vuetify-styles) .me-xl-2 {
    margin-inline-end: 8px !important;
  }
  :where(.vuetify-styles) .me-xl-3 {
    margin-inline-end: 12px !important;
  }
  :where(.vuetify-styles) .me-xl-4 {
    margin-inline-end: 16px !important;
  }
  :where(.vuetify-styles) .me-xl-5 {
    margin-inline-end: 20px !important;
  }
  :where(.vuetify-styles) .me-xl-6 {
    margin-inline-end: 24px !important;
  }
  :where(.vuetify-styles) .me-xl-7 {
    margin-inline-end: 28px !important;
  }
  :where(.vuetify-styles) .me-xl-8 {
    margin-inline-end: 32px !important;
  }
  :where(.vuetify-styles) .me-xl-9 {
    margin-inline-end: 36px !important;
  }
  :where(.vuetify-styles) .me-xl-10 {
    margin-inline-end: 40px !important;
  }
  :where(.vuetify-styles) .me-xl-11 {
    margin-inline-end: 44px !important;
  }
  :where(.vuetify-styles) .me-xl-12 {
    margin-inline-end: 48px !important;
  }
  :where(.vuetify-styles) .me-xl-13 {
    margin-inline-end: 52px !important;
  }
  :where(.vuetify-styles) .me-xl-14 {
    margin-inline-end: 56px !important;
  }
  :where(.vuetify-styles) .me-xl-15 {
    margin-inline-end: 60px !important;
  }
  :where(.vuetify-styles) .me-xl-16 {
    margin-inline-end: 64px !important;
  }
  :where(.vuetify-styles) .me-xl-auto {
    margin-inline-end: auto !important;
  }
  :where(.vuetify-styles) .ma-xl-n1 {
    margin: -4px !important;
  }
  :where(.vuetify-styles) .ma-xl-n2 {
    margin: -8px !important;
  }
  :where(.vuetify-styles) .ma-xl-n3 {
    margin: -12px !important;
  }
  :where(.vuetify-styles) .ma-xl-n4 {
    margin: -16px !important;
  }
  :where(.vuetify-styles) .ma-xl-n5 {
    margin: -20px !important;
  }
  :where(.vuetify-styles) .ma-xl-n6 {
    margin: -24px !important;
  }
  :where(.vuetify-styles) .ma-xl-n7 {
    margin: -28px !important;
  }
  :where(.vuetify-styles) .ma-xl-n8 {
    margin: -32px !important;
  }
  :where(.vuetify-styles) .ma-xl-n9 {
    margin: -36px !important;
  }
  :where(.vuetify-styles) .ma-xl-n10 {
    margin: -40px !important;
  }
  :where(.vuetify-styles) .ma-xl-n11 {
    margin: -44px !important;
  }
  :where(.vuetify-styles) .ma-xl-n12 {
    margin: -48px !important;
  }
  :where(.vuetify-styles) .ma-xl-n13 {
    margin: -52px !important;
  }
  :where(.vuetify-styles) .ma-xl-n14 {
    margin: -56px !important;
  }
  :where(.vuetify-styles) .ma-xl-n15 {
    margin: -60px !important;
  }
  :where(.vuetify-styles) .ma-xl-n16 {
    margin: -64px !important;
  }
  :where(.vuetify-styles) .mx-xl-n1 {
    margin-right: -4px !important;
    margin-left: -4px !important;
  }
  :where(.vuetify-styles) .mx-xl-n2 {
    margin-right: -8px !important;
    margin-left: -8px !important;
  }
  :where(.vuetify-styles) .mx-xl-n3 {
    margin-right: -12px !important;
    margin-left: -12px !important;
  }
  :where(.vuetify-styles) .mx-xl-n4 {
    margin-right: -16px !important;
    margin-left: -16px !important;
  }
  :where(.vuetify-styles) .mx-xl-n5 {
    margin-right: -20px !important;
    margin-left: -20px !important;
  }
  :where(.vuetify-styles) .mx-xl-n6 {
    margin-right: -24px !important;
    margin-left: -24px !important;
  }
  :where(.vuetify-styles) .mx-xl-n7 {
    margin-right: -28px !important;
    margin-left: -28px !important;
  }
  :where(.vuetify-styles) .mx-xl-n8 {
    margin-right: -32px !important;
    margin-left: -32px !important;
  }
  :where(.vuetify-styles) .mx-xl-n9 {
    margin-right: -36px !important;
    margin-left: -36px !important;
  }
  :where(.vuetify-styles) .mx-xl-n10 {
    margin-right: -40px !important;
    margin-left: -40px !important;
  }
  :where(.vuetify-styles) .mx-xl-n11 {
    margin-right: -44px !important;
    margin-left: -44px !important;
  }
  :where(.vuetify-styles) .mx-xl-n12 {
    margin-right: -48px !important;
    margin-left: -48px !important;
  }
  :where(.vuetify-styles) .mx-xl-n13 {
    margin-right: -52px !important;
    margin-left: -52px !important;
  }
  :where(.vuetify-styles) .mx-xl-n14 {
    margin-right: -56px !important;
    margin-left: -56px !important;
  }
  :where(.vuetify-styles) .mx-xl-n15 {
    margin-right: -60px !important;
    margin-left: -60px !important;
  }
  :where(.vuetify-styles) .mx-xl-n16 {
    margin-right: -64px !important;
    margin-left: -64px !important;
  }
  :where(.vuetify-styles) .my-xl-n1 {
    margin-top: -4px !important;
    margin-bottom: -4px !important;
  }
  :where(.vuetify-styles) .my-xl-n2 {
    margin-top: -8px !important;
    margin-bottom: -8px !important;
  }
  :where(.vuetify-styles) .my-xl-n3 {
    margin-top: -12px !important;
    margin-bottom: -12px !important;
  }
  :where(.vuetify-styles) .my-xl-n4 {
    margin-top: -16px !important;
    margin-bottom: -16px !important;
  }
  :where(.vuetify-styles) .my-xl-n5 {
    margin-top: -20px !important;
    margin-bottom: -20px !important;
  }
  :where(.vuetify-styles) .my-xl-n6 {
    margin-top: -24px !important;
    margin-bottom: -24px !important;
  }
  :where(.vuetify-styles) .my-xl-n7 {
    margin-top: -28px !important;
    margin-bottom: -28px !important;
  }
  :where(.vuetify-styles) .my-xl-n8 {
    margin-top: -32px !important;
    margin-bottom: -32px !important;
  }
  :where(.vuetify-styles) .my-xl-n9 {
    margin-top: -36px !important;
    margin-bottom: -36px !important;
  }
  :where(.vuetify-styles) .my-xl-n10 {
    margin-top: -40px !important;
    margin-bottom: -40px !important;
  }
  :where(.vuetify-styles) .my-xl-n11 {
    margin-top: -44px !important;
    margin-bottom: -44px !important;
  }
  :where(.vuetify-styles) .my-xl-n12 {
    margin-top: -48px !important;
    margin-bottom: -48px !important;
  }
  :where(.vuetify-styles) .my-xl-n13 {
    margin-top: -52px !important;
    margin-bottom: -52px !important;
  }
  :where(.vuetify-styles) .my-xl-n14 {
    margin-top: -56px !important;
    margin-bottom: -56px !important;
  }
  :where(.vuetify-styles) .my-xl-n15 {
    margin-top: -60px !important;
    margin-bottom: -60px !important;
  }
  :where(.vuetify-styles) .my-xl-n16 {
    margin-top: -64px !important;
    margin-bottom: -64px !important;
  }
  :where(.vuetify-styles) .mt-xl-n1 {
    margin-top: -4px !important;
  }
  :where(.vuetify-styles) .mt-xl-n2 {
    margin-top: -8px !important;
  }
  :where(.vuetify-styles) .mt-xl-n3 {
    margin-top: -12px !important;
  }
  :where(.vuetify-styles) .mt-xl-n4 {
    margin-top: -16px !important;
  }
  :where(.vuetify-styles) .mt-xl-n5 {
    margin-top: -20px !important;
  }
  :where(.vuetify-styles) .mt-xl-n6 {
    margin-top: -24px !important;
  }
  :where(.vuetify-styles) .mt-xl-n7 {
    margin-top: -28px !important;
  }
  :where(.vuetify-styles) .mt-xl-n8 {
    margin-top: -32px !important;
  }
  :where(.vuetify-styles) .mt-xl-n9 {
    margin-top: -36px !important;
  }
  :where(.vuetify-styles) .mt-xl-n10 {
    margin-top: -40px !important;
  }
  :where(.vuetify-styles) .mt-xl-n11 {
    margin-top: -44px !important;
  }
  :where(.vuetify-styles) .mt-xl-n12 {
    margin-top: -48px !important;
  }
  :where(.vuetify-styles) .mt-xl-n13 {
    margin-top: -52px !important;
  }
  :where(.vuetify-styles) .mt-xl-n14 {
    margin-top: -56px !important;
  }
  :where(.vuetify-styles) .mt-xl-n15 {
    margin-top: -60px !important;
  }
  :where(.vuetify-styles) .mt-xl-n16 {
    margin-top: -64px !important;
  }
  :where(.vuetify-styles) .mr-xl-n1 {
    margin-right: -4px !important;
  }
  :where(.vuetify-styles) .mr-xl-n2 {
    margin-right: -8px !important;
  }
  :where(.vuetify-styles) .mr-xl-n3 {
    margin-right: -12px !important;
  }
  :where(.vuetify-styles) .mr-xl-n4 {
    margin-right: -16px !important;
  }
  :where(.vuetify-styles) .mr-xl-n5 {
    margin-right: -20px !important;
  }
  :where(.vuetify-styles) .mr-xl-n6 {
    margin-right: -24px !important;
  }
  :where(.vuetify-styles) .mr-xl-n7 {
    margin-right: -28px !important;
  }
  :where(.vuetify-styles) .mr-xl-n8 {
    margin-right: -32px !important;
  }
  :where(.vuetify-styles) .mr-xl-n9 {
    margin-right: -36px !important;
  }
  :where(.vuetify-styles) .mr-xl-n10 {
    margin-right: -40px !important;
  }
  :where(.vuetify-styles) .mr-xl-n11 {
    margin-right: -44px !important;
  }
  :where(.vuetify-styles) .mr-xl-n12 {
    margin-right: -48px !important;
  }
  :where(.vuetify-styles) .mr-xl-n13 {
    margin-right: -52px !important;
  }
  :where(.vuetify-styles) .mr-xl-n14 {
    margin-right: -56px !important;
  }
  :where(.vuetify-styles) .mr-xl-n15 {
    margin-right: -60px !important;
  }
  :where(.vuetify-styles) .mr-xl-n16 {
    margin-right: -64px !important;
  }
  :where(.vuetify-styles) .mb-xl-n1 {
    margin-bottom: -4px !important;
  }
  :where(.vuetify-styles) .mb-xl-n2 {
    margin-bottom: -8px !important;
  }
  :where(.vuetify-styles) .mb-xl-n3 {
    margin-bottom: -12px !important;
  }
  :where(.vuetify-styles) .mb-xl-n4 {
    margin-bottom: -16px !important;
  }
  :where(.vuetify-styles) .mb-xl-n5 {
    margin-bottom: -20px !important;
  }
  :where(.vuetify-styles) .mb-xl-n6 {
    margin-bottom: -24px !important;
  }
  :where(.vuetify-styles) .mb-xl-n7 {
    margin-bottom: -28px !important;
  }
  :where(.vuetify-styles) .mb-xl-n8 {
    margin-bottom: -32px !important;
  }
  :where(.vuetify-styles) .mb-xl-n9 {
    margin-bottom: -36px !important;
  }
  :where(.vuetify-styles) .mb-xl-n10 {
    margin-bottom: -40px !important;
  }
  :where(.vuetify-styles) .mb-xl-n11 {
    margin-bottom: -44px !important;
  }
  :where(.vuetify-styles) .mb-xl-n12 {
    margin-bottom: -48px !important;
  }
  :where(.vuetify-styles) .mb-xl-n13 {
    margin-bottom: -52px !important;
  }
  :where(.vuetify-styles) .mb-xl-n14 {
    margin-bottom: -56px !important;
  }
  :where(.vuetify-styles) .mb-xl-n15 {
    margin-bottom: -60px !important;
  }
  :where(.vuetify-styles) .mb-xl-n16 {
    margin-bottom: -64px !important;
  }
  :where(.vuetify-styles) .ml-xl-n1 {
    margin-left: -4px !important;
  }
  :where(.vuetify-styles) .ml-xl-n2 {
    margin-left: -8px !important;
  }
  :where(.vuetify-styles) .ml-xl-n3 {
    margin-left: -12px !important;
  }
  :where(.vuetify-styles) .ml-xl-n4 {
    margin-left: -16px !important;
  }
  :where(.vuetify-styles) .ml-xl-n5 {
    margin-left: -20px !important;
  }
  :where(.vuetify-styles) .ml-xl-n6 {
    margin-left: -24px !important;
  }
  :where(.vuetify-styles) .ml-xl-n7 {
    margin-left: -28px !important;
  }
  :where(.vuetify-styles) .ml-xl-n8 {
    margin-left: -32px !important;
  }
  :where(.vuetify-styles) .ml-xl-n9 {
    margin-left: -36px !important;
  }
  :where(.vuetify-styles) .ml-xl-n10 {
    margin-left: -40px !important;
  }
  :where(.vuetify-styles) .ml-xl-n11 {
    margin-left: -44px !important;
  }
  :where(.vuetify-styles) .ml-xl-n12 {
    margin-left: -48px !important;
  }
  :where(.vuetify-styles) .ml-xl-n13 {
    margin-left: -52px !important;
  }
  :where(.vuetify-styles) .ml-xl-n14 {
    margin-left: -56px !important;
  }
  :where(.vuetify-styles) .ml-xl-n15 {
    margin-left: -60px !important;
  }
  :where(.vuetify-styles) .ml-xl-n16 {
    margin-left: -64px !important;
  }
  :where(.vuetify-styles) .ms-xl-n1 {
    margin-inline-start: -4px !important;
  }
  :where(.vuetify-styles) .ms-xl-n2 {
    margin-inline-start: -8px !important;
  }
  :where(.vuetify-styles) .ms-xl-n3 {
    margin-inline-start: -12px !important;
  }
  :where(.vuetify-styles) .ms-xl-n4 {
    margin-inline-start: -16px !important;
  }
  :where(.vuetify-styles) .ms-xl-n5 {
    margin-inline-start: -20px !important;
  }
  :where(.vuetify-styles) .ms-xl-n6 {
    margin-inline-start: -24px !important;
  }
  :where(.vuetify-styles) .ms-xl-n7 {
    margin-inline-start: -28px !important;
  }
  :where(.vuetify-styles) .ms-xl-n8 {
    margin-inline-start: -32px !important;
  }
  :where(.vuetify-styles) .ms-xl-n9 {
    margin-inline-start: -36px !important;
  }
  :where(.vuetify-styles) .ms-xl-n10 {
    margin-inline-start: -40px !important;
  }
  :where(.vuetify-styles) .ms-xl-n11 {
    margin-inline-start: -44px !important;
  }
  :where(.vuetify-styles) .ms-xl-n12 {
    margin-inline-start: -48px !important;
  }
  :where(.vuetify-styles) .ms-xl-n13 {
    margin-inline-start: -52px !important;
  }
  :where(.vuetify-styles) .ms-xl-n14 {
    margin-inline-start: -56px !important;
  }
  :where(.vuetify-styles) .ms-xl-n15 {
    margin-inline-start: -60px !important;
  }
  :where(.vuetify-styles) .ms-xl-n16 {
    margin-inline-start: -64px !important;
  }
  :where(.vuetify-styles) .me-xl-n1 {
    margin-inline-end: -4px !important;
  }
  :where(.vuetify-styles) .me-xl-n2 {
    margin-inline-end: -8px !important;
  }
  :where(.vuetify-styles) .me-xl-n3 {
    margin-inline-end: -12px !important;
  }
  :where(.vuetify-styles) .me-xl-n4 {
    margin-inline-end: -16px !important;
  }
  :where(.vuetify-styles) .me-xl-n5 {
    margin-inline-end: -20px !important;
  }
  :where(.vuetify-styles) .me-xl-n6 {
    margin-inline-end: -24px !important;
  }
  :where(.vuetify-styles) .me-xl-n7 {
    margin-inline-end: -28px !important;
  }
  :where(.vuetify-styles) .me-xl-n8 {
    margin-inline-end: -32px !important;
  }
  :where(.vuetify-styles) .me-xl-n9 {
    margin-inline-end: -36px !important;
  }
  :where(.vuetify-styles) .me-xl-n10 {
    margin-inline-end: -40px !important;
  }
  :where(.vuetify-styles) .me-xl-n11 {
    margin-inline-end: -44px !important;
  }
  :where(.vuetify-styles) .me-xl-n12 {
    margin-inline-end: -48px !important;
  }
  :where(.vuetify-styles) .me-xl-n13 {
    margin-inline-end: -52px !important;
  }
  :where(.vuetify-styles) .me-xl-n14 {
    margin-inline-end: -56px !important;
  }
  :where(.vuetify-styles) .me-xl-n15 {
    margin-inline-end: -60px !important;
  }
  :where(.vuetify-styles) .me-xl-n16 {
    margin-inline-end: -64px !important;
  }
  :where(.vuetify-styles) .pa-xl-0 {
    padding: 0px !important;
  }
  :where(.vuetify-styles) .pa-xl-1 {
    padding: 4px !important;
  }
  :where(.vuetify-styles) .pa-xl-2 {
    padding: 8px !important;
  }
  :where(.vuetify-styles) .pa-xl-3 {
    padding: 12px !important;
  }
  :where(.vuetify-styles) .pa-xl-4 {
    padding: 16px !important;
  }
  :where(.vuetify-styles) .pa-xl-5 {
    padding: 20px !important;
  }
  :where(.vuetify-styles) .pa-xl-6 {
    padding: 24px !important;
  }
  :where(.vuetify-styles) .pa-xl-7 {
    padding: 28px !important;
  }
  :where(.vuetify-styles) .pa-xl-8 {
    padding: 32px !important;
  }
  :where(.vuetify-styles) .pa-xl-9 {
    padding: 36px !important;
  }
  :where(.vuetify-styles) .pa-xl-10 {
    padding: 40px !important;
  }
  :where(.vuetify-styles) .pa-xl-11 {
    padding: 44px !important;
  }
  :where(.vuetify-styles) .pa-xl-12 {
    padding: 48px !important;
  }
  :where(.vuetify-styles) .pa-xl-13 {
    padding: 52px !important;
  }
  :where(.vuetify-styles) .pa-xl-14 {
    padding: 56px !important;
  }
  :where(.vuetify-styles) .pa-xl-15 {
    padding: 60px !important;
  }
  :where(.vuetify-styles) .pa-xl-16 {
    padding: 64px !important;
  }
  :where(.vuetify-styles) .px-xl-0 {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  :where(.vuetify-styles) .px-xl-1 {
    padding-right: 4px !important;
    padding-left: 4px !important;
  }
  :where(.vuetify-styles) .px-xl-2 {
    padding-right: 8px !important;
    padding-left: 8px !important;
  }
  :where(.vuetify-styles) .px-xl-3 {
    padding-right: 12px !important;
    padding-left: 12px !important;
  }
  :where(.vuetify-styles) .px-xl-4 {
    padding-right: 16px !important;
    padding-left: 16px !important;
  }
  :where(.vuetify-styles) .px-xl-5 {
    padding-right: 20px !important;
    padding-left: 20px !important;
  }
  :where(.vuetify-styles) .px-xl-6 {
    padding-right: 24px !important;
    padding-left: 24px !important;
  }
  :where(.vuetify-styles) .px-xl-7 {
    padding-right: 28px !important;
    padding-left: 28px !important;
  }
  :where(.vuetify-styles) .px-xl-8 {
    padding-right: 32px !important;
    padding-left: 32px !important;
  }
  :where(.vuetify-styles) .px-xl-9 {
    padding-right: 36px !important;
    padding-left: 36px !important;
  }
  :where(.vuetify-styles) .px-xl-10 {
    padding-right: 40px !important;
    padding-left: 40px !important;
  }
  :where(.vuetify-styles) .px-xl-11 {
    padding-right: 44px !important;
    padding-left: 44px !important;
  }
  :where(.vuetify-styles) .px-xl-12 {
    padding-right: 48px !important;
    padding-left: 48px !important;
  }
  :where(.vuetify-styles) .px-xl-13 {
    padding-right: 52px !important;
    padding-left: 52px !important;
  }
  :where(.vuetify-styles) .px-xl-14 {
    padding-right: 56px !important;
    padding-left: 56px !important;
  }
  :where(.vuetify-styles) .px-xl-15 {
    padding-right: 60px !important;
    padding-left: 60px !important;
  }
  :where(.vuetify-styles) .px-xl-16 {
    padding-right: 64px !important;
    padding-left: 64px !important;
  }
  :where(.vuetify-styles) .py-xl-0 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  :where(.vuetify-styles) .py-xl-1 {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
  :where(.vuetify-styles) .py-xl-2 {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  :where(.vuetify-styles) .py-xl-3 {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  :where(.vuetify-styles) .py-xl-4 {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
  :where(.vuetify-styles) .py-xl-5 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  :where(.vuetify-styles) .py-xl-6 {
    padding-top: 24px !important;
    padding-bottom: 24px !important;
  }
  :where(.vuetify-styles) .py-xl-7 {
    padding-top: 28px !important;
    padding-bottom: 28px !important;
  }
  :where(.vuetify-styles) .py-xl-8 {
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }
  :where(.vuetify-styles) .py-xl-9 {
    padding-top: 36px !important;
    padding-bottom: 36px !important;
  }
  :where(.vuetify-styles) .py-xl-10 {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  :where(.vuetify-styles) .py-xl-11 {
    padding-top: 44px !important;
    padding-bottom: 44px !important;
  }
  :where(.vuetify-styles) .py-xl-12 {
    padding-top: 48px !important;
    padding-bottom: 48px !important;
  }
  :where(.vuetify-styles) .py-xl-13 {
    padding-top: 52px !important;
    padding-bottom: 52px !important;
  }
  :where(.vuetify-styles) .py-xl-14 {
    padding-top: 56px !important;
    padding-bottom: 56px !important;
  }
  :where(.vuetify-styles) .py-xl-15 {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }
  :where(.vuetify-styles) .py-xl-16 {
    padding-top: 64px !important;
    padding-bottom: 64px !important;
  }
  :where(.vuetify-styles) .pt-xl-0 {
    padding-top: 0px !important;
  }
  :where(.vuetify-styles) .pt-xl-1 {
    padding-top: 4px !important;
  }
  :where(.vuetify-styles) .pt-xl-2 {
    padding-top: 8px !important;
  }
  :where(.vuetify-styles) .pt-xl-3 {
    padding-top: 12px !important;
  }
  :where(.vuetify-styles) .pt-xl-4 {
    padding-top: 16px !important;
  }
  :where(.vuetify-styles) .pt-xl-5 {
    padding-top: 20px !important;
  }
  :where(.vuetify-styles) .pt-xl-6 {
    padding-top: 24px !important;
  }
  :where(.vuetify-styles) .pt-xl-7 {
    padding-top: 28px !important;
  }
  :where(.vuetify-styles) .pt-xl-8 {
    padding-top: 32px !important;
  }
  :where(.vuetify-styles) .pt-xl-9 {
    padding-top: 36px !important;
  }
  :where(.vuetify-styles) .pt-xl-10 {
    padding-top: 40px !important;
  }
  :where(.vuetify-styles) .pt-xl-11 {
    padding-top: 44px !important;
  }
  :where(.vuetify-styles) .pt-xl-12 {
    padding-top: 48px !important;
  }
  :where(.vuetify-styles) .pt-xl-13 {
    padding-top: 52px !important;
  }
  :where(.vuetify-styles) .pt-xl-14 {
    padding-top: 56px !important;
  }
  :where(.vuetify-styles) .pt-xl-15 {
    padding-top: 60px !important;
  }
  :where(.vuetify-styles) .pt-xl-16 {
    padding-top: 64px !important;
  }
  :where(.vuetify-styles) .pr-xl-0 {
    padding-right: 0px !important;
  }
  :where(.vuetify-styles) .pr-xl-1 {
    padding-right: 4px !important;
  }
  :where(.vuetify-styles) .pr-xl-2 {
    padding-right: 8px !important;
  }
  :where(.vuetify-styles) .pr-xl-3 {
    padding-right: 12px !important;
  }
  :where(.vuetify-styles) .pr-xl-4 {
    padding-right: 16px !important;
  }
  :where(.vuetify-styles) .pr-xl-5 {
    padding-right: 20px !important;
  }
  :where(.vuetify-styles) .pr-xl-6 {
    padding-right: 24px !important;
  }
  :where(.vuetify-styles) .pr-xl-7 {
    padding-right: 28px !important;
  }
  :where(.vuetify-styles) .pr-xl-8 {
    padding-right: 32px !important;
  }
  :where(.vuetify-styles) .pr-xl-9 {
    padding-right: 36px !important;
  }
  :where(.vuetify-styles) .pr-xl-10 {
    padding-right: 40px !important;
  }
  :where(.vuetify-styles) .pr-xl-11 {
    padding-right: 44px !important;
  }
  :where(.vuetify-styles) .pr-xl-12 {
    padding-right: 48px !important;
  }
  :where(.vuetify-styles) .pr-xl-13 {
    padding-right: 52px !important;
  }
  :where(.vuetify-styles) .pr-xl-14 {
    padding-right: 56px !important;
  }
  :where(.vuetify-styles) .pr-xl-15 {
    padding-right: 60px !important;
  }
  :where(.vuetify-styles) .pr-xl-16 {
    padding-right: 64px !important;
  }
  :where(.vuetify-styles) .pb-xl-0 {
    padding-bottom: 0px !important;
  }
  :where(.vuetify-styles) .pb-xl-1 {
    padding-bottom: 4px !important;
  }
  :where(.vuetify-styles) .pb-xl-2 {
    padding-bottom: 8px !important;
  }
  :where(.vuetify-styles) .pb-xl-3 {
    padding-bottom: 12px !important;
  }
  :where(.vuetify-styles) .pb-xl-4 {
    padding-bottom: 16px !important;
  }
  :where(.vuetify-styles) .pb-xl-5 {
    padding-bottom: 20px !important;
  }
  :where(.vuetify-styles) .pb-xl-6 {
    padding-bottom: 24px !important;
  }
  :where(.vuetify-styles) .pb-xl-7 {
    padding-bottom: 28px !important;
  }
  :where(.vuetify-styles) .pb-xl-8 {
    padding-bottom: 32px !important;
  }
  :where(.vuetify-styles) .pb-xl-9 {
    padding-bottom: 36px !important;
  }
  :where(.vuetify-styles) .pb-xl-10 {
    padding-bottom: 40px !important;
  }
  :where(.vuetify-styles) .pb-xl-11 {
    padding-bottom: 44px !important;
  }
  :where(.vuetify-styles) .pb-xl-12 {
    padding-bottom: 48px !important;
  }
  :where(.vuetify-styles) .pb-xl-13 {
    padding-bottom: 52px !important;
  }
  :where(.vuetify-styles) .pb-xl-14 {
    padding-bottom: 56px !important;
  }
  :where(.vuetify-styles) .pb-xl-15 {
    padding-bottom: 60px !important;
  }
  :where(.vuetify-styles) .pb-xl-16 {
    padding-bottom: 64px !important;
  }
  :where(.vuetify-styles) .pl-xl-0 {
    padding-left: 0px !important;
  }
  :where(.vuetify-styles) .pl-xl-1 {
    padding-left: 4px !important;
  }
  :where(.vuetify-styles) .pl-xl-2 {
    padding-left: 8px !important;
  }
  :where(.vuetify-styles) .pl-xl-3 {
    padding-left: 12px !important;
  }
  :where(.vuetify-styles) .pl-xl-4 {
    padding-left: 16px !important;
  }
  :where(.vuetify-styles) .pl-xl-5 {
    padding-left: 20px !important;
  }
  :where(.vuetify-styles) .pl-xl-6 {
    padding-left: 24px !important;
  }
  :where(.vuetify-styles) .pl-xl-7 {
    padding-left: 28px !important;
  }
  :where(.vuetify-styles) .pl-xl-8 {
    padding-left: 32px !important;
  }
  :where(.vuetify-styles) .pl-xl-9 {
    padding-left: 36px !important;
  }
  :where(.vuetify-styles) .pl-xl-10 {
    padding-left: 40px !important;
  }
  :where(.vuetify-styles) .pl-xl-11 {
    padding-left: 44px !important;
  }
  :where(.vuetify-styles) .pl-xl-12 {
    padding-left: 48px !important;
  }
  :where(.vuetify-styles) .pl-xl-13 {
    padding-left: 52px !important;
  }
  :where(.vuetify-styles) .pl-xl-14 {
    padding-left: 56px !important;
  }
  :where(.vuetify-styles) .pl-xl-15 {
    padding-left: 60px !important;
  }
  :where(.vuetify-styles) .pl-xl-16 {
    padding-left: 64px !important;
  }
  :where(.vuetify-styles) .ps-xl-0 {
    padding-inline-start: 0px !important;
  }
  :where(.vuetify-styles) .ps-xl-1 {
    padding-inline-start: 4px !important;
  }
  :where(.vuetify-styles) .ps-xl-2 {
    padding-inline-start: 8px !important;
  }
  :where(.vuetify-styles) .ps-xl-3 {
    padding-inline-start: 12px !important;
  }
  :where(.vuetify-styles) .ps-xl-4 {
    padding-inline-start: 16px !important;
  }
  :where(.vuetify-styles) .ps-xl-5 {
    padding-inline-start: 20px !important;
  }
  :where(.vuetify-styles) .ps-xl-6 {
    padding-inline-start: 24px !important;
  }
  :where(.vuetify-styles) .ps-xl-7 {
    padding-inline-start: 28px !important;
  }
  :where(.vuetify-styles) .ps-xl-8 {
    padding-inline-start: 32px !important;
  }
  :where(.vuetify-styles) .ps-xl-9 {
    padding-inline-start: 36px !important;
  }
  :where(.vuetify-styles) .ps-xl-10 {
    padding-inline-start: 40px !important;
  }
  :where(.vuetify-styles) .ps-xl-11 {
    padding-inline-start: 44px !important;
  }
  :where(.vuetify-styles) .ps-xl-12 {
    padding-inline-start: 48px !important;
  }
  :where(.vuetify-styles) .ps-xl-13 {
    padding-inline-start: 52px !important;
  }
  :where(.vuetify-styles) .ps-xl-14 {
    padding-inline-start: 56px !important;
  }
  :where(.vuetify-styles) .ps-xl-15 {
    padding-inline-start: 60px !important;
  }
  :where(.vuetify-styles) .ps-xl-16 {
    padding-inline-start: 64px !important;
  }
  :where(.vuetify-styles) .pe-xl-0 {
    padding-inline-end: 0px !important;
  }
  :where(.vuetify-styles) .pe-xl-1 {
    padding-inline-end: 4px !important;
  }
  :where(.vuetify-styles) .pe-xl-2 {
    padding-inline-end: 8px !important;
  }
  :where(.vuetify-styles) .pe-xl-3 {
    padding-inline-end: 12px !important;
  }
  :where(.vuetify-styles) .pe-xl-4 {
    padding-inline-end: 16px !important;
  }
  :where(.vuetify-styles) .pe-xl-5 {
    padding-inline-end: 20px !important;
  }
  :where(.vuetify-styles) .pe-xl-6 {
    padding-inline-end: 24px !important;
  }
  :where(.vuetify-styles) .pe-xl-7 {
    padding-inline-end: 28px !important;
  }
  :where(.vuetify-styles) .pe-xl-8 {
    padding-inline-end: 32px !important;
  }
  :where(.vuetify-styles) .pe-xl-9 {
    padding-inline-end: 36px !important;
  }
  :where(.vuetify-styles) .pe-xl-10 {
    padding-inline-end: 40px !important;
  }
  :where(.vuetify-styles) .pe-xl-11 {
    padding-inline-end: 44px !important;
  }
  :where(.vuetify-styles) .pe-xl-12 {
    padding-inline-end: 48px !important;
  }
  :where(.vuetify-styles) .pe-xl-13 {
    padding-inline-end: 52px !important;
  }
  :where(.vuetify-styles) .pe-xl-14 {
    padding-inline-end: 56px !important;
  }
  :where(.vuetify-styles) .pe-xl-15 {
    padding-inline-end: 60px !important;
  }
  :where(.vuetify-styles) .pe-xl-16 {
    padding-inline-end: 64px !important;
  }
  :where(.vuetify-styles) .text-xl-left {
    text-align: left !important;
  }
  :where(.vuetify-styles) .text-xl-right {
    text-align: right !important;
  }
  :where(.vuetify-styles) .text-xl-center {
    text-align: center !important;
  }
  :where(.vuetify-styles) .text-xl-justify {
    text-align: justify !important;
  }
  :where(.vuetify-styles) .text-xl-start {
    text-align: start !important;
  }
  :where(.vuetify-styles) .text-xl-end {
    text-align: end !important;
  }
  :where(.vuetify-styles) .text-xl-h1 {
    font-size: 6rem !important;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.015625em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xl-h2 {
    font-size: 3.75rem !important;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.0083333333em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xl-h3 {
    font-size: 3rem !important;
    font-weight: 400;
    line-height: 1.05;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xl-h4 {
    font-size: 2.125rem !important;
    font-weight: 400;
    line-height: 1.175;
    letter-spacing: 0.0073529412em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xl-h5 {
    font-size: 1.5rem !important;
    font-weight: 400;
    line-height: 1.333;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xl-h6 {
    font-size: 1.25rem !important;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: 0.0125em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xl-subtitle-1 {
    font-size: 1rem !important;
    font-weight: normal;
    line-height: 1.75;
    letter-spacing: 0.009375em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xl-subtitle-2 {
    font-size: 0.875rem !important;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: 0.0071428571em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xl-body-1 {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.03125em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xl-body-2 {
    font-size: 0.875rem !important;
    font-weight: 400;
    line-height: 1.425;
    letter-spacing: 0.0178571429em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xl-button {
    font-size: 0.875rem !important;
    font-weight: 500;
    line-height: 2.6;
    letter-spacing: 0.0892857143em !important;
    font-family: "Roboto", sans-serif;
    text-transform: uppercase !important;
  }
  :where(.vuetify-styles) .text-xl-caption {
    font-size: 0.75rem !important;
    font-weight: 400;
    line-height: 1.667;
    letter-spacing: 0.0333333333em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xl-overline {
    font-size: 0.75rem !important;
    font-weight: 500;
    line-height: 2.667;
    letter-spacing: 0.1666666667em !important;
    font-family: "Roboto", sans-serif;
    text-transform: uppercase !important;
  }
  :where(.vuetify-styles) .h-xl-auto {
    height: auto !important;
  }
  :where(.vuetify-styles) .h-xl-screen {
    height: 100vh !important;
  }
  :where(.vuetify-styles) .h-xl-0 {
    height: 0 !important;
  }
  :where(.vuetify-styles) .h-xl-25 {
    height: 25% !important;
  }
  :where(.vuetify-styles) .h-xl-50 {
    height: 50% !important;
  }
  :where(.vuetify-styles) .h-xl-75 {
    height: 75% !important;
  }
  :where(.vuetify-styles) .h-xl-100 {
    height: 100% !important;
  }
  :where(.vuetify-styles) .w-xl-auto {
    width: auto !important;
  }
  :where(.vuetify-styles) .w-xl-0 {
    width: 0 !important;
  }
  :where(.vuetify-styles) .w-xl-25 {
    width: 25% !important;
  }
  :where(.vuetify-styles) .w-xl-33 {
    width: 33% !important;
  }
  :where(.vuetify-styles) .w-xl-50 {
    width: 50% !important;
  }
  :where(.vuetify-styles) .w-xl-66 {
    width: 66% !important;
  }
  :where(.vuetify-styles) .w-xl-75 {
    width: 75% !important;
  }
  :where(.vuetify-styles) .w-xl-100 {
    width: 100% !important;
  }
}
@media (min-width: 2560px) {
  :where(.vuetify-styles) .d-xxl-none {
    display: none !important;
  }
  :where(.vuetify-styles) .d-xxl-inline {
    display: inline !important;
  }
  :where(.vuetify-styles) .d-xxl-inline-block {
    display: inline-block !important;
  }
  :where(.vuetify-styles) .d-xxl-block {
    display: block !important;
  }
  :where(.vuetify-styles) .d-xxl-table {
    display: table !important;
  }
  :where(.vuetify-styles) .d-xxl-table-row {
    display: table-row !important;
  }
  :where(.vuetify-styles) .d-xxl-table-cell {
    display: table-cell !important;
  }
  :where(.vuetify-styles) .d-xxl-flex {
    display: flex !important;
  }
  :where(.vuetify-styles) .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  :where(.vuetify-styles) .float-xxl-none {
    float: none !important;
  }
  :where(.vuetify-styles) .float-xxl-left {
    float: left !important;
  }
  :where(.vuetify-styles) .float-xxl-right {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-rtl .float-xxl-end {
    float: left !important;
  }
  :where(.vuetify-styles) .v-locale--is-rtl .float-xxl-start {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-ltr .float-xxl-end {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-ltr .float-xxl-start {
    float: left !important;
  }
  :where(.vuetify-styles) .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  :where(.vuetify-styles) .flex-xxl-1-1 {
    flex: 1 1 auto !important;
  }
  :where(.vuetify-styles) .flex-xxl-1-0 {
    flex: 1 0 auto !important;
  }
  :where(.vuetify-styles) .flex-xxl-0-1 {
    flex: 0 1 auto !important;
  }
  :where(.vuetify-styles) .flex-xxl-0-0 {
    flex: 0 0 auto !important;
  }
  :where(.vuetify-styles) .flex-xxl-1-1-100 {
    flex: 1 1 100% !important;
  }
  :where(.vuetify-styles) .flex-xxl-1-0-100 {
    flex: 1 0 100% !important;
  }
  :where(.vuetify-styles) .flex-xxl-0-1-100 {
    flex: 0 1 100% !important;
  }
  :where(.vuetify-styles) .flex-xxl-0-0-100 {
    flex: 0 0 100% !important;
  }
  :where(.vuetify-styles) .flex-xxl-1-1-0 {
    flex: 1 1 0 !important;
  }
  :where(.vuetify-styles) .flex-xxl-1-0-0 {
    flex: 1 0 0 !important;
  }
  :where(.vuetify-styles) .flex-xxl-0-1-0 {
    flex: 0 1 0 !important;
  }
  :where(.vuetify-styles) .flex-xxl-0-0-0 {
    flex: 0 0 0 !important;
  }
  :where(.vuetify-styles) .flex-xxl-row {
    flex-direction: row !important;
  }
  :where(.vuetify-styles) .flex-xxl-column {
    flex-direction: column !important;
  }
  :where(.vuetify-styles) .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  :where(.vuetify-styles) .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  :where(.vuetify-styles) .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  :where(.vuetify-styles) .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  :where(.vuetify-styles) .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  :where(.vuetify-styles) .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  :where(.vuetify-styles) .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  :where(.vuetify-styles) .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  :where(.vuetify-styles) .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  :where(.vuetify-styles) .justify-xxl-start {
    justify-content: flex-start !important;
  }
  :where(.vuetify-styles) .justify-xxl-end {
    justify-content: flex-end !important;
  }
  :where(.vuetify-styles) .justify-xxl-center {
    justify-content: center !important;
  }
  :where(.vuetify-styles) .justify-xxl-space-between {
    justify-content: space-between !important;
  }
  :where(.vuetify-styles) .justify-xxl-space-around {
    justify-content: space-around !important;
  }
  :where(.vuetify-styles) .justify-xxl-space-evenly {
    justify-content: space-evenly !important;
  }
  :where(.vuetify-styles) .justify-items-xxl-start {
    justify-items: flex-start !important;
  }
  :where(.vuetify-styles) .justify-items-xxl-end {
    justify-items: flex-end !important;
  }
  :where(.vuetify-styles) .justify-items-xxl-center {
    justify-items: center !important;
  }
  :where(.vuetify-styles) .justify-items-xxl-stretch {
    justify-items: stretch !important;
  }
  :where(.vuetify-styles) .align-xxl-start {
    align-items: flex-start !important;
  }
  :where(.vuetify-styles) .align-xxl-end {
    align-items: flex-end !important;
  }
  :where(.vuetify-styles) .align-xxl-center {
    align-items: center !important;
  }
  :where(.vuetify-styles) .align-xxl-baseline {
    align-items: baseline !important;
  }
  :where(.vuetify-styles) .align-xxl-stretch {
    align-items: stretch !important;
  }
  :where(.vuetify-styles) .align-content-xxl-start {
    align-content: flex-start !important;
  }
  :where(.vuetify-styles) .align-content-xxl-end {
    align-content: flex-end !important;
  }
  :where(.vuetify-styles) .align-content-xxl-center {
    align-content: center !important;
  }
  :where(.vuetify-styles) .align-content-xxl-space-between {
    align-content: space-between !important;
  }
  :where(.vuetify-styles) .align-content-xxl-space-around {
    align-content: space-around !important;
  }
  :where(.vuetify-styles) .align-content-xxl-space-evenly {
    align-content: space-evenly !important;
  }
  :where(.vuetify-styles) .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  :where(.vuetify-styles) .align-self-xxl-auto {
    align-self: auto !important;
  }
  :where(.vuetify-styles) .align-self-xxl-start {
    align-self: flex-start !important;
  }
  :where(.vuetify-styles) .align-self-xxl-end {
    align-self: flex-end !important;
  }
  :where(.vuetify-styles) .align-self-xxl-center {
    align-self: center !important;
  }
  :where(.vuetify-styles) .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  :where(.vuetify-styles) .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  :where(.vuetify-styles) .order-xxl-first {
    order: -1 !important;
  }
  :where(.vuetify-styles) .order-xxl-0 {
    order: 0 !important;
  }
  :where(.vuetify-styles) .order-xxl-1 {
    order: 1 !important;
  }
  :where(.vuetify-styles) .order-xxl-2 {
    order: 2 !important;
  }
  :where(.vuetify-styles) .order-xxl-3 {
    order: 3 !important;
  }
  :where(.vuetify-styles) .order-xxl-4 {
    order: 4 !important;
  }
  :where(.vuetify-styles) .order-xxl-5 {
    order: 5 !important;
  }
  :where(.vuetify-styles) .order-xxl-6 {
    order: 6 !important;
  }
  :where(.vuetify-styles) .order-xxl-7 {
    order: 7 !important;
  }
  :where(.vuetify-styles) .order-xxl-8 {
    order: 8 !important;
  }
  :where(.vuetify-styles) .order-xxl-9 {
    order: 9 !important;
  }
  :where(.vuetify-styles) .order-xxl-10 {
    order: 10 !important;
  }
  :where(.vuetify-styles) .order-xxl-11 {
    order: 11 !important;
  }
  :where(.vuetify-styles) .order-xxl-12 {
    order: 12 !important;
  }
  :where(.vuetify-styles) .order-xxl-last {
    order: 13 !important;
  }
  :where(.vuetify-styles) .ga-xxl-0 {
    gap: 0px !important;
  }
  :where(.vuetify-styles) .ga-xxl-1 {
    gap: 4px !important;
  }
  :where(.vuetify-styles) .ga-xxl-2 {
    gap: 8px !important;
  }
  :where(.vuetify-styles) .ga-xxl-3 {
    gap: 12px !important;
  }
  :where(.vuetify-styles) .ga-xxl-4 {
    gap: 16px !important;
  }
  :where(.vuetify-styles) .ga-xxl-5 {
    gap: 20px !important;
  }
  :where(.vuetify-styles) .ga-xxl-6 {
    gap: 24px !important;
  }
  :where(.vuetify-styles) .ga-xxl-7 {
    gap: 28px !important;
  }
  :where(.vuetify-styles) .ga-xxl-8 {
    gap: 32px !important;
  }
  :where(.vuetify-styles) .ga-xxl-9 {
    gap: 36px !important;
  }
  :where(.vuetify-styles) .ga-xxl-10 {
    gap: 40px !important;
  }
  :where(.vuetify-styles) .ga-xxl-11 {
    gap: 44px !important;
  }
  :where(.vuetify-styles) .ga-xxl-12 {
    gap: 48px !important;
  }
  :where(.vuetify-styles) .ga-xxl-13 {
    gap: 52px !important;
  }
  :where(.vuetify-styles) .ga-xxl-14 {
    gap: 56px !important;
  }
  :where(.vuetify-styles) .ga-xxl-15 {
    gap: 60px !important;
  }
  :where(.vuetify-styles) .ga-xxl-16 {
    gap: 64px !important;
  }
  :where(.vuetify-styles) .ga-xxl-auto {
    gap: auto !important;
  }
  :where(.vuetify-styles) .gr-xxl-0 {
    row-gap: 0px !important;
  }
  :where(.vuetify-styles) .gr-xxl-1 {
    row-gap: 4px !important;
  }
  :where(.vuetify-styles) .gr-xxl-2 {
    row-gap: 8px !important;
  }
  :where(.vuetify-styles) .gr-xxl-3 {
    row-gap: 12px !important;
  }
  :where(.vuetify-styles) .gr-xxl-4 {
    row-gap: 16px !important;
  }
  :where(.vuetify-styles) .gr-xxl-5 {
    row-gap: 20px !important;
  }
  :where(.vuetify-styles) .gr-xxl-6 {
    row-gap: 24px !important;
  }
  :where(.vuetify-styles) .gr-xxl-7 {
    row-gap: 28px !important;
  }
  :where(.vuetify-styles) .gr-xxl-8 {
    row-gap: 32px !important;
  }
  :where(.vuetify-styles) .gr-xxl-9 {
    row-gap: 36px !important;
  }
  :where(.vuetify-styles) .gr-xxl-10 {
    row-gap: 40px !important;
  }
  :where(.vuetify-styles) .gr-xxl-11 {
    row-gap: 44px !important;
  }
  :where(.vuetify-styles) .gr-xxl-12 {
    row-gap: 48px !important;
  }
  :where(.vuetify-styles) .gr-xxl-13 {
    row-gap: 52px !important;
  }
  :where(.vuetify-styles) .gr-xxl-14 {
    row-gap: 56px !important;
  }
  :where(.vuetify-styles) .gr-xxl-15 {
    row-gap: 60px !important;
  }
  :where(.vuetify-styles) .gr-xxl-16 {
    row-gap: 64px !important;
  }
  :where(.vuetify-styles) .gr-xxl-auto {
    row-gap: auto !important;
  }
  :where(.vuetify-styles) .gc-xxl-0 {
    column-gap: 0px !important;
  }
  :where(.vuetify-styles) .gc-xxl-1 {
    column-gap: 4px !important;
  }
  :where(.vuetify-styles) .gc-xxl-2 {
    column-gap: 8px !important;
  }
  :where(.vuetify-styles) .gc-xxl-3 {
    column-gap: 12px !important;
  }
  :where(.vuetify-styles) .gc-xxl-4 {
    column-gap: 16px !important;
  }
  :where(.vuetify-styles) .gc-xxl-5 {
    column-gap: 20px !important;
  }
  :where(.vuetify-styles) .gc-xxl-6 {
    column-gap: 24px !important;
  }
  :where(.vuetify-styles) .gc-xxl-7 {
    column-gap: 28px !important;
  }
  :where(.vuetify-styles) .gc-xxl-8 {
    column-gap: 32px !important;
  }
  :where(.vuetify-styles) .gc-xxl-9 {
    column-gap: 36px !important;
  }
  :where(.vuetify-styles) .gc-xxl-10 {
    column-gap: 40px !important;
  }
  :where(.vuetify-styles) .gc-xxl-11 {
    column-gap: 44px !important;
  }
  :where(.vuetify-styles) .gc-xxl-12 {
    column-gap: 48px !important;
  }
  :where(.vuetify-styles) .gc-xxl-13 {
    column-gap: 52px !important;
  }
  :where(.vuetify-styles) .gc-xxl-14 {
    column-gap: 56px !important;
  }
  :where(.vuetify-styles) .gc-xxl-15 {
    column-gap: 60px !important;
  }
  :where(.vuetify-styles) .gc-xxl-16 {
    column-gap: 64px !important;
  }
  :where(.vuetify-styles) .gc-xxl-auto {
    column-gap: auto !important;
  }
  :where(.vuetify-styles) .ma-xxl-0 {
    margin: 0px !important;
  }
  :where(.vuetify-styles) .ma-xxl-1 {
    margin: 4px !important;
  }
  :where(.vuetify-styles) .ma-xxl-2 {
    margin: 8px !important;
  }
  :where(.vuetify-styles) .ma-xxl-3 {
    margin: 12px !important;
  }
  :where(.vuetify-styles) .ma-xxl-4 {
    margin: 16px !important;
  }
  :where(.vuetify-styles) .ma-xxl-5 {
    margin: 20px !important;
  }
  :where(.vuetify-styles) .ma-xxl-6 {
    margin: 24px !important;
  }
  :where(.vuetify-styles) .ma-xxl-7 {
    margin: 28px !important;
  }
  :where(.vuetify-styles) .ma-xxl-8 {
    margin: 32px !important;
  }
  :where(.vuetify-styles) .ma-xxl-9 {
    margin: 36px !important;
  }
  :where(.vuetify-styles) .ma-xxl-10 {
    margin: 40px !important;
  }
  :where(.vuetify-styles) .ma-xxl-11 {
    margin: 44px !important;
  }
  :where(.vuetify-styles) .ma-xxl-12 {
    margin: 48px !important;
  }
  :where(.vuetify-styles) .ma-xxl-13 {
    margin: 52px !important;
  }
  :where(.vuetify-styles) .ma-xxl-14 {
    margin: 56px !important;
  }
  :where(.vuetify-styles) .ma-xxl-15 {
    margin: 60px !important;
  }
  :where(.vuetify-styles) .ma-xxl-16 {
    margin: 64px !important;
  }
  :where(.vuetify-styles) .ma-xxl-auto {
    margin: auto !important;
  }
  :where(.vuetify-styles) .mx-xxl-0 {
    margin-right: 0px !important;
    margin-left: 0px !important;
  }
  :where(.vuetify-styles) .mx-xxl-1 {
    margin-right: 4px !important;
    margin-left: 4px !important;
  }
  :where(.vuetify-styles) .mx-xxl-2 {
    margin-right: 8px !important;
    margin-left: 8px !important;
  }
  :where(.vuetify-styles) .mx-xxl-3 {
    margin-right: 12px !important;
    margin-left: 12px !important;
  }
  :where(.vuetify-styles) .mx-xxl-4 {
    margin-right: 16px !important;
    margin-left: 16px !important;
  }
  :where(.vuetify-styles) .mx-xxl-5 {
    margin-right: 20px !important;
    margin-left: 20px !important;
  }
  :where(.vuetify-styles) .mx-xxl-6 {
    margin-right: 24px !important;
    margin-left: 24px !important;
  }
  :where(.vuetify-styles) .mx-xxl-7 {
    margin-right: 28px !important;
    margin-left: 28px !important;
  }
  :where(.vuetify-styles) .mx-xxl-8 {
    margin-right: 32px !important;
    margin-left: 32px !important;
  }
  :where(.vuetify-styles) .mx-xxl-9 {
    margin-right: 36px !important;
    margin-left: 36px !important;
  }
  :where(.vuetify-styles) .mx-xxl-10 {
    margin-right: 40px !important;
    margin-left: 40px !important;
  }
  :where(.vuetify-styles) .mx-xxl-11 {
    margin-right: 44px !important;
    margin-left: 44px !important;
  }
  :where(.vuetify-styles) .mx-xxl-12 {
    margin-right: 48px !important;
    margin-left: 48px !important;
  }
  :where(.vuetify-styles) .mx-xxl-13 {
    margin-right: 52px !important;
    margin-left: 52px !important;
  }
  :where(.vuetify-styles) .mx-xxl-14 {
    margin-right: 56px !important;
    margin-left: 56px !important;
  }
  :where(.vuetify-styles) .mx-xxl-15 {
    margin-right: 60px !important;
    margin-left: 60px !important;
  }
  :where(.vuetify-styles) .mx-xxl-16 {
    margin-right: 64px !important;
    margin-left: 64px !important;
  }
  :where(.vuetify-styles) .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  :where(.vuetify-styles) .my-xxl-0 {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  :where(.vuetify-styles) .my-xxl-1 {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }
  :where(.vuetify-styles) .my-xxl-2 {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }
  :where(.vuetify-styles) .my-xxl-3 {
    margin-top: 12px !important;
    margin-bottom: 12px !important;
  }
  :where(.vuetify-styles) .my-xxl-4 {
    margin-top: 16px !important;
    margin-bottom: 16px !important;
  }
  :where(.vuetify-styles) .my-xxl-5 {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  :where(.vuetify-styles) .my-xxl-6 {
    margin-top: 24px !important;
    margin-bottom: 24px !important;
  }
  :where(.vuetify-styles) .my-xxl-7 {
    margin-top: 28px !important;
    margin-bottom: 28px !important;
  }
  :where(.vuetify-styles) .my-xxl-8 {
    margin-top: 32px !important;
    margin-bottom: 32px !important;
  }
  :where(.vuetify-styles) .my-xxl-9 {
    margin-top: 36px !important;
    margin-bottom: 36px !important;
  }
  :where(.vuetify-styles) .my-xxl-10 {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  :where(.vuetify-styles) .my-xxl-11 {
    margin-top: 44px !important;
    margin-bottom: 44px !important;
  }
  :where(.vuetify-styles) .my-xxl-12 {
    margin-top: 48px !important;
    margin-bottom: 48px !important;
  }
  :where(.vuetify-styles) .my-xxl-13 {
    margin-top: 52px !important;
    margin-bottom: 52px !important;
  }
  :where(.vuetify-styles) .my-xxl-14 {
    margin-top: 56px !important;
    margin-bottom: 56px !important;
  }
  :where(.vuetify-styles) .my-xxl-15 {
    margin-top: 60px !important;
    margin-bottom: 60px !important;
  }
  :where(.vuetify-styles) .my-xxl-16 {
    margin-top: 64px !important;
    margin-bottom: 64px !important;
  }
  :where(.vuetify-styles) .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  :where(.vuetify-styles) .mt-xxl-0 {
    margin-top: 0px !important;
  }
  :where(.vuetify-styles) .mt-xxl-1 {
    margin-top: 4px !important;
  }
  :where(.vuetify-styles) .mt-xxl-2 {
    margin-top: 8px !important;
  }
  :where(.vuetify-styles) .mt-xxl-3 {
    margin-top: 12px !important;
  }
  :where(.vuetify-styles) .mt-xxl-4 {
    margin-top: 16px !important;
  }
  :where(.vuetify-styles) .mt-xxl-5 {
    margin-top: 20px !important;
  }
  :where(.vuetify-styles) .mt-xxl-6 {
    margin-top: 24px !important;
  }
  :where(.vuetify-styles) .mt-xxl-7 {
    margin-top: 28px !important;
  }
  :where(.vuetify-styles) .mt-xxl-8 {
    margin-top: 32px !important;
  }
  :where(.vuetify-styles) .mt-xxl-9 {
    margin-top: 36px !important;
  }
  :where(.vuetify-styles) .mt-xxl-10 {
    margin-top: 40px !important;
  }
  :where(.vuetify-styles) .mt-xxl-11 {
    margin-top: 44px !important;
  }
  :where(.vuetify-styles) .mt-xxl-12 {
    margin-top: 48px !important;
  }
  :where(.vuetify-styles) .mt-xxl-13 {
    margin-top: 52px !important;
  }
  :where(.vuetify-styles) .mt-xxl-14 {
    margin-top: 56px !important;
  }
  :where(.vuetify-styles) .mt-xxl-15 {
    margin-top: 60px !important;
  }
  :where(.vuetify-styles) .mt-xxl-16 {
    margin-top: 64px !important;
  }
  :where(.vuetify-styles) .mt-xxl-auto {
    margin-top: auto !important;
  }
  :where(.vuetify-styles) .mr-xxl-0 {
    margin-right: 0px !important;
  }
  :where(.vuetify-styles) .mr-xxl-1 {
    margin-right: 4px !important;
  }
  :where(.vuetify-styles) .mr-xxl-2 {
    margin-right: 8px !important;
  }
  :where(.vuetify-styles) .mr-xxl-3 {
    margin-right: 12px !important;
  }
  :where(.vuetify-styles) .mr-xxl-4 {
    margin-right: 16px !important;
  }
  :where(.vuetify-styles) .mr-xxl-5 {
    margin-right: 20px !important;
  }
  :where(.vuetify-styles) .mr-xxl-6 {
    margin-right: 24px !important;
  }
  :where(.vuetify-styles) .mr-xxl-7 {
    margin-right: 28px !important;
  }
  :where(.vuetify-styles) .mr-xxl-8 {
    margin-right: 32px !important;
  }
  :where(.vuetify-styles) .mr-xxl-9 {
    margin-right: 36px !important;
  }
  :where(.vuetify-styles) .mr-xxl-10 {
    margin-right: 40px !important;
  }
  :where(.vuetify-styles) .mr-xxl-11 {
    margin-right: 44px !important;
  }
  :where(.vuetify-styles) .mr-xxl-12 {
    margin-right: 48px !important;
  }
  :where(.vuetify-styles) .mr-xxl-13 {
    margin-right: 52px !important;
  }
  :where(.vuetify-styles) .mr-xxl-14 {
    margin-right: 56px !important;
  }
  :where(.vuetify-styles) .mr-xxl-15 {
    margin-right: 60px !important;
  }
  :where(.vuetify-styles) .mr-xxl-16 {
    margin-right: 64px !important;
  }
  :where(.vuetify-styles) .mr-xxl-auto {
    margin-right: auto !important;
  }
  :where(.vuetify-styles) .mb-xxl-0 {
    margin-bottom: 0px !important;
  }
  :where(.vuetify-styles) .mb-xxl-1 {
    margin-bottom: 4px !important;
  }
  :where(.vuetify-styles) .mb-xxl-2 {
    margin-bottom: 8px !important;
  }
  :where(.vuetify-styles) .mb-xxl-3 {
    margin-bottom: 12px !important;
  }
  :where(.vuetify-styles) .mb-xxl-4 {
    margin-bottom: 16px !important;
  }
  :where(.vuetify-styles) .mb-xxl-5 {
    margin-bottom: 20px !important;
  }
  :where(.vuetify-styles) .mb-xxl-6 {
    margin-bottom: 24px !important;
  }
  :where(.vuetify-styles) .mb-xxl-7 {
    margin-bottom: 28px !important;
  }
  :where(.vuetify-styles) .mb-xxl-8 {
    margin-bottom: 32px !important;
  }
  :where(.vuetify-styles) .mb-xxl-9 {
    margin-bottom: 36px !important;
  }
  :where(.vuetify-styles) .mb-xxl-10 {
    margin-bottom: 40px !important;
  }
  :where(.vuetify-styles) .mb-xxl-11 {
    margin-bottom: 44px !important;
  }
  :where(.vuetify-styles) .mb-xxl-12 {
    margin-bottom: 48px !important;
  }
  :where(.vuetify-styles) .mb-xxl-13 {
    margin-bottom: 52px !important;
  }
  :where(.vuetify-styles) .mb-xxl-14 {
    margin-bottom: 56px !important;
  }
  :where(.vuetify-styles) .mb-xxl-15 {
    margin-bottom: 60px !important;
  }
  :where(.vuetify-styles) .mb-xxl-16 {
    margin-bottom: 64px !important;
  }
  :where(.vuetify-styles) .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  :where(.vuetify-styles) .ml-xxl-0 {
    margin-left: 0px !important;
  }
  :where(.vuetify-styles) .ml-xxl-1 {
    margin-left: 4px !important;
  }
  :where(.vuetify-styles) .ml-xxl-2 {
    margin-left: 8px !important;
  }
  :where(.vuetify-styles) .ml-xxl-3 {
    margin-left: 12px !important;
  }
  :where(.vuetify-styles) .ml-xxl-4 {
    margin-left: 16px !important;
  }
  :where(.vuetify-styles) .ml-xxl-5 {
    margin-left: 20px !important;
  }
  :where(.vuetify-styles) .ml-xxl-6 {
    margin-left: 24px !important;
  }
  :where(.vuetify-styles) .ml-xxl-7 {
    margin-left: 28px !important;
  }
  :where(.vuetify-styles) .ml-xxl-8 {
    margin-left: 32px !important;
  }
  :where(.vuetify-styles) .ml-xxl-9 {
    margin-left: 36px !important;
  }
  :where(.vuetify-styles) .ml-xxl-10 {
    margin-left: 40px !important;
  }
  :where(.vuetify-styles) .ml-xxl-11 {
    margin-left: 44px !important;
  }
  :where(.vuetify-styles) .ml-xxl-12 {
    margin-left: 48px !important;
  }
  :where(.vuetify-styles) .ml-xxl-13 {
    margin-left: 52px !important;
  }
  :where(.vuetify-styles) .ml-xxl-14 {
    margin-left: 56px !important;
  }
  :where(.vuetify-styles) .ml-xxl-15 {
    margin-left: 60px !important;
  }
  :where(.vuetify-styles) .ml-xxl-16 {
    margin-left: 64px !important;
  }
  :where(.vuetify-styles) .ml-xxl-auto {
    margin-left: auto !important;
  }
  :where(.vuetify-styles) .ms-xxl-0 {
    margin-inline-start: 0px !important;
  }
  :where(.vuetify-styles) .ms-xxl-1 {
    margin-inline-start: 4px !important;
  }
  :where(.vuetify-styles) .ms-xxl-2 {
    margin-inline-start: 8px !important;
  }
  :where(.vuetify-styles) .ms-xxl-3 {
    margin-inline-start: 12px !important;
  }
  :where(.vuetify-styles) .ms-xxl-4 {
    margin-inline-start: 16px !important;
  }
  :where(.vuetify-styles) .ms-xxl-5 {
    margin-inline-start: 20px !important;
  }
  :where(.vuetify-styles) .ms-xxl-6 {
    margin-inline-start: 24px !important;
  }
  :where(.vuetify-styles) .ms-xxl-7 {
    margin-inline-start: 28px !important;
  }
  :where(.vuetify-styles) .ms-xxl-8 {
    margin-inline-start: 32px !important;
  }
  :where(.vuetify-styles) .ms-xxl-9 {
    margin-inline-start: 36px !important;
  }
  :where(.vuetify-styles) .ms-xxl-10 {
    margin-inline-start: 40px !important;
  }
  :where(.vuetify-styles) .ms-xxl-11 {
    margin-inline-start: 44px !important;
  }
  :where(.vuetify-styles) .ms-xxl-12 {
    margin-inline-start: 48px !important;
  }
  :where(.vuetify-styles) .ms-xxl-13 {
    margin-inline-start: 52px !important;
  }
  :where(.vuetify-styles) .ms-xxl-14 {
    margin-inline-start: 56px !important;
  }
  :where(.vuetify-styles) .ms-xxl-15 {
    margin-inline-start: 60px !important;
  }
  :where(.vuetify-styles) .ms-xxl-16 {
    margin-inline-start: 64px !important;
  }
  :where(.vuetify-styles) .ms-xxl-auto {
    margin-inline-start: auto !important;
  }
  :where(.vuetify-styles) .me-xxl-0 {
    margin-inline-end: 0px !important;
  }
  :where(.vuetify-styles) .me-xxl-1 {
    margin-inline-end: 4px !important;
  }
  :where(.vuetify-styles) .me-xxl-2 {
    margin-inline-end: 8px !important;
  }
  :where(.vuetify-styles) .me-xxl-3 {
    margin-inline-end: 12px !important;
  }
  :where(.vuetify-styles) .me-xxl-4 {
    margin-inline-end: 16px !important;
  }
  :where(.vuetify-styles) .me-xxl-5 {
    margin-inline-end: 20px !important;
  }
  :where(.vuetify-styles) .me-xxl-6 {
    margin-inline-end: 24px !important;
  }
  :where(.vuetify-styles) .me-xxl-7 {
    margin-inline-end: 28px !important;
  }
  :where(.vuetify-styles) .me-xxl-8 {
    margin-inline-end: 32px !important;
  }
  :where(.vuetify-styles) .me-xxl-9 {
    margin-inline-end: 36px !important;
  }
  :where(.vuetify-styles) .me-xxl-10 {
    margin-inline-end: 40px !important;
  }
  :where(.vuetify-styles) .me-xxl-11 {
    margin-inline-end: 44px !important;
  }
  :where(.vuetify-styles) .me-xxl-12 {
    margin-inline-end: 48px !important;
  }
  :where(.vuetify-styles) .me-xxl-13 {
    margin-inline-end: 52px !important;
  }
  :where(.vuetify-styles) .me-xxl-14 {
    margin-inline-end: 56px !important;
  }
  :where(.vuetify-styles) .me-xxl-15 {
    margin-inline-end: 60px !important;
  }
  :where(.vuetify-styles) .me-xxl-16 {
    margin-inline-end: 64px !important;
  }
  :where(.vuetify-styles) .me-xxl-auto {
    margin-inline-end: auto !important;
  }
  :where(.vuetify-styles) .ma-xxl-n1 {
    margin: -4px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n2 {
    margin: -8px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n3 {
    margin: -12px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n4 {
    margin: -16px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n5 {
    margin: -20px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n6 {
    margin: -24px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n7 {
    margin: -28px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n8 {
    margin: -32px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n9 {
    margin: -36px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n10 {
    margin: -40px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n11 {
    margin: -44px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n12 {
    margin: -48px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n13 {
    margin: -52px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n14 {
    margin: -56px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n15 {
    margin: -60px !important;
  }
  :where(.vuetify-styles) .ma-xxl-n16 {
    margin: -64px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n1 {
    margin-right: -4px !important;
    margin-left: -4px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n2 {
    margin-right: -8px !important;
    margin-left: -8px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n3 {
    margin-right: -12px !important;
    margin-left: -12px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n4 {
    margin-right: -16px !important;
    margin-left: -16px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n5 {
    margin-right: -20px !important;
    margin-left: -20px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n6 {
    margin-right: -24px !important;
    margin-left: -24px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n7 {
    margin-right: -28px !important;
    margin-left: -28px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n8 {
    margin-right: -32px !important;
    margin-left: -32px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n9 {
    margin-right: -36px !important;
    margin-left: -36px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n10 {
    margin-right: -40px !important;
    margin-left: -40px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n11 {
    margin-right: -44px !important;
    margin-left: -44px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n12 {
    margin-right: -48px !important;
    margin-left: -48px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n13 {
    margin-right: -52px !important;
    margin-left: -52px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n14 {
    margin-right: -56px !important;
    margin-left: -56px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n15 {
    margin-right: -60px !important;
    margin-left: -60px !important;
  }
  :where(.vuetify-styles) .mx-xxl-n16 {
    margin-right: -64px !important;
    margin-left: -64px !important;
  }
  :where(.vuetify-styles) .my-xxl-n1 {
    margin-top: -4px !important;
    margin-bottom: -4px !important;
  }
  :where(.vuetify-styles) .my-xxl-n2 {
    margin-top: -8px !important;
    margin-bottom: -8px !important;
  }
  :where(.vuetify-styles) .my-xxl-n3 {
    margin-top: -12px !important;
    margin-bottom: -12px !important;
  }
  :where(.vuetify-styles) .my-xxl-n4 {
    margin-top: -16px !important;
    margin-bottom: -16px !important;
  }
  :where(.vuetify-styles) .my-xxl-n5 {
    margin-top: -20px !important;
    margin-bottom: -20px !important;
  }
  :where(.vuetify-styles) .my-xxl-n6 {
    margin-top: -24px !important;
    margin-bottom: -24px !important;
  }
  :where(.vuetify-styles) .my-xxl-n7 {
    margin-top: -28px !important;
    margin-bottom: -28px !important;
  }
  :where(.vuetify-styles) .my-xxl-n8 {
    margin-top: -32px !important;
    margin-bottom: -32px !important;
  }
  :where(.vuetify-styles) .my-xxl-n9 {
    margin-top: -36px !important;
    margin-bottom: -36px !important;
  }
  :where(.vuetify-styles) .my-xxl-n10 {
    margin-top: -40px !important;
    margin-bottom: -40px !important;
  }
  :where(.vuetify-styles) .my-xxl-n11 {
    margin-top: -44px !important;
    margin-bottom: -44px !important;
  }
  :where(.vuetify-styles) .my-xxl-n12 {
    margin-top: -48px !important;
    margin-bottom: -48px !important;
  }
  :where(.vuetify-styles) .my-xxl-n13 {
    margin-top: -52px !important;
    margin-bottom: -52px !important;
  }
  :where(.vuetify-styles) .my-xxl-n14 {
    margin-top: -56px !important;
    margin-bottom: -56px !important;
  }
  :where(.vuetify-styles) .my-xxl-n15 {
    margin-top: -60px !important;
    margin-bottom: -60px !important;
  }
  :where(.vuetify-styles) .my-xxl-n16 {
    margin-top: -64px !important;
    margin-bottom: -64px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n1 {
    margin-top: -4px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n2 {
    margin-top: -8px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n3 {
    margin-top: -12px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n4 {
    margin-top: -16px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n5 {
    margin-top: -20px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n6 {
    margin-top: -24px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n7 {
    margin-top: -28px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n8 {
    margin-top: -32px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n9 {
    margin-top: -36px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n10 {
    margin-top: -40px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n11 {
    margin-top: -44px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n12 {
    margin-top: -48px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n13 {
    margin-top: -52px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n14 {
    margin-top: -56px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n15 {
    margin-top: -60px !important;
  }
  :where(.vuetify-styles) .mt-xxl-n16 {
    margin-top: -64px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n1 {
    margin-right: -4px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n2 {
    margin-right: -8px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n3 {
    margin-right: -12px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n4 {
    margin-right: -16px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n5 {
    margin-right: -20px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n6 {
    margin-right: -24px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n7 {
    margin-right: -28px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n8 {
    margin-right: -32px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n9 {
    margin-right: -36px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n10 {
    margin-right: -40px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n11 {
    margin-right: -44px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n12 {
    margin-right: -48px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n13 {
    margin-right: -52px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n14 {
    margin-right: -56px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n15 {
    margin-right: -60px !important;
  }
  :where(.vuetify-styles) .mr-xxl-n16 {
    margin-right: -64px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n1 {
    margin-bottom: -4px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n2 {
    margin-bottom: -8px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n3 {
    margin-bottom: -12px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n4 {
    margin-bottom: -16px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n5 {
    margin-bottom: -20px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n6 {
    margin-bottom: -24px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n7 {
    margin-bottom: -28px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n8 {
    margin-bottom: -32px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n9 {
    margin-bottom: -36px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n10 {
    margin-bottom: -40px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n11 {
    margin-bottom: -44px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n12 {
    margin-bottom: -48px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n13 {
    margin-bottom: -52px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n14 {
    margin-bottom: -56px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n15 {
    margin-bottom: -60px !important;
  }
  :where(.vuetify-styles) .mb-xxl-n16 {
    margin-bottom: -64px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n1 {
    margin-left: -4px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n2 {
    margin-left: -8px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n3 {
    margin-left: -12px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n4 {
    margin-left: -16px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n5 {
    margin-left: -20px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n6 {
    margin-left: -24px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n7 {
    margin-left: -28px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n8 {
    margin-left: -32px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n9 {
    margin-left: -36px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n10 {
    margin-left: -40px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n11 {
    margin-left: -44px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n12 {
    margin-left: -48px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n13 {
    margin-left: -52px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n14 {
    margin-left: -56px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n15 {
    margin-left: -60px !important;
  }
  :where(.vuetify-styles) .ml-xxl-n16 {
    margin-left: -64px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n1 {
    margin-inline-start: -4px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n2 {
    margin-inline-start: -8px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n3 {
    margin-inline-start: -12px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n4 {
    margin-inline-start: -16px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n5 {
    margin-inline-start: -20px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n6 {
    margin-inline-start: -24px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n7 {
    margin-inline-start: -28px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n8 {
    margin-inline-start: -32px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n9 {
    margin-inline-start: -36px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n10 {
    margin-inline-start: -40px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n11 {
    margin-inline-start: -44px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n12 {
    margin-inline-start: -48px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n13 {
    margin-inline-start: -52px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n14 {
    margin-inline-start: -56px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n15 {
    margin-inline-start: -60px !important;
  }
  :where(.vuetify-styles) .ms-xxl-n16 {
    margin-inline-start: -64px !important;
  }
  :where(.vuetify-styles) .me-xxl-n1 {
    margin-inline-end: -4px !important;
  }
  :where(.vuetify-styles) .me-xxl-n2 {
    margin-inline-end: -8px !important;
  }
  :where(.vuetify-styles) .me-xxl-n3 {
    margin-inline-end: -12px !important;
  }
  :where(.vuetify-styles) .me-xxl-n4 {
    margin-inline-end: -16px !important;
  }
  :where(.vuetify-styles) .me-xxl-n5 {
    margin-inline-end: -20px !important;
  }
  :where(.vuetify-styles) .me-xxl-n6 {
    margin-inline-end: -24px !important;
  }
  :where(.vuetify-styles) .me-xxl-n7 {
    margin-inline-end: -28px !important;
  }
  :where(.vuetify-styles) .me-xxl-n8 {
    margin-inline-end: -32px !important;
  }
  :where(.vuetify-styles) .me-xxl-n9 {
    margin-inline-end: -36px !important;
  }
  :where(.vuetify-styles) .me-xxl-n10 {
    margin-inline-end: -40px !important;
  }
  :where(.vuetify-styles) .me-xxl-n11 {
    margin-inline-end: -44px !important;
  }
  :where(.vuetify-styles) .me-xxl-n12 {
    margin-inline-end: -48px !important;
  }
  :where(.vuetify-styles) .me-xxl-n13 {
    margin-inline-end: -52px !important;
  }
  :where(.vuetify-styles) .me-xxl-n14 {
    margin-inline-end: -56px !important;
  }
  :where(.vuetify-styles) .me-xxl-n15 {
    margin-inline-end: -60px !important;
  }
  :where(.vuetify-styles) .me-xxl-n16 {
    margin-inline-end: -64px !important;
  }
  :where(.vuetify-styles) .pa-xxl-0 {
    padding: 0px !important;
  }
  :where(.vuetify-styles) .pa-xxl-1 {
    padding: 4px !important;
  }
  :where(.vuetify-styles) .pa-xxl-2 {
    padding: 8px !important;
  }
  :where(.vuetify-styles) .pa-xxl-3 {
    padding: 12px !important;
  }
  :where(.vuetify-styles) .pa-xxl-4 {
    padding: 16px !important;
  }
  :where(.vuetify-styles) .pa-xxl-5 {
    padding: 20px !important;
  }
  :where(.vuetify-styles) .pa-xxl-6 {
    padding: 24px !important;
  }
  :where(.vuetify-styles) .pa-xxl-7 {
    padding: 28px !important;
  }
  :where(.vuetify-styles) .pa-xxl-8 {
    padding: 32px !important;
  }
  :where(.vuetify-styles) .pa-xxl-9 {
    padding: 36px !important;
  }
  :where(.vuetify-styles) .pa-xxl-10 {
    padding: 40px !important;
  }
  :where(.vuetify-styles) .pa-xxl-11 {
    padding: 44px !important;
  }
  :where(.vuetify-styles) .pa-xxl-12 {
    padding: 48px !important;
  }
  :where(.vuetify-styles) .pa-xxl-13 {
    padding: 52px !important;
  }
  :where(.vuetify-styles) .pa-xxl-14 {
    padding: 56px !important;
  }
  :where(.vuetify-styles) .pa-xxl-15 {
    padding: 60px !important;
  }
  :where(.vuetify-styles) .pa-xxl-16 {
    padding: 64px !important;
  }
  :where(.vuetify-styles) .px-xxl-0 {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  :where(.vuetify-styles) .px-xxl-1 {
    padding-right: 4px !important;
    padding-left: 4px !important;
  }
  :where(.vuetify-styles) .px-xxl-2 {
    padding-right: 8px !important;
    padding-left: 8px !important;
  }
  :where(.vuetify-styles) .px-xxl-3 {
    padding-right: 12px !important;
    padding-left: 12px !important;
  }
  :where(.vuetify-styles) .px-xxl-4 {
    padding-right: 16px !important;
    padding-left: 16px !important;
  }
  :where(.vuetify-styles) .px-xxl-5 {
    padding-right: 20px !important;
    padding-left: 20px !important;
  }
  :where(.vuetify-styles) .px-xxl-6 {
    padding-right: 24px !important;
    padding-left: 24px !important;
  }
  :where(.vuetify-styles) .px-xxl-7 {
    padding-right: 28px !important;
    padding-left: 28px !important;
  }
  :where(.vuetify-styles) .px-xxl-8 {
    padding-right: 32px !important;
    padding-left: 32px !important;
  }
  :where(.vuetify-styles) .px-xxl-9 {
    padding-right: 36px !important;
    padding-left: 36px !important;
  }
  :where(.vuetify-styles) .px-xxl-10 {
    padding-right: 40px !important;
    padding-left: 40px !important;
  }
  :where(.vuetify-styles) .px-xxl-11 {
    padding-right: 44px !important;
    padding-left: 44px !important;
  }
  :where(.vuetify-styles) .px-xxl-12 {
    padding-right: 48px !important;
    padding-left: 48px !important;
  }
  :where(.vuetify-styles) .px-xxl-13 {
    padding-right: 52px !important;
    padding-left: 52px !important;
  }
  :where(.vuetify-styles) .px-xxl-14 {
    padding-right: 56px !important;
    padding-left: 56px !important;
  }
  :where(.vuetify-styles) .px-xxl-15 {
    padding-right: 60px !important;
    padding-left: 60px !important;
  }
  :where(.vuetify-styles) .px-xxl-16 {
    padding-right: 64px !important;
    padding-left: 64px !important;
  }
  :where(.vuetify-styles) .py-xxl-0 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  :where(.vuetify-styles) .py-xxl-1 {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
  :where(.vuetify-styles) .py-xxl-2 {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  :where(.vuetify-styles) .py-xxl-3 {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  :where(.vuetify-styles) .py-xxl-4 {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
  :where(.vuetify-styles) .py-xxl-5 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  :where(.vuetify-styles) .py-xxl-6 {
    padding-top: 24px !important;
    padding-bottom: 24px !important;
  }
  :where(.vuetify-styles) .py-xxl-7 {
    padding-top: 28px !important;
    padding-bottom: 28px !important;
  }
  :where(.vuetify-styles) .py-xxl-8 {
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }
  :where(.vuetify-styles) .py-xxl-9 {
    padding-top: 36px !important;
    padding-bottom: 36px !important;
  }
  :where(.vuetify-styles) .py-xxl-10 {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  :where(.vuetify-styles) .py-xxl-11 {
    padding-top: 44px !important;
    padding-bottom: 44px !important;
  }
  :where(.vuetify-styles) .py-xxl-12 {
    padding-top: 48px !important;
    padding-bottom: 48px !important;
  }
  :where(.vuetify-styles) .py-xxl-13 {
    padding-top: 52px !important;
    padding-bottom: 52px !important;
  }
  :where(.vuetify-styles) .py-xxl-14 {
    padding-top: 56px !important;
    padding-bottom: 56px !important;
  }
  :where(.vuetify-styles) .py-xxl-15 {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }
  :where(.vuetify-styles) .py-xxl-16 {
    padding-top: 64px !important;
    padding-bottom: 64px !important;
  }
  :where(.vuetify-styles) .pt-xxl-0 {
    padding-top: 0px !important;
  }
  :where(.vuetify-styles) .pt-xxl-1 {
    padding-top: 4px !important;
  }
  :where(.vuetify-styles) .pt-xxl-2 {
    padding-top: 8px !important;
  }
  :where(.vuetify-styles) .pt-xxl-3 {
    padding-top: 12px !important;
  }
  :where(.vuetify-styles) .pt-xxl-4 {
    padding-top: 16px !important;
  }
  :where(.vuetify-styles) .pt-xxl-5 {
    padding-top: 20px !important;
  }
  :where(.vuetify-styles) .pt-xxl-6 {
    padding-top: 24px !important;
  }
  :where(.vuetify-styles) .pt-xxl-7 {
    padding-top: 28px !important;
  }
  :where(.vuetify-styles) .pt-xxl-8 {
    padding-top: 32px !important;
  }
  :where(.vuetify-styles) .pt-xxl-9 {
    padding-top: 36px !important;
  }
  :where(.vuetify-styles) .pt-xxl-10 {
    padding-top: 40px !important;
  }
  :where(.vuetify-styles) .pt-xxl-11 {
    padding-top: 44px !important;
  }
  :where(.vuetify-styles) .pt-xxl-12 {
    padding-top: 48px !important;
  }
  :where(.vuetify-styles) .pt-xxl-13 {
    padding-top: 52px !important;
  }
  :where(.vuetify-styles) .pt-xxl-14 {
    padding-top: 56px !important;
  }
  :where(.vuetify-styles) .pt-xxl-15 {
    padding-top: 60px !important;
  }
  :where(.vuetify-styles) .pt-xxl-16 {
    padding-top: 64px !important;
  }
  :where(.vuetify-styles) .pr-xxl-0 {
    padding-right: 0px !important;
  }
  :where(.vuetify-styles) .pr-xxl-1 {
    padding-right: 4px !important;
  }
  :where(.vuetify-styles) .pr-xxl-2 {
    padding-right: 8px !important;
  }
  :where(.vuetify-styles) .pr-xxl-3 {
    padding-right: 12px !important;
  }
  :where(.vuetify-styles) .pr-xxl-4 {
    padding-right: 16px !important;
  }
  :where(.vuetify-styles) .pr-xxl-5 {
    padding-right: 20px !important;
  }
  :where(.vuetify-styles) .pr-xxl-6 {
    padding-right: 24px !important;
  }
  :where(.vuetify-styles) .pr-xxl-7 {
    padding-right: 28px !important;
  }
  :where(.vuetify-styles) .pr-xxl-8 {
    padding-right: 32px !important;
  }
  :where(.vuetify-styles) .pr-xxl-9 {
    padding-right: 36px !important;
  }
  :where(.vuetify-styles) .pr-xxl-10 {
    padding-right: 40px !important;
  }
  :where(.vuetify-styles) .pr-xxl-11 {
    padding-right: 44px !important;
  }
  :where(.vuetify-styles) .pr-xxl-12 {
    padding-right: 48px !important;
  }
  :where(.vuetify-styles) .pr-xxl-13 {
    padding-right: 52px !important;
  }
  :where(.vuetify-styles) .pr-xxl-14 {
    padding-right: 56px !important;
  }
  :where(.vuetify-styles) .pr-xxl-15 {
    padding-right: 60px !important;
  }
  :where(.vuetify-styles) .pr-xxl-16 {
    padding-right: 64px !important;
  }
  :where(.vuetify-styles) .pb-xxl-0 {
    padding-bottom: 0px !important;
  }
  :where(.vuetify-styles) .pb-xxl-1 {
    padding-bottom: 4px !important;
  }
  :where(.vuetify-styles) .pb-xxl-2 {
    padding-bottom: 8px !important;
  }
  :where(.vuetify-styles) .pb-xxl-3 {
    padding-bottom: 12px !important;
  }
  :where(.vuetify-styles) .pb-xxl-4 {
    padding-bottom: 16px !important;
  }
  :where(.vuetify-styles) .pb-xxl-5 {
    padding-bottom: 20px !important;
  }
  :where(.vuetify-styles) .pb-xxl-6 {
    padding-bottom: 24px !important;
  }
  :where(.vuetify-styles) .pb-xxl-7 {
    padding-bottom: 28px !important;
  }
  :where(.vuetify-styles) .pb-xxl-8 {
    padding-bottom: 32px !important;
  }
  :where(.vuetify-styles) .pb-xxl-9 {
    padding-bottom: 36px !important;
  }
  :where(.vuetify-styles) .pb-xxl-10 {
    padding-bottom: 40px !important;
  }
  :where(.vuetify-styles) .pb-xxl-11 {
    padding-bottom: 44px !important;
  }
  :where(.vuetify-styles) .pb-xxl-12 {
    padding-bottom: 48px !important;
  }
  :where(.vuetify-styles) .pb-xxl-13 {
    padding-bottom: 52px !important;
  }
  :where(.vuetify-styles) .pb-xxl-14 {
    padding-bottom: 56px !important;
  }
  :where(.vuetify-styles) .pb-xxl-15 {
    padding-bottom: 60px !important;
  }
  :where(.vuetify-styles) .pb-xxl-16 {
    padding-bottom: 64px !important;
  }
  :where(.vuetify-styles) .pl-xxl-0 {
    padding-left: 0px !important;
  }
  :where(.vuetify-styles) .pl-xxl-1 {
    padding-left: 4px !important;
  }
  :where(.vuetify-styles) .pl-xxl-2 {
    padding-left: 8px !important;
  }
  :where(.vuetify-styles) .pl-xxl-3 {
    padding-left: 12px !important;
  }
  :where(.vuetify-styles) .pl-xxl-4 {
    padding-left: 16px !important;
  }
  :where(.vuetify-styles) .pl-xxl-5 {
    padding-left: 20px !important;
  }
  :where(.vuetify-styles) .pl-xxl-6 {
    padding-left: 24px !important;
  }
  :where(.vuetify-styles) .pl-xxl-7 {
    padding-left: 28px !important;
  }
  :where(.vuetify-styles) .pl-xxl-8 {
    padding-left: 32px !important;
  }
  :where(.vuetify-styles) .pl-xxl-9 {
    padding-left: 36px !important;
  }
  :where(.vuetify-styles) .pl-xxl-10 {
    padding-left: 40px !important;
  }
  :where(.vuetify-styles) .pl-xxl-11 {
    padding-left: 44px !important;
  }
  :where(.vuetify-styles) .pl-xxl-12 {
    padding-left: 48px !important;
  }
  :where(.vuetify-styles) .pl-xxl-13 {
    padding-left: 52px !important;
  }
  :where(.vuetify-styles) .pl-xxl-14 {
    padding-left: 56px !important;
  }
  :where(.vuetify-styles) .pl-xxl-15 {
    padding-left: 60px !important;
  }
  :where(.vuetify-styles) .pl-xxl-16 {
    padding-left: 64px !important;
  }
  :where(.vuetify-styles) .ps-xxl-0 {
    padding-inline-start: 0px !important;
  }
  :where(.vuetify-styles) .ps-xxl-1 {
    padding-inline-start: 4px !important;
  }
  :where(.vuetify-styles) .ps-xxl-2 {
    padding-inline-start: 8px !important;
  }
  :where(.vuetify-styles) .ps-xxl-3 {
    padding-inline-start: 12px !important;
  }
  :where(.vuetify-styles) .ps-xxl-4 {
    padding-inline-start: 16px !important;
  }
  :where(.vuetify-styles) .ps-xxl-5 {
    padding-inline-start: 20px !important;
  }
  :where(.vuetify-styles) .ps-xxl-6 {
    padding-inline-start: 24px !important;
  }
  :where(.vuetify-styles) .ps-xxl-7 {
    padding-inline-start: 28px !important;
  }
  :where(.vuetify-styles) .ps-xxl-8 {
    padding-inline-start: 32px !important;
  }
  :where(.vuetify-styles) .ps-xxl-9 {
    padding-inline-start: 36px !important;
  }
  :where(.vuetify-styles) .ps-xxl-10 {
    padding-inline-start: 40px !important;
  }
  :where(.vuetify-styles) .ps-xxl-11 {
    padding-inline-start: 44px !important;
  }
  :where(.vuetify-styles) .ps-xxl-12 {
    padding-inline-start: 48px !important;
  }
  :where(.vuetify-styles) .ps-xxl-13 {
    padding-inline-start: 52px !important;
  }
  :where(.vuetify-styles) .ps-xxl-14 {
    padding-inline-start: 56px !important;
  }
  :where(.vuetify-styles) .ps-xxl-15 {
    padding-inline-start: 60px !important;
  }
  :where(.vuetify-styles) .ps-xxl-16 {
    padding-inline-start: 64px !important;
  }
  :where(.vuetify-styles) .pe-xxl-0 {
    padding-inline-end: 0px !important;
  }
  :where(.vuetify-styles) .pe-xxl-1 {
    padding-inline-end: 4px !important;
  }
  :where(.vuetify-styles) .pe-xxl-2 {
    padding-inline-end: 8px !important;
  }
  :where(.vuetify-styles) .pe-xxl-3 {
    padding-inline-end: 12px !important;
  }
  :where(.vuetify-styles) .pe-xxl-4 {
    padding-inline-end: 16px !important;
  }
  :where(.vuetify-styles) .pe-xxl-5 {
    padding-inline-end: 20px !important;
  }
  :where(.vuetify-styles) .pe-xxl-6 {
    padding-inline-end: 24px !important;
  }
  :where(.vuetify-styles) .pe-xxl-7 {
    padding-inline-end: 28px !important;
  }
  :where(.vuetify-styles) .pe-xxl-8 {
    padding-inline-end: 32px !important;
  }
  :where(.vuetify-styles) .pe-xxl-9 {
    padding-inline-end: 36px !important;
  }
  :where(.vuetify-styles) .pe-xxl-10 {
    padding-inline-end: 40px !important;
  }
  :where(.vuetify-styles) .pe-xxl-11 {
    padding-inline-end: 44px !important;
  }
  :where(.vuetify-styles) .pe-xxl-12 {
    padding-inline-end: 48px !important;
  }
  :where(.vuetify-styles) .pe-xxl-13 {
    padding-inline-end: 52px !important;
  }
  :where(.vuetify-styles) .pe-xxl-14 {
    padding-inline-end: 56px !important;
  }
  :where(.vuetify-styles) .pe-xxl-15 {
    padding-inline-end: 60px !important;
  }
  :where(.vuetify-styles) .pe-xxl-16 {
    padding-inline-end: 64px !important;
  }
  :where(.vuetify-styles) .text-xxl-left {
    text-align: left !important;
  }
  :where(.vuetify-styles) .text-xxl-right {
    text-align: right !important;
  }
  :where(.vuetify-styles) .text-xxl-center {
    text-align: center !important;
  }
  :where(.vuetify-styles) .text-xxl-justify {
    text-align: justify !important;
  }
  :where(.vuetify-styles) .text-xxl-start {
    text-align: start !important;
  }
  :where(.vuetify-styles) .text-xxl-end {
    text-align: end !important;
  }
  :where(.vuetify-styles) .text-xxl-h1 {
    font-size: 6rem !important;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.015625em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xxl-h2 {
    font-size: 3.75rem !important;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.0083333333em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xxl-h3 {
    font-size: 3rem !important;
    font-weight: 400;
    line-height: 1.05;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xxl-h4 {
    font-size: 2.125rem !important;
    font-weight: 400;
    line-height: 1.175;
    letter-spacing: 0.0073529412em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xxl-h5 {
    font-size: 1.5rem !important;
    font-weight: 400;
    line-height: 1.333;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xxl-h6 {
    font-size: 1.25rem !important;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: 0.0125em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xxl-subtitle-1 {
    font-size: 1rem !important;
    font-weight: normal;
    line-height: 1.75;
    letter-spacing: 0.009375em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xxl-subtitle-2 {
    font-size: 0.875rem !important;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: 0.0071428571em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xxl-body-1 {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.03125em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xxl-body-2 {
    font-size: 0.875rem !important;
    font-weight: 400;
    line-height: 1.425;
    letter-spacing: 0.0178571429em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xxl-button {
    font-size: 0.875rem !important;
    font-weight: 500;
    line-height: 2.6;
    letter-spacing: 0.0892857143em !important;
    font-family: "Roboto", sans-serif;
    text-transform: uppercase !important;
  }
  :where(.vuetify-styles) .text-xxl-caption {
    font-size: 0.75rem !important;
    font-weight: 400;
    line-height: 1.667;
    letter-spacing: 0.0333333333em !important;
    font-family: "Roboto", sans-serif;
    text-transform: none !important;
  }
  :where(.vuetify-styles) .text-xxl-overline {
    font-size: 0.75rem !important;
    font-weight: 500;
    line-height: 2.667;
    letter-spacing: 0.1666666667em !important;
    font-family: "Roboto", sans-serif;
    text-transform: uppercase !important;
  }
  :where(.vuetify-styles) .h-xxl-auto {
    height: auto !important;
  }
  :where(.vuetify-styles) .h-xxl-screen {
    height: 100vh !important;
  }
  :where(.vuetify-styles) .h-xxl-0 {
    height: 0 !important;
  }
  :where(.vuetify-styles) .h-xxl-25 {
    height: 25% !important;
  }
  :where(.vuetify-styles) .h-xxl-50 {
    height: 50% !important;
  }
  :where(.vuetify-styles) .h-xxl-75 {
    height: 75% !important;
  }
  :where(.vuetify-styles) .h-xxl-100 {
    height: 100% !important;
  }
  :where(.vuetify-styles) .w-xxl-auto {
    width: auto !important;
  }
  :where(.vuetify-styles) .w-xxl-0 {
    width: 0 !important;
  }
  :where(.vuetify-styles) .w-xxl-25 {
    width: 25% !important;
  }
  :where(.vuetify-styles) .w-xxl-33 {
    width: 33% !important;
  }
  :where(.vuetify-styles) .w-xxl-50 {
    width: 50% !important;
  }
  :where(.vuetify-styles) .w-xxl-66 {
    width: 66% !important;
  }
  :where(.vuetify-styles) .w-xxl-75 {
    width: 75% !important;
  }
  :where(.vuetify-styles) .w-xxl-100 {
    width: 100% !important;
  }
}
@media print {
  :where(.vuetify-styles) .d-print-none {
    display: none !important;
  }
  :where(.vuetify-styles) .d-print-inline {
    display: inline !important;
  }
  :where(.vuetify-styles) .d-print-inline-block {
    display: inline-block !important;
  }
  :where(.vuetify-styles) .d-print-block {
    display: block !important;
  }
  :where(.vuetify-styles) .d-print-table {
    display: table !important;
  }
  :where(.vuetify-styles) .d-print-table-row {
    display: table-row !important;
  }
  :where(.vuetify-styles) .d-print-table-cell {
    display: table-cell !important;
  }
  :where(.vuetify-styles) .d-print-flex {
    display: flex !important;
  }
  :where(.vuetify-styles) .d-print-inline-flex {
    display: inline-flex !important;
  }
  :where(.vuetify-styles) .float-print-none {
    float: none !important;
  }
  :where(.vuetify-styles) .float-print-left {
    float: left !important;
  }
  :where(.vuetify-styles) .float-print-right {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-rtl .float-print-end {
    float: left !important;
  }
  :where(.vuetify-styles) .v-locale--is-rtl .float-print-start {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-ltr .float-print-end {
    float: right !important;
  }
  :where(.vuetify-styles) .v-locale--is-ltr .float-print-start {
    float: left !important;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/styles/main.css"],"names":[],"mappings":"AAAA;EACE;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;EAIE;AACF;;wEAEwE;AACxE;EACE,sBAAsB;EACtB,kBAAkB,EAAE,+CAA+C;EACnE,8BAA8B,EAAE,sEAAsE;EACtG,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,4BAA4B,EAAE,2EAA2E;EACzG,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB,EAAE,uFAAuF;EACjH,uBAAuB;AACzB;;AAEA;EACE,UAAU,EAAE,iDAAiD;EAC7D,SAAS;AACX;;AAEA;;wEAEwE;AACxE;EACE,iBAAiB,EAAE,qCAAqC;EACxD,SAAS,EAAE,0CAA0C;AACvD;;AAEA;;EAEE,cAAc,EAAE,kDAAkD;AACpE;;AAEA;EACE,kBAAkB,EAAE,4CAA4C;AAClE;;AAEA;EACE,cAAc,EAAE,6CAA6C;AAC/D;;AAEA;EACE,aAAa,EAAE,kCAAkC;AACnD;;AAEA;EACE,mBAAmB,EAAE,0CAA0C;EAC/D,2EAA2E;EAC3E,0BAA0B;EAC1B,yCAAiC;UAAjC,iCAAiC;AACnC;;AAEA;EACE,6BAA6B,EAAE,wDAAwD;AACzF;;AAEA;;EAEE,gBAAgB,EAAE,qDAAqD;AACzE;;AAEA;;;;EAIE,iCAAiC,EAAE,6CAA6C;AAClF;;AAEA;EACE,cAAc,EAAE,qDAAqD;AACvE;;AAEA;;EAEE,mBAAmB,EAAE,4DAA4D;AACnF;;AAEA,8CAA8C;AAC9C;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;wEAEwE;AACxE;EACE,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,eAAe;AACjB;;AAEA;;EAEE,YAAY,EAAE,0EAA0E;AAC1F;;AAEA;EACE,6BAA6B,EAAE,oDAAoD;EACnF,oBAAoB,EAAE,wCAAwC;AAChE;;AAEA;;EAEE,wBAAwB,EAAE,2DAA2D;AACvF;;AAEA;EACE,cAAc,EAAE,0BAA0B;EAC1C,gBAAgB,EAAE,kCAAkC;AACtD;;AAEA;;;;;EAKE,aAAa,EAAE,8CAA8C;AAC/D;;AAEA;EACE,iBAAiB,EAAE,uDAAuD;AAC5E;;AAEA;EACE,iBAAiB,EAAE,uDAAuD;AAC5E;;AAEA;;EAEE,oBAAoB,EAAE,uCAAuC;AAC/D;;AAEA,4CAA4C;AAC5C;;;;;EAKE,eAAe;EACf,cAAc;AAChB;;AAEA,kDAAkD;AAClD;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,0DAA0D;AAC1D;;;;EAIE,8BAA8B;AAChC;;AAEA;;;;EAIE,0BAA0B,EAAE,0DAA0D;AACxF;;AAEA,sDAAsD;AACtD;;;;EAIE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,qBAAqB,EAAE,gBAAgB;EACvC,wBAAwB,EAAE,eAAe;AAC3C;;AAEA;EACE,aAAa,EAAE,0BAA0B;AAC3C;;AAEA;EACE,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA;EACE,SAAS,EAAE,wDAAwD;EACnE,cAAc,EAAE,iEAAiE;EACjF,cAAc,EAAE,6CAA6C;EAC7D,eAAe,EAAE,6CAA6C;EAC9D,mBAAmB,EAAE,6CAA6C;EAClE,eAAe,EAAE,iDAAiD;AACpE;;AAEA;EACE,qEAAqE;EACrE,0BAA0B;EAC1B,cAAc;EACd,aAAa,EAAE,6DAA6D;AAC9E;;AAEA;;EAEE,aAAa;AACf;;AAEA;;wEAEwE;AACxE;EACE,kBAAkB,EAAE,uDAAuD;AAC7E;;AAEA,qEAAqE;AACrE;EACE,wBAAwB;AAC1B;;AAEA;;wEAEwE;AACxE,oDAAoD;AACpD;EACE;IACE,gBAAgB;EAClB;EACA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;AACF;AACA,qDAAqD;AACrD;EACE,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,eAAe;AACjB;;AAEA,4FAA4F;AAC5F;EACE,eAAe;AACjB;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,iEAAiE;EACnE;EACA;;;IAGE,qCAAqC;IACrC,iEAAiE;EACnE;EACA;IAKE,kDAAkD;IAClD,oBAAoB;EACtB;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,uCAAuC;EACzC;EACA;IACE,wCAAwC;EAC1C;EACA;;IAEE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;;IAEE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;;IAEE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IAGE,UAAU;EACZ;EACA;IAIE,6BAA6B;EAC/B;EACA;IAGE,kDAAkD;EACpD;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,qCAAqC;EACvC;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,UAAU;EACZ;EACA;IACE,qCAAqC;EACvC;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,kDAAkD;EACpD;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,UAAU;EACZ;EACA;IACE,qCAAqC;EACvC;EACA;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,kDAAkD;EACpD;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,UAAU;EACZ;EACA;IACE,qCAAqC;EACvC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,kDAAkD;EACpD;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kDAAkD;EACpD;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,kDAAkD;EACpD;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,kDAAkD;EACpD;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,UAAU;EACZ;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,kDAAkD;EACpD;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,UAAU;EACZ;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kDAAkD;EACpD;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,UAAU;EACZ;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,kDAAkD;EACpD;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,UAAU;EACZ;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kDAAkD;EACpD;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,kDAAkD;EACpD;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,kDAAkD;EACpD;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uCAAuC;EACzC;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,mEAAmE;EACrE;EACA;IACE,oCAAoC;IACpC,yCAAyC;IACzC,mEAAmE;EACrE;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,uPAAuP;AACzP;;AAEA;EACE,uPAAuP;AACzP;;AAEA;EACE,uPAAuP;AACzP;;AAEA;EACE,uPAAuP;AACzP;;AAEA;EACE,uPAAuP;AACzP;;AAEA;EACE,sPAAsP;AACxP;;AAEA;EACE,sPAAsP;AACxP;;AAEA;EACE,sPAAsP;AACxP;;AAEA;EACE,sPAAsP;AACxP;;AAEA;EACE,qPAAqP;AACvP;;AAEA;EACE,qPAAqP;AACvP;;AAEA;EACE,qPAAqP;AACvP;;AAEA;EACE,qPAAqP;AACvP;;AAEA;EACE,qPAAqP;AACvP;;AAEA;EACE,qPAAqP;AACvP;;AAEA;EACE,oPAAoP;AACtP;;AAEA;EACE,oPAAoP;AACtP;;AAEA;EACE,oPAAoP;AACtP;;AAEA;EACE,oPAAoP;AACtP;;AAEA;EACE,mPAAmP;AACrP;;AAEA;EACE,mPAAmP;AACrP;;AAEA;EACE,kPAAkP;AACpP;;AAEA;EACE,kPAAkP;AACpP;;AAEA;EACE,kPAAkP;AACpP;;AAEA;EACE,iPAAiP;AACnP;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;EACpB,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,6EAA6E;AAC/E;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,6EAA6E;AAC/E;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,6EAA6E;AAC/E;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,6EAA6E;AAC/E;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,6EAA6E;AAC/E;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,6EAA6E;AAC/E;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,6EAA6E;AAC/E;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,yFAAyF;AAC3F;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,yFAAyF;AAC3F;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,yFAAyF;AAC3F;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,yFAAyF;AAC3F;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,yFAAyF;AAC3F;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,yFAAyF;AAC3F;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,yFAAyF;AAC3F;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,wFAAwF;AAC1F;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,wFAAwF;AAC1F;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,wFAAwF;AAC1F;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,wFAAwF;AAC1F;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,wFAAwF;AAC1F;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,wFAAwF;AAC1F;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,wFAAwF;AAC1F;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,uFAAuF;AACzF;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;EACxC,uFAAuF;AACzF;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;EACxC,uFAAuF;AACzF;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,uFAAuF;AACzF;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,uFAAuF;AACzF;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,uFAAuF;AACzF;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,uFAAuF;AACzF;;AAEA;EACE,uCAAuC;EACvC,2CAA2C;EAC3C,0FAA0F;AAC5F;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,0FAA0F;AAC5F;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,0FAA0F;AAC5F;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,0FAA0F;AAC5F;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,0FAA0F;AAC5F;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,0FAA0F;AAC5F;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,0FAA0F;AAC5F;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,0CAA0C;EAC1C,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,sCAAsC;IACtC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,0CAA0C;IAC1C,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;IACjC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;IACrC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,oCAAoC;IACpC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,sCAAsC;IACtC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,0CAA0C;IAC1C,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;IACjC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;IACrC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,oCAAoC;IACpC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,sCAAsC;IACtC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,0CAA0C;IAC1C,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;IACjC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;IACrC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,oCAAoC;IACpC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,sCAAsC;IACtC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,0CAA0C;IAC1C,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;IACjC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;IACrC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,oCAAoC;IACpC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,sCAAsC;IACtC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,0CAA0C;IAC1C,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;IACjC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;IACrC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,oCAAoC;IACpC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,iCAAiC;IACjC,oCAAoC;EACtC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["@keyframes v-shake {\n  59% {\n    margin-left: 0;\n  }\n  60%, 80% {\n    margin-left: 2px;\n  }\n  70%, 90% {\n    margin-left: -2px;\n  }\n}\n.bg-black {\n  background-color: #000000 !important;\n}\n.bg-black {\n  color: #FFFFFF !important;\n}\n\n.bg-white {\n  background-color: #FFFFFF !important;\n}\n.bg-white {\n  color: #000000 !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n.bg-transparent {\n  color: currentColor !important;\n}\n\n.bg-red {\n  background-color: #F44336 !important;\n}\n.bg-red {\n  color: #FFFFFF !important;\n}\n\n.bg-red-lighten-5 {\n  background-color: #FFEBEE !important;\n}\n.bg-red-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-red-lighten-4 {\n  background-color: #FFCDD2 !important;\n}\n.bg-red-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-red-lighten-3 {\n  background-color: #EF9A9A !important;\n}\n.bg-red-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-red-lighten-2 {\n  background-color: #E57373 !important;\n}\n.bg-red-lighten-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-red-lighten-1 {\n  background-color: #EF5350 !important;\n}\n.bg-red-lighten-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-red-darken-1 {\n  background-color: #E53935 !important;\n}\n.bg-red-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-red-darken-2 {\n  background-color: #D32F2F !important;\n}\n.bg-red-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-red-darken-3 {\n  background-color: #C62828 !important;\n}\n.bg-red-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-red-darken-4 {\n  background-color: #B71C1C !important;\n}\n.bg-red-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-red-accent-1 {\n  background-color: #FF8A80 !important;\n}\n.bg-red-accent-1 {\n  color: #000000 !important;\n}\n\n.bg-red-accent-2 {\n  background-color: #FF5252 !important;\n}\n.bg-red-accent-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-red-accent-3 {\n  background-color: #FF1744 !important;\n}\n.bg-red-accent-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-red-accent-4 {\n  background-color: #D50000 !important;\n}\n.bg-red-accent-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-pink {\n  background-color: #e91e63 !important;\n}\n.bg-pink {\n  color: #FFFFFF !important;\n}\n\n.bg-pink-lighten-5 {\n  background-color: #fce4ec !important;\n}\n.bg-pink-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-pink-lighten-4 {\n  background-color: #f8bbd0 !important;\n}\n.bg-pink-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-pink-lighten-3 {\n  background-color: #f48fb1 !important;\n}\n.bg-pink-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-pink-lighten-2 {\n  background-color: #f06292 !important;\n}\n.bg-pink-lighten-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-pink-lighten-1 {\n  background-color: #ec407a !important;\n}\n.bg-pink-lighten-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-pink-darken-1 {\n  background-color: #d81b60 !important;\n}\n.bg-pink-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-pink-darken-2 {\n  background-color: #c2185b !important;\n}\n.bg-pink-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-pink-darken-3 {\n  background-color: #ad1457 !important;\n}\n.bg-pink-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-pink-darken-4 {\n  background-color: #880e4f !important;\n}\n.bg-pink-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-pink-accent-1 {\n  background-color: #ff80ab !important;\n}\n.bg-pink-accent-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-pink-accent-2 {\n  background-color: #ff4081 !important;\n}\n.bg-pink-accent-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-pink-accent-3 {\n  background-color: #f50057 !important;\n}\n.bg-pink-accent-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-pink-accent-4 {\n  background-color: #c51162 !important;\n}\n.bg-pink-accent-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-purple {\n  background-color: #9c27b0 !important;\n}\n.bg-purple {\n  color: #FFFFFF !important;\n}\n\n.bg-purple-lighten-5 {\n  background-color: #f3e5f5 !important;\n}\n.bg-purple-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-purple-lighten-4 {\n  background-color: #e1bee7 !important;\n}\n.bg-purple-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-purple-lighten-3 {\n  background-color: #ce93d8 !important;\n}\n.bg-purple-lighten-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-purple-lighten-2 {\n  background-color: #ba68c8 !important;\n}\n.bg-purple-lighten-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-purple-lighten-1 {\n  background-color: #ab47bc !important;\n}\n.bg-purple-lighten-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-purple-darken-1 {\n  background-color: #8e24aa !important;\n}\n.bg-purple-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-purple-darken-2 {\n  background-color: #7b1fa2 !important;\n}\n.bg-purple-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-purple-darken-3 {\n  background-color: #6a1b9a !important;\n}\n.bg-purple-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-purple-darken-4 {\n  background-color: #4a148c !important;\n}\n.bg-purple-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-purple-accent-1 {\n  background-color: #ea80fc !important;\n}\n.bg-purple-accent-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-purple-accent-2 {\n  background-color: #e040fb !important;\n}\n.bg-purple-accent-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-purple-accent-3 {\n  background-color: #d500f9 !important;\n}\n.bg-purple-accent-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-purple-accent-4 {\n  background-color: #aa00ff !important;\n}\n.bg-purple-accent-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-purple {\n  background-color: #673ab7 !important;\n}\n.bg-deep-purple {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-purple-lighten-5 {\n  background-color: #ede7f6 !important;\n}\n.bg-deep-purple-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-deep-purple-lighten-4 {\n  background-color: #d1c4e9 !important;\n}\n.bg-deep-purple-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-deep-purple-lighten-3 {\n  background-color: #b39ddb !important;\n}\n.bg-deep-purple-lighten-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-purple-lighten-2 {\n  background-color: #9575cd !important;\n}\n.bg-deep-purple-lighten-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-purple-lighten-1 {\n  background-color: #7e57c2 !important;\n}\n.bg-deep-purple-lighten-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-purple-darken-1 {\n  background-color: #5e35b1 !important;\n}\n.bg-deep-purple-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-purple-darken-2 {\n  background-color: #512da8 !important;\n}\n.bg-deep-purple-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-purple-darken-3 {\n  background-color: #4527a0 !important;\n}\n.bg-deep-purple-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-purple-darken-4 {\n  background-color: #311b92 !important;\n}\n.bg-deep-purple-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-purple-accent-1 {\n  background-color: #b388ff !important;\n}\n.bg-deep-purple-accent-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-purple-accent-2 {\n  background-color: #7c4dff !important;\n}\n.bg-deep-purple-accent-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-purple-accent-3 {\n  background-color: #651fff !important;\n}\n.bg-deep-purple-accent-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-purple-accent-4 {\n  background-color: #6200ea !important;\n}\n.bg-deep-purple-accent-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-indigo {\n  background-color: #3f51b5 !important;\n}\n.bg-indigo {\n  color: #FFFFFF !important;\n}\n\n.bg-indigo-lighten-5 {\n  background-color: #e8eaf6 !important;\n}\n.bg-indigo-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-indigo-lighten-4 {\n  background-color: #c5cae9 !important;\n}\n.bg-indigo-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-indigo-lighten-3 {\n  background-color: #9fa8da !important;\n}\n.bg-indigo-lighten-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-indigo-lighten-2 {\n  background-color: #7986cb !important;\n}\n.bg-indigo-lighten-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-indigo-lighten-1 {\n  background-color: #5c6bc0 !important;\n}\n.bg-indigo-lighten-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-indigo-darken-1 {\n  background-color: #3949ab !important;\n}\n.bg-indigo-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-indigo-darken-2 {\n  background-color: #303f9f !important;\n}\n.bg-indigo-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-indigo-darken-3 {\n  background-color: #283593 !important;\n}\n.bg-indigo-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-indigo-darken-4 {\n  background-color: #1a237e !important;\n}\n.bg-indigo-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-indigo-accent-1 {\n  background-color: #8c9eff !important;\n}\n.bg-indigo-accent-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-indigo-accent-2 {\n  background-color: #536dfe !important;\n}\n.bg-indigo-accent-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-indigo-accent-3 {\n  background-color: #3d5afe !important;\n}\n.bg-indigo-accent-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-indigo-accent-4 {\n  background-color: #304ffe !important;\n}\n.bg-indigo-accent-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue {\n  background-color: #2196F3 !important;\n}\n.bg-blue {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-lighten-5 {\n  background-color: #E3F2FD !important;\n}\n.bg-blue-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-blue-lighten-4 {\n  background-color: #BBDEFB !important;\n}\n.bg-blue-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-blue-lighten-3 {\n  background-color: #90CAF9 !important;\n}\n.bg-blue-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-blue-lighten-2 {\n  background-color: #64B5F6 !important;\n}\n.bg-blue-lighten-2 {\n  color: #000000 !important;\n}\n\n.bg-blue-lighten-1 {\n  background-color: #42A5F5 !important;\n}\n.bg-blue-lighten-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-darken-1 {\n  background-color: #1E88E5 !important;\n}\n.bg-blue-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-darken-2 {\n  background-color: #1976D2 !important;\n}\n.bg-blue-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-darken-3 {\n  background-color: #1565C0 !important;\n}\n.bg-blue-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-darken-4 {\n  background-color: #0D47A1 !important;\n}\n.bg-blue-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-accent-1 {\n  background-color: #82B1FF !important;\n}\n.bg-blue-accent-1 {\n  color: #000000 !important;\n}\n\n.bg-blue-accent-2 {\n  background-color: #448AFF !important;\n}\n.bg-blue-accent-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-accent-3 {\n  background-color: #2979FF !important;\n}\n.bg-blue-accent-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-accent-4 {\n  background-color: #2962FF !important;\n}\n.bg-blue-accent-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-light-blue {\n  background-color: #03a9f4 !important;\n}\n.bg-light-blue {\n  color: #FFFFFF !important;\n}\n\n.bg-light-blue-lighten-5 {\n  background-color: #e1f5fe !important;\n}\n.bg-light-blue-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-light-blue-lighten-4 {\n  background-color: #b3e5fc !important;\n}\n.bg-light-blue-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-light-blue-lighten-3 {\n  background-color: #81d4fa !important;\n}\n.bg-light-blue-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-light-blue-lighten-2 {\n  background-color: #4fc3f7 !important;\n}\n.bg-light-blue-lighten-2 {\n  color: #000000 !important;\n}\n\n.bg-light-blue-lighten-1 {\n  background-color: #29b6f6 !important;\n}\n.bg-light-blue-lighten-1 {\n  color: #000000 !important;\n}\n\n.bg-light-blue-darken-1 {\n  background-color: #039be5 !important;\n}\n.bg-light-blue-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-light-blue-darken-2 {\n  background-color: #0288d1 !important;\n}\n.bg-light-blue-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-light-blue-darken-3 {\n  background-color: #0277bd !important;\n}\n.bg-light-blue-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-light-blue-darken-4 {\n  background-color: #01579b !important;\n}\n.bg-light-blue-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-light-blue-accent-1 {\n  background-color: #80d8ff !important;\n}\n.bg-light-blue-accent-1 {\n  color: #000000 !important;\n}\n\n.bg-light-blue-accent-2 {\n  background-color: #40c4ff !important;\n}\n.bg-light-blue-accent-2 {\n  color: #000000 !important;\n}\n\n.bg-light-blue-accent-3 {\n  background-color: #00b0ff !important;\n}\n.bg-light-blue-accent-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-light-blue-accent-4 {\n  background-color: #0091ea !important;\n}\n.bg-light-blue-accent-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-cyan {\n  background-color: #00bcd4 !important;\n}\n.bg-cyan {\n  color: #000000 !important;\n}\n\n.bg-cyan-lighten-5 {\n  background-color: #e0f7fa !important;\n}\n.bg-cyan-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-cyan-lighten-4 {\n  background-color: #b2ebf2 !important;\n}\n.bg-cyan-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-cyan-lighten-3 {\n  background-color: #80deea !important;\n}\n.bg-cyan-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-cyan-lighten-2 {\n  background-color: #4dd0e1 !important;\n}\n.bg-cyan-lighten-2 {\n  color: #000000 !important;\n}\n\n.bg-cyan-lighten-1 {\n  background-color: #26c6da !important;\n}\n.bg-cyan-lighten-1 {\n  color: #000000 !important;\n}\n\n.bg-cyan-darken-1 {\n  background-color: #00acc1 !important;\n}\n.bg-cyan-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-cyan-darken-2 {\n  background-color: #0097a7 !important;\n}\n.bg-cyan-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-cyan-darken-3 {\n  background-color: #00838f !important;\n}\n.bg-cyan-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-cyan-darken-4 {\n  background-color: #006064 !important;\n}\n.bg-cyan-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-cyan-accent-1 {\n  background-color: #84ffff !important;\n}\n.bg-cyan-accent-1 {\n  color: #000000 !important;\n}\n\n.bg-cyan-accent-2 {\n  background-color: #18ffff !important;\n}\n.bg-cyan-accent-2 {\n  color: #000000 !important;\n}\n\n.bg-cyan-accent-3 {\n  background-color: #00e5ff !important;\n}\n.bg-cyan-accent-3 {\n  color: #000000 !important;\n}\n\n.bg-cyan-accent-4 {\n  background-color: #00b8d4 !important;\n}\n.bg-cyan-accent-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-teal {\n  background-color: #009688 !important;\n}\n.bg-teal {\n  color: #FFFFFF !important;\n}\n\n.bg-teal-lighten-5 {\n  background-color: #e0f2f1 !important;\n}\n.bg-teal-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-teal-lighten-4 {\n  background-color: #b2dfdb !important;\n}\n.bg-teal-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-teal-lighten-3 {\n  background-color: #80cbc4 !important;\n}\n.bg-teal-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-teal-lighten-2 {\n  background-color: #4db6ac !important;\n}\n.bg-teal-lighten-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-teal-lighten-1 {\n  background-color: #26a69a !important;\n}\n.bg-teal-lighten-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-teal-darken-1 {\n  background-color: #00897b !important;\n}\n.bg-teal-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-teal-darken-2 {\n  background-color: #00796b !important;\n}\n.bg-teal-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-teal-darken-3 {\n  background-color: #00695c !important;\n}\n.bg-teal-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-teal-darken-4 {\n  background-color: #004d40 !important;\n}\n.bg-teal-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-teal-accent-1 {\n  background-color: #a7ffeb !important;\n}\n.bg-teal-accent-1 {\n  color: #000000 !important;\n}\n\n.bg-teal-accent-2 {\n  background-color: #64ffda !important;\n}\n.bg-teal-accent-2 {\n  color: #000000 !important;\n}\n\n.bg-teal-accent-3 {\n  background-color: #1de9b6 !important;\n}\n.bg-teal-accent-3 {\n  color: #000000 !important;\n}\n\n.bg-teal-accent-4 {\n  background-color: #00bfa5 !important;\n}\n.bg-teal-accent-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-green {\n  background-color: #4CAF50 !important;\n}\n.bg-green {\n  color: #FFFFFF !important;\n}\n\n.bg-green-lighten-5 {\n  background-color: #E8F5E9 !important;\n}\n.bg-green-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-green-lighten-4 {\n  background-color: #C8E6C9 !important;\n}\n.bg-green-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-green-lighten-3 {\n  background-color: #A5D6A7 !important;\n}\n.bg-green-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-green-lighten-2 {\n  background-color: #81C784 !important;\n}\n.bg-green-lighten-2 {\n  color: #000000 !important;\n}\n\n.bg-green-lighten-1 {\n  background-color: #66BB6A !important;\n}\n.bg-green-lighten-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-green-darken-1 {\n  background-color: #43A047 !important;\n}\n.bg-green-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-green-darken-2 {\n  background-color: #388E3C !important;\n}\n.bg-green-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-green-darken-3 {\n  background-color: #2E7D32 !important;\n}\n.bg-green-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-green-darken-4 {\n  background-color: #1B5E20 !important;\n}\n.bg-green-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-green-accent-1 {\n  background-color: #B9F6CA !important;\n}\n.bg-green-accent-1 {\n  color: #000000 !important;\n}\n\n.bg-green-accent-2 {\n  background-color: #69F0AE !important;\n}\n.bg-green-accent-2 {\n  color: #000000 !important;\n}\n\n.bg-green-accent-3 {\n  background-color: #00E676 !important;\n}\n.bg-green-accent-3 {\n  color: #000000 !important;\n}\n\n.bg-green-accent-4 {\n  background-color: #00C853 !important;\n}\n.bg-green-accent-4 {\n  color: #000000 !important;\n}\n\n.bg-light-green {\n  background-color: #8bc34a !important;\n}\n.bg-light-green {\n  color: #000000 !important;\n}\n\n.bg-light-green-lighten-5 {\n  background-color: #f1f8e9 !important;\n}\n.bg-light-green-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-light-green-lighten-4 {\n  background-color: #dcedc8 !important;\n}\n.bg-light-green-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-light-green-lighten-3 {\n  background-color: #c5e1a5 !important;\n}\n.bg-light-green-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-light-green-lighten-2 {\n  background-color: #aed581 !important;\n}\n.bg-light-green-lighten-2 {\n  color: #000000 !important;\n}\n\n.bg-light-green-lighten-1 {\n  background-color: #9ccc65 !important;\n}\n.bg-light-green-lighten-1 {\n  color: #000000 !important;\n}\n\n.bg-light-green-darken-1 {\n  background-color: #7cb342 !important;\n}\n.bg-light-green-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-light-green-darken-2 {\n  background-color: #689f38 !important;\n}\n.bg-light-green-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-light-green-darken-3 {\n  background-color: #558b2f !important;\n}\n.bg-light-green-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-light-green-darken-4 {\n  background-color: #33691e !important;\n}\n.bg-light-green-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-light-green-accent-1 {\n  background-color: #ccff90 !important;\n}\n.bg-light-green-accent-1 {\n  color: #000000 !important;\n}\n\n.bg-light-green-accent-2 {\n  background-color: #b2ff59 !important;\n}\n.bg-light-green-accent-2 {\n  color: #000000 !important;\n}\n\n.bg-light-green-accent-3 {\n  background-color: #76ff03 !important;\n}\n.bg-light-green-accent-3 {\n  color: #000000 !important;\n}\n\n.bg-light-green-accent-4 {\n  background-color: #64dd17 !important;\n}\n.bg-light-green-accent-4 {\n  color: #000000 !important;\n}\n\n.bg-lime {\n  background-color: #cddc39 !important;\n}\n.bg-lime {\n  color: #000000 !important;\n}\n\n.bg-lime-lighten-5 {\n  background-color: #f9fbe7 !important;\n}\n.bg-lime-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-lime-lighten-4 {\n  background-color: #f0f4c3 !important;\n}\n.bg-lime-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-lime-lighten-3 {\n  background-color: #e6ee9c !important;\n}\n.bg-lime-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-lime-lighten-2 {\n  background-color: #dce775 !important;\n}\n.bg-lime-lighten-2 {\n  color: #000000 !important;\n}\n\n.bg-lime-lighten-1 {\n  background-color: #d4e157 !important;\n}\n.bg-lime-lighten-1 {\n  color: #000000 !important;\n}\n\n.bg-lime-darken-1 {\n  background-color: #c0ca33 !important;\n}\n.bg-lime-darken-1 {\n  color: #000000 !important;\n}\n\n.bg-lime-darken-2 {\n  background-color: #afb42b !important;\n}\n.bg-lime-darken-2 {\n  color: #000000 !important;\n}\n\n.bg-lime-darken-3 {\n  background-color: #9e9d24 !important;\n}\n.bg-lime-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-lime-darken-4 {\n  background-color: #827717 !important;\n}\n.bg-lime-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-lime-accent-1 {\n  background-color: #f4ff81 !important;\n}\n.bg-lime-accent-1 {\n  color: #000000 !important;\n}\n\n.bg-lime-accent-2 {\n  background-color: #eeff41 !important;\n}\n.bg-lime-accent-2 {\n  color: #000000 !important;\n}\n\n.bg-lime-accent-3 {\n  background-color: #c6ff00 !important;\n}\n.bg-lime-accent-3 {\n  color: #000000 !important;\n}\n\n.bg-lime-accent-4 {\n  background-color: #aeea00 !important;\n}\n.bg-lime-accent-4 {\n  color: #000000 !important;\n}\n\n.bg-yellow {\n  background-color: #ffeb3b !important;\n}\n.bg-yellow {\n  color: #000000 !important;\n}\n\n.bg-yellow-lighten-5 {\n  background-color: #fffde7 !important;\n}\n.bg-yellow-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-yellow-lighten-4 {\n  background-color: #fff9c4 !important;\n}\n.bg-yellow-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-yellow-lighten-3 {\n  background-color: #fff59d !important;\n}\n.bg-yellow-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-yellow-lighten-2 {\n  background-color: #fff176 !important;\n}\n.bg-yellow-lighten-2 {\n  color: #000000 !important;\n}\n\n.bg-yellow-lighten-1 {\n  background-color: #ffee58 !important;\n}\n.bg-yellow-lighten-1 {\n  color: #000000 !important;\n}\n\n.bg-yellow-darken-1 {\n  background-color: #fdd835 !important;\n}\n.bg-yellow-darken-1 {\n  color: #000000 !important;\n}\n\n.bg-yellow-darken-2 {\n  background-color: #fbc02d !important;\n}\n.bg-yellow-darken-2 {\n  color: #000000 !important;\n}\n\n.bg-yellow-darken-3 {\n  background-color: #f9a825 !important;\n}\n.bg-yellow-darken-3 {\n  color: #000000 !important;\n}\n\n.bg-yellow-darken-4 {\n  background-color: #f57f17 !important;\n}\n.bg-yellow-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-yellow-accent-1 {\n  background-color: #ffff8d !important;\n}\n.bg-yellow-accent-1 {\n  color: #000000 !important;\n}\n\n.bg-yellow-accent-2 {\n  background-color: #ffff00 !important;\n}\n.bg-yellow-accent-2 {\n  color: #000000 !important;\n}\n\n.bg-yellow-accent-3 {\n  background-color: #ffea00 !important;\n}\n.bg-yellow-accent-3 {\n  color: #000000 !important;\n}\n\n.bg-yellow-accent-4 {\n  background-color: #ffd600 !important;\n}\n.bg-yellow-accent-4 {\n  color: #000000 !important;\n}\n\n.bg-amber {\n  background-color: #ffc107 !important;\n}\n.bg-amber {\n  color: #000000 !important;\n}\n\n.bg-amber-lighten-5 {\n  background-color: #fff8e1 !important;\n}\n.bg-amber-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-amber-lighten-4 {\n  background-color: #ffecb3 !important;\n}\n.bg-amber-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-amber-lighten-3 {\n  background-color: #ffe082 !important;\n}\n.bg-amber-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-amber-lighten-2 {\n  background-color: #ffd54f !important;\n}\n.bg-amber-lighten-2 {\n  color: #000000 !important;\n}\n\n.bg-amber-lighten-1 {\n  background-color: #ffca28 !important;\n}\n.bg-amber-lighten-1 {\n  color: #000000 !important;\n}\n\n.bg-amber-darken-1 {\n  background-color: #ffb300 !important;\n}\n.bg-amber-darken-1 {\n  color: #000000 !important;\n}\n\n.bg-amber-darken-2 {\n  background-color: #ffa000 !important;\n}\n.bg-amber-darken-2 {\n  color: #000000 !important;\n}\n\n.bg-amber-darken-3 {\n  background-color: #ff8f00 !important;\n}\n.bg-amber-darken-3 {\n  color: #000000 !important;\n}\n\n.bg-amber-darken-4 {\n  background-color: #ff6f00 !important;\n}\n.bg-amber-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-amber-accent-1 {\n  background-color: #ffe57f !important;\n}\n.bg-amber-accent-1 {\n  color: #000000 !important;\n}\n\n.bg-amber-accent-2 {\n  background-color: #ffd740 !important;\n}\n.bg-amber-accent-2 {\n  color: #000000 !important;\n}\n\n.bg-amber-accent-3 {\n  background-color: #ffc400 !important;\n}\n.bg-amber-accent-3 {\n  color: #000000 !important;\n}\n\n.bg-amber-accent-4 {\n  background-color: #ffab00 !important;\n}\n.bg-amber-accent-4 {\n  color: #000000 !important;\n}\n\n.bg-orange {\n  background-color: #ff9800 !important;\n}\n.bg-orange {\n  color: #000000 !important;\n}\n\n.bg-orange-lighten-5 {\n  background-color: #fff3e0 !important;\n}\n.bg-orange-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-orange-lighten-4 {\n  background-color: #ffe0b2 !important;\n}\n.bg-orange-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-orange-lighten-3 {\n  background-color: #ffcc80 !important;\n}\n.bg-orange-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-orange-lighten-2 {\n  background-color: #ffb74d !important;\n}\n.bg-orange-lighten-2 {\n  color: #000000 !important;\n}\n\n.bg-orange-lighten-1 {\n  background-color: #ffa726 !important;\n}\n.bg-orange-lighten-1 {\n  color: #000000 !important;\n}\n\n.bg-orange-darken-1 {\n  background-color: #fb8c00 !important;\n}\n.bg-orange-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-orange-darken-2 {\n  background-color: #f57c00 !important;\n}\n.bg-orange-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-orange-darken-3 {\n  background-color: #ef6c00 !important;\n}\n.bg-orange-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-orange-darken-4 {\n  background-color: #e65100 !important;\n}\n.bg-orange-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-orange-accent-1 {\n  background-color: #ffd180 !important;\n}\n.bg-orange-accent-1 {\n  color: #000000 !important;\n}\n\n.bg-orange-accent-2 {\n  background-color: #ffab40 !important;\n}\n.bg-orange-accent-2 {\n  color: #000000 !important;\n}\n\n.bg-orange-accent-3 {\n  background-color: #ff9100 !important;\n}\n.bg-orange-accent-3 {\n  color: #000000 !important;\n}\n\n.bg-orange-accent-4 {\n  background-color: #ff6d00 !important;\n}\n.bg-orange-accent-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-orange {\n  background-color: #ff5722 !important;\n}\n.bg-deep-orange {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-orange-lighten-5 {\n  background-color: #fbe9e7 !important;\n}\n.bg-deep-orange-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-deep-orange-lighten-4 {\n  background-color: #ffccbc !important;\n}\n.bg-deep-orange-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-deep-orange-lighten-3 {\n  background-color: #ffab91 !important;\n}\n.bg-deep-orange-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-deep-orange-lighten-2 {\n  background-color: #ff8a65 !important;\n}\n.bg-deep-orange-lighten-2 {\n  color: #000000 !important;\n}\n\n.bg-deep-orange-lighten-1 {\n  background-color: #ff7043 !important;\n}\n.bg-deep-orange-lighten-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-orange-darken-1 {\n  background-color: #f4511e !important;\n}\n.bg-deep-orange-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-orange-darken-2 {\n  background-color: #e64a19 !important;\n}\n.bg-deep-orange-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-orange-darken-3 {\n  background-color: #d84315 !important;\n}\n.bg-deep-orange-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-orange-darken-4 {\n  background-color: #bf360c !important;\n}\n.bg-deep-orange-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-orange-accent-1 {\n  background-color: #ff9e80 !important;\n}\n.bg-deep-orange-accent-1 {\n  color: #000000 !important;\n}\n\n.bg-deep-orange-accent-2 {\n  background-color: #ff6e40 !important;\n}\n.bg-deep-orange-accent-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-orange-accent-3 {\n  background-color: #ff3d00 !important;\n}\n.bg-deep-orange-accent-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-deep-orange-accent-4 {\n  background-color: #dd2c00 !important;\n}\n.bg-deep-orange-accent-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-brown {\n  background-color: #795548 !important;\n}\n.bg-brown {\n  color: #FFFFFF !important;\n}\n\n.bg-brown-lighten-5 {\n  background-color: #efebe9 !important;\n}\n.bg-brown-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-brown-lighten-4 {\n  background-color: #d7ccc8 !important;\n}\n.bg-brown-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-brown-lighten-3 {\n  background-color: #bcaaa4 !important;\n}\n.bg-brown-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-brown-lighten-2 {\n  background-color: #a1887f !important;\n}\n.bg-brown-lighten-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-brown-lighten-1 {\n  background-color: #8d6e63 !important;\n}\n.bg-brown-lighten-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-brown-darken-1 {\n  background-color: #6d4c41 !important;\n}\n.bg-brown-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-brown-darken-2 {\n  background-color: #5d4037 !important;\n}\n.bg-brown-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-brown-darken-3 {\n  background-color: #4e342e !important;\n}\n.bg-brown-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-brown-darken-4 {\n  background-color: #3e2723 !important;\n}\n.bg-brown-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-grey {\n  background-color: #607d8b !important;\n}\n.bg-blue-grey {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-grey-lighten-5 {\n  background-color: #eceff1 !important;\n}\n.bg-blue-grey-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-blue-grey-lighten-4 {\n  background-color: #cfd8dc !important;\n}\n.bg-blue-grey-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-blue-grey-lighten-3 {\n  background-color: #b0bec5 !important;\n}\n.bg-blue-grey-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-blue-grey-lighten-2 {\n  background-color: #90a4ae !important;\n}\n.bg-blue-grey-lighten-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-grey-lighten-1 {\n  background-color: #78909c !important;\n}\n.bg-blue-grey-lighten-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-grey-darken-1 {\n  background-color: #546e7a !important;\n}\n.bg-blue-grey-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-grey-darken-2 {\n  background-color: #455a64 !important;\n}\n.bg-blue-grey-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-grey-darken-3 {\n  background-color: #37474f !important;\n}\n.bg-blue-grey-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-blue-grey-darken-4 {\n  background-color: #263238 !important;\n}\n.bg-blue-grey-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-grey {\n  background-color: #9e9e9e !important;\n}\n.bg-grey {\n  color: #FFFFFF !important;\n}\n\n.bg-grey-lighten-5 {\n  background-color: #fafafa !important;\n}\n.bg-grey-lighten-5 {\n  color: #000000 !important;\n}\n\n.bg-grey-lighten-4 {\n  background-color: #f5f5f5 !important;\n}\n.bg-grey-lighten-4 {\n  color: #000000 !important;\n}\n\n.bg-grey-lighten-3 {\n  background-color: #eeeeee !important;\n}\n.bg-grey-lighten-3 {\n  color: #000000 !important;\n}\n\n.bg-grey-lighten-2 {\n  background-color: #e0e0e0 !important;\n}\n.bg-grey-lighten-2 {\n  color: #000000 !important;\n}\n\n.bg-grey-lighten-1 {\n  background-color: #bdbdbd !important;\n}\n.bg-grey-lighten-1 {\n  color: #000000 !important;\n}\n\n.bg-grey-darken-1 {\n  background-color: #757575 !important;\n}\n.bg-grey-darken-1 {\n  color: #FFFFFF !important;\n}\n\n.bg-grey-darken-2 {\n  background-color: #616161 !important;\n}\n.bg-grey-darken-2 {\n  color: #FFFFFF !important;\n}\n\n.bg-grey-darken-3 {\n  background-color: #424242 !important;\n}\n.bg-grey-darken-3 {\n  color: #FFFFFF !important;\n}\n\n.bg-grey-darken-4 {\n  background-color: #212121 !important;\n}\n.bg-grey-darken-4 {\n  color: #FFFFFF !important;\n}\n\n.bg-shades-black {\n  background-color: #000000 !important;\n}\n.bg-shades-black {\n  color: #FFFFFF !important;\n}\n\n.bg-shades-white {\n  background-color: #FFFFFF !important;\n}\n.bg-shades-white {\n  color: #000000 !important;\n}\n\n.bg-shades-transparent {\n  background-color: transparent !important;\n}\n.bg-shades-transparent {\n  color: currentColor !important;\n}\n\n.text-black {\n  color: #000000 !important;\n}\n\n.text-white {\n  color: #FFFFFF !important;\n}\n\n.text-transparent {\n  color: transparent !important;\n}\n\n.text-red {\n  color: #F44336 !important;\n}\n\n.text-red-lighten-5 {\n  color: #FFEBEE !important;\n}\n\n.text-red-lighten-4 {\n  color: #FFCDD2 !important;\n}\n\n.text-red-lighten-3 {\n  color: #EF9A9A !important;\n}\n\n.text-red-lighten-2 {\n  color: #E57373 !important;\n}\n\n.text-red-lighten-1 {\n  color: #EF5350 !important;\n}\n\n.text-red-darken-1 {\n  color: #E53935 !important;\n}\n\n.text-red-darken-2 {\n  color: #D32F2F !important;\n}\n\n.text-red-darken-3 {\n  color: #C62828 !important;\n}\n\n.text-red-darken-4 {\n  color: #B71C1C !important;\n}\n\n.text-red-accent-1 {\n  color: #FF8A80 !important;\n}\n\n.text-red-accent-2 {\n  color: #FF5252 !important;\n}\n\n.text-red-accent-3 {\n  color: #FF1744 !important;\n}\n\n.text-red-accent-4 {\n  color: #D50000 !important;\n}\n\n.text-pink {\n  color: #e91e63 !important;\n}\n\n.text-pink-lighten-5 {\n  color: #fce4ec !important;\n}\n\n.text-pink-lighten-4 {\n  color: #f8bbd0 !important;\n}\n\n.text-pink-lighten-3 {\n  color: #f48fb1 !important;\n}\n\n.text-pink-lighten-2 {\n  color: #f06292 !important;\n}\n\n.text-pink-lighten-1 {\n  color: #ec407a !important;\n}\n\n.text-pink-darken-1 {\n  color: #d81b60 !important;\n}\n\n.text-pink-darken-2 {\n  color: #c2185b !important;\n}\n\n.text-pink-darken-3 {\n  color: #ad1457 !important;\n}\n\n.text-pink-darken-4 {\n  color: #880e4f !important;\n}\n\n.text-pink-accent-1 {\n  color: #ff80ab !important;\n}\n\n.text-pink-accent-2 {\n  color: #ff4081 !important;\n}\n\n.text-pink-accent-3 {\n  color: #f50057 !important;\n}\n\n.text-pink-accent-4 {\n  color: #c51162 !important;\n}\n\n.text-purple {\n  color: #9c27b0 !important;\n}\n\n.text-purple-lighten-5 {\n  color: #f3e5f5 !important;\n}\n\n.text-purple-lighten-4 {\n  color: #e1bee7 !important;\n}\n\n.text-purple-lighten-3 {\n  color: #ce93d8 !important;\n}\n\n.text-purple-lighten-2 {\n  color: #ba68c8 !important;\n}\n\n.text-purple-lighten-1 {\n  color: #ab47bc !important;\n}\n\n.text-purple-darken-1 {\n  color: #8e24aa !important;\n}\n\n.text-purple-darken-2 {\n  color: #7b1fa2 !important;\n}\n\n.text-purple-darken-3 {\n  color: #6a1b9a !important;\n}\n\n.text-purple-darken-4 {\n  color: #4a148c !important;\n}\n\n.text-purple-accent-1 {\n  color: #ea80fc !important;\n}\n\n.text-purple-accent-2 {\n  color: #e040fb !important;\n}\n\n.text-purple-accent-3 {\n  color: #d500f9 !important;\n}\n\n.text-purple-accent-4 {\n  color: #aa00ff !important;\n}\n\n.text-deep-purple {\n  color: #673ab7 !important;\n}\n\n.text-deep-purple-lighten-5 {\n  color: #ede7f6 !important;\n}\n\n.text-deep-purple-lighten-4 {\n  color: #d1c4e9 !important;\n}\n\n.text-deep-purple-lighten-3 {\n  color: #b39ddb !important;\n}\n\n.text-deep-purple-lighten-2 {\n  color: #9575cd !important;\n}\n\n.text-deep-purple-lighten-1 {\n  color: #7e57c2 !important;\n}\n\n.text-deep-purple-darken-1 {\n  color: #5e35b1 !important;\n}\n\n.text-deep-purple-darken-2 {\n  color: #512da8 !important;\n}\n\n.text-deep-purple-darken-3 {\n  color: #4527a0 !important;\n}\n\n.text-deep-purple-darken-4 {\n  color: #311b92 !important;\n}\n\n.text-deep-purple-accent-1 {\n  color: #b388ff !important;\n}\n\n.text-deep-purple-accent-2 {\n  color: #7c4dff !important;\n}\n\n.text-deep-purple-accent-3 {\n  color: #651fff !important;\n}\n\n.text-deep-purple-accent-4 {\n  color: #6200ea !important;\n}\n\n.text-indigo {\n  color: #3f51b5 !important;\n}\n\n.text-indigo-lighten-5 {\n  color: #e8eaf6 !important;\n}\n\n.text-indigo-lighten-4 {\n  color: #c5cae9 !important;\n}\n\n.text-indigo-lighten-3 {\n  color: #9fa8da !important;\n}\n\n.text-indigo-lighten-2 {\n  color: #7986cb !important;\n}\n\n.text-indigo-lighten-1 {\n  color: #5c6bc0 !important;\n}\n\n.text-indigo-darken-1 {\n  color: #3949ab !important;\n}\n\n.text-indigo-darken-2 {\n  color: #303f9f !important;\n}\n\n.text-indigo-darken-3 {\n  color: #283593 !important;\n}\n\n.text-indigo-darken-4 {\n  color: #1a237e !important;\n}\n\n.text-indigo-accent-1 {\n  color: #8c9eff !important;\n}\n\n.text-indigo-accent-2 {\n  color: #536dfe !important;\n}\n\n.text-indigo-accent-3 {\n  color: #3d5afe !important;\n}\n\n.text-indigo-accent-4 {\n  color: #304ffe !important;\n}\n\n.text-blue {\n  color: #2196F3 !important;\n}\n\n.text-blue-lighten-5 {\n  color: #E3F2FD !important;\n}\n\n.text-blue-lighten-4 {\n  color: #BBDEFB !important;\n}\n\n.text-blue-lighten-3 {\n  color: #90CAF9 !important;\n}\n\n.text-blue-lighten-2 {\n  color: #64B5F6 !important;\n}\n\n.text-blue-lighten-1 {\n  color: #42A5F5 !important;\n}\n\n.text-blue-darken-1 {\n  color: #1E88E5 !important;\n}\n\n.text-blue-darken-2 {\n  color: #1976D2 !important;\n}\n\n.text-blue-darken-3 {\n  color: #1565C0 !important;\n}\n\n.text-blue-darken-4 {\n  color: #0D47A1 !important;\n}\n\n.text-blue-accent-1 {\n  color: #82B1FF !important;\n}\n\n.text-blue-accent-2 {\n  color: #448AFF !important;\n}\n\n.text-blue-accent-3 {\n  color: #2979FF !important;\n}\n\n.text-blue-accent-4 {\n  color: #2962FF !important;\n}\n\n.text-light-blue {\n  color: #03a9f4 !important;\n}\n\n.text-light-blue-lighten-5 {\n  color: #e1f5fe !important;\n}\n\n.text-light-blue-lighten-4 {\n  color: #b3e5fc !important;\n}\n\n.text-light-blue-lighten-3 {\n  color: #81d4fa !important;\n}\n\n.text-light-blue-lighten-2 {\n  color: #4fc3f7 !important;\n}\n\n.text-light-blue-lighten-1 {\n  color: #29b6f6 !important;\n}\n\n.text-light-blue-darken-1 {\n  color: #039be5 !important;\n}\n\n.text-light-blue-darken-2 {\n  color: #0288d1 !important;\n}\n\n.text-light-blue-darken-3 {\n  color: #0277bd !important;\n}\n\n.text-light-blue-darken-4 {\n  color: #01579b !important;\n}\n\n.text-light-blue-accent-1 {\n  color: #80d8ff !important;\n}\n\n.text-light-blue-accent-2 {\n  color: #40c4ff !important;\n}\n\n.text-light-blue-accent-3 {\n  color: #00b0ff !important;\n}\n\n.text-light-blue-accent-4 {\n  color: #0091ea !important;\n}\n\n.text-cyan {\n  color: #00bcd4 !important;\n}\n\n.text-cyan-lighten-5 {\n  color: #e0f7fa !important;\n}\n\n.text-cyan-lighten-4 {\n  color: #b2ebf2 !important;\n}\n\n.text-cyan-lighten-3 {\n  color: #80deea !important;\n}\n\n.text-cyan-lighten-2 {\n  color: #4dd0e1 !important;\n}\n\n.text-cyan-lighten-1 {\n  color: #26c6da !important;\n}\n\n.text-cyan-darken-1 {\n  color: #00acc1 !important;\n}\n\n.text-cyan-darken-2 {\n  color: #0097a7 !important;\n}\n\n.text-cyan-darken-3 {\n  color: #00838f !important;\n}\n\n.text-cyan-darken-4 {\n  color: #006064 !important;\n}\n\n.text-cyan-accent-1 {\n  color: #84ffff !important;\n}\n\n.text-cyan-accent-2 {\n  color: #18ffff !important;\n}\n\n.text-cyan-accent-3 {\n  color: #00e5ff !important;\n}\n\n.text-cyan-accent-4 {\n  color: #00b8d4 !important;\n}\n\n.text-teal {\n  color: #009688 !important;\n}\n\n.text-teal-lighten-5 {\n  color: #e0f2f1 !important;\n}\n\n.text-teal-lighten-4 {\n  color: #b2dfdb !important;\n}\n\n.text-teal-lighten-3 {\n  color: #80cbc4 !important;\n}\n\n.text-teal-lighten-2 {\n  color: #4db6ac !important;\n}\n\n.text-teal-lighten-1 {\n  color: #26a69a !important;\n}\n\n.text-teal-darken-1 {\n  color: #00897b !important;\n}\n\n.text-teal-darken-2 {\n  color: #00796b !important;\n}\n\n.text-teal-darken-3 {\n  color: #00695c !important;\n}\n\n.text-teal-darken-4 {\n  color: #004d40 !important;\n}\n\n.text-teal-accent-1 {\n  color: #a7ffeb !important;\n}\n\n.text-teal-accent-2 {\n  color: #64ffda !important;\n}\n\n.text-teal-accent-3 {\n  color: #1de9b6 !important;\n}\n\n.text-teal-accent-4 {\n  color: #00bfa5 !important;\n}\n\n.text-green {\n  color: #4CAF50 !important;\n}\n\n.text-green-lighten-5 {\n  color: #E8F5E9 !important;\n}\n\n.text-green-lighten-4 {\n  color: #C8E6C9 !important;\n}\n\n.text-green-lighten-3 {\n  color: #A5D6A7 !important;\n}\n\n.text-green-lighten-2 {\n  color: #81C784 !important;\n}\n\n.text-green-lighten-1 {\n  color: #66BB6A !important;\n}\n\n.text-green-darken-1 {\n  color: #43A047 !important;\n}\n\n.text-green-darken-2 {\n  color: #388E3C !important;\n}\n\n.text-green-darken-3 {\n  color: #2E7D32 !important;\n}\n\n.text-green-darken-4 {\n  color: #1B5E20 !important;\n}\n\n.text-green-accent-1 {\n  color: #B9F6CA !important;\n}\n\n.text-green-accent-2 {\n  color: #69F0AE !important;\n}\n\n.text-green-accent-3 {\n  color: #00E676 !important;\n}\n\n.text-green-accent-4 {\n  color: #00C853 !important;\n}\n\n.text-light-green {\n  color: #8bc34a !important;\n}\n\n.text-light-green-lighten-5 {\n  color: #f1f8e9 !important;\n}\n\n.text-light-green-lighten-4 {\n  color: #dcedc8 !important;\n}\n\n.text-light-green-lighten-3 {\n  color: #c5e1a5 !important;\n}\n\n.text-light-green-lighten-2 {\n  color: #aed581 !important;\n}\n\n.text-light-green-lighten-1 {\n  color: #9ccc65 !important;\n}\n\n.text-light-green-darken-1 {\n  color: #7cb342 !important;\n}\n\n.text-light-green-darken-2 {\n  color: #689f38 !important;\n}\n\n.text-light-green-darken-3 {\n  color: #558b2f !important;\n}\n\n.text-light-green-darken-4 {\n  color: #33691e !important;\n}\n\n.text-light-green-accent-1 {\n  color: #ccff90 !important;\n}\n\n.text-light-green-accent-2 {\n  color: #b2ff59 !important;\n}\n\n.text-light-green-accent-3 {\n  color: #76ff03 !important;\n}\n\n.text-light-green-accent-4 {\n  color: #64dd17 !important;\n}\n\n.text-lime {\n  color: #cddc39 !important;\n}\n\n.text-lime-lighten-5 {\n  color: #f9fbe7 !important;\n}\n\n.text-lime-lighten-4 {\n  color: #f0f4c3 !important;\n}\n\n.text-lime-lighten-3 {\n  color: #e6ee9c !important;\n}\n\n.text-lime-lighten-2 {\n  color: #dce775 !important;\n}\n\n.text-lime-lighten-1 {\n  color: #d4e157 !important;\n}\n\n.text-lime-darken-1 {\n  color: #c0ca33 !important;\n}\n\n.text-lime-darken-2 {\n  color: #afb42b !important;\n}\n\n.text-lime-darken-3 {\n  color: #9e9d24 !important;\n}\n\n.text-lime-darken-4 {\n  color: #827717 !important;\n}\n\n.text-lime-accent-1 {\n  color: #f4ff81 !important;\n}\n\n.text-lime-accent-2 {\n  color: #eeff41 !important;\n}\n\n.text-lime-accent-3 {\n  color: #c6ff00 !important;\n}\n\n.text-lime-accent-4 {\n  color: #aeea00 !important;\n}\n\n.text-yellow {\n  color: #ffeb3b !important;\n}\n\n.text-yellow-lighten-5 {\n  color: #fffde7 !important;\n}\n\n.text-yellow-lighten-4 {\n  color: #fff9c4 !important;\n}\n\n.text-yellow-lighten-3 {\n  color: #fff59d !important;\n}\n\n.text-yellow-lighten-2 {\n  color: #fff176 !important;\n}\n\n.text-yellow-lighten-1 {\n  color: #ffee58 !important;\n}\n\n.text-yellow-darken-1 {\n  color: #fdd835 !important;\n}\n\n.text-yellow-darken-2 {\n  color: #fbc02d !important;\n}\n\n.text-yellow-darken-3 {\n  color: #f9a825 !important;\n}\n\n.text-yellow-darken-4 {\n  color: #f57f17 !important;\n}\n\n.text-yellow-accent-1 {\n  color: #ffff8d !important;\n}\n\n.text-yellow-accent-2 {\n  color: #ffff00 !important;\n}\n\n.text-yellow-accent-3 {\n  color: #ffea00 !important;\n}\n\n.text-yellow-accent-4 {\n  color: #ffd600 !important;\n}\n\n.text-amber {\n  color: #ffc107 !important;\n}\n\n.text-amber-lighten-5 {\n  color: #fff8e1 !important;\n}\n\n.text-amber-lighten-4 {\n  color: #ffecb3 !important;\n}\n\n.text-amber-lighten-3 {\n  color: #ffe082 !important;\n}\n\n.text-amber-lighten-2 {\n  color: #ffd54f !important;\n}\n\n.text-amber-lighten-1 {\n  color: #ffca28 !important;\n}\n\n.text-amber-darken-1 {\n  color: #ffb300 !important;\n}\n\n.text-amber-darken-2 {\n  color: #ffa000 !important;\n}\n\n.text-amber-darken-3 {\n  color: #ff8f00 !important;\n}\n\n.text-amber-darken-4 {\n  color: #ff6f00 !important;\n}\n\n.text-amber-accent-1 {\n  color: #ffe57f !important;\n}\n\n.text-amber-accent-2 {\n  color: #ffd740 !important;\n}\n\n.text-amber-accent-3 {\n  color: #ffc400 !important;\n}\n\n.text-amber-accent-4 {\n  color: #ffab00 !important;\n}\n\n.text-orange {\n  color: #ff9800 !important;\n}\n\n.text-orange-lighten-5 {\n  color: #fff3e0 !important;\n}\n\n.text-orange-lighten-4 {\n  color: #ffe0b2 !important;\n}\n\n.text-orange-lighten-3 {\n  color: #ffcc80 !important;\n}\n\n.text-orange-lighten-2 {\n  color: #ffb74d !important;\n}\n\n.text-orange-lighten-1 {\n  color: #ffa726 !important;\n}\n\n.text-orange-darken-1 {\n  color: #fb8c00 !important;\n}\n\n.text-orange-darken-2 {\n  color: #f57c00 !important;\n}\n\n.text-orange-darken-3 {\n  color: #ef6c00 !important;\n}\n\n.text-orange-darken-4 {\n  color: #e65100 !important;\n}\n\n.text-orange-accent-1 {\n  color: #ffd180 !important;\n}\n\n.text-orange-accent-2 {\n  color: #ffab40 !important;\n}\n\n.text-orange-accent-3 {\n  color: #ff9100 !important;\n}\n\n.text-orange-accent-4 {\n  color: #ff6d00 !important;\n}\n\n.text-deep-orange {\n  color: #ff5722 !important;\n}\n\n.text-deep-orange-lighten-5 {\n  color: #fbe9e7 !important;\n}\n\n.text-deep-orange-lighten-4 {\n  color: #ffccbc !important;\n}\n\n.text-deep-orange-lighten-3 {\n  color: #ffab91 !important;\n}\n\n.text-deep-orange-lighten-2 {\n  color: #ff8a65 !important;\n}\n\n.text-deep-orange-lighten-1 {\n  color: #ff7043 !important;\n}\n\n.text-deep-orange-darken-1 {\n  color: #f4511e !important;\n}\n\n.text-deep-orange-darken-2 {\n  color: #e64a19 !important;\n}\n\n.text-deep-orange-darken-3 {\n  color: #d84315 !important;\n}\n\n.text-deep-orange-darken-4 {\n  color: #bf360c !important;\n}\n\n.text-deep-orange-accent-1 {\n  color: #ff9e80 !important;\n}\n\n.text-deep-orange-accent-2 {\n  color: #ff6e40 !important;\n}\n\n.text-deep-orange-accent-3 {\n  color: #ff3d00 !important;\n}\n\n.text-deep-orange-accent-4 {\n  color: #dd2c00 !important;\n}\n\n.text-brown {\n  color: #795548 !important;\n}\n\n.text-brown-lighten-5 {\n  color: #efebe9 !important;\n}\n\n.text-brown-lighten-4 {\n  color: #d7ccc8 !important;\n}\n\n.text-brown-lighten-3 {\n  color: #bcaaa4 !important;\n}\n\n.text-brown-lighten-2 {\n  color: #a1887f !important;\n}\n\n.text-brown-lighten-1 {\n  color: #8d6e63 !important;\n}\n\n.text-brown-darken-1 {\n  color: #6d4c41 !important;\n}\n\n.text-brown-darken-2 {\n  color: #5d4037 !important;\n}\n\n.text-brown-darken-3 {\n  color: #4e342e !important;\n}\n\n.text-brown-darken-4 {\n  color: #3e2723 !important;\n}\n\n.text-blue-grey {\n  color: #607d8b !important;\n}\n\n.text-blue-grey-lighten-5 {\n  color: #eceff1 !important;\n}\n\n.text-blue-grey-lighten-4 {\n  color: #cfd8dc !important;\n}\n\n.text-blue-grey-lighten-3 {\n  color: #b0bec5 !important;\n}\n\n.text-blue-grey-lighten-2 {\n  color: #90a4ae !important;\n}\n\n.text-blue-grey-lighten-1 {\n  color: #78909c !important;\n}\n\n.text-blue-grey-darken-1 {\n  color: #546e7a !important;\n}\n\n.text-blue-grey-darken-2 {\n  color: #455a64 !important;\n}\n\n.text-blue-grey-darken-3 {\n  color: #37474f !important;\n}\n\n.text-blue-grey-darken-4 {\n  color: #263238 !important;\n}\n\n.text-grey {\n  color: #9e9e9e !important;\n}\n\n.text-grey-lighten-5 {\n  color: #fafafa !important;\n}\n\n.text-grey-lighten-4 {\n  color: #f5f5f5 !important;\n}\n\n.text-grey-lighten-3 {\n  color: #eeeeee !important;\n}\n\n.text-grey-lighten-2 {\n  color: #e0e0e0 !important;\n}\n\n.text-grey-lighten-1 {\n  color: #bdbdbd !important;\n}\n\n.text-grey-darken-1 {\n  color: #757575 !important;\n}\n\n.text-grey-darken-2 {\n  color: #616161 !important;\n}\n\n.text-grey-darken-3 {\n  color: #424242 !important;\n}\n\n.text-grey-darken-4 {\n  color: #212121 !important;\n}\n\n.text-shades-black {\n  color: #000000 !important;\n}\n\n.text-shades-white {\n  color: #FFFFFF !important;\n}\n\n.text-shades-transparent {\n  color: transparent !important;\n}\n\n/*!\n * ress.css • v2.0.4\n * MIT License\n * github.com/filipelinhares/ress\n */\n/* # =================================================================\n   # Global selectors\n   # ================================================================= */\nhtml {\n  box-sizing: border-box;\n  overflow-y: scroll; /* All browsers without overlaying scrollbars */\n  -webkit-text-size-adjust: 100%; /* Prevent adjustments of font size after orientation changes in iOS */\n  word-break: normal;\n  -moz-tab-size: 4;\n  tab-size: 4;\n}\n\n*,\n::before,\n::after {\n  background-repeat: no-repeat; /* Set `background-repeat: no-repeat` to all elements and pseudo elements */\n  box-sizing: inherit;\n}\n\n::before,\n::after {\n  text-decoration: inherit; /* Inherit text-decoration and vertical align to ::before and ::after pseudo elements */\n  vertical-align: inherit;\n}\n\n* {\n  padding: 0; /* Reset `padding` and `margin` of all elements */\n  margin: 0;\n}\n\n/* # =================================================================\n   # General elements\n   # ================================================================= */\nhr {\n  overflow: visible; /* Show the overflow in Edge and IE */\n  height: 0; /* Add the correct box sizing in Firefox */\n}\n\ndetails,\nmain {\n  display: block; /* Render the `main` element consistently in IE. */\n}\n\nsummary {\n  display: list-item; /* Add the correct display in all browsers */\n}\n\nsmall {\n  font-size: 80%; /* Set font-size to 80% in `small` elements */\n}\n\n[hidden] {\n  display: none; /* Add the correct display in IE */\n}\n\nabbr[title] {\n  border-bottom: none; /* Remove the bottom border in Chrome 57 */\n  /* Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari */\n  text-decoration: underline;\n  text-decoration: underline dotted;\n}\n\na {\n  background-color: transparent; /* Remove the gray background on active links in IE 10 */\n}\n\na:active,\na:hover {\n  outline-width: 0; /* Remove the outline when hovering in all browsers */\n}\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace; /* Specify the font family of code elements */\n}\n\npre {\n  font-size: 1em; /* Correct the odd `em` font sizing in all browsers */\n}\n\nb,\nstrong {\n  font-weight: bolder; /* Add the correct font weight in Chrome, Edge, and Safari */\n}\n\n/* https://gist.github.com/unruthless/413930 */\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* # =================================================================\n   # Forms\n   # ================================================================= */\ninput {\n  border-radius: 0;\n}\n\n/* Replace pointer cursor in disabled elements */\n[disabled] {\n  cursor: default;\n}\n\n[type=number]::-webkit-inner-spin-button,\n[type=number]::-webkit-outer-spin-button {\n  height: auto; /* Correct the cursor style of increment and decrement buttons in Chrome */\n}\n\n[type=search] {\n  -webkit-appearance: textfield; /* Correct the odd appearance in Chrome and Safari */\n  outline-offset: -2px; /* Correct the outline style in Safari */\n}\n\n[type=search]::-webkit-search-cancel-button,\n[type=search]::-webkit-search-decoration {\n  -webkit-appearance: none; /* Remove the inner padding in Chrome and Safari on macOS */\n}\n\ntextarea {\n  overflow: auto; /* Internet Explorer 11+ */\n  resize: vertical; /* Specify textarea resizability */\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit; /* Specify font inheritance of form elements */\n}\n\noptgroup {\n  font-weight: bold; /* Restore the font weight unset by the previous rule */\n}\n\nbutton {\n  overflow: visible; /* Address `overflow` set to `hidden` in IE 8/9/10/11 */\n}\n\nbutton,\nselect {\n  text-transform: none; /* Firefox 40+, Internet Explorer 11- */\n}\n\n/* Apply cursor pointer to button elements */\nbutton,\n[type=button],\n[type=reset],\n[type=submit],\n[role=button] {\n  cursor: pointer;\n  color: inherit;\n}\n\n/* Remove inner padding and border in Firefox 4+ */\nbutton::-moz-focus-inner,\n[type=button]::-moz-focus-inner,\n[type=reset]::-moz-focus-inner,\n[type=submit]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/* Replace focus style removed in the border reset above */\nbutton:-moz-focusring,\n[type=button]::-moz-focus-inner,\n[type=reset]::-moz-focus-inner,\n[type=submit]::-moz-focus-inner {\n  outline: 1px dotted ButtonText;\n}\n\nbutton,\nhtml [type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button; /* Correct the inability to style clickable types in iOS */\n}\n\n/* Remove the default button styling in all browsers */\nbutton,\ninput,\nselect,\ntextarea {\n  background-color: transparent;\n  border-style: none;\n}\n\n/* Style select like a standard input */\nselect {\n  -moz-appearance: none; /* Firefox 36+ */\n  -webkit-appearance: none; /* Chrome 41+ */\n}\n\nselect::-ms-expand {\n  display: none; /* Internet Explorer 11+ */\n}\n\nselect::-ms-value {\n  color: currentColor; /* Internet Explorer 11+ */\n}\n\nlegend {\n  border: 0; /* Correct `color` not being inherited in IE 8/9/10/11 */\n  color: inherit; /* Correct the color inheritance from `fieldset` elements in IE */\n  display: table; /* Correct the text wrapping in Edge and IE */\n  max-width: 100%; /* Correct the text wrapping in Edge and IE */\n  white-space: normal; /* Correct the text wrapping in Edge and IE */\n  max-width: 100%; /* Correct the text wrapping in Edge 18- and IE */\n}\n\n::-webkit-file-upload-button {\n  /* Correct the inability to style clickable types in iOS and Safari */\n  -webkit-appearance: button;\n  color: inherit;\n  font: inherit; /* Change font properties to `inherit` in Chrome and Safari */\n}\n\n::-ms-clear,\n::-ms-reveal {\n  display: none;\n}\n\n/* # =================================================================\n   # Specify media element style\n   # ================================================================= */\nimg {\n  border-style: none; /* Remove border when inside `a` element in IE 8/9/10 */\n}\n\n/* Add the correct vertical alignment in Chrome, Firefox, and Opera */\nprogress {\n  vertical-align: baseline;\n}\n\n/* # =================================================================\n   # Accessibility\n   # ================================================================= */\n/* Hide content from screens but not screenreaders */\n@media screen {\n  [hidden~=screen] {\n    display: inherit;\n  }\n  [hidden~=screen]:not(:active):not(:focus):not(:target) {\n    position: absolute !important;\n    clip: rect(0 0 0 0) !important;\n  }\n}\n/* Specify the progress cursor of updating elements */\n[aria-busy=true] {\n  cursor: progress;\n}\n\n/* Specify the pointer cursor of trigger elements */\n[aria-controls] {\n  cursor: pointer;\n}\n\n/* Specify the unstyled cursor of disabled, not-editable, or otherwise inoperable elements */\n[aria-disabled=true] {\n  cursor: default;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .dialog-transition-enter-active,\n  .dialog-bottom-transition-enter-active,\n  .dialog-top-transition-enter-active {\n    transition-duration: 225ms !important;\n    transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;\n  }\n  .dialog-transition-leave-active,\n  .dialog-bottom-transition-leave-active,\n  .dialog-top-transition-leave-active {\n    transition-duration: 125ms !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 1, 1) !important;\n  }\n  .dialog-transition-enter-active, .dialog-transition-leave-active,\n  .dialog-bottom-transition-enter-active,\n  .dialog-bottom-transition-leave-active,\n  .dialog-top-transition-enter-active,\n  .dialog-top-transition-leave-active {\n    transition-property: transform, opacity !important;\n    pointer-events: none;\n  }\n  .dialog-transition-enter-from, .dialog-transition-leave-to {\n    transform: scale(0.9);\n    opacity: 0;\n  }\n  .dialog-transition-enter-to, .dialog-transition-leave-from {\n    opacity: 1;\n  }\n  .dialog-bottom-transition-enter-from, .dialog-bottom-transition-leave-to {\n    transform: translateY(calc(50vh + 50%));\n  }\n  .dialog-top-transition-enter-from, .dialog-top-transition-leave-to {\n    transform: translateY(calc(-50vh - 50%));\n  }\n  .picker-transition-enter-active,\n  .picker-reverse-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .picker-transition-leave-active,\n  .picker-reverse-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .picker-transition-move,\n  .picker-reverse-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .picker-transition-enter-from, .picker-transition-leave-to,\n  .picker-reverse-transition-enter-from,\n  .picker-reverse-transition-leave-to {\n    opacity: 0;\n  }\n  .picker-transition-leave-from, .picker-transition-leave-active, .picker-transition-leave-to,\n  .picker-reverse-transition-leave-from,\n  .picker-reverse-transition-leave-active,\n  .picker-reverse-transition-leave-to {\n    position: absolute !important;\n  }\n  .picker-transition-enter-active, .picker-transition-leave-active,\n  .picker-reverse-transition-enter-active,\n  .picker-reverse-transition-leave-active {\n    transition-property: transform, opacity !important;\n  }\n  .picker-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .picker-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .picker-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .picker-transition-enter-from {\n    transform: translate(100%, 0);\n  }\n  .picker-transition-leave-to {\n    transform: translate(-100%, 0);\n  }\n  .picker-reverse-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .picker-reverse-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .picker-reverse-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .picker-reverse-transition-enter-from {\n    transform: translate(-100%, 0);\n  }\n  .picker-reverse-transition-leave-to {\n    transform: translate(100%, 0);\n  }\n  .expand-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .expand-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .expand-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .expand-transition-enter-active, .expand-transition-leave-active {\n    transition-property: height !important;\n  }\n  .expand-x-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .expand-x-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .expand-x-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .expand-x-transition-enter-active, .expand-x-transition-leave-active {\n    transition-property: width !important;\n  }\n  .expand-both-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .expand-both-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .expand-both-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .expand-both-transition-enter-active, .expand-both-transition-leave-active {\n    transition-property: height, width !important;\n  }\n  .scale-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scale-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scale-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scale-transition-leave-to {\n    opacity: 0;\n  }\n  .scale-transition-leave-active {\n    transition-duration: 100ms !important;\n  }\n  .scale-transition-enter-from {\n    opacity: 0;\n    transform: scale(0);\n  }\n  .scale-transition-enter-active, .scale-transition-leave-active {\n    transition-property: transform, opacity !important;\n  }\n  .scale-rotate-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scale-rotate-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scale-rotate-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scale-rotate-transition-leave-to {\n    opacity: 0;\n  }\n  .scale-rotate-transition-leave-active {\n    transition-duration: 100ms !important;\n  }\n  .scale-rotate-transition-enter-from {\n    opacity: 0;\n    transform: scale(0) rotate(-45deg);\n  }\n  .scale-rotate-transition-enter-active, .scale-rotate-transition-leave-active {\n    transition-property: transform, opacity !important;\n  }\n  .scale-rotate-reverse-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scale-rotate-reverse-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scale-rotate-reverse-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scale-rotate-reverse-transition-leave-to {\n    opacity: 0;\n  }\n  .scale-rotate-reverse-transition-leave-active {\n    transition-duration: 100ms !important;\n  }\n  .scale-rotate-reverse-transition-enter-from {\n    opacity: 0;\n    transform: scale(0) rotate(45deg);\n  }\n  .scale-rotate-reverse-transition-enter-active, .scale-rotate-reverse-transition-leave-active {\n    transition-property: transform, opacity !important;\n  }\n  .message-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .message-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .message-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .message-transition-enter-from, .message-transition-leave-to {\n    opacity: 0;\n    transform: translateY(-15px);\n  }\n  .message-transition-leave-from, .message-transition-leave-active {\n    position: absolute;\n  }\n  .message-transition-enter-active, .message-transition-leave-active {\n    transition-property: transform, opacity !important;\n  }\n  .slide-y-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .slide-y-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .slide-y-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .slide-y-transition-enter-from, .slide-y-transition-leave-to {\n    opacity: 0;\n    transform: translateY(-15px);\n  }\n  .slide-y-transition-enter-active, .slide-y-transition-leave-active {\n    transition-property: transform, opacity !important;\n  }\n  .slide-y-reverse-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .slide-y-reverse-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .slide-y-reverse-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .slide-y-reverse-transition-enter-from, .slide-y-reverse-transition-leave-to {\n    opacity: 0;\n    transform: translateY(15px);\n  }\n  .slide-y-reverse-transition-enter-active, .slide-y-reverse-transition-leave-active {\n    transition-property: transform, opacity !important;\n  }\n  .scroll-y-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scroll-y-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scroll-y-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scroll-y-transition-enter-from, .scroll-y-transition-leave-to {\n    opacity: 0;\n  }\n  .scroll-y-transition-enter-from {\n    transform: translateY(-15px);\n  }\n  .scroll-y-transition-leave-to {\n    transform: translateY(15px);\n  }\n  .scroll-y-transition-enter-active, .scroll-y-transition-leave-active {\n    transition-property: transform, opacity !important;\n  }\n  .scroll-y-reverse-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scroll-y-reverse-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scroll-y-reverse-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scroll-y-reverse-transition-enter-from, .scroll-y-reverse-transition-leave-to {\n    opacity: 0;\n  }\n  .scroll-y-reverse-transition-enter-from {\n    transform: translateY(15px);\n  }\n  .scroll-y-reverse-transition-leave-to {\n    transform: translateY(-15px);\n  }\n  .scroll-y-reverse-transition-enter-active, .scroll-y-reverse-transition-leave-active {\n    transition-property: transform, opacity !important;\n  }\n  .scroll-x-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scroll-x-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scroll-x-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scroll-x-transition-enter-from, .scroll-x-transition-leave-to {\n    opacity: 0;\n  }\n  .scroll-x-transition-enter-from {\n    transform: translateX(-15px);\n  }\n  .scroll-x-transition-leave-to {\n    transform: translateX(15px);\n  }\n  .scroll-x-transition-enter-active, .scroll-x-transition-leave-active {\n    transition-property: transform, opacity !important;\n  }\n  .scroll-x-reverse-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scroll-x-reverse-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scroll-x-reverse-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .scroll-x-reverse-transition-enter-from, .scroll-x-reverse-transition-leave-to {\n    opacity: 0;\n  }\n  .scroll-x-reverse-transition-enter-from {\n    transform: translateX(15px);\n  }\n  .scroll-x-reverse-transition-leave-to {\n    transform: translateX(-15px);\n  }\n  .scroll-x-reverse-transition-enter-active, .scroll-x-reverse-transition-leave-active {\n    transition-property: transform, opacity !important;\n  }\n  .slide-x-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .slide-x-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .slide-x-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .slide-x-transition-enter-from, .slide-x-transition-leave-to {\n    opacity: 0;\n    transform: translateX(-15px);\n  }\n  .slide-x-transition-enter-active, .slide-x-transition-leave-active {\n    transition-property: transform, opacity !important;\n  }\n  .slide-x-reverse-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .slide-x-reverse-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .slide-x-reverse-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .slide-x-reverse-transition-enter-from, .slide-x-reverse-transition-leave-to {\n    opacity: 0;\n    transform: translateX(15px);\n  }\n  .slide-x-reverse-transition-enter-active, .slide-x-reverse-transition-leave-active {\n    transition-property: transform, opacity !important;\n  }\n  .fade-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .fade-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .fade-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .fade-transition-enter-from, .fade-transition-leave-to {\n    opacity: 0 !important;\n  }\n  .fade-transition-enter-active, .fade-transition-leave-active {\n    transition-property: opacity !important;\n  }\n  .fab-transition-enter-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .fab-transition-leave-active {\n    transition-duration: 0.3s !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .fab-transition-move {\n    transition-duration: 0.5s !important;\n    transition-property: transform !important;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  }\n  .fab-transition-enter-from, .fab-transition-leave-to {\n    transform: scale(0) rotate(-45deg);\n  }\n  .fab-transition-enter-active, .fab-transition-leave-active {\n    transition-property: transform !important;\n  }\n}\n.v-locale--is-rtl {\n  direction: rtl;\n}\n.v-locale--is-ltr {\n  direction: ltr;\n}\n\n.blockquote {\n  padding: 16px 0 16px 24px;\n  font-size: 18px;\n  font-weight: 300;\n}\n\nhtml {\n  font-family: \"Roboto\", sans-serif;\n  line-height: 1.5;\n  font-size: 1rem;\n  overflow-x: hidden;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhtml.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n:root {\n  --v-theme-overlay-multiplier: 1;\n  --v-scrollbar-offset: 0px;\n}\n\n@supports (-webkit-touch-callout: none) {\n  body {\n    cursor: pointer;\n  }\n}\n@media only print {\n  .hidden-print-only {\n    display: none !important;\n  }\n}\n\n@media only screen {\n  .hidden-screen-only {\n    display: none !important;\n  }\n}\n\n@media (max-width: 599.98px) {\n  .hidden-xs {\n    display: none !important;\n  }\n}\n\n@media (min-width: 600px) and (max-width: 959.98px) {\n  .hidden-sm {\n    display: none !important;\n  }\n}\n\n@media (min-width: 960px) and (max-width: 1279.98px) {\n  .hidden-md {\n    display: none !important;\n  }\n}\n\n@media (min-width: 1280px) and (max-width: 1919.98px) {\n  .hidden-lg {\n    display: none !important;\n  }\n}\n\n@media (min-width: 1920px) and (max-width: 2559.98px) {\n  .hidden-xl {\n    display: none !important;\n  }\n}\n\n@media (min-width: 2560px) {\n  .hidden-xxl {\n    display: none !important;\n  }\n}\n\n@media (min-width: 600px) {\n  .hidden-sm-and-up {\n    display: none !important;\n  }\n}\n\n@media (min-width: 960px) {\n  .hidden-md-and-up {\n    display: none !important;\n  }\n}\n\n@media (min-width: 1280px) {\n  .hidden-lg-and-up {\n    display: none !important;\n  }\n}\n\n@media (min-width: 1920px) {\n  .hidden-xl-and-up {\n    display: none !important;\n  }\n}\n\n@media (max-width: 959.98px) {\n  .hidden-sm-and-down {\n    display: none !important;\n  }\n}\n\n@media (max-width: 1279.98px) {\n  .hidden-md-and-down {\n    display: none !important;\n  }\n}\n\n@media (max-width: 1919.98px) {\n  .hidden-lg-and-down {\n    display: none !important;\n  }\n}\n\n@media (max-width: 2559.98px) {\n  .hidden-xl-and-down {\n    display: none !important;\n  }\n}\n\n.elevation-24 {\n  box-shadow: 0px 11px 15px -7px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 24px 38px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 9px 46px 8px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-23 {\n  box-shadow: 0px 11px 14px -7px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 23px 36px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 9px 44px 8px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-22 {\n  box-shadow: 0px 10px 14px -6px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 22px 35px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 8px 42px 7px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-21 {\n  box-shadow: 0px 10px 13px -6px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 21px 33px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 8px 40px 7px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-20 {\n  box-shadow: 0px 10px 13px -6px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 20px 31px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 8px 38px 7px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-19 {\n  box-shadow: 0px 9px 12px -6px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 19px 29px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 7px 36px 6px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-18 {\n  box-shadow: 0px 9px 11px -5px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 18px 28px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 7px 34px 6px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-17 {\n  box-shadow: 0px 8px 11px -5px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 17px 26px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 6px 32px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-16 {\n  box-shadow: 0px 8px 10px -5px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 16px 24px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 6px 30px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-15 {\n  box-shadow: 0px 8px 9px -5px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 15px 22px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 6px 28px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-14 {\n  box-shadow: 0px 7px 9px -4px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 14px 21px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 5px 26px 4px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-13 {\n  box-shadow: 0px 7px 8px -4px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 13px 19px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 5px 24px 4px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-12 {\n  box-shadow: 0px 7px 8px -4px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 12px 17px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 5px 22px 4px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-11 {\n  box-shadow: 0px 6px 7px -4px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 11px 15px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 4px 20px 3px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-10 {\n  box-shadow: 0px 6px 6px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 10px 14px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 4px 18px 3px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-9 {\n  box-shadow: 0px 5px 6px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 9px 12px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 3px 16px 2px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-8 {\n  box-shadow: 0px 5px 5px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 8px 10px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 3px 14px 2px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-7 {\n  box-shadow: 0px 4px 5px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 7px 10px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 2px 16px 1px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-6 {\n  box-shadow: 0px 3px 5px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 6px 10px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 18px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-5 {\n  box-shadow: 0px 3px 5px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 5px 8px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 14px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-4 {\n  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-3 {\n  box-shadow: 0px 3px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 3px 4px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 8px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-2 {\n  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-1 {\n  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.elevation-0 {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.pointer-events-none {\n  pointer-events: none !important;\n}\n\n.pointer-events-auto {\n  pointer-events: auto !important;\n}\n\n.pointer-pass-through {\n  pointer-events: none !important;\n}\n.pointer-pass-through > * {\n  pointer-events: auto !important;\n}\n\n.d-sr-only,\n.d-sr-only-focusable:not(:focus) {\n  border: 0 !important;\n  clip: rect(0, 0, 0, 0) !important;\n  height: 1px !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  white-space: nowrap !important;\n  width: 1px !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.float-left {\n  float: left !important;\n}\n\n.float-right {\n  float: right !important;\n}\n\n.v-locale--is-rtl .float-end {\n  float: left !important;\n}\n\n.v-locale--is-rtl .float-start {\n  float: right !important;\n}\n\n.v-locale--is-ltr .float-end {\n  float: right !important;\n}\n\n.v-locale--is-ltr .float-start {\n  float: left !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-1-1 {\n  flex: 1 1 auto !important;\n}\n\n.flex-1-0 {\n  flex: 1 0 auto !important;\n}\n\n.flex-0-1 {\n  flex: 0 1 auto !important;\n}\n\n.flex-0-0 {\n  flex: 0 0 auto !important;\n}\n\n.flex-1-1-100 {\n  flex: 1 1 100% !important;\n}\n\n.flex-1-0-100 {\n  flex: 1 0 100% !important;\n}\n\n.flex-0-1-100 {\n  flex: 0 1 100% !important;\n}\n\n.flex-0-0-100 {\n  flex: 0 0 100% !important;\n}\n\n.flex-1-1-0 {\n  flex: 1 1 0 !important;\n}\n\n.flex-1-0-0 {\n  flex: 1 0 0 !important;\n}\n\n.flex-0-1-0 {\n  flex: 0 1 0 !important;\n}\n\n.flex-0-0-0 {\n  flex: 0 0 0 !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-start {\n  justify-content: flex-start !important;\n}\n\n.justify-end {\n  justify-content: flex-end !important;\n}\n\n.justify-center {\n  justify-content: center !important;\n}\n\n.justify-space-between {\n  justify-content: space-between !important;\n}\n\n.justify-space-around {\n  justify-content: space-around !important;\n}\n\n.justify-space-evenly {\n  justify-content: space-evenly !important;\n}\n\n.justify-items-start {\n  justify-items: flex-start !important;\n}\n\n.justify-items-end {\n  justify-items: flex-end !important;\n}\n\n.justify-items-center {\n  justify-items: center !important;\n}\n\n.justify-items-stretch {\n  justify-items: stretch !important;\n}\n\n.align-start {\n  align-items: flex-start !important;\n}\n\n.align-end {\n  align-items: flex-end !important;\n}\n\n.align-center {\n  align-items: center !important;\n}\n\n.align-baseline {\n  align-items: baseline !important;\n}\n\n.align-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-space-between {\n  align-content: space-between !important;\n}\n\n.align-content-space-around {\n  align-content: space-around !important;\n}\n\n.align-content-space-evenly {\n  align-content: space-evenly !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-6 {\n  order: 6 !important;\n}\n\n.order-7 {\n  order: 7 !important;\n}\n\n.order-8 {\n  order: 8 !important;\n}\n\n.order-9 {\n  order: 9 !important;\n}\n\n.order-10 {\n  order: 10 !important;\n}\n\n.order-11 {\n  order: 11 !important;\n}\n\n.order-12 {\n  order: 12 !important;\n}\n\n.order-last {\n  order: 13 !important;\n}\n\n.ga-0 {\n  gap: 0px !important;\n}\n\n.ga-1 {\n  gap: 4px !important;\n}\n\n.ga-2 {\n  gap: 8px !important;\n}\n\n.ga-3 {\n  gap: 12px !important;\n}\n\n.ga-4 {\n  gap: 16px !important;\n}\n\n.ga-5 {\n  gap: 20px !important;\n}\n\n.ga-6 {\n  gap: 24px !important;\n}\n\n.ga-7 {\n  gap: 28px !important;\n}\n\n.ga-8 {\n  gap: 32px !important;\n}\n\n.ga-9 {\n  gap: 36px !important;\n}\n\n.ga-10 {\n  gap: 40px !important;\n}\n\n.ga-11 {\n  gap: 44px !important;\n}\n\n.ga-12 {\n  gap: 48px !important;\n}\n\n.ga-13 {\n  gap: 52px !important;\n}\n\n.ga-14 {\n  gap: 56px !important;\n}\n\n.ga-15 {\n  gap: 60px !important;\n}\n\n.ga-16 {\n  gap: 64px !important;\n}\n\n.ga-auto {\n  gap: auto !important;\n}\n\n.gr-0 {\n  row-gap: 0px !important;\n}\n\n.gr-1 {\n  row-gap: 4px !important;\n}\n\n.gr-2 {\n  row-gap: 8px !important;\n}\n\n.gr-3 {\n  row-gap: 12px !important;\n}\n\n.gr-4 {\n  row-gap: 16px !important;\n}\n\n.gr-5 {\n  row-gap: 20px !important;\n}\n\n.gr-6 {\n  row-gap: 24px !important;\n}\n\n.gr-7 {\n  row-gap: 28px !important;\n}\n\n.gr-8 {\n  row-gap: 32px !important;\n}\n\n.gr-9 {\n  row-gap: 36px !important;\n}\n\n.gr-10 {\n  row-gap: 40px !important;\n}\n\n.gr-11 {\n  row-gap: 44px !important;\n}\n\n.gr-12 {\n  row-gap: 48px !important;\n}\n\n.gr-13 {\n  row-gap: 52px !important;\n}\n\n.gr-14 {\n  row-gap: 56px !important;\n}\n\n.gr-15 {\n  row-gap: 60px !important;\n}\n\n.gr-16 {\n  row-gap: 64px !important;\n}\n\n.gr-auto {\n  row-gap: auto !important;\n}\n\n.gc-0 {\n  column-gap: 0px !important;\n}\n\n.gc-1 {\n  column-gap: 4px !important;\n}\n\n.gc-2 {\n  column-gap: 8px !important;\n}\n\n.gc-3 {\n  column-gap: 12px !important;\n}\n\n.gc-4 {\n  column-gap: 16px !important;\n}\n\n.gc-5 {\n  column-gap: 20px !important;\n}\n\n.gc-6 {\n  column-gap: 24px !important;\n}\n\n.gc-7 {\n  column-gap: 28px !important;\n}\n\n.gc-8 {\n  column-gap: 32px !important;\n}\n\n.gc-9 {\n  column-gap: 36px !important;\n}\n\n.gc-10 {\n  column-gap: 40px !important;\n}\n\n.gc-11 {\n  column-gap: 44px !important;\n}\n\n.gc-12 {\n  column-gap: 48px !important;\n}\n\n.gc-13 {\n  column-gap: 52px !important;\n}\n\n.gc-14 {\n  column-gap: 56px !important;\n}\n\n.gc-15 {\n  column-gap: 60px !important;\n}\n\n.gc-16 {\n  column-gap: 64px !important;\n}\n\n.gc-auto {\n  column-gap: auto !important;\n}\n\n.ma-0 {\n  margin: 0px !important;\n}\n\n.ma-1 {\n  margin: 4px !important;\n}\n\n.ma-2 {\n  margin: 8px !important;\n}\n\n.ma-3 {\n  margin: 12px !important;\n}\n\n.ma-4 {\n  margin: 16px !important;\n}\n\n.ma-5 {\n  margin: 20px !important;\n}\n\n.ma-6 {\n  margin: 24px !important;\n}\n\n.ma-7 {\n  margin: 28px !important;\n}\n\n.ma-8 {\n  margin: 32px !important;\n}\n\n.ma-9 {\n  margin: 36px !important;\n}\n\n.ma-10 {\n  margin: 40px !important;\n}\n\n.ma-11 {\n  margin: 44px !important;\n}\n\n.ma-12 {\n  margin: 48px !important;\n}\n\n.ma-13 {\n  margin: 52px !important;\n}\n\n.ma-14 {\n  margin: 56px !important;\n}\n\n.ma-15 {\n  margin: 60px !important;\n}\n\n.ma-16 {\n  margin: 64px !important;\n}\n\n.ma-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n\n.mx-1 {\n  margin-right: 4px !important;\n  margin-left: 4px !important;\n}\n\n.mx-2 {\n  margin-right: 8px !important;\n  margin-left: 8px !important;\n}\n\n.mx-3 {\n  margin-right: 12px !important;\n  margin-left: 12px !important;\n}\n\n.mx-4 {\n  margin-right: 16px !important;\n  margin-left: 16px !important;\n}\n\n.mx-5 {\n  margin-right: 20px !important;\n  margin-left: 20px !important;\n}\n\n.mx-6 {\n  margin-right: 24px !important;\n  margin-left: 24px !important;\n}\n\n.mx-7 {\n  margin-right: 28px !important;\n  margin-left: 28px !important;\n}\n\n.mx-8 {\n  margin-right: 32px !important;\n  margin-left: 32px !important;\n}\n\n.mx-9 {\n  margin-right: 36px !important;\n  margin-left: 36px !important;\n}\n\n.mx-10 {\n  margin-right: 40px !important;\n  margin-left: 40px !important;\n}\n\n.mx-11 {\n  margin-right: 44px !important;\n  margin-left: 44px !important;\n}\n\n.mx-12 {\n  margin-right: 48px !important;\n  margin-left: 48px !important;\n}\n\n.mx-13 {\n  margin-right: 52px !important;\n  margin-left: 52px !important;\n}\n\n.mx-14 {\n  margin-right: 56px !important;\n  margin-left: 56px !important;\n}\n\n.mx-15 {\n  margin-right: 60px !important;\n  margin-left: 60px !important;\n}\n\n.mx-16 {\n  margin-right: 64px !important;\n  margin-left: 64px !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0px !important;\n  margin-bottom: 0px !important;\n}\n\n.my-1 {\n  margin-top: 4px !important;\n  margin-bottom: 4px !important;\n}\n\n.my-2 {\n  margin-top: 8px !important;\n  margin-bottom: 8px !important;\n}\n\n.my-3 {\n  margin-top: 12px !important;\n  margin-bottom: 12px !important;\n}\n\n.my-4 {\n  margin-top: 16px !important;\n  margin-bottom: 16px !important;\n}\n\n.my-5 {\n  margin-top: 20px !important;\n  margin-bottom: 20px !important;\n}\n\n.my-6 {\n  margin-top: 24px !important;\n  margin-bottom: 24px !important;\n}\n\n.my-7 {\n  margin-top: 28px !important;\n  margin-bottom: 28px !important;\n}\n\n.my-8 {\n  margin-top: 32px !important;\n  margin-bottom: 32px !important;\n}\n\n.my-9 {\n  margin-top: 36px !important;\n  margin-bottom: 36px !important;\n}\n\n.my-10 {\n  margin-top: 40px !important;\n  margin-bottom: 40px !important;\n}\n\n.my-11 {\n  margin-top: 44px !important;\n  margin-bottom: 44px !important;\n}\n\n.my-12 {\n  margin-top: 48px !important;\n  margin-bottom: 48px !important;\n}\n\n.my-13 {\n  margin-top: 52px !important;\n  margin-bottom: 52px !important;\n}\n\n.my-14 {\n  margin-top: 56px !important;\n  margin-bottom: 56px !important;\n}\n\n.my-15 {\n  margin-top: 60px !important;\n  margin-bottom: 60px !important;\n}\n\n.my-16 {\n  margin-top: 64px !important;\n  margin-bottom: 64px !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0px !important;\n}\n\n.mt-1 {\n  margin-top: 4px !important;\n}\n\n.mt-2 {\n  margin-top: 8px !important;\n}\n\n.mt-3 {\n  margin-top: 12px !important;\n}\n\n.mt-4 {\n  margin-top: 16px !important;\n}\n\n.mt-5 {\n  margin-top: 20px !important;\n}\n\n.mt-6 {\n  margin-top: 24px !important;\n}\n\n.mt-7 {\n  margin-top: 28px !important;\n}\n\n.mt-8 {\n  margin-top: 32px !important;\n}\n\n.mt-9 {\n  margin-top: 36px !important;\n}\n\n.mt-10 {\n  margin-top: 40px !important;\n}\n\n.mt-11 {\n  margin-top: 44px !important;\n}\n\n.mt-12 {\n  margin-top: 48px !important;\n}\n\n.mt-13 {\n  margin-top: 52px !important;\n}\n\n.mt-14 {\n  margin-top: 56px !important;\n}\n\n.mt-15 {\n  margin-top: 60px !important;\n}\n\n.mt-16 {\n  margin-top: 64px !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.mr-0 {\n  margin-right: 0px !important;\n}\n\n.mr-1 {\n  margin-right: 4px !important;\n}\n\n.mr-2 {\n  margin-right: 8px !important;\n}\n\n.mr-3 {\n  margin-right: 12px !important;\n}\n\n.mr-4 {\n  margin-right: 16px !important;\n}\n\n.mr-5 {\n  margin-right: 20px !important;\n}\n\n.mr-6 {\n  margin-right: 24px !important;\n}\n\n.mr-7 {\n  margin-right: 28px !important;\n}\n\n.mr-8 {\n  margin-right: 32px !important;\n}\n\n.mr-9 {\n  margin-right: 36px !important;\n}\n\n.mr-10 {\n  margin-right: 40px !important;\n}\n\n.mr-11 {\n  margin-right: 44px !important;\n}\n\n.mr-12 {\n  margin-right: 48px !important;\n}\n\n.mr-13 {\n  margin-right: 52px !important;\n}\n\n.mr-14 {\n  margin-right: 56px !important;\n}\n\n.mr-15 {\n  margin-right: 60px !important;\n}\n\n.mr-16 {\n  margin-right: 64px !important;\n}\n\n.mr-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0px !important;\n}\n\n.mb-1 {\n  margin-bottom: 4px !important;\n}\n\n.mb-2 {\n  margin-bottom: 8px !important;\n}\n\n.mb-3 {\n  margin-bottom: 12px !important;\n}\n\n.mb-4 {\n  margin-bottom: 16px !important;\n}\n\n.mb-5 {\n  margin-bottom: 20px !important;\n}\n\n.mb-6 {\n  margin-bottom: 24px !important;\n}\n\n.mb-7 {\n  margin-bottom: 28px !important;\n}\n\n.mb-8 {\n  margin-bottom: 32px !important;\n}\n\n.mb-9 {\n  margin-bottom: 36px !important;\n}\n\n.mb-10 {\n  margin-bottom: 40px !important;\n}\n\n.mb-11 {\n  margin-bottom: 44px !important;\n}\n\n.mb-12 {\n  margin-bottom: 48px !important;\n}\n\n.mb-13 {\n  margin-bottom: 52px !important;\n}\n\n.mb-14 {\n  margin-bottom: 56px !important;\n}\n\n.mb-15 {\n  margin-bottom: 60px !important;\n}\n\n.mb-16 {\n  margin-bottom: 64px !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ml-0 {\n  margin-left: 0px !important;\n}\n\n.ml-1 {\n  margin-left: 4px !important;\n}\n\n.ml-2 {\n  margin-left: 8px !important;\n}\n\n.ml-3 {\n  margin-left: 12px !important;\n}\n\n.ml-4 {\n  margin-left: 16px !important;\n}\n\n.ml-5 {\n  margin-left: 20px !important;\n}\n\n.ml-6 {\n  margin-left: 24px !important;\n}\n\n.ml-7 {\n  margin-left: 28px !important;\n}\n\n.ml-8 {\n  margin-left: 32px !important;\n}\n\n.ml-9 {\n  margin-left: 36px !important;\n}\n\n.ml-10 {\n  margin-left: 40px !important;\n}\n\n.ml-11 {\n  margin-left: 44px !important;\n}\n\n.ml-12 {\n  margin-left: 48px !important;\n}\n\n.ml-13 {\n  margin-left: 52px !important;\n}\n\n.ml-14 {\n  margin-left: 56px !important;\n}\n\n.ml-15 {\n  margin-left: 60px !important;\n}\n\n.ml-16 {\n  margin-left: 64px !important;\n}\n\n.ml-auto {\n  margin-left: auto !important;\n}\n\n.ms-0 {\n  margin-inline-start: 0px !important;\n}\n\n.ms-1 {\n  margin-inline-start: 4px !important;\n}\n\n.ms-2 {\n  margin-inline-start: 8px !important;\n}\n\n.ms-3 {\n  margin-inline-start: 12px !important;\n}\n\n.ms-4 {\n  margin-inline-start: 16px !important;\n}\n\n.ms-5 {\n  margin-inline-start: 20px !important;\n}\n\n.ms-6 {\n  margin-inline-start: 24px !important;\n}\n\n.ms-7 {\n  margin-inline-start: 28px !important;\n}\n\n.ms-8 {\n  margin-inline-start: 32px !important;\n}\n\n.ms-9 {\n  margin-inline-start: 36px !important;\n}\n\n.ms-10 {\n  margin-inline-start: 40px !important;\n}\n\n.ms-11 {\n  margin-inline-start: 44px !important;\n}\n\n.ms-12 {\n  margin-inline-start: 48px !important;\n}\n\n.ms-13 {\n  margin-inline-start: 52px !important;\n}\n\n.ms-14 {\n  margin-inline-start: 56px !important;\n}\n\n.ms-15 {\n  margin-inline-start: 60px !important;\n}\n\n.ms-16 {\n  margin-inline-start: 64px !important;\n}\n\n.ms-auto {\n  margin-inline-start: auto !important;\n}\n\n.me-0 {\n  margin-inline-end: 0px !important;\n}\n\n.me-1 {\n  margin-inline-end: 4px !important;\n}\n\n.me-2 {\n  margin-inline-end: 8px !important;\n}\n\n.me-3 {\n  margin-inline-end: 12px !important;\n}\n\n.me-4 {\n  margin-inline-end: 16px !important;\n}\n\n.me-5 {\n  margin-inline-end: 20px !important;\n}\n\n.me-6 {\n  margin-inline-end: 24px !important;\n}\n\n.me-7 {\n  margin-inline-end: 28px !important;\n}\n\n.me-8 {\n  margin-inline-end: 32px !important;\n}\n\n.me-9 {\n  margin-inline-end: 36px !important;\n}\n\n.me-10 {\n  margin-inline-end: 40px !important;\n}\n\n.me-11 {\n  margin-inline-end: 44px !important;\n}\n\n.me-12 {\n  margin-inline-end: 48px !important;\n}\n\n.me-13 {\n  margin-inline-end: 52px !important;\n}\n\n.me-14 {\n  margin-inline-end: 56px !important;\n}\n\n.me-15 {\n  margin-inline-end: 60px !important;\n}\n\n.me-16 {\n  margin-inline-end: 64px !important;\n}\n\n.me-auto {\n  margin-inline-end: auto !important;\n}\n\n.ma-n1 {\n  margin: -4px !important;\n}\n\n.ma-n2 {\n  margin: -8px !important;\n}\n\n.ma-n3 {\n  margin: -12px !important;\n}\n\n.ma-n4 {\n  margin: -16px !important;\n}\n\n.ma-n5 {\n  margin: -20px !important;\n}\n\n.ma-n6 {\n  margin: -24px !important;\n}\n\n.ma-n7 {\n  margin: -28px !important;\n}\n\n.ma-n8 {\n  margin: -32px !important;\n}\n\n.ma-n9 {\n  margin: -36px !important;\n}\n\n.ma-n10 {\n  margin: -40px !important;\n}\n\n.ma-n11 {\n  margin: -44px !important;\n}\n\n.ma-n12 {\n  margin: -48px !important;\n}\n\n.ma-n13 {\n  margin: -52px !important;\n}\n\n.ma-n14 {\n  margin: -56px !important;\n}\n\n.ma-n15 {\n  margin: -60px !important;\n}\n\n.ma-n16 {\n  margin: -64px !important;\n}\n\n.mx-n1 {\n  margin-right: -4px !important;\n  margin-left: -4px !important;\n}\n\n.mx-n2 {\n  margin-right: -8px !important;\n  margin-left: -8px !important;\n}\n\n.mx-n3 {\n  margin-right: -12px !important;\n  margin-left: -12px !important;\n}\n\n.mx-n4 {\n  margin-right: -16px !important;\n  margin-left: -16px !important;\n}\n\n.mx-n5 {\n  margin-right: -20px !important;\n  margin-left: -20px !important;\n}\n\n.mx-n6 {\n  margin-right: -24px !important;\n  margin-left: -24px !important;\n}\n\n.mx-n7 {\n  margin-right: -28px !important;\n  margin-left: -28px !important;\n}\n\n.mx-n8 {\n  margin-right: -32px !important;\n  margin-left: -32px !important;\n}\n\n.mx-n9 {\n  margin-right: -36px !important;\n  margin-left: -36px !important;\n}\n\n.mx-n10 {\n  margin-right: -40px !important;\n  margin-left: -40px !important;\n}\n\n.mx-n11 {\n  margin-right: -44px !important;\n  margin-left: -44px !important;\n}\n\n.mx-n12 {\n  margin-right: -48px !important;\n  margin-left: -48px !important;\n}\n\n.mx-n13 {\n  margin-right: -52px !important;\n  margin-left: -52px !important;\n}\n\n.mx-n14 {\n  margin-right: -56px !important;\n  margin-left: -56px !important;\n}\n\n.mx-n15 {\n  margin-right: -60px !important;\n  margin-left: -60px !important;\n}\n\n.mx-n16 {\n  margin-right: -64px !important;\n  margin-left: -64px !important;\n}\n\n.my-n1 {\n  margin-top: -4px !important;\n  margin-bottom: -4px !important;\n}\n\n.my-n2 {\n  margin-top: -8px !important;\n  margin-bottom: -8px !important;\n}\n\n.my-n3 {\n  margin-top: -12px !important;\n  margin-bottom: -12px !important;\n}\n\n.my-n4 {\n  margin-top: -16px !important;\n  margin-bottom: -16px !important;\n}\n\n.my-n5 {\n  margin-top: -20px !important;\n  margin-bottom: -20px !important;\n}\n\n.my-n6 {\n  margin-top: -24px !important;\n  margin-bottom: -24px !important;\n}\n\n.my-n7 {\n  margin-top: -28px !important;\n  margin-bottom: -28px !important;\n}\n\n.my-n8 {\n  margin-top: -32px !important;\n  margin-bottom: -32px !important;\n}\n\n.my-n9 {\n  margin-top: -36px !important;\n  margin-bottom: -36px !important;\n}\n\n.my-n10 {\n  margin-top: -40px !important;\n  margin-bottom: -40px !important;\n}\n\n.my-n11 {\n  margin-top: -44px !important;\n  margin-bottom: -44px !important;\n}\n\n.my-n12 {\n  margin-top: -48px !important;\n  margin-bottom: -48px !important;\n}\n\n.my-n13 {\n  margin-top: -52px !important;\n  margin-bottom: -52px !important;\n}\n\n.my-n14 {\n  margin-top: -56px !important;\n  margin-bottom: -56px !important;\n}\n\n.my-n15 {\n  margin-top: -60px !important;\n  margin-bottom: -60px !important;\n}\n\n.my-n16 {\n  margin-top: -64px !important;\n  margin-bottom: -64px !important;\n}\n\n.mt-n1 {\n  margin-top: -4px !important;\n}\n\n.mt-n2 {\n  margin-top: -8px !important;\n}\n\n.mt-n3 {\n  margin-top: -12px !important;\n}\n\n.mt-n4 {\n  margin-top: -16px !important;\n}\n\n.mt-n5 {\n  margin-top: -20px !important;\n}\n\n.mt-n6 {\n  margin-top: -24px !important;\n}\n\n.mt-n7 {\n  margin-top: -28px !important;\n}\n\n.mt-n8 {\n  margin-top: -32px !important;\n}\n\n.mt-n9 {\n  margin-top: -36px !important;\n}\n\n.mt-n10 {\n  margin-top: -40px !important;\n}\n\n.mt-n11 {\n  margin-top: -44px !important;\n}\n\n.mt-n12 {\n  margin-top: -48px !important;\n}\n\n.mt-n13 {\n  margin-top: -52px !important;\n}\n\n.mt-n14 {\n  margin-top: -56px !important;\n}\n\n.mt-n15 {\n  margin-top: -60px !important;\n}\n\n.mt-n16 {\n  margin-top: -64px !important;\n}\n\n.mr-n1 {\n  margin-right: -4px !important;\n}\n\n.mr-n2 {\n  margin-right: -8px !important;\n}\n\n.mr-n3 {\n  margin-right: -12px !important;\n}\n\n.mr-n4 {\n  margin-right: -16px !important;\n}\n\n.mr-n5 {\n  margin-right: -20px !important;\n}\n\n.mr-n6 {\n  margin-right: -24px !important;\n}\n\n.mr-n7 {\n  margin-right: -28px !important;\n}\n\n.mr-n8 {\n  margin-right: -32px !important;\n}\n\n.mr-n9 {\n  margin-right: -36px !important;\n}\n\n.mr-n10 {\n  margin-right: -40px !important;\n}\n\n.mr-n11 {\n  margin-right: -44px !important;\n}\n\n.mr-n12 {\n  margin-right: -48px !important;\n}\n\n.mr-n13 {\n  margin-right: -52px !important;\n}\n\n.mr-n14 {\n  margin-right: -56px !important;\n}\n\n.mr-n15 {\n  margin-right: -60px !important;\n}\n\n.mr-n16 {\n  margin-right: -64px !important;\n}\n\n.mb-n1 {\n  margin-bottom: -4px !important;\n}\n\n.mb-n2 {\n  margin-bottom: -8px !important;\n}\n\n.mb-n3 {\n  margin-bottom: -12px !important;\n}\n\n.mb-n4 {\n  margin-bottom: -16px !important;\n}\n\n.mb-n5 {\n  margin-bottom: -20px !important;\n}\n\n.mb-n6 {\n  margin-bottom: -24px !important;\n}\n\n.mb-n7 {\n  margin-bottom: -28px !important;\n}\n\n.mb-n8 {\n  margin-bottom: -32px !important;\n}\n\n.mb-n9 {\n  margin-bottom: -36px !important;\n}\n\n.mb-n10 {\n  margin-bottom: -40px !important;\n}\n\n.mb-n11 {\n  margin-bottom: -44px !important;\n}\n\n.mb-n12 {\n  margin-bottom: -48px !important;\n}\n\n.mb-n13 {\n  margin-bottom: -52px !important;\n}\n\n.mb-n14 {\n  margin-bottom: -56px !important;\n}\n\n.mb-n15 {\n  margin-bottom: -60px !important;\n}\n\n.mb-n16 {\n  margin-bottom: -64px !important;\n}\n\n.ml-n1 {\n  margin-left: -4px !important;\n}\n\n.ml-n2 {\n  margin-left: -8px !important;\n}\n\n.ml-n3 {\n  margin-left: -12px !important;\n}\n\n.ml-n4 {\n  margin-left: -16px !important;\n}\n\n.ml-n5 {\n  margin-left: -20px !important;\n}\n\n.ml-n6 {\n  margin-left: -24px !important;\n}\n\n.ml-n7 {\n  margin-left: -28px !important;\n}\n\n.ml-n8 {\n  margin-left: -32px !important;\n}\n\n.ml-n9 {\n  margin-left: -36px !important;\n}\n\n.ml-n10 {\n  margin-left: -40px !important;\n}\n\n.ml-n11 {\n  margin-left: -44px !important;\n}\n\n.ml-n12 {\n  margin-left: -48px !important;\n}\n\n.ml-n13 {\n  margin-left: -52px !important;\n}\n\n.ml-n14 {\n  margin-left: -56px !important;\n}\n\n.ml-n15 {\n  margin-left: -60px !important;\n}\n\n.ml-n16 {\n  margin-left: -64px !important;\n}\n\n.ms-n1 {\n  margin-inline-start: -4px !important;\n}\n\n.ms-n2 {\n  margin-inline-start: -8px !important;\n}\n\n.ms-n3 {\n  margin-inline-start: -12px !important;\n}\n\n.ms-n4 {\n  margin-inline-start: -16px !important;\n}\n\n.ms-n5 {\n  margin-inline-start: -20px !important;\n}\n\n.ms-n6 {\n  margin-inline-start: -24px !important;\n}\n\n.ms-n7 {\n  margin-inline-start: -28px !important;\n}\n\n.ms-n8 {\n  margin-inline-start: -32px !important;\n}\n\n.ms-n9 {\n  margin-inline-start: -36px !important;\n}\n\n.ms-n10 {\n  margin-inline-start: -40px !important;\n}\n\n.ms-n11 {\n  margin-inline-start: -44px !important;\n}\n\n.ms-n12 {\n  margin-inline-start: -48px !important;\n}\n\n.ms-n13 {\n  margin-inline-start: -52px !important;\n}\n\n.ms-n14 {\n  margin-inline-start: -56px !important;\n}\n\n.ms-n15 {\n  margin-inline-start: -60px !important;\n}\n\n.ms-n16 {\n  margin-inline-start: -64px !important;\n}\n\n.me-n1 {\n  margin-inline-end: -4px !important;\n}\n\n.me-n2 {\n  margin-inline-end: -8px !important;\n}\n\n.me-n3 {\n  margin-inline-end: -12px !important;\n}\n\n.me-n4 {\n  margin-inline-end: -16px !important;\n}\n\n.me-n5 {\n  margin-inline-end: -20px !important;\n}\n\n.me-n6 {\n  margin-inline-end: -24px !important;\n}\n\n.me-n7 {\n  margin-inline-end: -28px !important;\n}\n\n.me-n8 {\n  margin-inline-end: -32px !important;\n}\n\n.me-n9 {\n  margin-inline-end: -36px !important;\n}\n\n.me-n10 {\n  margin-inline-end: -40px !important;\n}\n\n.me-n11 {\n  margin-inline-end: -44px !important;\n}\n\n.me-n12 {\n  margin-inline-end: -48px !important;\n}\n\n.me-n13 {\n  margin-inline-end: -52px !important;\n}\n\n.me-n14 {\n  margin-inline-end: -56px !important;\n}\n\n.me-n15 {\n  margin-inline-end: -60px !important;\n}\n\n.me-n16 {\n  margin-inline-end: -64px !important;\n}\n\n.pa-0 {\n  padding: 0px !important;\n}\n\n.pa-1 {\n  padding: 4px !important;\n}\n\n.pa-2 {\n  padding: 8px !important;\n}\n\n.pa-3 {\n  padding: 12px !important;\n}\n\n.pa-4 {\n  padding: 16px !important;\n}\n\n.pa-5 {\n  padding: 20px !important;\n}\n\n.pa-6 {\n  padding: 24px !important;\n}\n\n.pa-7 {\n  padding: 28px !important;\n}\n\n.pa-8 {\n  padding: 32px !important;\n}\n\n.pa-9 {\n  padding: 36px !important;\n}\n\n.pa-10 {\n  padding: 40px !important;\n}\n\n.pa-11 {\n  padding: 44px !important;\n}\n\n.pa-12 {\n  padding: 48px !important;\n}\n\n.pa-13 {\n  padding: 52px !important;\n}\n\n.pa-14 {\n  padding: 56px !important;\n}\n\n.pa-15 {\n  padding: 60px !important;\n}\n\n.pa-16 {\n  padding: 64px !important;\n}\n\n.px-0 {\n  padding-right: 0px !important;\n  padding-left: 0px !important;\n}\n\n.px-1 {\n  padding-right: 4px !important;\n  padding-left: 4px !important;\n}\n\n.px-2 {\n  padding-right: 8px !important;\n  padding-left: 8px !important;\n}\n\n.px-3 {\n  padding-right: 12px !important;\n  padding-left: 12px !important;\n}\n\n.px-4 {\n  padding-right: 16px !important;\n  padding-left: 16px !important;\n}\n\n.px-5 {\n  padding-right: 20px !important;\n  padding-left: 20px !important;\n}\n\n.px-6 {\n  padding-right: 24px !important;\n  padding-left: 24px !important;\n}\n\n.px-7 {\n  padding-right: 28px !important;\n  padding-left: 28px !important;\n}\n\n.px-8 {\n  padding-right: 32px !important;\n  padding-left: 32px !important;\n}\n\n.px-9 {\n  padding-right: 36px !important;\n  padding-left: 36px !important;\n}\n\n.px-10 {\n  padding-right: 40px !important;\n  padding-left: 40px !important;\n}\n\n.px-11 {\n  padding-right: 44px !important;\n  padding-left: 44px !important;\n}\n\n.px-12 {\n  padding-right: 48px !important;\n  padding-left: 48px !important;\n}\n\n.px-13 {\n  padding-right: 52px !important;\n  padding-left: 52px !important;\n}\n\n.px-14 {\n  padding-right: 56px !important;\n  padding-left: 56px !important;\n}\n\n.px-15 {\n  padding-right: 60px !important;\n  padding-left: 60px !important;\n}\n\n.px-16 {\n  padding-right: 64px !important;\n  padding-left: 64px !important;\n}\n\n.py-0 {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n\n.py-1 {\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n\n.py-2 {\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n\n.py-3 {\n  padding-top: 12px !important;\n  padding-bottom: 12px !important;\n}\n\n.py-4 {\n  padding-top: 16px !important;\n  padding-bottom: 16px !important;\n}\n\n.py-5 {\n  padding-top: 20px !important;\n  padding-bottom: 20px !important;\n}\n\n.py-6 {\n  padding-top: 24px !important;\n  padding-bottom: 24px !important;\n}\n\n.py-7 {\n  padding-top: 28px !important;\n  padding-bottom: 28px !important;\n}\n\n.py-8 {\n  padding-top: 32px !important;\n  padding-bottom: 32px !important;\n}\n\n.py-9 {\n  padding-top: 36px !important;\n  padding-bottom: 36px !important;\n}\n\n.py-10 {\n  padding-top: 40px !important;\n  padding-bottom: 40px !important;\n}\n\n.py-11 {\n  padding-top: 44px !important;\n  padding-bottom: 44px !important;\n}\n\n.py-12 {\n  padding-top: 48px !important;\n  padding-bottom: 48px !important;\n}\n\n.py-13 {\n  padding-top: 52px !important;\n  padding-bottom: 52px !important;\n}\n\n.py-14 {\n  padding-top: 56px !important;\n  padding-bottom: 56px !important;\n}\n\n.py-15 {\n  padding-top: 60px !important;\n  padding-bottom: 60px !important;\n}\n\n.py-16 {\n  padding-top: 64px !important;\n  padding-bottom: 64px !important;\n}\n\n.pt-0 {\n  padding-top: 0px !important;\n}\n\n.pt-1 {\n  padding-top: 4px !important;\n}\n\n.pt-2 {\n  padding-top: 8px !important;\n}\n\n.pt-3 {\n  padding-top: 12px !important;\n}\n\n.pt-4 {\n  padding-top: 16px !important;\n}\n\n.pt-5 {\n  padding-top: 20px !important;\n}\n\n.pt-6 {\n  padding-top: 24px !important;\n}\n\n.pt-7 {\n  padding-top: 28px !important;\n}\n\n.pt-8 {\n  padding-top: 32px !important;\n}\n\n.pt-9 {\n  padding-top: 36px !important;\n}\n\n.pt-10 {\n  padding-top: 40px !important;\n}\n\n.pt-11 {\n  padding-top: 44px !important;\n}\n\n.pt-12 {\n  padding-top: 48px !important;\n}\n\n.pt-13 {\n  padding-top: 52px !important;\n}\n\n.pt-14 {\n  padding-top: 56px !important;\n}\n\n.pt-15 {\n  padding-top: 60px !important;\n}\n\n.pt-16 {\n  padding-top: 64px !important;\n}\n\n.pr-0 {\n  padding-right: 0px !important;\n}\n\n.pr-1 {\n  padding-right: 4px !important;\n}\n\n.pr-2 {\n  padding-right: 8px !important;\n}\n\n.pr-3 {\n  padding-right: 12px !important;\n}\n\n.pr-4 {\n  padding-right: 16px !important;\n}\n\n.pr-5 {\n  padding-right: 20px !important;\n}\n\n.pr-6 {\n  padding-right: 24px !important;\n}\n\n.pr-7 {\n  padding-right: 28px !important;\n}\n\n.pr-8 {\n  padding-right: 32px !important;\n}\n\n.pr-9 {\n  padding-right: 36px !important;\n}\n\n.pr-10 {\n  padding-right: 40px !important;\n}\n\n.pr-11 {\n  padding-right: 44px !important;\n}\n\n.pr-12 {\n  padding-right: 48px !important;\n}\n\n.pr-13 {\n  padding-right: 52px !important;\n}\n\n.pr-14 {\n  padding-right: 56px !important;\n}\n\n.pr-15 {\n  padding-right: 60px !important;\n}\n\n.pr-16 {\n  padding-right: 64px !important;\n}\n\n.pb-0 {\n  padding-bottom: 0px !important;\n}\n\n.pb-1 {\n  padding-bottom: 4px !important;\n}\n\n.pb-2 {\n  padding-bottom: 8px !important;\n}\n\n.pb-3 {\n  padding-bottom: 12px !important;\n}\n\n.pb-4 {\n  padding-bottom: 16px !important;\n}\n\n.pb-5 {\n  padding-bottom: 20px !important;\n}\n\n.pb-6 {\n  padding-bottom: 24px !important;\n}\n\n.pb-7 {\n  padding-bottom: 28px !important;\n}\n\n.pb-8 {\n  padding-bottom: 32px !important;\n}\n\n.pb-9 {\n  padding-bottom: 36px !important;\n}\n\n.pb-10 {\n  padding-bottom: 40px !important;\n}\n\n.pb-11 {\n  padding-bottom: 44px !important;\n}\n\n.pb-12 {\n  padding-bottom: 48px !important;\n}\n\n.pb-13 {\n  padding-bottom: 52px !important;\n}\n\n.pb-14 {\n  padding-bottom: 56px !important;\n}\n\n.pb-15 {\n  padding-bottom: 60px !important;\n}\n\n.pb-16 {\n  padding-bottom: 64px !important;\n}\n\n.pl-0 {\n  padding-left: 0px !important;\n}\n\n.pl-1 {\n  padding-left: 4px !important;\n}\n\n.pl-2 {\n  padding-left: 8px !important;\n}\n\n.pl-3 {\n  padding-left: 12px !important;\n}\n\n.pl-4 {\n  padding-left: 16px !important;\n}\n\n.pl-5 {\n  padding-left: 20px !important;\n}\n\n.pl-6 {\n  padding-left: 24px !important;\n}\n\n.pl-7 {\n  padding-left: 28px !important;\n}\n\n.pl-8 {\n  padding-left: 32px !important;\n}\n\n.pl-9 {\n  padding-left: 36px !important;\n}\n\n.pl-10 {\n  padding-left: 40px !important;\n}\n\n.pl-11 {\n  padding-left: 44px !important;\n}\n\n.pl-12 {\n  padding-left: 48px !important;\n}\n\n.pl-13 {\n  padding-left: 52px !important;\n}\n\n.pl-14 {\n  padding-left: 56px !important;\n}\n\n.pl-15 {\n  padding-left: 60px !important;\n}\n\n.pl-16 {\n  padding-left: 64px !important;\n}\n\n.ps-0 {\n  padding-inline-start: 0px !important;\n}\n\n.ps-1 {\n  padding-inline-start: 4px !important;\n}\n\n.ps-2 {\n  padding-inline-start: 8px !important;\n}\n\n.ps-3 {\n  padding-inline-start: 12px !important;\n}\n\n.ps-4 {\n  padding-inline-start: 16px !important;\n}\n\n.ps-5 {\n  padding-inline-start: 20px !important;\n}\n\n.ps-6 {\n  padding-inline-start: 24px !important;\n}\n\n.ps-7 {\n  padding-inline-start: 28px !important;\n}\n\n.ps-8 {\n  padding-inline-start: 32px !important;\n}\n\n.ps-9 {\n  padding-inline-start: 36px !important;\n}\n\n.ps-10 {\n  padding-inline-start: 40px !important;\n}\n\n.ps-11 {\n  padding-inline-start: 44px !important;\n}\n\n.ps-12 {\n  padding-inline-start: 48px !important;\n}\n\n.ps-13 {\n  padding-inline-start: 52px !important;\n}\n\n.ps-14 {\n  padding-inline-start: 56px !important;\n}\n\n.ps-15 {\n  padding-inline-start: 60px !important;\n}\n\n.ps-16 {\n  padding-inline-start: 64px !important;\n}\n\n.pe-0 {\n  padding-inline-end: 0px !important;\n}\n\n.pe-1 {\n  padding-inline-end: 4px !important;\n}\n\n.pe-2 {\n  padding-inline-end: 8px !important;\n}\n\n.pe-3 {\n  padding-inline-end: 12px !important;\n}\n\n.pe-4 {\n  padding-inline-end: 16px !important;\n}\n\n.pe-5 {\n  padding-inline-end: 20px !important;\n}\n\n.pe-6 {\n  padding-inline-end: 24px !important;\n}\n\n.pe-7 {\n  padding-inline-end: 28px !important;\n}\n\n.pe-8 {\n  padding-inline-end: 32px !important;\n}\n\n.pe-9 {\n  padding-inline-end: 36px !important;\n}\n\n.pe-10 {\n  padding-inline-end: 40px !important;\n}\n\n.pe-11 {\n  padding-inline-end: 44px !important;\n}\n\n.pe-12 {\n  padding-inline-end: 48px !important;\n}\n\n.pe-13 {\n  padding-inline-end: 52px !important;\n}\n\n.pe-14 {\n  padding-inline-end: 56px !important;\n}\n\n.pe-15 {\n  padding-inline-end: 60px !important;\n}\n\n.pe-16 {\n  padding-inline-end: 64px !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-sm {\n  border-radius: 2px !important;\n}\n\n.rounded {\n  border-radius: 4px !important;\n}\n\n.rounded-lg {\n  border-radius: 8px !important;\n}\n\n.rounded-xl {\n  border-radius: 24px !important;\n}\n\n.rounded-pill {\n  border-radius: 9999px !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-shaped {\n  border-radius: 24px 0 !important;\n}\n\n.rounded-t-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-t-sm {\n  border-top-left-radius: 2px !important;\n  border-top-right-radius: 2px !important;\n}\n\n.rounded-t {\n  border-top-left-radius: 4px !important;\n  border-top-right-radius: 4px !important;\n}\n\n.rounded-t-lg {\n  border-top-left-radius: 8px !important;\n  border-top-right-radius: 8px !important;\n}\n\n.rounded-t-xl {\n  border-top-left-radius: 24px !important;\n  border-top-right-radius: 24px !important;\n}\n\n.rounded-t-pill {\n  border-top-left-radius: 9999px !important;\n  border-top-right-radius: 9999px !important;\n}\n\n.rounded-t-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-t-shaped {\n  border-top-left-radius: 24px !important;\n  border-top-right-radius: 0 !important;\n}\n\n.v-locale--is-ltr .rounded-e-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.v-locale--is-rtl .rounded-e-0 {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.v-locale--is-ltr .rounded-e-sm {\n  border-top-right-radius: 2px !important;\n  border-bottom-right-radius: 2px !important;\n}\n\n.v-locale--is-rtl .rounded-e-sm {\n  border-top-left-radius: 2px !important;\n  border-bottom-left-radius: 2px !important;\n}\n\n.v-locale--is-ltr .rounded-e {\n  border-top-right-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n}\n\n.v-locale--is-rtl .rounded-e {\n  border-top-left-radius: 4px !important;\n  border-bottom-left-radius: 4px !important;\n}\n\n.v-locale--is-ltr .rounded-e-lg {\n  border-top-right-radius: 8px !important;\n  border-bottom-right-radius: 8px !important;\n}\n\n.v-locale--is-rtl .rounded-e-lg {\n  border-top-left-radius: 8px !important;\n  border-bottom-left-radius: 8px !important;\n}\n\n.v-locale--is-ltr .rounded-e-xl {\n  border-top-right-radius: 24px !important;\n  border-bottom-right-radius: 24px !important;\n}\n\n.v-locale--is-rtl .rounded-e-xl {\n  border-top-left-radius: 24px !important;\n  border-bottom-left-radius: 24px !important;\n}\n\n.v-locale--is-ltr .rounded-e-pill {\n  border-top-right-radius: 9999px !important;\n  border-bottom-right-radius: 9999px !important;\n}\n\n.v-locale--is-rtl .rounded-e-pill {\n  border-top-left-radius: 9999px !important;\n  border-bottom-left-radius: 9999px !important;\n}\n\n.v-locale--is-ltr .rounded-e-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.v-locale--is-rtl .rounded-e-circle {\n  border-top-left-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.v-locale--is-ltr .rounded-e-shaped {\n  border-top-right-radius: 24px !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.v-locale--is-rtl .rounded-e-shaped {\n  border-top-left-radius: 24px !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-b-0 {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-b-sm {\n  border-bottom-left-radius: 2px !important;\n  border-bottom-right-radius: 2px !important;\n}\n\n.rounded-b {\n  border-bottom-left-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n}\n\n.rounded-b-lg {\n  border-bottom-left-radius: 8px !important;\n  border-bottom-right-radius: 8px !important;\n}\n\n.rounded-b-xl {\n  border-bottom-left-radius: 24px !important;\n  border-bottom-right-radius: 24px !important;\n}\n\n.rounded-b-pill {\n  border-bottom-left-radius: 9999px !important;\n  border-bottom-right-radius: 9999px !important;\n}\n\n.rounded-b-circle {\n  border-bottom-left-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-b-shaped {\n  border-bottom-left-radius: 24px !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.v-locale--is-ltr .rounded-s-0 {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.v-locale--is-rtl .rounded-s-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.v-locale--is-ltr .rounded-s-sm {\n  border-top-left-radius: 2px !important;\n  border-bottom-left-radius: 2px !important;\n}\n\n.v-locale--is-rtl .rounded-s-sm {\n  border-top-right-radius: 2px !important;\n  border-bottom-right-radius: 2px !important;\n}\n\n.v-locale--is-ltr .rounded-s {\n  border-top-left-radius: 4px !important;\n  border-bottom-left-radius: 4px !important;\n}\n\n.v-locale--is-rtl .rounded-s {\n  border-top-right-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n}\n\n.v-locale--is-ltr .rounded-s-lg {\n  border-top-left-radius: 8px !important;\n  border-bottom-left-radius: 8px !important;\n}\n\n.v-locale--is-rtl .rounded-s-lg {\n  border-top-right-radius: 8px !important;\n  border-bottom-right-radius: 8px !important;\n}\n\n.v-locale--is-ltr .rounded-s-xl {\n  border-top-left-radius: 24px !important;\n  border-bottom-left-radius: 24px !important;\n}\n\n.v-locale--is-rtl .rounded-s-xl {\n  border-top-right-radius: 24px !important;\n  border-bottom-right-radius: 24px !important;\n}\n\n.v-locale--is-ltr .rounded-s-pill {\n  border-top-left-radius: 9999px !important;\n  border-bottom-left-radius: 9999px !important;\n}\n\n.v-locale--is-rtl .rounded-s-pill {\n  border-top-right-radius: 9999px !important;\n  border-bottom-right-radius: 9999px !important;\n}\n\n.v-locale--is-ltr .rounded-s-circle {\n  border-top-left-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.v-locale--is-rtl .rounded-s-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.v-locale--is-ltr .rounded-s-shaped {\n  border-top-left-radius: 24px !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.v-locale--is-rtl .rounded-s-shaped {\n  border-top-right-radius: 24px !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.v-locale--is-ltr .rounded-ts-0 {\n  border-top-left-radius: 0 !important;\n}\n\n.v-locale--is-rtl .rounded-ts-0 {\n  border-top-right-radius: 0 !important;\n}\n\n.v-locale--is-ltr .rounded-ts-sm {\n  border-top-left-radius: 2px !important;\n}\n\n.v-locale--is-rtl .rounded-ts-sm {\n  border-top-right-radius: 2px !important;\n}\n\n.v-locale--is-ltr .rounded-ts {\n  border-top-left-radius: 4px !important;\n}\n\n.v-locale--is-rtl .rounded-ts {\n  border-top-right-radius: 4px !important;\n}\n\n.v-locale--is-ltr .rounded-ts-lg {\n  border-top-left-radius: 8px !important;\n}\n\n.v-locale--is-rtl .rounded-ts-lg {\n  border-top-right-radius: 8px !important;\n}\n\n.v-locale--is-ltr .rounded-ts-xl {\n  border-top-left-radius: 24px !important;\n}\n\n.v-locale--is-rtl .rounded-ts-xl {\n  border-top-right-radius: 24px !important;\n}\n\n.v-locale--is-ltr .rounded-ts-pill {\n  border-top-left-radius: 9999px !important;\n}\n\n.v-locale--is-rtl .rounded-ts-pill {\n  border-top-right-radius: 9999px !important;\n}\n\n.v-locale--is-ltr .rounded-ts-circle {\n  border-top-left-radius: 50% !important;\n}\n\n.v-locale--is-rtl .rounded-ts-circle {\n  border-top-right-radius: 50% !important;\n}\n\n.v-locale--is-ltr .rounded-ts-shaped {\n  border-top-left-radius: 24px 0 !important;\n}\n\n.v-locale--is-rtl .rounded-ts-shaped {\n  border-top-right-radius: 24px 0 !important;\n}\n\n.v-locale--is-ltr .rounded-te-0 {\n  border-top-right-radius: 0 !important;\n}\n\n.v-locale--is-rtl .rounded-te-0 {\n  border-top-left-radius: 0 !important;\n}\n\n.v-locale--is-ltr .rounded-te-sm {\n  border-top-right-radius: 2px !important;\n}\n\n.v-locale--is-rtl .rounded-te-sm {\n  border-top-left-radius: 2px !important;\n}\n\n.v-locale--is-ltr .rounded-te {\n  border-top-right-radius: 4px !important;\n}\n\n.v-locale--is-rtl .rounded-te {\n  border-top-left-radius: 4px !important;\n}\n\n.v-locale--is-ltr .rounded-te-lg {\n  border-top-right-radius: 8px !important;\n}\n\n.v-locale--is-rtl .rounded-te-lg {\n  border-top-left-radius: 8px !important;\n}\n\n.v-locale--is-ltr .rounded-te-xl {\n  border-top-right-radius: 24px !important;\n}\n\n.v-locale--is-rtl .rounded-te-xl {\n  border-top-left-radius: 24px !important;\n}\n\n.v-locale--is-ltr .rounded-te-pill {\n  border-top-right-radius: 9999px !important;\n}\n\n.v-locale--is-rtl .rounded-te-pill {\n  border-top-left-radius: 9999px !important;\n}\n\n.v-locale--is-ltr .rounded-te-circle {\n  border-top-right-radius: 50% !important;\n}\n\n.v-locale--is-rtl .rounded-te-circle {\n  border-top-left-radius: 50% !important;\n}\n\n.v-locale--is-ltr .rounded-te-shaped {\n  border-top-right-radius: 24px 0 !important;\n}\n\n.v-locale--is-rtl .rounded-te-shaped {\n  border-top-left-radius: 24px 0 !important;\n}\n\n.v-locale--is-ltr .rounded-be-0 {\n  border-bottom-right-radius: 0 !important;\n}\n\n.v-locale--is-rtl .rounded-be-0 {\n  border-bottom-left-radius: 0 !important;\n}\n\n.v-locale--is-ltr .rounded-be-sm {\n  border-bottom-right-radius: 2px !important;\n}\n\n.v-locale--is-rtl .rounded-be-sm {\n  border-bottom-left-radius: 2px !important;\n}\n\n.v-locale--is-ltr .rounded-be {\n  border-bottom-right-radius: 4px !important;\n}\n\n.v-locale--is-rtl .rounded-be {\n  border-bottom-left-radius: 4px !important;\n}\n\n.v-locale--is-ltr .rounded-be-lg {\n  border-bottom-right-radius: 8px !important;\n}\n\n.v-locale--is-rtl .rounded-be-lg {\n  border-bottom-left-radius: 8px !important;\n}\n\n.v-locale--is-ltr .rounded-be-xl {\n  border-bottom-right-radius: 24px !important;\n}\n\n.v-locale--is-rtl .rounded-be-xl {\n  border-bottom-left-radius: 24px !important;\n}\n\n.v-locale--is-ltr .rounded-be-pill {\n  border-bottom-right-radius: 9999px !important;\n}\n\n.v-locale--is-rtl .rounded-be-pill {\n  border-bottom-left-radius: 9999px !important;\n}\n\n.v-locale--is-ltr .rounded-be-circle {\n  border-bottom-right-radius: 50% !important;\n}\n\n.v-locale--is-rtl .rounded-be-circle {\n  border-bottom-left-radius: 50% !important;\n}\n\n.v-locale--is-ltr .rounded-be-shaped {\n  border-bottom-right-radius: 24px 0 !important;\n}\n\n.v-locale--is-rtl .rounded-be-shaped {\n  border-bottom-left-radius: 24px 0 !important;\n}\n\n.v-locale--is-ltr .rounded-bs-0 {\n  border-bottom-left-radius: 0 !important;\n}\n\n.v-locale--is-rtl .rounded-bs-0 {\n  border-bottom-right-radius: 0 !important;\n}\n\n.v-locale--is-ltr .rounded-bs-sm {\n  border-bottom-left-radius: 2px !important;\n}\n\n.v-locale--is-rtl .rounded-bs-sm {\n  border-bottom-right-radius: 2px !important;\n}\n\n.v-locale--is-ltr .rounded-bs {\n  border-bottom-left-radius: 4px !important;\n}\n\n.v-locale--is-rtl .rounded-bs {\n  border-bottom-right-radius: 4px !important;\n}\n\n.v-locale--is-ltr .rounded-bs-lg {\n  border-bottom-left-radius: 8px !important;\n}\n\n.v-locale--is-rtl .rounded-bs-lg {\n  border-bottom-right-radius: 8px !important;\n}\n\n.v-locale--is-ltr .rounded-bs-xl {\n  border-bottom-left-radius: 24px !important;\n}\n\n.v-locale--is-rtl .rounded-bs-xl {\n  border-bottom-right-radius: 24px !important;\n}\n\n.v-locale--is-ltr .rounded-bs-pill {\n  border-bottom-left-radius: 9999px !important;\n}\n\n.v-locale--is-rtl .rounded-bs-pill {\n  border-bottom-right-radius: 9999px !important;\n}\n\n.v-locale--is-ltr .rounded-bs-circle {\n  border-bottom-left-radius: 50% !important;\n}\n\n.v-locale--is-rtl .rounded-bs-circle {\n  border-bottom-right-radius: 50% !important;\n}\n\n.v-locale--is-ltr .rounded-bs-shaped {\n  border-bottom-left-radius: 24px 0 !important;\n}\n\n.v-locale--is-rtl .rounded-bs-shaped {\n  border-bottom-right-radius: 24px 0 !important;\n}\n\n.border-0 {\n  border-width: 0 !important;\n  border-style: solid !important;\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border {\n  border-width: thin !important;\n  border-style: solid !important;\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-thin {\n  border-width: thin !important;\n  border-style: solid !important;\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-sm {\n  border-width: 1px !important;\n  border-style: solid !important;\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-md {\n  border-width: 2px !important;\n  border-style: solid !important;\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-lg {\n  border-width: 4px !important;\n  border-style: solid !important;\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-xl {\n  border-width: 8px !important;\n  border-style: solid !important;\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-current {\n  border-color: currentColor !important;\n}\n\n.border-opacity-0 {\n  --v-border-opacity: 0 !important;\n}\n\n.border-opacity {\n  --v-border-opacity: 0.12 !important;\n}\n\n.border-opacity-25 {\n  --v-border-opacity: 0.25 !important;\n}\n\n.border-opacity-50 {\n  --v-border-opacity: 0.5 !important;\n}\n\n.border-opacity-75 {\n  --v-border-opacity: 0.75 !important;\n}\n\n.border-opacity-100 {\n  --v-border-opacity: 1 !important;\n}\n\n.border-t-0 {\n  border-block-start-width: 0 !important;\n  border-block-start-style: solid !important;\n  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-t {\n  border-block-start-width: thin !important;\n  border-block-start-style: solid !important;\n  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-t-thin {\n  border-block-start-width: thin !important;\n  border-block-start-style: solid !important;\n  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-t-sm {\n  border-block-start-width: 1px !important;\n  border-block-start-style: solid !important;\n  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-t-md {\n  border-block-start-width: 2px !important;\n  border-block-start-style: solid !important;\n  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-t-lg {\n  border-block-start-width: 4px !important;\n  border-block-start-style: solid !important;\n  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-t-xl {\n  border-block-start-width: 8px !important;\n  border-block-start-style: solid !important;\n  border-block-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-e-0 {\n  border-inline-end-width: 0 !important;\n  border-inline-end-style: solid !important;\n  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-e {\n  border-inline-end-width: thin !important;\n  border-inline-end-style: solid !important;\n  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-e-thin {\n  border-inline-end-width: thin !important;\n  border-inline-end-style: solid !important;\n  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-e-sm {\n  border-inline-end-width: 1px !important;\n  border-inline-end-style: solid !important;\n  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-e-md {\n  border-inline-end-width: 2px !important;\n  border-inline-end-style: solid !important;\n  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-e-lg {\n  border-inline-end-width: 4px !important;\n  border-inline-end-style: solid !important;\n  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-e-xl {\n  border-inline-end-width: 8px !important;\n  border-inline-end-style: solid !important;\n  border-inline-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-b-0 {\n  border-block-end-width: 0 !important;\n  border-block-end-style: solid !important;\n  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-b {\n  border-block-end-width: thin !important;\n  border-block-end-style: solid !important;\n  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-b-thin {\n  border-block-end-width: thin !important;\n  border-block-end-style: solid !important;\n  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-b-sm {\n  border-block-end-width: 1px !important;\n  border-block-end-style: solid !important;\n  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-b-md {\n  border-block-end-width: 2px !important;\n  border-block-end-style: solid !important;\n  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-b-lg {\n  border-block-end-width: 4px !important;\n  border-block-end-style: solid !important;\n  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-b-xl {\n  border-block-end-width: 8px !important;\n  border-block-end-style: solid !important;\n  border-block-end-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-s-0 {\n  border-inline-start-width: 0 !important;\n  border-inline-start-style: solid !important;\n  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-s {\n  border-inline-start-width: thin !important;\n  border-inline-start-style: solid !important;\n  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-s-thin {\n  border-inline-start-width: thin !important;\n  border-inline-start-style: solid !important;\n  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-s-sm {\n  border-inline-start-width: 1px !important;\n  border-inline-start-style: solid !important;\n  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-s-md {\n  border-inline-start-width: 2px !important;\n  border-inline-start-style: solid !important;\n  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-s-lg {\n  border-inline-start-width: 4px !important;\n  border-inline-start-style: solid !important;\n  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-s-xl {\n  border-inline-start-width: 8px !important;\n  border-inline-start-style: solid !important;\n  border-inline-start-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;\n}\n\n.border-solid {\n  border-style: solid !important;\n}\n\n.border-dashed {\n  border-style: dashed !important;\n}\n\n.border-dotted {\n  border-style: dotted !important;\n}\n\n.border-double {\n  border-style: double !important;\n}\n\n.border-none {\n  border-style: none !important;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-justify {\n  text-align: justify !important;\n}\n\n.text-start {\n  text-align: start !important;\n}\n\n.text-end {\n  text-align: end !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-overline {\n  text-decoration: overline !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-no-wrap {\n  white-space: nowrap !important;\n}\n\n.text-pre {\n  white-space: pre !important;\n}\n\n.text-pre-line {\n  white-space: pre-line !important;\n}\n\n.text-pre-wrap {\n  white-space: pre-wrap !important;\n}\n\n.text-break {\n  overflow-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n.opacity-hover {\n  opacity: var(--v-hover-opacity) !important;\n}\n\n.opacity-focus {\n  opacity: var(--v-focus-opacity) !important;\n}\n\n.opacity-selected {\n  opacity: var(--v-selected-opacity) !important;\n}\n\n.opacity-activated {\n  opacity: var(--v-activated-opacity) !important;\n}\n\n.opacity-pressed {\n  opacity: var(--v-pressed-opacity) !important;\n}\n\n.opacity-dragged {\n  opacity: var(--v-dragged-opacity) !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-10 {\n  opacity: 0.1 !important;\n}\n\n.opacity-20 {\n  opacity: 0.2 !important;\n}\n\n.opacity-30 {\n  opacity: 0.3 !important;\n}\n\n.opacity-40 {\n  opacity: 0.4 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-60 {\n  opacity: 0.6 !important;\n}\n\n.opacity-70 {\n  opacity: 0.7 !important;\n}\n\n.opacity-80 {\n  opacity: 0.8 !important;\n}\n\n.opacity-90 {\n  opacity: 0.9 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.text-high-emphasis {\n  color: rgba(var(--v-theme-on-background), var(--v-high-emphasis-opacity)) !important;\n}\n\n.text-medium-emphasis {\n  color: rgba(var(--v-theme-on-background), var(--v-medium-emphasis-opacity)) !important;\n}\n\n.text-disabled {\n  color: rgba(var(--v-theme-on-background), var(--v-disabled-opacity)) !important;\n}\n\n.text-truncate {\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n.text-h1 {\n  font-size: 6rem !important;\n  font-weight: 300;\n  line-height: 1;\n  letter-spacing: -0.015625em !important;\n  font-family: \"Roboto\", sans-serif;\n  text-transform: none !important;\n}\n\n.text-h2 {\n  font-size: 3.75rem !important;\n  font-weight: 300;\n  line-height: 1;\n  letter-spacing: -0.0083333333em !important;\n  font-family: \"Roboto\", sans-serif;\n  text-transform: none !important;\n}\n\n.text-h3 {\n  font-size: 3rem !important;\n  font-weight: 400;\n  line-height: 1.05;\n  letter-spacing: normal !important;\n  font-family: \"Roboto\", sans-serif;\n  text-transform: none !important;\n}\n\n.text-h4 {\n  font-size: 2.125rem !important;\n  font-weight: 400;\n  line-height: 1.175;\n  letter-spacing: 0.0073529412em !important;\n  font-family: \"Roboto\", sans-serif;\n  text-transform: none !important;\n}\n\n.text-h5 {\n  font-size: 1.5rem !important;\n  font-weight: 400;\n  line-height: 1.333;\n  letter-spacing: normal !important;\n  font-family: \"Roboto\", sans-serif;\n  text-transform: none !important;\n}\n\n.text-h6 {\n  font-size: 1.25rem !important;\n  font-weight: 500;\n  line-height: 1.6;\n  letter-spacing: 0.0125em !important;\n  font-family: \"Roboto\", sans-serif;\n  text-transform: none !important;\n}\n\n.text-subtitle-1 {\n  font-size: 1rem !important;\n  font-weight: normal;\n  line-height: 1.75;\n  letter-spacing: 0.009375em !important;\n  font-family: \"Roboto\", sans-serif;\n  text-transform: none !important;\n}\n\n.text-subtitle-2 {\n  font-size: 0.875rem !important;\n  font-weight: 500;\n  line-height: 1.6;\n  letter-spacing: 0.0071428571em !important;\n  font-family: \"Roboto\", sans-serif;\n  text-transform: none !important;\n}\n\n.text-body-1 {\n  font-size: 1rem !important;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: 0.03125em !important;\n  font-family: \"Roboto\", sans-serif;\n  text-transform: none !important;\n}\n\n.text-body-2 {\n  font-size: 0.875rem !important;\n  font-weight: 400;\n  line-height: 1.425;\n  letter-spacing: 0.0178571429em !important;\n  font-family: \"Roboto\", sans-serif;\n  text-transform: none !important;\n}\n\n.text-button {\n  font-size: 0.875rem !important;\n  font-weight: 500;\n  line-height: 2.6;\n  letter-spacing: 0.0892857143em !important;\n  font-family: \"Roboto\", sans-serif;\n  text-transform: uppercase !important;\n}\n\n.text-caption {\n  font-size: 0.75rem !important;\n  font-weight: 400;\n  line-height: 1.667;\n  letter-spacing: 0.0333333333em !important;\n  font-family: \"Roboto\", sans-serif;\n  text-transform: none !important;\n}\n\n.text-overline {\n  font-size: 0.75rem !important;\n  font-weight: 500;\n  line-height: 2.667;\n  letter-spacing: 0.1666666667em !important;\n  font-family: \"Roboto\", sans-serif;\n  text-transform: uppercase !important;\n}\n\n.text-none {\n  text-transform: none !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.font-weight-thin {\n  font-weight: 100 !important;\n}\n\n.font-weight-light {\n  font-weight: 300 !important;\n}\n\n.font-weight-regular {\n  font-weight: 400 !important;\n}\n\n.font-weight-medium {\n  font-weight: 500 !important;\n}\n\n.font-weight-semibold {\n  font-weight: 600 !important;\n}\n\n.font-weight-bold {\n  font-weight: 700 !important;\n}\n\n.font-weight-black {\n  font-weight: 900 !important;\n}\n\n.font-italic {\n  font-style: italic !important;\n}\n\n.text-mono {\n  font-family: monospace !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.right-0 {\n  right: 0 !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.left-0 {\n  left: 0 !important;\n}\n\n.cursor-auto {\n  cursor: auto !important;\n}\n\n.cursor-default {\n  cursor: default !important;\n}\n\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.cursor-wait {\n  cursor: wait !important;\n}\n\n.cursor-text {\n  cursor: text !important;\n}\n\n.cursor-move {\n  cursor: move !important;\n}\n\n.cursor-help {\n  cursor: help !important;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n.cursor-progress {\n  cursor: progress !important;\n}\n\n.cursor-grab {\n  cursor: grab !important;\n}\n\n.cursor-grabbing {\n  cursor: grabbing !important;\n}\n\n.cursor-none {\n  cursor: none !important;\n}\n\n.fill-height {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.h-screen {\n  height: 100vh !important;\n}\n\n.h-0 {\n  height: 0 !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-screen {\n  height: 100dvh !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.w-0 {\n  width: 0 !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-33 {\n  width: 33% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-66 {\n  width: 66% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n@media (min-width: 600px) {\n  .d-sm-none {\n    display: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .float-sm-left {\n    float: left !important;\n  }\n  .float-sm-right {\n    float: right !important;\n  }\n  .v-locale--is-rtl .float-sm-end {\n    float: left !important;\n  }\n  .v-locale--is-rtl .float-sm-start {\n    float: right !important;\n  }\n  .v-locale--is-ltr .float-sm-end {\n    float: right !important;\n  }\n  .v-locale--is-ltr .float-sm-start {\n    float: left !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-1-1 {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-1-0 {\n    flex: 1 0 auto !important;\n  }\n  .flex-sm-0-1 {\n    flex: 0 1 auto !important;\n  }\n  .flex-sm-0-0 {\n    flex: 0 0 auto !important;\n  }\n  .flex-sm-1-1-100 {\n    flex: 1 1 100% !important;\n  }\n  .flex-sm-1-0-100 {\n    flex: 1 0 100% !important;\n  }\n  .flex-sm-0-1-100 {\n    flex: 0 1 100% !important;\n  }\n  .flex-sm-0-0-100 {\n    flex: 0 0 100% !important;\n  }\n  .flex-sm-1-1-0 {\n    flex: 1 1 0 !important;\n  }\n  .flex-sm-1-0-0 {\n    flex: 1 0 0 !important;\n  }\n  .flex-sm-0-1-0 {\n    flex: 0 1 0 !important;\n  }\n  .flex-sm-0-0-0 {\n    flex: 0 0 0 !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-sm-center {\n    justify-content: center !important;\n  }\n  .justify-sm-space-between {\n    justify-content: space-between !important;\n  }\n  .justify-sm-space-around {\n    justify-content: space-around !important;\n  }\n  .justify-sm-space-evenly {\n    justify-content: space-evenly !important;\n  }\n  .justify-items-sm-start {\n    justify-items: flex-start !important;\n  }\n  .justify-items-sm-end {\n    justify-items: flex-end !important;\n  }\n  .justify-items-sm-center {\n    justify-items: center !important;\n  }\n  .justify-items-sm-stretch {\n    justify-items: stretch !important;\n  }\n  .align-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-sm-center {\n    align-items: center !important;\n  }\n  .align-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-space-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-space-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-space-evenly {\n    align-content: space-evenly !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-6 {\n    order: 6 !important;\n  }\n  .order-sm-7 {\n    order: 7 !important;\n  }\n  .order-sm-8 {\n    order: 8 !important;\n  }\n  .order-sm-9 {\n    order: 9 !important;\n  }\n  .order-sm-10 {\n    order: 10 !important;\n  }\n  .order-sm-11 {\n    order: 11 !important;\n  }\n  .order-sm-12 {\n    order: 12 !important;\n  }\n  .order-sm-last {\n    order: 13 !important;\n  }\n  .ga-sm-0 {\n    gap: 0px !important;\n  }\n  .ga-sm-1 {\n    gap: 4px !important;\n  }\n  .ga-sm-2 {\n    gap: 8px !important;\n  }\n  .ga-sm-3 {\n    gap: 12px !important;\n  }\n  .ga-sm-4 {\n    gap: 16px !important;\n  }\n  .ga-sm-5 {\n    gap: 20px !important;\n  }\n  .ga-sm-6 {\n    gap: 24px !important;\n  }\n  .ga-sm-7 {\n    gap: 28px !important;\n  }\n  .ga-sm-8 {\n    gap: 32px !important;\n  }\n  .ga-sm-9 {\n    gap: 36px !important;\n  }\n  .ga-sm-10 {\n    gap: 40px !important;\n  }\n  .ga-sm-11 {\n    gap: 44px !important;\n  }\n  .ga-sm-12 {\n    gap: 48px !important;\n  }\n  .ga-sm-13 {\n    gap: 52px !important;\n  }\n  .ga-sm-14 {\n    gap: 56px !important;\n  }\n  .ga-sm-15 {\n    gap: 60px !important;\n  }\n  .ga-sm-16 {\n    gap: 64px !important;\n  }\n  .ga-sm-auto {\n    gap: auto !important;\n  }\n  .gr-sm-0 {\n    row-gap: 0px !important;\n  }\n  .gr-sm-1 {\n    row-gap: 4px !important;\n  }\n  .gr-sm-2 {\n    row-gap: 8px !important;\n  }\n  .gr-sm-3 {\n    row-gap: 12px !important;\n  }\n  .gr-sm-4 {\n    row-gap: 16px !important;\n  }\n  .gr-sm-5 {\n    row-gap: 20px !important;\n  }\n  .gr-sm-6 {\n    row-gap: 24px !important;\n  }\n  .gr-sm-7 {\n    row-gap: 28px !important;\n  }\n  .gr-sm-8 {\n    row-gap: 32px !important;\n  }\n  .gr-sm-9 {\n    row-gap: 36px !important;\n  }\n  .gr-sm-10 {\n    row-gap: 40px !important;\n  }\n  .gr-sm-11 {\n    row-gap: 44px !important;\n  }\n  .gr-sm-12 {\n    row-gap: 48px !important;\n  }\n  .gr-sm-13 {\n    row-gap: 52px !important;\n  }\n  .gr-sm-14 {\n    row-gap: 56px !important;\n  }\n  .gr-sm-15 {\n    row-gap: 60px !important;\n  }\n  .gr-sm-16 {\n    row-gap: 64px !important;\n  }\n  .gr-sm-auto {\n    row-gap: auto !important;\n  }\n  .gc-sm-0 {\n    column-gap: 0px !important;\n  }\n  .gc-sm-1 {\n    column-gap: 4px !important;\n  }\n  .gc-sm-2 {\n    column-gap: 8px !important;\n  }\n  .gc-sm-3 {\n    column-gap: 12px !important;\n  }\n  .gc-sm-4 {\n    column-gap: 16px !important;\n  }\n  .gc-sm-5 {\n    column-gap: 20px !important;\n  }\n  .gc-sm-6 {\n    column-gap: 24px !important;\n  }\n  .gc-sm-7 {\n    column-gap: 28px !important;\n  }\n  .gc-sm-8 {\n    column-gap: 32px !important;\n  }\n  .gc-sm-9 {\n    column-gap: 36px !important;\n  }\n  .gc-sm-10 {\n    column-gap: 40px !important;\n  }\n  .gc-sm-11 {\n    column-gap: 44px !important;\n  }\n  .gc-sm-12 {\n    column-gap: 48px !important;\n  }\n  .gc-sm-13 {\n    column-gap: 52px !important;\n  }\n  .gc-sm-14 {\n    column-gap: 56px !important;\n  }\n  .gc-sm-15 {\n    column-gap: 60px !important;\n  }\n  .gc-sm-16 {\n    column-gap: 64px !important;\n  }\n  .gc-sm-auto {\n    column-gap: auto !important;\n  }\n  .ma-sm-0 {\n    margin: 0px !important;\n  }\n  .ma-sm-1 {\n    margin: 4px !important;\n  }\n  .ma-sm-2 {\n    margin: 8px !important;\n  }\n  .ma-sm-3 {\n    margin: 12px !important;\n  }\n  .ma-sm-4 {\n    margin: 16px !important;\n  }\n  .ma-sm-5 {\n    margin: 20px !important;\n  }\n  .ma-sm-6 {\n    margin: 24px !important;\n  }\n  .ma-sm-7 {\n    margin: 28px !important;\n  }\n  .ma-sm-8 {\n    margin: 32px !important;\n  }\n  .ma-sm-9 {\n    margin: 36px !important;\n  }\n  .ma-sm-10 {\n    margin: 40px !important;\n  }\n  .ma-sm-11 {\n    margin: 44px !important;\n  }\n  .ma-sm-12 {\n    margin: 48px !important;\n  }\n  .ma-sm-13 {\n    margin: 52px !important;\n  }\n  .ma-sm-14 {\n    margin: 56px !important;\n  }\n  .ma-sm-15 {\n    margin: 60px !important;\n  }\n  .ma-sm-16 {\n    margin: 64px !important;\n  }\n  .ma-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0px !important;\n    margin-left: 0px !important;\n  }\n  .mx-sm-1 {\n    margin-right: 4px !important;\n    margin-left: 4px !important;\n  }\n  .mx-sm-2 {\n    margin-right: 8px !important;\n    margin-left: 8px !important;\n  }\n  .mx-sm-3 {\n    margin-right: 12px !important;\n    margin-left: 12px !important;\n  }\n  .mx-sm-4 {\n    margin-right: 16px !important;\n    margin-left: 16px !important;\n  }\n  .mx-sm-5 {\n    margin-right: 20px !important;\n    margin-left: 20px !important;\n  }\n  .mx-sm-6 {\n    margin-right: 24px !important;\n    margin-left: 24px !important;\n  }\n  .mx-sm-7 {\n    margin-right: 28px !important;\n    margin-left: 28px !important;\n  }\n  .mx-sm-8 {\n    margin-right: 32px !important;\n    margin-left: 32px !important;\n  }\n  .mx-sm-9 {\n    margin-right: 36px !important;\n    margin-left: 36px !important;\n  }\n  .mx-sm-10 {\n    margin-right: 40px !important;\n    margin-left: 40px !important;\n  }\n  .mx-sm-11 {\n    margin-right: 44px !important;\n    margin-left: 44px !important;\n  }\n  .mx-sm-12 {\n    margin-right: 48px !important;\n    margin-left: 48px !important;\n  }\n  .mx-sm-13 {\n    margin-right: 52px !important;\n    margin-left: 52px !important;\n  }\n  .mx-sm-14 {\n    margin-right: 56px !important;\n    margin-left: 56px !important;\n  }\n  .mx-sm-15 {\n    margin-right: 60px !important;\n    margin-left: 60px !important;\n  }\n  .mx-sm-16 {\n    margin-right: 64px !important;\n    margin-left: 64px !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n  .my-sm-1 {\n    margin-top: 4px !important;\n    margin-bottom: 4px !important;\n  }\n  .my-sm-2 {\n    margin-top: 8px !important;\n    margin-bottom: 8px !important;\n  }\n  .my-sm-3 {\n    margin-top: 12px !important;\n    margin-bottom: 12px !important;\n  }\n  .my-sm-4 {\n    margin-top: 16px !important;\n    margin-bottom: 16px !important;\n  }\n  .my-sm-5 {\n    margin-top: 20px !important;\n    margin-bottom: 20px !important;\n  }\n  .my-sm-6 {\n    margin-top: 24px !important;\n    margin-bottom: 24px !important;\n  }\n  .my-sm-7 {\n    margin-top: 28px !important;\n    margin-bottom: 28px !important;\n  }\n  .my-sm-8 {\n    margin-top: 32px !important;\n    margin-bottom: 32px !important;\n  }\n  .my-sm-9 {\n    margin-top: 36px !important;\n    margin-bottom: 36px !important;\n  }\n  .my-sm-10 {\n    margin-top: 40px !important;\n    margin-bottom: 40px !important;\n  }\n  .my-sm-11 {\n    margin-top: 44px !important;\n    margin-bottom: 44px !important;\n  }\n  .my-sm-12 {\n    margin-top: 48px !important;\n    margin-bottom: 48px !important;\n  }\n  .my-sm-13 {\n    margin-top: 52px !important;\n    margin-bottom: 52px !important;\n  }\n  .my-sm-14 {\n    margin-top: 56px !important;\n    margin-bottom: 56px !important;\n  }\n  .my-sm-15 {\n    margin-top: 60px !important;\n    margin-bottom: 60px !important;\n  }\n  .my-sm-16 {\n    margin-top: 64px !important;\n    margin-bottom: 64px !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0px !important;\n  }\n  .mt-sm-1 {\n    margin-top: 4px !important;\n  }\n  .mt-sm-2 {\n    margin-top: 8px !important;\n  }\n  .mt-sm-3 {\n    margin-top: 12px !important;\n  }\n  .mt-sm-4 {\n    margin-top: 16px !important;\n  }\n  .mt-sm-5 {\n    margin-top: 20px !important;\n  }\n  .mt-sm-6 {\n    margin-top: 24px !important;\n  }\n  .mt-sm-7 {\n    margin-top: 28px !important;\n  }\n  .mt-sm-8 {\n    margin-top: 32px !important;\n  }\n  .mt-sm-9 {\n    margin-top: 36px !important;\n  }\n  .mt-sm-10 {\n    margin-top: 40px !important;\n  }\n  .mt-sm-11 {\n    margin-top: 44px !important;\n  }\n  .mt-sm-12 {\n    margin-top: 48px !important;\n  }\n  .mt-sm-13 {\n    margin-top: 52px !important;\n  }\n  .mt-sm-14 {\n    margin-top: 56px !important;\n  }\n  .mt-sm-15 {\n    margin-top: 60px !important;\n  }\n  .mt-sm-16 {\n    margin-top: 64px !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .mr-sm-0 {\n    margin-right: 0px !important;\n  }\n  .mr-sm-1 {\n    margin-right: 4px !important;\n  }\n  .mr-sm-2 {\n    margin-right: 8px !important;\n  }\n  .mr-sm-3 {\n    margin-right: 12px !important;\n  }\n  .mr-sm-4 {\n    margin-right: 16px !important;\n  }\n  .mr-sm-5 {\n    margin-right: 20px !important;\n  }\n  .mr-sm-6 {\n    margin-right: 24px !important;\n  }\n  .mr-sm-7 {\n    margin-right: 28px !important;\n  }\n  .mr-sm-8 {\n    margin-right: 32px !important;\n  }\n  .mr-sm-9 {\n    margin-right: 36px !important;\n  }\n  .mr-sm-10 {\n    margin-right: 40px !important;\n  }\n  .mr-sm-11 {\n    margin-right: 44px !important;\n  }\n  .mr-sm-12 {\n    margin-right: 48px !important;\n  }\n  .mr-sm-13 {\n    margin-right: 52px !important;\n  }\n  .mr-sm-14 {\n    margin-right: 56px !important;\n  }\n  .mr-sm-15 {\n    margin-right: 60px !important;\n  }\n  .mr-sm-16 {\n    margin-right: 64px !important;\n  }\n  .mr-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0px !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 4px !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 8px !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 12px !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 16px !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 20px !important;\n  }\n  .mb-sm-6 {\n    margin-bottom: 24px !important;\n  }\n  .mb-sm-7 {\n    margin-bottom: 28px !important;\n  }\n  .mb-sm-8 {\n    margin-bottom: 32px !important;\n  }\n  .mb-sm-9 {\n    margin-bottom: 36px !important;\n  }\n  .mb-sm-10 {\n    margin-bottom: 40px !important;\n  }\n  .mb-sm-11 {\n    margin-bottom: 44px !important;\n  }\n  .mb-sm-12 {\n    margin-bottom: 48px !important;\n  }\n  .mb-sm-13 {\n    margin-bottom: 52px !important;\n  }\n  .mb-sm-14 {\n    margin-bottom: 56px !important;\n  }\n  .mb-sm-15 {\n    margin-bottom: 60px !important;\n  }\n  .mb-sm-16 {\n    margin-bottom: 64px !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-sm-0 {\n    margin-left: 0px !important;\n  }\n  .ml-sm-1 {\n    margin-left: 4px !important;\n  }\n  .ml-sm-2 {\n    margin-left: 8px !important;\n  }\n  .ml-sm-3 {\n    margin-left: 12px !important;\n  }\n  .ml-sm-4 {\n    margin-left: 16px !important;\n  }\n  .ml-sm-5 {\n    margin-left: 20px !important;\n  }\n  .ml-sm-6 {\n    margin-left: 24px !important;\n  }\n  .ml-sm-7 {\n    margin-left: 28px !important;\n  }\n  .ml-sm-8 {\n    margin-left: 32px !important;\n  }\n  .ml-sm-9 {\n    margin-left: 36px !important;\n  }\n  .ml-sm-10 {\n    margin-left: 40px !important;\n  }\n  .ml-sm-11 {\n    margin-left: 44px !important;\n  }\n  .ml-sm-12 {\n    margin-left: 48px !important;\n  }\n  .ml-sm-13 {\n    margin-left: 52px !important;\n  }\n  .ml-sm-14 {\n    margin-left: 56px !important;\n  }\n  .ml-sm-15 {\n    margin-left: 60px !important;\n  }\n  .ml-sm-16 {\n    margin-left: 64px !important;\n  }\n  .ml-sm-auto {\n    margin-left: auto !important;\n  }\n  .ms-sm-0 {\n    margin-inline-start: 0px !important;\n  }\n  .ms-sm-1 {\n    margin-inline-start: 4px !important;\n  }\n  .ms-sm-2 {\n    margin-inline-start: 8px !important;\n  }\n  .ms-sm-3 {\n    margin-inline-start: 12px !important;\n  }\n  .ms-sm-4 {\n    margin-inline-start: 16px !important;\n  }\n  .ms-sm-5 {\n    margin-inline-start: 20px !important;\n  }\n  .ms-sm-6 {\n    margin-inline-start: 24px !important;\n  }\n  .ms-sm-7 {\n    margin-inline-start: 28px !important;\n  }\n  .ms-sm-8 {\n    margin-inline-start: 32px !important;\n  }\n  .ms-sm-9 {\n    margin-inline-start: 36px !important;\n  }\n  .ms-sm-10 {\n    margin-inline-start: 40px !important;\n  }\n  .ms-sm-11 {\n    margin-inline-start: 44px !important;\n  }\n  .ms-sm-12 {\n    margin-inline-start: 48px !important;\n  }\n  .ms-sm-13 {\n    margin-inline-start: 52px !important;\n  }\n  .ms-sm-14 {\n    margin-inline-start: 56px !important;\n  }\n  .ms-sm-15 {\n    margin-inline-start: 60px !important;\n  }\n  .ms-sm-16 {\n    margin-inline-start: 64px !important;\n  }\n  .ms-sm-auto {\n    margin-inline-start: auto !important;\n  }\n  .me-sm-0 {\n    margin-inline-end: 0px !important;\n  }\n  .me-sm-1 {\n    margin-inline-end: 4px !important;\n  }\n  .me-sm-2 {\n    margin-inline-end: 8px !important;\n  }\n  .me-sm-3 {\n    margin-inline-end: 12px !important;\n  }\n  .me-sm-4 {\n    margin-inline-end: 16px !important;\n  }\n  .me-sm-5 {\n    margin-inline-end: 20px !important;\n  }\n  .me-sm-6 {\n    margin-inline-end: 24px !important;\n  }\n  .me-sm-7 {\n    margin-inline-end: 28px !important;\n  }\n  .me-sm-8 {\n    margin-inline-end: 32px !important;\n  }\n  .me-sm-9 {\n    margin-inline-end: 36px !important;\n  }\n  .me-sm-10 {\n    margin-inline-end: 40px !important;\n  }\n  .me-sm-11 {\n    margin-inline-end: 44px !important;\n  }\n  .me-sm-12 {\n    margin-inline-end: 48px !important;\n  }\n  .me-sm-13 {\n    margin-inline-end: 52px !important;\n  }\n  .me-sm-14 {\n    margin-inline-end: 56px !important;\n  }\n  .me-sm-15 {\n    margin-inline-end: 60px !important;\n  }\n  .me-sm-16 {\n    margin-inline-end: 64px !important;\n  }\n  .me-sm-auto {\n    margin-inline-end: auto !important;\n  }\n  .ma-sm-n1 {\n    margin: -4px !important;\n  }\n  .ma-sm-n2 {\n    margin: -8px !important;\n  }\n  .ma-sm-n3 {\n    margin: -12px !important;\n  }\n  .ma-sm-n4 {\n    margin: -16px !important;\n  }\n  .ma-sm-n5 {\n    margin: -20px !important;\n  }\n  .ma-sm-n6 {\n    margin: -24px !important;\n  }\n  .ma-sm-n7 {\n    margin: -28px !important;\n  }\n  .ma-sm-n8 {\n    margin: -32px !important;\n  }\n  .ma-sm-n9 {\n    margin: -36px !important;\n  }\n  .ma-sm-n10 {\n    margin: -40px !important;\n  }\n  .ma-sm-n11 {\n    margin: -44px !important;\n  }\n  .ma-sm-n12 {\n    margin: -48px !important;\n  }\n  .ma-sm-n13 {\n    margin: -52px !important;\n  }\n  .ma-sm-n14 {\n    margin: -56px !important;\n  }\n  .ma-sm-n15 {\n    margin: -60px !important;\n  }\n  .ma-sm-n16 {\n    margin: -64px !important;\n  }\n  .mx-sm-n1 {\n    margin-right: -4px !important;\n    margin-left: -4px !important;\n  }\n  .mx-sm-n2 {\n    margin-right: -8px !important;\n    margin-left: -8px !important;\n  }\n  .mx-sm-n3 {\n    margin-right: -12px !important;\n    margin-left: -12px !important;\n  }\n  .mx-sm-n4 {\n    margin-right: -16px !important;\n    margin-left: -16px !important;\n  }\n  .mx-sm-n5 {\n    margin-right: -20px !important;\n    margin-left: -20px !important;\n  }\n  .mx-sm-n6 {\n    margin-right: -24px !important;\n    margin-left: -24px !important;\n  }\n  .mx-sm-n7 {\n    margin-right: -28px !important;\n    margin-left: -28px !important;\n  }\n  .mx-sm-n8 {\n    margin-right: -32px !important;\n    margin-left: -32px !important;\n  }\n  .mx-sm-n9 {\n    margin-right: -36px !important;\n    margin-left: -36px !important;\n  }\n  .mx-sm-n10 {\n    margin-right: -40px !important;\n    margin-left: -40px !important;\n  }\n  .mx-sm-n11 {\n    margin-right: -44px !important;\n    margin-left: -44px !important;\n  }\n  .mx-sm-n12 {\n    margin-right: -48px !important;\n    margin-left: -48px !important;\n  }\n  .mx-sm-n13 {\n    margin-right: -52px !important;\n    margin-left: -52px !important;\n  }\n  .mx-sm-n14 {\n    margin-right: -56px !important;\n    margin-left: -56px !important;\n  }\n  .mx-sm-n15 {\n    margin-right: -60px !important;\n    margin-left: -60px !important;\n  }\n  .mx-sm-n16 {\n    margin-right: -64px !important;\n    margin-left: -64px !important;\n  }\n  .my-sm-n1 {\n    margin-top: -4px !important;\n    margin-bottom: -4px !important;\n  }\n  .my-sm-n2 {\n    margin-top: -8px !important;\n    margin-bottom: -8px !important;\n  }\n  .my-sm-n3 {\n    margin-top: -12px !important;\n    margin-bottom: -12px !important;\n  }\n  .my-sm-n4 {\n    margin-top: -16px !important;\n    margin-bottom: -16px !important;\n  }\n  .my-sm-n5 {\n    margin-top: -20px !important;\n    margin-bottom: -20px !important;\n  }\n  .my-sm-n6 {\n    margin-top: -24px !important;\n    margin-bottom: -24px !important;\n  }\n  .my-sm-n7 {\n    margin-top: -28px !important;\n    margin-bottom: -28px !important;\n  }\n  .my-sm-n8 {\n    margin-top: -32px !important;\n    margin-bottom: -32px !important;\n  }\n  .my-sm-n9 {\n    margin-top: -36px !important;\n    margin-bottom: -36px !important;\n  }\n  .my-sm-n10 {\n    margin-top: -40px !important;\n    margin-bottom: -40px !important;\n  }\n  .my-sm-n11 {\n    margin-top: -44px !important;\n    margin-bottom: -44px !important;\n  }\n  .my-sm-n12 {\n    margin-top: -48px !important;\n    margin-bottom: -48px !important;\n  }\n  .my-sm-n13 {\n    margin-top: -52px !important;\n    margin-bottom: -52px !important;\n  }\n  .my-sm-n14 {\n    margin-top: -56px !important;\n    margin-bottom: -56px !important;\n  }\n  .my-sm-n15 {\n    margin-top: -60px !important;\n    margin-bottom: -60px !important;\n  }\n  .my-sm-n16 {\n    margin-top: -64px !important;\n    margin-bottom: -64px !important;\n  }\n  .mt-sm-n1 {\n    margin-top: -4px !important;\n  }\n  .mt-sm-n2 {\n    margin-top: -8px !important;\n  }\n  .mt-sm-n3 {\n    margin-top: -12px !important;\n  }\n  .mt-sm-n4 {\n    margin-top: -16px !important;\n  }\n  .mt-sm-n5 {\n    margin-top: -20px !important;\n  }\n  .mt-sm-n6 {\n    margin-top: -24px !important;\n  }\n  .mt-sm-n7 {\n    margin-top: -28px !important;\n  }\n  .mt-sm-n8 {\n    margin-top: -32px !important;\n  }\n  .mt-sm-n9 {\n    margin-top: -36px !important;\n  }\n  .mt-sm-n10 {\n    margin-top: -40px !important;\n  }\n  .mt-sm-n11 {\n    margin-top: -44px !important;\n  }\n  .mt-sm-n12 {\n    margin-top: -48px !important;\n  }\n  .mt-sm-n13 {\n    margin-top: -52px !important;\n  }\n  .mt-sm-n14 {\n    margin-top: -56px !important;\n  }\n  .mt-sm-n15 {\n    margin-top: -60px !important;\n  }\n  .mt-sm-n16 {\n    margin-top: -64px !important;\n  }\n  .mr-sm-n1 {\n    margin-right: -4px !important;\n  }\n  .mr-sm-n2 {\n    margin-right: -8px !important;\n  }\n  .mr-sm-n3 {\n    margin-right: -12px !important;\n  }\n  .mr-sm-n4 {\n    margin-right: -16px !important;\n  }\n  .mr-sm-n5 {\n    margin-right: -20px !important;\n  }\n  .mr-sm-n6 {\n    margin-right: -24px !important;\n  }\n  .mr-sm-n7 {\n    margin-right: -28px !important;\n  }\n  .mr-sm-n8 {\n    margin-right: -32px !important;\n  }\n  .mr-sm-n9 {\n    margin-right: -36px !important;\n  }\n  .mr-sm-n10 {\n    margin-right: -40px !important;\n  }\n  .mr-sm-n11 {\n    margin-right: -44px !important;\n  }\n  .mr-sm-n12 {\n    margin-right: -48px !important;\n  }\n  .mr-sm-n13 {\n    margin-right: -52px !important;\n  }\n  .mr-sm-n14 {\n    margin-right: -56px !important;\n  }\n  .mr-sm-n15 {\n    margin-right: -60px !important;\n  }\n  .mr-sm-n16 {\n    margin-right: -64px !important;\n  }\n  .mb-sm-n1 {\n    margin-bottom: -4px !important;\n  }\n  .mb-sm-n2 {\n    margin-bottom: -8px !important;\n  }\n  .mb-sm-n3 {\n    margin-bottom: -12px !important;\n  }\n  .mb-sm-n4 {\n    margin-bottom: -16px !important;\n  }\n  .mb-sm-n5 {\n    margin-bottom: -20px !important;\n  }\n  .mb-sm-n6 {\n    margin-bottom: -24px !important;\n  }\n  .mb-sm-n7 {\n    margin-bottom: -28px !important;\n  }\n  .mb-sm-n8 {\n    margin-bottom: -32px !important;\n  }\n  .mb-sm-n9 {\n    margin-bottom: -36px !important;\n  }\n  .mb-sm-n10 {\n    margin-bottom: -40px !important;\n  }\n  .mb-sm-n11 {\n    margin-bottom: -44px !important;\n  }\n  .mb-sm-n12 {\n    margin-bottom: -48px !important;\n  }\n  .mb-sm-n13 {\n    margin-bottom: -52px !important;\n  }\n  .mb-sm-n14 {\n    margin-bottom: -56px !important;\n  }\n  .mb-sm-n15 {\n    margin-bottom: -60px !important;\n  }\n  .mb-sm-n16 {\n    margin-bottom: -64px !important;\n  }\n  .ml-sm-n1 {\n    margin-left: -4px !important;\n  }\n  .ml-sm-n2 {\n    margin-left: -8px !important;\n  }\n  .ml-sm-n3 {\n    margin-left: -12px !important;\n  }\n  .ml-sm-n4 {\n    margin-left: -16px !important;\n  }\n  .ml-sm-n5 {\n    margin-left: -20px !important;\n  }\n  .ml-sm-n6 {\n    margin-left: -24px !important;\n  }\n  .ml-sm-n7 {\n    margin-left: -28px !important;\n  }\n  .ml-sm-n8 {\n    margin-left: -32px !important;\n  }\n  .ml-sm-n9 {\n    margin-left: -36px !important;\n  }\n  .ml-sm-n10 {\n    margin-left: -40px !important;\n  }\n  .ml-sm-n11 {\n    margin-left: -44px !important;\n  }\n  .ml-sm-n12 {\n    margin-left: -48px !important;\n  }\n  .ml-sm-n13 {\n    margin-left: -52px !important;\n  }\n  .ml-sm-n14 {\n    margin-left: -56px !important;\n  }\n  .ml-sm-n15 {\n    margin-left: -60px !important;\n  }\n  .ml-sm-n16 {\n    margin-left: -64px !important;\n  }\n  .ms-sm-n1 {\n    margin-inline-start: -4px !important;\n  }\n  .ms-sm-n2 {\n    margin-inline-start: -8px !important;\n  }\n  .ms-sm-n3 {\n    margin-inline-start: -12px !important;\n  }\n  .ms-sm-n4 {\n    margin-inline-start: -16px !important;\n  }\n  .ms-sm-n5 {\n    margin-inline-start: -20px !important;\n  }\n  .ms-sm-n6 {\n    margin-inline-start: -24px !important;\n  }\n  .ms-sm-n7 {\n    margin-inline-start: -28px !important;\n  }\n  .ms-sm-n8 {\n    margin-inline-start: -32px !important;\n  }\n  .ms-sm-n9 {\n    margin-inline-start: -36px !important;\n  }\n  .ms-sm-n10 {\n    margin-inline-start: -40px !important;\n  }\n  .ms-sm-n11 {\n    margin-inline-start: -44px !important;\n  }\n  .ms-sm-n12 {\n    margin-inline-start: -48px !important;\n  }\n  .ms-sm-n13 {\n    margin-inline-start: -52px !important;\n  }\n  .ms-sm-n14 {\n    margin-inline-start: -56px !important;\n  }\n  .ms-sm-n15 {\n    margin-inline-start: -60px !important;\n  }\n  .ms-sm-n16 {\n    margin-inline-start: -64px !important;\n  }\n  .me-sm-n1 {\n    margin-inline-end: -4px !important;\n  }\n  .me-sm-n2 {\n    margin-inline-end: -8px !important;\n  }\n  .me-sm-n3 {\n    margin-inline-end: -12px !important;\n  }\n  .me-sm-n4 {\n    margin-inline-end: -16px !important;\n  }\n  .me-sm-n5 {\n    margin-inline-end: -20px !important;\n  }\n  .me-sm-n6 {\n    margin-inline-end: -24px !important;\n  }\n  .me-sm-n7 {\n    margin-inline-end: -28px !important;\n  }\n  .me-sm-n8 {\n    margin-inline-end: -32px !important;\n  }\n  .me-sm-n9 {\n    margin-inline-end: -36px !important;\n  }\n  .me-sm-n10 {\n    margin-inline-end: -40px !important;\n  }\n  .me-sm-n11 {\n    margin-inline-end: -44px !important;\n  }\n  .me-sm-n12 {\n    margin-inline-end: -48px !important;\n  }\n  .me-sm-n13 {\n    margin-inline-end: -52px !important;\n  }\n  .me-sm-n14 {\n    margin-inline-end: -56px !important;\n  }\n  .me-sm-n15 {\n    margin-inline-end: -60px !important;\n  }\n  .me-sm-n16 {\n    margin-inline-end: -64px !important;\n  }\n  .pa-sm-0 {\n    padding: 0px !important;\n  }\n  .pa-sm-1 {\n    padding: 4px !important;\n  }\n  .pa-sm-2 {\n    padding: 8px !important;\n  }\n  .pa-sm-3 {\n    padding: 12px !important;\n  }\n  .pa-sm-4 {\n    padding: 16px !important;\n  }\n  .pa-sm-5 {\n    padding: 20px !important;\n  }\n  .pa-sm-6 {\n    padding: 24px !important;\n  }\n  .pa-sm-7 {\n    padding: 28px !important;\n  }\n  .pa-sm-8 {\n    padding: 32px !important;\n  }\n  .pa-sm-9 {\n    padding: 36px !important;\n  }\n  .pa-sm-10 {\n    padding: 40px !important;\n  }\n  .pa-sm-11 {\n    padding: 44px !important;\n  }\n  .pa-sm-12 {\n    padding: 48px !important;\n  }\n  .pa-sm-13 {\n    padding: 52px !important;\n  }\n  .pa-sm-14 {\n    padding: 56px !important;\n  }\n  .pa-sm-15 {\n    padding: 60px !important;\n  }\n  .pa-sm-16 {\n    padding: 64px !important;\n  }\n  .px-sm-0 {\n    padding-right: 0px !important;\n    padding-left: 0px !important;\n  }\n  .px-sm-1 {\n    padding-right: 4px !important;\n    padding-left: 4px !important;\n  }\n  .px-sm-2 {\n    padding-right: 8px !important;\n    padding-left: 8px !important;\n  }\n  .px-sm-3 {\n    padding-right: 12px !important;\n    padding-left: 12px !important;\n  }\n  .px-sm-4 {\n    padding-right: 16px !important;\n    padding-left: 16px !important;\n  }\n  .px-sm-5 {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n  }\n  .px-sm-6 {\n    padding-right: 24px !important;\n    padding-left: 24px !important;\n  }\n  .px-sm-7 {\n    padding-right: 28px !important;\n    padding-left: 28px !important;\n  }\n  .px-sm-8 {\n    padding-right: 32px !important;\n    padding-left: 32px !important;\n  }\n  .px-sm-9 {\n    padding-right: 36px !important;\n    padding-left: 36px !important;\n  }\n  .px-sm-10 {\n    padding-right: 40px !important;\n    padding-left: 40px !important;\n  }\n  .px-sm-11 {\n    padding-right: 44px !important;\n    padding-left: 44px !important;\n  }\n  .px-sm-12 {\n    padding-right: 48px !important;\n    padding-left: 48px !important;\n  }\n  .px-sm-13 {\n    padding-right: 52px !important;\n    padding-left: 52px !important;\n  }\n  .px-sm-14 {\n    padding-right: 56px !important;\n    padding-left: 56px !important;\n  }\n  .px-sm-15 {\n    padding-right: 60px !important;\n    padding-left: 60px !important;\n  }\n  .px-sm-16 {\n    padding-right: 64px !important;\n    padding-left: 64px !important;\n  }\n  .py-sm-0 {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n  .py-sm-1 {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n  }\n  .py-sm-2 {\n    padding-top: 8px !important;\n    padding-bottom: 8px !important;\n  }\n  .py-sm-3 {\n    padding-top: 12px !important;\n    padding-bottom: 12px !important;\n  }\n  .py-sm-4 {\n    padding-top: 16px !important;\n    padding-bottom: 16px !important;\n  }\n  .py-sm-5 {\n    padding-top: 20px !important;\n    padding-bottom: 20px !important;\n  }\n  .py-sm-6 {\n    padding-top: 24px !important;\n    padding-bottom: 24px !important;\n  }\n  .py-sm-7 {\n    padding-top: 28px !important;\n    padding-bottom: 28px !important;\n  }\n  .py-sm-8 {\n    padding-top: 32px !important;\n    padding-bottom: 32px !important;\n  }\n  .py-sm-9 {\n    padding-top: 36px !important;\n    padding-bottom: 36px !important;\n  }\n  .py-sm-10 {\n    padding-top: 40px !important;\n    padding-bottom: 40px !important;\n  }\n  .py-sm-11 {\n    padding-top: 44px !important;\n    padding-bottom: 44px !important;\n  }\n  .py-sm-12 {\n    padding-top: 48px !important;\n    padding-bottom: 48px !important;\n  }\n  .py-sm-13 {\n    padding-top: 52px !important;\n    padding-bottom: 52px !important;\n  }\n  .py-sm-14 {\n    padding-top: 56px !important;\n    padding-bottom: 56px !important;\n  }\n  .py-sm-15 {\n    padding-top: 60px !important;\n    padding-bottom: 60px !important;\n  }\n  .py-sm-16 {\n    padding-top: 64px !important;\n    padding-bottom: 64px !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0px !important;\n  }\n  .pt-sm-1 {\n    padding-top: 4px !important;\n  }\n  .pt-sm-2 {\n    padding-top: 8px !important;\n  }\n  .pt-sm-3 {\n    padding-top: 12px !important;\n  }\n  .pt-sm-4 {\n    padding-top: 16px !important;\n  }\n  .pt-sm-5 {\n    padding-top: 20px !important;\n  }\n  .pt-sm-6 {\n    padding-top: 24px !important;\n  }\n  .pt-sm-7 {\n    padding-top: 28px !important;\n  }\n  .pt-sm-8 {\n    padding-top: 32px !important;\n  }\n  .pt-sm-9 {\n    padding-top: 36px !important;\n  }\n  .pt-sm-10 {\n    padding-top: 40px !important;\n  }\n  .pt-sm-11 {\n    padding-top: 44px !important;\n  }\n  .pt-sm-12 {\n    padding-top: 48px !important;\n  }\n  .pt-sm-13 {\n    padding-top: 52px !important;\n  }\n  .pt-sm-14 {\n    padding-top: 56px !important;\n  }\n  .pt-sm-15 {\n    padding-top: 60px !important;\n  }\n  .pt-sm-16 {\n    padding-top: 64px !important;\n  }\n  .pr-sm-0 {\n    padding-right: 0px !important;\n  }\n  .pr-sm-1 {\n    padding-right: 4px !important;\n  }\n  .pr-sm-2 {\n    padding-right: 8px !important;\n  }\n  .pr-sm-3 {\n    padding-right: 12px !important;\n  }\n  .pr-sm-4 {\n    padding-right: 16px !important;\n  }\n  .pr-sm-5 {\n    padding-right: 20px !important;\n  }\n  .pr-sm-6 {\n    padding-right: 24px !important;\n  }\n  .pr-sm-7 {\n    padding-right: 28px !important;\n  }\n  .pr-sm-8 {\n    padding-right: 32px !important;\n  }\n  .pr-sm-9 {\n    padding-right: 36px !important;\n  }\n  .pr-sm-10 {\n    padding-right: 40px !important;\n  }\n  .pr-sm-11 {\n    padding-right: 44px !important;\n  }\n  .pr-sm-12 {\n    padding-right: 48px !important;\n  }\n  .pr-sm-13 {\n    padding-right: 52px !important;\n  }\n  .pr-sm-14 {\n    padding-right: 56px !important;\n  }\n  .pr-sm-15 {\n    padding-right: 60px !important;\n  }\n  .pr-sm-16 {\n    padding-right: 64px !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0px !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 4px !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 8px !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 12px !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 16px !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 20px !important;\n  }\n  .pb-sm-6 {\n    padding-bottom: 24px !important;\n  }\n  .pb-sm-7 {\n    padding-bottom: 28px !important;\n  }\n  .pb-sm-8 {\n    padding-bottom: 32px !important;\n  }\n  .pb-sm-9 {\n    padding-bottom: 36px !important;\n  }\n  .pb-sm-10 {\n    padding-bottom: 40px !important;\n  }\n  .pb-sm-11 {\n    padding-bottom: 44px !important;\n  }\n  .pb-sm-12 {\n    padding-bottom: 48px !important;\n  }\n  .pb-sm-13 {\n    padding-bottom: 52px !important;\n  }\n  .pb-sm-14 {\n    padding-bottom: 56px !important;\n  }\n  .pb-sm-15 {\n    padding-bottom: 60px !important;\n  }\n  .pb-sm-16 {\n    padding-bottom: 64px !important;\n  }\n  .pl-sm-0 {\n    padding-left: 0px !important;\n  }\n  .pl-sm-1 {\n    padding-left: 4px !important;\n  }\n  .pl-sm-2 {\n    padding-left: 8px !important;\n  }\n  .pl-sm-3 {\n    padding-left: 12px !important;\n  }\n  .pl-sm-4 {\n    padding-left: 16px !important;\n  }\n  .pl-sm-5 {\n    padding-left: 20px !important;\n  }\n  .pl-sm-6 {\n    padding-left: 24px !important;\n  }\n  .pl-sm-7 {\n    padding-left: 28px !important;\n  }\n  .pl-sm-8 {\n    padding-left: 32px !important;\n  }\n  .pl-sm-9 {\n    padding-left: 36px !important;\n  }\n  .pl-sm-10 {\n    padding-left: 40px !important;\n  }\n  .pl-sm-11 {\n    padding-left: 44px !important;\n  }\n  .pl-sm-12 {\n    padding-left: 48px !important;\n  }\n  .pl-sm-13 {\n    padding-left: 52px !important;\n  }\n  .pl-sm-14 {\n    padding-left: 56px !important;\n  }\n  .pl-sm-15 {\n    padding-left: 60px !important;\n  }\n  .pl-sm-16 {\n    padding-left: 64px !important;\n  }\n  .ps-sm-0 {\n    padding-inline-start: 0px !important;\n  }\n  .ps-sm-1 {\n    padding-inline-start: 4px !important;\n  }\n  .ps-sm-2 {\n    padding-inline-start: 8px !important;\n  }\n  .ps-sm-3 {\n    padding-inline-start: 12px !important;\n  }\n  .ps-sm-4 {\n    padding-inline-start: 16px !important;\n  }\n  .ps-sm-5 {\n    padding-inline-start: 20px !important;\n  }\n  .ps-sm-6 {\n    padding-inline-start: 24px !important;\n  }\n  .ps-sm-7 {\n    padding-inline-start: 28px !important;\n  }\n  .ps-sm-8 {\n    padding-inline-start: 32px !important;\n  }\n  .ps-sm-9 {\n    padding-inline-start: 36px !important;\n  }\n  .ps-sm-10 {\n    padding-inline-start: 40px !important;\n  }\n  .ps-sm-11 {\n    padding-inline-start: 44px !important;\n  }\n  .ps-sm-12 {\n    padding-inline-start: 48px !important;\n  }\n  .ps-sm-13 {\n    padding-inline-start: 52px !important;\n  }\n  .ps-sm-14 {\n    padding-inline-start: 56px !important;\n  }\n  .ps-sm-15 {\n    padding-inline-start: 60px !important;\n  }\n  .ps-sm-16 {\n    padding-inline-start: 64px !important;\n  }\n  .pe-sm-0 {\n    padding-inline-end: 0px !important;\n  }\n  .pe-sm-1 {\n    padding-inline-end: 4px !important;\n  }\n  .pe-sm-2 {\n    padding-inline-end: 8px !important;\n  }\n  .pe-sm-3 {\n    padding-inline-end: 12px !important;\n  }\n  .pe-sm-4 {\n    padding-inline-end: 16px !important;\n  }\n  .pe-sm-5 {\n    padding-inline-end: 20px !important;\n  }\n  .pe-sm-6 {\n    padding-inline-end: 24px !important;\n  }\n  .pe-sm-7 {\n    padding-inline-end: 28px !important;\n  }\n  .pe-sm-8 {\n    padding-inline-end: 32px !important;\n  }\n  .pe-sm-9 {\n    padding-inline-end: 36px !important;\n  }\n  .pe-sm-10 {\n    padding-inline-end: 40px !important;\n  }\n  .pe-sm-11 {\n    padding-inline-end: 44px !important;\n  }\n  .pe-sm-12 {\n    padding-inline-end: 48px !important;\n  }\n  .pe-sm-13 {\n    padding-inline-end: 52px !important;\n  }\n  .pe-sm-14 {\n    padding-inline-end: 56px !important;\n  }\n  .pe-sm-15 {\n    padding-inline-end: 60px !important;\n  }\n  .pe-sm-16 {\n    padding-inline-end: 64px !important;\n  }\n  .text-sm-left {\n    text-align: left !important;\n  }\n  .text-sm-right {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n  .text-sm-justify {\n    text-align: justify !important;\n  }\n  .text-sm-start {\n    text-align: start !important;\n  }\n  .text-sm-end {\n    text-align: end !important;\n  }\n  .text-sm-h1 {\n    font-size: 6rem !important;\n    font-weight: 300;\n    line-height: 1;\n    letter-spacing: -0.015625em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-sm-h2 {\n    font-size: 3.75rem !important;\n    font-weight: 300;\n    line-height: 1;\n    letter-spacing: -0.0083333333em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-sm-h3 {\n    font-size: 3rem !important;\n    font-weight: 400;\n    line-height: 1.05;\n    letter-spacing: normal !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-sm-h4 {\n    font-size: 2.125rem !important;\n    font-weight: 400;\n    line-height: 1.175;\n    letter-spacing: 0.0073529412em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-sm-h5 {\n    font-size: 1.5rem !important;\n    font-weight: 400;\n    line-height: 1.333;\n    letter-spacing: normal !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-sm-h6 {\n    font-size: 1.25rem !important;\n    font-weight: 500;\n    line-height: 1.6;\n    letter-spacing: 0.0125em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-sm-subtitle-1 {\n    font-size: 1rem !important;\n    font-weight: normal;\n    line-height: 1.75;\n    letter-spacing: 0.009375em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-sm-subtitle-2 {\n    font-size: 0.875rem !important;\n    font-weight: 500;\n    line-height: 1.6;\n    letter-spacing: 0.0071428571em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-sm-body-1 {\n    font-size: 1rem !important;\n    font-weight: 400;\n    line-height: 1.5;\n    letter-spacing: 0.03125em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-sm-body-2 {\n    font-size: 0.875rem !important;\n    font-weight: 400;\n    line-height: 1.425;\n    letter-spacing: 0.0178571429em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-sm-button {\n    font-size: 0.875rem !important;\n    font-weight: 500;\n    line-height: 2.6;\n    letter-spacing: 0.0892857143em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: uppercase !important;\n  }\n  .text-sm-caption {\n    font-size: 0.75rem !important;\n    font-weight: 400;\n    line-height: 1.667;\n    letter-spacing: 0.0333333333em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-sm-overline {\n    font-size: 0.75rem !important;\n    font-weight: 500;\n    line-height: 2.667;\n    letter-spacing: 0.1666666667em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: uppercase !important;\n  }\n  .h-sm-auto {\n    height: auto !important;\n  }\n  .h-sm-screen {\n    height: 100vh !important;\n  }\n  .h-sm-0 {\n    height: 0 !important;\n  }\n  .h-sm-25 {\n    height: 25% !important;\n  }\n  .h-sm-50 {\n    height: 50% !important;\n  }\n  .h-sm-75 {\n    height: 75% !important;\n  }\n  .h-sm-100 {\n    height: 100% !important;\n  }\n  .w-sm-auto {\n    width: auto !important;\n  }\n  .w-sm-0 {\n    width: 0 !important;\n  }\n  .w-sm-25 {\n    width: 25% !important;\n  }\n  .w-sm-33 {\n    width: 33% !important;\n  }\n  .w-sm-50 {\n    width: 50% !important;\n  }\n  .w-sm-66 {\n    width: 66% !important;\n  }\n  .w-sm-75 {\n    width: 75% !important;\n  }\n  .w-sm-100 {\n    width: 100% !important;\n  }\n}\n@media (min-width: 960px) {\n  .d-md-none {\n    display: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .float-md-left {\n    float: left !important;\n  }\n  .float-md-right {\n    float: right !important;\n  }\n  .v-locale--is-rtl .float-md-end {\n    float: left !important;\n  }\n  .v-locale--is-rtl .float-md-start {\n    float: right !important;\n  }\n  .v-locale--is-ltr .float-md-end {\n    float: right !important;\n  }\n  .v-locale--is-ltr .float-md-start {\n    float: left !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-1-1 {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-1-0 {\n    flex: 1 0 auto !important;\n  }\n  .flex-md-0-1 {\n    flex: 0 1 auto !important;\n  }\n  .flex-md-0-0 {\n    flex: 0 0 auto !important;\n  }\n  .flex-md-1-1-100 {\n    flex: 1 1 100% !important;\n  }\n  .flex-md-1-0-100 {\n    flex: 1 0 100% !important;\n  }\n  .flex-md-0-1-100 {\n    flex: 0 1 100% !important;\n  }\n  .flex-md-0-0-100 {\n    flex: 0 0 100% !important;\n  }\n  .flex-md-1-1-0 {\n    flex: 1 1 0 !important;\n  }\n  .flex-md-1-0-0 {\n    flex: 1 0 0 !important;\n  }\n  .flex-md-0-1-0 {\n    flex: 0 1 0 !important;\n  }\n  .flex-md-0-0-0 {\n    flex: 0 0 0 !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-md-center {\n    justify-content: center !important;\n  }\n  .justify-md-space-between {\n    justify-content: space-between !important;\n  }\n  .justify-md-space-around {\n    justify-content: space-around !important;\n  }\n  .justify-md-space-evenly {\n    justify-content: space-evenly !important;\n  }\n  .justify-items-md-start {\n    justify-items: flex-start !important;\n  }\n  .justify-items-md-end {\n    justify-items: flex-end !important;\n  }\n  .justify-items-md-center {\n    justify-items: center !important;\n  }\n  .justify-items-md-stretch {\n    justify-items: stretch !important;\n  }\n  .align-md-start {\n    align-items: flex-start !important;\n  }\n  .align-md-end {\n    align-items: flex-end !important;\n  }\n  .align-md-center {\n    align-items: center !important;\n  }\n  .align-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-space-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-space-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-space-evenly {\n    align-content: space-evenly !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-6 {\n    order: 6 !important;\n  }\n  .order-md-7 {\n    order: 7 !important;\n  }\n  .order-md-8 {\n    order: 8 !important;\n  }\n  .order-md-9 {\n    order: 9 !important;\n  }\n  .order-md-10 {\n    order: 10 !important;\n  }\n  .order-md-11 {\n    order: 11 !important;\n  }\n  .order-md-12 {\n    order: 12 !important;\n  }\n  .order-md-last {\n    order: 13 !important;\n  }\n  .ga-md-0 {\n    gap: 0px !important;\n  }\n  .ga-md-1 {\n    gap: 4px !important;\n  }\n  .ga-md-2 {\n    gap: 8px !important;\n  }\n  .ga-md-3 {\n    gap: 12px !important;\n  }\n  .ga-md-4 {\n    gap: 16px !important;\n  }\n  .ga-md-5 {\n    gap: 20px !important;\n  }\n  .ga-md-6 {\n    gap: 24px !important;\n  }\n  .ga-md-7 {\n    gap: 28px !important;\n  }\n  .ga-md-8 {\n    gap: 32px !important;\n  }\n  .ga-md-9 {\n    gap: 36px !important;\n  }\n  .ga-md-10 {\n    gap: 40px !important;\n  }\n  .ga-md-11 {\n    gap: 44px !important;\n  }\n  .ga-md-12 {\n    gap: 48px !important;\n  }\n  .ga-md-13 {\n    gap: 52px !important;\n  }\n  .ga-md-14 {\n    gap: 56px !important;\n  }\n  .ga-md-15 {\n    gap: 60px !important;\n  }\n  .ga-md-16 {\n    gap: 64px !important;\n  }\n  .ga-md-auto {\n    gap: auto !important;\n  }\n  .gr-md-0 {\n    row-gap: 0px !important;\n  }\n  .gr-md-1 {\n    row-gap: 4px !important;\n  }\n  .gr-md-2 {\n    row-gap: 8px !important;\n  }\n  .gr-md-3 {\n    row-gap: 12px !important;\n  }\n  .gr-md-4 {\n    row-gap: 16px !important;\n  }\n  .gr-md-5 {\n    row-gap: 20px !important;\n  }\n  .gr-md-6 {\n    row-gap: 24px !important;\n  }\n  .gr-md-7 {\n    row-gap: 28px !important;\n  }\n  .gr-md-8 {\n    row-gap: 32px !important;\n  }\n  .gr-md-9 {\n    row-gap: 36px !important;\n  }\n  .gr-md-10 {\n    row-gap: 40px !important;\n  }\n  .gr-md-11 {\n    row-gap: 44px !important;\n  }\n  .gr-md-12 {\n    row-gap: 48px !important;\n  }\n  .gr-md-13 {\n    row-gap: 52px !important;\n  }\n  .gr-md-14 {\n    row-gap: 56px !important;\n  }\n  .gr-md-15 {\n    row-gap: 60px !important;\n  }\n  .gr-md-16 {\n    row-gap: 64px !important;\n  }\n  .gr-md-auto {\n    row-gap: auto !important;\n  }\n  .gc-md-0 {\n    column-gap: 0px !important;\n  }\n  .gc-md-1 {\n    column-gap: 4px !important;\n  }\n  .gc-md-2 {\n    column-gap: 8px !important;\n  }\n  .gc-md-3 {\n    column-gap: 12px !important;\n  }\n  .gc-md-4 {\n    column-gap: 16px !important;\n  }\n  .gc-md-5 {\n    column-gap: 20px !important;\n  }\n  .gc-md-6 {\n    column-gap: 24px !important;\n  }\n  .gc-md-7 {\n    column-gap: 28px !important;\n  }\n  .gc-md-8 {\n    column-gap: 32px !important;\n  }\n  .gc-md-9 {\n    column-gap: 36px !important;\n  }\n  .gc-md-10 {\n    column-gap: 40px !important;\n  }\n  .gc-md-11 {\n    column-gap: 44px !important;\n  }\n  .gc-md-12 {\n    column-gap: 48px !important;\n  }\n  .gc-md-13 {\n    column-gap: 52px !important;\n  }\n  .gc-md-14 {\n    column-gap: 56px !important;\n  }\n  .gc-md-15 {\n    column-gap: 60px !important;\n  }\n  .gc-md-16 {\n    column-gap: 64px !important;\n  }\n  .gc-md-auto {\n    column-gap: auto !important;\n  }\n  .ma-md-0 {\n    margin: 0px !important;\n  }\n  .ma-md-1 {\n    margin: 4px !important;\n  }\n  .ma-md-2 {\n    margin: 8px !important;\n  }\n  .ma-md-3 {\n    margin: 12px !important;\n  }\n  .ma-md-4 {\n    margin: 16px !important;\n  }\n  .ma-md-5 {\n    margin: 20px !important;\n  }\n  .ma-md-6 {\n    margin: 24px !important;\n  }\n  .ma-md-7 {\n    margin: 28px !important;\n  }\n  .ma-md-8 {\n    margin: 32px !important;\n  }\n  .ma-md-9 {\n    margin: 36px !important;\n  }\n  .ma-md-10 {\n    margin: 40px !important;\n  }\n  .ma-md-11 {\n    margin: 44px !important;\n  }\n  .ma-md-12 {\n    margin: 48px !important;\n  }\n  .ma-md-13 {\n    margin: 52px !important;\n  }\n  .ma-md-14 {\n    margin: 56px !important;\n  }\n  .ma-md-15 {\n    margin: 60px !important;\n  }\n  .ma-md-16 {\n    margin: 64px !important;\n  }\n  .ma-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0px !important;\n    margin-left: 0px !important;\n  }\n  .mx-md-1 {\n    margin-right: 4px !important;\n    margin-left: 4px !important;\n  }\n  .mx-md-2 {\n    margin-right: 8px !important;\n    margin-left: 8px !important;\n  }\n  .mx-md-3 {\n    margin-right: 12px !important;\n    margin-left: 12px !important;\n  }\n  .mx-md-4 {\n    margin-right: 16px !important;\n    margin-left: 16px !important;\n  }\n  .mx-md-5 {\n    margin-right: 20px !important;\n    margin-left: 20px !important;\n  }\n  .mx-md-6 {\n    margin-right: 24px !important;\n    margin-left: 24px !important;\n  }\n  .mx-md-7 {\n    margin-right: 28px !important;\n    margin-left: 28px !important;\n  }\n  .mx-md-8 {\n    margin-right: 32px !important;\n    margin-left: 32px !important;\n  }\n  .mx-md-9 {\n    margin-right: 36px !important;\n    margin-left: 36px !important;\n  }\n  .mx-md-10 {\n    margin-right: 40px !important;\n    margin-left: 40px !important;\n  }\n  .mx-md-11 {\n    margin-right: 44px !important;\n    margin-left: 44px !important;\n  }\n  .mx-md-12 {\n    margin-right: 48px !important;\n    margin-left: 48px !important;\n  }\n  .mx-md-13 {\n    margin-right: 52px !important;\n    margin-left: 52px !important;\n  }\n  .mx-md-14 {\n    margin-right: 56px !important;\n    margin-left: 56px !important;\n  }\n  .mx-md-15 {\n    margin-right: 60px !important;\n    margin-left: 60px !important;\n  }\n  .mx-md-16 {\n    margin-right: 64px !important;\n    margin-left: 64px !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n  .my-md-1 {\n    margin-top: 4px !important;\n    margin-bottom: 4px !important;\n  }\n  .my-md-2 {\n    margin-top: 8px !important;\n    margin-bottom: 8px !important;\n  }\n  .my-md-3 {\n    margin-top: 12px !important;\n    margin-bottom: 12px !important;\n  }\n  .my-md-4 {\n    margin-top: 16px !important;\n    margin-bottom: 16px !important;\n  }\n  .my-md-5 {\n    margin-top: 20px !important;\n    margin-bottom: 20px !important;\n  }\n  .my-md-6 {\n    margin-top: 24px !important;\n    margin-bottom: 24px !important;\n  }\n  .my-md-7 {\n    margin-top: 28px !important;\n    margin-bottom: 28px !important;\n  }\n  .my-md-8 {\n    margin-top: 32px !important;\n    margin-bottom: 32px !important;\n  }\n  .my-md-9 {\n    margin-top: 36px !important;\n    margin-bottom: 36px !important;\n  }\n  .my-md-10 {\n    margin-top: 40px !important;\n    margin-bottom: 40px !important;\n  }\n  .my-md-11 {\n    margin-top: 44px !important;\n    margin-bottom: 44px !important;\n  }\n  .my-md-12 {\n    margin-top: 48px !important;\n    margin-bottom: 48px !important;\n  }\n  .my-md-13 {\n    margin-top: 52px !important;\n    margin-bottom: 52px !important;\n  }\n  .my-md-14 {\n    margin-top: 56px !important;\n    margin-bottom: 56px !important;\n  }\n  .my-md-15 {\n    margin-top: 60px !important;\n    margin-bottom: 60px !important;\n  }\n  .my-md-16 {\n    margin-top: 64px !important;\n    margin-bottom: 64px !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0px !important;\n  }\n  .mt-md-1 {\n    margin-top: 4px !important;\n  }\n  .mt-md-2 {\n    margin-top: 8px !important;\n  }\n  .mt-md-3 {\n    margin-top: 12px !important;\n  }\n  .mt-md-4 {\n    margin-top: 16px !important;\n  }\n  .mt-md-5 {\n    margin-top: 20px !important;\n  }\n  .mt-md-6 {\n    margin-top: 24px !important;\n  }\n  .mt-md-7 {\n    margin-top: 28px !important;\n  }\n  .mt-md-8 {\n    margin-top: 32px !important;\n  }\n  .mt-md-9 {\n    margin-top: 36px !important;\n  }\n  .mt-md-10 {\n    margin-top: 40px !important;\n  }\n  .mt-md-11 {\n    margin-top: 44px !important;\n  }\n  .mt-md-12 {\n    margin-top: 48px !important;\n  }\n  .mt-md-13 {\n    margin-top: 52px !important;\n  }\n  .mt-md-14 {\n    margin-top: 56px !important;\n  }\n  .mt-md-15 {\n    margin-top: 60px !important;\n  }\n  .mt-md-16 {\n    margin-top: 64px !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .mr-md-0 {\n    margin-right: 0px !important;\n  }\n  .mr-md-1 {\n    margin-right: 4px !important;\n  }\n  .mr-md-2 {\n    margin-right: 8px !important;\n  }\n  .mr-md-3 {\n    margin-right: 12px !important;\n  }\n  .mr-md-4 {\n    margin-right: 16px !important;\n  }\n  .mr-md-5 {\n    margin-right: 20px !important;\n  }\n  .mr-md-6 {\n    margin-right: 24px !important;\n  }\n  .mr-md-7 {\n    margin-right: 28px !important;\n  }\n  .mr-md-8 {\n    margin-right: 32px !important;\n  }\n  .mr-md-9 {\n    margin-right: 36px !important;\n  }\n  .mr-md-10 {\n    margin-right: 40px !important;\n  }\n  .mr-md-11 {\n    margin-right: 44px !important;\n  }\n  .mr-md-12 {\n    margin-right: 48px !important;\n  }\n  .mr-md-13 {\n    margin-right: 52px !important;\n  }\n  .mr-md-14 {\n    margin-right: 56px !important;\n  }\n  .mr-md-15 {\n    margin-right: 60px !important;\n  }\n  .mr-md-16 {\n    margin-right: 64px !important;\n  }\n  .mr-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0px !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 4px !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 8px !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 12px !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 16px !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 20px !important;\n  }\n  .mb-md-6 {\n    margin-bottom: 24px !important;\n  }\n  .mb-md-7 {\n    margin-bottom: 28px !important;\n  }\n  .mb-md-8 {\n    margin-bottom: 32px !important;\n  }\n  .mb-md-9 {\n    margin-bottom: 36px !important;\n  }\n  .mb-md-10 {\n    margin-bottom: 40px !important;\n  }\n  .mb-md-11 {\n    margin-bottom: 44px !important;\n  }\n  .mb-md-12 {\n    margin-bottom: 48px !important;\n  }\n  .mb-md-13 {\n    margin-bottom: 52px !important;\n  }\n  .mb-md-14 {\n    margin-bottom: 56px !important;\n  }\n  .mb-md-15 {\n    margin-bottom: 60px !important;\n  }\n  .mb-md-16 {\n    margin-bottom: 64px !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-md-0 {\n    margin-left: 0px !important;\n  }\n  .ml-md-1 {\n    margin-left: 4px !important;\n  }\n  .ml-md-2 {\n    margin-left: 8px !important;\n  }\n  .ml-md-3 {\n    margin-left: 12px !important;\n  }\n  .ml-md-4 {\n    margin-left: 16px !important;\n  }\n  .ml-md-5 {\n    margin-left: 20px !important;\n  }\n  .ml-md-6 {\n    margin-left: 24px !important;\n  }\n  .ml-md-7 {\n    margin-left: 28px !important;\n  }\n  .ml-md-8 {\n    margin-left: 32px !important;\n  }\n  .ml-md-9 {\n    margin-left: 36px !important;\n  }\n  .ml-md-10 {\n    margin-left: 40px !important;\n  }\n  .ml-md-11 {\n    margin-left: 44px !important;\n  }\n  .ml-md-12 {\n    margin-left: 48px !important;\n  }\n  .ml-md-13 {\n    margin-left: 52px !important;\n  }\n  .ml-md-14 {\n    margin-left: 56px !important;\n  }\n  .ml-md-15 {\n    margin-left: 60px !important;\n  }\n  .ml-md-16 {\n    margin-left: 64px !important;\n  }\n  .ml-md-auto {\n    margin-left: auto !important;\n  }\n  .ms-md-0 {\n    margin-inline-start: 0px !important;\n  }\n  .ms-md-1 {\n    margin-inline-start: 4px !important;\n  }\n  .ms-md-2 {\n    margin-inline-start: 8px !important;\n  }\n  .ms-md-3 {\n    margin-inline-start: 12px !important;\n  }\n  .ms-md-4 {\n    margin-inline-start: 16px !important;\n  }\n  .ms-md-5 {\n    margin-inline-start: 20px !important;\n  }\n  .ms-md-6 {\n    margin-inline-start: 24px !important;\n  }\n  .ms-md-7 {\n    margin-inline-start: 28px !important;\n  }\n  .ms-md-8 {\n    margin-inline-start: 32px !important;\n  }\n  .ms-md-9 {\n    margin-inline-start: 36px !important;\n  }\n  .ms-md-10 {\n    margin-inline-start: 40px !important;\n  }\n  .ms-md-11 {\n    margin-inline-start: 44px !important;\n  }\n  .ms-md-12 {\n    margin-inline-start: 48px !important;\n  }\n  .ms-md-13 {\n    margin-inline-start: 52px !important;\n  }\n  .ms-md-14 {\n    margin-inline-start: 56px !important;\n  }\n  .ms-md-15 {\n    margin-inline-start: 60px !important;\n  }\n  .ms-md-16 {\n    margin-inline-start: 64px !important;\n  }\n  .ms-md-auto {\n    margin-inline-start: auto !important;\n  }\n  .me-md-0 {\n    margin-inline-end: 0px !important;\n  }\n  .me-md-1 {\n    margin-inline-end: 4px !important;\n  }\n  .me-md-2 {\n    margin-inline-end: 8px !important;\n  }\n  .me-md-3 {\n    margin-inline-end: 12px !important;\n  }\n  .me-md-4 {\n    margin-inline-end: 16px !important;\n  }\n  .me-md-5 {\n    margin-inline-end: 20px !important;\n  }\n  .me-md-6 {\n    margin-inline-end: 24px !important;\n  }\n  .me-md-7 {\n    margin-inline-end: 28px !important;\n  }\n  .me-md-8 {\n    margin-inline-end: 32px !important;\n  }\n  .me-md-9 {\n    margin-inline-end: 36px !important;\n  }\n  .me-md-10 {\n    margin-inline-end: 40px !important;\n  }\n  .me-md-11 {\n    margin-inline-end: 44px !important;\n  }\n  .me-md-12 {\n    margin-inline-end: 48px !important;\n  }\n  .me-md-13 {\n    margin-inline-end: 52px !important;\n  }\n  .me-md-14 {\n    margin-inline-end: 56px !important;\n  }\n  .me-md-15 {\n    margin-inline-end: 60px !important;\n  }\n  .me-md-16 {\n    margin-inline-end: 64px !important;\n  }\n  .me-md-auto {\n    margin-inline-end: auto !important;\n  }\n  .ma-md-n1 {\n    margin: -4px !important;\n  }\n  .ma-md-n2 {\n    margin: -8px !important;\n  }\n  .ma-md-n3 {\n    margin: -12px !important;\n  }\n  .ma-md-n4 {\n    margin: -16px !important;\n  }\n  .ma-md-n5 {\n    margin: -20px !important;\n  }\n  .ma-md-n6 {\n    margin: -24px !important;\n  }\n  .ma-md-n7 {\n    margin: -28px !important;\n  }\n  .ma-md-n8 {\n    margin: -32px !important;\n  }\n  .ma-md-n9 {\n    margin: -36px !important;\n  }\n  .ma-md-n10 {\n    margin: -40px !important;\n  }\n  .ma-md-n11 {\n    margin: -44px !important;\n  }\n  .ma-md-n12 {\n    margin: -48px !important;\n  }\n  .ma-md-n13 {\n    margin: -52px !important;\n  }\n  .ma-md-n14 {\n    margin: -56px !important;\n  }\n  .ma-md-n15 {\n    margin: -60px !important;\n  }\n  .ma-md-n16 {\n    margin: -64px !important;\n  }\n  .mx-md-n1 {\n    margin-right: -4px !important;\n    margin-left: -4px !important;\n  }\n  .mx-md-n2 {\n    margin-right: -8px !important;\n    margin-left: -8px !important;\n  }\n  .mx-md-n3 {\n    margin-right: -12px !important;\n    margin-left: -12px !important;\n  }\n  .mx-md-n4 {\n    margin-right: -16px !important;\n    margin-left: -16px !important;\n  }\n  .mx-md-n5 {\n    margin-right: -20px !important;\n    margin-left: -20px !important;\n  }\n  .mx-md-n6 {\n    margin-right: -24px !important;\n    margin-left: -24px !important;\n  }\n  .mx-md-n7 {\n    margin-right: -28px !important;\n    margin-left: -28px !important;\n  }\n  .mx-md-n8 {\n    margin-right: -32px !important;\n    margin-left: -32px !important;\n  }\n  .mx-md-n9 {\n    margin-right: -36px !important;\n    margin-left: -36px !important;\n  }\n  .mx-md-n10 {\n    margin-right: -40px !important;\n    margin-left: -40px !important;\n  }\n  .mx-md-n11 {\n    margin-right: -44px !important;\n    margin-left: -44px !important;\n  }\n  .mx-md-n12 {\n    margin-right: -48px !important;\n    margin-left: -48px !important;\n  }\n  .mx-md-n13 {\n    margin-right: -52px !important;\n    margin-left: -52px !important;\n  }\n  .mx-md-n14 {\n    margin-right: -56px !important;\n    margin-left: -56px !important;\n  }\n  .mx-md-n15 {\n    margin-right: -60px !important;\n    margin-left: -60px !important;\n  }\n  .mx-md-n16 {\n    margin-right: -64px !important;\n    margin-left: -64px !important;\n  }\n  .my-md-n1 {\n    margin-top: -4px !important;\n    margin-bottom: -4px !important;\n  }\n  .my-md-n2 {\n    margin-top: -8px !important;\n    margin-bottom: -8px !important;\n  }\n  .my-md-n3 {\n    margin-top: -12px !important;\n    margin-bottom: -12px !important;\n  }\n  .my-md-n4 {\n    margin-top: -16px !important;\n    margin-bottom: -16px !important;\n  }\n  .my-md-n5 {\n    margin-top: -20px !important;\n    margin-bottom: -20px !important;\n  }\n  .my-md-n6 {\n    margin-top: -24px !important;\n    margin-bottom: -24px !important;\n  }\n  .my-md-n7 {\n    margin-top: -28px !important;\n    margin-bottom: -28px !important;\n  }\n  .my-md-n8 {\n    margin-top: -32px !important;\n    margin-bottom: -32px !important;\n  }\n  .my-md-n9 {\n    margin-top: -36px !important;\n    margin-bottom: -36px !important;\n  }\n  .my-md-n10 {\n    margin-top: -40px !important;\n    margin-bottom: -40px !important;\n  }\n  .my-md-n11 {\n    margin-top: -44px !important;\n    margin-bottom: -44px !important;\n  }\n  .my-md-n12 {\n    margin-top: -48px !important;\n    margin-bottom: -48px !important;\n  }\n  .my-md-n13 {\n    margin-top: -52px !important;\n    margin-bottom: -52px !important;\n  }\n  .my-md-n14 {\n    margin-top: -56px !important;\n    margin-bottom: -56px !important;\n  }\n  .my-md-n15 {\n    margin-top: -60px !important;\n    margin-bottom: -60px !important;\n  }\n  .my-md-n16 {\n    margin-top: -64px !important;\n    margin-bottom: -64px !important;\n  }\n  .mt-md-n1 {\n    margin-top: -4px !important;\n  }\n  .mt-md-n2 {\n    margin-top: -8px !important;\n  }\n  .mt-md-n3 {\n    margin-top: -12px !important;\n  }\n  .mt-md-n4 {\n    margin-top: -16px !important;\n  }\n  .mt-md-n5 {\n    margin-top: -20px !important;\n  }\n  .mt-md-n6 {\n    margin-top: -24px !important;\n  }\n  .mt-md-n7 {\n    margin-top: -28px !important;\n  }\n  .mt-md-n8 {\n    margin-top: -32px !important;\n  }\n  .mt-md-n9 {\n    margin-top: -36px !important;\n  }\n  .mt-md-n10 {\n    margin-top: -40px !important;\n  }\n  .mt-md-n11 {\n    margin-top: -44px !important;\n  }\n  .mt-md-n12 {\n    margin-top: -48px !important;\n  }\n  .mt-md-n13 {\n    margin-top: -52px !important;\n  }\n  .mt-md-n14 {\n    margin-top: -56px !important;\n  }\n  .mt-md-n15 {\n    margin-top: -60px !important;\n  }\n  .mt-md-n16 {\n    margin-top: -64px !important;\n  }\n  .mr-md-n1 {\n    margin-right: -4px !important;\n  }\n  .mr-md-n2 {\n    margin-right: -8px !important;\n  }\n  .mr-md-n3 {\n    margin-right: -12px !important;\n  }\n  .mr-md-n4 {\n    margin-right: -16px !important;\n  }\n  .mr-md-n5 {\n    margin-right: -20px !important;\n  }\n  .mr-md-n6 {\n    margin-right: -24px !important;\n  }\n  .mr-md-n7 {\n    margin-right: -28px !important;\n  }\n  .mr-md-n8 {\n    margin-right: -32px !important;\n  }\n  .mr-md-n9 {\n    margin-right: -36px !important;\n  }\n  .mr-md-n10 {\n    margin-right: -40px !important;\n  }\n  .mr-md-n11 {\n    margin-right: -44px !important;\n  }\n  .mr-md-n12 {\n    margin-right: -48px !important;\n  }\n  .mr-md-n13 {\n    margin-right: -52px !important;\n  }\n  .mr-md-n14 {\n    margin-right: -56px !important;\n  }\n  .mr-md-n15 {\n    margin-right: -60px !important;\n  }\n  .mr-md-n16 {\n    margin-right: -64px !important;\n  }\n  .mb-md-n1 {\n    margin-bottom: -4px !important;\n  }\n  .mb-md-n2 {\n    margin-bottom: -8px !important;\n  }\n  .mb-md-n3 {\n    margin-bottom: -12px !important;\n  }\n  .mb-md-n4 {\n    margin-bottom: -16px !important;\n  }\n  .mb-md-n5 {\n    margin-bottom: -20px !important;\n  }\n  .mb-md-n6 {\n    margin-bottom: -24px !important;\n  }\n  .mb-md-n7 {\n    margin-bottom: -28px !important;\n  }\n  .mb-md-n8 {\n    margin-bottom: -32px !important;\n  }\n  .mb-md-n9 {\n    margin-bottom: -36px !important;\n  }\n  .mb-md-n10 {\n    margin-bottom: -40px !important;\n  }\n  .mb-md-n11 {\n    margin-bottom: -44px !important;\n  }\n  .mb-md-n12 {\n    margin-bottom: -48px !important;\n  }\n  .mb-md-n13 {\n    margin-bottom: -52px !important;\n  }\n  .mb-md-n14 {\n    margin-bottom: -56px !important;\n  }\n  .mb-md-n15 {\n    margin-bottom: -60px !important;\n  }\n  .mb-md-n16 {\n    margin-bottom: -64px !important;\n  }\n  .ml-md-n1 {\n    margin-left: -4px !important;\n  }\n  .ml-md-n2 {\n    margin-left: -8px !important;\n  }\n  .ml-md-n3 {\n    margin-left: -12px !important;\n  }\n  .ml-md-n4 {\n    margin-left: -16px !important;\n  }\n  .ml-md-n5 {\n    margin-left: -20px !important;\n  }\n  .ml-md-n6 {\n    margin-left: -24px !important;\n  }\n  .ml-md-n7 {\n    margin-left: -28px !important;\n  }\n  .ml-md-n8 {\n    margin-left: -32px !important;\n  }\n  .ml-md-n9 {\n    margin-left: -36px !important;\n  }\n  .ml-md-n10 {\n    margin-left: -40px !important;\n  }\n  .ml-md-n11 {\n    margin-left: -44px !important;\n  }\n  .ml-md-n12 {\n    margin-left: -48px !important;\n  }\n  .ml-md-n13 {\n    margin-left: -52px !important;\n  }\n  .ml-md-n14 {\n    margin-left: -56px !important;\n  }\n  .ml-md-n15 {\n    margin-left: -60px !important;\n  }\n  .ml-md-n16 {\n    margin-left: -64px !important;\n  }\n  .ms-md-n1 {\n    margin-inline-start: -4px !important;\n  }\n  .ms-md-n2 {\n    margin-inline-start: -8px !important;\n  }\n  .ms-md-n3 {\n    margin-inline-start: -12px !important;\n  }\n  .ms-md-n4 {\n    margin-inline-start: -16px !important;\n  }\n  .ms-md-n5 {\n    margin-inline-start: -20px !important;\n  }\n  .ms-md-n6 {\n    margin-inline-start: -24px !important;\n  }\n  .ms-md-n7 {\n    margin-inline-start: -28px !important;\n  }\n  .ms-md-n8 {\n    margin-inline-start: -32px !important;\n  }\n  .ms-md-n9 {\n    margin-inline-start: -36px !important;\n  }\n  .ms-md-n10 {\n    margin-inline-start: -40px !important;\n  }\n  .ms-md-n11 {\n    margin-inline-start: -44px !important;\n  }\n  .ms-md-n12 {\n    margin-inline-start: -48px !important;\n  }\n  .ms-md-n13 {\n    margin-inline-start: -52px !important;\n  }\n  .ms-md-n14 {\n    margin-inline-start: -56px !important;\n  }\n  .ms-md-n15 {\n    margin-inline-start: -60px !important;\n  }\n  .ms-md-n16 {\n    margin-inline-start: -64px !important;\n  }\n  .me-md-n1 {\n    margin-inline-end: -4px !important;\n  }\n  .me-md-n2 {\n    margin-inline-end: -8px !important;\n  }\n  .me-md-n3 {\n    margin-inline-end: -12px !important;\n  }\n  .me-md-n4 {\n    margin-inline-end: -16px !important;\n  }\n  .me-md-n5 {\n    margin-inline-end: -20px !important;\n  }\n  .me-md-n6 {\n    margin-inline-end: -24px !important;\n  }\n  .me-md-n7 {\n    margin-inline-end: -28px !important;\n  }\n  .me-md-n8 {\n    margin-inline-end: -32px !important;\n  }\n  .me-md-n9 {\n    margin-inline-end: -36px !important;\n  }\n  .me-md-n10 {\n    margin-inline-end: -40px !important;\n  }\n  .me-md-n11 {\n    margin-inline-end: -44px !important;\n  }\n  .me-md-n12 {\n    margin-inline-end: -48px !important;\n  }\n  .me-md-n13 {\n    margin-inline-end: -52px !important;\n  }\n  .me-md-n14 {\n    margin-inline-end: -56px !important;\n  }\n  .me-md-n15 {\n    margin-inline-end: -60px !important;\n  }\n  .me-md-n16 {\n    margin-inline-end: -64px !important;\n  }\n  .pa-md-0 {\n    padding: 0px !important;\n  }\n  .pa-md-1 {\n    padding: 4px !important;\n  }\n  .pa-md-2 {\n    padding: 8px !important;\n  }\n  .pa-md-3 {\n    padding: 12px !important;\n  }\n  .pa-md-4 {\n    padding: 16px !important;\n  }\n  .pa-md-5 {\n    padding: 20px !important;\n  }\n  .pa-md-6 {\n    padding: 24px !important;\n  }\n  .pa-md-7 {\n    padding: 28px !important;\n  }\n  .pa-md-8 {\n    padding: 32px !important;\n  }\n  .pa-md-9 {\n    padding: 36px !important;\n  }\n  .pa-md-10 {\n    padding: 40px !important;\n  }\n  .pa-md-11 {\n    padding: 44px !important;\n  }\n  .pa-md-12 {\n    padding: 48px !important;\n  }\n  .pa-md-13 {\n    padding: 52px !important;\n  }\n  .pa-md-14 {\n    padding: 56px !important;\n  }\n  .pa-md-15 {\n    padding: 60px !important;\n  }\n  .pa-md-16 {\n    padding: 64px !important;\n  }\n  .px-md-0 {\n    padding-right: 0px !important;\n    padding-left: 0px !important;\n  }\n  .px-md-1 {\n    padding-right: 4px !important;\n    padding-left: 4px !important;\n  }\n  .px-md-2 {\n    padding-right: 8px !important;\n    padding-left: 8px !important;\n  }\n  .px-md-3 {\n    padding-right: 12px !important;\n    padding-left: 12px !important;\n  }\n  .px-md-4 {\n    padding-right: 16px !important;\n    padding-left: 16px !important;\n  }\n  .px-md-5 {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n  }\n  .px-md-6 {\n    padding-right: 24px !important;\n    padding-left: 24px !important;\n  }\n  .px-md-7 {\n    padding-right: 28px !important;\n    padding-left: 28px !important;\n  }\n  .px-md-8 {\n    padding-right: 32px !important;\n    padding-left: 32px !important;\n  }\n  .px-md-9 {\n    padding-right: 36px !important;\n    padding-left: 36px !important;\n  }\n  .px-md-10 {\n    padding-right: 40px !important;\n    padding-left: 40px !important;\n  }\n  .px-md-11 {\n    padding-right: 44px !important;\n    padding-left: 44px !important;\n  }\n  .px-md-12 {\n    padding-right: 48px !important;\n    padding-left: 48px !important;\n  }\n  .px-md-13 {\n    padding-right: 52px !important;\n    padding-left: 52px !important;\n  }\n  .px-md-14 {\n    padding-right: 56px !important;\n    padding-left: 56px !important;\n  }\n  .px-md-15 {\n    padding-right: 60px !important;\n    padding-left: 60px !important;\n  }\n  .px-md-16 {\n    padding-right: 64px !important;\n    padding-left: 64px !important;\n  }\n  .py-md-0 {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n  .py-md-1 {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n  }\n  .py-md-2 {\n    padding-top: 8px !important;\n    padding-bottom: 8px !important;\n  }\n  .py-md-3 {\n    padding-top: 12px !important;\n    padding-bottom: 12px !important;\n  }\n  .py-md-4 {\n    padding-top: 16px !important;\n    padding-bottom: 16px !important;\n  }\n  .py-md-5 {\n    padding-top: 20px !important;\n    padding-bottom: 20px !important;\n  }\n  .py-md-6 {\n    padding-top: 24px !important;\n    padding-bottom: 24px !important;\n  }\n  .py-md-7 {\n    padding-top: 28px !important;\n    padding-bottom: 28px !important;\n  }\n  .py-md-8 {\n    padding-top: 32px !important;\n    padding-bottom: 32px !important;\n  }\n  .py-md-9 {\n    padding-top: 36px !important;\n    padding-bottom: 36px !important;\n  }\n  .py-md-10 {\n    padding-top: 40px !important;\n    padding-bottom: 40px !important;\n  }\n  .py-md-11 {\n    padding-top: 44px !important;\n    padding-bottom: 44px !important;\n  }\n  .py-md-12 {\n    padding-top: 48px !important;\n    padding-bottom: 48px !important;\n  }\n  .py-md-13 {\n    padding-top: 52px !important;\n    padding-bottom: 52px !important;\n  }\n  .py-md-14 {\n    padding-top: 56px !important;\n    padding-bottom: 56px !important;\n  }\n  .py-md-15 {\n    padding-top: 60px !important;\n    padding-bottom: 60px !important;\n  }\n  .py-md-16 {\n    padding-top: 64px !important;\n    padding-bottom: 64px !important;\n  }\n  .pt-md-0 {\n    padding-top: 0px !important;\n  }\n  .pt-md-1 {\n    padding-top: 4px !important;\n  }\n  .pt-md-2 {\n    padding-top: 8px !important;\n  }\n  .pt-md-3 {\n    padding-top: 12px !important;\n  }\n  .pt-md-4 {\n    padding-top: 16px !important;\n  }\n  .pt-md-5 {\n    padding-top: 20px !important;\n  }\n  .pt-md-6 {\n    padding-top: 24px !important;\n  }\n  .pt-md-7 {\n    padding-top: 28px !important;\n  }\n  .pt-md-8 {\n    padding-top: 32px !important;\n  }\n  .pt-md-9 {\n    padding-top: 36px !important;\n  }\n  .pt-md-10 {\n    padding-top: 40px !important;\n  }\n  .pt-md-11 {\n    padding-top: 44px !important;\n  }\n  .pt-md-12 {\n    padding-top: 48px !important;\n  }\n  .pt-md-13 {\n    padding-top: 52px !important;\n  }\n  .pt-md-14 {\n    padding-top: 56px !important;\n  }\n  .pt-md-15 {\n    padding-top: 60px !important;\n  }\n  .pt-md-16 {\n    padding-top: 64px !important;\n  }\n  .pr-md-0 {\n    padding-right: 0px !important;\n  }\n  .pr-md-1 {\n    padding-right: 4px !important;\n  }\n  .pr-md-2 {\n    padding-right: 8px !important;\n  }\n  .pr-md-3 {\n    padding-right: 12px !important;\n  }\n  .pr-md-4 {\n    padding-right: 16px !important;\n  }\n  .pr-md-5 {\n    padding-right: 20px !important;\n  }\n  .pr-md-6 {\n    padding-right: 24px !important;\n  }\n  .pr-md-7 {\n    padding-right: 28px !important;\n  }\n  .pr-md-8 {\n    padding-right: 32px !important;\n  }\n  .pr-md-9 {\n    padding-right: 36px !important;\n  }\n  .pr-md-10 {\n    padding-right: 40px !important;\n  }\n  .pr-md-11 {\n    padding-right: 44px !important;\n  }\n  .pr-md-12 {\n    padding-right: 48px !important;\n  }\n  .pr-md-13 {\n    padding-right: 52px !important;\n  }\n  .pr-md-14 {\n    padding-right: 56px !important;\n  }\n  .pr-md-15 {\n    padding-right: 60px !important;\n  }\n  .pr-md-16 {\n    padding-right: 64px !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0px !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 4px !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 8px !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 12px !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 16px !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 20px !important;\n  }\n  .pb-md-6 {\n    padding-bottom: 24px !important;\n  }\n  .pb-md-7 {\n    padding-bottom: 28px !important;\n  }\n  .pb-md-8 {\n    padding-bottom: 32px !important;\n  }\n  .pb-md-9 {\n    padding-bottom: 36px !important;\n  }\n  .pb-md-10 {\n    padding-bottom: 40px !important;\n  }\n  .pb-md-11 {\n    padding-bottom: 44px !important;\n  }\n  .pb-md-12 {\n    padding-bottom: 48px !important;\n  }\n  .pb-md-13 {\n    padding-bottom: 52px !important;\n  }\n  .pb-md-14 {\n    padding-bottom: 56px !important;\n  }\n  .pb-md-15 {\n    padding-bottom: 60px !important;\n  }\n  .pb-md-16 {\n    padding-bottom: 64px !important;\n  }\n  .pl-md-0 {\n    padding-left: 0px !important;\n  }\n  .pl-md-1 {\n    padding-left: 4px !important;\n  }\n  .pl-md-2 {\n    padding-left: 8px !important;\n  }\n  .pl-md-3 {\n    padding-left: 12px !important;\n  }\n  .pl-md-4 {\n    padding-left: 16px !important;\n  }\n  .pl-md-5 {\n    padding-left: 20px !important;\n  }\n  .pl-md-6 {\n    padding-left: 24px !important;\n  }\n  .pl-md-7 {\n    padding-left: 28px !important;\n  }\n  .pl-md-8 {\n    padding-left: 32px !important;\n  }\n  .pl-md-9 {\n    padding-left: 36px !important;\n  }\n  .pl-md-10 {\n    padding-left: 40px !important;\n  }\n  .pl-md-11 {\n    padding-left: 44px !important;\n  }\n  .pl-md-12 {\n    padding-left: 48px !important;\n  }\n  .pl-md-13 {\n    padding-left: 52px !important;\n  }\n  .pl-md-14 {\n    padding-left: 56px !important;\n  }\n  .pl-md-15 {\n    padding-left: 60px !important;\n  }\n  .pl-md-16 {\n    padding-left: 64px !important;\n  }\n  .ps-md-0 {\n    padding-inline-start: 0px !important;\n  }\n  .ps-md-1 {\n    padding-inline-start: 4px !important;\n  }\n  .ps-md-2 {\n    padding-inline-start: 8px !important;\n  }\n  .ps-md-3 {\n    padding-inline-start: 12px !important;\n  }\n  .ps-md-4 {\n    padding-inline-start: 16px !important;\n  }\n  .ps-md-5 {\n    padding-inline-start: 20px !important;\n  }\n  .ps-md-6 {\n    padding-inline-start: 24px !important;\n  }\n  .ps-md-7 {\n    padding-inline-start: 28px !important;\n  }\n  .ps-md-8 {\n    padding-inline-start: 32px !important;\n  }\n  .ps-md-9 {\n    padding-inline-start: 36px !important;\n  }\n  .ps-md-10 {\n    padding-inline-start: 40px !important;\n  }\n  .ps-md-11 {\n    padding-inline-start: 44px !important;\n  }\n  .ps-md-12 {\n    padding-inline-start: 48px !important;\n  }\n  .ps-md-13 {\n    padding-inline-start: 52px !important;\n  }\n  .ps-md-14 {\n    padding-inline-start: 56px !important;\n  }\n  .ps-md-15 {\n    padding-inline-start: 60px !important;\n  }\n  .ps-md-16 {\n    padding-inline-start: 64px !important;\n  }\n  .pe-md-0 {\n    padding-inline-end: 0px !important;\n  }\n  .pe-md-1 {\n    padding-inline-end: 4px !important;\n  }\n  .pe-md-2 {\n    padding-inline-end: 8px !important;\n  }\n  .pe-md-3 {\n    padding-inline-end: 12px !important;\n  }\n  .pe-md-4 {\n    padding-inline-end: 16px !important;\n  }\n  .pe-md-5 {\n    padding-inline-end: 20px !important;\n  }\n  .pe-md-6 {\n    padding-inline-end: 24px !important;\n  }\n  .pe-md-7 {\n    padding-inline-end: 28px !important;\n  }\n  .pe-md-8 {\n    padding-inline-end: 32px !important;\n  }\n  .pe-md-9 {\n    padding-inline-end: 36px !important;\n  }\n  .pe-md-10 {\n    padding-inline-end: 40px !important;\n  }\n  .pe-md-11 {\n    padding-inline-end: 44px !important;\n  }\n  .pe-md-12 {\n    padding-inline-end: 48px !important;\n  }\n  .pe-md-13 {\n    padding-inline-end: 52px !important;\n  }\n  .pe-md-14 {\n    padding-inline-end: 56px !important;\n  }\n  .pe-md-15 {\n    padding-inline-end: 60px !important;\n  }\n  .pe-md-16 {\n    padding-inline-end: 64px !important;\n  }\n  .text-md-left {\n    text-align: left !important;\n  }\n  .text-md-right {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n  .text-md-justify {\n    text-align: justify !important;\n  }\n  .text-md-start {\n    text-align: start !important;\n  }\n  .text-md-end {\n    text-align: end !important;\n  }\n  .text-md-h1 {\n    font-size: 6rem !important;\n    font-weight: 300;\n    line-height: 1;\n    letter-spacing: -0.015625em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-md-h2 {\n    font-size: 3.75rem !important;\n    font-weight: 300;\n    line-height: 1;\n    letter-spacing: -0.0083333333em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-md-h3 {\n    font-size: 3rem !important;\n    font-weight: 400;\n    line-height: 1.05;\n    letter-spacing: normal !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-md-h4 {\n    font-size: 2.125rem !important;\n    font-weight: 400;\n    line-height: 1.175;\n    letter-spacing: 0.0073529412em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-md-h5 {\n    font-size: 1.5rem !important;\n    font-weight: 400;\n    line-height: 1.333;\n    letter-spacing: normal !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-md-h6 {\n    font-size: 1.25rem !important;\n    font-weight: 500;\n    line-height: 1.6;\n    letter-spacing: 0.0125em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-md-subtitle-1 {\n    font-size: 1rem !important;\n    font-weight: normal;\n    line-height: 1.75;\n    letter-spacing: 0.009375em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-md-subtitle-2 {\n    font-size: 0.875rem !important;\n    font-weight: 500;\n    line-height: 1.6;\n    letter-spacing: 0.0071428571em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-md-body-1 {\n    font-size: 1rem !important;\n    font-weight: 400;\n    line-height: 1.5;\n    letter-spacing: 0.03125em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-md-body-2 {\n    font-size: 0.875rem !important;\n    font-weight: 400;\n    line-height: 1.425;\n    letter-spacing: 0.0178571429em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-md-button {\n    font-size: 0.875rem !important;\n    font-weight: 500;\n    line-height: 2.6;\n    letter-spacing: 0.0892857143em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: uppercase !important;\n  }\n  .text-md-caption {\n    font-size: 0.75rem !important;\n    font-weight: 400;\n    line-height: 1.667;\n    letter-spacing: 0.0333333333em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-md-overline {\n    font-size: 0.75rem !important;\n    font-weight: 500;\n    line-height: 2.667;\n    letter-spacing: 0.1666666667em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: uppercase !important;\n  }\n  .h-md-auto {\n    height: auto !important;\n  }\n  .h-md-screen {\n    height: 100vh !important;\n  }\n  .h-md-0 {\n    height: 0 !important;\n  }\n  .h-md-25 {\n    height: 25% !important;\n  }\n  .h-md-50 {\n    height: 50% !important;\n  }\n  .h-md-75 {\n    height: 75% !important;\n  }\n  .h-md-100 {\n    height: 100% !important;\n  }\n  .w-md-auto {\n    width: auto !important;\n  }\n  .w-md-0 {\n    width: 0 !important;\n  }\n  .w-md-25 {\n    width: 25% !important;\n  }\n  .w-md-33 {\n    width: 33% !important;\n  }\n  .w-md-50 {\n    width: 50% !important;\n  }\n  .w-md-66 {\n    width: 66% !important;\n  }\n  .w-md-75 {\n    width: 75% !important;\n  }\n  .w-md-100 {\n    width: 100% !important;\n  }\n}\n@media (min-width: 1280px) {\n  .d-lg-none {\n    display: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .float-lg-left {\n    float: left !important;\n  }\n  .float-lg-right {\n    float: right !important;\n  }\n  .v-locale--is-rtl .float-lg-end {\n    float: left !important;\n  }\n  .v-locale--is-rtl .float-lg-start {\n    float: right !important;\n  }\n  .v-locale--is-ltr .float-lg-end {\n    float: right !important;\n  }\n  .v-locale--is-ltr .float-lg-start {\n    float: left !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-1-1 {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-1-0 {\n    flex: 1 0 auto !important;\n  }\n  .flex-lg-0-1 {\n    flex: 0 1 auto !important;\n  }\n  .flex-lg-0-0 {\n    flex: 0 0 auto !important;\n  }\n  .flex-lg-1-1-100 {\n    flex: 1 1 100% !important;\n  }\n  .flex-lg-1-0-100 {\n    flex: 1 0 100% !important;\n  }\n  .flex-lg-0-1-100 {\n    flex: 0 1 100% !important;\n  }\n  .flex-lg-0-0-100 {\n    flex: 0 0 100% !important;\n  }\n  .flex-lg-1-1-0 {\n    flex: 1 1 0 !important;\n  }\n  .flex-lg-1-0-0 {\n    flex: 1 0 0 !important;\n  }\n  .flex-lg-0-1-0 {\n    flex: 0 1 0 !important;\n  }\n  .flex-lg-0-0-0 {\n    flex: 0 0 0 !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-lg-center {\n    justify-content: center !important;\n  }\n  .justify-lg-space-between {\n    justify-content: space-between !important;\n  }\n  .justify-lg-space-around {\n    justify-content: space-around !important;\n  }\n  .justify-lg-space-evenly {\n    justify-content: space-evenly !important;\n  }\n  .justify-items-lg-start {\n    justify-items: flex-start !important;\n  }\n  .justify-items-lg-end {\n    justify-items: flex-end !important;\n  }\n  .justify-items-lg-center {\n    justify-items: center !important;\n  }\n  .justify-items-lg-stretch {\n    justify-items: stretch !important;\n  }\n  .align-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-lg-center {\n    align-items: center !important;\n  }\n  .align-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-space-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-space-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-space-evenly {\n    align-content: space-evenly !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-6 {\n    order: 6 !important;\n  }\n  .order-lg-7 {\n    order: 7 !important;\n  }\n  .order-lg-8 {\n    order: 8 !important;\n  }\n  .order-lg-9 {\n    order: 9 !important;\n  }\n  .order-lg-10 {\n    order: 10 !important;\n  }\n  .order-lg-11 {\n    order: 11 !important;\n  }\n  .order-lg-12 {\n    order: 12 !important;\n  }\n  .order-lg-last {\n    order: 13 !important;\n  }\n  .ga-lg-0 {\n    gap: 0px !important;\n  }\n  .ga-lg-1 {\n    gap: 4px !important;\n  }\n  .ga-lg-2 {\n    gap: 8px !important;\n  }\n  .ga-lg-3 {\n    gap: 12px !important;\n  }\n  .ga-lg-4 {\n    gap: 16px !important;\n  }\n  .ga-lg-5 {\n    gap: 20px !important;\n  }\n  .ga-lg-6 {\n    gap: 24px !important;\n  }\n  .ga-lg-7 {\n    gap: 28px !important;\n  }\n  .ga-lg-8 {\n    gap: 32px !important;\n  }\n  .ga-lg-9 {\n    gap: 36px !important;\n  }\n  .ga-lg-10 {\n    gap: 40px !important;\n  }\n  .ga-lg-11 {\n    gap: 44px !important;\n  }\n  .ga-lg-12 {\n    gap: 48px !important;\n  }\n  .ga-lg-13 {\n    gap: 52px !important;\n  }\n  .ga-lg-14 {\n    gap: 56px !important;\n  }\n  .ga-lg-15 {\n    gap: 60px !important;\n  }\n  .ga-lg-16 {\n    gap: 64px !important;\n  }\n  .ga-lg-auto {\n    gap: auto !important;\n  }\n  .gr-lg-0 {\n    row-gap: 0px !important;\n  }\n  .gr-lg-1 {\n    row-gap: 4px !important;\n  }\n  .gr-lg-2 {\n    row-gap: 8px !important;\n  }\n  .gr-lg-3 {\n    row-gap: 12px !important;\n  }\n  .gr-lg-4 {\n    row-gap: 16px !important;\n  }\n  .gr-lg-5 {\n    row-gap: 20px !important;\n  }\n  .gr-lg-6 {\n    row-gap: 24px !important;\n  }\n  .gr-lg-7 {\n    row-gap: 28px !important;\n  }\n  .gr-lg-8 {\n    row-gap: 32px !important;\n  }\n  .gr-lg-9 {\n    row-gap: 36px !important;\n  }\n  .gr-lg-10 {\n    row-gap: 40px !important;\n  }\n  .gr-lg-11 {\n    row-gap: 44px !important;\n  }\n  .gr-lg-12 {\n    row-gap: 48px !important;\n  }\n  .gr-lg-13 {\n    row-gap: 52px !important;\n  }\n  .gr-lg-14 {\n    row-gap: 56px !important;\n  }\n  .gr-lg-15 {\n    row-gap: 60px !important;\n  }\n  .gr-lg-16 {\n    row-gap: 64px !important;\n  }\n  .gr-lg-auto {\n    row-gap: auto !important;\n  }\n  .gc-lg-0 {\n    column-gap: 0px !important;\n  }\n  .gc-lg-1 {\n    column-gap: 4px !important;\n  }\n  .gc-lg-2 {\n    column-gap: 8px !important;\n  }\n  .gc-lg-3 {\n    column-gap: 12px !important;\n  }\n  .gc-lg-4 {\n    column-gap: 16px !important;\n  }\n  .gc-lg-5 {\n    column-gap: 20px !important;\n  }\n  .gc-lg-6 {\n    column-gap: 24px !important;\n  }\n  .gc-lg-7 {\n    column-gap: 28px !important;\n  }\n  .gc-lg-8 {\n    column-gap: 32px !important;\n  }\n  .gc-lg-9 {\n    column-gap: 36px !important;\n  }\n  .gc-lg-10 {\n    column-gap: 40px !important;\n  }\n  .gc-lg-11 {\n    column-gap: 44px !important;\n  }\n  .gc-lg-12 {\n    column-gap: 48px !important;\n  }\n  .gc-lg-13 {\n    column-gap: 52px !important;\n  }\n  .gc-lg-14 {\n    column-gap: 56px !important;\n  }\n  .gc-lg-15 {\n    column-gap: 60px !important;\n  }\n  .gc-lg-16 {\n    column-gap: 64px !important;\n  }\n  .gc-lg-auto {\n    column-gap: auto !important;\n  }\n  .ma-lg-0 {\n    margin: 0px !important;\n  }\n  .ma-lg-1 {\n    margin: 4px !important;\n  }\n  .ma-lg-2 {\n    margin: 8px !important;\n  }\n  .ma-lg-3 {\n    margin: 12px !important;\n  }\n  .ma-lg-4 {\n    margin: 16px !important;\n  }\n  .ma-lg-5 {\n    margin: 20px !important;\n  }\n  .ma-lg-6 {\n    margin: 24px !important;\n  }\n  .ma-lg-7 {\n    margin: 28px !important;\n  }\n  .ma-lg-8 {\n    margin: 32px !important;\n  }\n  .ma-lg-9 {\n    margin: 36px !important;\n  }\n  .ma-lg-10 {\n    margin: 40px !important;\n  }\n  .ma-lg-11 {\n    margin: 44px !important;\n  }\n  .ma-lg-12 {\n    margin: 48px !important;\n  }\n  .ma-lg-13 {\n    margin: 52px !important;\n  }\n  .ma-lg-14 {\n    margin: 56px !important;\n  }\n  .ma-lg-15 {\n    margin: 60px !important;\n  }\n  .ma-lg-16 {\n    margin: 64px !important;\n  }\n  .ma-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0px !important;\n    margin-left: 0px !important;\n  }\n  .mx-lg-1 {\n    margin-right: 4px !important;\n    margin-left: 4px !important;\n  }\n  .mx-lg-2 {\n    margin-right: 8px !important;\n    margin-left: 8px !important;\n  }\n  .mx-lg-3 {\n    margin-right: 12px !important;\n    margin-left: 12px !important;\n  }\n  .mx-lg-4 {\n    margin-right: 16px !important;\n    margin-left: 16px !important;\n  }\n  .mx-lg-5 {\n    margin-right: 20px !important;\n    margin-left: 20px !important;\n  }\n  .mx-lg-6 {\n    margin-right: 24px !important;\n    margin-left: 24px !important;\n  }\n  .mx-lg-7 {\n    margin-right: 28px !important;\n    margin-left: 28px !important;\n  }\n  .mx-lg-8 {\n    margin-right: 32px !important;\n    margin-left: 32px !important;\n  }\n  .mx-lg-9 {\n    margin-right: 36px !important;\n    margin-left: 36px !important;\n  }\n  .mx-lg-10 {\n    margin-right: 40px !important;\n    margin-left: 40px !important;\n  }\n  .mx-lg-11 {\n    margin-right: 44px !important;\n    margin-left: 44px !important;\n  }\n  .mx-lg-12 {\n    margin-right: 48px !important;\n    margin-left: 48px !important;\n  }\n  .mx-lg-13 {\n    margin-right: 52px !important;\n    margin-left: 52px !important;\n  }\n  .mx-lg-14 {\n    margin-right: 56px !important;\n    margin-left: 56px !important;\n  }\n  .mx-lg-15 {\n    margin-right: 60px !important;\n    margin-left: 60px !important;\n  }\n  .mx-lg-16 {\n    margin-right: 64px !important;\n    margin-left: 64px !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n  .my-lg-1 {\n    margin-top: 4px !important;\n    margin-bottom: 4px !important;\n  }\n  .my-lg-2 {\n    margin-top: 8px !important;\n    margin-bottom: 8px !important;\n  }\n  .my-lg-3 {\n    margin-top: 12px !important;\n    margin-bottom: 12px !important;\n  }\n  .my-lg-4 {\n    margin-top: 16px !important;\n    margin-bottom: 16px !important;\n  }\n  .my-lg-5 {\n    margin-top: 20px !important;\n    margin-bottom: 20px !important;\n  }\n  .my-lg-6 {\n    margin-top: 24px !important;\n    margin-bottom: 24px !important;\n  }\n  .my-lg-7 {\n    margin-top: 28px !important;\n    margin-bottom: 28px !important;\n  }\n  .my-lg-8 {\n    margin-top: 32px !important;\n    margin-bottom: 32px !important;\n  }\n  .my-lg-9 {\n    margin-top: 36px !important;\n    margin-bottom: 36px !important;\n  }\n  .my-lg-10 {\n    margin-top: 40px !important;\n    margin-bottom: 40px !important;\n  }\n  .my-lg-11 {\n    margin-top: 44px !important;\n    margin-bottom: 44px !important;\n  }\n  .my-lg-12 {\n    margin-top: 48px !important;\n    margin-bottom: 48px !important;\n  }\n  .my-lg-13 {\n    margin-top: 52px !important;\n    margin-bottom: 52px !important;\n  }\n  .my-lg-14 {\n    margin-top: 56px !important;\n    margin-bottom: 56px !important;\n  }\n  .my-lg-15 {\n    margin-top: 60px !important;\n    margin-bottom: 60px !important;\n  }\n  .my-lg-16 {\n    margin-top: 64px !important;\n    margin-bottom: 64px !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0px !important;\n  }\n  .mt-lg-1 {\n    margin-top: 4px !important;\n  }\n  .mt-lg-2 {\n    margin-top: 8px !important;\n  }\n  .mt-lg-3 {\n    margin-top: 12px !important;\n  }\n  .mt-lg-4 {\n    margin-top: 16px !important;\n  }\n  .mt-lg-5 {\n    margin-top: 20px !important;\n  }\n  .mt-lg-6 {\n    margin-top: 24px !important;\n  }\n  .mt-lg-7 {\n    margin-top: 28px !important;\n  }\n  .mt-lg-8 {\n    margin-top: 32px !important;\n  }\n  .mt-lg-9 {\n    margin-top: 36px !important;\n  }\n  .mt-lg-10 {\n    margin-top: 40px !important;\n  }\n  .mt-lg-11 {\n    margin-top: 44px !important;\n  }\n  .mt-lg-12 {\n    margin-top: 48px !important;\n  }\n  .mt-lg-13 {\n    margin-top: 52px !important;\n  }\n  .mt-lg-14 {\n    margin-top: 56px !important;\n  }\n  .mt-lg-15 {\n    margin-top: 60px !important;\n  }\n  .mt-lg-16 {\n    margin-top: 64px !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .mr-lg-0 {\n    margin-right: 0px !important;\n  }\n  .mr-lg-1 {\n    margin-right: 4px !important;\n  }\n  .mr-lg-2 {\n    margin-right: 8px !important;\n  }\n  .mr-lg-3 {\n    margin-right: 12px !important;\n  }\n  .mr-lg-4 {\n    margin-right: 16px !important;\n  }\n  .mr-lg-5 {\n    margin-right: 20px !important;\n  }\n  .mr-lg-6 {\n    margin-right: 24px !important;\n  }\n  .mr-lg-7 {\n    margin-right: 28px !important;\n  }\n  .mr-lg-8 {\n    margin-right: 32px !important;\n  }\n  .mr-lg-9 {\n    margin-right: 36px !important;\n  }\n  .mr-lg-10 {\n    margin-right: 40px !important;\n  }\n  .mr-lg-11 {\n    margin-right: 44px !important;\n  }\n  .mr-lg-12 {\n    margin-right: 48px !important;\n  }\n  .mr-lg-13 {\n    margin-right: 52px !important;\n  }\n  .mr-lg-14 {\n    margin-right: 56px !important;\n  }\n  .mr-lg-15 {\n    margin-right: 60px !important;\n  }\n  .mr-lg-16 {\n    margin-right: 64px !important;\n  }\n  .mr-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0px !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 4px !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 8px !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 12px !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 16px !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 20px !important;\n  }\n  .mb-lg-6 {\n    margin-bottom: 24px !important;\n  }\n  .mb-lg-7 {\n    margin-bottom: 28px !important;\n  }\n  .mb-lg-8 {\n    margin-bottom: 32px !important;\n  }\n  .mb-lg-9 {\n    margin-bottom: 36px !important;\n  }\n  .mb-lg-10 {\n    margin-bottom: 40px !important;\n  }\n  .mb-lg-11 {\n    margin-bottom: 44px !important;\n  }\n  .mb-lg-12 {\n    margin-bottom: 48px !important;\n  }\n  .mb-lg-13 {\n    margin-bottom: 52px !important;\n  }\n  .mb-lg-14 {\n    margin-bottom: 56px !important;\n  }\n  .mb-lg-15 {\n    margin-bottom: 60px !important;\n  }\n  .mb-lg-16 {\n    margin-bottom: 64px !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-lg-0 {\n    margin-left: 0px !important;\n  }\n  .ml-lg-1 {\n    margin-left: 4px !important;\n  }\n  .ml-lg-2 {\n    margin-left: 8px !important;\n  }\n  .ml-lg-3 {\n    margin-left: 12px !important;\n  }\n  .ml-lg-4 {\n    margin-left: 16px !important;\n  }\n  .ml-lg-5 {\n    margin-left: 20px !important;\n  }\n  .ml-lg-6 {\n    margin-left: 24px !important;\n  }\n  .ml-lg-7 {\n    margin-left: 28px !important;\n  }\n  .ml-lg-8 {\n    margin-left: 32px !important;\n  }\n  .ml-lg-9 {\n    margin-left: 36px !important;\n  }\n  .ml-lg-10 {\n    margin-left: 40px !important;\n  }\n  .ml-lg-11 {\n    margin-left: 44px !important;\n  }\n  .ml-lg-12 {\n    margin-left: 48px !important;\n  }\n  .ml-lg-13 {\n    margin-left: 52px !important;\n  }\n  .ml-lg-14 {\n    margin-left: 56px !important;\n  }\n  .ml-lg-15 {\n    margin-left: 60px !important;\n  }\n  .ml-lg-16 {\n    margin-left: 64px !important;\n  }\n  .ml-lg-auto {\n    margin-left: auto !important;\n  }\n  .ms-lg-0 {\n    margin-inline-start: 0px !important;\n  }\n  .ms-lg-1 {\n    margin-inline-start: 4px !important;\n  }\n  .ms-lg-2 {\n    margin-inline-start: 8px !important;\n  }\n  .ms-lg-3 {\n    margin-inline-start: 12px !important;\n  }\n  .ms-lg-4 {\n    margin-inline-start: 16px !important;\n  }\n  .ms-lg-5 {\n    margin-inline-start: 20px !important;\n  }\n  .ms-lg-6 {\n    margin-inline-start: 24px !important;\n  }\n  .ms-lg-7 {\n    margin-inline-start: 28px !important;\n  }\n  .ms-lg-8 {\n    margin-inline-start: 32px !important;\n  }\n  .ms-lg-9 {\n    margin-inline-start: 36px !important;\n  }\n  .ms-lg-10 {\n    margin-inline-start: 40px !important;\n  }\n  .ms-lg-11 {\n    margin-inline-start: 44px !important;\n  }\n  .ms-lg-12 {\n    margin-inline-start: 48px !important;\n  }\n  .ms-lg-13 {\n    margin-inline-start: 52px !important;\n  }\n  .ms-lg-14 {\n    margin-inline-start: 56px !important;\n  }\n  .ms-lg-15 {\n    margin-inline-start: 60px !important;\n  }\n  .ms-lg-16 {\n    margin-inline-start: 64px !important;\n  }\n  .ms-lg-auto {\n    margin-inline-start: auto !important;\n  }\n  .me-lg-0 {\n    margin-inline-end: 0px !important;\n  }\n  .me-lg-1 {\n    margin-inline-end: 4px !important;\n  }\n  .me-lg-2 {\n    margin-inline-end: 8px !important;\n  }\n  .me-lg-3 {\n    margin-inline-end: 12px !important;\n  }\n  .me-lg-4 {\n    margin-inline-end: 16px !important;\n  }\n  .me-lg-5 {\n    margin-inline-end: 20px !important;\n  }\n  .me-lg-6 {\n    margin-inline-end: 24px !important;\n  }\n  .me-lg-7 {\n    margin-inline-end: 28px !important;\n  }\n  .me-lg-8 {\n    margin-inline-end: 32px !important;\n  }\n  .me-lg-9 {\n    margin-inline-end: 36px !important;\n  }\n  .me-lg-10 {\n    margin-inline-end: 40px !important;\n  }\n  .me-lg-11 {\n    margin-inline-end: 44px !important;\n  }\n  .me-lg-12 {\n    margin-inline-end: 48px !important;\n  }\n  .me-lg-13 {\n    margin-inline-end: 52px !important;\n  }\n  .me-lg-14 {\n    margin-inline-end: 56px !important;\n  }\n  .me-lg-15 {\n    margin-inline-end: 60px !important;\n  }\n  .me-lg-16 {\n    margin-inline-end: 64px !important;\n  }\n  .me-lg-auto {\n    margin-inline-end: auto !important;\n  }\n  .ma-lg-n1 {\n    margin: -4px !important;\n  }\n  .ma-lg-n2 {\n    margin: -8px !important;\n  }\n  .ma-lg-n3 {\n    margin: -12px !important;\n  }\n  .ma-lg-n4 {\n    margin: -16px !important;\n  }\n  .ma-lg-n5 {\n    margin: -20px !important;\n  }\n  .ma-lg-n6 {\n    margin: -24px !important;\n  }\n  .ma-lg-n7 {\n    margin: -28px !important;\n  }\n  .ma-lg-n8 {\n    margin: -32px !important;\n  }\n  .ma-lg-n9 {\n    margin: -36px !important;\n  }\n  .ma-lg-n10 {\n    margin: -40px !important;\n  }\n  .ma-lg-n11 {\n    margin: -44px !important;\n  }\n  .ma-lg-n12 {\n    margin: -48px !important;\n  }\n  .ma-lg-n13 {\n    margin: -52px !important;\n  }\n  .ma-lg-n14 {\n    margin: -56px !important;\n  }\n  .ma-lg-n15 {\n    margin: -60px !important;\n  }\n  .ma-lg-n16 {\n    margin: -64px !important;\n  }\n  .mx-lg-n1 {\n    margin-right: -4px !important;\n    margin-left: -4px !important;\n  }\n  .mx-lg-n2 {\n    margin-right: -8px !important;\n    margin-left: -8px !important;\n  }\n  .mx-lg-n3 {\n    margin-right: -12px !important;\n    margin-left: -12px !important;\n  }\n  .mx-lg-n4 {\n    margin-right: -16px !important;\n    margin-left: -16px !important;\n  }\n  .mx-lg-n5 {\n    margin-right: -20px !important;\n    margin-left: -20px !important;\n  }\n  .mx-lg-n6 {\n    margin-right: -24px !important;\n    margin-left: -24px !important;\n  }\n  .mx-lg-n7 {\n    margin-right: -28px !important;\n    margin-left: -28px !important;\n  }\n  .mx-lg-n8 {\n    margin-right: -32px !important;\n    margin-left: -32px !important;\n  }\n  .mx-lg-n9 {\n    margin-right: -36px !important;\n    margin-left: -36px !important;\n  }\n  .mx-lg-n10 {\n    margin-right: -40px !important;\n    margin-left: -40px !important;\n  }\n  .mx-lg-n11 {\n    margin-right: -44px !important;\n    margin-left: -44px !important;\n  }\n  .mx-lg-n12 {\n    margin-right: -48px !important;\n    margin-left: -48px !important;\n  }\n  .mx-lg-n13 {\n    margin-right: -52px !important;\n    margin-left: -52px !important;\n  }\n  .mx-lg-n14 {\n    margin-right: -56px !important;\n    margin-left: -56px !important;\n  }\n  .mx-lg-n15 {\n    margin-right: -60px !important;\n    margin-left: -60px !important;\n  }\n  .mx-lg-n16 {\n    margin-right: -64px !important;\n    margin-left: -64px !important;\n  }\n  .my-lg-n1 {\n    margin-top: -4px !important;\n    margin-bottom: -4px !important;\n  }\n  .my-lg-n2 {\n    margin-top: -8px !important;\n    margin-bottom: -8px !important;\n  }\n  .my-lg-n3 {\n    margin-top: -12px !important;\n    margin-bottom: -12px !important;\n  }\n  .my-lg-n4 {\n    margin-top: -16px !important;\n    margin-bottom: -16px !important;\n  }\n  .my-lg-n5 {\n    margin-top: -20px !important;\n    margin-bottom: -20px !important;\n  }\n  .my-lg-n6 {\n    margin-top: -24px !important;\n    margin-bottom: -24px !important;\n  }\n  .my-lg-n7 {\n    margin-top: -28px !important;\n    margin-bottom: -28px !important;\n  }\n  .my-lg-n8 {\n    margin-top: -32px !important;\n    margin-bottom: -32px !important;\n  }\n  .my-lg-n9 {\n    margin-top: -36px !important;\n    margin-bottom: -36px !important;\n  }\n  .my-lg-n10 {\n    margin-top: -40px !important;\n    margin-bottom: -40px !important;\n  }\n  .my-lg-n11 {\n    margin-top: -44px !important;\n    margin-bottom: -44px !important;\n  }\n  .my-lg-n12 {\n    margin-top: -48px !important;\n    margin-bottom: -48px !important;\n  }\n  .my-lg-n13 {\n    margin-top: -52px !important;\n    margin-bottom: -52px !important;\n  }\n  .my-lg-n14 {\n    margin-top: -56px !important;\n    margin-bottom: -56px !important;\n  }\n  .my-lg-n15 {\n    margin-top: -60px !important;\n    margin-bottom: -60px !important;\n  }\n  .my-lg-n16 {\n    margin-top: -64px !important;\n    margin-bottom: -64px !important;\n  }\n  .mt-lg-n1 {\n    margin-top: -4px !important;\n  }\n  .mt-lg-n2 {\n    margin-top: -8px !important;\n  }\n  .mt-lg-n3 {\n    margin-top: -12px !important;\n  }\n  .mt-lg-n4 {\n    margin-top: -16px !important;\n  }\n  .mt-lg-n5 {\n    margin-top: -20px !important;\n  }\n  .mt-lg-n6 {\n    margin-top: -24px !important;\n  }\n  .mt-lg-n7 {\n    margin-top: -28px !important;\n  }\n  .mt-lg-n8 {\n    margin-top: -32px !important;\n  }\n  .mt-lg-n9 {\n    margin-top: -36px !important;\n  }\n  .mt-lg-n10 {\n    margin-top: -40px !important;\n  }\n  .mt-lg-n11 {\n    margin-top: -44px !important;\n  }\n  .mt-lg-n12 {\n    margin-top: -48px !important;\n  }\n  .mt-lg-n13 {\n    margin-top: -52px !important;\n  }\n  .mt-lg-n14 {\n    margin-top: -56px !important;\n  }\n  .mt-lg-n15 {\n    margin-top: -60px !important;\n  }\n  .mt-lg-n16 {\n    margin-top: -64px !important;\n  }\n  .mr-lg-n1 {\n    margin-right: -4px !important;\n  }\n  .mr-lg-n2 {\n    margin-right: -8px !important;\n  }\n  .mr-lg-n3 {\n    margin-right: -12px !important;\n  }\n  .mr-lg-n4 {\n    margin-right: -16px !important;\n  }\n  .mr-lg-n5 {\n    margin-right: -20px !important;\n  }\n  .mr-lg-n6 {\n    margin-right: -24px !important;\n  }\n  .mr-lg-n7 {\n    margin-right: -28px !important;\n  }\n  .mr-lg-n8 {\n    margin-right: -32px !important;\n  }\n  .mr-lg-n9 {\n    margin-right: -36px !important;\n  }\n  .mr-lg-n10 {\n    margin-right: -40px !important;\n  }\n  .mr-lg-n11 {\n    margin-right: -44px !important;\n  }\n  .mr-lg-n12 {\n    margin-right: -48px !important;\n  }\n  .mr-lg-n13 {\n    margin-right: -52px !important;\n  }\n  .mr-lg-n14 {\n    margin-right: -56px !important;\n  }\n  .mr-lg-n15 {\n    margin-right: -60px !important;\n  }\n  .mr-lg-n16 {\n    margin-right: -64px !important;\n  }\n  .mb-lg-n1 {\n    margin-bottom: -4px !important;\n  }\n  .mb-lg-n2 {\n    margin-bottom: -8px !important;\n  }\n  .mb-lg-n3 {\n    margin-bottom: -12px !important;\n  }\n  .mb-lg-n4 {\n    margin-bottom: -16px !important;\n  }\n  .mb-lg-n5 {\n    margin-bottom: -20px !important;\n  }\n  .mb-lg-n6 {\n    margin-bottom: -24px !important;\n  }\n  .mb-lg-n7 {\n    margin-bottom: -28px !important;\n  }\n  .mb-lg-n8 {\n    margin-bottom: -32px !important;\n  }\n  .mb-lg-n9 {\n    margin-bottom: -36px !important;\n  }\n  .mb-lg-n10 {\n    margin-bottom: -40px !important;\n  }\n  .mb-lg-n11 {\n    margin-bottom: -44px !important;\n  }\n  .mb-lg-n12 {\n    margin-bottom: -48px !important;\n  }\n  .mb-lg-n13 {\n    margin-bottom: -52px !important;\n  }\n  .mb-lg-n14 {\n    margin-bottom: -56px !important;\n  }\n  .mb-lg-n15 {\n    margin-bottom: -60px !important;\n  }\n  .mb-lg-n16 {\n    margin-bottom: -64px !important;\n  }\n  .ml-lg-n1 {\n    margin-left: -4px !important;\n  }\n  .ml-lg-n2 {\n    margin-left: -8px !important;\n  }\n  .ml-lg-n3 {\n    margin-left: -12px !important;\n  }\n  .ml-lg-n4 {\n    margin-left: -16px !important;\n  }\n  .ml-lg-n5 {\n    margin-left: -20px !important;\n  }\n  .ml-lg-n6 {\n    margin-left: -24px !important;\n  }\n  .ml-lg-n7 {\n    margin-left: -28px !important;\n  }\n  .ml-lg-n8 {\n    margin-left: -32px !important;\n  }\n  .ml-lg-n9 {\n    margin-left: -36px !important;\n  }\n  .ml-lg-n10 {\n    margin-left: -40px !important;\n  }\n  .ml-lg-n11 {\n    margin-left: -44px !important;\n  }\n  .ml-lg-n12 {\n    margin-left: -48px !important;\n  }\n  .ml-lg-n13 {\n    margin-left: -52px !important;\n  }\n  .ml-lg-n14 {\n    margin-left: -56px !important;\n  }\n  .ml-lg-n15 {\n    margin-left: -60px !important;\n  }\n  .ml-lg-n16 {\n    margin-left: -64px !important;\n  }\n  .ms-lg-n1 {\n    margin-inline-start: -4px !important;\n  }\n  .ms-lg-n2 {\n    margin-inline-start: -8px !important;\n  }\n  .ms-lg-n3 {\n    margin-inline-start: -12px !important;\n  }\n  .ms-lg-n4 {\n    margin-inline-start: -16px !important;\n  }\n  .ms-lg-n5 {\n    margin-inline-start: -20px !important;\n  }\n  .ms-lg-n6 {\n    margin-inline-start: -24px !important;\n  }\n  .ms-lg-n7 {\n    margin-inline-start: -28px !important;\n  }\n  .ms-lg-n8 {\n    margin-inline-start: -32px !important;\n  }\n  .ms-lg-n9 {\n    margin-inline-start: -36px !important;\n  }\n  .ms-lg-n10 {\n    margin-inline-start: -40px !important;\n  }\n  .ms-lg-n11 {\n    margin-inline-start: -44px !important;\n  }\n  .ms-lg-n12 {\n    margin-inline-start: -48px !important;\n  }\n  .ms-lg-n13 {\n    margin-inline-start: -52px !important;\n  }\n  .ms-lg-n14 {\n    margin-inline-start: -56px !important;\n  }\n  .ms-lg-n15 {\n    margin-inline-start: -60px !important;\n  }\n  .ms-lg-n16 {\n    margin-inline-start: -64px !important;\n  }\n  .me-lg-n1 {\n    margin-inline-end: -4px !important;\n  }\n  .me-lg-n2 {\n    margin-inline-end: -8px !important;\n  }\n  .me-lg-n3 {\n    margin-inline-end: -12px !important;\n  }\n  .me-lg-n4 {\n    margin-inline-end: -16px !important;\n  }\n  .me-lg-n5 {\n    margin-inline-end: -20px !important;\n  }\n  .me-lg-n6 {\n    margin-inline-end: -24px !important;\n  }\n  .me-lg-n7 {\n    margin-inline-end: -28px !important;\n  }\n  .me-lg-n8 {\n    margin-inline-end: -32px !important;\n  }\n  .me-lg-n9 {\n    margin-inline-end: -36px !important;\n  }\n  .me-lg-n10 {\n    margin-inline-end: -40px !important;\n  }\n  .me-lg-n11 {\n    margin-inline-end: -44px !important;\n  }\n  .me-lg-n12 {\n    margin-inline-end: -48px !important;\n  }\n  .me-lg-n13 {\n    margin-inline-end: -52px !important;\n  }\n  .me-lg-n14 {\n    margin-inline-end: -56px !important;\n  }\n  .me-lg-n15 {\n    margin-inline-end: -60px !important;\n  }\n  .me-lg-n16 {\n    margin-inline-end: -64px !important;\n  }\n  .pa-lg-0 {\n    padding: 0px !important;\n  }\n  .pa-lg-1 {\n    padding: 4px !important;\n  }\n  .pa-lg-2 {\n    padding: 8px !important;\n  }\n  .pa-lg-3 {\n    padding: 12px !important;\n  }\n  .pa-lg-4 {\n    padding: 16px !important;\n  }\n  .pa-lg-5 {\n    padding: 20px !important;\n  }\n  .pa-lg-6 {\n    padding: 24px !important;\n  }\n  .pa-lg-7 {\n    padding: 28px !important;\n  }\n  .pa-lg-8 {\n    padding: 32px !important;\n  }\n  .pa-lg-9 {\n    padding: 36px !important;\n  }\n  .pa-lg-10 {\n    padding: 40px !important;\n  }\n  .pa-lg-11 {\n    padding: 44px !important;\n  }\n  .pa-lg-12 {\n    padding: 48px !important;\n  }\n  .pa-lg-13 {\n    padding: 52px !important;\n  }\n  .pa-lg-14 {\n    padding: 56px !important;\n  }\n  .pa-lg-15 {\n    padding: 60px !important;\n  }\n  .pa-lg-16 {\n    padding: 64px !important;\n  }\n  .px-lg-0 {\n    padding-right: 0px !important;\n    padding-left: 0px !important;\n  }\n  .px-lg-1 {\n    padding-right: 4px !important;\n    padding-left: 4px !important;\n  }\n  .px-lg-2 {\n    padding-right: 8px !important;\n    padding-left: 8px !important;\n  }\n  .px-lg-3 {\n    padding-right: 12px !important;\n    padding-left: 12px !important;\n  }\n  .px-lg-4 {\n    padding-right: 16px !important;\n    padding-left: 16px !important;\n  }\n  .px-lg-5 {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n  }\n  .px-lg-6 {\n    padding-right: 24px !important;\n    padding-left: 24px !important;\n  }\n  .px-lg-7 {\n    padding-right: 28px !important;\n    padding-left: 28px !important;\n  }\n  .px-lg-8 {\n    padding-right: 32px !important;\n    padding-left: 32px !important;\n  }\n  .px-lg-9 {\n    padding-right: 36px !important;\n    padding-left: 36px !important;\n  }\n  .px-lg-10 {\n    padding-right: 40px !important;\n    padding-left: 40px !important;\n  }\n  .px-lg-11 {\n    padding-right: 44px !important;\n    padding-left: 44px !important;\n  }\n  .px-lg-12 {\n    padding-right: 48px !important;\n    padding-left: 48px !important;\n  }\n  .px-lg-13 {\n    padding-right: 52px !important;\n    padding-left: 52px !important;\n  }\n  .px-lg-14 {\n    padding-right: 56px !important;\n    padding-left: 56px !important;\n  }\n  .px-lg-15 {\n    padding-right: 60px !important;\n    padding-left: 60px !important;\n  }\n  .px-lg-16 {\n    padding-right: 64px !important;\n    padding-left: 64px !important;\n  }\n  .py-lg-0 {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n  .py-lg-1 {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n  }\n  .py-lg-2 {\n    padding-top: 8px !important;\n    padding-bottom: 8px !important;\n  }\n  .py-lg-3 {\n    padding-top: 12px !important;\n    padding-bottom: 12px !important;\n  }\n  .py-lg-4 {\n    padding-top: 16px !important;\n    padding-bottom: 16px !important;\n  }\n  .py-lg-5 {\n    padding-top: 20px !important;\n    padding-bottom: 20px !important;\n  }\n  .py-lg-6 {\n    padding-top: 24px !important;\n    padding-bottom: 24px !important;\n  }\n  .py-lg-7 {\n    padding-top: 28px !important;\n    padding-bottom: 28px !important;\n  }\n  .py-lg-8 {\n    padding-top: 32px !important;\n    padding-bottom: 32px !important;\n  }\n  .py-lg-9 {\n    padding-top: 36px !important;\n    padding-bottom: 36px !important;\n  }\n  .py-lg-10 {\n    padding-top: 40px !important;\n    padding-bottom: 40px !important;\n  }\n  .py-lg-11 {\n    padding-top: 44px !important;\n    padding-bottom: 44px !important;\n  }\n  .py-lg-12 {\n    padding-top: 48px !important;\n    padding-bottom: 48px !important;\n  }\n  .py-lg-13 {\n    padding-top: 52px !important;\n    padding-bottom: 52px !important;\n  }\n  .py-lg-14 {\n    padding-top: 56px !important;\n    padding-bottom: 56px !important;\n  }\n  .py-lg-15 {\n    padding-top: 60px !important;\n    padding-bottom: 60px !important;\n  }\n  .py-lg-16 {\n    padding-top: 64px !important;\n    padding-bottom: 64px !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0px !important;\n  }\n  .pt-lg-1 {\n    padding-top: 4px !important;\n  }\n  .pt-lg-2 {\n    padding-top: 8px !important;\n  }\n  .pt-lg-3 {\n    padding-top: 12px !important;\n  }\n  .pt-lg-4 {\n    padding-top: 16px !important;\n  }\n  .pt-lg-5 {\n    padding-top: 20px !important;\n  }\n  .pt-lg-6 {\n    padding-top: 24px !important;\n  }\n  .pt-lg-7 {\n    padding-top: 28px !important;\n  }\n  .pt-lg-8 {\n    padding-top: 32px !important;\n  }\n  .pt-lg-9 {\n    padding-top: 36px !important;\n  }\n  .pt-lg-10 {\n    padding-top: 40px !important;\n  }\n  .pt-lg-11 {\n    padding-top: 44px !important;\n  }\n  .pt-lg-12 {\n    padding-top: 48px !important;\n  }\n  .pt-lg-13 {\n    padding-top: 52px !important;\n  }\n  .pt-lg-14 {\n    padding-top: 56px !important;\n  }\n  .pt-lg-15 {\n    padding-top: 60px !important;\n  }\n  .pt-lg-16 {\n    padding-top: 64px !important;\n  }\n  .pr-lg-0 {\n    padding-right: 0px !important;\n  }\n  .pr-lg-1 {\n    padding-right: 4px !important;\n  }\n  .pr-lg-2 {\n    padding-right: 8px !important;\n  }\n  .pr-lg-3 {\n    padding-right: 12px !important;\n  }\n  .pr-lg-4 {\n    padding-right: 16px !important;\n  }\n  .pr-lg-5 {\n    padding-right: 20px !important;\n  }\n  .pr-lg-6 {\n    padding-right: 24px !important;\n  }\n  .pr-lg-7 {\n    padding-right: 28px !important;\n  }\n  .pr-lg-8 {\n    padding-right: 32px !important;\n  }\n  .pr-lg-9 {\n    padding-right: 36px !important;\n  }\n  .pr-lg-10 {\n    padding-right: 40px !important;\n  }\n  .pr-lg-11 {\n    padding-right: 44px !important;\n  }\n  .pr-lg-12 {\n    padding-right: 48px !important;\n  }\n  .pr-lg-13 {\n    padding-right: 52px !important;\n  }\n  .pr-lg-14 {\n    padding-right: 56px !important;\n  }\n  .pr-lg-15 {\n    padding-right: 60px !important;\n  }\n  .pr-lg-16 {\n    padding-right: 64px !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0px !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 4px !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 8px !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 12px !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 16px !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 20px !important;\n  }\n  .pb-lg-6 {\n    padding-bottom: 24px !important;\n  }\n  .pb-lg-7 {\n    padding-bottom: 28px !important;\n  }\n  .pb-lg-8 {\n    padding-bottom: 32px !important;\n  }\n  .pb-lg-9 {\n    padding-bottom: 36px !important;\n  }\n  .pb-lg-10 {\n    padding-bottom: 40px !important;\n  }\n  .pb-lg-11 {\n    padding-bottom: 44px !important;\n  }\n  .pb-lg-12 {\n    padding-bottom: 48px !important;\n  }\n  .pb-lg-13 {\n    padding-bottom: 52px !important;\n  }\n  .pb-lg-14 {\n    padding-bottom: 56px !important;\n  }\n  .pb-lg-15 {\n    padding-bottom: 60px !important;\n  }\n  .pb-lg-16 {\n    padding-bottom: 64px !important;\n  }\n  .pl-lg-0 {\n    padding-left: 0px !important;\n  }\n  .pl-lg-1 {\n    padding-left: 4px !important;\n  }\n  .pl-lg-2 {\n    padding-left: 8px !important;\n  }\n  .pl-lg-3 {\n    padding-left: 12px !important;\n  }\n  .pl-lg-4 {\n    padding-left: 16px !important;\n  }\n  .pl-lg-5 {\n    padding-left: 20px !important;\n  }\n  .pl-lg-6 {\n    padding-left: 24px !important;\n  }\n  .pl-lg-7 {\n    padding-left: 28px !important;\n  }\n  .pl-lg-8 {\n    padding-left: 32px !important;\n  }\n  .pl-lg-9 {\n    padding-left: 36px !important;\n  }\n  .pl-lg-10 {\n    padding-left: 40px !important;\n  }\n  .pl-lg-11 {\n    padding-left: 44px !important;\n  }\n  .pl-lg-12 {\n    padding-left: 48px !important;\n  }\n  .pl-lg-13 {\n    padding-left: 52px !important;\n  }\n  .pl-lg-14 {\n    padding-left: 56px !important;\n  }\n  .pl-lg-15 {\n    padding-left: 60px !important;\n  }\n  .pl-lg-16 {\n    padding-left: 64px !important;\n  }\n  .ps-lg-0 {\n    padding-inline-start: 0px !important;\n  }\n  .ps-lg-1 {\n    padding-inline-start: 4px !important;\n  }\n  .ps-lg-2 {\n    padding-inline-start: 8px !important;\n  }\n  .ps-lg-3 {\n    padding-inline-start: 12px !important;\n  }\n  .ps-lg-4 {\n    padding-inline-start: 16px !important;\n  }\n  .ps-lg-5 {\n    padding-inline-start: 20px !important;\n  }\n  .ps-lg-6 {\n    padding-inline-start: 24px !important;\n  }\n  .ps-lg-7 {\n    padding-inline-start: 28px !important;\n  }\n  .ps-lg-8 {\n    padding-inline-start: 32px !important;\n  }\n  .ps-lg-9 {\n    padding-inline-start: 36px !important;\n  }\n  .ps-lg-10 {\n    padding-inline-start: 40px !important;\n  }\n  .ps-lg-11 {\n    padding-inline-start: 44px !important;\n  }\n  .ps-lg-12 {\n    padding-inline-start: 48px !important;\n  }\n  .ps-lg-13 {\n    padding-inline-start: 52px !important;\n  }\n  .ps-lg-14 {\n    padding-inline-start: 56px !important;\n  }\n  .ps-lg-15 {\n    padding-inline-start: 60px !important;\n  }\n  .ps-lg-16 {\n    padding-inline-start: 64px !important;\n  }\n  .pe-lg-0 {\n    padding-inline-end: 0px !important;\n  }\n  .pe-lg-1 {\n    padding-inline-end: 4px !important;\n  }\n  .pe-lg-2 {\n    padding-inline-end: 8px !important;\n  }\n  .pe-lg-3 {\n    padding-inline-end: 12px !important;\n  }\n  .pe-lg-4 {\n    padding-inline-end: 16px !important;\n  }\n  .pe-lg-5 {\n    padding-inline-end: 20px !important;\n  }\n  .pe-lg-6 {\n    padding-inline-end: 24px !important;\n  }\n  .pe-lg-7 {\n    padding-inline-end: 28px !important;\n  }\n  .pe-lg-8 {\n    padding-inline-end: 32px !important;\n  }\n  .pe-lg-9 {\n    padding-inline-end: 36px !important;\n  }\n  .pe-lg-10 {\n    padding-inline-end: 40px !important;\n  }\n  .pe-lg-11 {\n    padding-inline-end: 44px !important;\n  }\n  .pe-lg-12 {\n    padding-inline-end: 48px !important;\n  }\n  .pe-lg-13 {\n    padding-inline-end: 52px !important;\n  }\n  .pe-lg-14 {\n    padding-inline-end: 56px !important;\n  }\n  .pe-lg-15 {\n    padding-inline-end: 60px !important;\n  }\n  .pe-lg-16 {\n    padding-inline-end: 64px !important;\n  }\n  .text-lg-left {\n    text-align: left !important;\n  }\n  .text-lg-right {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n  .text-lg-justify {\n    text-align: justify !important;\n  }\n  .text-lg-start {\n    text-align: start !important;\n  }\n  .text-lg-end {\n    text-align: end !important;\n  }\n  .text-lg-h1 {\n    font-size: 6rem !important;\n    font-weight: 300;\n    line-height: 1;\n    letter-spacing: -0.015625em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-lg-h2 {\n    font-size: 3.75rem !important;\n    font-weight: 300;\n    line-height: 1;\n    letter-spacing: -0.0083333333em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-lg-h3 {\n    font-size: 3rem !important;\n    font-weight: 400;\n    line-height: 1.05;\n    letter-spacing: normal !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-lg-h4 {\n    font-size: 2.125rem !important;\n    font-weight: 400;\n    line-height: 1.175;\n    letter-spacing: 0.0073529412em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-lg-h5 {\n    font-size: 1.5rem !important;\n    font-weight: 400;\n    line-height: 1.333;\n    letter-spacing: normal !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-lg-h6 {\n    font-size: 1.25rem !important;\n    font-weight: 500;\n    line-height: 1.6;\n    letter-spacing: 0.0125em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-lg-subtitle-1 {\n    font-size: 1rem !important;\n    font-weight: normal;\n    line-height: 1.75;\n    letter-spacing: 0.009375em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-lg-subtitle-2 {\n    font-size: 0.875rem !important;\n    font-weight: 500;\n    line-height: 1.6;\n    letter-spacing: 0.0071428571em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-lg-body-1 {\n    font-size: 1rem !important;\n    font-weight: 400;\n    line-height: 1.5;\n    letter-spacing: 0.03125em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-lg-body-2 {\n    font-size: 0.875rem !important;\n    font-weight: 400;\n    line-height: 1.425;\n    letter-spacing: 0.0178571429em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-lg-button {\n    font-size: 0.875rem !important;\n    font-weight: 500;\n    line-height: 2.6;\n    letter-spacing: 0.0892857143em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: uppercase !important;\n  }\n  .text-lg-caption {\n    font-size: 0.75rem !important;\n    font-weight: 400;\n    line-height: 1.667;\n    letter-spacing: 0.0333333333em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-lg-overline {\n    font-size: 0.75rem !important;\n    font-weight: 500;\n    line-height: 2.667;\n    letter-spacing: 0.1666666667em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: uppercase !important;\n  }\n  .h-lg-auto {\n    height: auto !important;\n  }\n  .h-lg-screen {\n    height: 100vh !important;\n  }\n  .h-lg-0 {\n    height: 0 !important;\n  }\n  .h-lg-25 {\n    height: 25% !important;\n  }\n  .h-lg-50 {\n    height: 50% !important;\n  }\n  .h-lg-75 {\n    height: 75% !important;\n  }\n  .h-lg-100 {\n    height: 100% !important;\n  }\n  .w-lg-auto {\n    width: auto !important;\n  }\n  .w-lg-0 {\n    width: 0 !important;\n  }\n  .w-lg-25 {\n    width: 25% !important;\n  }\n  .w-lg-33 {\n    width: 33% !important;\n  }\n  .w-lg-50 {\n    width: 50% !important;\n  }\n  .w-lg-66 {\n    width: 66% !important;\n  }\n  .w-lg-75 {\n    width: 75% !important;\n  }\n  .w-lg-100 {\n    width: 100% !important;\n  }\n}\n@media (min-width: 1920px) {\n  .d-xl-none {\n    display: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .float-xl-left {\n    float: left !important;\n  }\n  .float-xl-right {\n    float: right !important;\n  }\n  .v-locale--is-rtl .float-xl-end {\n    float: left !important;\n  }\n  .v-locale--is-rtl .float-xl-start {\n    float: right !important;\n  }\n  .v-locale--is-ltr .float-xl-end {\n    float: right !important;\n  }\n  .v-locale--is-ltr .float-xl-start {\n    float: left !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-1-1 {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-1-0 {\n    flex: 1 0 auto !important;\n  }\n  .flex-xl-0-1 {\n    flex: 0 1 auto !important;\n  }\n  .flex-xl-0-0 {\n    flex: 0 0 auto !important;\n  }\n  .flex-xl-1-1-100 {\n    flex: 1 1 100% !important;\n  }\n  .flex-xl-1-0-100 {\n    flex: 1 0 100% !important;\n  }\n  .flex-xl-0-1-100 {\n    flex: 0 1 100% !important;\n  }\n  .flex-xl-0-0-100 {\n    flex: 0 0 100% !important;\n  }\n  .flex-xl-1-1-0 {\n    flex: 1 1 0 !important;\n  }\n  .flex-xl-1-0-0 {\n    flex: 1 0 0 !important;\n  }\n  .flex-xl-0-1-0 {\n    flex: 0 1 0 !important;\n  }\n  .flex-xl-0-0-0 {\n    flex: 0 0 0 !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-xl-center {\n    justify-content: center !important;\n  }\n  .justify-xl-space-between {\n    justify-content: space-between !important;\n  }\n  .justify-xl-space-around {\n    justify-content: space-around !important;\n  }\n  .justify-xl-space-evenly {\n    justify-content: space-evenly !important;\n  }\n  .justify-items-xl-start {\n    justify-items: flex-start !important;\n  }\n  .justify-items-xl-end {\n    justify-items: flex-end !important;\n  }\n  .justify-items-xl-center {\n    justify-items: center !important;\n  }\n  .justify-items-xl-stretch {\n    justify-items: stretch !important;\n  }\n  .align-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-xl-center {\n    align-items: center !important;\n  }\n  .align-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-space-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-space-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-space-evenly {\n    align-content: space-evenly !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-6 {\n    order: 6 !important;\n  }\n  .order-xl-7 {\n    order: 7 !important;\n  }\n  .order-xl-8 {\n    order: 8 !important;\n  }\n  .order-xl-9 {\n    order: 9 !important;\n  }\n  .order-xl-10 {\n    order: 10 !important;\n  }\n  .order-xl-11 {\n    order: 11 !important;\n  }\n  .order-xl-12 {\n    order: 12 !important;\n  }\n  .order-xl-last {\n    order: 13 !important;\n  }\n  .ga-xl-0 {\n    gap: 0px !important;\n  }\n  .ga-xl-1 {\n    gap: 4px !important;\n  }\n  .ga-xl-2 {\n    gap: 8px !important;\n  }\n  .ga-xl-3 {\n    gap: 12px !important;\n  }\n  .ga-xl-4 {\n    gap: 16px !important;\n  }\n  .ga-xl-5 {\n    gap: 20px !important;\n  }\n  .ga-xl-6 {\n    gap: 24px !important;\n  }\n  .ga-xl-7 {\n    gap: 28px !important;\n  }\n  .ga-xl-8 {\n    gap: 32px !important;\n  }\n  .ga-xl-9 {\n    gap: 36px !important;\n  }\n  .ga-xl-10 {\n    gap: 40px !important;\n  }\n  .ga-xl-11 {\n    gap: 44px !important;\n  }\n  .ga-xl-12 {\n    gap: 48px !important;\n  }\n  .ga-xl-13 {\n    gap: 52px !important;\n  }\n  .ga-xl-14 {\n    gap: 56px !important;\n  }\n  .ga-xl-15 {\n    gap: 60px !important;\n  }\n  .ga-xl-16 {\n    gap: 64px !important;\n  }\n  .ga-xl-auto {\n    gap: auto !important;\n  }\n  .gr-xl-0 {\n    row-gap: 0px !important;\n  }\n  .gr-xl-1 {\n    row-gap: 4px !important;\n  }\n  .gr-xl-2 {\n    row-gap: 8px !important;\n  }\n  .gr-xl-3 {\n    row-gap: 12px !important;\n  }\n  .gr-xl-4 {\n    row-gap: 16px !important;\n  }\n  .gr-xl-5 {\n    row-gap: 20px !important;\n  }\n  .gr-xl-6 {\n    row-gap: 24px !important;\n  }\n  .gr-xl-7 {\n    row-gap: 28px !important;\n  }\n  .gr-xl-8 {\n    row-gap: 32px !important;\n  }\n  .gr-xl-9 {\n    row-gap: 36px !important;\n  }\n  .gr-xl-10 {\n    row-gap: 40px !important;\n  }\n  .gr-xl-11 {\n    row-gap: 44px !important;\n  }\n  .gr-xl-12 {\n    row-gap: 48px !important;\n  }\n  .gr-xl-13 {\n    row-gap: 52px !important;\n  }\n  .gr-xl-14 {\n    row-gap: 56px !important;\n  }\n  .gr-xl-15 {\n    row-gap: 60px !important;\n  }\n  .gr-xl-16 {\n    row-gap: 64px !important;\n  }\n  .gr-xl-auto {\n    row-gap: auto !important;\n  }\n  .gc-xl-0 {\n    column-gap: 0px !important;\n  }\n  .gc-xl-1 {\n    column-gap: 4px !important;\n  }\n  .gc-xl-2 {\n    column-gap: 8px !important;\n  }\n  .gc-xl-3 {\n    column-gap: 12px !important;\n  }\n  .gc-xl-4 {\n    column-gap: 16px !important;\n  }\n  .gc-xl-5 {\n    column-gap: 20px !important;\n  }\n  .gc-xl-6 {\n    column-gap: 24px !important;\n  }\n  .gc-xl-7 {\n    column-gap: 28px !important;\n  }\n  .gc-xl-8 {\n    column-gap: 32px !important;\n  }\n  .gc-xl-9 {\n    column-gap: 36px !important;\n  }\n  .gc-xl-10 {\n    column-gap: 40px !important;\n  }\n  .gc-xl-11 {\n    column-gap: 44px !important;\n  }\n  .gc-xl-12 {\n    column-gap: 48px !important;\n  }\n  .gc-xl-13 {\n    column-gap: 52px !important;\n  }\n  .gc-xl-14 {\n    column-gap: 56px !important;\n  }\n  .gc-xl-15 {\n    column-gap: 60px !important;\n  }\n  .gc-xl-16 {\n    column-gap: 64px !important;\n  }\n  .gc-xl-auto {\n    column-gap: auto !important;\n  }\n  .ma-xl-0 {\n    margin: 0px !important;\n  }\n  .ma-xl-1 {\n    margin: 4px !important;\n  }\n  .ma-xl-2 {\n    margin: 8px !important;\n  }\n  .ma-xl-3 {\n    margin: 12px !important;\n  }\n  .ma-xl-4 {\n    margin: 16px !important;\n  }\n  .ma-xl-5 {\n    margin: 20px !important;\n  }\n  .ma-xl-6 {\n    margin: 24px !important;\n  }\n  .ma-xl-7 {\n    margin: 28px !important;\n  }\n  .ma-xl-8 {\n    margin: 32px !important;\n  }\n  .ma-xl-9 {\n    margin: 36px !important;\n  }\n  .ma-xl-10 {\n    margin: 40px !important;\n  }\n  .ma-xl-11 {\n    margin: 44px !important;\n  }\n  .ma-xl-12 {\n    margin: 48px !important;\n  }\n  .ma-xl-13 {\n    margin: 52px !important;\n  }\n  .ma-xl-14 {\n    margin: 56px !important;\n  }\n  .ma-xl-15 {\n    margin: 60px !important;\n  }\n  .ma-xl-16 {\n    margin: 64px !important;\n  }\n  .ma-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0px !important;\n    margin-left: 0px !important;\n  }\n  .mx-xl-1 {\n    margin-right: 4px !important;\n    margin-left: 4px !important;\n  }\n  .mx-xl-2 {\n    margin-right: 8px !important;\n    margin-left: 8px !important;\n  }\n  .mx-xl-3 {\n    margin-right: 12px !important;\n    margin-left: 12px !important;\n  }\n  .mx-xl-4 {\n    margin-right: 16px !important;\n    margin-left: 16px !important;\n  }\n  .mx-xl-5 {\n    margin-right: 20px !important;\n    margin-left: 20px !important;\n  }\n  .mx-xl-6 {\n    margin-right: 24px !important;\n    margin-left: 24px !important;\n  }\n  .mx-xl-7 {\n    margin-right: 28px !important;\n    margin-left: 28px !important;\n  }\n  .mx-xl-8 {\n    margin-right: 32px !important;\n    margin-left: 32px !important;\n  }\n  .mx-xl-9 {\n    margin-right: 36px !important;\n    margin-left: 36px !important;\n  }\n  .mx-xl-10 {\n    margin-right: 40px !important;\n    margin-left: 40px !important;\n  }\n  .mx-xl-11 {\n    margin-right: 44px !important;\n    margin-left: 44px !important;\n  }\n  .mx-xl-12 {\n    margin-right: 48px !important;\n    margin-left: 48px !important;\n  }\n  .mx-xl-13 {\n    margin-right: 52px !important;\n    margin-left: 52px !important;\n  }\n  .mx-xl-14 {\n    margin-right: 56px !important;\n    margin-left: 56px !important;\n  }\n  .mx-xl-15 {\n    margin-right: 60px !important;\n    margin-left: 60px !important;\n  }\n  .mx-xl-16 {\n    margin-right: 64px !important;\n    margin-left: 64px !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n  .my-xl-1 {\n    margin-top: 4px !important;\n    margin-bottom: 4px !important;\n  }\n  .my-xl-2 {\n    margin-top: 8px !important;\n    margin-bottom: 8px !important;\n  }\n  .my-xl-3 {\n    margin-top: 12px !important;\n    margin-bottom: 12px !important;\n  }\n  .my-xl-4 {\n    margin-top: 16px !important;\n    margin-bottom: 16px !important;\n  }\n  .my-xl-5 {\n    margin-top: 20px !important;\n    margin-bottom: 20px !important;\n  }\n  .my-xl-6 {\n    margin-top: 24px !important;\n    margin-bottom: 24px !important;\n  }\n  .my-xl-7 {\n    margin-top: 28px !important;\n    margin-bottom: 28px !important;\n  }\n  .my-xl-8 {\n    margin-top: 32px !important;\n    margin-bottom: 32px !important;\n  }\n  .my-xl-9 {\n    margin-top: 36px !important;\n    margin-bottom: 36px !important;\n  }\n  .my-xl-10 {\n    margin-top: 40px !important;\n    margin-bottom: 40px !important;\n  }\n  .my-xl-11 {\n    margin-top: 44px !important;\n    margin-bottom: 44px !important;\n  }\n  .my-xl-12 {\n    margin-top: 48px !important;\n    margin-bottom: 48px !important;\n  }\n  .my-xl-13 {\n    margin-top: 52px !important;\n    margin-bottom: 52px !important;\n  }\n  .my-xl-14 {\n    margin-top: 56px !important;\n    margin-bottom: 56px !important;\n  }\n  .my-xl-15 {\n    margin-top: 60px !important;\n    margin-bottom: 60px !important;\n  }\n  .my-xl-16 {\n    margin-top: 64px !important;\n    margin-bottom: 64px !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0px !important;\n  }\n  .mt-xl-1 {\n    margin-top: 4px !important;\n  }\n  .mt-xl-2 {\n    margin-top: 8px !important;\n  }\n  .mt-xl-3 {\n    margin-top: 12px !important;\n  }\n  .mt-xl-4 {\n    margin-top: 16px !important;\n  }\n  .mt-xl-5 {\n    margin-top: 20px !important;\n  }\n  .mt-xl-6 {\n    margin-top: 24px !important;\n  }\n  .mt-xl-7 {\n    margin-top: 28px !important;\n  }\n  .mt-xl-8 {\n    margin-top: 32px !important;\n  }\n  .mt-xl-9 {\n    margin-top: 36px !important;\n  }\n  .mt-xl-10 {\n    margin-top: 40px !important;\n  }\n  .mt-xl-11 {\n    margin-top: 44px !important;\n  }\n  .mt-xl-12 {\n    margin-top: 48px !important;\n  }\n  .mt-xl-13 {\n    margin-top: 52px !important;\n  }\n  .mt-xl-14 {\n    margin-top: 56px !important;\n  }\n  .mt-xl-15 {\n    margin-top: 60px !important;\n  }\n  .mt-xl-16 {\n    margin-top: 64px !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .mr-xl-0 {\n    margin-right: 0px !important;\n  }\n  .mr-xl-1 {\n    margin-right: 4px !important;\n  }\n  .mr-xl-2 {\n    margin-right: 8px !important;\n  }\n  .mr-xl-3 {\n    margin-right: 12px !important;\n  }\n  .mr-xl-4 {\n    margin-right: 16px !important;\n  }\n  .mr-xl-5 {\n    margin-right: 20px !important;\n  }\n  .mr-xl-6 {\n    margin-right: 24px !important;\n  }\n  .mr-xl-7 {\n    margin-right: 28px !important;\n  }\n  .mr-xl-8 {\n    margin-right: 32px !important;\n  }\n  .mr-xl-9 {\n    margin-right: 36px !important;\n  }\n  .mr-xl-10 {\n    margin-right: 40px !important;\n  }\n  .mr-xl-11 {\n    margin-right: 44px !important;\n  }\n  .mr-xl-12 {\n    margin-right: 48px !important;\n  }\n  .mr-xl-13 {\n    margin-right: 52px !important;\n  }\n  .mr-xl-14 {\n    margin-right: 56px !important;\n  }\n  .mr-xl-15 {\n    margin-right: 60px !important;\n  }\n  .mr-xl-16 {\n    margin-right: 64px !important;\n  }\n  .mr-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0px !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 4px !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 8px !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 12px !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 16px !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 20px !important;\n  }\n  .mb-xl-6 {\n    margin-bottom: 24px !important;\n  }\n  .mb-xl-7 {\n    margin-bottom: 28px !important;\n  }\n  .mb-xl-8 {\n    margin-bottom: 32px !important;\n  }\n  .mb-xl-9 {\n    margin-bottom: 36px !important;\n  }\n  .mb-xl-10 {\n    margin-bottom: 40px !important;\n  }\n  .mb-xl-11 {\n    margin-bottom: 44px !important;\n  }\n  .mb-xl-12 {\n    margin-bottom: 48px !important;\n  }\n  .mb-xl-13 {\n    margin-bottom: 52px !important;\n  }\n  .mb-xl-14 {\n    margin-bottom: 56px !important;\n  }\n  .mb-xl-15 {\n    margin-bottom: 60px !important;\n  }\n  .mb-xl-16 {\n    margin-bottom: 64px !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-xl-0 {\n    margin-left: 0px !important;\n  }\n  .ml-xl-1 {\n    margin-left: 4px !important;\n  }\n  .ml-xl-2 {\n    margin-left: 8px !important;\n  }\n  .ml-xl-3 {\n    margin-left: 12px !important;\n  }\n  .ml-xl-4 {\n    margin-left: 16px !important;\n  }\n  .ml-xl-5 {\n    margin-left: 20px !important;\n  }\n  .ml-xl-6 {\n    margin-left: 24px !important;\n  }\n  .ml-xl-7 {\n    margin-left: 28px !important;\n  }\n  .ml-xl-8 {\n    margin-left: 32px !important;\n  }\n  .ml-xl-9 {\n    margin-left: 36px !important;\n  }\n  .ml-xl-10 {\n    margin-left: 40px !important;\n  }\n  .ml-xl-11 {\n    margin-left: 44px !important;\n  }\n  .ml-xl-12 {\n    margin-left: 48px !important;\n  }\n  .ml-xl-13 {\n    margin-left: 52px !important;\n  }\n  .ml-xl-14 {\n    margin-left: 56px !important;\n  }\n  .ml-xl-15 {\n    margin-left: 60px !important;\n  }\n  .ml-xl-16 {\n    margin-left: 64px !important;\n  }\n  .ml-xl-auto {\n    margin-left: auto !important;\n  }\n  .ms-xl-0 {\n    margin-inline-start: 0px !important;\n  }\n  .ms-xl-1 {\n    margin-inline-start: 4px !important;\n  }\n  .ms-xl-2 {\n    margin-inline-start: 8px !important;\n  }\n  .ms-xl-3 {\n    margin-inline-start: 12px !important;\n  }\n  .ms-xl-4 {\n    margin-inline-start: 16px !important;\n  }\n  .ms-xl-5 {\n    margin-inline-start: 20px !important;\n  }\n  .ms-xl-6 {\n    margin-inline-start: 24px !important;\n  }\n  .ms-xl-7 {\n    margin-inline-start: 28px !important;\n  }\n  .ms-xl-8 {\n    margin-inline-start: 32px !important;\n  }\n  .ms-xl-9 {\n    margin-inline-start: 36px !important;\n  }\n  .ms-xl-10 {\n    margin-inline-start: 40px !important;\n  }\n  .ms-xl-11 {\n    margin-inline-start: 44px !important;\n  }\n  .ms-xl-12 {\n    margin-inline-start: 48px !important;\n  }\n  .ms-xl-13 {\n    margin-inline-start: 52px !important;\n  }\n  .ms-xl-14 {\n    margin-inline-start: 56px !important;\n  }\n  .ms-xl-15 {\n    margin-inline-start: 60px !important;\n  }\n  .ms-xl-16 {\n    margin-inline-start: 64px !important;\n  }\n  .ms-xl-auto {\n    margin-inline-start: auto !important;\n  }\n  .me-xl-0 {\n    margin-inline-end: 0px !important;\n  }\n  .me-xl-1 {\n    margin-inline-end: 4px !important;\n  }\n  .me-xl-2 {\n    margin-inline-end: 8px !important;\n  }\n  .me-xl-3 {\n    margin-inline-end: 12px !important;\n  }\n  .me-xl-4 {\n    margin-inline-end: 16px !important;\n  }\n  .me-xl-5 {\n    margin-inline-end: 20px !important;\n  }\n  .me-xl-6 {\n    margin-inline-end: 24px !important;\n  }\n  .me-xl-7 {\n    margin-inline-end: 28px !important;\n  }\n  .me-xl-8 {\n    margin-inline-end: 32px !important;\n  }\n  .me-xl-9 {\n    margin-inline-end: 36px !important;\n  }\n  .me-xl-10 {\n    margin-inline-end: 40px !important;\n  }\n  .me-xl-11 {\n    margin-inline-end: 44px !important;\n  }\n  .me-xl-12 {\n    margin-inline-end: 48px !important;\n  }\n  .me-xl-13 {\n    margin-inline-end: 52px !important;\n  }\n  .me-xl-14 {\n    margin-inline-end: 56px !important;\n  }\n  .me-xl-15 {\n    margin-inline-end: 60px !important;\n  }\n  .me-xl-16 {\n    margin-inline-end: 64px !important;\n  }\n  .me-xl-auto {\n    margin-inline-end: auto !important;\n  }\n  .ma-xl-n1 {\n    margin: -4px !important;\n  }\n  .ma-xl-n2 {\n    margin: -8px !important;\n  }\n  .ma-xl-n3 {\n    margin: -12px !important;\n  }\n  .ma-xl-n4 {\n    margin: -16px !important;\n  }\n  .ma-xl-n5 {\n    margin: -20px !important;\n  }\n  .ma-xl-n6 {\n    margin: -24px !important;\n  }\n  .ma-xl-n7 {\n    margin: -28px !important;\n  }\n  .ma-xl-n8 {\n    margin: -32px !important;\n  }\n  .ma-xl-n9 {\n    margin: -36px !important;\n  }\n  .ma-xl-n10 {\n    margin: -40px !important;\n  }\n  .ma-xl-n11 {\n    margin: -44px !important;\n  }\n  .ma-xl-n12 {\n    margin: -48px !important;\n  }\n  .ma-xl-n13 {\n    margin: -52px !important;\n  }\n  .ma-xl-n14 {\n    margin: -56px !important;\n  }\n  .ma-xl-n15 {\n    margin: -60px !important;\n  }\n  .ma-xl-n16 {\n    margin: -64px !important;\n  }\n  .mx-xl-n1 {\n    margin-right: -4px !important;\n    margin-left: -4px !important;\n  }\n  .mx-xl-n2 {\n    margin-right: -8px !important;\n    margin-left: -8px !important;\n  }\n  .mx-xl-n3 {\n    margin-right: -12px !important;\n    margin-left: -12px !important;\n  }\n  .mx-xl-n4 {\n    margin-right: -16px !important;\n    margin-left: -16px !important;\n  }\n  .mx-xl-n5 {\n    margin-right: -20px !important;\n    margin-left: -20px !important;\n  }\n  .mx-xl-n6 {\n    margin-right: -24px !important;\n    margin-left: -24px !important;\n  }\n  .mx-xl-n7 {\n    margin-right: -28px !important;\n    margin-left: -28px !important;\n  }\n  .mx-xl-n8 {\n    margin-right: -32px !important;\n    margin-left: -32px !important;\n  }\n  .mx-xl-n9 {\n    margin-right: -36px !important;\n    margin-left: -36px !important;\n  }\n  .mx-xl-n10 {\n    margin-right: -40px !important;\n    margin-left: -40px !important;\n  }\n  .mx-xl-n11 {\n    margin-right: -44px !important;\n    margin-left: -44px !important;\n  }\n  .mx-xl-n12 {\n    margin-right: -48px !important;\n    margin-left: -48px !important;\n  }\n  .mx-xl-n13 {\n    margin-right: -52px !important;\n    margin-left: -52px !important;\n  }\n  .mx-xl-n14 {\n    margin-right: -56px !important;\n    margin-left: -56px !important;\n  }\n  .mx-xl-n15 {\n    margin-right: -60px !important;\n    margin-left: -60px !important;\n  }\n  .mx-xl-n16 {\n    margin-right: -64px !important;\n    margin-left: -64px !important;\n  }\n  .my-xl-n1 {\n    margin-top: -4px !important;\n    margin-bottom: -4px !important;\n  }\n  .my-xl-n2 {\n    margin-top: -8px !important;\n    margin-bottom: -8px !important;\n  }\n  .my-xl-n3 {\n    margin-top: -12px !important;\n    margin-bottom: -12px !important;\n  }\n  .my-xl-n4 {\n    margin-top: -16px !important;\n    margin-bottom: -16px !important;\n  }\n  .my-xl-n5 {\n    margin-top: -20px !important;\n    margin-bottom: -20px !important;\n  }\n  .my-xl-n6 {\n    margin-top: -24px !important;\n    margin-bottom: -24px !important;\n  }\n  .my-xl-n7 {\n    margin-top: -28px !important;\n    margin-bottom: -28px !important;\n  }\n  .my-xl-n8 {\n    margin-top: -32px !important;\n    margin-bottom: -32px !important;\n  }\n  .my-xl-n9 {\n    margin-top: -36px !important;\n    margin-bottom: -36px !important;\n  }\n  .my-xl-n10 {\n    margin-top: -40px !important;\n    margin-bottom: -40px !important;\n  }\n  .my-xl-n11 {\n    margin-top: -44px !important;\n    margin-bottom: -44px !important;\n  }\n  .my-xl-n12 {\n    margin-top: -48px !important;\n    margin-bottom: -48px !important;\n  }\n  .my-xl-n13 {\n    margin-top: -52px !important;\n    margin-bottom: -52px !important;\n  }\n  .my-xl-n14 {\n    margin-top: -56px !important;\n    margin-bottom: -56px !important;\n  }\n  .my-xl-n15 {\n    margin-top: -60px !important;\n    margin-bottom: -60px !important;\n  }\n  .my-xl-n16 {\n    margin-top: -64px !important;\n    margin-bottom: -64px !important;\n  }\n  .mt-xl-n1 {\n    margin-top: -4px !important;\n  }\n  .mt-xl-n2 {\n    margin-top: -8px !important;\n  }\n  .mt-xl-n3 {\n    margin-top: -12px !important;\n  }\n  .mt-xl-n4 {\n    margin-top: -16px !important;\n  }\n  .mt-xl-n5 {\n    margin-top: -20px !important;\n  }\n  .mt-xl-n6 {\n    margin-top: -24px !important;\n  }\n  .mt-xl-n7 {\n    margin-top: -28px !important;\n  }\n  .mt-xl-n8 {\n    margin-top: -32px !important;\n  }\n  .mt-xl-n9 {\n    margin-top: -36px !important;\n  }\n  .mt-xl-n10 {\n    margin-top: -40px !important;\n  }\n  .mt-xl-n11 {\n    margin-top: -44px !important;\n  }\n  .mt-xl-n12 {\n    margin-top: -48px !important;\n  }\n  .mt-xl-n13 {\n    margin-top: -52px !important;\n  }\n  .mt-xl-n14 {\n    margin-top: -56px !important;\n  }\n  .mt-xl-n15 {\n    margin-top: -60px !important;\n  }\n  .mt-xl-n16 {\n    margin-top: -64px !important;\n  }\n  .mr-xl-n1 {\n    margin-right: -4px !important;\n  }\n  .mr-xl-n2 {\n    margin-right: -8px !important;\n  }\n  .mr-xl-n3 {\n    margin-right: -12px !important;\n  }\n  .mr-xl-n4 {\n    margin-right: -16px !important;\n  }\n  .mr-xl-n5 {\n    margin-right: -20px !important;\n  }\n  .mr-xl-n6 {\n    margin-right: -24px !important;\n  }\n  .mr-xl-n7 {\n    margin-right: -28px !important;\n  }\n  .mr-xl-n8 {\n    margin-right: -32px !important;\n  }\n  .mr-xl-n9 {\n    margin-right: -36px !important;\n  }\n  .mr-xl-n10 {\n    margin-right: -40px !important;\n  }\n  .mr-xl-n11 {\n    margin-right: -44px !important;\n  }\n  .mr-xl-n12 {\n    margin-right: -48px !important;\n  }\n  .mr-xl-n13 {\n    margin-right: -52px !important;\n  }\n  .mr-xl-n14 {\n    margin-right: -56px !important;\n  }\n  .mr-xl-n15 {\n    margin-right: -60px !important;\n  }\n  .mr-xl-n16 {\n    margin-right: -64px !important;\n  }\n  .mb-xl-n1 {\n    margin-bottom: -4px !important;\n  }\n  .mb-xl-n2 {\n    margin-bottom: -8px !important;\n  }\n  .mb-xl-n3 {\n    margin-bottom: -12px !important;\n  }\n  .mb-xl-n4 {\n    margin-bottom: -16px !important;\n  }\n  .mb-xl-n5 {\n    margin-bottom: -20px !important;\n  }\n  .mb-xl-n6 {\n    margin-bottom: -24px !important;\n  }\n  .mb-xl-n7 {\n    margin-bottom: -28px !important;\n  }\n  .mb-xl-n8 {\n    margin-bottom: -32px !important;\n  }\n  .mb-xl-n9 {\n    margin-bottom: -36px !important;\n  }\n  .mb-xl-n10 {\n    margin-bottom: -40px !important;\n  }\n  .mb-xl-n11 {\n    margin-bottom: -44px !important;\n  }\n  .mb-xl-n12 {\n    margin-bottom: -48px !important;\n  }\n  .mb-xl-n13 {\n    margin-bottom: -52px !important;\n  }\n  .mb-xl-n14 {\n    margin-bottom: -56px !important;\n  }\n  .mb-xl-n15 {\n    margin-bottom: -60px !important;\n  }\n  .mb-xl-n16 {\n    margin-bottom: -64px !important;\n  }\n  .ml-xl-n1 {\n    margin-left: -4px !important;\n  }\n  .ml-xl-n2 {\n    margin-left: -8px !important;\n  }\n  .ml-xl-n3 {\n    margin-left: -12px !important;\n  }\n  .ml-xl-n4 {\n    margin-left: -16px !important;\n  }\n  .ml-xl-n5 {\n    margin-left: -20px !important;\n  }\n  .ml-xl-n6 {\n    margin-left: -24px !important;\n  }\n  .ml-xl-n7 {\n    margin-left: -28px !important;\n  }\n  .ml-xl-n8 {\n    margin-left: -32px !important;\n  }\n  .ml-xl-n9 {\n    margin-left: -36px !important;\n  }\n  .ml-xl-n10 {\n    margin-left: -40px !important;\n  }\n  .ml-xl-n11 {\n    margin-left: -44px !important;\n  }\n  .ml-xl-n12 {\n    margin-left: -48px !important;\n  }\n  .ml-xl-n13 {\n    margin-left: -52px !important;\n  }\n  .ml-xl-n14 {\n    margin-left: -56px !important;\n  }\n  .ml-xl-n15 {\n    margin-left: -60px !important;\n  }\n  .ml-xl-n16 {\n    margin-left: -64px !important;\n  }\n  .ms-xl-n1 {\n    margin-inline-start: -4px !important;\n  }\n  .ms-xl-n2 {\n    margin-inline-start: -8px !important;\n  }\n  .ms-xl-n3 {\n    margin-inline-start: -12px !important;\n  }\n  .ms-xl-n4 {\n    margin-inline-start: -16px !important;\n  }\n  .ms-xl-n5 {\n    margin-inline-start: -20px !important;\n  }\n  .ms-xl-n6 {\n    margin-inline-start: -24px !important;\n  }\n  .ms-xl-n7 {\n    margin-inline-start: -28px !important;\n  }\n  .ms-xl-n8 {\n    margin-inline-start: -32px !important;\n  }\n  .ms-xl-n9 {\n    margin-inline-start: -36px !important;\n  }\n  .ms-xl-n10 {\n    margin-inline-start: -40px !important;\n  }\n  .ms-xl-n11 {\n    margin-inline-start: -44px !important;\n  }\n  .ms-xl-n12 {\n    margin-inline-start: -48px !important;\n  }\n  .ms-xl-n13 {\n    margin-inline-start: -52px !important;\n  }\n  .ms-xl-n14 {\n    margin-inline-start: -56px !important;\n  }\n  .ms-xl-n15 {\n    margin-inline-start: -60px !important;\n  }\n  .ms-xl-n16 {\n    margin-inline-start: -64px !important;\n  }\n  .me-xl-n1 {\n    margin-inline-end: -4px !important;\n  }\n  .me-xl-n2 {\n    margin-inline-end: -8px !important;\n  }\n  .me-xl-n3 {\n    margin-inline-end: -12px !important;\n  }\n  .me-xl-n4 {\n    margin-inline-end: -16px !important;\n  }\n  .me-xl-n5 {\n    margin-inline-end: -20px !important;\n  }\n  .me-xl-n6 {\n    margin-inline-end: -24px !important;\n  }\n  .me-xl-n7 {\n    margin-inline-end: -28px !important;\n  }\n  .me-xl-n8 {\n    margin-inline-end: -32px !important;\n  }\n  .me-xl-n9 {\n    margin-inline-end: -36px !important;\n  }\n  .me-xl-n10 {\n    margin-inline-end: -40px !important;\n  }\n  .me-xl-n11 {\n    margin-inline-end: -44px !important;\n  }\n  .me-xl-n12 {\n    margin-inline-end: -48px !important;\n  }\n  .me-xl-n13 {\n    margin-inline-end: -52px !important;\n  }\n  .me-xl-n14 {\n    margin-inline-end: -56px !important;\n  }\n  .me-xl-n15 {\n    margin-inline-end: -60px !important;\n  }\n  .me-xl-n16 {\n    margin-inline-end: -64px !important;\n  }\n  .pa-xl-0 {\n    padding: 0px !important;\n  }\n  .pa-xl-1 {\n    padding: 4px !important;\n  }\n  .pa-xl-2 {\n    padding: 8px !important;\n  }\n  .pa-xl-3 {\n    padding: 12px !important;\n  }\n  .pa-xl-4 {\n    padding: 16px !important;\n  }\n  .pa-xl-5 {\n    padding: 20px !important;\n  }\n  .pa-xl-6 {\n    padding: 24px !important;\n  }\n  .pa-xl-7 {\n    padding: 28px !important;\n  }\n  .pa-xl-8 {\n    padding: 32px !important;\n  }\n  .pa-xl-9 {\n    padding: 36px !important;\n  }\n  .pa-xl-10 {\n    padding: 40px !important;\n  }\n  .pa-xl-11 {\n    padding: 44px !important;\n  }\n  .pa-xl-12 {\n    padding: 48px !important;\n  }\n  .pa-xl-13 {\n    padding: 52px !important;\n  }\n  .pa-xl-14 {\n    padding: 56px !important;\n  }\n  .pa-xl-15 {\n    padding: 60px !important;\n  }\n  .pa-xl-16 {\n    padding: 64px !important;\n  }\n  .px-xl-0 {\n    padding-right: 0px !important;\n    padding-left: 0px !important;\n  }\n  .px-xl-1 {\n    padding-right: 4px !important;\n    padding-left: 4px !important;\n  }\n  .px-xl-2 {\n    padding-right: 8px !important;\n    padding-left: 8px !important;\n  }\n  .px-xl-3 {\n    padding-right: 12px !important;\n    padding-left: 12px !important;\n  }\n  .px-xl-4 {\n    padding-right: 16px !important;\n    padding-left: 16px !important;\n  }\n  .px-xl-5 {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n  }\n  .px-xl-6 {\n    padding-right: 24px !important;\n    padding-left: 24px !important;\n  }\n  .px-xl-7 {\n    padding-right: 28px !important;\n    padding-left: 28px !important;\n  }\n  .px-xl-8 {\n    padding-right: 32px !important;\n    padding-left: 32px !important;\n  }\n  .px-xl-9 {\n    padding-right: 36px !important;\n    padding-left: 36px !important;\n  }\n  .px-xl-10 {\n    padding-right: 40px !important;\n    padding-left: 40px !important;\n  }\n  .px-xl-11 {\n    padding-right: 44px !important;\n    padding-left: 44px !important;\n  }\n  .px-xl-12 {\n    padding-right: 48px !important;\n    padding-left: 48px !important;\n  }\n  .px-xl-13 {\n    padding-right: 52px !important;\n    padding-left: 52px !important;\n  }\n  .px-xl-14 {\n    padding-right: 56px !important;\n    padding-left: 56px !important;\n  }\n  .px-xl-15 {\n    padding-right: 60px !important;\n    padding-left: 60px !important;\n  }\n  .px-xl-16 {\n    padding-right: 64px !important;\n    padding-left: 64px !important;\n  }\n  .py-xl-0 {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n  .py-xl-1 {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n  }\n  .py-xl-2 {\n    padding-top: 8px !important;\n    padding-bottom: 8px !important;\n  }\n  .py-xl-3 {\n    padding-top: 12px !important;\n    padding-bottom: 12px !important;\n  }\n  .py-xl-4 {\n    padding-top: 16px !important;\n    padding-bottom: 16px !important;\n  }\n  .py-xl-5 {\n    padding-top: 20px !important;\n    padding-bottom: 20px !important;\n  }\n  .py-xl-6 {\n    padding-top: 24px !important;\n    padding-bottom: 24px !important;\n  }\n  .py-xl-7 {\n    padding-top: 28px !important;\n    padding-bottom: 28px !important;\n  }\n  .py-xl-8 {\n    padding-top: 32px !important;\n    padding-bottom: 32px !important;\n  }\n  .py-xl-9 {\n    padding-top: 36px !important;\n    padding-bottom: 36px !important;\n  }\n  .py-xl-10 {\n    padding-top: 40px !important;\n    padding-bottom: 40px !important;\n  }\n  .py-xl-11 {\n    padding-top: 44px !important;\n    padding-bottom: 44px !important;\n  }\n  .py-xl-12 {\n    padding-top: 48px !important;\n    padding-bottom: 48px !important;\n  }\n  .py-xl-13 {\n    padding-top: 52px !important;\n    padding-bottom: 52px !important;\n  }\n  .py-xl-14 {\n    padding-top: 56px !important;\n    padding-bottom: 56px !important;\n  }\n  .py-xl-15 {\n    padding-top: 60px !important;\n    padding-bottom: 60px !important;\n  }\n  .py-xl-16 {\n    padding-top: 64px !important;\n    padding-bottom: 64px !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0px !important;\n  }\n  .pt-xl-1 {\n    padding-top: 4px !important;\n  }\n  .pt-xl-2 {\n    padding-top: 8px !important;\n  }\n  .pt-xl-3 {\n    padding-top: 12px !important;\n  }\n  .pt-xl-4 {\n    padding-top: 16px !important;\n  }\n  .pt-xl-5 {\n    padding-top: 20px !important;\n  }\n  .pt-xl-6 {\n    padding-top: 24px !important;\n  }\n  .pt-xl-7 {\n    padding-top: 28px !important;\n  }\n  .pt-xl-8 {\n    padding-top: 32px !important;\n  }\n  .pt-xl-9 {\n    padding-top: 36px !important;\n  }\n  .pt-xl-10 {\n    padding-top: 40px !important;\n  }\n  .pt-xl-11 {\n    padding-top: 44px !important;\n  }\n  .pt-xl-12 {\n    padding-top: 48px !important;\n  }\n  .pt-xl-13 {\n    padding-top: 52px !important;\n  }\n  .pt-xl-14 {\n    padding-top: 56px !important;\n  }\n  .pt-xl-15 {\n    padding-top: 60px !important;\n  }\n  .pt-xl-16 {\n    padding-top: 64px !important;\n  }\n  .pr-xl-0 {\n    padding-right: 0px !important;\n  }\n  .pr-xl-1 {\n    padding-right: 4px !important;\n  }\n  .pr-xl-2 {\n    padding-right: 8px !important;\n  }\n  .pr-xl-3 {\n    padding-right: 12px !important;\n  }\n  .pr-xl-4 {\n    padding-right: 16px !important;\n  }\n  .pr-xl-5 {\n    padding-right: 20px !important;\n  }\n  .pr-xl-6 {\n    padding-right: 24px !important;\n  }\n  .pr-xl-7 {\n    padding-right: 28px !important;\n  }\n  .pr-xl-8 {\n    padding-right: 32px !important;\n  }\n  .pr-xl-9 {\n    padding-right: 36px !important;\n  }\n  .pr-xl-10 {\n    padding-right: 40px !important;\n  }\n  .pr-xl-11 {\n    padding-right: 44px !important;\n  }\n  .pr-xl-12 {\n    padding-right: 48px !important;\n  }\n  .pr-xl-13 {\n    padding-right: 52px !important;\n  }\n  .pr-xl-14 {\n    padding-right: 56px !important;\n  }\n  .pr-xl-15 {\n    padding-right: 60px !important;\n  }\n  .pr-xl-16 {\n    padding-right: 64px !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0px !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 4px !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 8px !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 12px !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 16px !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 20px !important;\n  }\n  .pb-xl-6 {\n    padding-bottom: 24px !important;\n  }\n  .pb-xl-7 {\n    padding-bottom: 28px !important;\n  }\n  .pb-xl-8 {\n    padding-bottom: 32px !important;\n  }\n  .pb-xl-9 {\n    padding-bottom: 36px !important;\n  }\n  .pb-xl-10 {\n    padding-bottom: 40px !important;\n  }\n  .pb-xl-11 {\n    padding-bottom: 44px !important;\n  }\n  .pb-xl-12 {\n    padding-bottom: 48px !important;\n  }\n  .pb-xl-13 {\n    padding-bottom: 52px !important;\n  }\n  .pb-xl-14 {\n    padding-bottom: 56px !important;\n  }\n  .pb-xl-15 {\n    padding-bottom: 60px !important;\n  }\n  .pb-xl-16 {\n    padding-bottom: 64px !important;\n  }\n  .pl-xl-0 {\n    padding-left: 0px !important;\n  }\n  .pl-xl-1 {\n    padding-left: 4px !important;\n  }\n  .pl-xl-2 {\n    padding-left: 8px !important;\n  }\n  .pl-xl-3 {\n    padding-left: 12px !important;\n  }\n  .pl-xl-4 {\n    padding-left: 16px !important;\n  }\n  .pl-xl-5 {\n    padding-left: 20px !important;\n  }\n  .pl-xl-6 {\n    padding-left: 24px !important;\n  }\n  .pl-xl-7 {\n    padding-left: 28px !important;\n  }\n  .pl-xl-8 {\n    padding-left: 32px !important;\n  }\n  .pl-xl-9 {\n    padding-left: 36px !important;\n  }\n  .pl-xl-10 {\n    padding-left: 40px !important;\n  }\n  .pl-xl-11 {\n    padding-left: 44px !important;\n  }\n  .pl-xl-12 {\n    padding-left: 48px !important;\n  }\n  .pl-xl-13 {\n    padding-left: 52px !important;\n  }\n  .pl-xl-14 {\n    padding-left: 56px !important;\n  }\n  .pl-xl-15 {\n    padding-left: 60px !important;\n  }\n  .pl-xl-16 {\n    padding-left: 64px !important;\n  }\n  .ps-xl-0 {\n    padding-inline-start: 0px !important;\n  }\n  .ps-xl-1 {\n    padding-inline-start: 4px !important;\n  }\n  .ps-xl-2 {\n    padding-inline-start: 8px !important;\n  }\n  .ps-xl-3 {\n    padding-inline-start: 12px !important;\n  }\n  .ps-xl-4 {\n    padding-inline-start: 16px !important;\n  }\n  .ps-xl-5 {\n    padding-inline-start: 20px !important;\n  }\n  .ps-xl-6 {\n    padding-inline-start: 24px !important;\n  }\n  .ps-xl-7 {\n    padding-inline-start: 28px !important;\n  }\n  .ps-xl-8 {\n    padding-inline-start: 32px !important;\n  }\n  .ps-xl-9 {\n    padding-inline-start: 36px !important;\n  }\n  .ps-xl-10 {\n    padding-inline-start: 40px !important;\n  }\n  .ps-xl-11 {\n    padding-inline-start: 44px !important;\n  }\n  .ps-xl-12 {\n    padding-inline-start: 48px !important;\n  }\n  .ps-xl-13 {\n    padding-inline-start: 52px !important;\n  }\n  .ps-xl-14 {\n    padding-inline-start: 56px !important;\n  }\n  .ps-xl-15 {\n    padding-inline-start: 60px !important;\n  }\n  .ps-xl-16 {\n    padding-inline-start: 64px !important;\n  }\n  .pe-xl-0 {\n    padding-inline-end: 0px !important;\n  }\n  .pe-xl-1 {\n    padding-inline-end: 4px !important;\n  }\n  .pe-xl-2 {\n    padding-inline-end: 8px !important;\n  }\n  .pe-xl-3 {\n    padding-inline-end: 12px !important;\n  }\n  .pe-xl-4 {\n    padding-inline-end: 16px !important;\n  }\n  .pe-xl-5 {\n    padding-inline-end: 20px !important;\n  }\n  .pe-xl-6 {\n    padding-inline-end: 24px !important;\n  }\n  .pe-xl-7 {\n    padding-inline-end: 28px !important;\n  }\n  .pe-xl-8 {\n    padding-inline-end: 32px !important;\n  }\n  .pe-xl-9 {\n    padding-inline-end: 36px !important;\n  }\n  .pe-xl-10 {\n    padding-inline-end: 40px !important;\n  }\n  .pe-xl-11 {\n    padding-inline-end: 44px !important;\n  }\n  .pe-xl-12 {\n    padding-inline-end: 48px !important;\n  }\n  .pe-xl-13 {\n    padding-inline-end: 52px !important;\n  }\n  .pe-xl-14 {\n    padding-inline-end: 56px !important;\n  }\n  .pe-xl-15 {\n    padding-inline-end: 60px !important;\n  }\n  .pe-xl-16 {\n    padding-inline-end: 64px !important;\n  }\n  .text-xl-left {\n    text-align: left !important;\n  }\n  .text-xl-right {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n  .text-xl-justify {\n    text-align: justify !important;\n  }\n  .text-xl-start {\n    text-align: start !important;\n  }\n  .text-xl-end {\n    text-align: end !important;\n  }\n  .text-xl-h1 {\n    font-size: 6rem !important;\n    font-weight: 300;\n    line-height: 1;\n    letter-spacing: -0.015625em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xl-h2 {\n    font-size: 3.75rem !important;\n    font-weight: 300;\n    line-height: 1;\n    letter-spacing: -0.0083333333em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xl-h3 {\n    font-size: 3rem !important;\n    font-weight: 400;\n    line-height: 1.05;\n    letter-spacing: normal !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xl-h4 {\n    font-size: 2.125rem !important;\n    font-weight: 400;\n    line-height: 1.175;\n    letter-spacing: 0.0073529412em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xl-h5 {\n    font-size: 1.5rem !important;\n    font-weight: 400;\n    line-height: 1.333;\n    letter-spacing: normal !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xl-h6 {\n    font-size: 1.25rem !important;\n    font-weight: 500;\n    line-height: 1.6;\n    letter-spacing: 0.0125em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xl-subtitle-1 {\n    font-size: 1rem !important;\n    font-weight: normal;\n    line-height: 1.75;\n    letter-spacing: 0.009375em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xl-subtitle-2 {\n    font-size: 0.875rem !important;\n    font-weight: 500;\n    line-height: 1.6;\n    letter-spacing: 0.0071428571em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xl-body-1 {\n    font-size: 1rem !important;\n    font-weight: 400;\n    line-height: 1.5;\n    letter-spacing: 0.03125em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xl-body-2 {\n    font-size: 0.875rem !important;\n    font-weight: 400;\n    line-height: 1.425;\n    letter-spacing: 0.0178571429em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xl-button {\n    font-size: 0.875rem !important;\n    font-weight: 500;\n    line-height: 2.6;\n    letter-spacing: 0.0892857143em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: uppercase !important;\n  }\n  .text-xl-caption {\n    font-size: 0.75rem !important;\n    font-weight: 400;\n    line-height: 1.667;\n    letter-spacing: 0.0333333333em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xl-overline {\n    font-size: 0.75rem !important;\n    font-weight: 500;\n    line-height: 2.667;\n    letter-spacing: 0.1666666667em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: uppercase !important;\n  }\n  .h-xl-auto {\n    height: auto !important;\n  }\n  .h-xl-screen {\n    height: 100vh !important;\n  }\n  .h-xl-0 {\n    height: 0 !important;\n  }\n  .h-xl-25 {\n    height: 25% !important;\n  }\n  .h-xl-50 {\n    height: 50% !important;\n  }\n  .h-xl-75 {\n    height: 75% !important;\n  }\n  .h-xl-100 {\n    height: 100% !important;\n  }\n  .w-xl-auto {\n    width: auto !important;\n  }\n  .w-xl-0 {\n    width: 0 !important;\n  }\n  .w-xl-25 {\n    width: 25% !important;\n  }\n  .w-xl-33 {\n    width: 33% !important;\n  }\n  .w-xl-50 {\n    width: 50% !important;\n  }\n  .w-xl-66 {\n    width: 66% !important;\n  }\n  .w-xl-75 {\n    width: 75% !important;\n  }\n  .w-xl-100 {\n    width: 100% !important;\n  }\n}\n@media (min-width: 2560px) {\n  .d-xxl-none {\n    display: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .float-xxl-left {\n    float: left !important;\n  }\n  .float-xxl-right {\n    float: right !important;\n  }\n  .v-locale--is-rtl .float-xxl-end {\n    float: left !important;\n  }\n  .v-locale--is-rtl .float-xxl-start {\n    float: right !important;\n  }\n  .v-locale--is-ltr .float-xxl-end {\n    float: right !important;\n  }\n  .v-locale--is-ltr .float-xxl-start {\n    float: left !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-1-1 {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-1-0 {\n    flex: 1 0 auto !important;\n  }\n  .flex-xxl-0-1 {\n    flex: 0 1 auto !important;\n  }\n  .flex-xxl-0-0 {\n    flex: 0 0 auto !important;\n  }\n  .flex-xxl-1-1-100 {\n    flex: 1 1 100% !important;\n  }\n  .flex-xxl-1-0-100 {\n    flex: 1 0 100% !important;\n  }\n  .flex-xxl-0-1-100 {\n    flex: 0 1 100% !important;\n  }\n  .flex-xxl-0-0-100 {\n    flex: 0 0 100% !important;\n  }\n  .flex-xxl-1-1-0 {\n    flex: 1 1 0 !important;\n  }\n  .flex-xxl-1-0-0 {\n    flex: 1 0 0 !important;\n  }\n  .flex-xxl-0-1-0 {\n    flex: 0 1 0 !important;\n  }\n  .flex-xxl-0-0-0 {\n    flex: 0 0 0 !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-xxl-space-between {\n    justify-content: space-between !important;\n  }\n  .justify-xxl-space-around {\n    justify-content: space-around !important;\n  }\n  .justify-xxl-space-evenly {\n    justify-content: space-evenly !important;\n  }\n  .justify-items-xxl-start {\n    justify-items: flex-start !important;\n  }\n  .justify-items-xxl-end {\n    justify-items: flex-end !important;\n  }\n  .justify-items-xxl-center {\n    justify-items: center !important;\n  }\n  .justify-items-xxl-stretch {\n    justify-items: stretch !important;\n  }\n  .align-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-xxl-center {\n    align-items: center !important;\n  }\n  .align-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-space-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-space-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-space-evenly {\n    align-content: space-evenly !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-6 {\n    order: 6 !important;\n  }\n  .order-xxl-7 {\n    order: 7 !important;\n  }\n  .order-xxl-8 {\n    order: 8 !important;\n  }\n  .order-xxl-9 {\n    order: 9 !important;\n  }\n  .order-xxl-10 {\n    order: 10 !important;\n  }\n  .order-xxl-11 {\n    order: 11 !important;\n  }\n  .order-xxl-12 {\n    order: 12 !important;\n  }\n  .order-xxl-last {\n    order: 13 !important;\n  }\n  .ga-xxl-0 {\n    gap: 0px !important;\n  }\n  .ga-xxl-1 {\n    gap: 4px !important;\n  }\n  .ga-xxl-2 {\n    gap: 8px !important;\n  }\n  .ga-xxl-3 {\n    gap: 12px !important;\n  }\n  .ga-xxl-4 {\n    gap: 16px !important;\n  }\n  .ga-xxl-5 {\n    gap: 20px !important;\n  }\n  .ga-xxl-6 {\n    gap: 24px !important;\n  }\n  .ga-xxl-7 {\n    gap: 28px !important;\n  }\n  .ga-xxl-8 {\n    gap: 32px !important;\n  }\n  .ga-xxl-9 {\n    gap: 36px !important;\n  }\n  .ga-xxl-10 {\n    gap: 40px !important;\n  }\n  .ga-xxl-11 {\n    gap: 44px !important;\n  }\n  .ga-xxl-12 {\n    gap: 48px !important;\n  }\n  .ga-xxl-13 {\n    gap: 52px !important;\n  }\n  .ga-xxl-14 {\n    gap: 56px !important;\n  }\n  .ga-xxl-15 {\n    gap: 60px !important;\n  }\n  .ga-xxl-16 {\n    gap: 64px !important;\n  }\n  .ga-xxl-auto {\n    gap: auto !important;\n  }\n  .gr-xxl-0 {\n    row-gap: 0px !important;\n  }\n  .gr-xxl-1 {\n    row-gap: 4px !important;\n  }\n  .gr-xxl-2 {\n    row-gap: 8px !important;\n  }\n  .gr-xxl-3 {\n    row-gap: 12px !important;\n  }\n  .gr-xxl-4 {\n    row-gap: 16px !important;\n  }\n  .gr-xxl-5 {\n    row-gap: 20px !important;\n  }\n  .gr-xxl-6 {\n    row-gap: 24px !important;\n  }\n  .gr-xxl-7 {\n    row-gap: 28px !important;\n  }\n  .gr-xxl-8 {\n    row-gap: 32px !important;\n  }\n  .gr-xxl-9 {\n    row-gap: 36px !important;\n  }\n  .gr-xxl-10 {\n    row-gap: 40px !important;\n  }\n  .gr-xxl-11 {\n    row-gap: 44px !important;\n  }\n  .gr-xxl-12 {\n    row-gap: 48px !important;\n  }\n  .gr-xxl-13 {\n    row-gap: 52px !important;\n  }\n  .gr-xxl-14 {\n    row-gap: 56px !important;\n  }\n  .gr-xxl-15 {\n    row-gap: 60px !important;\n  }\n  .gr-xxl-16 {\n    row-gap: 64px !important;\n  }\n  .gr-xxl-auto {\n    row-gap: auto !important;\n  }\n  .gc-xxl-0 {\n    column-gap: 0px !important;\n  }\n  .gc-xxl-1 {\n    column-gap: 4px !important;\n  }\n  .gc-xxl-2 {\n    column-gap: 8px !important;\n  }\n  .gc-xxl-3 {\n    column-gap: 12px !important;\n  }\n  .gc-xxl-4 {\n    column-gap: 16px !important;\n  }\n  .gc-xxl-5 {\n    column-gap: 20px !important;\n  }\n  .gc-xxl-6 {\n    column-gap: 24px !important;\n  }\n  .gc-xxl-7 {\n    column-gap: 28px !important;\n  }\n  .gc-xxl-8 {\n    column-gap: 32px !important;\n  }\n  .gc-xxl-9 {\n    column-gap: 36px !important;\n  }\n  .gc-xxl-10 {\n    column-gap: 40px !important;\n  }\n  .gc-xxl-11 {\n    column-gap: 44px !important;\n  }\n  .gc-xxl-12 {\n    column-gap: 48px !important;\n  }\n  .gc-xxl-13 {\n    column-gap: 52px !important;\n  }\n  .gc-xxl-14 {\n    column-gap: 56px !important;\n  }\n  .gc-xxl-15 {\n    column-gap: 60px !important;\n  }\n  .gc-xxl-16 {\n    column-gap: 64px !important;\n  }\n  .gc-xxl-auto {\n    column-gap: auto !important;\n  }\n  .ma-xxl-0 {\n    margin: 0px !important;\n  }\n  .ma-xxl-1 {\n    margin: 4px !important;\n  }\n  .ma-xxl-2 {\n    margin: 8px !important;\n  }\n  .ma-xxl-3 {\n    margin: 12px !important;\n  }\n  .ma-xxl-4 {\n    margin: 16px !important;\n  }\n  .ma-xxl-5 {\n    margin: 20px !important;\n  }\n  .ma-xxl-6 {\n    margin: 24px !important;\n  }\n  .ma-xxl-7 {\n    margin: 28px !important;\n  }\n  .ma-xxl-8 {\n    margin: 32px !important;\n  }\n  .ma-xxl-9 {\n    margin: 36px !important;\n  }\n  .ma-xxl-10 {\n    margin: 40px !important;\n  }\n  .ma-xxl-11 {\n    margin: 44px !important;\n  }\n  .ma-xxl-12 {\n    margin: 48px !important;\n  }\n  .ma-xxl-13 {\n    margin: 52px !important;\n  }\n  .ma-xxl-14 {\n    margin: 56px !important;\n  }\n  .ma-xxl-15 {\n    margin: 60px !important;\n  }\n  .ma-xxl-16 {\n    margin: 64px !important;\n  }\n  .ma-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0px !important;\n    margin-left: 0px !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 4px !important;\n    margin-left: 4px !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 8px !important;\n    margin-left: 8px !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 12px !important;\n    margin-left: 12px !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 16px !important;\n    margin-left: 16px !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 20px !important;\n    margin-left: 20px !important;\n  }\n  .mx-xxl-6 {\n    margin-right: 24px !important;\n    margin-left: 24px !important;\n  }\n  .mx-xxl-7 {\n    margin-right: 28px !important;\n    margin-left: 28px !important;\n  }\n  .mx-xxl-8 {\n    margin-right: 32px !important;\n    margin-left: 32px !important;\n  }\n  .mx-xxl-9 {\n    margin-right: 36px !important;\n    margin-left: 36px !important;\n  }\n  .mx-xxl-10 {\n    margin-right: 40px !important;\n    margin-left: 40px !important;\n  }\n  .mx-xxl-11 {\n    margin-right: 44px !important;\n    margin-left: 44px !important;\n  }\n  .mx-xxl-12 {\n    margin-right: 48px !important;\n    margin-left: 48px !important;\n  }\n  .mx-xxl-13 {\n    margin-right: 52px !important;\n    margin-left: 52px !important;\n  }\n  .mx-xxl-14 {\n    margin-right: 56px !important;\n    margin-left: 56px !important;\n  }\n  .mx-xxl-15 {\n    margin-right: 60px !important;\n    margin-left: 60px !important;\n  }\n  .mx-xxl-16 {\n    margin-right: 64px !important;\n    margin-left: 64px !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n  .my-xxl-1 {\n    margin-top: 4px !important;\n    margin-bottom: 4px !important;\n  }\n  .my-xxl-2 {\n    margin-top: 8px !important;\n    margin-bottom: 8px !important;\n  }\n  .my-xxl-3 {\n    margin-top: 12px !important;\n    margin-bottom: 12px !important;\n  }\n  .my-xxl-4 {\n    margin-top: 16px !important;\n    margin-bottom: 16px !important;\n  }\n  .my-xxl-5 {\n    margin-top: 20px !important;\n    margin-bottom: 20px !important;\n  }\n  .my-xxl-6 {\n    margin-top: 24px !important;\n    margin-bottom: 24px !important;\n  }\n  .my-xxl-7 {\n    margin-top: 28px !important;\n    margin-bottom: 28px !important;\n  }\n  .my-xxl-8 {\n    margin-top: 32px !important;\n    margin-bottom: 32px !important;\n  }\n  .my-xxl-9 {\n    margin-top: 36px !important;\n    margin-bottom: 36px !important;\n  }\n  .my-xxl-10 {\n    margin-top: 40px !important;\n    margin-bottom: 40px !important;\n  }\n  .my-xxl-11 {\n    margin-top: 44px !important;\n    margin-bottom: 44px !important;\n  }\n  .my-xxl-12 {\n    margin-top: 48px !important;\n    margin-bottom: 48px !important;\n  }\n  .my-xxl-13 {\n    margin-top: 52px !important;\n    margin-bottom: 52px !important;\n  }\n  .my-xxl-14 {\n    margin-top: 56px !important;\n    margin-bottom: 56px !important;\n  }\n  .my-xxl-15 {\n    margin-top: 60px !important;\n    margin-bottom: 60px !important;\n  }\n  .my-xxl-16 {\n    margin-top: 64px !important;\n    margin-bottom: 64px !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0px !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 4px !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 8px !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 12px !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 16px !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 20px !important;\n  }\n  .mt-xxl-6 {\n    margin-top: 24px !important;\n  }\n  .mt-xxl-7 {\n    margin-top: 28px !important;\n  }\n  .mt-xxl-8 {\n    margin-top: 32px !important;\n  }\n  .mt-xxl-9 {\n    margin-top: 36px !important;\n  }\n  .mt-xxl-10 {\n    margin-top: 40px !important;\n  }\n  .mt-xxl-11 {\n    margin-top: 44px !important;\n  }\n  .mt-xxl-12 {\n    margin-top: 48px !important;\n  }\n  .mt-xxl-13 {\n    margin-top: 52px !important;\n  }\n  .mt-xxl-14 {\n    margin-top: 56px !important;\n  }\n  .mt-xxl-15 {\n    margin-top: 60px !important;\n  }\n  .mt-xxl-16 {\n    margin-top: 64px !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .mr-xxl-0 {\n    margin-right: 0px !important;\n  }\n  .mr-xxl-1 {\n    margin-right: 4px !important;\n  }\n  .mr-xxl-2 {\n    margin-right: 8px !important;\n  }\n  .mr-xxl-3 {\n    margin-right: 12px !important;\n  }\n  .mr-xxl-4 {\n    margin-right: 16px !important;\n  }\n  .mr-xxl-5 {\n    margin-right: 20px !important;\n  }\n  .mr-xxl-6 {\n    margin-right: 24px !important;\n  }\n  .mr-xxl-7 {\n    margin-right: 28px !important;\n  }\n  .mr-xxl-8 {\n    margin-right: 32px !important;\n  }\n  .mr-xxl-9 {\n    margin-right: 36px !important;\n  }\n  .mr-xxl-10 {\n    margin-right: 40px !important;\n  }\n  .mr-xxl-11 {\n    margin-right: 44px !important;\n  }\n  .mr-xxl-12 {\n    margin-right: 48px !important;\n  }\n  .mr-xxl-13 {\n    margin-right: 52px !important;\n  }\n  .mr-xxl-14 {\n    margin-right: 56px !important;\n  }\n  .mr-xxl-15 {\n    margin-right: 60px !important;\n  }\n  .mr-xxl-16 {\n    margin-right: 64px !important;\n  }\n  .mr-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0px !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 4px !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 8px !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 12px !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 16px !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 20px !important;\n  }\n  .mb-xxl-6 {\n    margin-bottom: 24px !important;\n  }\n  .mb-xxl-7 {\n    margin-bottom: 28px !important;\n  }\n  .mb-xxl-8 {\n    margin-bottom: 32px !important;\n  }\n  .mb-xxl-9 {\n    margin-bottom: 36px !important;\n  }\n  .mb-xxl-10 {\n    margin-bottom: 40px !important;\n  }\n  .mb-xxl-11 {\n    margin-bottom: 44px !important;\n  }\n  .mb-xxl-12 {\n    margin-bottom: 48px !important;\n  }\n  .mb-xxl-13 {\n    margin-bottom: 52px !important;\n  }\n  .mb-xxl-14 {\n    margin-bottom: 56px !important;\n  }\n  .mb-xxl-15 {\n    margin-bottom: 60px !important;\n  }\n  .mb-xxl-16 {\n    margin-bottom: 64px !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-xxl-0 {\n    margin-left: 0px !important;\n  }\n  .ml-xxl-1 {\n    margin-left: 4px !important;\n  }\n  .ml-xxl-2 {\n    margin-left: 8px !important;\n  }\n  .ml-xxl-3 {\n    margin-left: 12px !important;\n  }\n  .ml-xxl-4 {\n    margin-left: 16px !important;\n  }\n  .ml-xxl-5 {\n    margin-left: 20px !important;\n  }\n  .ml-xxl-6 {\n    margin-left: 24px !important;\n  }\n  .ml-xxl-7 {\n    margin-left: 28px !important;\n  }\n  .ml-xxl-8 {\n    margin-left: 32px !important;\n  }\n  .ml-xxl-9 {\n    margin-left: 36px !important;\n  }\n  .ml-xxl-10 {\n    margin-left: 40px !important;\n  }\n  .ml-xxl-11 {\n    margin-left: 44px !important;\n  }\n  .ml-xxl-12 {\n    margin-left: 48px !important;\n  }\n  .ml-xxl-13 {\n    margin-left: 52px !important;\n  }\n  .ml-xxl-14 {\n    margin-left: 56px !important;\n  }\n  .ml-xxl-15 {\n    margin-left: 60px !important;\n  }\n  .ml-xxl-16 {\n    margin-left: 64px !important;\n  }\n  .ml-xxl-auto {\n    margin-left: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-inline-start: 0px !important;\n  }\n  .ms-xxl-1 {\n    margin-inline-start: 4px !important;\n  }\n  .ms-xxl-2 {\n    margin-inline-start: 8px !important;\n  }\n  .ms-xxl-3 {\n    margin-inline-start: 12px !important;\n  }\n  .ms-xxl-4 {\n    margin-inline-start: 16px !important;\n  }\n  .ms-xxl-5 {\n    margin-inline-start: 20px !important;\n  }\n  .ms-xxl-6 {\n    margin-inline-start: 24px !important;\n  }\n  .ms-xxl-7 {\n    margin-inline-start: 28px !important;\n  }\n  .ms-xxl-8 {\n    margin-inline-start: 32px !important;\n  }\n  .ms-xxl-9 {\n    margin-inline-start: 36px !important;\n  }\n  .ms-xxl-10 {\n    margin-inline-start: 40px !important;\n  }\n  .ms-xxl-11 {\n    margin-inline-start: 44px !important;\n  }\n  .ms-xxl-12 {\n    margin-inline-start: 48px !important;\n  }\n  .ms-xxl-13 {\n    margin-inline-start: 52px !important;\n  }\n  .ms-xxl-14 {\n    margin-inline-start: 56px !important;\n  }\n  .ms-xxl-15 {\n    margin-inline-start: 60px !important;\n  }\n  .ms-xxl-16 {\n    margin-inline-start: 64px !important;\n  }\n  .ms-xxl-auto {\n    margin-inline-start: auto !important;\n  }\n  .me-xxl-0 {\n    margin-inline-end: 0px !important;\n  }\n  .me-xxl-1 {\n    margin-inline-end: 4px !important;\n  }\n  .me-xxl-2 {\n    margin-inline-end: 8px !important;\n  }\n  .me-xxl-3 {\n    margin-inline-end: 12px !important;\n  }\n  .me-xxl-4 {\n    margin-inline-end: 16px !important;\n  }\n  .me-xxl-5 {\n    margin-inline-end: 20px !important;\n  }\n  .me-xxl-6 {\n    margin-inline-end: 24px !important;\n  }\n  .me-xxl-7 {\n    margin-inline-end: 28px !important;\n  }\n  .me-xxl-8 {\n    margin-inline-end: 32px !important;\n  }\n  .me-xxl-9 {\n    margin-inline-end: 36px !important;\n  }\n  .me-xxl-10 {\n    margin-inline-end: 40px !important;\n  }\n  .me-xxl-11 {\n    margin-inline-end: 44px !important;\n  }\n  .me-xxl-12 {\n    margin-inline-end: 48px !important;\n  }\n  .me-xxl-13 {\n    margin-inline-end: 52px !important;\n  }\n  .me-xxl-14 {\n    margin-inline-end: 56px !important;\n  }\n  .me-xxl-15 {\n    margin-inline-end: 60px !important;\n  }\n  .me-xxl-16 {\n    margin-inline-end: 64px !important;\n  }\n  .me-xxl-auto {\n    margin-inline-end: auto !important;\n  }\n  .ma-xxl-n1 {\n    margin: -4px !important;\n  }\n  .ma-xxl-n2 {\n    margin: -8px !important;\n  }\n  .ma-xxl-n3 {\n    margin: -12px !important;\n  }\n  .ma-xxl-n4 {\n    margin: -16px !important;\n  }\n  .ma-xxl-n5 {\n    margin: -20px !important;\n  }\n  .ma-xxl-n6 {\n    margin: -24px !important;\n  }\n  .ma-xxl-n7 {\n    margin: -28px !important;\n  }\n  .ma-xxl-n8 {\n    margin: -32px !important;\n  }\n  .ma-xxl-n9 {\n    margin: -36px !important;\n  }\n  .ma-xxl-n10 {\n    margin: -40px !important;\n  }\n  .ma-xxl-n11 {\n    margin: -44px !important;\n  }\n  .ma-xxl-n12 {\n    margin: -48px !important;\n  }\n  .ma-xxl-n13 {\n    margin: -52px !important;\n  }\n  .ma-xxl-n14 {\n    margin: -56px !important;\n  }\n  .ma-xxl-n15 {\n    margin: -60px !important;\n  }\n  .ma-xxl-n16 {\n    margin: -64px !important;\n  }\n  .mx-xxl-n1 {\n    margin-right: -4px !important;\n    margin-left: -4px !important;\n  }\n  .mx-xxl-n2 {\n    margin-right: -8px !important;\n    margin-left: -8px !important;\n  }\n  .mx-xxl-n3 {\n    margin-right: -12px !important;\n    margin-left: -12px !important;\n  }\n  .mx-xxl-n4 {\n    margin-right: -16px !important;\n    margin-left: -16px !important;\n  }\n  .mx-xxl-n5 {\n    margin-right: -20px !important;\n    margin-left: -20px !important;\n  }\n  .mx-xxl-n6 {\n    margin-right: -24px !important;\n    margin-left: -24px !important;\n  }\n  .mx-xxl-n7 {\n    margin-right: -28px !important;\n    margin-left: -28px !important;\n  }\n  .mx-xxl-n8 {\n    margin-right: -32px !important;\n    margin-left: -32px !important;\n  }\n  .mx-xxl-n9 {\n    margin-right: -36px !important;\n    margin-left: -36px !important;\n  }\n  .mx-xxl-n10 {\n    margin-right: -40px !important;\n    margin-left: -40px !important;\n  }\n  .mx-xxl-n11 {\n    margin-right: -44px !important;\n    margin-left: -44px !important;\n  }\n  .mx-xxl-n12 {\n    margin-right: -48px !important;\n    margin-left: -48px !important;\n  }\n  .mx-xxl-n13 {\n    margin-right: -52px !important;\n    margin-left: -52px !important;\n  }\n  .mx-xxl-n14 {\n    margin-right: -56px !important;\n    margin-left: -56px !important;\n  }\n  .mx-xxl-n15 {\n    margin-right: -60px !important;\n    margin-left: -60px !important;\n  }\n  .mx-xxl-n16 {\n    margin-right: -64px !important;\n    margin-left: -64px !important;\n  }\n  .my-xxl-n1 {\n    margin-top: -4px !important;\n    margin-bottom: -4px !important;\n  }\n  .my-xxl-n2 {\n    margin-top: -8px !important;\n    margin-bottom: -8px !important;\n  }\n  .my-xxl-n3 {\n    margin-top: -12px !important;\n    margin-bottom: -12px !important;\n  }\n  .my-xxl-n4 {\n    margin-top: -16px !important;\n    margin-bottom: -16px !important;\n  }\n  .my-xxl-n5 {\n    margin-top: -20px !important;\n    margin-bottom: -20px !important;\n  }\n  .my-xxl-n6 {\n    margin-top: -24px !important;\n    margin-bottom: -24px !important;\n  }\n  .my-xxl-n7 {\n    margin-top: -28px !important;\n    margin-bottom: -28px !important;\n  }\n  .my-xxl-n8 {\n    margin-top: -32px !important;\n    margin-bottom: -32px !important;\n  }\n  .my-xxl-n9 {\n    margin-top: -36px !important;\n    margin-bottom: -36px !important;\n  }\n  .my-xxl-n10 {\n    margin-top: -40px !important;\n    margin-bottom: -40px !important;\n  }\n  .my-xxl-n11 {\n    margin-top: -44px !important;\n    margin-bottom: -44px !important;\n  }\n  .my-xxl-n12 {\n    margin-top: -48px !important;\n    margin-bottom: -48px !important;\n  }\n  .my-xxl-n13 {\n    margin-top: -52px !important;\n    margin-bottom: -52px !important;\n  }\n  .my-xxl-n14 {\n    margin-top: -56px !important;\n    margin-bottom: -56px !important;\n  }\n  .my-xxl-n15 {\n    margin-top: -60px !important;\n    margin-bottom: -60px !important;\n  }\n  .my-xxl-n16 {\n    margin-top: -64px !important;\n    margin-bottom: -64px !important;\n  }\n  .mt-xxl-n1 {\n    margin-top: -4px !important;\n  }\n  .mt-xxl-n2 {\n    margin-top: -8px !important;\n  }\n  .mt-xxl-n3 {\n    margin-top: -12px !important;\n  }\n  .mt-xxl-n4 {\n    margin-top: -16px !important;\n  }\n  .mt-xxl-n5 {\n    margin-top: -20px !important;\n  }\n  .mt-xxl-n6 {\n    margin-top: -24px !important;\n  }\n  .mt-xxl-n7 {\n    margin-top: -28px !important;\n  }\n  .mt-xxl-n8 {\n    margin-top: -32px !important;\n  }\n  .mt-xxl-n9 {\n    margin-top: -36px !important;\n  }\n  .mt-xxl-n10 {\n    margin-top: -40px !important;\n  }\n  .mt-xxl-n11 {\n    margin-top: -44px !important;\n  }\n  .mt-xxl-n12 {\n    margin-top: -48px !important;\n  }\n  .mt-xxl-n13 {\n    margin-top: -52px !important;\n  }\n  .mt-xxl-n14 {\n    margin-top: -56px !important;\n  }\n  .mt-xxl-n15 {\n    margin-top: -60px !important;\n  }\n  .mt-xxl-n16 {\n    margin-top: -64px !important;\n  }\n  .mr-xxl-n1 {\n    margin-right: -4px !important;\n  }\n  .mr-xxl-n2 {\n    margin-right: -8px !important;\n  }\n  .mr-xxl-n3 {\n    margin-right: -12px !important;\n  }\n  .mr-xxl-n4 {\n    margin-right: -16px !important;\n  }\n  .mr-xxl-n5 {\n    margin-right: -20px !important;\n  }\n  .mr-xxl-n6 {\n    margin-right: -24px !important;\n  }\n  .mr-xxl-n7 {\n    margin-right: -28px !important;\n  }\n  .mr-xxl-n8 {\n    margin-right: -32px !important;\n  }\n  .mr-xxl-n9 {\n    margin-right: -36px !important;\n  }\n  .mr-xxl-n10 {\n    margin-right: -40px !important;\n  }\n  .mr-xxl-n11 {\n    margin-right: -44px !important;\n  }\n  .mr-xxl-n12 {\n    margin-right: -48px !important;\n  }\n  .mr-xxl-n13 {\n    margin-right: -52px !important;\n  }\n  .mr-xxl-n14 {\n    margin-right: -56px !important;\n  }\n  .mr-xxl-n15 {\n    margin-right: -60px !important;\n  }\n  .mr-xxl-n16 {\n    margin-right: -64px !important;\n  }\n  .mb-xxl-n1 {\n    margin-bottom: -4px !important;\n  }\n  .mb-xxl-n2 {\n    margin-bottom: -8px !important;\n  }\n  .mb-xxl-n3 {\n    margin-bottom: -12px !important;\n  }\n  .mb-xxl-n4 {\n    margin-bottom: -16px !important;\n  }\n  .mb-xxl-n5 {\n    margin-bottom: -20px !important;\n  }\n  .mb-xxl-n6 {\n    margin-bottom: -24px !important;\n  }\n  .mb-xxl-n7 {\n    margin-bottom: -28px !important;\n  }\n  .mb-xxl-n8 {\n    margin-bottom: -32px !important;\n  }\n  .mb-xxl-n9 {\n    margin-bottom: -36px !important;\n  }\n  .mb-xxl-n10 {\n    margin-bottom: -40px !important;\n  }\n  .mb-xxl-n11 {\n    margin-bottom: -44px !important;\n  }\n  .mb-xxl-n12 {\n    margin-bottom: -48px !important;\n  }\n  .mb-xxl-n13 {\n    margin-bottom: -52px !important;\n  }\n  .mb-xxl-n14 {\n    margin-bottom: -56px !important;\n  }\n  .mb-xxl-n15 {\n    margin-bottom: -60px !important;\n  }\n  .mb-xxl-n16 {\n    margin-bottom: -64px !important;\n  }\n  .ml-xxl-n1 {\n    margin-left: -4px !important;\n  }\n  .ml-xxl-n2 {\n    margin-left: -8px !important;\n  }\n  .ml-xxl-n3 {\n    margin-left: -12px !important;\n  }\n  .ml-xxl-n4 {\n    margin-left: -16px !important;\n  }\n  .ml-xxl-n5 {\n    margin-left: -20px !important;\n  }\n  .ml-xxl-n6 {\n    margin-left: -24px !important;\n  }\n  .ml-xxl-n7 {\n    margin-left: -28px !important;\n  }\n  .ml-xxl-n8 {\n    margin-left: -32px !important;\n  }\n  .ml-xxl-n9 {\n    margin-left: -36px !important;\n  }\n  .ml-xxl-n10 {\n    margin-left: -40px !important;\n  }\n  .ml-xxl-n11 {\n    margin-left: -44px !important;\n  }\n  .ml-xxl-n12 {\n    margin-left: -48px !important;\n  }\n  .ml-xxl-n13 {\n    margin-left: -52px !important;\n  }\n  .ml-xxl-n14 {\n    margin-left: -56px !important;\n  }\n  .ml-xxl-n15 {\n    margin-left: -60px !important;\n  }\n  .ml-xxl-n16 {\n    margin-left: -64px !important;\n  }\n  .ms-xxl-n1 {\n    margin-inline-start: -4px !important;\n  }\n  .ms-xxl-n2 {\n    margin-inline-start: -8px !important;\n  }\n  .ms-xxl-n3 {\n    margin-inline-start: -12px !important;\n  }\n  .ms-xxl-n4 {\n    margin-inline-start: -16px !important;\n  }\n  .ms-xxl-n5 {\n    margin-inline-start: -20px !important;\n  }\n  .ms-xxl-n6 {\n    margin-inline-start: -24px !important;\n  }\n  .ms-xxl-n7 {\n    margin-inline-start: -28px !important;\n  }\n  .ms-xxl-n8 {\n    margin-inline-start: -32px !important;\n  }\n  .ms-xxl-n9 {\n    margin-inline-start: -36px !important;\n  }\n  .ms-xxl-n10 {\n    margin-inline-start: -40px !important;\n  }\n  .ms-xxl-n11 {\n    margin-inline-start: -44px !important;\n  }\n  .ms-xxl-n12 {\n    margin-inline-start: -48px !important;\n  }\n  .ms-xxl-n13 {\n    margin-inline-start: -52px !important;\n  }\n  .ms-xxl-n14 {\n    margin-inline-start: -56px !important;\n  }\n  .ms-xxl-n15 {\n    margin-inline-start: -60px !important;\n  }\n  .ms-xxl-n16 {\n    margin-inline-start: -64px !important;\n  }\n  .me-xxl-n1 {\n    margin-inline-end: -4px !important;\n  }\n  .me-xxl-n2 {\n    margin-inline-end: -8px !important;\n  }\n  .me-xxl-n3 {\n    margin-inline-end: -12px !important;\n  }\n  .me-xxl-n4 {\n    margin-inline-end: -16px !important;\n  }\n  .me-xxl-n5 {\n    margin-inline-end: -20px !important;\n  }\n  .me-xxl-n6 {\n    margin-inline-end: -24px !important;\n  }\n  .me-xxl-n7 {\n    margin-inline-end: -28px !important;\n  }\n  .me-xxl-n8 {\n    margin-inline-end: -32px !important;\n  }\n  .me-xxl-n9 {\n    margin-inline-end: -36px !important;\n  }\n  .me-xxl-n10 {\n    margin-inline-end: -40px !important;\n  }\n  .me-xxl-n11 {\n    margin-inline-end: -44px !important;\n  }\n  .me-xxl-n12 {\n    margin-inline-end: -48px !important;\n  }\n  .me-xxl-n13 {\n    margin-inline-end: -52px !important;\n  }\n  .me-xxl-n14 {\n    margin-inline-end: -56px !important;\n  }\n  .me-xxl-n15 {\n    margin-inline-end: -60px !important;\n  }\n  .me-xxl-n16 {\n    margin-inline-end: -64px !important;\n  }\n  .pa-xxl-0 {\n    padding: 0px !important;\n  }\n  .pa-xxl-1 {\n    padding: 4px !important;\n  }\n  .pa-xxl-2 {\n    padding: 8px !important;\n  }\n  .pa-xxl-3 {\n    padding: 12px !important;\n  }\n  .pa-xxl-4 {\n    padding: 16px !important;\n  }\n  .pa-xxl-5 {\n    padding: 20px !important;\n  }\n  .pa-xxl-6 {\n    padding: 24px !important;\n  }\n  .pa-xxl-7 {\n    padding: 28px !important;\n  }\n  .pa-xxl-8 {\n    padding: 32px !important;\n  }\n  .pa-xxl-9 {\n    padding: 36px !important;\n  }\n  .pa-xxl-10 {\n    padding: 40px !important;\n  }\n  .pa-xxl-11 {\n    padding: 44px !important;\n  }\n  .pa-xxl-12 {\n    padding: 48px !important;\n  }\n  .pa-xxl-13 {\n    padding: 52px !important;\n  }\n  .pa-xxl-14 {\n    padding: 56px !important;\n  }\n  .pa-xxl-15 {\n    padding: 60px !important;\n  }\n  .pa-xxl-16 {\n    padding: 64px !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0px !important;\n    padding-left: 0px !important;\n  }\n  .px-xxl-1 {\n    padding-right: 4px !important;\n    padding-left: 4px !important;\n  }\n  .px-xxl-2 {\n    padding-right: 8px !important;\n    padding-left: 8px !important;\n  }\n  .px-xxl-3 {\n    padding-right: 12px !important;\n    padding-left: 12px !important;\n  }\n  .px-xxl-4 {\n    padding-right: 16px !important;\n    padding-left: 16px !important;\n  }\n  .px-xxl-5 {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n  }\n  .px-xxl-6 {\n    padding-right: 24px !important;\n    padding-left: 24px !important;\n  }\n  .px-xxl-7 {\n    padding-right: 28px !important;\n    padding-left: 28px !important;\n  }\n  .px-xxl-8 {\n    padding-right: 32px !important;\n    padding-left: 32px !important;\n  }\n  .px-xxl-9 {\n    padding-right: 36px !important;\n    padding-left: 36px !important;\n  }\n  .px-xxl-10 {\n    padding-right: 40px !important;\n    padding-left: 40px !important;\n  }\n  .px-xxl-11 {\n    padding-right: 44px !important;\n    padding-left: 44px !important;\n  }\n  .px-xxl-12 {\n    padding-right: 48px !important;\n    padding-left: 48px !important;\n  }\n  .px-xxl-13 {\n    padding-right: 52px !important;\n    padding-left: 52px !important;\n  }\n  .px-xxl-14 {\n    padding-right: 56px !important;\n    padding-left: 56px !important;\n  }\n  .px-xxl-15 {\n    padding-right: 60px !important;\n    padding-left: 60px !important;\n  }\n  .px-xxl-16 {\n    padding-right: 64px !important;\n    padding-left: 64px !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n  .py-xxl-1 {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n  }\n  .py-xxl-2 {\n    padding-top: 8px !important;\n    padding-bottom: 8px !important;\n  }\n  .py-xxl-3 {\n    padding-top: 12px !important;\n    padding-bottom: 12px !important;\n  }\n  .py-xxl-4 {\n    padding-top: 16px !important;\n    padding-bottom: 16px !important;\n  }\n  .py-xxl-5 {\n    padding-top: 20px !important;\n    padding-bottom: 20px !important;\n  }\n  .py-xxl-6 {\n    padding-top: 24px !important;\n    padding-bottom: 24px !important;\n  }\n  .py-xxl-7 {\n    padding-top: 28px !important;\n    padding-bottom: 28px !important;\n  }\n  .py-xxl-8 {\n    padding-top: 32px !important;\n    padding-bottom: 32px !important;\n  }\n  .py-xxl-9 {\n    padding-top: 36px !important;\n    padding-bottom: 36px !important;\n  }\n  .py-xxl-10 {\n    padding-top: 40px !important;\n    padding-bottom: 40px !important;\n  }\n  .py-xxl-11 {\n    padding-top: 44px !important;\n    padding-bottom: 44px !important;\n  }\n  .py-xxl-12 {\n    padding-top: 48px !important;\n    padding-bottom: 48px !important;\n  }\n  .py-xxl-13 {\n    padding-top: 52px !important;\n    padding-bottom: 52px !important;\n  }\n  .py-xxl-14 {\n    padding-top: 56px !important;\n    padding-bottom: 56px !important;\n  }\n  .py-xxl-15 {\n    padding-top: 60px !important;\n    padding-bottom: 60px !important;\n  }\n  .py-xxl-16 {\n    padding-top: 64px !important;\n    padding-bottom: 64px !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0px !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 4px !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 8px !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 12px !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 16px !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 20px !important;\n  }\n  .pt-xxl-6 {\n    padding-top: 24px !important;\n  }\n  .pt-xxl-7 {\n    padding-top: 28px !important;\n  }\n  .pt-xxl-8 {\n    padding-top: 32px !important;\n  }\n  .pt-xxl-9 {\n    padding-top: 36px !important;\n  }\n  .pt-xxl-10 {\n    padding-top: 40px !important;\n  }\n  .pt-xxl-11 {\n    padding-top: 44px !important;\n  }\n  .pt-xxl-12 {\n    padding-top: 48px !important;\n  }\n  .pt-xxl-13 {\n    padding-top: 52px !important;\n  }\n  .pt-xxl-14 {\n    padding-top: 56px !important;\n  }\n  .pt-xxl-15 {\n    padding-top: 60px !important;\n  }\n  .pt-xxl-16 {\n    padding-top: 64px !important;\n  }\n  .pr-xxl-0 {\n    padding-right: 0px !important;\n  }\n  .pr-xxl-1 {\n    padding-right: 4px !important;\n  }\n  .pr-xxl-2 {\n    padding-right: 8px !important;\n  }\n  .pr-xxl-3 {\n    padding-right: 12px !important;\n  }\n  .pr-xxl-4 {\n    padding-right: 16px !important;\n  }\n  .pr-xxl-5 {\n    padding-right: 20px !important;\n  }\n  .pr-xxl-6 {\n    padding-right: 24px !important;\n  }\n  .pr-xxl-7 {\n    padding-right: 28px !important;\n  }\n  .pr-xxl-8 {\n    padding-right: 32px !important;\n  }\n  .pr-xxl-9 {\n    padding-right: 36px !important;\n  }\n  .pr-xxl-10 {\n    padding-right: 40px !important;\n  }\n  .pr-xxl-11 {\n    padding-right: 44px !important;\n  }\n  .pr-xxl-12 {\n    padding-right: 48px !important;\n  }\n  .pr-xxl-13 {\n    padding-right: 52px !important;\n  }\n  .pr-xxl-14 {\n    padding-right: 56px !important;\n  }\n  .pr-xxl-15 {\n    padding-right: 60px !important;\n  }\n  .pr-xxl-16 {\n    padding-right: 64px !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0px !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 4px !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 8px !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 12px !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 16px !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 20px !important;\n  }\n  .pb-xxl-6 {\n    padding-bottom: 24px !important;\n  }\n  .pb-xxl-7 {\n    padding-bottom: 28px !important;\n  }\n  .pb-xxl-8 {\n    padding-bottom: 32px !important;\n  }\n  .pb-xxl-9 {\n    padding-bottom: 36px !important;\n  }\n  .pb-xxl-10 {\n    padding-bottom: 40px !important;\n  }\n  .pb-xxl-11 {\n    padding-bottom: 44px !important;\n  }\n  .pb-xxl-12 {\n    padding-bottom: 48px !important;\n  }\n  .pb-xxl-13 {\n    padding-bottom: 52px !important;\n  }\n  .pb-xxl-14 {\n    padding-bottom: 56px !important;\n  }\n  .pb-xxl-15 {\n    padding-bottom: 60px !important;\n  }\n  .pb-xxl-16 {\n    padding-bottom: 64px !important;\n  }\n  .pl-xxl-0 {\n    padding-left: 0px !important;\n  }\n  .pl-xxl-1 {\n    padding-left: 4px !important;\n  }\n  .pl-xxl-2 {\n    padding-left: 8px !important;\n  }\n  .pl-xxl-3 {\n    padding-left: 12px !important;\n  }\n  .pl-xxl-4 {\n    padding-left: 16px !important;\n  }\n  .pl-xxl-5 {\n    padding-left: 20px !important;\n  }\n  .pl-xxl-6 {\n    padding-left: 24px !important;\n  }\n  .pl-xxl-7 {\n    padding-left: 28px !important;\n  }\n  .pl-xxl-8 {\n    padding-left: 32px !important;\n  }\n  .pl-xxl-9 {\n    padding-left: 36px !important;\n  }\n  .pl-xxl-10 {\n    padding-left: 40px !important;\n  }\n  .pl-xxl-11 {\n    padding-left: 44px !important;\n  }\n  .pl-xxl-12 {\n    padding-left: 48px !important;\n  }\n  .pl-xxl-13 {\n    padding-left: 52px !important;\n  }\n  .pl-xxl-14 {\n    padding-left: 56px !important;\n  }\n  .pl-xxl-15 {\n    padding-left: 60px !important;\n  }\n  .pl-xxl-16 {\n    padding-left: 64px !important;\n  }\n  .ps-xxl-0 {\n    padding-inline-start: 0px !important;\n  }\n  .ps-xxl-1 {\n    padding-inline-start: 4px !important;\n  }\n  .ps-xxl-2 {\n    padding-inline-start: 8px !important;\n  }\n  .ps-xxl-3 {\n    padding-inline-start: 12px !important;\n  }\n  .ps-xxl-4 {\n    padding-inline-start: 16px !important;\n  }\n  .ps-xxl-5 {\n    padding-inline-start: 20px !important;\n  }\n  .ps-xxl-6 {\n    padding-inline-start: 24px !important;\n  }\n  .ps-xxl-7 {\n    padding-inline-start: 28px !important;\n  }\n  .ps-xxl-8 {\n    padding-inline-start: 32px !important;\n  }\n  .ps-xxl-9 {\n    padding-inline-start: 36px !important;\n  }\n  .ps-xxl-10 {\n    padding-inline-start: 40px !important;\n  }\n  .ps-xxl-11 {\n    padding-inline-start: 44px !important;\n  }\n  .ps-xxl-12 {\n    padding-inline-start: 48px !important;\n  }\n  .ps-xxl-13 {\n    padding-inline-start: 52px !important;\n  }\n  .ps-xxl-14 {\n    padding-inline-start: 56px !important;\n  }\n  .ps-xxl-15 {\n    padding-inline-start: 60px !important;\n  }\n  .ps-xxl-16 {\n    padding-inline-start: 64px !important;\n  }\n  .pe-xxl-0 {\n    padding-inline-end: 0px !important;\n  }\n  .pe-xxl-1 {\n    padding-inline-end: 4px !important;\n  }\n  .pe-xxl-2 {\n    padding-inline-end: 8px !important;\n  }\n  .pe-xxl-3 {\n    padding-inline-end: 12px !important;\n  }\n  .pe-xxl-4 {\n    padding-inline-end: 16px !important;\n  }\n  .pe-xxl-5 {\n    padding-inline-end: 20px !important;\n  }\n  .pe-xxl-6 {\n    padding-inline-end: 24px !important;\n  }\n  .pe-xxl-7 {\n    padding-inline-end: 28px !important;\n  }\n  .pe-xxl-8 {\n    padding-inline-end: 32px !important;\n  }\n  .pe-xxl-9 {\n    padding-inline-end: 36px !important;\n  }\n  .pe-xxl-10 {\n    padding-inline-end: 40px !important;\n  }\n  .pe-xxl-11 {\n    padding-inline-end: 44px !important;\n  }\n  .pe-xxl-12 {\n    padding-inline-end: 48px !important;\n  }\n  .pe-xxl-13 {\n    padding-inline-end: 52px !important;\n  }\n  .pe-xxl-14 {\n    padding-inline-end: 56px !important;\n  }\n  .pe-xxl-15 {\n    padding-inline-end: 60px !important;\n  }\n  .pe-xxl-16 {\n    padding-inline-end: 64px !important;\n  }\n  .text-xxl-left {\n    text-align: left !important;\n  }\n  .text-xxl-right {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n  .text-xxl-justify {\n    text-align: justify !important;\n  }\n  .text-xxl-start {\n    text-align: start !important;\n  }\n  .text-xxl-end {\n    text-align: end !important;\n  }\n  .text-xxl-h1 {\n    font-size: 6rem !important;\n    font-weight: 300;\n    line-height: 1;\n    letter-spacing: -0.015625em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xxl-h2 {\n    font-size: 3.75rem !important;\n    font-weight: 300;\n    line-height: 1;\n    letter-spacing: -0.0083333333em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xxl-h3 {\n    font-size: 3rem !important;\n    font-weight: 400;\n    line-height: 1.05;\n    letter-spacing: normal !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xxl-h4 {\n    font-size: 2.125rem !important;\n    font-weight: 400;\n    line-height: 1.175;\n    letter-spacing: 0.0073529412em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xxl-h5 {\n    font-size: 1.5rem !important;\n    font-weight: 400;\n    line-height: 1.333;\n    letter-spacing: normal !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xxl-h6 {\n    font-size: 1.25rem !important;\n    font-weight: 500;\n    line-height: 1.6;\n    letter-spacing: 0.0125em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xxl-subtitle-1 {\n    font-size: 1rem !important;\n    font-weight: normal;\n    line-height: 1.75;\n    letter-spacing: 0.009375em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xxl-subtitle-2 {\n    font-size: 0.875rem !important;\n    font-weight: 500;\n    line-height: 1.6;\n    letter-spacing: 0.0071428571em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xxl-body-1 {\n    font-size: 1rem !important;\n    font-weight: 400;\n    line-height: 1.5;\n    letter-spacing: 0.03125em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xxl-body-2 {\n    font-size: 0.875rem !important;\n    font-weight: 400;\n    line-height: 1.425;\n    letter-spacing: 0.0178571429em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xxl-button {\n    font-size: 0.875rem !important;\n    font-weight: 500;\n    line-height: 2.6;\n    letter-spacing: 0.0892857143em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: uppercase !important;\n  }\n  .text-xxl-caption {\n    font-size: 0.75rem !important;\n    font-weight: 400;\n    line-height: 1.667;\n    letter-spacing: 0.0333333333em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: none !important;\n  }\n  .text-xxl-overline {\n    font-size: 0.75rem !important;\n    font-weight: 500;\n    line-height: 2.667;\n    letter-spacing: 0.1666666667em !important;\n    font-family: \"Roboto\", sans-serif;\n    text-transform: uppercase !important;\n  }\n  .h-xxl-auto {\n    height: auto !important;\n  }\n  .h-xxl-screen {\n    height: 100vh !important;\n  }\n  .h-xxl-0 {\n    height: 0 !important;\n  }\n  .h-xxl-25 {\n    height: 25% !important;\n  }\n  .h-xxl-50 {\n    height: 50% !important;\n  }\n  .h-xxl-75 {\n    height: 75% !important;\n  }\n  .h-xxl-100 {\n    height: 100% !important;\n  }\n  .w-xxl-auto {\n    width: auto !important;\n  }\n  .w-xxl-0 {\n    width: 0 !important;\n  }\n  .w-xxl-25 {\n    width: 25% !important;\n  }\n  .w-xxl-33 {\n    width: 33% !important;\n  }\n  .w-xxl-50 {\n    width: 50% !important;\n  }\n  .w-xxl-66 {\n    width: 66% !important;\n  }\n  .w-xxl-75 {\n    width: 75% !important;\n  }\n  .w-xxl-100 {\n    width: 100% !important;\n  }\n}\n@media print {\n  .d-print-none {\n    display: none !important;\n  }\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .float-print-none {\n    float: none !important;\n  }\n  .float-print-left {\n    float: left !important;\n  }\n  .float-print-right {\n    float: right !important;\n  }\n  .v-locale--is-rtl .float-print-end {\n    float: left !important;\n  }\n  .v-locale--is-rtl .float-print-start {\n    float: right !important;\n  }\n  .v-locale--is-ltr .float-print-end {\n    float: right !important;\n  }\n  .v-locale--is-ltr .float-print-start {\n    float: left !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
